import { jsx, Fragment, jsxs } from 'react/jsx-runtime';
import React, { useEffect, createContext, useContext, useCallback, useState, useRef, useMemo, createElement } from 'react';
import { ArrowLeftIcon, EnvelopeIcon, EuroSignIcon, DoorClosedIcon, ExpandIcon, BedFrontIcon, ChevronRightIcon, TrashCanIcon, PenIcon, EllipsisVerticalIcon, AlertOnFilledIcon, CloseIcon, BellFilledIcon, BellIcon, MagnifyingGlassIcon } from '@gemini/icons';
import { Button, InfoState, TextField, TextArea, Checkbox, StateMessage, useSnackbar, Tag, Divider, RadioGroup, ToggleGroup, Modal, Toggle, ActionMenu, FeedbackMessage, Skeleton } from '@gemini/ui';
import { Box, useBreakpointValue, getRootFontSizeValue, useHoverable, usePopover, Overlay, useSafeArea } from '@gemini/core';
import { WithThor, useThorEvent } from '@aviv-dxp/react-thor';
import { SavedSearchNotificationChannel, DistributionType, Cellar, Furnished, KitchenEquipment, HasFee, Elevator, LocationInBuilding, EnergyClass, EstateType, BuildState as BuildState$1, EstateSubType as EstateSubType$1, SwimmingPool, Garden, LocationGeometryTravelMode, LocationGeometryTravelUnit, LocationGeometryCircleRadiusUnit, DistributionSubType, ManagementUseFor, SavedSearchDeviceType, LegacyIWTRelaxMode, NotificationsTargetEnum, SavedSearchOrigin, SavedSearchState, SpaceMeasureUnit, SavedSearchFrequency } from '@aviv-saved-search/types';
import { LocationType, BuildState, CertificateOfEligibility, DistributionType as DistributionType$1, EstateSubType, EstateType as EstateType$1, ProjectType, FeatureType, Furnished as Furnished$1, CommuteMode, LocationInBuildingType, UseFor } from '@aviv-search/types';
import '@gemini/tokens';
import fetch$1 from 'cross-fetch';
import { SearchEdit } from '@aviv-search/refiner/edit';
import { mapSearchModelToQueryString } from '@aviv-search/transformers';
import { CardMFEProvider, CardFull, getCardsData } from '@aviv-classified-card/card/full';
import { FavoritesProvider, FavoriteHeart } from '@seeker-consumer-portal/favorite-heart';

const createLegacyEndpoint = (stage, brand, route = '')=>{
    switch(brand){
        case 'sl':
            return `https://${stage === 'live' ? 'www' : stage}.seloger.com${route}`;
        case 'imn':
            return `https://${stage === 'live' ? '' : stage + '-'}api.immowelt.com${route}`;
        case 'iwt':
            return `https://${stage === 'live' ? '' : stage + '-'}api.immowelt.com${route}`;
        case 'li':
            return `https://${stage === 'live' ? 'www' : stage}.logic-immo.com${route}`;
        default:
            return `https://${stage === 'live' ? '' : stage + '-'}api.immowelt.com${route}`;
    }
};
/***
 * From https://github.com/axel-springer-kugawana/aviv_platform_unified_frontend_routing
 */ const brandHostnames = {
    dev: {
        imn: 'https://www.dev.immonet.de',
        iwt: 'https://dev.immowelt.de',
        sl: 'https://dev.seloger.com',
        slp: 'https://dev.myselogerpro.com',
        li: 'https://dev.logic-immo.com',
        iwb: 'https://dev.immoweb.be',
        sln: 'https://dev.selogerneuf.com',
        /** doesn't exist atm  */ ma: ''
    },
    preview: {
        imn: 'https://www.preview.immonet.de',
        iwt: 'https://preview.immowelt.de',
        sl: 'https://preview.seloger.com',
        slp: 'https://preview.myselogerpro.com',
        li: 'https://preview.logic-immo.com',
        iwb: 'https://preview.immoweb.be',
        sln: 'https://preview.selogerneuf.com',
        /** doesn't exist atm  */ ma: ''
    },
    live: {
        imn: 'https://www.immonet.de',
        iwt: 'https://www.immowelt.de',
        sl: 'https://www.seloger.com',
        slp: 'https://myselogerpro.com',
        li: 'https://www.logic-immo.com',
        iwb: 'https://www.immoweb.be',
        sln: 'https://www.selogerneuf.com',
        ma: 'https://www.meilleursagents.com'
    }
};
const getBrandHostname = (stage, brand)=>brandHostnames[stage][brand];

const DataDome = ({ element, stage, brand })=>{
    useEffect(()=>{
        const BASE_URI = getBrandHostname(stage, brand);
        const getDomainName = (url)=>url.replace(/^https?:\/\//, '').replace(/^www./, '').replace(/\/$/, '');
        window.ddjskey = '8C7191D8AA1BF5FBB1B84DC7268196';
        window.ddoptions = {
            ajaxListenerPath: [
                getDomainName(BASE_URI),
                'aws.aviv-internal.eu',
                'aws.aviv.eu',
                'immonet.de',
                'immowelt.de'
            ],
            // sessionByHeader: true,
            allowHtmlContentTypeOnCaptcha: true
        };
    }, [
        stage,
        brand
    ]);
    return /*#__PURE__*/ jsx(Fragment, {
        children: /*#__PURE__*/ jsx("script", {
            src: "https://js.datadome.co/tags.js",
            async: true,
            "data-testid": `saved-search-${element}-datadome`
        })
    });
};

const BackButton = (props)=>{
    const { route, buttonText } = props;
    return /*#__PURE__*/ jsx(Button, {
        href: route,
        variant: "tertiary",
        icon: ArrowLeftIcon,
        iconPosition: "start",
        testId: "av-ssap-AlertPage-BackButton-button",
        children: buttonText
    });
};

const ErrorPage = ({ title, description, imgSrc, button, testIds, showBack, backButtonText, backButtonRoute })=>{
    return imgSrc && /*#__PURE__*/ jsxs(Box, {
        width: {
            'breakpoint.md': '100%',
            'breakpoint.lg': '930px'
        },
        marginHorizontal: "auto",
        testId: testIds.page,
        children: [
            showBack && /*#__PURE__*/ jsx(Box, {
                as: "div",
                marginBottom: "spacing.10",
                marginTop: "spacing.10",
                alignSelf: "start",
                color: "color.content.default.default",
                testId: "av-ssap-AlertPage-BackButton",
                children: /*#__PURE__*/ jsx(BackButton, {
                    route: backButtonRoute,
                    buttonText: backButtonText
                })
            }),
            /*#__PURE__*/ jsx(Box, {
                display: "flex",
                flexWrap: "wrap",
                flexDirection: "row",
                justifyContent: "center",
                gap: "spacing.32",
                padding: "spacing.32",
                testId: testIds.layout,
                children: /*#__PURE__*/ jsx(InfoState, {
                    image: imgSrc,
                    description: description,
                    title: title,
                    startButtonProps: {
                        children: button.text,
                        onPress: button.onPress
                    }
                })
            })
        ]
    });
};

const isWindowUndefined = ()=>typeof window === 'undefined';
const isDocumentUndefined = ()=>typeof document === 'undefined';
const isLocalStorageUndefined = ()=>typeof localStorage === 'undefined';

const clearObject = (toClear)=>{
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    const cleared = JSON.stringify(toClear, (_, value)=>value === null ? undefined : value);
    return JSON.parse(cleared);
};
const isValidEmail = (email)=>{
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
};
const formatNumber$1 = (input, locale)=>{
    let number;
    if (!input) return null;
    if (typeof input === 'string') {
        if (isNaN(Number(input))) {
            throw new Error(`${input} is not a number`);
        }
        number = Number(input);
    } else {
        number = input;
    }
    if (locale === 'fr') return number.toLocaleString('fr-FR');
    if (locale === 'en') return number.toLocaleString('en-US');
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
};
const getNumberOfLocations = (locations)=>{
    return locations.placeIds.length + locations.geometries.circles.length + locations.geometries.polygons.length + locations.geometries.travels.length;
};
const isLegacyIWTSavedSearch = (obj)=>{
    return !!obj && 'baseAttributes' in obj;
};
const isLegacySLGSavedSearch = (obj)=>{
    return !!obj && 'searchId' in obj;
};
const createIntermediaryMatchingMandatePayload = (data, search)=>{
    return {
        user: {
            name: data.name,
            email: data.email,
            phoneNumber: data.phoneNumber,
            description: data?.message ?? '',
            postalCode: '',
            address: ''
        },
        search: {
            criteria: {
                estateType: search?.estateTypes ?? null,
                distributionType: search?.distributionTypes ?? null,
                prices: {
                    priceMin: search?.priceMin ?? null,
                    priceMax: search?.priceMax ?? null
                },
                spaces: {
                    spaceMin: search?.spaceMin ?? null,
                    spaceMax: search?.spaceMax ?? null
                },
                structure: {
                    rooms: {
                        numberOfRoomsMin: search?.numberOfRoomsMin ?? null,
                        numberOfRoomsMax: search?.numberOfRoomsMax ?? null
                    }
                },
                location: {
                    placeIds: search?.locations?.flatMap((location)=>location.type === LocationType.COMMUTE ? location.placeIds : location.placeId) ?? null
                }
            }
        }
    };
};
const getMostRecentSearch = (searches)=>{
    if (searches.length === 0) return null;
    const activeSearches = searches.filter((search)=>search.channels.find((channel)=>channel.channel === SavedSearchNotificationChannel.email)?.enabled);
    if (activeSearches.length === 0) return null;
    return activeSearches.reduce((previousSavedSearch, currentSavedSearch)=>{
        const previousDate = new Date(previousSavedSearch.metadata.updated).getTime();
        const currentDate = new Date(currentSavedSearch.metadata.updated).getTime();
        return currentDate > previousDate ? currentSavedSearch : previousSavedSearch;
    });
};
const includeCommuteLocation = (locations)=>{
    const commutes = locations.filter((location)=>location.type === LocationType.COMMUTE);
    return commutes.length > 0;
};
const isIntermediaryMatchingMandateShowable = (brandConfig)=>{
    const { intermediaryMatchingMandate, intermediaryMatchingMandateWithLocal } = brandConfig.button;
    if (intermediaryMatchingMandate) return true;
    const hasLocalStorageValue = getLocalStorageItem(intermediaryMatchingMandateLocalStorageKey);
    const hasSessionStorageValue = sessionStorage.getItem(intermediaryMatchingMandateLocalStorageKey);
    if (!hasLocalStorageValue && !hasSessionStorageValue) return false;
    if (intermediaryMatchingMandateWithLocal) return true;
    return false;
};

const spacesSymbol = 'm²';
const currencySymbol = '€';
const roomsKey = ' Zimmer'; //TODO: Translation is needed for rooms <> Zimmer
const getRange = (min, max, symbol = '')=>{
    if (min && max) {
        return `${min}${symbol} - ${max}${symbol}`;
    } else if (min) {
        return `min ${min}${symbol}`;
    } else if (max) {
        return `max ${max}${symbol}`;
    }
    return ``;
};
const energyClassToWording = (energyClass)=>{
    switch(energyClass){
        case EnergyClass.A_PLUS_PLUS:
            return 'A++';
        case EnergyClass.A_PLUS:
            return 'A+';
        default:
            return energyClass;
    }
};
const mapCriteriaToWording = (item, translate)=>{
    const { criteria } = item;
    const criteriasArray = [];
    const criteriaCheckboxKey = 'savedSearch.criterias.features.checkbox';
    if (criteria?.structure?.parkingLots?.numberOfGaragesMin || criteria?.structure?.parkingLots?.numberOfParkingsMin) {
        criteriasArray.push(translate(`${criteriaCheckboxKey}.parking_garage`));
    }
    if (criteria?.structure?.rooms?.numberOfBalconiesMin || criteria?.structure?.rooms?.numberOfTerracesMin) {
        criteriasArray.push(translate(`${criteriaCheckboxKey}.balcony_terrace`));
    }
    if (criteria?.features?.garden && criteria?.features?.garden.length !== 0) {
        criteriasArray.push(translate(`${criteriaCheckboxKey}.garden`));
    }
    if (criteria?.structure?.building?.bath?.window) {
        criteriasArray.push(translate(`${criteriaCheckboxKey}.bathroom_with_window`));
    }
    if (criteria?.structure?.building?.bath?.bathtub) {
        criteriasArray.push(translate(`${criteriaCheckboxKey}.bathroom_with_bathtub`));
    }
    if (criteria?.structure?.building?.cellar === Cellar.ANYKIND) {
        criteriasArray.push(translate(`${criteriaCheckboxKey}.cellar`));
    }
    if (criteria?.features?.furnished === Furnished.FULL || criteria?.features?.furnished === Furnished.ANYKIND) {
        criteriasArray.push(translate(`${criteriaCheckboxKey}.furnished`));
    }
    if (criteria?.structure?.building?.kitchen?.equipment === KitchenEquipment.FULLY_EQUIPPED) {
        criteriasArray.push(translate(`${criteriaCheckboxKey}.built_in_kitchen`));
    }
    if (criteria?.management?.isRented === false) {
        criteriasArray.push(translate(`${criteriaCheckboxKey}.vacant`));
    }
    if (criteria?.prices?.brokerageFee?.hasFee === HasFee.YES) {
        criteriasArray.push(translate(`${criteriaCheckboxKey}.free_of_commission`));
    }
    if (criteria?.features?.wheelchairUse) {
        criteriasArray.push(translate(`${criteriaCheckboxKey}.reduced_mobility_access`));
    }
    if (criteria?.structure?.building?.elevator?.length !== 0 && !criteria?.structure?.building?.elevator?.includes(Elevator.None)) {
        criteriasArray.push(translate(`${criteriaCheckboxKey}.elevator`));
    }
    if (criteria?.management?.rent?.petsAllowed) {
        criteriasArray.push(translate(`${criteriaCheckboxKey}.pets_allowed`));
    }
    if (criteria?.structure?.building?.locationInBuilding && criteria?.structure?.building?.locationInBuilding?.indexOf(LocationInBuilding.GROUNDFLOOR_EXCLUDED) !== -1) {
        criteriasArray.push(translate(`${criteriaCheckboxKey}.no_ground_floor`));
    }
    if (criteria?.structure?.building?.locationInBuilding && criteria?.structure?.building?.locationInBuilding?.indexOf(LocationInBuilding.ROOF_STOREY_EXCLUDED) !== -1) {
        criteriasArray.push(translate(`${criteriaCheckboxKey}.no_attic_apartment`));
    }
    if (criteria?.management?.rent?.certificateOfEligibilityNeeded) {
        criteriasArray.push(translate(`${criteriaCheckboxKey}.certificate_of_eligibility_needed`));
    }
    if (criteria?.conditions?.energyClass) {
        criteria.conditions.energyClass.forEach((energyClass)=>{
            criteriasArray.push(energyClassToWording(energyClass));
        });
    }
    return criteriasArray;
};
const getLocationsWording = ({ placeIds, placeIdInfos, geometries: { circles, travels, polygons } }, translate, { prefixed = false } = {})=>{
    if (polygons.length) {
        return translate(`savedSearch.criterias.location.polygons${prefixed ? '_prefixed' : ''}`);
    }
    const placeNames = placeIdInfos.map((place)=>place.placeName);
    if (placeNames.length === 0) {
        // we don't have any valid place infos so we return an empty string
        return '';
    }
    const firstCircle = circles[0];
    if (firstCircle) {
        return translate(`savedSearch.criterias.location.circles${prefixed ? '_prefixed' : ''}`, {
            replace: {
                placeName: placeNames[0],
                radius: firstCircle.radius,
                radiusUnit: firstCircle.radiusUnit
            },
            unsafe_escapeValue: false
        });
    }
    const firstTravel = travels[0];
    if (firstTravel) {
        return translate(`savedSearch.criterias.location.travels`, {
            replace: {
                placeName: placeNames[0],
                mode: translate(`savedSearch.enums.travelMode.${firstTravel.travelMode[0]}_prefixed`),
                duration: firstTravel.travelValue
            },
            unsafe_escapeValue: false
        });
    }
    if (placeIds.length) {
        return translate(`savedSearch.criterias.location.places${prefixed ? '_prefixed' : ''}`, {
            count: placeIds.length,
            replace: {
                count: placeIds.length - 1,
                placeName: placeNames[0]
            },
            unsafe_escapeValue: false
        });
    }
    return '';
};
const generateSavedSearchTitle = (criteria, translate)=>{
    const estateTypes = criteria.estateType.map((el)=>translate(`savedSearch.enums.estateType.${el}`));
    const distributionTypeEnum = criteria.distributionType.includes(DistributionType.RENT) ? DistributionType.RENT : DistributionType.BUY;
    const distributionType = translate(`savedSearch.enums.distributionType.${distributionTypeEnum}_prefixed`);
    const location = getLocationsWording(criteria.location, translate, {
        prefixed: true
    });
    return translate(`savedSearch.title.location`, {
        replace: {
            estateTypes,
            distributionType,
            location
        },
        unsafe_escapeValue: false
    }).trim();
};
const getOldFormatLocale = (newLocale)=>{
    return newLocale.split('-')[0] ?? newLocale;
};
const includeUpperOrLower = (toCheck, value)=>{
    return toCheck.includes(value.toLowerCase()) || toCheck.includes(value.toUpperCase());
};
const getWLItemWording = (item, translate)=>{
    const { prices, spaces, location } = item.criteria;
    const title = item?.title ? item.title : generateSavedSearchTitle(item.criteria, translate);
    const rooms = item.criteria.structure?.rooms;
    const pricesRange = getRange(prices?.priceMin, prices?.priceMax, currencySymbol);
    const spacesRange = getRange(spaces?.spaceMin, spaces?.spaceMax, spacesSymbol);
    let roomsRange = getRange(rooms?.numberOfRoomsMin, rooms?.numberOfRoomsMax, '');
    if (roomsRange.trim().length > 0) {
        roomsRange += roomsKey;
    }
    const criteriasDisplay = mapCriteriaToWording(item, translate).join(' · ');
    const adLocations = getLocationsWording(location, translate);
    return {
        title,
        pricesRange,
        spacesRange,
        roomsRange,
        criteriasDisplay,
        adLocations
    };
};
const getHintType = (search, translate)=>{
    if (includeCommuteLocation(search.locations)) {
        return {
            type: 'travelTime',
            content: {
                title: translate('savedSearch.hint.travel_time.title'),
                text: translate('savedSearch.hint.travel_time.text')
            }
        };
    }
    return {
        type: 'default',
        content: {
            title: translate('savedSearch.hint.default.title'),
            text: translate('savedSearch.hint.default.text')
        }
    };
};

const config_IMN_DEU = {
    brandId: 'imn',
    searchBrand: 'immonet',
    favoriteBrand: 'immonet',
    mySpaceLink: '/meinbereich',
    hostnames: {
        signIn: 'https://{env}signin.immonet.de'
    },
    tracking: {
        site: 'INT'
    },
    legals: {
        upperLocal: "DE",
        country: "Deutschland",
        terms: '/',
        policy: '/'
    },
    legacy: {
        loadingEnabled: false,
        checkMigrationState: false,
        useRecommendations: false,
        channelInteractionEnabled: true
    },
    recommendations: true,
    createUtils: {
        supported: true,
        emailRequired: false
    },
    button: {
        supported: true,
        supportCard: true,
        legacy: true,
        hintFeatures: {
            default: true,
            travelTime: false
        },
        intermediaryMatchingMandate: false,
        intermediaryMatchingMandateWithLocal: false
    },
    login: {
        supported: true,
        oauth: true
    },
    hpList: {
        supported: true,
        showMore: false,
        withRelaxed: false,
        favorites: false
    }
};

const config_IWT_DEU = {
    brandId: 'iwt',
    searchBrand: 'immowelt',
    favoriteBrand: 'immowelt',
    mySpaceLink: '/meinbereich',
    hostnames: {
        signIn: 'https://{env}signin.immowelt.de'
    },
    tracking: {
        site: 'IWT'
    },
    legals: {
        upperLocal: 'DE',
        country: 'Deutschland',
        terms: '/',
        policy: '/'
    },
    legacy: {
        loadingEnabled: false,
        checkMigrationState: false,
        useRecommendations: true,
        channelInteractionEnabled: true
    },
    recommendations: true,
    createUtils: {
        supported: true,
        emailRequired: false
    },
    button: {
        supported: true,
        supportCard: false,
        legacy: true,
        hintFeatures: {
            default: true,
            travelTime: false
        },
        intermediaryMatchingMandate: false,
        intermediaryMatchingMandateWithLocal: false
    },
    login: {
        supported: true,
        oauth: true
    },
    hpList: {
        supported: false,
        showMore: false,
        withRelaxed: false,
        favorites: false
    }
};

const config_LIM_FRA = {
    brandId: 'li',
    searchBrand: 'logicimmo',
    favoriteBrand: 'logicimmo',
    hostnames: {
        signIn: 'https://{env}signin.logic-immo.com'
    },
    tracking: {
        site: 'LICOM'
    },
    legals: {
        upperLocal: 'FR',
        country: 'France',
        terms: 'https://www.logic-immo.com/conditions-generales-d-utilisation.html',
        policy: 'https://www.logic-immo.com/cgu-et-politique-de-confidentialite.html'
    },
    legacy: {
        loadingEnabled: true,
        checkMigrationState: false,
        useRecommendations: false,
        channelInteractionEnabled: true
    },
    recommendations: true,
    createUtils: {
        supported: true,
        emailRequired: true
    },
    button: {
        supported: true,
        supportCard: true,
        legacy: true,
        hintFeatures: {
            default: false,
            travelTime: false
        },
        intermediaryMatchingMandate: false,
        intermediaryMatchingMandateWithLocal: true
    },
    login: {
        supported: true,
        oauth: false
    },
    hpList: {
        supported: false,
        showMore: false,
        withRelaxed: false,
        favorites: false
    }
};

const config_SLG_FRA = {
    brandId: 'sl',
    searchBrand: 'seloger',
    favoriteBrand: 'seloger',
    mySpaceLink: '/mon-espace',
    hostnames: {
        signIn: 'https://{env}signin.seloger.com'
    },
    tracking: {
        site: 'SL'
    },
    legals: {
        upperLocal: 'FR',
        country: 'France',
        terms: 'https://www.seloger.com/Conditions_Generales_d_Utilisation.html',
        policy: 'https://www.seloger.com/CGU_politique_de_confidentialite.html'
    },
    legacy: {
        loadingEnabled: true,
        checkMigrationState: true,
        useRecommendations: false,
        channelInteractionEnabled: false
    },
    recommendations: true,
    createUtils: {
        supported: true,
        emailRequired: false
    },
    button: {
        supported: true,
        supportCard: true,
        legacy: false,
        hintFeatures: {
            default: false,
            travelTime: true
        },
        intermediaryMatchingMandate: true,
        intermediaryMatchingMandateWithLocal: false
    },
    login: {
        supported: true,
        oauth: true
    },
    hpList: {
        supported: true,
        showMore: false,
        withRelaxed: false,
        favorites: true
    }
};

const config_SLN_FRA = {
    brandId: 'sln',
    searchBrand: 'selogerneuf',
    hostnames: {
        // auth not supported yet on SLN
        signIn: 'https://{env}signin.selogerneuf.com'
    },
    tracking: {
        site: 'SLN'
    },
    legals: {
        upperLocal: "FR",
        country: "France",
        terms: 'https://www.selogerneuf.com/conditions-generales-utilisation/',
        policy: 'https://www.seloger.com/CGU_politique_de_confidentialite.html'
    },
    legacy: {
        loadingEnabled: true,
        checkMigrationState: true,
        useRecommendations: false,
        channelInteractionEnabled: false
    },
    recommendations: false,
    createUtils: {
        supported: false,
        emailRequired: false
    },
    button: {
        supported: false,
        supportCard: false,
        legacy: false,
        hintFeatures: {
            default: false,
            travelTime: false
        },
        intermediaryMatchingMandate: false,
        intermediaryMatchingMandateWithLocal: false
    },
    login: {
        supported: false,
        oauth: false
    },
    hpList: {
        supported: false,
        showMore: false,
        withRelaxed: false,
        favorites: false
    }
};

const brandConfigs = {
    imn: config_IMN_DEU,
    iwt: config_IWT_DEU,
    sl: config_SLG_FRA,
    sln: config_SLN_FRA,
    li: config_LIM_FRA
};
/**
 * Retrieve the brand config for a given brand defined in our types repo
 * @param brand From the brand defined in our types repo
 * @returns our brand config if we support that brand
 */ function getCustomBrandConfig(brand) {
    return brandConfigs[brand];
}

const mapMethod = (savedSearch)=>{
    let method = 'none';
    savedSearch.channels.forEach((channel)=>{
        if (channel.channel === 'email') {
            method = 'email';
        }
    });
    return method;
};
const mapDistributionTypeGlobal = (distributionType)=>{
    switch(distributionType){
        case DistributionType.RENT:
            return '1';
        case DistributionType.BUY:
            return '2';
        case DistributionType.BUY_AUCTION:
            return '3';
        case DistributionType.COMPULSORY_AUCTION:
            return '4';
        default:
            return '0';
    }
};
const mapEstateTypeGlobal = (estateType)=>{
    switch(estateType){
        case EstateType.AGRICULTURE_FORESTRY:
            return 'av_1';
        case EstateType.APARTMENT:
            return 'av_2';
        case EstateType.BUILDING:
            return 'av_3';
        case EstateType.GASTRONOMY_HOTEL:
            return 'av_4';
        case EstateType.HOUSE:
            return 'av_5';
        case EstateType.MISCELLANEOUS:
            return 'av_6';
        case EstateType.OFFICE:
            return 'av_7';
        case EstateType.PARKING:
            return 'av_8';
        case EstateType.PLOT:
            return 'av_9';
        case EstateType.PROJECT:
            return 'av_10';
        case EstateType.SENIOR:
            return 'av_11';
        case EstateType.STORAGE_PRODUCTION:
            return 'av_12';
        case EstateType.TRADING:
            return 'av_13';
        default:
            return '';
    }
};
const getMedium = ()=>{
    if (isWindowUndefined()) return '';
    const urlSearchParams = !isWindowUndefined() ? window?.location?.search : '';
    const queryParameters = new URLSearchParams(urlSearchParams);
    return queryParameters.get('m') ?? '';
};

const mapSavedSearchCommonsThorKeys = (savedSearch, initiative = 'wl_ss_web', category = 'alert')=>{
    const av_initiative = initiative;
    const av_category = category;
    const av_distribution_type_global = mapDistributionTypeGlobal(savedSearch?.criteria?.distributionType[0]);
    const estateType = savedSearch.criteria.estateType?.[0] ?? '';
    const av_estate_type_global = mapEstateTypeGlobal(estateType);
    return {
        av_initiative,
        av_category,
        av_distribution_type_global,
        av_estate_type_global
    };
};
const mapSavedSearchInterestToThorEvent = (savedSearch, eventType)=>{
    return {
        ...mapSavedSearchCommonsThorKeys(savedSearch),
        event: eventType
    };
};
const mapSavedSearchSubscripionToThorEvent = (savedSearch, eventType, origin = 'serp_full_list')=>{
    const eventBase = {
        ...mapSavedSearchInterestToThorEvent(savedSearch, eventType),
        av_medium: getMedium(),
        method: mapMethod(savedSearch)
    };
    return eventType === 'lead_classified_alert_opened' ? eventBase : {
        ...eventBase,
        av_feature: origin
    };
};
const mapSavedSearchDeletedToThorEvent = (savedSearch)=>{
    return {
        ...mapSavedSearchCommonsThorKeys(savedSearch),
        av_medium: getMedium(),
        event: 'lead_classified_alert_unsub'
    };
};
const mapSavedSearchSeePropertiesToThorEvent = (savedSearch)=>{
    return {
        ...mapSavedSearchCommonsThorKeys(savedSearch),
        link_text: 'see_properties',
        event: 'see_properties'
    };
};
const mapSavedSearchToogleAlertToThorEvent = (savedSearch, method, eventType)=>{
    return {
        ...mapSavedSearchCommonsThorKeys(savedSearch),
        method,
        event: eventType
    };
};
const mapSavedSearchEditAlert = (savedSearch, eventType)=>{
    return {
        ...mapSavedSearchCommonsThorKeys(savedSearch),
        event: eventType
    };
};
const intermediaryMatchingMandateThorEvent = (search, type)=>{
    const savedSearch = mapSearchDataModelToWLSearch(search);
    return {
        ...mapSavedSearchCommonsThorKeys(savedSearch, 'wl_ss_web', 'classified'),
        event: type
    };
};
const matchingListTracking = (classifieds, savedSearch)=>{
    if (!classifieds || !savedSearch) {
        return undefined;
    }
    const { av_category, av_initiative, av_distribution_type_global, av_estate_type_global } = mapSavedSearchCommonsThorKeys(savedSearch, 'wl_ss_web', 'classified');
    const items = Object.values(classifieds).map((classified)=>classified.tracking).filter((tracking)=>tracking !== undefined && tracking !== null).map((tracking)=>({
            ...tracking,
            list_name: 'last_saved_search'
        }));
    // @ts-ignore
    const EVENT_DATA = {
        event: 'view_item_list',
        av_items: items,
        av_category,
        av_initiative,
        av_distribution_type_global,
        av_estate_type_global
    };
    return EVENT_DATA;
};

new Map([
    [
        'HAUS',
        EstateType.HOUSE
    ],
    [
        'WOHNUNG',
        EstateType.APARTMENT
    ],
    [
        'GEWERBE_GRUNDSTUECK',
        EstateType.PLOT
    ],
    [
        'GRUNDSTUECK',
        EstateType.PLOT
    ],
    [
        'BUERO_PRAXISFLAECHE',
        EstateType.OFFICE
    ],
    [
        'LADENFLAECHE',
        EstateType.TRADING
    ],
    [
        'GASTRONOMIE_HOTEL',
        EstateType.GASTRONOMY_HOTEL
    ],
    [
        'HALLEN_INDUSTRIEFLAECHE',
        EstateType.STORAGE_PRODUCTION
    ],
    [
        'LAND_FORSTWIRTSCHAFT',
        EstateType.AGRICULTURE_FORESTRY
    ],
    [
        'GARAGE_STELLPLATZ',
        EstateType.PARKING
    ],
    [
        'SONSTIGES',
        EstateType.MISCELLANEOUS
    ],
    [
        'WOHNGEMEINSCHAFT',
        undefined
    ],
    [
        'WOHNEN_AUF_ZEIT',
        undefined
    ],
    [
        'RENDITEOBJEKT',
        undefined
    ]
]);
new Map([
    [
        'ZUM_KAUF',
        DistributionType.BUY
    ],
    [
        'ZUR_MIETE',
        DistributionType.RENT
    ],
    [
        'ZWANGSVERSTEIGERUNG',
        DistributionType.COMPULSORY_AUCTION
    ]
]);
({
    KEIN_DACHGESCHOSS: [
        LocationInBuilding.ROOF_STOREY_EXCLUDED
    ],
    KEIN_ERDGESCHOSS: [
        LocationInBuilding.GROUNDFLOOR_EXCLUDED
    ]
});
const LEGACY_MODEL_VERSION = 'legacy';
const isLegacySavedSearch = (savedSearch)=>savedSearch.metadata.modelVersion === LEGACY_MODEL_VERSION;

/** WALDO -> HYP BuildState */ const getCriteriaBuildState = (searchModel)=>{
    return searchModel.buildState?.map((v)=>BuildState$1[v.toUpperCase()]).filter((v)=>v !== undefined) ?? [];
};
/** HYP -> WALDO BuildState */ const getSearchBuildState = (criterias)=>{
    const result = criterias?.conditions?.buildState?.map((v)=>BuildState[v.toUpperCase()]).filter((v)=>v !== undefined) ?? [];
    return result.length ? result : undefined;
};

/** WALDO -> HYP CertificateOfEligibilityNeeded */ const getCriteriaCertificateOfEligibilityNeeded = (searchModel)=>{
    switch(searchModel.certificateOfEligibilityNeeded){
        case CertificateOfEligibility.YES:
            return true;
        case CertificateOfEligibility.NO:
            return false;
    }
    return undefined;
};
/** HYP -> WALDO CertificateOfEligibilityNeeded */ const getSearchCertificateOfEligibilityNeeded = (criterias)=>{
    switch(criterias?.management?.rent?.certificateOfEligibilityNeeded){
        case true:
            return CertificateOfEligibility.YES;
        case false:
            return CertificateOfEligibility.NO;
    }
    return undefined;
};

const searchToCriteriaMap = new Map([
    [
        DistributionType$1.BUY,
        DistributionType.BUY
    ],
    [
        DistributionType$1.BUY_AUCTION,
        DistributionType.BUY_AUCTION
    ],
    [
        DistributionType$1.COMPULSORY_AUCTION,
        DistributionType.COMPULSORY_AUCTION
    ],
    [
        DistributionType$1.RENT,
        DistributionType.RENT
    ]
]);
/** WALDO -> HYP DistributionType */ const getCriteriaDistributionType = (searchModel)=>{
    const result = new Set();
    for (const v of searchModel?.distributionTypes ?? []){
        const distributionType = searchToCriteriaMap.get(v);
        if (distributionType !== undefined) {
            result.add(distributionType);
        }
    }
    return Array.from(result);
};
const criteriaToSearchMap = new Map([
    [
        DistributionType.BUY,
        DistributionType$1.BUY
    ],
    [
        DistributionType.BUY_AUCTION,
        DistributionType$1.BUY_AUCTION
    ],
    [
        DistributionType.COMPULSORY_AUCTION,
        DistributionType$1.COMPULSORY_AUCTION
    ],
    [
        DistributionType.RENT,
        DistributionType$1.RENT
    ]
]);
/** HYP -> WALDO DistributionType */ const getSearchDistributionType = (criterias)=>{
    const result = new Set();
    for (const v of criterias?.distributionType ?? []){
        const distributionType = criteriaToSearchMap.get(v);
        if (distributionType !== undefined) {
            result.add(distributionType);
        }
    }
    return Array.from(result);
};

/** WALDO -> HYP EnergyCertificateClass */ const getCriteriaEnergyCertificateClass = (searchModel)=>{
    const result = new Set();
    for (const v of searchModel.energyCertificateClass ?? []){
        const energyClass = EnergyClass[v.toUpperCase()];
        if (energyClass !== undefined && energyClass !== EnergyClass.None) {
            result.add(energyClass);
        }
    }
    return Array.from(result);
};
/** HYP -> WALDO EnergyCertificateClass */ const getSearchEnergyCertificateClass = (criterias)=>{
    const result = criterias?.conditions?.energyClass ?? [];
    return result.length ? result : undefined;
};

/** WALDO -> HYP EstateSubType */ const getCriteriaEstateSubType = (searchModel)=>{
    const result = new Set();
    for (const v of searchModel.estateSubTypes ?? []){
        const estateSubType = EstateSubType$1[v.toUpperCase()];
        if (estateSubType !== undefined && estateSubType !== EstateSubType$1.None) {
            result.add(estateSubType);
        }
    }
    return Array.from(result);
};
/** HYP -> WALDO EstateSubType */ const getSearchEstateSubType = (criterias)=>{
    const result = new Set();
    for (const v of criterias?.estateSubType ?? []){
        const estateSubType = EstateSubType[v];
        if (estateSubType !== undefined) {
            result.add(estateSubType);
        }
    }
    return result.size ? Array.from(result) : undefined;
};

const criteriaEstateTypeMap = new Map([
    [
        EstateType$1.HOUSE,
        EstateType.HOUSE
    ],
    [
        EstateType$1.APARTMENT,
        EstateType.APARTMENT
    ],
    [
        EstateType$1.PARKING,
        EstateType.PARKING
    ],
    [
        EstateType$1.PLOT,
        EstateType.PLOT
    ],
    [
        EstateType$1.MISCELLANEOUS,
        EstateType.MISCELLANEOUS
    ],
    [
        EstateType$1.OFFICE,
        EstateType.OFFICE
    ],
    [
        EstateType$1.TRADING,
        EstateType.TRADING
    ],
    [
        EstateType$1.GASTRONOMY_HOTEL,
        EstateType.GASTRONOMY_HOTEL
    ],
    [
        EstateType$1.STORAGE_PRODUCTION,
        EstateType.STORAGE_PRODUCTION
    ],
    [
        EstateType$1.AGRICULTURE_FORESTRY,
        EstateType.AGRICULTURE_FORESTRY
    ]
]);
/** WALDO -> HYP EstateType */ const getCriteriaEstateType = (searchModel)=>{
    const result = new Set();
    for (const estateType of searchModel.estateTypes ?? []){
        const mappedEstateType = criteriaEstateTypeMap.get(estateType);
        if (mappedEstateType) {
            result.add(mappedEstateType);
        }
    }
    if (searchModel.projectTypes?.includes(ProjectType.PROJECTED) || searchModel.estateTypes?.includes(EstateType$1.HOUSE) || searchModel.estateTypes?.includes(EstateType$1.APARTMENT)) {
        result.add(EstateType.PROJECT);
    }
    return Array.from(result);
};
const SearchEstateTypeMap = new Map([
    [
        EstateType.None,
        undefined
    ],
    [
        EstateType.HOUSE,
        EstateType$1.HOUSE
    ],
    [
        EstateType.APARTMENT,
        EstateType$1.APARTMENT
    ],
    [
        EstateType.PARKING,
        EstateType$1.PARKING
    ],
    [
        EstateType.PLOT,
        EstateType$1.PLOT
    ],
    [
        EstateType.MISCELLANEOUS,
        EstateType$1.MISCELLANEOUS
    ],
    [
        EstateType.OFFICE,
        EstateType$1.OFFICE
    ],
    [
        EstateType.TRADING,
        EstateType$1.TRADING
    ],
    [
        EstateType.GASTRONOMY_HOTEL,
        EstateType$1.GASTRONOMY_HOTEL
    ],
    [
        EstateType.STORAGE_PRODUCTION,
        EstateType$1.STORAGE_PRODUCTION
    ],
    [
        EstateType.AGRICULTURE_FORESTRY,
        EstateType$1.AGRICULTURE_FORESTRY
    ],
    [
        EstateType.BUILDING,
        undefined
    ],
    [
        EstateType.SENIOR,
        undefined
    ],
    [
        EstateType.PROJECT,
        undefined
    ],
    [
        EstateType.MISCELLANEOUS,
        undefined
    ]
]);
/** HYP -> WALDO EstateType */ const getSearchEstateType = (criterias)=>{
    const result = new Set();
    for (const estateType of criterias?.estateType ?? []){
        const mappedEstateType = SearchEstateTypeMap.get(estateType);
        if (mappedEstateType) {
            result.add(mappedEstateType);
        }
    }
    return result.size ? Array.from(result) : undefined;
};

/** WALDO -> HYP FeaturesIncluded */ const getCriteriaBrokerageFee = (searchModel)=>{
    return searchModel.featuresIncluded?.includes(FeatureType.COMMISSION_FREE) ? {
        hasFee: HasFee.YES
    } : {
        hasFee: HasFee.None
    };
};
const getCriteriaBathroom = (searchModel)=>{
    return {
        window: searchModel.featuresIncluded?.includes(FeatureType.BATHROOM_WINDOW) ? true : undefined,
        bathtub: searchModel.featuresIncluded?.includes(FeatureType.BATHROOM_BATHTUB) ? true : undefined
    };
};
const getCriteriaKitchen = (searchModel)=>{
    return {
        equipment: searchModel.featuresIncluded?.includes(FeatureType.KITCHEN_FULLY_EQUIPPED) ? KitchenEquipment.FULLY_EQUIPPED : KitchenEquipment.UNKNOWN
    };
};
const getCriteriaElevator = (searchModel)=>{
    return searchModel.featuresIncluded?.includes(FeatureType.ELEVATOR) ? [
        Elevator.ANYKIND
    ] : [];
};
const getCriteriaCellar = (searchModel)=>{
    return searchModel.featuresIncluded?.includes(FeatureType.CELLAR) ? Cellar.ANYKIND : Cellar.None;
};
const getCriteriaParkingLots = (searchModel)=>{
    return {
        numberOfParkingsMin: searchModel.featuresIncluded?.includes(FeatureType.PARKING_GARAGE) ? 1 : undefined,
        numberOfGaragesMin: undefined
    };
};
const getCriteriaIsRented = (searchModel)=>{
    return searchModel.featuresIncluded?.includes(FeatureType.VACANT) ? false : undefined;
};
const getCriteriaPetAllowed = (searchModel)=>{
    return searchModel.featuresIncluded?.includes(FeatureType.PETS_ALLOWED) ? true : undefined;
};
const getCriteriaWheelchairUse = (searchModel)=>{
    return searchModel.featuresIncluded?.includes(FeatureType.REDUCE_MOBILITY_ACCESS) ? true : undefined;
};
const getCriteriaGarden = (searchModel)=>{
    return searchModel.featuresIncluded?.includes(FeatureType.GARDEN) ? [
        Garden.ANYKIND
    ] : [];
};
const getCriteriaSwimmingPool = (searchModel)=>{
    return searchModel.featuresIncluded?.includes(FeatureType.SWIMMING_POOL) ? SwimmingPool.ANYKIND : SwimmingPool.None;
};
/** HYP -> WALDO FeaturesIncluded */ const getSearchFeaturesIncluded = (criterias)=>{
    const features = [];
    if (criterias?.prices?.brokerageFee?.hasFee === HasFee.YES) {
        features.push(FeatureType.COMMISSION_FREE);
    }
    if (criterias?.structure?.rooms?.numberOfBalconiesMin) {
        features.push(FeatureType.BALCONY_TERRACE);
    }
    if (criterias?.structure?.building?.bath?.window) {
        features.push(FeatureType.BATHROOM_WINDOW);
    }
    if (criterias?.structure?.building?.bath?.bathtub) {
        features.push(FeatureType.BATHROOM_BATHTUB);
    }
    if (criterias?.structure?.building?.kitchen?.equipment === KitchenEquipment.FULLY_EQUIPPED) {
        features.push(FeatureType.KITCHEN_FULLY_EQUIPPED);
    }
    if (criterias?.structure?.building?.elevator?.length) {
        features.push(FeatureType.ELEVATOR);
    }
    if (criterias?.structure?.building?.cellar === Cellar.ANYKIND) {
        features.push(FeatureType.CELLAR);
    }
    if (criterias?.structure?.parkingLots?.numberOfParkingsMin || criterias?.structure?.parkingLots?.numberOfGaragesMin) {
        features.push(FeatureType.PARKING_GARAGE);
    }
    if (criterias?.management?.rent?.petsAllowed) {
        features.push(FeatureType.PETS_ALLOWED);
    }
    if (criterias?.management?.isRented === false) {
        features.push(FeatureType.VACANT);
    }
    if (criterias?.features?.wheelchairUse) {
        features.push(FeatureType.REDUCE_MOBILITY_ACCESS);
    }
    if (criterias?.features?.garden?.length) {
        features.push(FeatureType.GARDEN);
    }
    if (criterias?.features?.residential?.swimmingPool === SwimmingPool.ANYKIND) {
        features.push(FeatureType.SWIMMING_POOL);
    }
    return features.length ? features : undefined;
};

/** WALDO -> HYP Furnished */ const getCriteriaFurnished = (searchModel)=>{
    const furnished = searchModel.furnished;
    if (!furnished) {
        return Furnished.None;
    }
    if (furnished.includes(Furnished$1.FULL) && furnished.includes(Furnished$1.NO)) {
        return Furnished.ANYKIND;
    }
    if (furnished.includes(Furnished$1.FULL)) {
        return Furnished.FULL;
    }
    if (furnished.includes(Furnished$1.NO)) {
        return Furnished.NO;
    }
    if (furnished.includes(Furnished$1.NOT_APPLICABLE)) {
        return Furnished.NOT_APPLICABLE;
    }
    return Furnished.None;
};
/** HYP -> WALDO Furnished */ const getSearchFurnished = (criterias)=>{
    switch(criterias?.features?.furnished){
        case Furnished.FULL:
            return [
                Furnished$1.FULL
            ];
        case Furnished.NO:
            return [
                Furnished$1.NO
            ];
        case Furnished.NOT_APPLICABLE:
            return [
                Furnished$1.NOT_APPLICABLE
            ];
        case Furnished.ANYKIND:
            return [
                Furnished$1.FULL,
                Furnished$1.NO
            ];
        default:
            return undefined;
    }
};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var polyline = {exports: {}};

var hasRequiredPolyline;

function requirePolyline () {
	if (hasRequiredPolyline) return polyline.exports;
	hasRequiredPolyline = 1;
	(function (module) {

		/**
		 * Based off of [the offical Google document](https://developers.google.com/maps/documentation/utilities/polylinealgorithm)
		 *
		 * Some parts from [this implementation](http://facstaff.unca.edu/mcmcclur/GoogleMaps/EncodePolyline/PolylineEncoder.js)
		 * by [Mark McClure](http://facstaff.unca.edu/mcmcclur/)
		 *
		 * @module polyline
		 */

		var polyline = {};

		function py2_round(value) {
		    // Google's polyline algorithm uses the same rounding strategy as Python 2, which is different from JS for negative values
		    return Math.floor(Math.abs(value) + 0.5) * (value >= 0 ? 1 : -1);
		}

		function encode(current, previous, factor) {
		    current = py2_round(current * factor);
		    previous = py2_round(previous * factor);
		    var coordinate = (current - previous) * 2;
		    if (coordinate < 0) {
		        coordinate = -coordinate - 1;
		    }
		    var output = '';
		    while (coordinate >= 0x20) {
		        output += String.fromCharCode((0x20 | (coordinate & 0x1f)) + 63);
		        coordinate /= 32;
		    }
		    output += String.fromCharCode((coordinate | 0) + 63);
		    return output;
		}

		/**
		 * Decodes to a [latitude, longitude] coordinates array.
		 *
		 * This is adapted from the implementation in Project-OSRM.
		 *
		 * @param {String} str
		 * @param {Number} precision
		 * @returns {Array}
		 *
		 * @see https://github.com/Project-OSRM/osrm-frontend/blob/master/WebContent/routing/OSRM.RoutingGeometry.js
		 */
		polyline.decode = function(str, precision) {
		    var index = 0,
		        lat = 0,
		        lng = 0,
		        coordinates = [],
		        shift = 0,
		        result = 0,
		        byte = null,
		        latitude_change,
		        longitude_change,
		        factor = Math.pow(10, Number.isInteger(precision) ? precision : 5);

		    // Coordinates have variable length when encoded, so just keep
		    // track of whether we've hit the end of the string. In each
		    // loop iteration, a single coordinate is decoded.
		    while (index < str.length) {

		        // Reset shift, result, and byte
		        byte = null;
		        shift = 1;
		        result = 0;

		        do {
		            byte = str.charCodeAt(index++) - 63;
		            result += (byte & 0x1f) * shift;
		            shift *= 32;
		        } while (byte >= 0x20);

		        latitude_change = (result & 1) ? ((-result - 1) / 2) : (result / 2);

		        shift = 1;
		        result = 0;

		        do {
		            byte = str.charCodeAt(index++) - 63;
		            result += (byte & 0x1f) * shift;
		            shift *= 32;
		        } while (byte >= 0x20);

		        longitude_change = (result & 1) ? ((-result - 1) / 2) : (result / 2);

		        lat += latitude_change;
		        lng += longitude_change;

		        coordinates.push([lat / factor, lng / factor]);
		    }

		    return coordinates;
		};

		/**
		 * Encodes the given [latitude, longitude] coordinates array.
		 *
		 * @param {Array.<Array.<Number>>} coordinates
		 * @param {Number} precision
		 * @returns {String}
		 */
		polyline.encode = function(coordinates, precision) {
		    if (!coordinates.length) { return ''; }

		    var factor = Math.pow(10, Number.isInteger(precision) ? precision : 5),
		        output = encode(coordinates[0][0], 0, factor) + encode(coordinates[0][1], 0, factor);

		    for (var i = 1; i < coordinates.length; i++) {
		        var a = coordinates[i], b = coordinates[i - 1];
		        output += encode(a[0], b[0], factor);
		        output += encode(a[1], b[1], factor);
		    }

		    return output;
		};

		function flipped(coords) {
		    var flipped = [];
		    for (var i = 0; i < coords.length; i++) {
		        var coord = coords[i].slice();
		        flipped.push([coord[1], coord[0]]);
		    }
		    return flipped;
		}

		/**
		 * Encodes a GeoJSON LineString feature/geometry.
		 *
		 * @param {Object} geojson
		 * @param {Number} precision
		 * @returns {String}
		 */
		polyline.fromGeoJSON = function(geojson, precision) {
		    if (geojson && geojson.type === 'Feature') {
		        geojson = geojson.geometry;
		    }
		    if (!geojson || geojson.type !== 'LineString') {
		        throw new Error('Input must be a GeoJSON LineString');
		    }
		    return polyline.encode(flipped(geojson.coordinates), precision);
		};

		/**
		 * Decodes to a GeoJSON LineString geometry.
		 *
		 * @param {String} str
		 * @param {Number} precision
		 * @returns {Object}
		 */
		polyline.toGeoJSON = function(str, precision) {
		    var coords = polyline.decode(str, precision);
		    return {
		        type: 'LineString',
		        coordinates: flipped(coords)
		    };
		};

		if (module.exports) {
		    module.exports = polyline;
		} 
	} (polyline));
	return polyline.exports;
}

var polylineExports = requirePolyline();

var inputValidation = {};

var validateCenter = {};

var hasRequiredValidateCenter;

function requireValidateCenter () {
	if (hasRequiredValidateCenter) return validateCenter;
	hasRequiredValidateCenter = 1;
	validateCenter.validateCenter = function validateCenter(center) {
	  var validCenterLengths = [2, 3];
	  if (!Array.isArray(center) || !validCenterLengths.includes(center.length)) {
	    throw new Error("ERROR! Center has to be an array of length two or three");
	  }

	  var [lng, lat] = center;
	  if (typeof lng !== "number" || typeof lat !== "number") {
	    throw new Error(
	      `ERROR! Longitude and Latitude has to be numbers but where ${typeof lng} and ${typeof lat}`
	    );
	  }
	  if (lng > 180 || lng < -180) {
	    throw new Error(`ERROR! Longitude has to be between -180 and 180 but was ${lng}`);
	  }

	  if (lat > 90 || lat < -90) {
	    throw new Error(`ERROR! Latitude has to be between -90 and 90 but was ${lat}`);
	  }
	};
	return validateCenter;
}

var validateRadius = {};

var hasRequiredValidateRadius;

function requireValidateRadius () {
	if (hasRequiredValidateRadius) return validateRadius;
	hasRequiredValidateRadius = 1;
	validateRadius.validateRadius = function validateRadius(radius) {
	  if (typeof radius !== "number") {
	    throw new Error(`ERROR! Radius has to be a positive number but was: ${typeof radius}`);
	  }

	  if (radius <= 0) {
	    throw new Error(`ERROR! Radius has to be a positive number but was: ${radius}`);
	  }
	};
	return validateRadius;
}

var validateNumberOfEdges = {};

var hasRequiredValidateNumberOfEdges;

function requireValidateNumberOfEdges () {
	if (hasRequiredValidateNumberOfEdges) return validateNumberOfEdges;
	hasRequiredValidateNumberOfEdges = 1;
	validateNumberOfEdges.validateNumberOfEdges = function validateNumberOfEdges(numberOfEdges) {
	  if (typeof numberOfEdges !== "number") {
	    const ARGUMENT_TYPE = Array.isArray(numberOfEdges) ? "array" : typeof numberOfEdges;
	    throw new Error(`ERROR! Number of edges has to be a number but was: ${ARGUMENT_TYPE}`);
	  }

	  if (numberOfEdges < 3) {
	    throw new Error(`ERROR! Number of edges has to be at least 3 but was: ${numberOfEdges}`);
	  }
	};
	return validateNumberOfEdges;
}

var validateEarthRadius = {};

var hasRequiredValidateEarthRadius;

function requireValidateEarthRadius () {
	if (hasRequiredValidateEarthRadius) return validateEarthRadius;
	hasRequiredValidateEarthRadius = 1;
	validateEarthRadius.validateEarthRadius = function validateEarthRadius(earthRadius) {
	  if (typeof earthRadius !== "number") {
	    const ARGUMENT_TYPE = Array.isArray(earthRadius) ? "array" : typeof earthRadius;
	    throw new Error(`ERROR! Earth radius has to be a number but was: ${ARGUMENT_TYPE}`);
	  }

	  if (earthRadius <= 0) {
	    throw new Error(`ERROR! Earth radius has to be a positive number but was: ${earthRadius}`);
	  }
	};
	return validateEarthRadius;
}

var validateBearing = {};

var hasRequiredValidateBearing;

function requireValidateBearing () {
	if (hasRequiredValidateBearing) return validateBearing;
	hasRequiredValidateBearing = 1;
	validateBearing.validateBearing = function validateBearing(bearing) {
	  if (typeof bearing !== "number") {
	    const ARGUMENT_TYPE = Array.isArray(bearing) ? "array" : typeof bearing;
	    throw new Error(`ERROR! Bearing has to be a number but was: ${ARGUMENT_TYPE}`);
	  }
	};
	return validateBearing;
}

var hasRequiredInputValidation;

function requireInputValidation () {
	if (hasRequiredInputValidation) return inputValidation;
	hasRequiredInputValidation = 1;
	var validateCenter = requireValidateCenter().validateCenter;
	var validateRadius = requireValidateRadius().validateRadius;
	var validateNumberOfEdges = requireValidateNumberOfEdges().validateNumberOfEdges;
	var validateEarthRadius = requireValidateEarthRadius().validateEarthRadius;
	var validateBearing = requireValidateBearing().validateBearing;

	function validateInput({ center, radius, numberOfEdges, earthRadius, bearing }) {
	  validateCenter(center);
	  validateRadius(radius);
	  validateNumberOfEdges(numberOfEdges);
	  validateEarthRadius(earthRadius);
	  validateBearing(bearing);
	}

	inputValidation.validateCenter = validateCenter;
	inputValidation.validateRadius = validateRadius;
	inputValidation.validateNumberOfEdges = validateNumberOfEdges;
	inputValidation.validateEarthRadius = validateEarthRadius;
	inputValidation.validateBearing = validateBearing;
	inputValidation.validateInput = validateInput;
	return inputValidation;
}

var circleToPolygon$1;
var hasRequiredCircleToPolygon;

function requireCircleToPolygon () {
	if (hasRequiredCircleToPolygon) return circleToPolygon$1;
	hasRequiredCircleToPolygon = 1;
	var { validateInput } = requireInputValidation();

	const defaultEarthRadius = 6378137; // equatorial Earth radius

	function toRadians(angleInDegrees) {
	  return (angleInDegrees * Math.PI) / 180;
	}

	function toDegrees(angleInRadians) {
	  return (angleInRadians * 180) / Math.PI;
	}

	function offset(c1, distance, earthRadius, bearing) {
	  var lat1 = toRadians(c1[1]);
	  var lon1 = toRadians(c1[0]);
	  var dByR = distance / earthRadius;
	  var lat = Math.asin(
	    Math.sin(lat1) * Math.cos(dByR) + Math.cos(lat1) * Math.sin(dByR) * Math.cos(bearing)
	  );
	  var lon =
	    lon1 +
	    Math.atan2(
	      Math.sin(bearing) * Math.sin(dByR) * Math.cos(lat1),
	      Math.cos(dByR) - Math.sin(lat1) * Math.sin(lat)
	    );
	  return [toDegrees(lon), toDegrees(lat)];
	}

	circleToPolygon$1 = function circleToPolygon(center, radius, options) {
	  var n = getNumberOfEdges(options);
	  var earthRadius = getEarthRadius(options);
	  var bearing = getBearing(options);
	  var direction = getDirection(options);

	  // validateInput() throws error on invalid input and do nothing on valid input
	  validateInput({ center, radius, numberOfEdges: n, earthRadius, bearing });

	  var start = toRadians(bearing);
	  var coordinates = [];
	  for (var i = 0; i < n; ++i) {
	    coordinates.push(
	      offset(
	        center, radius, earthRadius, start + (direction * 2 * Math.PI * -i) / n
	      )
	    );
	  }
	  coordinates.push(coordinates[0]);

	  return {
	    type: "Polygon",
	    coordinates: [coordinates]
	  };
	};

	function getNumberOfEdges(options) {
	  if (isUndefinedOrNull(options)) {
	    return 32;
	  } else if (isObjectNotArray(options)) {
	    var numberOfEdges = options.numberOfEdges;
	    return numberOfEdges === undefined ? 32 : numberOfEdges;
	  }
	  return options;
	}

	function getEarthRadius(options) {
	  if (isUndefinedOrNull(options)) {
	    return defaultEarthRadius;
	  } else if (isObjectNotArray(options)) {
	    var earthRadius = options.earthRadius;
	    return earthRadius === undefined ? defaultEarthRadius : earthRadius;
	  }
	  return defaultEarthRadius;
	}

	function getDirection(options){
	  if (isObjectNotArray(options) && options.rightHandRule){
	    return -1;
	  }
	  return 1;
	}

	function getBearing(options) {
	  if (isUndefinedOrNull(options)) {
	    return 0;
	  } else if (isObjectNotArray(options)) {
	    var bearing = options.bearing;
	    return bearing === undefined ? 0 : bearing;
	  }
	  return 0;
	}

	function isObjectNotArray(argument) {
	  return argument !== null && typeof argument === "object" && !Array.isArray(argument);
	}

	function isUndefinedOrNull(argument) {
	  return argument === null || argument === undefined;
	}
	return circleToPolygon$1;
}

var circleToPolygonExports = requireCircleToPolygon();
var circleToPolygon = /*@__PURE__*/getDefaultExportFromCjs(circleToPolygonExports);

function isRadiusLocation(obj) {
    return obj.type === LocationType.RADIUS || 'radius' in obj && obj.radius !== undefined;
}
function isSearchCommuteLocation(obj) {
    return obj.type === LocationType.COMMUTE || 'duration' in obj && obj.duration !== undefined;
}
function isBaseLocation(obj) {
    return obj.type === LocationType.PLACE_ID || !isRadiusLocation(obj) && !isSearchCommuteLocation(obj);
}
/** WALDO -> HYP Location */ const getCriteriaLocation = (searchModel)=>{
    const result = {
        placeIds: [],
        geometries: {
            circles: [],
            polygons: [],
            travels: []
        },
        placeIdInfos: []
    };
    const locations = searchModel.locations;
    if (!locations?.length) {
        return result;
    }
    result.geometries.circles = locations.filter(isRadiusLocation).map((el)=>({
            radius: el.radius,
            radiusUnit: LocationGeometryCircleRadiusUnit.km,
            centerPlaceId: el.placeId,
            locationGeometryCoordinate: {
                latitude: 0,
                longitude: 0
            }
        }));
    result.geometries.travels = locations.filter(isSearchCommuteLocation).map((commute)=>({
            placeIds: commute.placeIds,
            travelMode: [
                searchCommuteToSavedSearchTravelMode[commute.mode]
            ],
            travelUnit: LocationGeometryTravelUnit.TIME,
            travelValue: commute.duration,
            polylines: commute.polylines
        }));
    result.placeIds = locations.filter(isBaseLocation).map((l)=>l.placeId);
    return result;
};
const searchCommuteToSavedSearchTravelMode = {
    [CommuteMode.BIKE]: LocationGeometryTravelMode.BIKE,
    [CommuteMode.CAR]: LocationGeometryTravelMode.CAR,
    [CommuteMode.TRANSIT]: LocationGeometryTravelMode.TRANSIT,
    [CommuteMode.WALK]: LocationGeometryTravelMode.WALK
};
/** HYP -> WALDO Location */ const getSearchLocation = (criterias)=>{
    const locations = criterias?.location;
    if (!locations) {
        return [];
    }
    const result = [];
    if (locations.placeIds.length) {
        result.push(...locations.placeIds.map((placeId)=>({
                type: LocationType.PLACE_ID,
                placeId
            })));
    }
    if (locations.geometries.circles.length) {
        result.push(...locations.geometries.circles.map(getSearchRadiusLocation).filter((x)=>x !== undefined));
    }
    if (locations.geometries.travels.length) {
        result.push(...locations.geometries.travels.filter((travel)=>travel.travelUnit === LocationGeometryTravelUnit.TIME).flatMap((commute)=>commute.travelMode.map((mode)=>({
                    type: LocationType.COMMUTE,
                    duration: commute.travelValue,
                    mode: savedSearchTravelModeToSearchCommute[mode],
                    placeIds: commute.placeIds,
                    polylines: commute.polylines
                }))));
    }
    return result;
};
const savedSearchTravelModeToSearchCommute = {
    [LocationGeometryTravelMode.BIKE]: CommuteMode.BIKE,
    [LocationGeometryTravelMode.CAR]: CommuteMode.CAR,
    [LocationGeometryTravelMode.TRANSIT]: CommuteMode.TRANSIT,
    [LocationGeometryTravelMode.WALK]: CommuteMode.WALK
};
const getSearchRadiusLocation = ({ radius, centerPlaceId, locationGeometryCoordinate: { latitude, longitude }, radiusUnit })=>{
    // method copy from https://github.com/axel-springer-kugawana/aviv_classified_search_mfe/blob/main/packages/refiner/src/services/getPolyline.ts
    try {
        const radiusInMeter = radiusUnit === LocationGeometryCircleRadiusUnit.km ? radius * 1000 : radius;
        const { coordinates: [firstCoordinate] } = circleToPolygon([
            longitude,
            latitude
        ], radiusInMeter, 32);
        if (!firstCoordinate || firstCoordinate.length === 0) {
            return undefined;
        }
        const polyline = polylineExports.encode(firstCoordinate.map(([longitude, latitude])=>[
                latitude,
                longitude
            ]));
        return {
            type: LocationType.RADIUS,
            placeId: centerPlaceId,
            radius,
            polyline
        };
    } catch  {
        return undefined;
    }
};

/** WALDO -> HYP LocationInBuilding */ const getCriteriaLocationInBuilding = (searchModel)=>{
    const result = new Set();
    for (const locationInBuilding of searchModel.locationsInBuildingIncluded ?? []){
        switch(locationInBuilding){
            case LocationInBuildingType.GROUND_FLOOR:
                result.add(LocationInBuilding.GROUNDFLOOR);
                break;
            case LocationInBuildingType.ROOF_STOREY:
                result.add(LocationInBuilding.ROOF_STOREY);
                break;
        }
    }
    for (const locationInBuilding of searchModel.locationsInBuildingExcluded ?? []){
        switch(locationInBuilding){
            case LocationInBuildingType.GROUND_FLOOR:
                result.add(LocationInBuilding.GROUNDFLOOR_EXCLUDED);
                break;
            case LocationInBuildingType.ROOF_STOREY:
                result.add(LocationInBuilding.ROOF_STOREY_EXCLUDED);
                break;
        }
    }
    return Array.from(result);
};
/** HYP -> WALDO LocationInBuilding */ const getSearchLocationsInBuilding = (criterias)=>{
    const excluded = new Set();
    const included = new Set();
    for (const element of criterias?.structure?.building?.locationInBuilding ?? []){
        switch(element){
            case LocationInBuilding.GROUNDFLOOR:
                included.add(LocationInBuildingType.GROUND_FLOOR);
                break;
            case LocationInBuilding.ROOF_STOREY:
                included.add(LocationInBuildingType.ROOF_STOREY);
                break;
            case LocationInBuilding.GROUNDFLOOR_EXCLUDED:
                excluded.add(LocationInBuildingType.GROUND_FLOOR);
                break;
            case LocationInBuilding.ROOF_STOREY_EXCLUDED:
                excluded.add(LocationInBuildingType.ROOF_STOREY);
                break;
        }
    }
    return {
        exclude: excluded.size ? Array.from(excluded) : undefined,
        include: included.size ? Array.from(included) : undefined
    };
};

const businessEstateTypes = new Set([
    EstateType$1.GASTRONOMY_HOTEL,
    EstateType$1.STORAGE_PRODUCTION,
    EstateType$1.TRADING
]);
/** WALDO -> HYP DistributionType */ const getCriteriaDistributionSubType = (searchModel)=>{
    const result = new Set();
    for (const projectType of searchModel.projectTypes ?? []){
        switch(projectType){
            case ProjectType.INVESTMENT:
                result.add(DistributionSubType.NEW_BUILD_INVESTMENT_PRODUCT);
                break;
            case ProjectType.NEW_BUILD:
                result.add(DistributionSubType.NEW_BUILD_UNIT);
                break;
            case ProjectType.PROJECTED:
                result.add(DistributionSubType.NEW_HOME);
                break;
            case ProjectType.LIFE_ANNUITY:
                result.add(DistributionSubType.LIFE_ANNUITY);
                break;
            case ProjectType.SHORT_TIME_RENTAL:
                result.add(DistributionSubType.TEMPORARY);
                result.add(DistributionSubType.VACATION);
                break;
            case ProjectType.STOCK:
                result.add(DistributionSubType.CLASSIC);
                result.add(DistributionSubType.BUSINESS);
                break;
            case ProjectType.RESALE:
                result.add(DistributionSubType.RESALE);
                if (searchModel.estateTypes?.some((estateType)=>businessEstateTypes.has(estateType))) {
                    result.add(DistributionSubType.BUSINESS_LEASEBACK);
                    result.add(DistributionSubType.BUSINESS_SALE_GOODWILL);
                }
                break;
            case ProjectType.SWAP_APARTMENT:
            case ProjectType.FLATSHARING:
        }
    }
    return Array.from(result);
};
const getCriteriaIsForSwap = (searchModel)=>{
    //https://avivgroup.atlassian.net/wiki/spaces/ATSS/pages/1381073256/studies+SSA+-+IsForSwap+fix#Fix-frontend-mapper
    //only apply to rent
    const isRent = searchModel.distributionTypes?.includes(DistributionType$1.RENT) ?? false;
    if (!isRent) return undefined;
    const projectType = searchModel.projectTypes ?? [];
    const isProjectTypesEmpty = projectType.length === 0;
    //seeker unselected all the project type: no filter is applied
    if (isProjectTypesEmpty) return undefined;
    const isSwapApartmentIncluded = projectType.includes(ProjectType.SWAP_APARTMENT);
    const hasOtherValueIncluded = projectType.filter((type)=>type !== ProjectType.SWAP_APARTMENT).length > 0;
    //seeker look for both swap and something else: isForSwap filter will not be applied
    if (isSwapApartmentIncluded && hasOtherValueIncluded) return undefined;
    //when seeker only look for swap e.g isSwapApartmentIncluded === true
    //nb:DistributionSubType should contain CLASSIC -> it will added by matcher engine if missing
    //https://avivgroup.atlassian.net/wiki/spaces/ATSS/pages/1381073256/studies+SSA+-+IsForSwap+fix#SSA-match-engine
    return isSwapApartmentIncluded;
};
/** HYP -> WALDO ProjectType */ const getSearchProjectType = (criterias)=>{
    const result = new Set();
    const distributionSubTypes = criterias.distributionSubType ?? [];
    for (const distributionSubType of distributionSubTypes){
        switch(distributionSubType){
            case DistributionSubType.BUSINESS_LEASEBACK:
            case DistributionSubType.BUSINESS_SALE_GOODWILL:
                result.add(ProjectType.RESALE);
                break;
            case DistributionSubType.RESALE:
                result.add(ProjectType.RESALE);
                break;
            case DistributionSubType.LIFE_ANNUITY:
                result.add(ProjectType.LIFE_ANNUITY);
                break;
            case DistributionSubType.NEW_BUILD_UNIT:
                result.add(ProjectType.NEW_BUILD);
                break;
            case DistributionSubType.NEW_BUILD_INVESTMENT_PRODUCT:
                result.add(ProjectType.INVESTMENT);
                result.add(ProjectType.NEW_BUILD);
                break;
            case DistributionSubType.NEW_BUILD_PROJECT:
                result.add(ProjectType.NEW_BUILD);
                break;
            case DistributionSubType.NEW_HOME:
                result.add(ProjectType.PROJECTED);
                break;
            case DistributionSubType.BUSINESS:
                result.add(ProjectType.STOCK);
                break;
            case DistributionSubType.CLASSIC:
                result.add(ProjectType.STOCK);
                break;
            case DistributionSubType.TEMPORARY:
                result.add(ProjectType.SHORT_TIME_RENTAL);
                break;
            case DistributionSubType.VACATION:
                result.add(ProjectType.SHORT_TIME_RENTAL);
                break;
        }
    }
    const isRent = criterias.distributionType?.includes(DistributionType.RENT) ?? false;
    if (isRent === true) {
        const distributionSubTypeEmpty = distributionSubTypes.length === 0;
        //https://avivgroup.atlassian.net/wiki/spaces/ATSS/pages/1393229856/SSA+-+MFE+-+SERP+Mapper#SSA-to-SERP
        //true: seeker look for swap - SWAP_APARTMENT is included
        //undefined : seeker don't care - SWAP_APARTMENT is included only when distributionSubType is not empty
        const hasToIncludeSwapApartment = criterias?.management?.isForSwap === true || !distributionSubTypeEmpty && criterias?.management?.isForSwap == undefined;
        if (hasToIncludeSwapApartment) {
            result.add(ProjectType.SWAP_APARTMENT);
        }
    //false: seeker doesn't look for swap - SWAP_APARTMENT is not included
    }
    return result.size ? Array.from(result) : undefined;
};

const useForToManagementUseFor = new Map([
    [
        UseFor.LIVING,
        ManagementUseFor.LIVING
    ],
    [
        UseFor.MIXED,
        ManagementUseFor.MIXED
    ],
    [
        UseFor.COMMERCIAL,
        ManagementUseFor.COMMERCIAL
    ],
    [
        UseFor.INDUSTRIAL,
        ManagementUseFor.INDUSTRIAL
    ],
    [
        UseFor.OFFICE,
        ManagementUseFor.OFFICE
    ]
]);
/** WALDO -> HYP UseFor */ const getCriteriaUseFor = (searchModel)=>{
    return searchModel.useFor?.map((useFor)=>useForToManagementUseFor.get(useFor)).filter((value)=>value !== undefined) ?? [];
};
const managementUseForToUseFor = new Map([
    [
        ManagementUseFor.LIVING,
        UseFor.LIVING
    ],
    [
        ManagementUseFor.MIXED,
        UseFor.MIXED
    ],
    [
        ManagementUseFor.COMMERCIAL,
        UseFor.COMMERCIAL
    ],
    [
        ManagementUseFor.INDUSTRIAL,
        UseFor.INDUSTRIAL
    ],
    [
        ManagementUseFor.OFFICE,
        UseFor.OFFICE
    ]
]);
/** HYP -> WALDO UseFor */ const getSearchUseFor = (criterias)=>{
    const useFor = criterias?.management?.useFor;
    const result = useFor?.map((useFor)=>managementUseForToUseFor.get(useFor))?.filter((value)=>value !== undefined) ?? [];
    return result.length ? result : undefined;
};

const mapSearchDataModelToWLSearch = (searchModel)=>{
    const resultModel = {
        title: '',
        externalProperties: {
            channelId: '',
            deviceType: SavedSearchDeviceType.None
        },
        criteria: getSavedSearchCriteria(searchModel),
        channels: [
            {
                enabled: true,
                channel: SavedSearchNotificationChannel.email
            }
        ]
    };
    return clearObject(resultModel);
};
const getSavedSearchCriteria = (searchModel)=>{
    return {
        estateType: getCriteriaEstateType(searchModel),
        estateSubType: getCriteriaEstateSubType(searchModel),
        distributionType: getCriteriaDistributionType(searchModel),
        distributionSubType: getCriteriaDistributionSubType(searchModel),
        prices: {
            currencySymbol: undefined,
            currencyUnit: undefined,
            priceMin: searchModel.priceMin,
            priceMax: searchModel.priceMax,
            brokerageFee: getCriteriaBrokerageFee(searchModel)
        },
        spaces: {
            spaceMeasureSymbol: undefined,
            spaceMeasureUnit: undefined,
            spaceMin: searchModel.spaceMin,
            spaceMax: searchModel.spaceMax,
            plotSpaceMin: searchModel.plotSpaceMin,
            plotSpaceMax: searchModel.plotSpaceMax
        },
        structure: {
            rooms: {
                numberOfRoomsMin: searchModel.numberOfRoomsMin,
                numberOfRoomsMax: searchModel.numberOfRoomsMax,
                numberOfBalconiesMin: searchModel.featuresIncluded?.includes(FeatureType.BALCONY_TERRACE) ? 1 : undefined,
                numberOfTerracesMin: undefined,
                numberOfBedRoomsMin: searchModel.numberOfBedroomsMin,
                numberOfBedRoomsMax: searchModel.numberOfBedroomsMax
            },
            building: {
                locationInBuilding: getCriteriaLocationInBuilding(searchModel),
                bath: getCriteriaBathroom(searchModel),
                kitchen: getCriteriaKitchen(searchModel),
                withView: {
                    niceView: undefined,
                    withoutOverlooking: undefined
                },
                elevator: getCriteriaElevator(searchModel),
                cellar: getCriteriaCellar(searchModel),
                attic: []
            },
            parkingLots: getCriteriaParkingLots(searchModel)
        },
        conditions: {
            yearOfConstructionMin: searchModel.yearOfConstructionMin,
            yearOfConstructionMax: searchModel.yearOfConstructionMax,
            buildState: getCriteriaBuildState(searchModel),
            energyClass: getCriteriaEnergyCertificateClass(searchModel)
        },
        location: getCriteriaLocation(searchModel),
        management: {
            isRented: getCriteriaIsRented(searchModel),
            isForSwap: getCriteriaIsForSwap(searchModel),
            rent: {
                petsAllowed: getCriteriaPetAllowed(searchModel),
                certificateOfEligibilityNeeded: getCriteriaCertificateOfEligibilityNeeded(searchModel)
            },
            useFor: getCriteriaUseFor(searchModel)
        },
        features: {
            wheelchairUse: getCriteriaWheelchairUse(searchModel),
            garden: getCriteriaGarden(searchModel),
            residential: {
                swimmingPool: getCriteriaSwimmingPool(searchModel)
            },
            propertyOrientation: [],
            furnished: getCriteriaFurnished(searchModel)
        },
        energy: {
            energyType: {
                energyHeatForm: [],
                energyHeatMethod: [],
                energySource: []
            }
        }
    };
};
const reverseWLItemToSearchModel = (item)=>getSearchModelFromSavedSearchCriteria(item?.criteria);
const getSearchModelFromSavedSearchCriteria = (criterias)=>{
    const locationsInBuilding = getSearchLocationsInBuilding(criterias);
    return {
        distributionTypes: getSearchDistributionType(criterias),
        projectTypes: getSearchProjectType(criterias),
        estateTypes: getSearchEstateType(criterias),
        estateSubTypes: getSearchEstateSubType(criterias),
        locations: getSearchLocation(criterias),
        buildState: getSearchBuildState(criterias),
        certificateOfEligibilityNeeded: getSearchCertificateOfEligibilityNeeded(criterias),
        energyCertificateClass: getSearchEnergyCertificateClass(criterias),
        featuresIncluded: getSearchFeaturesIncluded(criterias),
        furnished: getSearchFurnished(criterias),
        useFor: getSearchUseFor(criterias),
        locationsInBuildingIncluded: locationsInBuilding.include,
        locationsInBuildingExcluded: locationsInBuilding.exclude,
        priceMin: criterias?.prices?.priceMin ?? undefined,
        priceMax: criterias?.prices?.priceMax ?? undefined,
        numberOfRoomsMin: criterias?.structure?.rooms?.numberOfRoomsMin ?? undefined,
        numberOfRoomsMax: criterias?.structure?.rooms?.numberOfRoomsMax ?? undefined,
        numberOfBedroomsMax: criterias?.structure?.rooms?.numberOfBedRoomsMax ?? undefined,
        numberOfBedroomsMin: criterias?.structure?.rooms?.numberOfBedRoomsMin ?? undefined,
        spaceMin: criterias?.spaces?.spaceMin ?? undefined,
        spaceMax: criterias?.spaces?.spaceMax ?? undefined,
        plotSpaceMin: criterias?.spaces?.plotSpaceMin ?? undefined,
        plotSpaceMax: criterias?.spaces?.plotSpaceMax ?? undefined,
        yearOfConstructionMin: criterias?.conditions?.yearOfConstructionMin ?? undefined,
        yearOfConstructionMax: criterias?.conditions?.yearOfConstructionMax ?? undefined,
        classifiedBusiness: undefined,
        listingsDisplay: undefined
    };
};

const REST_RETRY_COUNT = 2;
const REST_RETRY_TIMEOUT = 3000;
const legacyAlternativesOn = {
    location: 10,
    primaryPriceMax: 10,
    primaryAreaMin: 10,
    relaxEquipmentMode: LegacyIWTRelaxMode.SINGLE
};
const legacyAlternativesOff = {
    location: 0,
    primaryPriceMax: 0,
    primaryAreaMin: 0,
    relaxEquipmentMode: LegacyIWTRelaxMode.None
};
const errorCodes = {
    tooMany: 'ERROR_TOO_MANY_SAVED_SEARCHES',
    duplicated: 'ERROR_DUPLICATED_SAVED_SEARCH',
    tooLarge: 'ERROR_LOCATION_AREA_TOO_LARGE',
    tooSmall: 'ERROR_LOCATION_AREA_TOO_SMALL',
    duplicatePlaceId: 'ERROR_DUPLICATE_PLACEID'
};
const savedSearchApiErrorCode = [
    {
        errorCode: errorCodes.tooMany,
        translationKey: null
    },
    {
        errorCode: errorCodes.duplicated,
        translationKey: 'savedSearch_duplicateError_text'
    },
    {
        errorCode: errorCodes.tooLarge,
        translationKey: 'savedSearch_locationTooLarge_text'
    },
    {
        errorCode: errorCodes.tooSmall,
        translationKey: 'savedSearch_locationTooSmall_text'
    },
    {
        errorCode: errorCodes.duplicatePlaceId,
        translationKey: 'savedSearch_duplicatePlaceId_text'
    }
];
const defaultChannels = [
    {
        channel: SavedSearchNotificationChannel.email,
        enabled: true
    }
];
const savedSearchButtonModalTestId = 'av-ssab-Modal';
const intermediaryMatchingMandateTestId = 'av-ssab-IntermediaryMatchingMandate';
const intermediaryMatchingMandateLokalizePrefix = 'savedSearch.intermediaryMatchingMandate';
const intermediaryMatchingMandateLocalStorageKey = 'showMatchingMandate';
const localKeys = {
    autoLocalStorageSearchKey: 'auto_save_search',
    logSearchDataModel: 'log_search_data_model',
    maxAlertsCustomKey: 'max_alerts_count',
    autoSaveSearchQueryParam: 'autoSaveSearch'
};

const baseApiWithResponse = async (success, error, options)=>{
    return getResponseOrThrowError(options).then(async (response)=>{
        const jsonResponse = await response.json();
        const payloadGenericObject = jsonResponse;
        success(payloadGenericObject);
    }).catch((errorResponse)=>{
        error(errorResponse);
    });
};
const baseApiWithoutResponse = async (success, error, options)=>{
    return getResponseOrThrowError(options).then(()=>{
        success();
    }).catch((errorResponse)=>{
        error(errorResponse);
    });
};
function delay(millis) {
    return new Promise((resolve)=>setTimeout(resolve, millis));
}
const getResponseOrThrowError = async (options)=>{
    const { url, httpMethod, body, authenticationToken, retryOnFailure, retryCount, retryDelay, headersOptions } = options;
    const headers = authenticationToken !== undefined ? {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${authenticationToken}`,
        ...headersOptions
    } : {
        'Content-Type': 'application/json',
        ...headersOptions
    };
    const fetchInit = {
        method: httpMethod,
        body: JSON.stringify(body),
        headers: headers
    };
    try {
        const response = await fetch$1(url, fetchInit);
        if (!response.ok) {
            const responseStatusString = response.status.toString();
            // Check if the response is a server ERROR
            if (responseStatusString === '401') {
                throw {
                    httpStatusCode: 401,
                    errorMessage: 'Unauthorized',
                    errorCode: 'UNAUTHORIZED'
                };
            }
            if (responseStatusString === '301') {
                throw {
                    httpStatusCode: 301,
                    errorMessage: 'Permanently Moved',
                    errorCode: 'PERMANENTLY_MOVED'
                };
            }
            if (retryOnFailure && retryDelay && retryCount && retryCount >= 0) {
                return delay(retryDelay).then(()=>getResponseOrThrowError({
                        ...options,
                        retryCount: retryCount - 1
                    }));
            }
            if (responseStatusString.startsWith('5')) {
                // eslint-disable-next-line no-throw-literal
                throw {
                    httpStatusCode: 500,
                    errorMessage: 'Internal Error',
                    errorCode: 'INTERNAL_ERROR'
                };
            }
            // eslint-disable-next-line no-throw-literal
            const responseJson = await response.json();
            if (!responseJson.errors || responseJson.errors.length === 0) {
                throw {
                    httpStatusCode: response.status,
                    errorMessage: 'Unknown error',
                    errorCode: 'UNKNOWN_ERROR'
                };
            }
            const responseBody = responseJson.errors[0];
            throw {
                httpStatusCode: response.status,
                errorMessage: responseBody.errorMessage,
                propertyName: responseBody.propertyName,
                errorCode: responseBody.errorCode
            };
        }
        return response;
    } catch (error) {
        if (retryOnFailure && retryDelay && retryCount && retryCount >= 0 && error?.httpStatusCode !== 401) {
            return delay(retryDelay).then(()=>getResponseOrThrowError({
                    ...options,
                    retryCount: retryCount - 1
                }));
        } else throw error;
    }
};

const URL_baseRoute = '/collect-communicate-bff';
const URL_addSavedSearch = `${URL_baseRoute}/createUnified`;
const addSavedSearch = async (success, error, options)=>{
    const { body, authenticationToken } = options;
    return baseApiWithResponse(success, error, {
        url: URL_addSavedSearch,
        httpMethod: 'POST',
        authenticationToken,
        body
    });
};
const URL_addSavedSearchEmail = `${URL_baseRoute}/createUnifiedFromEmail`;
const addSavedSearchEmail = async (success, error, options)=>{
    const { body } = options;
    return baseApiWithResponse(success, error, {
        url: URL_addSavedSearchEmail,
        httpMethod: 'POST',
        body
    });
};
const URL_getLogicImmoMapping = `${URL_baseRoute}/getLogicImmoMapping`;
const addSavedSearchEmailLI = async (success, error, options)=>{
    const { config, body } = options;
    const remappedResponse = await fetch(URL_getLogicImmoMapping, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
    }).catch((errorResponse)=>{
        console.error('Error while fetching remapped response', errorResponse);
        error(errorResponse);
    });
    if (!remappedResponse) {
        error({
            errorCode: 'UNKNOWN_ERROR',
            errorMessage: 'Error while fetching remapped response',
            httpStatusCode: 500,
            propertyName: 'error'
        });
        return;
    }
    if (!remappedResponse.ok) {
        error({
            errorCode: 'UNKNOWN_ERROR',
            errorMessage: remappedResponse.statusText,
            httpStatusCode: remappedResponse.status,
            propertyName: 'error'
        });
    }
    const logicImmoEndpointUrl = createLegacyEndpoint(config.stage, config.brand, '/refonte/aei?context=aeiContactDesktop');
    const remapped = await remappedResponse.text();
    await fetch(logicImmoEndpointUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: new URLSearchParams({
            contact: remapped
        })
    }).then((res)=>{
        if (!res.ok) {
            const errorObject = {
                httpStatusCode: res.status,
                errorMessage: res.statusText,
                errorCode: 'error',
                propertyName: 'error'
            };
            error(errorObject);
        } else {
            success(res);
        }
    }).catch((errorResponse)=>{
        console.error('Error while fetching Logic Immo', errorResponse);
        error(errorResponse);
    });
};
const URL_getSavedSearches = `${URL_baseRoute}/getAll`;
const getSavedSearches = async (success, error, options)=>{
    const { authenticationToken } = options;
    return baseApiWithResponse(success, error, {
        url: URL_getSavedSearches,
        httpMethod: 'GET',
        authenticationToken,
        retryOnFailure: true,
        retryCount: REST_RETRY_COUNT,
        retryDelay: REST_RETRY_TIMEOUT
    });
};
const URL_getSavedSearch = `${URL_baseRoute}/get`;
const getSavedSearch = async (success, error, options)=>{
    const { id, authenticationToken } = options;
    return baseApiWithResponse(success, error, {
        url: `${URL_getSavedSearch}?id=${id}`,
        httpMethod: 'GET',
        authenticationToken,
        retryOnFailure: true,
        retryCount: REST_RETRY_COUNT,
        retryDelay: REST_RETRY_TIMEOUT
    });
};
const URL_updateSavedSearch = `${URL_baseRoute}/update`;
const updateSavedSearch = async (success, error, options)=>{
    const { id, authenticationToken, body } = options;
    return baseApiWithResponse(success, error, {
        url: `${URL_updateSavedSearch}?id=${id}`,
        httpMethod: 'PUT',
        authenticationToken,
        body,
        retryOnFailure: true,
        retryCount: REST_RETRY_COUNT,
        retryDelay: REST_RETRY_TIMEOUT
    });
};
const URL_deleteSavedSearch = `${URL_baseRoute}/delete`;
const deleteSavedSearches = async (success, error, options)=>{
    const { id, authenticationToken } = options;
    return baseApiWithoutResponse(success, error, {
        url: `${URL_deleteSavedSearch}?id=${id}`,
        httpMethod: 'DELETE',
        authenticationToken
    });
};
const URL_updateChannelState = `${URL_baseRoute}/channel`;
const updateChannelState = async (success, error, options)=>{
    const { id, authenticationToken, body } = options;
    return baseApiWithoutResponse(success, error, {
        url: `${URL_updateChannelState}?id=${id}`,
        httpMethod: 'PUT',
        authenticationToken,
        body
    });
};
const URL_updateRelaxedCriteria = `${URL_baseRoute}/relaxedCriteria`;
const updateAlternativeState = async (success, error, options)=>{
    const { id, authenticationToken, value } = options;
    return baseApiWithoutResponse(success, error, {
        url: `${URL_updateRelaxedCriteria}?id=${id}`,
        httpMethod: 'PUT',
        authenticationToken,
        body: {
            enabled: value
        }
    });
};
const URL_getSavedSearchMatches = `${URL_baseRoute}/getSavedsearchMatches`;
const getSavedSearchMatches = async (success, error, options)=>{
    const { authenticationToken, savedSearchId } = options;
    return baseApiWithResponse(success, error, {
        url: `${URL_getSavedSearchMatches}?id=${savedSearchId}`,
        httpMethod: 'GET',
        authenticationToken
    });
};

const deleteLegacyIWTSavedSearchesAnonymous = async (success, error, options)=>{
    const { config, ssid } = options;
    const endpointUrlLegacy = createLegacyEndpoint(config.stage, config.brand, `/savedsearch/v1/savedsearches/${ssid}`);
    const token = await getIWTAnonymousAuthToken(config);
    return baseApiWithoutResponse(success, error, {
        url: endpointUrlLegacy,
        httpMethod: 'DELETE',
        authenticationToken: token
    });
};
const updateLegacySLGNotificationsStateAnonymous = async (success, error, searchId, value, options)=>{
    const { stage, params } = options;
    const { idalert, identifier } = params;
    const legacyEndpoint = createLegacyEndpoint(stage, 'sl', value ? `/userpreferences-bff/bff/v1/alerts/${searchId}/subscribe?identifier=${identifier}&idalert=${idalert}` : `/userpreferences-bff/bff/v1/alerts/${searchId}/unsubscribe?identifier=${identifier}&idalert=${idalert}`);
    return baseApiWithoutResponse(success, error, {
        url: legacyEndpoint,
        httpMethod: 'POST'
    });
};
const deleteLegacySLGAnonymousSavedSearch = async (success, error, searchId, options)=>{
    const { stage, params } = options;
    const { idalert, identifier } = params;
    const legacyEndpoint = createLegacyEndpoint(stage, 'sl', `/userpreferences-bff/bff/v1/alerts/${searchId}?identifier=${identifier}&idalert=${idalert}`);
    return baseApiWithoutResponse(success, error, {
        url: legacyEndpoint,
        httpMethod: 'DELETE'
    });
};
const updateLegacyNotificationsStatesAnonymous = async (success, error, options)=>{
    const { config, ssid, item, value, target } = options;
    const token = await getIWTAnonymousAuthToken(config);
    const emailChannel = item.baseAttributes.endpoints.find((ch)=>ch.channelType === 'EMAIL_MESSAGE');
    const newLegacyChannel = {
        channelType: 'EMAIL_MESSAGE',
        displayName: emailChannel?.displayName ?? '',
        endpointResourceId: emailChannel?.endpointResourceId ?? '',
        notificationFrequency: {
            displayName: value ? 'Sofot' : 'Nie',
            intervalInMinutes: 0,
            type: value ? 'IMMEDIATE' : 'NEVER',
            referenceTimestamp: new Date().toISOString()
        }
    };
    const criterias = {
        ...item?.baseAttributes?.searchCriteria,
        relaxedCriteria: !value.recommendation ? legacyAlternativesOff : legacyAlternativesOn
    };
    const updateBody = target.includes(NotificationsTargetEnum.EMAIL) && target.includes(NotificationsTargetEnum.RECOMMENDATIONS) ? {
        endpoints: [
            newLegacyChannel
        ],
        searchCriteria: criterias
    } : target.includes(NotificationsTargetEnum.EMAIL) ? {
        endpoints: [
            newLegacyChannel
        ]
    } : {
        searchCriteria: criterias
    };
    const endpointUrlLegacy = createLegacyEndpoint(config.stage, config.brand, '/savedsearch/v1/savedsearchmodifications');
    return baseApiWithResponse(success, error, {
        url: endpointUrlLegacy,
        httpMethod: 'PUT',
        authenticationToken: token,
        body: {
            savedSearchId: ssid,
            ...updateBody
        }
    });
};
const URL_updateWLChannelAnonymous = `${URL_baseRoute}/channelFromToken`;
const updateWLChannelAnonymous = async (success, error, options)=>{
    const { params, value } = options;
    const body = {
        channelName: SavedSearchNotificationChannel.email,
        enabled: value !== 'never',
        frequency: value !== 'never' ? value : undefined
    };
    return baseApiWithResponse(success, error, {
        url: `${URL_updateWLChannelAnonymous}?token=${params.token}`,
        httpMethod: 'PUT',
        body
    });
};

const updateLegacyIWTNotificationsStates = async (success, error, options)=>{
    const { id, value, item, target, config, authenticationToken } = options;
    const emailChannel = item.baseAttributes.endpoints.find((ch)=>ch.channelType === 'EMAIL_MESSAGE');
    const newLegacyChannel = {
        channelType: 'EMAIL_MESSAGE',
        displayName: emailChannel?.displayName ?? '',
        endpointResourceId: emailChannel?.endpointResourceId ?? '',
        notificationFrequency: {
            displayName: value.email ? 'Sofot' : 'Nie',
            intervalInMinutes: 0,
            type: value.email ? 'IMMEDIATE' : 'NEVER',
            referenceTimestamp: new Date().toISOString()
        }
    };
    const criterias = {
        ...item?.baseAttributes?.searchCriteria,
        relaxedCriteria: !value.recommendation ? legacyAlternativesOff : legacyAlternativesOn
    };
    const updateBody = target.includes(NotificationsTargetEnum.EMAIL) && target.includes(NotificationsTargetEnum.RECOMMENDATIONS) ? {
        endpoints: [
            newLegacyChannel
        ],
        searchCriteria: criterias
    } : target.includes(NotificationsTargetEnum.EMAIL) ? {
        endpoints: [
            newLegacyChannel
        ]
    } : {
        searchCriteria: criterias
    };
    const endpointUrlLegacy = createLegacyEndpoint(config.stage, config.brand, '/savedsearch/v1/savedsearchmodifications');
    return baseApiWithResponse(success, error, {
        url: endpointUrlLegacy,
        httpMethod: 'PUT',
        authenticationToken,
        body: {
            savedSearchId: id,
            ...updateBody
        }
    });
};
const updateLegacySLGNotificationsState = async (success, error, options)=>{
    const { id, value, config, authenticationToken } = options;
    const { stage, brand } = config;
    const endpointUrlLegacy = createLegacyEndpoint(stage, brand, value ? `/userpreferences-bff/bff/v1/alerts/${id}/subscribe` : `/userpreferences-bff/bff/v1/alerts/${id}/unsubscribe`);
    return baseApiWithoutResponse(success, error, {
        url: endpointUrlLegacy,
        httpMethod: 'POST',
        authenticationToken
    });
};
const deleteLegacyIWTSavedSearches = async (success, error, options)=>{
    const { id, config, authenticationToken } = options;
    const endpointUrlLegacy = createLegacyEndpoint(config.stage, config.brand, `/savedsearch/v1/savedsearches/${id}`);
    return baseApiWithoutResponse(success, error, {
        url: endpointUrlLegacy,
        httpMethod: 'DELETE',
        authenticationToken
    });
};
const deleteLegacySLGSavedSearches = async (success, error, options)=>{
    const { id, config, authenticationToken } = options;
    const { stage, brand } = config;
    const endpointUrlLegacy = createLegacyEndpoint(stage, brand, `/userpreferences-bff/bff/v1/alerts/${id}`);
    return baseApiWithoutResponse(success, error, {
        url: endpointUrlLegacy,
        httpMethod: 'DELETE',
        authenticationToken
    });
};

[
    {
        baseAttributes: {
            id: '20240702152114911-e76199bb',
            userId: 386462,
            config: {
                searchDisplayName: 'Haus zum Kauf in Hamburg',
                locationDisplayName: 'Hamburg'
            },
            searchCriteria: {
                pricing: {
                    priceMin: 10,
                    priceMax: 100000
                },
                construction: {
                    roomCountMin: null,
                    roomCountMax: null,
                    livingAreaMin: 0,
                    livingAreaMax: 1000
                },
                general: {
                    equipment: [],
                    estateTypes: [
                        'HAUS'
                    ],
                    distributionTypes: [
                        'ZWANGSVERSTEIGERUNG'
                    ],
                    energyCertificateClass: []
                },
                relaxedCriteria: {
                    location: 0,
                    primaryPriceMax: 0,
                    primaryAreaMin: 0,
                    relaxEquipmentMode: LegacyIWTRelaxMode.None
                }
            },
            endpoints: [
                {
                    channelType: 'EMAIL_MESSAGE',
                    endpointResourceId: 'christoph.semder@immonet.de',
                    displayName: 'christoph.semder@immonet.de',
                    notificationFrequency: {
                        type: 'IMMEDIATE',
                        displayName: 'Sofort',
                        referenceTimestamp: '2002-02-02T02:02:02Z',
                        intervalInMinutes: 5
                    }
                }
            ],
            formattedSearchCriteria: [
                'Haus zum Kauf'
            ],
            origin: 'migration-immonet-wl'
        },
        detailedLocationDisplayText: 'Hamburg'
    }
];
[
    {
        criteria: {
            estateType: [
                EstateType.HOUSE
            ],
            distributionType: [
                DistributionType.COMPULSORY_AUCTION
            ],
            distributionSubType: [],
            estateSubType: [],
            energy: {
                energyType: {
                    energyHeatForm: [],
                    energyHeatMethod: [],
                    energySource: []
                }
            },
            prices: {
                currencySymbol: '€',
                currencyUnit: 'EUR',
                priceMin: 10,
                priceMax: 100000,
                brokerageFee: {
                    hasFee: HasFee.None
                }
            },
            spaces: {
                spaceMeasureSymbol: 'm²',
                spaceMeasureUnit: SpaceMeasureUnit.SQUARE_METER,
                spaceMin: 0,
                spaceMax: 1000,
                plotSpaceMin: undefined,
                plotSpaceMax: undefined
            },
            location: {
                geometries: {
                    circles: [],
                    polygons: [],
                    travels: []
                },
                placeIdInfos: [],
                placeIds: []
            },
            structure: {
                rooms: {
                    numberOfRoomsMin: undefined,
                    numberOfRoomsMax: undefined,
                    numberOfBalconiesMin: undefined,
                    numberOfTerracesMin: undefined,
                    numberOfBedRoomsMin: undefined,
                    numberOfBedRoomsMax: undefined
                },
                building: {
                    locationInBuilding: [],
                    bath: {
                        window: undefined,
                        bathtub: undefined
                    },
                    kitchen: {
                        equipment: KitchenEquipment.UNKNOWN
                    },
                    withView: {},
                    elevator: [],
                    cellar: Cellar.None,
                    attic: []
                },
                parkingLots: {}
            },
            conditions: {
                yearOfConstructionMin: undefined,
                yearOfConstructionMax: undefined,
                buildState: [
                    BuildState$1.None
                ],
                energyClass: [
                    EnergyClass.A,
                    EnergyClass.B
                ]
            },
            management: {
                isRented: undefined,
                isForSwap: undefined,
                rent: {
                    petsAllowed: undefined,
                    certificateOfEligibilityNeeded: undefined
                },
                useFor: []
            },
            features: {
                wheelchairUse: false,
                garden: [],
                furnished: Furnished.NO,
                residential: {
                    swimmingPool: SwimmingPool.None
                },
                propertyOrientation: []
            }
        },
        title: 'Haus zum Kauf in Hamburg',
        identity: {
            id: '20240702152114911-e76199bb',
            userId: '386462',
            portal: 'migration-immonet-wl'
        },
        state: SavedSearchState.enabled,
        metadata: {
            modelVersion: LEGACY_MODEL_VERSION,
            created: '',
            updated: '',
            origin: SavedSearchOrigin.SavedSearch
        },
        channels: [
            {
                channel: SavedSearchNotificationChannel.email,
                enabled: true
            }
        ],
        externalProperties: {
            channelId: '',
            deviceType: SavedSearchDeviceType.None
        },
        relaxedCriteria: {
            isEnabled: false,
            options: {
                locationSearchAreaIncrease: 10,
                priceIncreaseInPercent: 10,
                relaxedCriteriaRemoval: false,
                surfaceDecreaseInPercent: 10
            }
        }
    }
];
({
    externalProperties: {
        deviceType: SavedSearchDeviceType.None
    },
    state: SavedSearchState.enabled,
    metadata: {
        origin: SavedSearchOrigin.SavedSearch
    },
    channels: [
        {
            channel: SavedSearchNotificationChannel.email,
            enabled: true
        }
    ],
    criteria: {
        estateType: [
            EstateType.APARTMENT
        ],
        distributionType: [
            DistributionType.BUY
        ],
        prices: {
            brokerageFee: {
                hasFee: HasFee.None
            }
        },
        spaces: {
            spaceMeasureUnit: SpaceMeasureUnit.SQUARE_METER},
        structure: {
            building: {
                kitchen: {
                    equipment: KitchenEquipment.UNKNOWN
                },
                cellar: Cellar.None}},
        features: {
            furnished: Furnished.None,
            residential: {
                swimmingPool: SwimmingPool.None
            }}
    }
});

[
    {
        title: '',
        externalProperties: {
            channelId: '',
            deviceType: SavedSearchDeviceType.None
        },
        criteria: {
            estateType: [
                EstateType.HOUSE,
                EstateType.APARTMENT
            ],
            estateSubType: [
                EstateSubType$1.MANOR_HOUSE
            ],
            distributionType: [
                DistributionType.BUY
            ],
            distributionSubType: [
                DistributionSubType.NEW_HOME
            ],
            prices: {
                currencySymbol: '€',
                currencyUnit: 'EUR',
                priceMin: 0,
                priceMax: 890,
                brokerageFee: {
                    hasFee: HasFee.None
                }
            },
            spaces: {
                spaceMeasureSymbol: 'm²',
                spaceMeasureUnit: SpaceMeasureUnit.SQUARE_METER,
                spaceMin: 0,
                spaceMax: 110,
                plotSpaceMin: 0,
                plotSpaceMax: 0
            },
            structure: {
                rooms: {
                    numberOfRoomsMin: 3,
                    numberOfRoomsMax: undefined,
                    numberOfBalconiesMin: 0,
                    numberOfTerracesMin: undefined,
                    numberOfBedRoomsMin: undefined,
                    numberOfBedRoomsMax: undefined
                },
                building: {
                    locationInBuilding: [],
                    bath: {
                        window: true,
                        bathtub: true
                    },
                    kitchen: {
                        equipment: KitchenEquipment.FULLY_EQUIPPED
                    },
                    withView: {},
                    elevator: [
                        Elevator.ANYKIND
                    ],
                    cellar: Cellar.ANYKIND,
                    attic: []
                },
                parkingLots: {}
            },
            conditions: {
                yearOfConstructionMin: undefined,
                yearOfConstructionMax: undefined,
                buildState: [],
                energyClass: [
                    EnergyClass.A,
                    EnergyClass.B
                ]
            },
            location: {
                placeIds: [
                    'NBH2DE65467'
                ],
                placeIdInfos: [
                    {
                        placeId: 'NBH2DE65467',
                        placeName: 'Allermöhe'
                    }
                ],
                geometries: {
                    circles: [],
                    polygons: [],
                    travels: []
                }
            },
            management: {
                isRented: false,
                isForSwap: true,
                rent: {
                    petsAllowed: true,
                    certificateOfEligibilityNeeded: true
                },
                useFor: [
                    ManagementUseFor.LIVING
                ]
            },
            features: {
                wheelchairUse: undefined,
                garden: [],
                furnished: Furnished.FULL,
                residential: {
                    swimmingPool: SwimmingPool.None
                },
                propertyOrientation: []
            },
            energy: {
                energyType: {
                    energyHeatForm: [],
                    energyHeatMethod: [],
                    energySource: []
                }
            }
        },
        channels: [
            {
                enabled: true,
                channel: SavedSearchNotificationChannel.email
            }
        ]
    },
    {
        title: '',
        externalProperties: {
            channelId: '',
            deviceType: SavedSearchDeviceType.None
        },
        criteria: {
            estateType: [
                EstateType.HOUSE
            ],
            estateSubType: [],
            distributionType: [
                DistributionType.BUY
            ],
            distributionSubType: [
                DistributionSubType.NEW_HOME
            ],
            prices: {
                currencySymbol: '€',
                currencyUnit: 'EUR',
                priceMin: 0,
                priceMax: 1100,
                brokerageFee: {
                    hasFee: HasFee.None
                }
            },
            spaces: {
                spaceMeasureSymbol: 'm²',
                spaceMeasureUnit: SpaceMeasureUnit.SQUARE_METER,
                spaceMin: 0,
                spaceMax: 150,
                plotSpaceMin: 0,
                plotSpaceMax: 0
            },
            structure: {
                rooms: {
                    numberOfRoomsMin: 3,
                    numberOfRoomsMax: undefined,
                    numberOfBalconiesMin: 1,
                    numberOfTerracesMin: undefined,
                    numberOfBedRoomsMin: undefined,
                    numberOfBedRoomsMax: undefined
                },
                building: {
                    locationInBuilding: [
                        LocationInBuilding.ROOF_STOREY_EXCLUDED
                    ],
                    bath: {},
                    elevator: [],
                    kitchen: {
                        equipment: KitchenEquipment.FULLY_EQUIPPED
                    },
                    withView: {},
                    cellar: Cellar.None,
                    attic: []
                },
                parkingLots: {
                    numberOfParkingsMin: 1,
                    numberOfGaragesMin: undefined
                }
            },
            conditions: {
                yearOfConstructionMin: undefined,
                yearOfConstructionMax: undefined,
                buildState: [
                    BuildState$1.FULLY_RENOVATED
                ],
                energyClass: [
                    EnergyClass.A,
                    EnergyClass.B
                ]
            },
            location: {
                placeIds: [
                    'NBH2DE65467'
                ],
                placeIdInfos: [
                    {
                        placeId: 'NBH2DE65467',
                        placeName: 'Allermöhe'
                    }
                ],
                geometries: {
                    circles: [],
                    polygons: [],
                    travels: []
                }
            },
            management: {
                isRented: undefined,
                isForSwap: true,
                rent: {
                    petsAllowed: true,
                    certificateOfEligibilityNeeded: true
                },
                useFor: [
                    ManagementUseFor.LIVING
                ]
            },
            features: {
                wheelchairUse: true,
                garden: [
                    Garden.ANYKIND
                ],
                furnished: Furnished.FULL,
                residential: {
                    swimmingPool: SwimmingPool.None
                },
                propertyOrientation: []
            },
            energy: {
                energyType: {
                    energyHeatForm: [],
                    energyHeatMethod: [],
                    energySource: []
                }
            }
        },
        channels: [
            {
                enabled: false,
                channel: SavedSearchNotificationChannel.email
            }
        ]
    }
];
({
    certificateOfEligibilityNeeded: CertificateOfEligibility.NO,
    featuresIncluded: [
        FeatureType.PETS_ALLOWED,
        FeatureType.BALCONY_TERRACE
    ],
    locations: [
        {
            type: LocationType.PLACE_ID,
            placeId: 'NBH2DE65467'
        }
    ],
    estateTypes: [
        EstateType$1.HOUSE,
        EstateType$1.APARTMENT
    ],
    distributionTypes: [
        DistributionType$1.BUY
    ],
    estateSubTypes: [
        EstateSubType.CASTLE,
        EstateSubType.CHALET
    ],
    projectTypes: [
        ProjectType.SWAP_APARTMENT
    ],
    furnished: [
        Furnished$1.FULL,
        Furnished$1.NO
    ],
    useFor: [
        UseFor.LIVING
    ],
    buildState: [
        BuildState.NEED_OF_RENOVATION
    ]
});
({
    locations: [
        {
            type: LocationType.RADIUS,
            placeId: 'NBH2DE65467',
            radius: 10,
            polyline: ''
        }
    ]
});
({
    locations: [
        {
            type: LocationType.COMMUTE,
            placeIds: [
                'NBH2DE65467'
            ],
            duration: 30,
            mode: CommuteMode.BIKE,
            polylines: []
        }
    ]
});

const getListingsLink = (stage, brand, searchUrl)=>{
    const url = new URL(getBrandHostname(stage, brand));
    url.pathname = '/classified-search';
    url.search = searchUrl.startsWith('?') ? searchUrl : `?${searchUrl}`;
    return url.toString();
};
const redirectToLogin = (stage, brand, additionalQueryParams)=>{
    if (isWindowUndefined()) {
        return;
    }
    const { href, search } = window?.location;
    if (additionalQueryParams && search) {
        additionalQueryParams = '&' + additionalQueryParams;
    } else {
        additionalQueryParams = '';
    }
    const redirectUriParameter = encodeURIComponent(href + additionalQueryParams);
    let signInHostname = getCustomBrandConfig(brand)?.hostnames.signIn;
    if (!signInHostname) {
        return;
    }
    signInHostname = signInHostname.replace('{env}', stage === 'live' ? '' : `${stage}-`);
    window.location.href = `${signInHostname}/?redirect_uri=${redirectUriParameter}`;
};

const isString$2 = obj => typeof obj === 'string';
const defer = () => {
  let res;
  let rej;
  const promise = new Promise((resolve, reject) => {
    res = resolve;
    rej = reject;
  });
  promise.resolve = res;
  promise.reject = rej;
  return promise;
};
const makeString = object => {
  if (object == null) return '';
  return '' + object;
};
const copy = (a, s, t) => {
  a.forEach(m => {
    if (s[m]) t[m] = s[m];
  });
};
const lastOfPathSeparatorRegExp = /###/g;
const cleanKey = key => key && key.indexOf('###') > -1 ? key.replace(lastOfPathSeparatorRegExp, '.') : key;
const canNotTraverseDeeper = object => !object || isString$2(object);
const getLastOfPath = (object, path, Empty) => {
  const stack = !isString$2(path) ? path : path.split('.');
  let stackIndex = 0;
  while (stackIndex < stack.length - 1) {
    if (canNotTraverseDeeper(object)) return {};
    const key = cleanKey(stack[stackIndex]);
    if (!object[key] && Empty) object[key] = new Empty();
    if (Object.prototype.hasOwnProperty.call(object, key)) {
      object = object[key];
    } else {
      object = {};
    }
    ++stackIndex;
  }
  if (canNotTraverseDeeper(object)) return {};
  return {
    obj: object,
    k: cleanKey(stack[stackIndex])
  };
};
const setPath = (object, path, newValue) => {
  const {
    obj,
    k
  } = getLastOfPath(object, path, Object);
  if (obj !== undefined || path.length === 1) {
    obj[k] = newValue;
    return;
  }
  let e = path[path.length - 1];
  let p = path.slice(0, path.length - 1);
  let last = getLastOfPath(object, p, Object);
  while (last.obj === undefined && p.length) {
    e = `${p[p.length - 1]}.${e}`;
    p = p.slice(0, p.length - 1);
    last = getLastOfPath(object, p, Object);
    if (last?.obj && typeof last.obj[`${last.k}.${e}`] !== 'undefined') {
      last.obj = undefined;
    }
  }
  last.obj[`${last.k}.${e}`] = newValue;
};
const pushPath = (object, path, newValue, concat) => {
  const {
    obj,
    k
  } = getLastOfPath(object, path, Object);
  obj[k] = obj[k] || [];
  obj[k].push(newValue);
};
const getPath = (object, path) => {
  const {
    obj,
    k
  } = getLastOfPath(object, path);
  if (!obj) return undefined;
  if (!Object.prototype.hasOwnProperty.call(obj, k)) return undefined;
  return obj[k];
};
const getPathWithDefaults = (data, defaultData, key) => {
  const value = getPath(data, key);
  if (value !== undefined) {
    return value;
  }
  return getPath(defaultData, key);
};
const deepExtend = (target, source, overwrite) => {
  for (const prop in source) {
    if (prop !== '__proto__' && prop !== 'constructor') {
      if (prop in target) {
        if (isString$2(target[prop]) || target[prop] instanceof String || isString$2(source[prop]) || source[prop] instanceof String) {
          if (overwrite) target[prop] = source[prop];
        } else {
          deepExtend(target[prop], source[prop], overwrite);
        }
      } else {
        target[prop] = source[prop];
      }
    }
  }
  return target;
};
const regexEscape = str => str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
var _entityMap = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '/': '&#x2F;'
};
const escape = data => {
  if (isString$2(data)) {
    return data.replace(/[&<>"'\/]/g, s => _entityMap[s]);
  }
  return data;
};
class RegExpCache {
  constructor(capacity) {
    this.capacity = capacity;
    this.regExpMap = new Map();
    this.regExpQueue = [];
  }
  getRegExp(pattern) {
    const regExpFromCache = this.regExpMap.get(pattern);
    if (regExpFromCache !== undefined) {
      return regExpFromCache;
    }
    const regExpNew = new RegExp(pattern);
    if (this.regExpQueue.length === this.capacity) {
      this.regExpMap.delete(this.regExpQueue.shift());
    }
    this.regExpMap.set(pattern, regExpNew);
    this.regExpQueue.push(pattern);
    return regExpNew;
  }
}
const chars = [' ', ',', '?', '!', ';'];
const looksLikeObjectPathRegExpCache = new RegExpCache(20);
const looksLikeObjectPath = (key, nsSeparator, keySeparator) => {
  nsSeparator = nsSeparator || '';
  keySeparator = keySeparator || '';
  const possibleChars = chars.filter(c => nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0);
  if (possibleChars.length === 0) return true;
  const r = looksLikeObjectPathRegExpCache.getRegExp(`(${possibleChars.map(c => c === '?' ? '\\?' : c).join('|')})`);
  let matched = !r.test(key);
  if (!matched) {
    const ki = key.indexOf(keySeparator);
    if (ki > 0 && !r.test(key.substring(0, ki))) {
      matched = true;
    }
  }
  return matched;
};
const deepFind = function (obj, path) {
  let keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.';
  if (!obj) return undefined;
  if (obj[path]) {
    if (!Object.prototype.hasOwnProperty.call(obj, path)) return undefined;
    return obj[path];
  }
  const tokens = path.split(keySeparator);
  let current = obj;
  for (let i = 0; i < tokens.length;) {
    if (!current || typeof current !== 'object') {
      return undefined;
    }
    let next;
    let nextPath = '';
    for (let j = i; j < tokens.length; ++j) {
      if (j !== i) {
        nextPath += keySeparator;
      }
      nextPath += tokens[j];
      next = current[nextPath];
      if (next !== undefined) {
        if (['string', 'number', 'boolean'].indexOf(typeof next) > -1 && j < tokens.length - 1) {
          continue;
        }
        i += j - i + 1;
        break;
      }
    }
    current = next;
  }
  return current;
};
const getCleanedCode = code => code?.replace('_', '-');

const consoleLogger = {
  type: 'logger',
  log(args) {
    this.output('log', args);
  },
  warn(args) {
    this.output('warn', args);
  },
  error(args) {
    this.output('error', args);
  },
  output(type, args) {
    console?.[type]?.apply?.(console, args);
  }
};
class Logger {
  constructor(concreteLogger) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.init(concreteLogger, options);
  }
  init(concreteLogger) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.prefix = options.prefix || 'i18next:';
    this.logger = concreteLogger || consoleLogger;
    this.options = options;
    this.debug = options.debug;
  }
  log() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return this.forward(args, 'log', '', true);
  }
  warn() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    return this.forward(args, 'warn', '', true);
  }
  error() {
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }
    return this.forward(args, 'error', '');
  }
  deprecate() {
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }
    return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
  }
  forward(args, lvl, prefix, debugOnly) {
    if (debugOnly && !this.debug) return null;
    if (isString$2(args[0])) args[0] = `${prefix}${this.prefix} ${args[0]}`;
    return this.logger[lvl](args);
  }
  create(moduleName) {
    return new Logger(this.logger, {
      ...{
        prefix: `${this.prefix}:${moduleName}:`
      },
      ...this.options
    });
  }
  clone(options) {
    options = options || this.options;
    options.prefix = options.prefix || this.prefix;
    return new Logger(this.logger, options);
  }
}
var baseLogger = new Logger();

class EventEmitter {
  constructor() {
    this.observers = {};
  }
  on(events, listener) {
    events.split(' ').forEach(event => {
      if (!this.observers[event]) this.observers[event] = new Map();
      const numListeners = this.observers[event].get(listener) || 0;
      this.observers[event].set(listener, numListeners + 1);
    });
    return this;
  }
  off(event, listener) {
    if (!this.observers[event]) return;
    if (!listener) {
      delete this.observers[event];
      return;
    }
    this.observers[event].delete(listener);
  }
  emit(event) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    if (this.observers[event]) {
      const cloned = Array.from(this.observers[event].entries());
      cloned.forEach(_ref => {
        let [observer, numTimesAdded] = _ref;
        for (let i = 0; i < numTimesAdded; i++) {
          observer(...args);
        }
      });
    }
    if (this.observers['*']) {
      const cloned = Array.from(this.observers['*'].entries());
      cloned.forEach(_ref2 => {
        let [observer, numTimesAdded] = _ref2;
        for (let i = 0; i < numTimesAdded; i++) {
          observer.apply(observer, [event, ...args]);
        }
      });
    }
  }
}

class ResourceStore extends EventEmitter {
  constructor(data) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      ns: ['translation'],
      defaultNS: 'translation'
    };
    super();
    this.data = data || {};
    this.options = options;
    if (this.options.keySeparator === undefined) {
      this.options.keySeparator = '.';
    }
    if (this.options.ignoreJSONStructure === undefined) {
      this.options.ignoreJSONStructure = true;
    }
  }
  addNamespaces(ns) {
    if (this.options.ns.indexOf(ns) < 0) {
      this.options.ns.push(ns);
    }
  }
  removeNamespaces(ns) {
    const index = this.options.ns.indexOf(ns);
    if (index > -1) {
      this.options.ns.splice(index, 1);
    }
  }
  getResource(lng, ns, key) {
    let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
    const ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let path;
    if (lng.indexOf('.') > -1) {
      path = lng.split('.');
    } else {
      path = [lng, ns];
      if (key) {
        if (Array.isArray(key)) {
          path.push(...key);
        } else if (isString$2(key) && keySeparator) {
          path.push(...key.split(keySeparator));
        } else {
          path.push(key);
        }
      }
    }
    const result = getPath(this.data, path);
    if (!result && !ns && !key && lng.indexOf('.') > -1) {
      lng = path[0];
      ns = path[1];
      key = path.slice(2).join('.');
    }
    if (result || !ignoreJSONStructure || !isString$2(key)) return result;
    return deepFind(this.data?.[lng]?.[ns], key, keySeparator);
  }
  addResource(lng, ns, key, value) {
    let options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
      silent: false
    };
    const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
    let path = [lng, ns];
    if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
    if (lng.indexOf('.') > -1) {
      path = lng.split('.');
      value = ns;
      ns = path[1];
    }
    this.addNamespaces(ns);
    setPath(this.data, path, value);
    if (!options.silent) this.emit('added', lng, ns, key, value);
  }
  addResources(lng, ns, resources) {
    let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
      silent: false
    };
    for (const m in resources) {
      if (isString$2(resources[m]) || Array.isArray(resources[m])) this.addResource(lng, ns, m, resources[m], {
        silent: true
      });
    }
    if (!options.silent) this.emit('added', lng, ns, resources);
  }
  addResourceBundle(lng, ns, resources, deep, overwrite) {
    let options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
      silent: false,
      skipCopy: false
    };
    let path = [lng, ns];
    if (lng.indexOf('.') > -1) {
      path = lng.split('.');
      deep = resources;
      resources = ns;
      ns = path[1];
    }
    this.addNamespaces(ns);
    let pack = getPath(this.data, path) || {};
    if (!options.skipCopy) resources = JSON.parse(JSON.stringify(resources));
    if (deep) {
      deepExtend(pack, resources, overwrite);
    } else {
      pack = {
        ...pack,
        ...resources
      };
    }
    setPath(this.data, path, pack);
    if (!options.silent) this.emit('added', lng, ns, resources);
  }
  removeResourceBundle(lng, ns) {
    if (this.hasResourceBundle(lng, ns)) {
      delete this.data[lng][ns];
    }
    this.removeNamespaces(ns);
    this.emit('removed', lng, ns);
  }
  hasResourceBundle(lng, ns) {
    return this.getResource(lng, ns) !== undefined;
  }
  getResourceBundle(lng, ns) {
    if (!ns) ns = this.options.defaultNS;
    return this.getResource(lng, ns);
  }
  getDataByLanguage(lng) {
    return this.data[lng];
  }
  hasLanguageSomeTranslations(lng) {
    const data = this.getDataByLanguage(lng);
    const n = data && Object.keys(data) || [];
    return !!n.find(v => data[v] && Object.keys(data[v]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}

var postProcessor = {
  processors: {},
  addPostProcessor(module) {
    this.processors[module.name] = module;
  },
  handle(processors, value, key, options, translator) {
    processors.forEach(processor => {
      value = this.processors[processor]?.process(value, key, options, translator) ?? value;
    });
    return value;
  }
};

const checkedLoadedFor = {};
const shouldHandleAsObject = res => !isString$2(res) && typeof res !== 'boolean' && typeof res !== 'number';
class Translator extends EventEmitter {
  constructor(services) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    super();
    copy(['resourceStore', 'languageUtils', 'pluralResolver', 'interpolator', 'backendConnector', 'i18nFormat', 'utils'], services, this);
    this.options = options;
    if (this.options.keySeparator === undefined) {
      this.options.keySeparator = '.';
    }
    this.logger = baseLogger.create('translator');
  }
  changeLanguage(lng) {
    if (lng) this.language = lng;
  }
  exists(key) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      interpolation: {}
    };
    if (key == null) {
      return false;
    }
    const resolved = this.resolve(key, options);
    return resolved?.res !== undefined;
  }
  extractFromKey(key, options) {
    let nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
    if (nsSeparator === undefined) nsSeparator = ':';
    const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
    let namespaces = options.ns || this.options.defaultNS || [];
    const wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
    const seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !looksLikeObjectPath(key, nsSeparator, keySeparator);
    if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
      const m = key.match(this.interpolator.nestingRegexp);
      if (m && m.length > 0) {
        return {
          key,
          namespaces: isString$2(namespaces) ? [namespaces] : namespaces
        };
      }
      const parts = key.split(nsSeparator);
      if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
      key = parts.join(keySeparator);
    }
    return {
      key,
      namespaces: isString$2(namespaces) ? [namespaces] : namespaces
    };
  }
  translate(keys, options, lastKey) {
    if (typeof options !== 'object' && this.options.overloadTranslationOptionHandler) {
      options = this.options.overloadTranslationOptionHandler(arguments);
    }
    if (typeof options === 'object') options = {
      ...options
    };
    if (!options) options = {};
    if (keys == null) return '';
    if (!Array.isArray(keys)) keys = [String(keys)];
    const returnDetails = options.returnDetails !== undefined ? options.returnDetails : this.options.returnDetails;
    const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
    const {
      key,
      namespaces
    } = this.extractFromKey(keys[keys.length - 1], options);
    const namespace = namespaces[namespaces.length - 1];
    const lng = options.lng || this.language;
    const appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (lng?.toLowerCase() === 'cimode') {
      if (appendNamespaceToCIMode) {
        const nsSeparator = options.nsSeparator || this.options.nsSeparator;
        if (returnDetails) {
          return {
            res: `${namespace}${nsSeparator}${key}`,
            usedKey: key,
            exactUsedKey: key,
            usedLng: lng,
            usedNS: namespace,
            usedParams: this.getUsedParamsDetails(options)
          };
        }
        return `${namespace}${nsSeparator}${key}`;
      }
      if (returnDetails) {
        return {
          res: key,
          usedKey: key,
          exactUsedKey: key,
          usedLng: lng,
          usedNS: namespace,
          usedParams: this.getUsedParamsDetails(options)
        };
      }
      return key;
    }
    const resolved = this.resolve(keys, options);
    let res = resolved?.res;
    const resUsedKey = resolved?.usedKey || key;
    const resExactUsedKey = resolved?.exactUsedKey || key;
    const noObject = ['[object Number]', '[object Function]', '[object RegExp]'];
    const joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
    const handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
    const needsPluralHandling = options.count !== undefined && !isString$2(options.count);
    const hasDefaultValue = Translator.hasDefaultValue(options);
    const defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : '';
    const defaultValueSuffixOrdinalFallback = options.ordinal && needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, {
      ordinal: false
    }) : '';
    const needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0;
    const defaultValue = needsZeroSuffixLookup && options[`defaultValue${this.options.pluralSeparator}zero`] || options[`defaultValue${defaultValueSuffix}`] || options[`defaultValue${defaultValueSuffixOrdinalFallback}`] || options.defaultValue;
    let resForObjHndl = res;
    if (handleAsObjectInI18nFormat && !res && hasDefaultValue) {
      resForObjHndl = defaultValue;
    }
    const handleAsObject = shouldHandleAsObject(resForObjHndl);
    const resType = Object.prototype.toString.apply(resForObjHndl);
    if (handleAsObjectInI18nFormat && resForObjHndl && handleAsObject && noObject.indexOf(resType) < 0 && !(isString$2(joinArrays) && Array.isArray(resForObjHndl))) {
      if (!options.returnObjects && !this.options.returnObjects) {
        if (!this.options.returnedObjectHandler) {
          this.logger.warn('accessing an object - but returnObjects options is not enabled!');
        }
        const r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, resForObjHndl, {
          ...options,
          ns: namespaces
        }) : `key '${key} (${this.language})' returned an object instead of string.`;
        if (returnDetails) {
          resolved.res = r;
          resolved.usedParams = this.getUsedParamsDetails(options);
          return resolved;
        }
        return r;
      }
      if (keySeparator) {
        const resTypeIsArray = Array.isArray(resForObjHndl);
        const copy = resTypeIsArray ? [] : {};
        const newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
        for (const m in resForObjHndl) {
          if (Object.prototype.hasOwnProperty.call(resForObjHndl, m)) {
            const deepKey = `${newKeyToUse}${keySeparator}${m}`;
            if (hasDefaultValue && !res) {
              copy[m] = this.translate(deepKey, {
                ...options,
                defaultValue: shouldHandleAsObject(defaultValue) ? defaultValue[m] : undefined,
                ...{
                  joinArrays: false,
                  ns: namespaces
                }
              });
            } else {
              copy[m] = this.translate(deepKey, {
                ...options,
                ...{
                  joinArrays: false,
                  ns: namespaces
                }
              });
            }
            if (copy[m] === deepKey) copy[m] = resForObjHndl[m];
          }
        }
        res = copy;
      }
    } else if (handleAsObjectInI18nFormat && isString$2(joinArrays) && Array.isArray(res)) {
      res = res.join(joinArrays);
      if (res) res = this.extendTranslation(res, keys, options, lastKey);
    } else {
      let usedDefault = false;
      let usedKey = false;
      if (!this.isValidLookup(res) && hasDefaultValue) {
        usedDefault = true;
        res = defaultValue;
      }
      if (!this.isValidLookup(res)) {
        usedKey = true;
        res = key;
      }
      const missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
      const resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
      const updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
      if (usedKey || usedDefault || updateMissing) {
        this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? defaultValue : res);
        if (keySeparator) {
          const fk = this.resolve(key, {
            ...options,
            keySeparator: false
          });
          if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
        }
        let lngs = [];
        const fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
        if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) {
          for (let i = 0; i < fallbackLngs.length; i++) {
            lngs.push(fallbackLngs[i]);
          }
        } else if (this.options.saveMissingTo === 'all') {
          lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
        } else {
          lngs.push(options.lng || this.language);
        }
        const send = (l, k, specificDefaultValue) => {
          const defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
          if (this.options.missingKeyHandler) {
            this.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
          } else if (this.backendConnector?.saveMissing) {
            this.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
          }
          this.emit('missingKey', l, namespace, k, res);
        };
        if (this.options.saveMissing) {
          if (this.options.saveMissingPlurals && needsPluralHandling) {
            lngs.forEach(language => {
              const suffixes = this.pluralResolver.getSuffixes(language, options);
              if (needsZeroSuffixLookup && options[`defaultValue${this.options.pluralSeparator}zero`] && suffixes.indexOf(`${this.options.pluralSeparator}zero`) < 0) {
                suffixes.push(`${this.options.pluralSeparator}zero`);
              }
              suffixes.forEach(suffix => {
                send([language], key + suffix, options[`defaultValue${suffix}`] || defaultValue);
              });
            });
          } else {
            send(lngs, key, defaultValue);
          }
        }
      }
      res = this.extendTranslation(res, keys, options, resolved, lastKey);
      if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = `${namespace}:${key}`;
      if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) {
        res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${namespace}:${key}` : key, usedDefault ? res : undefined);
      }
    }
    if (returnDetails) {
      resolved.res = res;
      resolved.usedParams = this.getUsedParamsDetails(options);
      return resolved;
    }
    return res;
  }
  extendTranslation(res, key, options, resolved, lastKey) {
    var _this = this;
    if (this.i18nFormat?.parse) {
      res = this.i18nFormat.parse(res, {
        ...this.options.interpolation.defaultVariables,
        ...options
      }, options.lng || this.language || resolved.usedLng, resolved.usedNS, resolved.usedKey, {
        resolved
      });
    } else if (!options.skipInterpolation) {
      if (options.interpolation) this.interpolator.init({
        ...options,
        ...{
          interpolation: {
            ...this.options.interpolation,
            ...options.interpolation
          }
        }
      });
      const skipOnVariables = isString$2(res) && (options?.interpolation?.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let nestBef;
      if (skipOnVariables) {
        const nb = res.match(this.interpolator.nestingRegexp);
        nestBef = nb && nb.length;
      }
      let data = options.replace && !isString$2(options.replace) ? options.replace : options;
      if (this.options.interpolation.defaultVariables) data = {
        ...this.options.interpolation.defaultVariables,
        ...data
      };
      res = this.interpolator.interpolate(res, data, options.lng || this.language || resolved.usedLng, options);
      if (skipOnVariables) {
        const na = res.match(this.interpolator.nestingRegexp);
        const nestAft = na && na.length;
        if (nestBef < nestAft) options.nest = false;
      }
      if (!options.lng && resolved && resolved.res) options.lng = this.language || resolved.usedLng;
      if (options.nest !== false) res = this.interpolator.nest(res, function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        if (lastKey?.[0] === args[0] && !options.context) {
          _this.logger.warn(`It seems you are nesting recursively key: ${args[0]} in key: ${key[0]}`);
          return null;
        }
        return _this.translate(...args, key);
      }, options);
      if (options.interpolation) this.interpolator.reset();
    }
    const postProcess = options.postProcess || this.options.postProcess;
    const postProcessorNames = isString$2(postProcess) ? [postProcess] : postProcess;
    if (res != null && postProcessorNames?.length && options.applyPostProcessor !== false) {
      res = postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? {
        i18nResolved: {
          ...resolved,
          usedParams: this.getUsedParamsDetails(options)
        },
        ...options
      } : options, this);
    }
    return res;
  }
  resolve(keys) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let found;
    let usedKey;
    let exactUsedKey;
    let usedLng;
    let usedNS;
    if (isString$2(keys)) keys = [keys];
    keys.forEach(k => {
      if (this.isValidLookup(found)) return;
      const extracted = this.extractFromKey(k, options);
      const key = extracted.key;
      usedKey = key;
      let namespaces = extracted.namespaces;
      if (this.options.fallbackNS) namespaces = namespaces.concat(this.options.fallbackNS);
      const needsPluralHandling = options.count !== undefined && !isString$2(options.count);
      const needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0;
      const needsContextHandling = options.context !== undefined && (isString$2(options.context) || typeof options.context === 'number') && options.context !== '';
      const codes = options.lngs ? options.lngs : this.languageUtils.toResolveHierarchy(options.lng || this.language, options.fallbackLng);
      namespaces.forEach(ns => {
        if (this.isValidLookup(found)) return;
        usedNS = ns;
        if (!checkedLoadedFor[`${codes[0]}-${ns}`] && this.utils?.hasLoadedNamespace && !this.utils?.hasLoadedNamespace(usedNS)) {
          checkedLoadedFor[`${codes[0]}-${ns}`] = true;
          this.logger.warn(`key "${usedKey}" for languages "${codes.join(', ')}" won't get resolved as namespace "${usedNS}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
        }
        codes.forEach(code => {
          if (this.isValidLookup(found)) return;
          usedLng = code;
          const finalKeys = [key];
          if (this.i18nFormat?.addLookupKeys) {
            this.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
          } else {
            let pluralSuffix;
            if (needsPluralHandling) pluralSuffix = this.pluralResolver.getSuffix(code, options.count, options);
            const zeroSuffix = `${this.options.pluralSeparator}zero`;
            const ordinalPrefix = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (needsPluralHandling) {
              finalKeys.push(key + pluralSuffix);
              if (options.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) {
                finalKeys.push(key + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
              }
              if (needsZeroSuffixLookup) {
                finalKeys.push(key + zeroSuffix);
              }
            }
            if (needsContextHandling) {
              const contextKey = `${key}${this.options.contextSeparator}${options.context}`;
              finalKeys.push(contextKey);
              if (needsPluralHandling) {
                finalKeys.push(contextKey + pluralSuffix);
                if (options.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) {
                  finalKeys.push(contextKey + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                }
                if (needsZeroSuffixLookup) {
                  finalKeys.push(contextKey + zeroSuffix);
                }
              }
            }
          }
          let possibleKey;
          while (possibleKey = finalKeys.pop()) {
            if (!this.isValidLookup(found)) {
              exactUsedKey = possibleKey;
              found = this.getResource(code, ns, possibleKey, options);
            }
          }
        });
      });
    });
    return {
      res: found,
      usedKey,
      exactUsedKey,
      usedLng,
      usedNS
    };
  }
  isValidLookup(res) {
    return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
  }
  getResource(code, ns, key) {
    let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    if (this.i18nFormat?.getResource) return this.i18nFormat.getResource(code, ns, key, options);
    return this.resourceStore.getResource(code, ns, key, options);
  }
  getUsedParamsDetails() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const optionsKeys = ['defaultValue', 'ordinal', 'context', 'replace', 'lng', 'lngs', 'fallbackLng', 'ns', 'keySeparator', 'nsSeparator', 'returnObjects', 'returnDetails', 'joinArrays', 'postProcess', 'interpolation'];
    const useOptionsReplaceForData = options.replace && !isString$2(options.replace);
    let data = useOptionsReplaceForData ? options.replace : options;
    if (useOptionsReplaceForData && typeof options.count !== 'undefined') {
      data.count = options.count;
    }
    if (this.options.interpolation.defaultVariables) {
      data = {
        ...this.options.interpolation.defaultVariables,
        ...data
      };
    }
    if (!useOptionsReplaceForData) {
      data = {
        ...data
      };
      for (const key of optionsKeys) {
        delete data[key];
      }
    }
    return data;
  }
  static hasDefaultValue(options) {
    const prefix = 'defaultValue';
    for (const option in options) {
      if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) {
        return true;
      }
    }
    return false;
  }
}

class LanguageUtil {
  constructor(options) {
    this.options = options;
    this.supportedLngs = this.options.supportedLngs || false;
    this.logger = baseLogger.create('languageUtils');
  }
  getScriptPartFromCode(code) {
    code = getCleanedCode(code);
    if (!code || code.indexOf('-') < 0) return null;
    const p = code.split('-');
    if (p.length === 2) return null;
    p.pop();
    if (p[p.length - 1].toLowerCase() === 'x') return null;
    return this.formatLanguageCode(p.join('-'));
  }
  getLanguagePartFromCode(code) {
    code = getCleanedCode(code);
    if (!code || code.indexOf('-') < 0) return code;
    const p = code.split('-');
    return this.formatLanguageCode(p[0]);
  }
  formatLanguageCode(code) {
    if (isString$2(code) && code.indexOf('-') > -1) {
      let formattedCode;
      try {
        formattedCode = Intl.getCanonicalLocales(code)[0];
      } catch (e) {}
      if (formattedCode && this.options.lowerCaseLng) {
        formattedCode = formattedCode.toLowerCase();
      }
      if (formattedCode) return formattedCode;
      if (this.options.lowerCaseLng) {
        return code.toLowerCase();
      }
      return code;
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
  }
  isSupportedCode(code) {
    if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) {
      code = this.getLanguagePartFromCode(code);
    }
    return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
  }
  getBestMatchFromCodes(codes) {
    if (!codes) return null;
    let found;
    codes.forEach(code => {
      if (found) return;
      const cleanedLng = this.formatLanguageCode(code);
      if (!this.options.supportedLngs || this.isSupportedCode(cleanedLng)) found = cleanedLng;
    });
    if (!found && this.options.supportedLngs) {
      codes.forEach(code => {
        if (found) return;
        const lngOnly = this.getLanguagePartFromCode(code);
        if (this.isSupportedCode(lngOnly)) return found = lngOnly;
        found = this.options.supportedLngs.find(supportedLng => {
          if (supportedLng === lngOnly) return supportedLng;
          if (supportedLng.indexOf('-') < 0 && lngOnly.indexOf('-') < 0) return;
          if (supportedLng.indexOf('-') > 0 && lngOnly.indexOf('-') < 0 && supportedLng.substring(0, supportedLng.indexOf('-')) === lngOnly) return supportedLng;
          if (supportedLng.indexOf(lngOnly) === 0 && lngOnly.length > 1) return supportedLng;
        });
      });
    }
    if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
    return found;
  }
  getFallbackCodes(fallbacks, code) {
    if (!fallbacks) return [];
    if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
    if (isString$2(fallbacks)) fallbacks = [fallbacks];
    if (Array.isArray(fallbacks)) return fallbacks;
    if (!code) return fallbacks.default || [];
    let found = fallbacks[code];
    if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
    if (!found) found = fallbacks[this.formatLanguageCode(code)];
    if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
    if (!found) found = fallbacks.default;
    return found || [];
  }
  toResolveHierarchy(code, fallbackCode) {
    const fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
    const codes = [];
    const addCode = c => {
      if (!c) return;
      if (this.isSupportedCode(c)) {
        codes.push(c);
      } else {
        this.logger.warn(`rejecting language code not found in supportedLngs: ${c}`);
      }
    };
    if (isString$2(code) && (code.indexOf('-') > -1 || code.indexOf('_') > -1)) {
      if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
      if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
      if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
    } else if (isString$2(code)) {
      addCode(this.formatLanguageCode(code));
    }
    fallbackCodes.forEach(fc => {
      if (codes.indexOf(fc) < 0) addCode(this.formatLanguageCode(fc));
    });
    return codes;
  }
}

const suffixesOrder = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
};
const dummyRule = {
  select: count => count === 1 ? 'one' : 'other',
  resolvedOptions: () => ({
    pluralCategories: ['one', 'other']
  })
};
class PluralResolver {
  constructor(languageUtils) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.languageUtils = languageUtils;
    this.options = options;
    this.logger = baseLogger.create('pluralResolver');
    this.pluralRulesCache = {};
  }
  addRule(lng, obj) {
    this.rules[lng] = obj;
  }
  clearCache() {
    this.pluralRulesCache = {};
  }
  getRule(code) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const cleanedCode = getCleanedCode(code === 'dev' ? 'en' : code);
    const type = options.ordinal ? 'ordinal' : 'cardinal';
    const cacheKey = JSON.stringify({
      cleanedCode,
      type
    });
    if (cacheKey in this.pluralRulesCache) {
      return this.pluralRulesCache[cacheKey];
    }
    let rule;
    try {
      rule = new Intl.PluralRules(cleanedCode, {
        type
      });
    } catch (err) {
      if (!Intl) {
        this.logger.error('No Intl support, please use an Intl polyfill!');
        return dummyRule;
      }
      if (!code.match(/-|_/)) return dummyRule;
      const lngPart = this.languageUtils.getLanguagePartFromCode(code);
      rule = this.getRule(lngPart, options);
    }
    this.pluralRulesCache[cacheKey] = rule;
    return rule;
  }
  needsPlural(code) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let rule = this.getRule(code, options);
    if (!rule) rule = this.getRule('dev', options);
    return rule?.resolvedOptions().pluralCategories.length > 1;
  }
  getPluralFormsOfKey(code, key) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return this.getSuffixes(code, options).map(suffix => `${key}${suffix}`);
  }
  getSuffixes(code) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let rule = this.getRule(code, options);
    if (!rule) rule = this.getRule('dev', options);
    if (!rule) return [];
    return rule.resolvedOptions().pluralCategories.sort((pluralCategory1, pluralCategory2) => suffixesOrder[pluralCategory1] - suffixesOrder[pluralCategory2]).map(pluralCategory => `${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${pluralCategory}`);
  }
  getSuffix(code, count) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    const rule = this.getRule(code, options);
    if (rule) {
      return `${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${rule.select(count)}`;
    }
    this.logger.warn(`no plural rule found for: ${code}`);
    return this.getSuffix('dev', count, options);
  }
}

const deepFindWithDefaults = function (data, defaultData, key) {
  let keySeparator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '.';
  let ignoreJSONStructure = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
  let path = getPathWithDefaults(data, defaultData, key);
  if (!path && ignoreJSONStructure && isString$2(key)) {
    path = deepFind(data, key, keySeparator);
    if (path === undefined) path = deepFind(defaultData, key, keySeparator);
  }
  return path;
};
const regexSafe = val => val.replace(/\$/g, '$$$$');
class Interpolator {
  constructor() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.logger = baseLogger.create('interpolator');
    this.options = options;
    this.format = options?.interpolation?.format || (value => value);
    this.init(options);
  }
  init() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (!options.interpolation) options.interpolation = {
      escapeValue: true
    };
    const {
      escape: escape$1,
      escapeValue,
      useRawValueToEscape,
      prefix,
      prefixEscaped,
      suffix,
      suffixEscaped,
      formatSeparator,
      unescapeSuffix,
      unescapePrefix,
      nestingPrefix,
      nestingPrefixEscaped,
      nestingSuffix,
      nestingSuffixEscaped,
      nestingOptionsSeparator,
      maxReplaces,
      alwaysFormat
    } = options.interpolation;
    this.escape = escape$1 !== undefined ? escape$1 : escape;
    this.escapeValue = escapeValue !== undefined ? escapeValue : true;
    this.useRawValueToEscape = useRawValueToEscape !== undefined ? useRawValueToEscape : false;
    this.prefix = prefix ? regexEscape(prefix) : prefixEscaped || '{{';
    this.suffix = suffix ? regexEscape(suffix) : suffixEscaped || '}}';
    this.formatSeparator = formatSeparator || ',';
    this.unescapePrefix = unescapeSuffix ? '' : unescapePrefix || '-';
    this.unescapeSuffix = this.unescapePrefix ? '' : unescapeSuffix || '';
    this.nestingPrefix = nestingPrefix ? regexEscape(nestingPrefix) : nestingPrefixEscaped || regexEscape('$t(');
    this.nestingSuffix = nestingSuffix ? regexEscape(nestingSuffix) : nestingSuffixEscaped || regexEscape(')');
    this.nestingOptionsSeparator = nestingOptionsSeparator || ',';
    this.maxReplaces = maxReplaces || 1000;
    this.alwaysFormat = alwaysFormat !== undefined ? alwaysFormat : false;
    this.resetRegExp();
  }
  reset() {
    if (this.options) this.init(this.options);
  }
  resetRegExp() {
    const getOrResetRegExp = (existingRegExp, pattern) => {
      if (existingRegExp?.source === pattern) {
        existingRegExp.lastIndex = 0;
        return existingRegExp;
      }
      return new RegExp(pattern, 'g');
    };
    this.regexp = getOrResetRegExp(this.regexp, `${this.prefix}(.+?)${this.suffix}`);
    this.regexpUnescape = getOrResetRegExp(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`);
    this.nestingRegexp = getOrResetRegExp(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
  }
  interpolate(str, data, lng, options) {
    let match;
    let value;
    let replaces;
    const defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
    const handleFormat = key => {
      if (key.indexOf(this.formatSeparator) < 0) {
        const path = deepFindWithDefaults(data, defaultData, key, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(path, undefined, lng, {
          ...options,
          ...data,
          interpolationkey: key
        }) : path;
      }
      const p = key.split(this.formatSeparator);
      const k = p.shift().trim();
      const f = p.join(this.formatSeparator).trim();
      return this.format(deepFindWithDefaults(data, defaultData, k, this.options.keySeparator, this.options.ignoreJSONStructure), f, lng, {
        ...options,
        ...data,
        interpolationkey: k
      });
    };
    this.resetRegExp();
    const missingInterpolationHandler = options?.missingInterpolationHandler || this.options.missingInterpolationHandler;
    const skipOnVariables = options?.interpolation?.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    const todos = [{
      regex: this.regexpUnescape,
      safeValue: val => regexSafe(val)
    }, {
      regex: this.regexp,
      safeValue: val => this.escapeValue ? regexSafe(this.escape(val)) : regexSafe(val)
    }];
    todos.forEach(todo => {
      replaces = 0;
      while (match = todo.regex.exec(str)) {
        const matchedVar = match[1].trim();
        value = handleFormat(matchedVar);
        if (value === undefined) {
          if (typeof missingInterpolationHandler === 'function') {
            const temp = missingInterpolationHandler(str, match, options);
            value = isString$2(temp) ? temp : '';
          } else if (options && Object.prototype.hasOwnProperty.call(options, matchedVar)) {
            value = '';
          } else if (skipOnVariables) {
            value = match[0];
            continue;
          } else {
            this.logger.warn(`missed to pass in variable ${matchedVar} for interpolating ${str}`);
            value = '';
          }
        } else if (!isString$2(value) && !this.useRawValueToEscape) {
          value = makeString(value);
        }
        const safeValue = todo.safeValue(value);
        str = str.replace(match[0], safeValue);
        if (skipOnVariables) {
          todo.regex.lastIndex += value.length;
          todo.regex.lastIndex -= match[0].length;
        } else {
          todo.regex.lastIndex = 0;
        }
        replaces++;
        if (replaces >= this.maxReplaces) {
          break;
        }
      }
    });
    return str;
  }
  nest(str, fc) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    let match;
    let value;
    let clonedOptions;
    const handleHasOptions = (key, inheritedOptions) => {
      const sep = this.nestingOptionsSeparator;
      if (key.indexOf(sep) < 0) return key;
      const c = key.split(new RegExp(`${sep}[ ]*{`));
      let optionsString = `{${c[1]}`;
      key = c[0];
      optionsString = this.interpolate(optionsString, clonedOptions);
      const matchedSingleQuotes = optionsString.match(/'/g);
      const matchedDoubleQuotes = optionsString.match(/"/g);
      if ((matchedSingleQuotes?.length ?? 0) % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) {
        optionsString = optionsString.replace(/'/g, '"');
      }
      try {
        clonedOptions = JSON.parse(optionsString);
        if (inheritedOptions) clonedOptions = {
          ...inheritedOptions,
          ...clonedOptions
        };
      } catch (e) {
        this.logger.warn(`failed parsing options string in nesting for key ${key}`, e);
        return `${key}${sep}${optionsString}`;
      }
      if (clonedOptions.defaultValue && clonedOptions.defaultValue.indexOf(this.prefix) > -1) delete clonedOptions.defaultValue;
      return key;
    };
    while (match = this.nestingRegexp.exec(str)) {
      let formatters = [];
      clonedOptions = {
        ...options
      };
      clonedOptions = clonedOptions.replace && !isString$2(clonedOptions.replace) ? clonedOptions.replace : clonedOptions;
      clonedOptions.applyPostProcessor = false;
      delete clonedOptions.defaultValue;
      let doReduce = false;
      if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
        const r = match[1].split(this.formatSeparator).map(elem => elem.trim());
        match[1] = r.shift();
        formatters = r;
        doReduce = true;
      }
      value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
      if (value && match[0] === str && !isString$2(value)) return value;
      if (!isString$2(value)) value = makeString(value);
      if (!value) {
        this.logger.warn(`missed to resolve ${match[1]} for nesting ${str}`);
        value = '';
      }
      if (doReduce) {
        value = formatters.reduce((v, f) => this.format(v, f, options.lng, {
          ...options,
          interpolationkey: match[1].trim()
        }), value.trim());
      }
      str = str.replace(match[0], value);
      this.regexp.lastIndex = 0;
    }
    return str;
  }
}

const parseFormatStr = formatStr => {
  let formatName = formatStr.toLowerCase().trim();
  const formatOptions = {};
  if (formatStr.indexOf('(') > -1) {
    const p = formatStr.split('(');
    formatName = p[0].toLowerCase().trim();
    const optStr = p[1].substring(0, p[1].length - 1);
    if (formatName === 'currency' && optStr.indexOf(':') < 0) {
      if (!formatOptions.currency) formatOptions.currency = optStr.trim();
    } else if (formatName === 'relativetime' && optStr.indexOf(':') < 0) {
      if (!formatOptions.range) formatOptions.range = optStr.trim();
    } else {
      const opts = optStr.split(';');
      opts.forEach(opt => {
        if (opt) {
          const [key, ...rest] = opt.split(':');
          const val = rest.join(':').trim().replace(/^'+|'+$/g, '');
          const trimmedKey = key.trim();
          if (!formatOptions[trimmedKey]) formatOptions[trimmedKey] = val;
          if (val === 'false') formatOptions[trimmedKey] = false;
          if (val === 'true') formatOptions[trimmedKey] = true;
          if (!isNaN(val)) formatOptions[trimmedKey] = parseInt(val, 10);
        }
      });
    }
  }
  return {
    formatName,
    formatOptions
  };
};
const createCachedFormatter = fn => {
  const cache = {};
  return (val, lng, options) => {
    let optForCache = options;
    if (options && options.interpolationkey && options.formatParams && options.formatParams[options.interpolationkey] && options[options.interpolationkey]) {
      optForCache = {
        ...optForCache,
        [options.interpolationkey]: undefined
      };
    }
    const key = lng + JSON.stringify(optForCache);
    let formatter = cache[key];
    if (!formatter) {
      formatter = fn(getCleanedCode(lng), options);
      cache[key] = formatter;
    }
    return formatter(val);
  };
};
class Formatter {
  constructor() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.logger = baseLogger.create('formatter');
    this.options = options;
    this.formats = {
      number: createCachedFormatter((lng, opt) => {
        const formatter = new Intl.NumberFormat(lng, {
          ...opt
        });
        return val => formatter.format(val);
      }),
      currency: createCachedFormatter((lng, opt) => {
        const formatter = new Intl.NumberFormat(lng, {
          ...opt,
          style: 'currency'
        });
        return val => formatter.format(val);
      }),
      datetime: createCachedFormatter((lng, opt) => {
        const formatter = new Intl.DateTimeFormat(lng, {
          ...opt
        });
        return val => formatter.format(val);
      }),
      relativetime: createCachedFormatter((lng, opt) => {
        const formatter = new Intl.RelativeTimeFormat(lng, {
          ...opt
        });
        return val => formatter.format(val, opt.range || 'day');
      }),
      list: createCachedFormatter((lng, opt) => {
        const formatter = new Intl.ListFormat(lng, {
          ...opt
        });
        return val => formatter.format(val);
      })
    };
    this.init(options);
  }
  init(services) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      interpolation: {}
    };
    this.formatSeparator = options.interpolation.formatSeparator || ',';
  }
  add(name, fc) {
    this.formats[name.toLowerCase().trim()] = fc;
  }
  addCached(name, fc) {
    this.formats[name.toLowerCase().trim()] = createCachedFormatter(fc);
  }
  format(value, format, lng) {
    let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    const formats = format.split(this.formatSeparator);
    if (formats.length > 1 && formats[0].indexOf('(') > 1 && formats[0].indexOf(')') < 0 && formats.find(f => f.indexOf(')') > -1)) {
      const lastIndex = formats.findIndex(f => f.indexOf(')') > -1);
      formats[0] = [formats[0], ...formats.splice(1, lastIndex)].join(this.formatSeparator);
    }
    const result = formats.reduce((mem, f) => {
      const {
        formatName,
        formatOptions
      } = parseFormatStr(f);
      if (this.formats[formatName]) {
        let formatted = mem;
        try {
          const valOptions = options?.formatParams?.[options.interpolationkey] || {};
          const l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
          formatted = this.formats[formatName](mem, l, {
            ...formatOptions,
            ...options,
            ...valOptions
          });
        } catch (error) {
          this.logger.warn(error);
        }
        return formatted;
      } else {
        this.logger.warn(`there was no format function for ${formatName}`);
      }
      return mem;
    }, value);
    return result;
  }
}

const removePending = (q, name) => {
  if (q.pending[name] !== undefined) {
    delete q.pending[name];
    q.pendingCount--;
  }
};
class Connector extends EventEmitter {
  constructor(backend, store, services) {
    let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    super();
    this.backend = backend;
    this.store = store;
    this.services = services;
    this.languageUtils = services.languageUtils;
    this.options = options;
    this.logger = baseLogger.create('backendConnector');
    this.waitingReads = [];
    this.maxParallelReads = options.maxParallelReads || 10;
    this.readingCalls = 0;
    this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
    this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
    this.state = {};
    this.queue = [];
    this.backend?.init?.(services, options.backend, options);
  }
  queueLoad(languages, namespaces, options, callback) {
    const toLoad = {};
    const pending = {};
    const toLoadLanguages = {};
    const toLoadNamespaces = {};
    languages.forEach(lng => {
      let hasAllNamespaces = true;
      namespaces.forEach(ns => {
        const name = `${lng}|${ns}`;
        if (!options.reload && this.store.hasResourceBundle(lng, ns)) {
          this.state[name] = 2;
        } else if (this.state[name] < 0) ; else if (this.state[name] === 1) {
          if (pending[name] === undefined) pending[name] = true;
        } else {
          this.state[name] = 1;
          hasAllNamespaces = false;
          if (pending[name] === undefined) pending[name] = true;
          if (toLoad[name] === undefined) toLoad[name] = true;
          if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
        }
      });
      if (!hasAllNamespaces) toLoadLanguages[lng] = true;
    });
    if (Object.keys(toLoad).length || Object.keys(pending).length) {
      this.queue.push({
        pending,
        pendingCount: Object.keys(pending).length,
        loaded: {},
        errors: [],
        callback
      });
    }
    return {
      toLoad: Object.keys(toLoad),
      pending: Object.keys(pending),
      toLoadLanguages: Object.keys(toLoadLanguages),
      toLoadNamespaces: Object.keys(toLoadNamespaces)
    };
  }
  loaded(name, err, data) {
    const s = name.split('|');
    const lng = s[0];
    const ns = s[1];
    if (err) this.emit('failedLoading', lng, ns, err);
    if (!err && data) {
      this.store.addResourceBundle(lng, ns, data, undefined, undefined, {
        skipCopy: true
      });
    }
    this.state[name] = err ? -1 : 2;
    if (err && data) this.state[name] = 0;
    const loaded = {};
    this.queue.forEach(q => {
      pushPath(q.loaded, [lng], ns);
      removePending(q, name);
      if (err) q.errors.push(err);
      if (q.pendingCount === 0 && !q.done) {
        Object.keys(q.loaded).forEach(l => {
          if (!loaded[l]) loaded[l] = {};
          const loadedKeys = q.loaded[l];
          if (loadedKeys.length) {
            loadedKeys.forEach(n => {
              if (loaded[l][n] === undefined) loaded[l][n] = true;
            });
          }
        });
        q.done = true;
        if (q.errors.length) {
          q.callback(q.errors);
        } else {
          q.callback();
        }
      }
    });
    this.emit('loaded', loaded);
    this.queue = this.queue.filter(q => !q.done);
  }
  read(lng, ns, fcName) {
    let tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    let wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.retryTimeout;
    let callback = arguments.length > 5 ? arguments[5] : undefined;
    if (!lng.length) return callback(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng,
        ns,
        fcName,
        tried,
        wait,
        callback
      });
      return;
    }
    this.readingCalls++;
    const resolver = (err, data) => {
      this.readingCalls--;
      if (this.waitingReads.length > 0) {
        const next = this.waitingReads.shift();
        this.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
      }
      if (err && data && tried < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, lng, ns, fcName, tried + 1, wait * 2, callback);
        }, wait);
        return;
      }
      callback(err, data);
    };
    const fc = this.backend[fcName].bind(this.backend);
    if (fc.length === 2) {
      try {
        const r = fc(lng, ns);
        if (r && typeof r.then === 'function') {
          r.then(data => resolver(null, data)).catch(resolver);
        } else {
          resolver(null, r);
        }
      } catch (err) {
        resolver(err);
      }
      return;
    }
    return fc(lng, ns, resolver);
  }
  prepareLoading(languages, namespaces) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    let callback = arguments.length > 3 ? arguments[3] : undefined;
    if (!this.backend) {
      this.logger.warn('No backend was added via i18next.use. Will not load resources.');
      return callback && callback();
    }
    if (isString$2(languages)) languages = this.languageUtils.toResolveHierarchy(languages);
    if (isString$2(namespaces)) namespaces = [namespaces];
    const toLoad = this.queueLoad(languages, namespaces, options, callback);
    if (!toLoad.toLoad.length) {
      if (!toLoad.pending.length) callback();
      return null;
    }
    toLoad.toLoad.forEach(name => {
      this.loadOne(name);
    });
  }
  load(languages, namespaces, callback) {
    this.prepareLoading(languages, namespaces, {}, callback);
  }
  reload(languages, namespaces, callback) {
    this.prepareLoading(languages, namespaces, {
      reload: true
    }, callback);
  }
  loadOne(name) {
    let prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    const s = name.split('|');
    const lng = s[0];
    const ns = s[1];
    this.read(lng, ns, 'read', undefined, undefined, (err, data) => {
      if (err) this.logger.warn(`${prefix}loading namespace ${ns} for language ${lng} failed`, err);
      if (!err && data) this.logger.log(`${prefix}loaded namespace ${ns} for language ${lng}`, data);
      this.loaded(name, err, data);
    });
  }
  saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
    let options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
    let clb = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : () => {};
    if (this.services?.utils?.hasLoadedNamespace && !this.services?.utils?.hasLoadedNamespace(namespace)) {
      this.logger.warn(`did not save key "${key}" as the namespace "${namespace}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
      return;
    }
    if (key === undefined || key === null || key === '') return;
    if (this.backend?.create) {
      const opts = {
        ...options,
        isUpdate
      };
      const fc = this.backend.create.bind(this.backend);
      if (fc.length < 6) {
        try {
          let r;
          if (fc.length === 5) {
            r = fc(languages, namespace, key, fallbackValue, opts);
          } else {
            r = fc(languages, namespace, key, fallbackValue);
          }
          if (r && typeof r.then === 'function') {
            r.then(data => clb(null, data)).catch(clb);
          } else {
            clb(null, r);
          }
        } catch (err) {
          clb(err);
        }
      } else {
        fc(languages, namespace, key, fallbackValue, clb, opts);
      }
    }
    if (!languages || !languages[0]) return;
    this.store.addResource(languages[0], namespace, key, fallbackValue);
  }
}

const get$1 = () => ({
  debug: false,
  initAsync: true,
  ns: ['translation'],
  defaultNS: ['translation'],
  fallbackLng: ['dev'],
  fallbackNS: false,
  supportedLngs: false,
  nonExplicitSupportedLngs: false,
  load: 'all',
  preload: false,
  simplifyPluralSuffix: true,
  keySeparator: '.',
  nsSeparator: ':',
  pluralSeparator: '_',
  contextSeparator: '_',
  partialBundledLanguages: false,
  saveMissing: false,
  updateMissing: false,
  saveMissingTo: 'fallback',
  saveMissingPlurals: true,
  missingKeyHandler: false,
  missingInterpolationHandler: false,
  postProcess: false,
  postProcessPassResolved: false,
  returnNull: false,
  returnEmptyString: true,
  returnObjects: false,
  joinArrays: false,
  returnedObjectHandler: false,
  parseMissingKeyHandler: false,
  appendNamespaceToMissingKey: false,
  appendNamespaceToCIMode: false,
  overloadTranslationOptionHandler: args => {
    let ret = {};
    if (typeof args[1] === 'object') ret = args[1];
    if (isString$2(args[1])) ret.defaultValue = args[1];
    if (isString$2(args[2])) ret.tDescription = args[2];
    if (typeof args[2] === 'object' || typeof args[3] === 'object') {
      const options = args[3] || args[2];
      Object.keys(options).forEach(key => {
        ret[key] = options[key];
      });
    }
    return ret;
  },
  interpolation: {
    escapeValue: true,
    format: value => value,
    prefix: '{{',
    suffix: '}}',
    formatSeparator: ',',
    unescapePrefix: '-',
    nestingPrefix: '$t(',
    nestingSuffix: ')',
    nestingOptionsSeparator: ',',
    maxReplaces: 1000,
    skipOnVariables: true
  }
});
const transformOptions = options => {
  if (isString$2(options.ns)) options.ns = [options.ns];
  if (isString$2(options.fallbackLng)) options.fallbackLng = [options.fallbackLng];
  if (isString$2(options.fallbackNS)) options.fallbackNS = [options.fallbackNS];
  if (options.supportedLngs?.indexOf?.('cimode') < 0) {
    options.supportedLngs = options.supportedLngs.concat(['cimode']);
  }
  if (typeof options.initImmediate === 'boolean') options.initAsync = options.initImmediate;
  return options;
};

const noop = () => {};
const bindMemberFunctions = inst => {
  const mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
  mems.forEach(mem => {
    if (typeof inst[mem] === 'function') {
      inst[mem] = inst[mem].bind(inst);
    }
  });
};
class I18n extends EventEmitter {
  constructor() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let callback = arguments.length > 1 ? arguments[1] : undefined;
    super();
    this.options = transformOptions(options);
    this.services = {};
    this.logger = baseLogger;
    this.modules = {
      external: []
    };
    bindMemberFunctions(this);
    if (callback && !this.isInitialized && !options.isClone) {
      if (!this.options.initAsync) {
        this.init(options, callback);
        return this;
      }
      setTimeout(() => {
        this.init(options, callback);
      }, 0);
    }
  }
  init() {
    var _this = this;
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let callback = arguments.length > 1 ? arguments[1] : undefined;
    this.isInitializing = true;
    if (typeof options === 'function') {
      callback = options;
      options = {};
    }
    if (options.defaultNS == null && options.ns) {
      if (isString$2(options.ns)) {
        options.defaultNS = options.ns;
      } else if (options.ns.indexOf('translation') < 0) {
        options.defaultNS = options.ns[0];
      }
    }
    const defOpts = get$1();
    this.options = {
      ...defOpts,
      ...this.options,
      ...transformOptions(options)
    };
    this.options.interpolation = {
      ...defOpts.interpolation,
      ...this.options.interpolation
    };
    if (options.keySeparator !== undefined) {
      this.options.userDefinedKeySeparator = options.keySeparator;
    }
    if (options.nsSeparator !== undefined) {
      this.options.userDefinedNsSeparator = options.nsSeparator;
    }
    const createClassOnDemand = ClassOrObject => {
      if (!ClassOrObject) return null;
      if (typeof ClassOrObject === 'function') return new ClassOrObject();
      return ClassOrObject;
    };
    if (!this.options.isClone) {
      if (this.modules.logger) {
        baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
      } else {
        baseLogger.init(null, this.options);
      }
      let formatter;
      if (this.modules.formatter) {
        formatter = this.modules.formatter;
      } else {
        formatter = Formatter;
      }
      const lu = new LanguageUtil(this.options);
      this.store = new ResourceStore(this.options.resources, this.options);
      const s = this.services;
      s.logger = baseLogger;
      s.resourceStore = this.store;
      s.languageUtils = lu;
      s.pluralResolver = new PluralResolver(lu, {
        prepend: this.options.pluralSeparator,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      });
      if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
        s.formatter = createClassOnDemand(formatter);
        s.formatter.init(s, this.options);
        this.options.interpolation.format = s.formatter.format.bind(s.formatter);
      }
      s.interpolator = new Interpolator(this.options);
      s.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      };
      s.backendConnector = new Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
      s.backendConnector.on('*', function (event) {
        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }
        _this.emit(event, ...args);
      });
      if (this.modules.languageDetector) {
        s.languageDetector = createClassOnDemand(this.modules.languageDetector);
        if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
      }
      if (this.modules.i18nFormat) {
        s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
        if (s.i18nFormat.init) s.i18nFormat.init(this);
      }
      this.translator = new Translator(this.services, this.options);
      this.translator.on('*', function (event) {
        for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }
        _this.emit(event, ...args);
      });
      this.modules.external.forEach(m => {
        if (m.init) m.init(this);
      });
    }
    this.format = this.options.interpolation.format;
    if (!callback) callback = noop;
    if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
    }
    if (!this.services.languageDetector && !this.options.lng) {
      this.logger.warn('init: no languageDetector is used and no lng is defined');
    }
    const storeApi = ['getResource', 'hasResourceBundle', 'getResourceBundle', 'getDataByLanguage'];
    storeApi.forEach(fcName => {
      this[fcName] = function () {
        return _this.store[fcName](...arguments);
      };
    });
    const storeApiChained = ['addResource', 'addResources', 'addResourceBundle', 'removeResourceBundle'];
    storeApiChained.forEach(fcName => {
      this[fcName] = function () {
        _this.store[fcName](...arguments);
        return _this;
      };
    });
    const deferred = defer();
    const load = () => {
      const finish = (err, t) => {
        this.isInitializing = false;
        if (this.isInitialized && !this.initializedStoreOnce) this.logger.warn('init: i18next is already initialized. You should call init just once!');
        this.isInitialized = true;
        if (!this.options.isClone) this.logger.log('initialized', this.options);
        this.emit('initialized', this.options);
        deferred.resolve(t);
        callback(err, t);
      };
      if (this.languages && !this.isInitialized) return finish(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, finish);
    };
    if (this.options.resources || !this.options.initAsync) {
      load();
    } else {
      setTimeout(load, 0);
    }
    return deferred;
  }
  loadResources(language) {
    let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
    let usedCallback = callback;
    const usedLng = isString$2(language) ? language : this.language;
    if (typeof language === 'function') usedCallback = language;
    if (!this.options.resources || this.options.partialBundledLanguages) {
      if (usedLng?.toLowerCase() === 'cimode' && (!this.options.preload || this.options.preload.length === 0)) return usedCallback();
      const toLoad = [];
      const append = lng => {
        if (!lng) return;
        if (lng === 'cimode') return;
        const lngs = this.services.languageUtils.toResolveHierarchy(lng);
        lngs.forEach(l => {
          if (l === 'cimode') return;
          if (toLoad.indexOf(l) < 0) toLoad.push(l);
        });
      };
      if (!usedLng) {
        const fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
        fallbacks.forEach(l => append(l));
      } else {
        append(usedLng);
      }
      this.options.preload?.forEach?.(l => append(l));
      this.services.backendConnector.load(toLoad, this.options.ns, e => {
        if (!e && !this.resolvedLanguage && this.language) this.setResolvedLanguage(this.language);
        usedCallback(e);
      });
    } else {
      usedCallback(null);
    }
  }
  reloadResources(lngs, ns, callback) {
    const deferred = defer();
    if (typeof lngs === 'function') {
      callback = lngs;
      lngs = undefined;
    }
    if (typeof ns === 'function') {
      callback = ns;
      ns = undefined;
    }
    if (!lngs) lngs = this.languages;
    if (!ns) ns = this.options.ns;
    if (!callback) callback = noop;
    this.services.backendConnector.reload(lngs, ns, err => {
      deferred.resolve();
      callback(err);
    });
    return deferred;
  }
  use(module) {
    if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
    if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');
    if (module.type === 'backend') {
      this.modules.backend = module;
    }
    if (module.type === 'logger' || module.log && module.warn && module.error) {
      this.modules.logger = module;
    }
    if (module.type === 'languageDetector') {
      this.modules.languageDetector = module;
    }
    if (module.type === 'i18nFormat') {
      this.modules.i18nFormat = module;
    }
    if (module.type === 'postProcessor') {
      postProcessor.addPostProcessor(module);
    }
    if (module.type === 'formatter') {
      this.modules.formatter = module;
    }
    if (module.type === '3rdParty') {
      this.modules.external.push(module);
    }
    return this;
  }
  setResolvedLanguage(l) {
    if (!l || !this.languages) return;
    if (['cimode', 'dev'].indexOf(l) > -1) return;
    for (let li = 0; li < this.languages.length; li++) {
      const lngInLngs = this.languages[li];
      if (['cimode', 'dev'].indexOf(lngInLngs) > -1) continue;
      if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
        this.resolvedLanguage = lngInLngs;
        break;
      }
    }
  }
  changeLanguage(lng, callback) {
    var _this2 = this;
    this.isLanguageChangingTo = lng;
    const deferred = defer();
    this.emit('languageChanging', lng);
    const setLngProps = l => {
      this.language = l;
      this.languages = this.services.languageUtils.toResolveHierarchy(l);
      this.resolvedLanguage = undefined;
      this.setResolvedLanguage(l);
    };
    const done = (err, l) => {
      if (l) {
        setLngProps(l);
        this.translator.changeLanguage(l);
        this.isLanguageChangingTo = undefined;
        this.emit('languageChanged', l);
        this.logger.log('languageChanged', l);
      } else {
        this.isLanguageChangingTo = undefined;
      }
      deferred.resolve(function () {
        return _this2.t(...arguments);
      });
      if (callback) callback(err, function () {
        return _this2.t(...arguments);
      });
    };
    const setLng = lngs => {
      if (!lng && !lngs && this.services.languageDetector) lngs = [];
      const l = isString$2(lngs) ? lngs : this.services.languageUtils.getBestMatchFromCodes(lngs);
      if (l) {
        if (!this.language) {
          setLngProps(l);
        }
        if (!this.translator.language) this.translator.changeLanguage(l);
        this.services.languageDetector?.cacheUserLanguage?.(l);
      }
      this.loadResources(l, err => {
        done(err, l);
      });
    };
    if (!lng && this.services.languageDetector && !this.services.languageDetector.async) {
      setLng(this.services.languageDetector.detect());
    } else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
      if (this.services.languageDetector.detect.length === 0) {
        this.services.languageDetector.detect().then(setLng);
      } else {
        this.services.languageDetector.detect(setLng);
      }
    } else {
      setLng(lng);
    }
    return deferred;
  }
  getFixedT(lng, ns, keyPrefix) {
    var _this3 = this;
    const fixedT = function (key, opts) {
      let options;
      if (typeof opts !== 'object') {
        for (var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
          rest[_key3 - 2] = arguments[_key3];
        }
        options = _this3.options.overloadTranslationOptionHandler([key, opts].concat(rest));
      } else {
        options = {
          ...opts
        };
      }
      options.lng = options.lng || fixedT.lng;
      options.lngs = options.lngs || fixedT.lngs;
      options.ns = options.ns || fixedT.ns;
      if (options.keyPrefix !== '') options.keyPrefix = options.keyPrefix || keyPrefix || fixedT.keyPrefix;
      const keySeparator = _this3.options.keySeparator || '.';
      let resultKey;
      if (options.keyPrefix && Array.isArray(key)) {
        resultKey = key.map(k => `${options.keyPrefix}${keySeparator}${k}`);
      } else {
        resultKey = options.keyPrefix ? `${options.keyPrefix}${keySeparator}${key}` : key;
      }
      return _this3.t(resultKey, options);
    };
    if (isString$2(lng)) {
      fixedT.lng = lng;
    } else {
      fixedT.lngs = lng;
    }
    fixedT.ns = ns;
    fixedT.keyPrefix = keyPrefix;
    return fixedT;
  }
  t() {
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }
    return this.translator?.translate(...args);
  }
  exists() {
    for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }
    return this.translator?.exists(...args);
  }
  setDefaultNamespace(ns) {
    this.options.defaultNS = ns;
  }
  hasLoadedNamespace(ns) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!this.isInitialized) {
      this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
      return false;
    }
    if (!this.languages || !this.languages.length) {
      this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
      return false;
    }
    const lng = options.lng || this.resolvedLanguage || this.languages[0];
    const fallbackLng = this.options ? this.options.fallbackLng : false;
    const lastLng = this.languages[this.languages.length - 1];
    if (lng.toLowerCase() === 'cimode') return true;
    const loadNotPending = (l, n) => {
      const loadState = this.services.backendConnector.state[`${l}|${n}`];
      return loadState === -1 || loadState === 0 || loadState === 2;
    };
    if (options.precheck) {
      const preResult = options.precheck(this, loadNotPending);
      if (preResult !== undefined) return preResult;
    }
    if (this.hasResourceBundle(lng, ns)) return true;
    if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
    if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
    return false;
  }
  loadNamespaces(ns, callback) {
    const deferred = defer();
    if (!this.options.ns) {
      if (callback) callback();
      return Promise.resolve();
    }
    if (isString$2(ns)) ns = [ns];
    ns.forEach(n => {
      if (this.options.ns.indexOf(n) < 0) this.options.ns.push(n);
    });
    this.loadResources(err => {
      deferred.resolve();
      if (callback) callback(err);
    });
    return deferred;
  }
  loadLanguages(lngs, callback) {
    const deferred = defer();
    if (isString$2(lngs)) lngs = [lngs];
    const preloaded = this.options.preload || [];
    const newLngs = lngs.filter(lng => preloaded.indexOf(lng) < 0 && this.services.languageUtils.isSupportedCode(lng));
    if (!newLngs.length) {
      if (callback) callback();
      return Promise.resolve();
    }
    this.options.preload = preloaded.concat(newLngs);
    this.loadResources(err => {
      deferred.resolve();
      if (callback) callback(err);
    });
    return deferred;
  }
  dir(lng) {
    if (!lng) lng = this.resolvedLanguage || (this.languages?.length > 0 ? this.languages[0] : this.language);
    if (!lng) return 'rtl';
    const rtlLngs = ['ar', 'shu', 'sqr', 'ssh', 'xaa', 'yhd', 'yud', 'aao', 'abh', 'abv', 'acm', 'acq', 'acw', 'acx', 'acy', 'adf', 'ads', 'aeb', 'aec', 'afb', 'ajp', 'apc', 'apd', 'arb', 'arq', 'ars', 'ary', 'arz', 'auz', 'avl', 'ayh', 'ayl', 'ayn', 'ayp', 'bbz', 'pga', 'he', 'iw', 'ps', 'pbt', 'pbu', 'pst', 'prp', 'prd', 'ug', 'ur', 'ydd', 'yds', 'yih', 'ji', 'yi', 'hbo', 'men', 'xmn', 'fa', 'jpr', 'peo', 'pes', 'prs', 'dv', 'sam', 'ckb'];
    const languageUtils = this.services?.languageUtils || new LanguageUtil(get$1());
    return rtlLngs.indexOf(languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf('-arab') > 1 ? 'rtl' : 'ltr';
  }
  static createInstance() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let callback = arguments.length > 1 ? arguments[1] : undefined;
    return new I18n(options, callback);
  }
  cloneInstance() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
    const forkResourceStore = options.forkResourceStore;
    if (forkResourceStore) delete options.forkResourceStore;
    const mergedOptions = {
      ...this.options,
      ...options,
      ...{
        isClone: true
      }
    };
    const clone = new I18n(mergedOptions);
    if (options.debug !== undefined || options.prefix !== undefined) {
      clone.logger = clone.logger.clone(options);
    }
    const membersToCopy = ['store', 'services', 'language'];
    membersToCopy.forEach(m => {
      clone[m] = this[m];
    });
    clone.services = {
      ...this.services
    };
    clone.services.utils = {
      hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
    };
    if (forkResourceStore) {
      const clonedData = Object.keys(this.store.data).reduce((prev, l) => {
        prev[l] = {
          ...this.store.data[l]
        };
        return Object.keys(prev[l]).reduce((acc, n) => {
          acc[n] = {
            ...prev[l][n]
          };
          return acc;
        }, {});
      }, {});
      clone.store = new ResourceStore(clonedData, mergedOptions);
      clone.services.resourceStore = clone.store;
    }
    clone.translator = new Translator(clone.services, mergedOptions);
    clone.translator.on('*', function (event) {
      for (var _len6 = arguments.length, args = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
        args[_key6 - 1] = arguments[_key6];
      }
      clone.emit(event, ...args);
    });
    clone.init(mergedOptions, callback);
    clone.translator.options = mergedOptions;
    clone.translator.backendConnector.services.utils = {
      hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
    };
    return clone;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const instance = I18n.createInstance();
instance.createInstance = I18n.createInstance;

instance.createInstance;
instance.dir;
instance.init;
instance.loadResources;
instance.reloadResources;
instance.use;
instance.changeLanguage;
instance.getFixedT;
instance.t;
instance.exists;
instance.setDefaultNamespace;
instance.hasLoadedNamespace;
instance.loadNamespaces;
instance.loadLanguages;

const warn = (i18n, code, msg, rest) => {
  const args = [msg, {
    code,
    ...(rest || {})
  }];
  if (i18n?.services?.logger?.forward) {
    return i18n.services.logger.forward(args, 'warn', 'react-i18next::', true);
  }
  if (isString$1(args[0])) args[0] = `react-i18next:: ${args[0]}`;
  if (i18n?.services?.logger?.warn) {
    i18n.services.logger.warn(...args);
  } else if (console?.warn) {
    console.warn(...args);
  }
};
const alreadyWarned = {};
const warnOnce = (i18n, code, msg, rest) => {
  if (isString$1(msg) && alreadyWarned[msg]) return;
  if (isString$1(msg)) alreadyWarned[msg] = new Date();
  warn(i18n, code, msg, rest);
};
const loadedClb = (i18n, cb) => () => {
  if (i18n.isInitialized) {
    cb();
  } else {
    const initialized = () => {
      setTimeout(() => {
        i18n.off('initialized', initialized);
      }, 0);
      cb();
    };
    i18n.on('initialized', initialized);
  }
};
const loadNamespaces = (i18n, ns, cb) => {
  i18n.loadNamespaces(ns, loadedClb(i18n, cb));
};
const loadLanguages = (i18n, lng, ns, cb) => {
  if (isString$1(ns)) ns = [ns];
  if (i18n.options.preload && i18n.options.preload.indexOf(lng) > -1) return loadNamespaces(i18n, ns, cb);
  ns.forEach(n => {
    if (i18n.options.ns.indexOf(n) < 0) i18n.options.ns.push(n);
  });
  i18n.loadLanguages(lng, loadedClb(i18n, cb));
};
const hasLoadedNamespace = (ns, i18n, options = {}) => {
  if (!i18n.languages || !i18n.languages.length) {
    warnOnce(i18n, 'NO_LANGUAGES', 'i18n.languages were undefined or empty', {
      languages: i18n.languages
    });
    return true;
  }
  return i18n.hasLoadedNamespace(ns, {
    lng: options.lng,
    precheck: (i18nInstance, loadNotPending) => {
      if (options.bindI18n?.indexOf('languageChanging') > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
    }
  });
};
const isString$1 = obj => typeof obj === 'string';
const isObject$2 = obj => typeof obj === 'object' && obj !== null;

const matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
const htmlEntities = {
  '&amp;': '&',
  '&#38;': '&',
  '&lt;': '<',
  '&#60;': '<',
  '&gt;': '>',
  '&#62;': '>',
  '&apos;': "'",
  '&#39;': "'",
  '&quot;': '"',
  '&#34;': '"',
  '&nbsp;': ' ',
  '&#160;': ' ',
  '&copy;': '©',
  '&#169;': '©',
  '&reg;': '®',
  '&#174;': '®',
  '&hellip;': '…',
  '&#8230;': '…',
  '&#x2F;': '/',
  '&#47;': '/'
};
const unescapeHtmlEntity = m => htmlEntities[m];
const unescape = text => text.replace(matchHtmlEntity, unescapeHtmlEntity);

let defaultOptions$1 = {
  bindI18n: 'languageChanged',
  bindI18nStore: '',
  transEmptyNodeValue: '',
  transSupportBasicHtmlNodes: true,
  transWrapTextNodes: '',
  transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p'],
  useSuspense: true,
  unescape
};
const setDefaults = (options = {}) => {
  defaultOptions$1 = {
    ...defaultOptions$1,
    ...options
  };
};
const getDefaults = () => defaultOptions$1;

let i18nInstance;
const setI18n = instance => {
  i18nInstance = instance;
};
const getI18n = () => i18nInstance;

const initReactI18next = {
  type: '3rdParty',
  init(instance) {
    setDefaults(instance.options.react);
    setI18n(instance);
  }
};

const I18nContext = createContext();
class ReportNamespaces {
  constructor() {
    this.usedNamespaces = {};
  }
  addUsedNamespaces(namespaces) {
    namespaces.forEach(ns => {
      if (!this.usedNamespaces[ns]) this.usedNamespaces[ns] = true;
    });
  }
  getUsedNamespaces() {
    return Object.keys(this.usedNamespaces);
  }
}

const usePrevious = (value, ignore) => {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  }, [value, ignore]);
  return ref.current;
};
const alwaysNewT = (i18n, language, namespace, keyPrefix) => i18n.getFixedT(language, namespace, keyPrefix);
const useMemoizedT = (i18n, language, namespace, keyPrefix) => useCallback(alwaysNewT(i18n, language, namespace, keyPrefix), [i18n, language, namespace, keyPrefix]);
const useTranslation = (ns, props = {}) => {
  const {
    i18n: i18nFromProps
  } = props;
  const {
    i18n: i18nFromContext,
    defaultNS: defaultNSFromContext
  } = useContext(I18nContext) || {};
  const i18n = i18nFromProps || i18nFromContext || getI18n();
  if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new ReportNamespaces();
  if (!i18n) {
    warnOnce(i18n, 'NO_I18NEXT_INSTANCE', 'useTranslation: You will need to pass in an i18next instance by using initReactI18next');
    const notReadyT = (k, optsOrDefaultValue) => {
      if (isString$1(optsOrDefaultValue)) return optsOrDefaultValue;
      if (isObject$2(optsOrDefaultValue) && isString$1(optsOrDefaultValue.defaultValue)) return optsOrDefaultValue.defaultValue;
      return Array.isArray(k) ? k[k.length - 1] : k;
    };
    const retNotReady = [notReadyT, {}, false];
    retNotReady.t = notReadyT;
    retNotReady.i18n = {};
    retNotReady.ready = false;
    return retNotReady;
  }
  if (i18n.options.react?.wait) warnOnce(i18n, 'DEPRECATED_OPTION', 'useTranslation: It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.');
  const i18nOptions = {
    ...getDefaults(),
    ...i18n.options.react,
    ...props
  };
  const {
    useSuspense,
    keyPrefix
  } = i18nOptions;
  let namespaces = defaultNSFromContext || i18n.options?.defaultNS;
  namespaces = isString$1(namespaces) ? [namespaces] : namespaces || ['translation'];
  i18n.reportNamespaces.addUsedNamespaces?.(namespaces);
  const ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every(n => hasLoadedNamespace(n, i18n, i18nOptions));
  const memoGetT = useMemoizedT(i18n, props.lng || null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
  const getT = () => memoGetT;
  const getNewT = () => alwaysNewT(i18n, props.lng || null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
  const [t, setT] = useState(getT);
  let joinedNS = namespaces.join();
  if (props.lng) joinedNS = `${props.lng}${joinedNS}`;
  const previousJoinedNS = usePrevious(joinedNS);
  const isMounted = useRef(true);
  useEffect(() => {
    const {
      bindI18n,
      bindI18nStore
    } = i18nOptions;
    isMounted.current = true;
    if (!ready && !useSuspense) {
      if (props.lng) {
        loadLanguages(i18n, props.lng, namespaces, () => {
          if (isMounted.current) setT(getNewT);
        });
      } else {
        loadNamespaces(i18n, namespaces, () => {
          if (isMounted.current) setT(getNewT);
        });
      }
    }
    if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) {
      setT(getNewT);
    }
    const boundReset = () => {
      if (isMounted.current) setT(getNewT);
    };
    if (bindI18n) i18n?.on(bindI18n, boundReset);
    if (bindI18nStore) i18n?.store.on(bindI18nStore, boundReset);
    return () => {
      isMounted.current = false;
      if (i18n) bindI18n?.split(' ').forEach(e => i18n.off(e, boundReset));
      if (bindI18nStore && i18n) bindI18nStore.split(' ').forEach(e => i18n.store.off(e, boundReset));
    };
  }, [i18n, joinedNS]);
  useEffect(() => {
    if (isMounted.current && ready) {
      setT(getT);
    }
  }, [i18n, keyPrefix, ready]);
  const ret = [t, i18n, ready];
  ret.t = t;
  ret.i18n = i18n;
  ret.ready = ready;
  if (ready) return ret;
  if (!ready && !useSuspense) return ret;
  throw new Promise(resolve => {
    if (props.lng) {
      loadLanguages(i18n, props.lng, namespaces, () => resolve());
    } else {
      loadNamespaces(i18n, namespaces, () => resolve());
    }
  });
};

function I18nextProvider({
  i18n,
  defaultNS,
  children
}) {
  const value = useMemo(() => ({
    i18n,
    defaultNS
  }), [i18n, defaultNS]);
  return createElement(I18nContext.Provider, {
    value
  }, children);
}

var savedSearch$3 = {
	actions: {
		alertTitle: "Titel des Suchauftrags",
		disabled: "Aus",
		edit: "Bearbeiten",
		editAlert: "Suchauftrag bearbeiten",
		enabled: "Ein",
		listings: "Treffer anzeigen",
		update: "Speichern"
	},
	alert: {
		title: "Gespeicherte Suchen"
	},
	alertActivated: {
		action: "Suche gespeichert"
	},
	alertAlertsTab: {
		action: "Benachrichtigungen suchen"
	},
	alertAppNotifications: {
		option: "Push-Benachrichtigungen"
	},
	alertContinue: {
		action: "Fortfahren"
	},
	alertCreate: {
		action: "Suche speichern",
		text: "Erhalte Benachrichtigungen, wenn eine neue Immobilie deinen Kriterien entspricht"
	},
	alertDelete: {
		action: "Löschen"
	},
	alertDeletePopUp: {
		text: "Du hast die maximale Anzahl gespeicherter Suchen erreicht. Lösche mindestens eine, um fortzufahren.",
		title: "Gespeicherte Suche löschen"
	},
	alertEdit: {
		title: "Meine gespeicherte Suche bearbeiten"
	},
	alertEmail: {
		actionCreate: "",
		created: {
			action: "Treffer azeigen",
			text: "Du erhältst ab sofort neue Vorschläge an die folgende E-Mail-Adresse:",
			title: "Deine E-Mail-Benachrichtigung wurde erfolgreich eingerichtet."
		},
		disclaimer: {
			link: "",
			text: ""
		},
		invalid: "Bitte geben Sie eine gütige E-Mail-Adresse ein",
		option: "E-Mail",
		text: ""
	},
	alertEmptyState: {
		text: "Werde benachrichtigt, wenn neue Immobilien deinen Kriterien entsprechen",
		title: "Keine gespeicherte Suche"
	},
	alertFavouritesTab: {
		action: "Wunschliste"
	},
	alertForceLogin: {
		text: "Melde dich an, um deine gespeicherten Suchen zu verwalten. Du wirst benachrichtigt, wenn neue Anzeigen deinen Kriterien entsprechen.",
		title: "Melde dich an, um deine gespeicherten Suchen zu verwalten"
	},
	alertInternetError: {
		text: "Schalte deine mobilen Daten ein oder stelle eine Verbindung zu einem WLAN-Netzwerk her",
		title: "Keine Internetverbindung"
	},
	alertInvalid: {
		text: "Ungültige Suchkriterien"
	},
	alertLoading: {
		title: "Deine gespeicherten Suchen werden geladen"
	},
	alertRetry: {
		action: "Erneut versuchen"
	},
	alertSave: {
		action: "Suche speichern"
	},
	alertSee: {
		action: "Immobilien anzeigen"
	},
	alertSetup: {
		title: "Erhalte Benachrichtigungen über neue Immobilien"
	},
	alertSignin: {
		action: "Anmelden "
	},
	alertSignup: {
		action: "Registrieren"
	},
	alertTechnicalError: {
		text: "Es gibt zurzeit ein paar Probleme. Bitte warte ein paar Minuten und versuche es erneut.",
		title: "Etwas ist schiefgelaufen"
	},
	alertValidate: {
		action: "Bestätigen"
	},
	alertsPaused: {
		text: "Alle Benachrichtigungen wurden deaktiviert. Du kannst sie jederzeit wieder aktivieren."
	},
	anonymousRegister: {
		action: "Anmelden",
		text: "Melden Sie sich an, um Ihre Suchaufträge weiter zu bearbeiten.",
		title: "Anmelden und Vorteile nutzen"
	},
	cancel: {
		action: "Abbrechen"
	},
	createAlertsByHitting: {
		text: "Du kannst eine Suche über die Suchergebnisseite speichern."
	},
	criterias: {
		area: {
			title: "Fläche"
		},
		common: {
			range: {
				label: {
					max: "Max",
					min: "Min"
				}
			}
		},
		context_switch: {
			commercial: "Gewerbe",
			residential: "Wohnen"
		},
		estate_subtype: {
			agriculture_forestry: {
				checkbox: {
					agriculture_company: "Landwirtschaftlicher Betrieb",
					farm_ranch: "Bauernhof",
					forestry: "Forstwirtschaft",
					gardening_orchard: "Gartenarbeit / Obstgarten",
					hunting_fishing: "Jagd und Fischerei",
					riding: "Reiterhof",
					winery: "Weingut"
				},
				title: "Objektart"
			},
			apartment: {
				checkbox: {
					loft: "Loft",
					multi_storey: "Mehrgeschosswohnung",
					penthouse: "Penthouse",
					studio: "Studio",
					terrace: "Terrassenwohnung"
				},
				title: "Wohnungstyp"
			},
			gastronomy_hotel: {
				checkbox: {
					cafe_bar_pub: "Café / Bar / Kneipe",
					club_discotheque: "Club / Diskothek",
					hotel_pension: "Hotel / Pension",
					restaurant: "Restaurant"
				},
				title: "Objektart"
			},
			house: {
				checkbox: {
					bungalow: "Bungalow",
					castle: "Schloss",
					chalet: "Chalet",
					farmhouse: "Bauernhaus",
					finca: "Finca",
					manor_house: "Herrenhaus",
					multi_family_house: "Mehrfamilienhaus",
					rustico: "Rustico",
					semidetached_house: "Doppelhaushälfte",
					single_family_house: "Einfamilienhaus",
					terrace_house: "Reihenhaus",
					town_house: "Stadthaus",
					villa: "Villa"
				},
				title: "Haustyp"
			},
			office: {
				checkbox: {
					atelier: "Atelier",
					coworking: "Coworking",
					living_and_commercial_building: "Wohn- und Geschäftshaus",
					medical: "Praxis",
					office: "Büro"
				},
				title: "Objektart"
			},
			parking: {
				checkbox: {
					carport: "Carport",
					duplex: "Doppelgarage",
					garage: "Garage",
					outside: "Außenstellplatz",
					underground_garage: "Tiefgarage",
					underground_parking_space: "Tiefgaragenstellplatz"
				},
				title: "Stellplatztyp"
			},
			plot: {
				checkbox: {
					commercial: "Gewerbliche Nutzung",
					leisure_facility: "Freizeit",
					living: "Wohnen"
				},
				title: "Grundstücksart"
			},
			storage_production: {
				checkbox: {
					garage_repair: "Werkstatt",
					logistic_center: "Logistik-Center",
					miscellaneous_storage: "Sonstige Lagerung",
					outdoor_space: "Außenfläche",
					production_hall: "Industriehalle",
					warehouse_hall: "Lagerhalle"
				},
				title: "Objektart"
			},
			trading: {
				checkbox: {
					kiosk: "Kiosk",
					sales_area: "Verkaufsfläche",
					shopping_centre: "Einkaufszentrum",
					showroom_space: "Ausstellungsfläche",
					store: "Laden Sie"
				},
				title: "Objektart"
			}
		},
		features: {
			checkbox: {
				attic_apartment: "Dachgeschoss-Wohnung",
				balcony_terrace: "Balkon / Terrasse",
				bathroom_with_bathtub: "Badezimmer mit Badewanne",
				bathroom_with_window: "Bad mit Fenster",
				built_in_kitchen: "Einbauküche",
				cellar: "Keller",
				certificate_of_eligibility_needed: "mit Wohnberechtigungsschein",
				elevator: "Aufzug",
				free_of_commission: "Provisionsfrei",
				furnished: "Vollständig möbliert",
				garden: "Garten",
				no_attic_apartment: "Kein Dachgeschoss",
				no_ground_floor: "Kein Erdgeschoss",
				parking_garage: "Parkplatz / Garage",
				pets_allowed: "Haustiere erlaubt",
				reduced_mobility_access: "Barrierefrei",
				unfurnished: "Unmöbliert",
				vacant: "Frei / Nicht vermietet"
			},
			subtitle: {
				accessibility: "Erreichbarkeit",
				furnished_unfurnished: "Möbliert/unmöbliert",
				indoor: "Innenbereich",
				usage: "Verwendung"
			},
			title: {
				features_excluded: "Ausschlusskriterien",
				features_included: "Eigenschaften",
				foreclosure: "Zwangsversteigerung",
				new_builds: "Neubauprojekte",
				subsidizing_housing: "Wohnberechtigungsschein"
			}
		},
		floor: "Geschoss",
		floors: {
			checkbox: {
				ground_floor: "Erdgeschoss",
				no_ground_floor: "Kein Erdgeschoss",
				other_floors: "Andere Geschosse"
			}
		},
		living_area: {
			input_field: {
				surface_type: "m²"
			},
			title: "Wohnfläche"
		},
		location: {
			circles: "{{placeName}} +{{radius}} {{radiusUnit}}",
			circles_prefixed: "in {{placeName}} +{{radius}} {{radiusUnit}}",
			places_one: "{{placeName}}",
			places_other: "{{placeName}} (+{{count}})",
			places_prefixed_one: "in {{placeName}}",
			places_prefixed_other: "in {{placeName}} (+{{count}})",
			places_prefixed_zero: "",
			polygons: "persönlichem Kartenausschnitt",
			polygons_prefixed: "in persönlichem Kartenausschnitt",
			travels: "{{duration}} min {{mode}} von {{placeName}}",
			travels_prefixed: "bei {{duration}} min {{mode}} von {{placeName}}"
		},
		plot_area: {
			input_field: {
				surface_type: "m²"
			},
			title: "Grundstücksfläche"
		},
		project_type: {
			checkbox: {
				foreclosure_sale: "Zwangsversteigerung",
				investment: "Anlageobjekte",
				new_builds: "Neubauprojekte",
				resale: "Wiederverkauf",
				shared_flats: "Wohngemeinschaften",
				stock: "Lagerbestand",
				temporary_living: "Vorübergehendes Wohnen"
			},
			title: "Projekttyp"
		}
	},
	deleteAlertConfirmation: {
		text: "Du wirst keine weiteren Benachrichtigungen für neue Suchtreffer erhalten",
		title: "Bist du sicher, dass du diese gespeicherte Suche löschen möchtest?"
	},
	distribution_type: {
		buy: "Kauf",
		compulsory_auction: "Zwangsversteigerung",
		rent: "Miete"
	},
	emailResubscribed: {
		action: "Weitersuchen",
		text: "Danke, dass du bei uns geblieben bist.",
		title: "Du hast die Benachrichtigungen für deinen Suchauftrag wieder aktiviert."
	},
	enums: {
		distributionType: {
			BUY: "Kauf",
			BUY_AUCTION: "Kauf",
			BUY_AUCTION_prefixed: "zum Kauf",
			BUY_prefixed: "zum Kauf",
			COMPULSORY_AUCTION: "Zwangsversteigerung",
			COMPULSORY_AUCTION_prefixed: "zur Zwangsversteigerung",
			RENT: "Miete",
			RENT_prefixed: "zur Miete"
		},
		estateType: {
			AGRICULTURE_FORESTRY: "Land-/Forstwirtschaft",
			AGRICULTURE_FORESTRY_prefixed: "eine Land-/Forstwirtschaft",
			APARTMENT: "Wohnung",
			APARTMENT_prefixed: "eine Wohnung",
			BUILDING: "Gebäude",
			BUILDING_prefixed: "ein Gebäude",
			GASTRONOMY_HOTEL: "Gastronomie/Hotel",
			GASTRONOMY_HOTEL_prefixed: "eine Gastronomie/Hotel",
			HOUSE: "Haus",
			HOUSE_prefixed: "ein Haus",
			MISCELLANEOUS: "Sonstiges",
			MISCELLANEOUS_prefixed: "Sonstiges",
			OFFICE: "Büro-/Praxisfläche",
			OFFICE_prefixed: "eine Büro-/Praxisfläche",
			PARKING: "Parkplatz",
			PARKING_prefixed: "ein Parkplatz",
			PLOT: "Grundstück",
			PLOT_prefixed: "ein Grundstück",
			PROJECT: "Bauprojekt",
			PROJECT_prefixed: "ein Bauprojekt",
			SENIOR: "Seniorenwohnung",
			SENIOR_prefixed: "eine Seniorenwohnung",
			STORAGE_PRODUCTION: "Halle/Industriefläche",
			STORAGE_PRODUCTION_prefixed: "eine Halle/Industriefläche",
			TRADING: "Ladenfläche",
			TRADING_prefixed: "eine Ladenfläche"
		},
		travelMode: {
			BIKE: "Fahrrad",
			BIKE_prefixed: "mit dem Fahrrad",
			CAR: "Auto",
			CAR_prefixed: "mit dem Auto",
			TRANSIT: "ÖPNV",
			TRANSIT_prefixed: "mit dem ÖPNV",
			WALK: "zu Fuß",
			WALK_prefixed: "zu Fuß"
		}
	},
	errorCreate: {
		text: "Deine Suche konnte nicht gespeichert werden. Bitte versuche es später noch einmal."
	},
	errorDelete: {
		text: "Deine gespeicherte Suche kann nicht gelöscht werden."
	},
	errorPage: {
		action: "Zu den Suchbenachrichtigungen",
		text: "Der Link, dem Sie gefolgt sind, ist möglicherweise defekt, oder die Seite wurde entfernt.",
		title: "Diese Seite ist nicht verfügbar."
	},
	errorPageGeneric: {
		text: "Leider konnte diese Seite nicht geladen werden, bitte versuchen Sie es später erneut.",
		title: "Es ist ein Fehler aufgetreten"
	},
	errorTechnicalRetry: {
		text: "Es ist ein technischer Fehler aufgetreten. Bitte versuche es später noch einmal."
	},
	errorUpdate: {
		text: "Deine gespeicherte Suche kann nicht aktualisiert werden. Bitte versuche es später noch einmal."
	},
	estate_type: {
		agriculture_forestry: "Land- / Forstwirtschaft",
		apartment: "Wohnung",
		gastronomy_hotel: "Gastronomie / Hotel",
		house: "Haus",
		house_apartment: "Haus oder Wohnung",
		investment_property: "Renditeobjekt",
		miscellaneous: "Sonstiges",
		office: "Büro- / Praxisfläche",
		parking: "Parkplatz",
		plot: "Grundstück",
		project: "Projekt",
		shared_apartment: "Wohngemeinschaft",
		storage_production: "Halle / Industriefläche",
		temporary_living: "Wohnen auf Zeit",
		trading: "Ladenfläche"
	},
	geometry_location: {
		title: "persönlicher Kartenausschnitt"
	},
	getAlerts: {
		action: "Suche speichern"
	},
	goBack: {
		action: "Zurück"
	},
	goToSearch: {
		action: "Gehe zur Suche"
	},
	hint: {
		"default": {
			text: "Benachrichtigungen aktivieren, um sofort über neue Immobilien informiert zu werden, die den Suchkriterien entsprechen.",
			title: "Suchauftrag einrichten"
		},
		travel_time: {
			text: "Das Speichern Ihrer Suche ist jetzt möglich!",
			title: "Neue Funktion"
		}
	},
	hpMfe: {
		mvp: {
			blockText: "Sollen wir weitermachen?"
		},
		noMore: {
			firstAction: "Weitere Unterkünfte anzeigen",
			firstText: "Interessiert an weiteren Treffern?",
			secondAction: "Neue Suche starten",
			secondText: "Dann kannst du jetzt..."
		},
		seeMore: {
			action: "Mehr laden",
			text: "{{number}} weitere Treffer für dich"
		},
		text: "Neueste Treffer zu deinem Suchauftrag",
		title: "Ihre letzte gespeicherte Suche"
	},
	iconCriteria: {
		rooms: {
			text: "Zi."
		}
	},
	intermediaryMatchingMandate: {
		errors: {
			consent: "",
			email: "",
			phoneNumber: "",
			required: "",
			string: ""
		},
		informations: "",
		labels: {
			consent: "",
			email: "",
			message: "",
			name: "",
			phoneNumber: ""
		},
		legal: {
			text: {
				first: "",
				fourth: "",
				link: {
					first: "AVIV Group",
					second: "Datenschutzrichtlinie.",
					third: "Allgemeine Nutzungsbedingungen"
				},
				second: "",
				third: ""
			}
		},
		placeholders: {
			message: "",
			phoneNumber: ""
		},
		submit: "",
		success: "",
		suggestions: {
			text: "",
			title: ""
		}
	},
	loader_text: "Seite wird geladen",
	notifications: {
		recommendations: "Empfehlungen",
		title: "Benachrichtigungen",
		tooltip: "Aktualisiere deine Einstellungen und erhalte Empfehlungen basierend auf deinem Suchauftrag"
	},
	notificationsEdit: {
		email: "E-Mail-Benachrichtigungen",
		frequency: {
			daily: "Einmal täglich",
			never: "Aus",
			realtime: "In Echtzeit"
		},
		recommendation: {
			text: "Erhalten Sie alternative Angebote zu Ihren vordefinierten Suchkriterien",
			title: "Empfehlungen"
		},
		title: "Benachrichtigungen erhalten",
		trigger: "Benachrichtigungen"
	},
	pauseAllNotifications: {
		action: "Alle Benachrichtigungen deaktiviert."
	},
	resubscribe: {
		action: "Wieder aktivieren"
	},
	title: {
		circles: "{{estateTypes, list(type: disjunction)}} $t(savedSearch.enums.distributionType.{{distributionType}}_prefixed) in {{placeName}} +{{radius}} {{radiusUnit}}",
		"default": "{{estateTypes, list(type: disjunction)}} $t(savedSearch.enums.distributionType.{{distributionType}}_prefixed)",
		location: "{{estateTypes, list(type: disjunction)}} {{distributionType}} {{location}}",
		places: "{{estateTypes, list(type: disjunction)}} $t(savedSearch.enums.distributionType.{{distributionType}}_prefixed) $t(savedSearch.criterias.location.places, { \"context\": \"prefixed\", \"placeName\":  \"{{placeName}}\", \"count\": {{placeCount}} })",
		polygons: "{{estateTypes, list(type: disjunction)}} $t(savedSearch.enums.distributionType.{{distributionType}}_prefixed) in persönlichem Kartenausschnitt",
		travels: "{{estateTypes, list(type: disjunction)}} $t(savedSearch.enums.distributionType.{{distributionType}}_prefixed) {{duration}} min {{mode}} von {{placeName}}"
	},
	unsubscribedEmailAlertSuccessfully: {
		title: "Du hast die Benachrichtigungen für deinen Suchauftrag \"{{alertName}}\" erfolgreich deaktiviert."
	},
	youCanAlso: {
		title: "Du kannst sie außerdem:"
	}
};
var savedSearch_alertClose_action$3 = "Schließen";
var savedSearch_alertCreated_text$3 = "Du wirst per E-Mail über neue Immobilien benachrichtigt.";
var savedSearch_alertDelete_text$3 = "Deine gespeicherte Suche wurde gelöscht.";
var savedSearch_alertNotCreated_text$3 = "Die Suche kann nicht gespeichert werden.";
var savedSearch_alertUpdated_text$3 = "Deine Suche wurde gespeichert.";
var savedSearch_buttonCard_title$3 = "Benachrichtigungen erhalten";
var savedSearch_deleteAlert_title$3 = "Suche speichern";
var savedSearch_duplicateError_text$3 = "Dieser Suchauftrag existiert bereits";
var savedSearch_duplicatePlaceId_text$3 = "Leider gab es ein Problem mit dem gewählten Suchbereich, bitte versuche es später noch einmal.";
var savedSearch_errorSameSearchCriteria_text$3 = "Du hast bereits eine gespeicherte Suche mit denselben Suchkriterien.";
var savedSearch_errorTechnical_text$3 = "Es ist ein technischer Fehler aufgetreten.";
var savedSearch_locationTooLarge_text$3 = "Suchgebiet zu groß, bitte reduziere die Anzahl der Standorte";
var savedSearch_locationTooSmall_text$3 = "Der ausgewählte Suchbereich ist zu klein.";
var savedSearch_niceJob_text$3 = "Jetzt kannst du die neue Suche speichern.";
var savedSearch_niceJob_title$3 = "Deine gespeicherte Suche wurde gelöscht.";
var savedSearch_polygonAlert_text$3 = "Eine Umkreissuche kann leider nicht gespeichert werden";
var deTranslations = {
	savedSearch: savedSearch$3,
	savedSearch_alertClose_action: savedSearch_alertClose_action$3,
	savedSearch_alertCreated_text: savedSearch_alertCreated_text$3,
	savedSearch_alertDelete_text: savedSearch_alertDelete_text$3,
	savedSearch_alertNotCreated_text: savedSearch_alertNotCreated_text$3,
	savedSearch_alertUpdated_text: savedSearch_alertUpdated_text$3,
	savedSearch_buttonCard_title: savedSearch_buttonCard_title$3,
	savedSearch_deleteAlert_title: savedSearch_deleteAlert_title$3,
	savedSearch_duplicateError_text: savedSearch_duplicateError_text$3,
	savedSearch_duplicatePlaceId_text: savedSearch_duplicatePlaceId_text$3,
	savedSearch_errorSameSearchCriteria_text: savedSearch_errorSameSearchCriteria_text$3,
	savedSearch_errorTechnical_text: savedSearch_errorTechnical_text$3,
	savedSearch_locationTooLarge_text: savedSearch_locationTooLarge_text$3,
	savedSearch_locationTooSmall_text: savedSearch_locationTooSmall_text$3,
	savedSearch_niceJob_text: savedSearch_niceJob_text$3,
	savedSearch_niceJob_title: savedSearch_niceJob_title$3,
	savedSearch_polygonAlert_text: savedSearch_polygonAlert_text$3,
	"savedSearch_there’sNoRoomLeft_text": "Du hast die maximale Anzahl von {{maxAlertsCount}} gespeicherten Suchen erreicht. Lösche mindestens eine, um fortzufahren.",
	"savedSearch_there’sNoRoomLeft_title": "Gespeicherte Suche löschen"
};

var savedSearch$2 = {
	actions: {
		alertTitle: "Alert Title",
		disabled: "Disabled",
		edit: "Edit",
		editAlert: "Edit Alert",
		enabled: "Enabled",
		listings: "See listings",
		update: "Save"
	},
	alert: {
		title: "Alerts"
	},
	alertActivated: {
		action: "Alert enabled"
	},
	alertAlertsTab: {
		action: "Search Alerts"
	},
	alertAppNotifications: {
		option: "App notifications"
	},
	alertContinue: {
		action: "Continue"
	},
	alertCreate: {
		action: "Create an alert",
		text: "Get alerts when a new property match your criterias"
	},
	alertDelete: {
		action: "Delete"
	},
	alertDeletePopUp: {
		text: "You have reached the maximum number of alerts. Delete at least one to continue.",
		title: "Delete an alert"
	},
	alertEdit: {
		title: "Edit my alert"
	},
	alertEmail: {
		actionCreate: "Create a saved search",
		created: {
			action: "See search results",
			text: "You will now receive new property suggestions to the following email address:",
			title: "Your email alert has been successfully created!"
		},
		disclaimer: {
			link: "click here",
			text: "Digital Classifieds France processes your data in order to manage your request to alert new real estate advertisements by e-mail. To find out more and exercise your rights, "
		},
		invalid: "Please enter a valid email address",
		option: "Email",
		text: "Enter your email to receive all new personalized real estate ads and the selection of professionals."
	},
	alertEmptyState: {
		text: "Get notified when new classifieds match your criteria.",
		title: "No alert"
	},
	alertFavouritesTab: {
		action: "Wishlist"
	},
	alertForceLogin: {
		text: "Log in to set up your alerts. You will get notified when new classifieds match your criteria.",
		title: "Log in to manage your alerts"
	},
	alertInternetError: {
		text: "Turn on your mobile data or connect to a Wi-Fi network.",
		title: "No internet connection"
	},
	alertInvalid: {
		text: "Invalid search criteria"
	},
	alertLoading: {
		title: "Alerts loading"
	},
	alertRetry: {
		action: "Retry"
	},
	alertSave: {
		action: "Create the alert"
	},
	alertSee: {
		action: "See listings"
	},
	alertSetup: {
		title: "Get notified of new classifieds"
	},
	alertSignin: {
		action: "Log in "
	},
	alertSignup: {
		action: "Sign up"
	},
	alertTechnicalError: {
		text: "We are experiencing some difficulties. Please wait a few minutes and try again.",
		title: "Something went wrong"
	},
	alertValidate: {
		action: "Validate"
	},
	alertsPaused: {
		text: "Notifications on all alerts have been paused. You can reactivate them at anytime."
	},
	anonymousRegister: {
		action: "Register",
		text: "Only then will you be able to see all your saved searches.",
		title: "Please login"
	},
	cancel: {
		action: "Cancel"
	},
	createAlertsByHitting: {
		text: "You can create an alert from the search result page."
	},
	criterias: {
		area: {
			title: "Area"
		},
		common: {
			range: {
				label: {
					max: "Max",
					min: "Min"
				}
			}
		},
		context_switch: {
			commercial: "For my business",
			residential: "For me"
		},
		estate_subtype: {
			agriculture_forestry: {
				checkbox: {
					agriculture_company: "Agriculture company",
					farm_ranch: "Farm / Ranch",
					forestry: "Forestry",
					gardening_orchard: "Gardening / Orchard",
					hunting_fishing: "Hunting / Fishing",
					riding: "Riding",
					winery: "Winery"
				},
				title: "Type of estate"
			},
			apartment: {
				checkbox: {
					loft: "Loft",
					multi_storey: "Multi Storey",
					penthouse: "Penthouse",
					studio: "Studio",
					terrace: "Terrace"
				},
				title: "Type of apartment"
			},
			gastronomy_hotel: {
				checkbox: {
					cafe_bar_pub: "Café / Bar / Pub",
					club_discotheque: "Club / Discotheque",
					hotel_pension: "Hotel / Pension",
					restaurant: "Restaurant"
				},
				title: "Type of estate"
			},
			house: {
				checkbox: {
					bungalow: "Bungalow",
					castle: "Castle",
					chalet: "Chalet",
					farmhouse: "Farmhouse",
					finca: "Finca",
					manor_house: "Manor house",
					multi_family_house: "Multi family house",
					rustico: "Rustico",
					semidetached_house: "Semidetached house",
					single_family_house: "Single family house",
					terrace_house: "Terrace house",
					town_house: "Town house",
					villa: "Villa"
				},
				title: "Type of house"
			},
			office: {
				checkbox: {
					atelier: "Atelier",
					coworking: "Coworking",
					living_and_commercial_building: "Living and commercial building",
					medical: "Medical",
					office: "Office"
				},
				title: "Type of office"
			},
			parking: {
				checkbox: {
					carport: "Carport",
					duplex: "Duplex",
					garage: "Garage",
					outside: "Outside parking",
					underground_garage: "Underground garage",
					underground_parking_space: "Underground parking"
				},
				title: "Type of parking"
			},
			plot: {
				checkbox: {
					commercial: "Commercial",
					leisure_facility: "Leisure facility",
					living: "Living"
				},
				title: "Type of plot"
			},
			storage_production: {
				checkbox: {
					garage_repair: "Garage / Repair",
					logistic_center: "Logistic Center",
					miscellaneous_storage: "Miscellaneous storage",
					outdoor_space: "Outdoor space",
					production_hall: "Production hall",
					warehouse_hall: "Warehouse hall"
				},
				title: "Type of estate"
			},
			trading: {
				checkbox: {
					kiosk: "Kiosk",
					sales_area: "Sales area",
					shopping_centre: "Shopping centre",
					showroom_space: "Showroom space",
					store: "Store"
				},
				title: "Type of shop"
			}
		},
		features: {
			checkbox: {
				attic_apartment: "Attic apartment",
				balcony_terrace: "Balcony / Terrace",
				bathroom_with_bathtub: "Bathroom with bathtub",
				bathroom_with_window: "Bathroom with window",
				built_in_kitchen: "Built-in kitchen",
				cellar: "Cellar",
				certificate_of_eligibility_needed: "certificate of eligibility required",
				elevator: "Elevator",
				free_of_commission: "Free of commission",
				furnished: "Fully furnished",
				garden: "Garden",
				no_attic_apartment: "No attic apartment",
				no_ground_floor: "No ground floor",
				parking_garage: "Parking / Garage",
				pets_allowed: "Pets allowed",
				reduced_mobility_access: "Reduced-mobility access",
				unfurnished: "Unfurnished",
				vacant: "Vacant / Not rented"
			},
			subtitle: {
				accessibility: "Accessibility",
				furnished_unfurnished: "Furnished / Unfurnished",
				indoor: "Indoor",
				usage: "Usage"
			},
			title: {
				features_excluded: "Features to exclude",
				features_included: "Features",
				foreclosure: "Foreclosure sale",
				new_builds: "New builds",
				subsidizing_housing: "Subsidizing housing"
			}
		},
		floor: "Floor",
		floors: {
			checkbox: {
				ground_floor: "Ground floor",
				no_ground_floor: "No ground floor",
				other_floors: "Other floors"
			}
		},
		living_area: {
			input_field: {
				surface_type: "m²"
			},
			title: "Living area"
		},
		location: {
			circles: "{{placeName}} +{{radius}} {{radiusUnit}}",
			circles_prefixed: "in {{placeName}} +{{radius}} {{radiusUnit}}",
			places_one: "{{placeName}}",
			places_other: "{{placeName}} (+{{count}})",
			places_prefixed_one: "in {{placeName}}",
			places_prefixed_other: "in {{placeName}} (+{{count}})",
			places_prefixed_zero: "",
			polygons: "personal map area",
			polygons_prefixed: "in personal map area",
			travels: "{{duration}} min {{mode}} from {{placeName}}",
			travels_prefixed: "at {{duration}} min {{mode}} from {{placeName}}"
		},
		plot_area: {
			input_field: {
				surface_type: "m²"
			},
			title: "Plot area"
		},
		project_type: {
			checkbox: {
				foreclosure_sale: "Foreclosure sale",
				investment: "Investment",
				new_builds: "New builds",
				resale: "Resale",
				shared_flats: "Shared flats",
				stock: "Stock",
				temporary_living: "Temporary living"
			},
			title: "Project type"
		}
	},
	deleteAlertConfirmation: {
		text: "You will no longer get notifications matching the criteria of this search",
		title: "Are you sure you want to delete this alert?"
	},
	distribution_type: {
		buy: "Buy",
		compulsory_auction: "Compulsory auction",
		rent: "Rent"
	},
	emailResubscribed: {
		action: "Continue searching",
		text: "Thanks for staying with us.",
		title: "You have resubscribed."
	},
	enums: {
		distributionType: {
			BUY: "buy",
			BUY_AUCTION: "buy",
			BUY_AUCTION_prefixed: "to buy",
			BUY_prefixed: "to buy",
			COMPULSORY_AUCTION: "compulsory auction",
			COMPULSORY_AUCTION_prefixed: "for compulsory auction",
			RENT: "rent",
			RENT_prefixed: "to rent"
		},
		estateType: {
			AGRICULTURE_FORESTRY: "Agriculture / Forestry",
			AGRICULTURE_FORESTRY_prefixed: "an Agriculture / Forestry",
			APARTMENT: "Apartment",
			APARTMENT_prefixed: "an Apartment",
			BUILDING: "Building",
			BUILDING_prefixed: "a Building",
			GASTRONOMY_HOTEL: "Gastronomy / Hotel",
			GASTRONOMY_HOTEL_prefixed: "a Gastronomy / Hotel",
			HOUSE: "House",
			HOUSE_prefixed: "a House",
			MISCELLANEOUS: "Miscellaneous",
			MISCELLANEOUS_prefixed: "Miscellaneous",
			OFFICE: "Office",
			OFFICE_prefixed: "an Office",
			PARKING: "Parking",
			PARKING_prefixed: "a Parking",
			PLOT: "Plot of land",
			PLOT_prefixed: "a Plot of land",
			PROJECT: "Project",
			PROJECT_prefixed: "a Project",
			SENIOR: "Senior apartment",
			SENIOR_prefixed: "a Senior apartment",
			STORAGE_PRODUCTION: "Storage / Production",
			STORAGE_PRODUCTION_prefixed: "a Storage / Production",
			TRADING: "Trading Area",
			TRADING_prefixed: "a Trading Area"
		},
		travelMode: {
			BIKE: "biking",
			BIKE_prefixed: "by biking",
			CAR: "car",
			CAR_prefixed: "by car",
			TRANSIT: "public transport",
			TRANSIT_prefixed: "by public transport",
			WALK: "walking",
			WALK_prefixed: "by walking"
		}
	},
	errorCreate: {
		text: "We were not able to create the alert. Try again later."
	},
	errorDelete: {
		text: "Can't delete your alert."
	},
	errorPage: {
		action: "Go to search alerts",
		text: "The link you followed may be broken, or the page may have been removed.",
		title: "This page isn’t available"
	},
	errorPageGeneric: {
		text: "The page is not available. Please try again later.",
		title: "An error has occured"
	},
	errorTechnicalRetry: {
		text: "A technical error has occured. Try again later."
	},
	errorUpdate: {
		text: "Can't update your alert. Try again later."
	},
	estate_type: {
		agriculture_forestry: "Agriculture / Forestry",
		apartment: "Apartment",
		gastronomy_hotel: "Gastronomy / Hotel",
		house: "House",
		house_apartment: "House / Apartment",
		investment_property: "Investment property",
		miscellaneous: "Miscellaneous",
		office: "Office",
		parking: "Parking",
		plot: "Plot of land",
		project: "Project",
		shared_apartment: "Shared apartment",
		storage_production: "Storage / Production",
		temporary_living: "Temporary living",
		trading: "Shop"
	},
	geometry_location: {
		title: "personal map area"
	},
	getAlerts: {
		action: "Create an alert"
	},
	goBack: {
		action: "Back"
	},
	goToSearch: {
		action: "Go to search"
	},
	hint: {
		"default": {
			text: "Get alerts for new properties matching your criteria.",
			title: "Set up your search alert"
		},
		travel_time: {
			text: "Saving your search is now possible!",
			title: "New feature"
		}
	},
	hpMfe: {
		mvp: {
			blockText: "Shall we continue ?"
		},
		noMore: {
			firstAction: "See more properties",
			firstText: "That's all for now !",
			secondAction: "Start a new search",
			secondText: "Now you can..."
		},
		seeMore: {
			action: "Load more",
			text: "{{number}} more properties in the selection"
		},
		text: "Latest matches based on your saved search",
		title: "Latest match based on your saved search"
	},
	iconCriteria: {
		rooms: {
			text: "ro"
		}
	},
	intermediaryMatchingMandate: {
		errors: {
			consent: "Without your consent, we cannot transmit your contact details to a selection of real estate agencies to assist you in your real estate project.",
			email: "Email is not valid",
			phoneNumber: "Phone number format is not valid",
			required: "{{field}} is required",
			string: "Wrong format"
		},
		informations: "By sending the request, you accept the Immowelt service. You will receive information based on the data you entered, the services used and the purpose of our business. You can object to this service anytime at datenschutz@immowelt.de. Further information can be found in the DataProtection policy.",
		labels: {
			consent: "I agree that my data are sent to a selection of real estate agencies proposing properties matching my alert, who could contact me by email or phone to helping me with my property project.",
			email: "Email",
			message: "Your message",
			name: "Name",
			phoneNumber: "Phone number"
		},
		legal: {
			text: {
				first: "{{upperLocal}} - Digital Classifieds {{country}} processes your data in order to transmit it to the indicated advertiser. In this context, we will transmit this data to our entities",
				fourth: "apply.",
				link: {
					first: "AVIV Group",
					second: "Privacy Policy.",
					third: "General Conditions of Use"
				},
				second: "and our external service providers. You can withdraw your consent to the processing of optional data at any time. For more information about your rights and your data, see our",
				third: "By clicking on \"Confirm my request\", our"
			}
		},
		placeholders: {
			message: "Provide details to help our experts understand exactly what you’re looking for.",
			phoneNumber: "+33 XXX XXX XXX"
		},
		submit: "Confirm my request",
		success: "Your contact request has been sent successfully.",
		suggestions: {
			text: "Receive direct proposals from trusted agents including unpublished listings tailored to your preferences.",
			title: "Get property suggestions from agents"
		}
	},
	loader_text: "Page is loading",
	notifications: {
		recommendations: "Recommendations",
		title: "Notifications",
		tooltip: "Update your notification settings and get alternative properties based on your search alert"
	},
	notificationsEdit: {
		email: "Email notifications",
		frequency: {
			daily: "Once a day",
			never: "Disabled",
			realtime: "In real time"
		},
		recommendation: {
			text: "Get alternative offers to your predefined search criteria",
			title: "Recommendations"
		},
		title: "Alert Settings",
		trigger: "Notifications"
	},
	pauseAllNotifications: {
		action: "Pause all notifications"
	},
	resubscribe: {
		action: "Resubscribe"
	},
	title: {
		circles: "{{estateTypes, list(type: disjunction)}} $t(savedSearch.enums.distributionType.{{distributionType}}_prefixed) in {{placeName}} +{{radius}} {{radiusUnit}}",
		"default": "{{estateTypes, list(type: disjunction)}} $t(savedSearch.enums.distributionType.{{distributionType}}_prefixed)",
		location: "{{estateTypes, list(type: disjunction)}} {{distributionType}} {{location}}",
		places: "{{estateTypes, list(type: disjunction)}} $t(savedSearch.enums.distributionType.{{distributionType}}_prefixed) $t(savedSearch.criterias.location.places, { \"context\": \"prefixed\", \"placeName\":  \"{{placeName}}\", \"count\": {{placeCount}} })",
		polygons: "{{estateTypes, list(type: disjunction)}} $t(savedSearch.enums.distributionType.{{distributionType}}_prefixed) in personal map area",
		travels: "{{estateTypes, list(type: disjunction)}} $t(savedSearch.enums.distributionType.{{distributionType}}_prefixed) {{duration}} min {{mode}} from {{placeName}}"
	},
	unsubscribedEmailAlertSuccessfully: {
		title: "You have been successfully unsubscribed from {{alertName}}."
	},
	youCanAlso: {
		title: "You can also:"
	}
};
var savedSearch_alertClose_action$2 = "Close";
var savedSearch_alertCreated_text$2 = "Your alert has been created.";
var savedSearch_alertDelete_text$2 = "Your alert has been deleted.";
var savedSearch_alertNotCreated_text$2 = "Can't create the alert.";
var savedSearch_alertUpdated_text$2 = "Your alert has been created.";
var savedSearch_buttonCard_title$2 = "Receive alerts in real time";
var savedSearch_deleteAlert_title$2 = "Create an alert";
var savedSearch_duplicateError_text$2 = "You have already saved this search";
var savedSearch_duplicatePlaceId_text$2 = "There is an issue with your selected location, pelase try again later";
var savedSearch_errorSameSearchCriteria_text$2 = "You already have an alert with the same search criteria.";
var savedSearch_errorTechnical_text$2 = "A technical error has occured.";
var savedSearch_locationTooLarge_text$2 = "Search area too large, please reduce number of locations";
var savedSearch_locationTooSmall_text$2 = "The selected search area is too small";
var savedSearch_niceJob_text$2 = "Now you can create the new alert.";
var savedSearch_niceJob_title$2 = "Your alert has been deleted";
var savedSearch_polygonAlert_text$2 = "We can't create an alert from the radius search";
var enTranslations = {
	savedSearch: savedSearch$2,
	savedSearch_alertClose_action: savedSearch_alertClose_action$2,
	savedSearch_alertCreated_text: savedSearch_alertCreated_text$2,
	savedSearch_alertDelete_text: savedSearch_alertDelete_text$2,
	savedSearch_alertNotCreated_text: savedSearch_alertNotCreated_text$2,
	savedSearch_alertUpdated_text: savedSearch_alertUpdated_text$2,
	savedSearch_buttonCard_title: savedSearch_buttonCard_title$2,
	savedSearch_deleteAlert_title: savedSearch_deleteAlert_title$2,
	savedSearch_duplicateError_text: savedSearch_duplicateError_text$2,
	savedSearch_duplicatePlaceId_text: savedSearch_duplicatePlaceId_text$2,
	savedSearch_errorSameSearchCriteria_text: savedSearch_errorSameSearchCriteria_text$2,
	savedSearch_errorTechnical_text: savedSearch_errorTechnical_text$2,
	savedSearch_locationTooLarge_text: savedSearch_locationTooLarge_text$2,
	savedSearch_locationTooSmall_text: savedSearch_locationTooSmall_text$2,
	savedSearch_niceJob_text: savedSearch_niceJob_text$2,
	savedSearch_niceJob_title: savedSearch_niceJob_title$2,
	savedSearch_polygonAlert_text: savedSearch_polygonAlert_text$2,
	"savedSearch_there’sNoRoomLeft_text": "You’ve reached the maximum number of {{maxAlertsCount}} alerts. Delete at least one to continue.",
	"savedSearch_there’sNoRoomLeft_title": "Delete an alert"
};

var savedSearch$1 = {
	actions: {
		alertTitle: "Titre de l'alerte",
		disabled: "Désactivée",
		edit: "Modifier",
		editAlert: "Modifier l'alerte",
		enabled: "Activée",
		listings: "Voir les annonces",
		update: "Mettre à jour"
	},
	alert: {
		title: "Alertes"
	},
	alertActivated: {
		action: "Alerte active"
	},
	alertAlertsTab: {
		action: "Alertes"
	},
	alertAppNotifications: {
		option: "Notifications de l'app"
	},
	alertContinue: {
		action: "Continuer"
	},
	alertCreate: {
		action: "Créer une alerte",
		text: "Recevoir une alerte dès qu'une nouvelle annonce correspond à vos critères"
	},
	alertDelete: {
		action: "Supprimer"
	},
	alertDeletePopUp: {
		text: "Vous avez atteint le nombre maximum d'alertes. Supprimez au moins une alerte pour en créer une nouvelle.",
		title: "Supprimez une alerte"
	},
	alertEdit: {
		title: "Modifier mon alerte"
	},
	alertEmail: {
		actionCreate: "Créer une alerte",
		created: {
			action: "Voir les résultats de la recherche",
			text: "Vous recevrez désormais de nouvelles suggestions de propriétés à l'adresse e-mail suivante :",
			title: "Votre alerte e-mail a été créée avec succès !"
		},
		disclaimer: {
			link: "cliquez ici",
			text: "Digital Classifieds France traite vos données afin de gérer votre demande d'alerte de nouvelles annonces immobilières par e-mail. Pour en savoir plus et exercer vos droits, "
		},
		invalid: "Vous devez entrer une adresse e-mail valide",
		option: "E-mail",
		text: "Entrez votre email pour recevoir toutes les nouvelles annonces immobilières personnalisées et la sélection des professionnels."
	},
	alertEmptyState: {
		text: "Soyez notifié dès que de nouvelles annonces correspondent à vos critères.",
		title: "Aucune alerte"
	},
	alertFavouritesTab: {
		action: "Favoris"
	},
	alertForceLogin: {
		text: "Connectez-vous pour configurer vos alertes. Vous recevrez une notification dès qu'une nouvelle annonce correspond à vos critères.",
		title: "Connectez-vous pour gérer vos alertes"
	},
	alertInternetError: {
		text: "Activez vos données mobiles ou connectez-vous à un réseau Wi-Fi.",
		title: "Aucune connexion internet"
	},
	alertInvalid: {
		text: "Critères de recherche invalides"
	},
	alertLoading: {
		title: "Chargement des alertes"
	},
	alertRetry: {
		action: "Réessayer"
	},
	alertSave: {
		action: "Créer l'alerte"
	},
	alertSee: {
		action: "Voir les annonces"
	},
	alertSetup: {
		title: "Ne manquez aucune annonce"
	},
	alertSignin: {
		action: "Se connecter"
	},
	alertSignup: {
		action: "S'inscrire"
	},
	alertTechnicalError: {
		text: "Une erreur technique est survenue. Réessayez plus tard.",
		title: "Une erreur s'est produite"
	},
	alertValidate: {
		action: "Valider"
	},
	alertsPaused: {
		text: "Les notifications de toutes vos alertes ont été désactivées."
	},
	anonymousRegister: {
		action: "S’inscrire",
		text: "Ce n'est qu'alors que vous pourrez voir toutes vos recherches enregistrées.",
		title: "Veuillez vous connecter"
	},
	cancel: {
		action: "Annuler"
	},
	createAlertsByHitting: {
		text: "Vous pouvez créer une alerte depuis la page des résultats de recherche."
	},
	criterias: {
		area: {
			title: "Surface"
		},
		common: {
			range: {
				label: {
					max: "Max",
					min: "Min"
				}
			}
		},
		context_switch: {
			commercial: "Pour mon entreprise",
			residential: "Pour moi"
		},
		estate_subtype: {
			agriculture_forestry: {
				checkbox: {
					agriculture_company: "Entreprise agricole",
					farm_ranch: "Ferme / Ranch",
					forestry: "Forêts",
					gardening_orchard: "Jardinage / Verger",
					hunting_fishing: "Chasse / Pêche",
					riding: "Équestre",
					winery: "Vignobles"
				},
				title: "Type de propriété"
			},
			apartment: {
				checkbox: {
					loft: "Loft",
					multi_storey: "Plusieurs étages",
					penthouse: "Penthouse",
					studio: "Studio",
					terrace: "Terrasse"
				},
				title: "Type d'immobilier"
			},
			gastronomy_hotel: {
				checkbox: {
					cafe_bar_pub: "Café / Bar / Pub",
					club_discotheque: "Club / Discothèque",
					hotel_pension: "Hôtel / Pension",
					restaurant: "Restaurant"
				},
				title: "Type de propriété"
			},
			house: {
				checkbox: {
					bungalow: "Bungalow",
					castle: "Château",
					chalet: "Chalet",
					farmhouse: "Ferme",
					finca: "Finca",
					manor_house: "Manoir",
					multi_family_house: "Maison multifamiliale",
					rustico: "Rustico",
					semidetached_house: "Maison jumelée",
					single_family_house: "Maison individuelle",
					terrace_house: "Maison en terrasse",
					town_house: "Maison de ville",
					villa: "Villa"
				},
				title: "Type de maison"
			},
			office: {
				checkbox: {
					atelier: "Atelier",
					coworking: "Coworking",
					living_and_commercial_building: "Bâtiment d'habitation et commercial",
					medical: "Médical",
					office: "Bureau"
				},
				title: "Type de bureau"
			},
			parking: {
				checkbox: {
					carport: "Abri de voiture",
					duplex: "Garage double",
					garage: "Garage",
					outside: "Parking extérieur",
					underground_garage: "Garage souterrain",
					underground_parking_space: "Parking souterrain"
				},
				title: "Type de parking"
			},
			plot: {
				checkbox: {
					commercial: "Commercial",
					leisure_facility: "Centre de loisirs",
					living: "Résidentiel"
				},
				title: "Type de parcelle"
			},
			storage_production: {
				checkbox: {
					garage_repair: "Garage / Réparation",
					logistic_center: "Centre logistique",
					miscellaneous_storage: "Stockage divers",
					outdoor_space: "Espace extérieur",
					production_hall: "Salle de production",
					warehouse_hall: "Entrepôt"
				},
				title: "Type de propriété"
			},
			trading: {
				checkbox: {
					kiosk: "Kiosque",
					sales_area: "Espace de vente",
					shopping_centre: "Centre commercial",
					showroom_space: "Espace d'exposition",
					store: "Magasin"
				},
				title: "Type de magasin"
			}
		},
		features: {
			checkbox: {
				attic_apartment: "Appartement au grenier",
				balcony_terrace: "Balcon / Terrasse",
				bathroom_with_bathtub: "Salle de bain avec baignoire",
				bathroom_with_window: "Salle de bain avec fenêtre",
				built_in_kitchen: "Cuisine intégrée",
				cellar: "Cave",
				certificate_of_eligibility_needed: "Un certificat d'éligibilité est requis",
				elevator: "Ascenseur",
				free_of_commission: "Sans commission",
				furnished: "Entièrement meublé",
				garden: "Jardin",
				no_attic_apartment: "Pas d'appartement mansardé",
				no_ground_floor: "Pas de rez-de-chaussée",
				parking_garage: "Parking / Garage",
				pets_allowed: "Animaux autorisés",
				reduced_mobility_access: "Accès à mobilité réduite",
				unfurnished: "Non meublé",
				vacant: "Vacant / Non loué"
			},
			subtitle: {
				accessibility: "Accessibilité",
				furnished_unfurnished: "Meublé / Non meublé",
				indoor: "Intérieur",
				usage: "Utilisation"
			},
			title: {
				features_excluded: "Caractéristiques à exclure",
				features_included: "Caractéristiques",
				foreclosure: "Vente sur saisie",
				new_builds: "Nouvelles constructions",
				subsidizing_housing: "Logement subventionné"
			}
		},
		floor: "Etage",
		floors: {
			checkbox: {
				ground_floor: "Rez-de-chaussée",
				no_ground_floor: "Pas de rez-de-chaussée",
				other_floors: "Autres étages"
			}
		},
		living_area: {
			input_field: {
				surface_type: "m²"
			},
			title: "Surface"
		},
		location: {
			circles: "{{placeName}} +{{radius}} {{radiusUnit}}",
			circles_prefixed: "autour de {{placeName}} +{{radius}} {{radiusUnit}}",
			places_one: "{{placeName}}",
			places_other: "{{placeName}} (+{{count}})",
			places_prefixed_one: "à {{placeName}}",
			places_prefixed_other: "à {{placeName}} (+{{count}})",
			places_prefixed_zero: "",
			polygons: "zone personnalisée",
			polygons_prefixed: "dans zone personnalisée",
			travels: "{{duration}} min {{mode}} de {{placeName}}",
			travels_prefixed: "à {{duration}} min {{mode}} de {{placeName}}"
		},
		plot_area: {
			input_field: {
				surface_type: "m²"
			},
			title: "Surface de la parcelle"
		},
		project_type: {
			checkbox: {
				foreclosure_sale: "Vente sur saisie",
				investment: "Investissement",
				new_builds: "Nouvelles constructions",
				resale: "Ancien",
				shared_flats: "Appartements partagés",
				stock: "Stock",
				temporary_living: "Logement temporaire"
			},
			title: "Type de projet"
		}
	},
	deleteAlertConfirmation: {
		text: "Vous ne recevrez plus de notifications correspondant aux critères de cette recherche",
		title: "Etes-vous sûr de vouloir supprimer cette alerte ?"
	},
	distribution_type: {
		buy: "Acheter",
		compulsory_auction: "Enchères obligatoires",
		rent: "Louer"
	},
	emailResubscribed: {
		action: "Continuer la recherche",
		text: "Merci d'être resté avec nous.",
		title: "Vous vous êtes réabonné."
	},
	enums: {
		distributionType: {
			BUY: "acheter",
			BUY_AUCTION: "acheter aux enchères",
			BUY_AUCTION_prefixed: "pour acheter aux enchères",
			BUY_prefixed: "à acheter",
			COMPULSORY_AUCTION: "enchères obligatoires",
			COMPULSORY_AUCTION_prefixed: "pour enchères obligatoires",
			RENT: "louer",
			RENT_prefixed: "à louer"
		},
		estateType: {
			AGRICULTURE_FORESTRY: "Agriculture / Sylviculture",
			AGRICULTURE_FORESTRY_prefixed: "une Agriculture / Sylviculture",
			APARTMENT: "Appartement",
			APARTMENT_prefixed: "un Appartement",
			BUILDING: "Bâtiment",
			BUILDING_prefixed: "un Bâtiment",
			GASTRONOMY_HOTEL: "Gastronomie / Hôtel",
			GASTRONOMY_HOTEL_prefixed: "un Gastronomie / Hôtel",
			HOUSE: "Maison",
			HOUSE_prefixed: "une Maison",
			MISCELLANEOUS: "Divers",
			MISCELLANEOUS_prefixed: "Divers",
			OFFICE: "Bureau",
			OFFICE_prefixed: "un Bureau",
			PARKING: "Parking",
			PARKING_prefixed: "un Parking",
			PLOT: "Terrain",
			PLOT_prefixed: "un Terrain",
			PROJECT: "Projet",
			PROJECT_prefixed: "un Projet",
			SENIOR: "Résidence pour personnes âgées",
			SENIOR_prefixed: "une Résidence pour personnes âgées",
			STORAGE_PRODUCTION: "Stockage / Production",
			STORAGE_PRODUCTION_prefixed: "un Stockage / Production",
			TRADING: "Boutique",
			TRADING_prefixed: "une Boutique"
		},
		travelMode: {
			BIKE: "vélo",
			BIKE_prefixed: "à vélo",
			CAR: "voiture",
			CAR_prefixed: "en voiture",
			TRANSIT: "transport en commun",
			TRANSIT_prefixed: "en transport en commun",
			WALK: "à pied",
			WALK_prefixed: "à pied"
		}
	},
	errorCreate: {
		text: "Impossible de créer l'alerte. Réessayez plus tard."
	},
	errorDelete: {
		text: "Impossible de supprimer votre alerte."
	},
	errorPage: {
		action: "Accédez aux alertes de recherche",
		text: "Il se peut que le lien que vous avez suivi soit rompu ou que la page ait été supprimée.",
		title: "Cette page n'est pas disponible."
	},
	errorPageGeneric: {
		text: "La page n'est pas disponible. Veuillez réessayer ultérieurement.",
		title: "Une erreur s'est produite"
	},
	errorTechnicalRetry: {
		text: "Une erreur technique ait survenue. Réessayez plus tard."
	},
	errorUpdate: {
		text: "Impossible de mettre à jour votre alerte. Réessayez plus tard."
	},
	estate_type: {
		agriculture_forestry: "Agriculture / sylviculture",
		apartment: "Appartement",
		gastronomy_hotel: "Gastronomie / Hôtel",
		house: "Maison",
		house_apartment: "Maison / Appartement",
		investment_property: "Investissement immobilier",
		miscellaneous: "Divers",
		office: "Bureau",
		parking: "Parking",
		plot: "Terrain",
		project: "Projet",
		shared_apartment: "Appartement partagé",
		storage_production: "Stockage / Production",
		temporary_living: "Logement temporaire",
		trading: "Boutique"
	},
	geometry_location: {
		title: "zone personnalisée"
	},
	getAlerts: {
		action: "Créer une alerte"
	},
	goBack: {
		action: "Retour"
	},
	goToSearch: {
		action: "Rechercher"
	},
	hint: {
		"default": {
			text: "Activez l'alerte pour recevoir en temps réel les nouveaux biens correspondant à vos critères",
			title: "Créez votre alerte de recherche"
		},
		travel_time: {
			text: "Gagnez du temps en sauvegardant votre recherche et recevez les dernières annonces dès qu’elles sont publiées !",
			title: "Nouvelle fonctionnalité"
		}
	},
	hpMfe: {
		mvp: {
			blockText: "On continue ?"
		},
		noMore: {
			firstAction: "Voir plus de biens",
			firstText: "C'est tout pour le moment !",
			secondAction: "Nouvelle recherche",
			secondText: "Vous pouvez désormais..."
		},
		seeMore: {
			action: "Charger plus",
			text: "{{number}} autres propriétés dans la sélection"
		},
		text: "Nouveau(x) bien(s) lié(s) à votre recherche sauvegardée",
		title: "Du nouveau pour votre recherche sauvegardée"
	},
	iconCriteria: {
		rooms: {
			text: "pc"
		}
	},
	intermediaryMatchingMandate: {
		errors: {
			consent: "Sans votre accord, nous ne pouvons transmettre vos coordonnées à une sélection d'agences immobilières pour vous accompagner dans votre projet immobilier.",
			email: "L'email n'est pas valide",
			phoneNumber: "Le format du numéro de téléphone n'est pas valide",
			required: "Le champ {{field}} est obligatoire",
			string: "Format incorrect"
		},
		informations: "En envoyant votre demande, vous acceptez le service Immowelt. Vous recevrez des informations basées sur les données que vous avez saisies, les services utilisés et l'objectif de notre activité. Vous pouvez vous opposer à ce service à tout moment à l'adresse datenschutz@immowelt.de. Vous trouverez de plus amples informations dans la déclaration de protection des données.",
		labels: {
			consent: "J'accepte que mes données soient transmises à une sélection d'agences immobilières proposant des biens correspondant à mon alerte, qui pourront me contacter par email ou par téléphone pour m'aider dans mon projet immobilier.",
			email: "Email",
			message: "Votre message",
			name: "Nom",
			phoneNumber: "Téléphone"
		},
		legal: {
			text: {
				first: "{{upperLocal}} - Digital Classifieds {{country}} procède au traitement de vos données afin les transmettre à l’annonceur indiqué. Dans ce cadre, nous transmettrons ces données à nos entités",
				fourth: "s'appliquent.",
				link: {
					first: "AVIV Group",
					second: "Politique de confidentialité.",
					third: "Conditions Générales d’Utilisation"
				},
				second: "et nos prestataires de services externes. Vous pouvez retirer à tout moment votre consentement au traitement des données facultatives. Pour plus d'informations sur vos droits et vos données, consultez notre",
				third: "En cliquant sur \"Confirmer ma demande\", notre"
			}
		},
		placeholders: {
			message: "Fournissez des détails pour aider nos experts à comprendre exactement ce que vous recherchez.",
			phoneNumber: "+33 XXX XXX XXX"
		},
		submit: "Confirmer ma demande",
		success: "Votre demande de contact a été envoyée avec succès.",
		suggestions: {
			text: "Recevez des propositions directes d'agents de confiance, y compris des annonces inédites adaptées à vos préférences.",
			title: "Obtenez des suggestions de propriétés auprès d'agents"
		}
	},
	loader_text: "La page est en cours de chargement",
	notifications: {
		recommendations: "Recommandations",
		title: "Notifications",
		tooltip: "Mettez à jour vos paramètres de notification et recevez des biens alternatifs basés sur votre alerte."
	},
	notificationsEdit: {
		email: "E-mail",
		frequency: {
			daily: "Une fois par jour",
			never: "Désactivée",
			realtime: "En temps réel"
		},
		recommendation: {
			text: "Obtenez des offres alternatives à vos critères de recherche prédéfinis",
			title: "Recommandations"
		},
		title: "Paramètres d'alerte",
		trigger: "Paramètres des notifications"
	},
	pauseAllNotifications: {
		action: "Suspendre toutes les notifications"
	},
	resubscribe: {
		action: "Se réabonner"
	},
	title: {
		circles: "{{estateTypes, list(type: disjunction)}} $t(savedSearch.enums.distributionType.{{distributionType}}_prefixed) autour de {{placeName}} +{{radius}} {{radiusUnit}}",
		"default": "{{estateTypes, list(type: disjunction)}} $t(savedSearch.enums.distributionType.{{distributionType}}_prefixed)",
		location: "{{estateTypes, list(type: disjunction)}} {{distributionType}} {{location}}",
		places: "{{estateTypes, list(type: disjunction)}} $t(savedSearch.enums.distributionType.{{distributionType}}_prefixed) $t(savedSearch.criterias.location.places, { \"context\": \"prefixed\", \"placeName\":  \"{{placeName}}\", \"count\": {{placeCount}} })",
		polygons: "{{estateTypes, list(type: disjunction)}} $t(savedSearch.enums.distributionType.{{distributionType}}_prefixed) dans zone personnalisée",
		travels: "{{estateTypes, list(type: disjunction)}} $t(savedSearch.enums.distributionType.{{distributionType}}_prefixed) à {{duration}} min {{mode}} de {{placeName}}"
	},
	unsubscribedEmailAlertSuccessfully: {
		title: "Vous avez été désabonné avec succès de {{alertName}}."
	},
	youCanAlso: {
		title: "Vous pouvez également :"
	}
};
var savedSearch_alertClose_action$1 = "Fermer";
var savedSearch_alertCreated_text$1 = "Votre alerte a été créée.";
var savedSearch_alertDelete_text$1 = "Votre alerte a été supprimée.";
var savedSearch_alertNotCreated_text$1 = "Impossible de créer l'alerte.";
var savedSearch_alertUpdated_text$1 = "Votre alerte a été créée.";
var savedSearch_buttonCard_title$1 = "Recevez des alertes en temps réel";
var savedSearch_deleteAlert_title$1 = "Créer une alerte";
var savedSearch_duplicateError_text$1 = "Vous avez déjà sauvegardé cette recherche";
var savedSearch_duplicatePlaceId_text$1 = "Il y a un problème avec la zone que vous avez sélectionnée, veuillez réessayer plus tard";
var savedSearch_errorSameSearchCriteria_text$1 = "Vous avez déjà une alerte avec les mêmes critères de recherche";
var savedSearch_errorTechnical_text$1 = "Une erreur technique s'est produite";
var savedSearch_locationTooLarge_text$1 = "Zone de recherche trop grande, veuillez réduire le nombre de localisations.";
var savedSearch_locationTooSmall_text$1 = "La zone de recherche sélectionnée est trop petite";
var savedSearch_niceJob_text$1 = "Vous pouvez maintenant créer une nouvelle alerte";
var savedSearch_niceJob_title$1 = "Votre alerte a été supprimée";
var savedSearch_polygonAlert_text$1 = "Nous ne pouvons pas créer d'alerte à partir de la recherche de rayon";
var frTranslations = {
	savedSearch: savedSearch$1,
	savedSearch_alertClose_action: savedSearch_alertClose_action$1,
	savedSearch_alertCreated_text: savedSearch_alertCreated_text$1,
	savedSearch_alertDelete_text: savedSearch_alertDelete_text$1,
	savedSearch_alertNotCreated_text: savedSearch_alertNotCreated_text$1,
	savedSearch_alertUpdated_text: savedSearch_alertUpdated_text$1,
	savedSearch_buttonCard_title: savedSearch_buttonCard_title$1,
	savedSearch_deleteAlert_title: savedSearch_deleteAlert_title$1,
	savedSearch_duplicateError_text: savedSearch_duplicateError_text$1,
	savedSearch_duplicatePlaceId_text: savedSearch_duplicatePlaceId_text$1,
	savedSearch_errorSameSearchCriteria_text: savedSearch_errorSameSearchCriteria_text$1,
	savedSearch_errorTechnical_text: savedSearch_errorTechnical_text$1,
	savedSearch_locationTooLarge_text: savedSearch_locationTooLarge_text$1,
	savedSearch_locationTooSmall_text: savedSearch_locationTooSmall_text$1,
	savedSearch_niceJob_text: savedSearch_niceJob_text$1,
	savedSearch_niceJob_title: savedSearch_niceJob_title$1,
	savedSearch_polygonAlert_text: savedSearch_polygonAlert_text$1,
	"savedSearch_there’sNoRoomLeft_text": "Vous avez atteint le nombre maximum de {{maxAlertsCount}} alertes. Supprimez-en au moins une pour continuer.",
	"savedSearch_there’sNoRoomLeft_title": "Supprimer une alerte"
};

var savedSearch = {
	actions: {
		alertTitle: "",
		disabled: "",
		edit: "",
		editAlert: "",
		enabled: "",
		listings: "",
		update: ""
	},
	alert: {
		title: "Meldingen"
	},
	alertActivated: {
		action: "Melding ingeschakeld"
	},
	alertAlertsTab: {
		action: "Meldingen"
	},
	alertAppNotifications: {
		option: "App-berichten"
	},
	alertContinue: {
		action: ""
	},
	alertCreate: {
		action: "Een melding maken",
		text: "Ontvang meldingen wanneer een nieuwe eigendom voldoet aan je criteria"
	},
	alertDelete: {
		action: "Verwijderen"
	},
	alertDeletePopUp: {
		text: "Je hebt het maximale aantal meldingen bereikt. Verwijder er ten minste één van om door te gaan.",
		title: "Een melding verwijderen"
	},
	alertEdit: {
		title: "Mijn melding bewerken"
	},
	alertEmail: {
		actionCreate: "",
		created: {
			action: "",
			text: "",
			title: ""
		},
		disclaimer: {
			link: "",
			text: ""
		},
		invalid: "",
		option: "E-mail",
		text: ""
	},
	alertEmptyState: {
		text: "Krijg een bericht wanneer nieuwe advertenties voldoen aan je criteria.",
		title: "Geen melding"
	},
	alertFavouritesTab: {
		action: "Verlanglijst"
	},
	alertForceLogin: {
		text: "Log in om je meldingen in te stellen. Je ontvangt een bericht wanneer nieuwe advertenties aan je criteria voldoen.",
		title: "Log in om je meldingen te beheren"
	},
	alertInternetError: {
		text: "Schakel je mobiele gegevens in of maak verbinding met een wifi-netwerk.",
		title: "Geen internetverbinding"
	},
	alertInvalid: {
		text: "Ongeldige zoekcriteria"
	},
	alertLoading: {
		title: "Meldingen worden geladen"
	},
	alertRetry: {
		action: "Opnieuw proberen"
	},
	alertSave: {
		action: "De melding maken"
	},
	alertSee: {
		action: "Eigendommen bekijken"
	},
	alertSetup: {
		title: "Ontvang een bericht van nieuwe advertenties"
	},
	alertSignin: {
		action: "Inloggen"
	},
	alertSignup: {
		action: "Registreren"
	},
	alertTechnicalError: {
		text: "Er is een technische fout opgetreden. Probeer het later opnieuw.",
		title: "Er ging iets mis"
	},
	alertValidate: {
		action: "Valideren"
	},
	alertsPaused: {
		text: "Berichten voor alle meldingen zijn gepauzeerd. Je kunt ze op elk moment opnieuw activeren."
	},
	anonymousRegister: {
		action: "Registreren",
		text: "Alleen dan kunt u al uw opgeslagen zoekopdrachten zien.",
		title: "Log alsjeblieft in"
	},
	cancel: {
		action: "Annuleer"
	},
	createAlertsByHitting: {
		text: "Je kunt een melding maken vanaf de pagina met zoekresultaten."
	},
	criterias: {
		area: {
			title: "Gebied"
		},
		common: {
			range: {
				label: {
					max: "Max",
					min: "Min"
				}
			}
		},
		context_switch: {
			commercial: "Voor mijn bedrijf",
			residential: "Voor mij"
		},
		estate_subtype: {
			agriculture_forestry: {
				checkbox: {
					agriculture_company: "Landbouwbedrijf",
					farm_ranch: "Boerderij",
					forestry: "Bosbouw",
					gardening_orchard: "Tuinieren / Boomgaard",
					hunting_fishing: "Jagen/Vissen",
					riding: "rijden",
					winery: "Wijnmakerij"
				},
				title: "Type landgoed"
			},
			apartment: {
				checkbox: {
					loft: "Zolder",
					multi_storey: "Meer verdiepingen",
					penthouse: "Penthouse",
					studio: "Studio",
					terrace: "Terras"
				},
				title: "Landgoed type"
			},
			gastronomy_hotel: {
				checkbox: {
					cafe_bar_pub: "Café / Bar / Pub",
					club_discotheque: "Club / Discotheek",
					hotel_pension: "Hotel / Pension",
					restaurant: "Restaurant"
				},
				title: "Type landgoed"
			},
			house: {
				checkbox: {
					bungalow: "Bungalow",
					castle: "Kasteel",
					chalet: "Chalet",
					farmhouse: "Boerderij",
					finca: "Finca",
					manor_house: "Landhuis",
					multi_family_house: "Meergezinswoning",
					rustico: "Rustico",
					semidetached_house: "Halfvrijstaand huis",
					single_family_house: "Eengezinswoning",
					terrace_house: "Terraswoning",
					town_house: "Herenhuis",
					villa: "Villa"
				},
				title: "Type huis"
			},
			office: {
				checkbox: {
					atelier: "Atelier",
					coworking: "Coworking",
					living_and_commercial_building: "Wonen en commerciële gebouwen",
					medical: "Medisch",
					office: "Kantoor"
				},
				title: "Type kantoor"
			},
			parking: {
				checkbox: {
					carport: "Carport",
					duplex: "Duplex",
					garage: "Garage",
					outside: "Buiten parkeren",
					underground_garage: "Ondergrondse garage",
					underground_parking_space: "Ondergronds parkeren"
				},
				title: "Type parkeerplaats"
			},
			plot: {
				checkbox: {
					commercial: "Commercieel",
					leisure_facility: "Vrijetijdscentrum",
					living: "Wonen"
				},
				title: "Type perceel"
			},
			storage_production: {
				checkbox: {
					garage_repair: "Garage / Reparatie",
					logistic_center: "Logistiek centrum",
					miscellaneous_storage: "Diverse opslag",
					outdoor_space: "Buitenruimte",
					production_hall: "Productiehal",
					warehouse_hall: "Magazijn"
				},
				title: "Type landgoed"
			},
			trading: {
				checkbox: {
					kiosk: "Kiosk",
					sales_area: "Verkoopgebied",
					shopping_centre: "Winkelcentrum",
					showroom_space: "Showroom ruimte",
					store: "Winkel"
				},
				title: "Type winkel"
			}
		},
		features: {
			checkbox: {
				attic_apartment: "Zolder appartement",
				balcony_terrace: "Balkon / Terras",
				bathroom_with_bathtub: "Badkamer met bad",
				bathroom_with_window: "Badkamer met raam",
				built_in_kitchen: "Ingebouwde keuken",
				cellar: "Kelder",
				certificate_of_eligibility_needed: "",
				elevator: "Lift",
				free_of_commission: "Vrij van commissie",
				furnished: "Volledig gemeubileerd",
				garden: "Tuin",
				no_attic_apartment: "Geen zolderappartement",
				no_ground_floor: "Geen begane grond",
				parking_garage: "Parkeren / Garage",
				pets_allowed: "Huisdieren toegestaan",
				reduced_mobility_access: "Toegang met beperkte mobiliteit",
				unfurnished: "Ongemeubileerd",
				vacant: "Leeg / Niet verhuurd"
			},
			subtitle: {
				accessibility: "Toegankelijkheid",
				furnished_unfurnished: "Gemeubileerd / Gestoffeerd",
				indoor: "Binnen",
				usage: "Gebruik"
			},
			title: {
				features_excluded: "",
				features_included: "",
				foreclosure: "Verkoop",
				new_builds: "Nieuwbouw",
				subsidizing_housing: "Huisvesting subsidiëren"
			}
		},
		floor: "Vloer",
		floors: {
			checkbox: {
				ground_floor: "Begane grond",
				no_ground_floor: "Geen begane grond",
				other_floors: "Andere vloeren"
			}
		},
		living_area: {
			input_field: {
				surface_type: "m²"
			},
			title: "Leefruimte"
		},
		location: {
			circles: "",
			circles_prefixed: "",
			places_one: "",
			places_other: "",
			places_prefixed_one: "",
			places_prefixed_other: "",
			places_prefixed_zero: "",
			polygons: "",
			polygons_prefixed: "",
			travels: "",
			travels_prefixed: ""
		},
		plot_area: {
			input_field: {
				surface_type: "m²"
			},
			title: ""
		},
		project_type: {
			checkbox: {
				foreclosure_sale: "Verkoop",
				investment: "Investering",
				new_builds: "Nieuwbouw",
				resale: "Wederverkoop",
				shared_flats: "Gedeelde flats",
				stock: "Voorraad",
				temporary_living: "Tijdelijk wonen"
			},
			title: "Type project"
		}
	},
	deleteAlertConfirmation: {
		text: "",
		title: "Weet je zeker dat je deze melding wilt verwijderen?"
	},
	distribution_type: {
		buy: "Kopen",
		compulsory_auction: "Verplichte veiling",
		rent: "Huren"
	},
	emailResubscribed: {
		action: "Doorgaan met zoeken",
		text: "Bedankt om bij ons te blijven.",
		title: "Je hebt je opnieuw geabonneerd."
	},
	enums: {
		distributionType: {
			BUY: "",
			BUY_AUCTION: "",
			BUY_AUCTION_prefixed: "",
			BUY_prefixed: "",
			COMPULSORY_AUCTION: "",
			COMPULSORY_AUCTION_prefixed: "",
			RENT: "",
			RENT_prefixed: ""
		},
		estateType: {
			AGRICULTURE_FORESTRY: "",
			AGRICULTURE_FORESTRY_prefixed: "",
			APARTMENT: "",
			APARTMENT_prefixed: "",
			BUILDING: "",
			BUILDING_prefixed: "",
			GASTRONOMY_HOTEL: "",
			GASTRONOMY_HOTEL_prefixed: "",
			HOUSE: "",
			HOUSE_prefixed: "",
			MISCELLANEOUS: "",
			MISCELLANEOUS_prefixed: "",
			OFFICE: "",
			OFFICE_prefixed: "",
			PARKING: "",
			PARKING_prefixed: "",
			PLOT: "",
			PLOT_prefixed: "",
			PROJECT: "",
			PROJECT_prefixed: "",
			SENIOR: "",
			SENIOR_prefixed: "",
			STORAGE_PRODUCTION: "",
			STORAGE_PRODUCTION_prefixed: "",
			TRADING: "",
			TRADING_prefixed: ""
		},
		travelMode: {
			BIKE: "",
			BIKE_prefixed: "",
			CAR: "",
			CAR_prefixed: "",
			TRANSIT: "",
			TRANSIT_prefixed: "",
			WALK: "",
			WALK_prefixed: ""
		}
	},
	errorCreate: {
		text: "We konden de melding niet maken. Probeer het later opnieuw."
	},
	errorDelete: {
		text: "Kan je melding niet verwijderen."
	},
	errorPage: {
		action: "Ga naar zoekmeldingen",
		text: "De link die je volgde kan verbroken zijn of de pagina kan verwijderd zijn.",
		title: "Deze pagina is niet beschikbaar."
	},
	errorPageGeneric: {
		text: "",
		title: ""
	},
	errorTechnicalRetry: {
		text: "Er is een technische fout opgetreden. Probeer het later opnieuw."
	},
	errorUpdate: {
		text: "Kan je melding niet bijwerken. Probeer het later opnieuw."
	},
	estate_type: {
		agriculture_forestry: "Landbouw / Bosbouw",
		apartment: "Appartement",
		gastronomy_hotel: "Gastronomie / Hotel",
		house: "Huis",
		house_apartment: "Huis / Appartement",
		investment_property: "Vastgoedbelegging",
		miscellaneous: "Diverse",
		office: "Kantoor",
		parking: "Parkeren",
		plot: "Perceel",
		project: "Project",
		shared_apartment: "Gedeeld appartement",
		storage_production: "Opslag / Productie",
		temporary_living: "Tijdelijk wonen",
		trading: "Winkel op"
	},
	geometry_location: {
		title: ""
	},
	getAlerts: {
		action: "Een melding maken"
	},
	goBack: {
		action: ""
	},
	goToSearch: {
		action: "Ga naar zoekopdracht"
	},
	hint: {
		"default": {
			text: "",
			title: ""
		},
		travel_time: {
			text: "Het is nu mogelijk om uw zoekopdracht op te slaan!",
			title: "Nieuwe functie"
		}
	},
	hpMfe: {
		mvp: {
			blockText: ""
		},
		noMore: {
			firstAction: "",
			firstText: "",
			secondAction: "",
			secondText: ""
		},
		seeMore: {
			action: "",
			text: ""
		},
		text: "",
		title: ""
	},
	iconCriteria: {
		rooms: {
			text: ""
		}
	},
	intermediaryMatchingMandate: {
		errors: {
			consent: "",
			email: "",
			phoneNumber: "",
			required: "",
			string: ""
		},
		informations: "",
		labels: {
			consent: "",
			email: "",
			message: "",
			name: "",
			phoneNumber: ""
		},
		legal: {
			text: {
				first: "",
				fourth: "",
				link: {
					first: "",
					second: "",
					third: ""
				},
				second: "",
				third: ""
			}
		},
		placeholders: {
			message: "",
			phoneNumber: ""
		},
		submit: "",
		success: "",
		suggestions: {
			text: "",
			title: ""
		}
	},
	loader_text: "",
	notifications: {
		recommendations: "",
		title: "",
		tooltip: ""
	},
	notificationsEdit: {
		email: "",
		frequency: {
			daily: "",
			never: "",
			realtime: ""
		},
		recommendation: {
			text: "",
			title: ""
		},
		title: "",
		trigger: ""
	},
	pauseAllNotifications: {
		action: "Pauzeer alle berichten"
	},
	resubscribe: {
		action: "Opnieuw abonneren"
	},
	title: {
		circles: "",
		"default": "",
		location: "",
		places: "",
		polygons: "",
		travels: ""
	},
	unsubscribedEmailAlertSuccessfully: {
		title: "Je bent met succes afgemeld voor {{alertName}}."
	},
	youCanAlso: {
		title: "Je kunt ook:"
	}
};
var savedSearch_alertClose_action = "Afsluiten";
var savedSearch_alertCreated_text = "Je melding werd gemaakt.";
var savedSearch_alertDelete_text = "Je melding werd verwijderd.";
var savedSearch_alertNotCreated_text = "Kan de melding niet maken.";
var savedSearch_alertUpdated_text = "Je melding werd gemaakt.";
var savedSearch_buttonCard_title = "";
var savedSearch_deleteAlert_title = "Bewaar zoekactie";
var savedSearch_duplicateError_text = "";
var savedSearch_duplicatePlaceId_text = "";
var savedSearch_errorSameSearchCriteria_text = "Je hebt al een melding met dezelfde zoekcriteria.";
var savedSearch_errorTechnical_text = "Er is een technische fout opgetreden.";
var savedSearch_locationTooLarge_text = "";
var savedSearch_locationTooSmall_text = "";
var savedSearch_niceJob_text = "Nu kun je de nieuwe melding maken.";
var savedSearch_niceJob_title = "Je melding werd verwijderd";
var savedSearch_polygonAlert_text = "";
var nlTranslations = {
	savedSearch: savedSearch,
	savedSearch_alertClose_action: savedSearch_alertClose_action,
	savedSearch_alertCreated_text: savedSearch_alertCreated_text,
	savedSearch_alertDelete_text: savedSearch_alertDelete_text,
	savedSearch_alertNotCreated_text: savedSearch_alertNotCreated_text,
	savedSearch_alertUpdated_text: savedSearch_alertUpdated_text,
	savedSearch_buttonCard_title: savedSearch_buttonCard_title,
	savedSearch_deleteAlert_title: savedSearch_deleteAlert_title,
	savedSearch_duplicateError_text: savedSearch_duplicateError_text,
	savedSearch_duplicatePlaceId_text: savedSearch_duplicatePlaceId_text,
	savedSearch_errorSameSearchCriteria_text: savedSearch_errorSameSearchCriteria_text,
	savedSearch_errorTechnical_text: savedSearch_errorTechnical_text,
	savedSearch_locationTooLarge_text: savedSearch_locationTooLarge_text,
	savedSearch_locationTooSmall_text: savedSearch_locationTooSmall_text,
	savedSearch_niceJob_text: savedSearch_niceJob_text,
	savedSearch_niceJob_title: savedSearch_niceJob_title,
	savedSearch_polygonAlert_text: savedSearch_polygonAlert_text,
	"savedSearch_there’sNoRoomLeft_text": "Je hebt het maximale aantal {{maxAlertsCount}} meldingen bereikt. Verwijder er ten minste één van om door te gaan.",
	"savedSearch_there’sNoRoomLeft_title": "Een melding verwijderen"
};

const getTranslationsFiles = (locale)=>{
    switch(locale){
        case 'de':
            return deTranslations;
        case 'en':
            return enTranslations;
        case 'fr':
            return frTranslations;
        case 'nl':
            return nlTranslations;
        default:
            return deTranslations;
    }
};
const resources = {
    de: {
        translation: getTranslationsFiles('de')
    },
    en: {
        translation: getTranslationsFiles('en')
    },
    fr: {
        translation: getTranslationsFiles('fr')
    }
};
instance.use(initReactI18next).init({
    resources,
    lng: 'en',
    fallbackLng: 'de',
    interpolation: {
        escapeValue: false
    }
});

const createOnLi = async ({ payload, configCalls })=>{
    let result = {
        error: 'undefined'
    };
    const wlBody = {
        title: payload?.title,
        email: payload?.email,
        criteria: payload?.search?.criteria,
        channels: defaultChannels,
        userInteractionData: payload?.userInteractionData
    };
    const legacyBody = {
        title: payload?.title,
        email: payload?.email,
        criteria: payload?.search?.criteria,
        currentUrl: payload?.currentUrl,
        externalProperties: payload?.search?.externalProperties
    };
    const success = (response)=>{
        result = commonSuccess(response);
    };
    const errorOnWl = (errorResponse)=>{
        result = commonError(errorResponse);
    };
    const error = async (errorResponse)=>{
        if (errorResponse.httpStatusCode === 410) {
            await addSavedSearchEmail(success, errorOnWl, {
                body: wlBody
            });
        } else {
            result = {
                error: errorResponse?.errorCode === 'UNKNOWN_ERROR' ? `Error response with status: ${errorResponse?.httpStatusCode}` : errorResponse?.errorCode ?? `Error response with status: ${errorResponse?.httpStatusCode}`
            };
        }
    };
    if (payload?.search?.criteria?.location?.placeIds?.length === 0) {
        addSavedSearchEmail(success, errorOnWl, {
            body: wlBody
        });
    } else {
        await addSavedSearchEmailLI(success, error, {
            config: configCalls,
            body: legacyBody
        });
    }
    while(result.error === 'undefined'){
        await new Promise((resolve)=>setTimeout(resolve, 50));
    }
    return result;
};

const commonSuccess = (response)=>{
    return {
        identity: response?.id ?? `No ID provided on success`
    };
};
const commonError = (errorResponse)=>{
    return {
        error: errorResponse?.errorCode === 'UNKNOWN_ERROR' ? `Error response with status: ${errorResponse?.httpStatusCode}` : errorResponse?.errorCode ?? `Error response with status: ${errorResponse?.httpStatusCode}`
    };
};

const useSavedSearch = (stage, brand, token)=>{
    const [savedSearches, setSavedSearches] = useState([]);
    const [lastSavedSearch, setLastSavedSearch] = useState(null);
    const [error, setError] = useState();
    const [isFetching, setIsFetching] = useState(true);
    const [isLoggedIn, setIsLoggedIn] = useState(getToken() !== undefined);
    const [authenticationToken, setAuthenticationToken] = useState(token);
    const config = getCustomBrandConfig(brand);
    if (!config) {
        throw new Error('Brand not supported');
    }
    if (!authenticationToken) {
        const cookieToken = getToken();
        if (cookieToken) {
            setAuthenticationToken(cookieToken);
        }
    }
    const fetchSavedSearches = async ()=>{
        setIsFetching(true);
        const options = {
            authenticationToken};
        const onError = (errorResponse)=>{
            setError(errorResponse);
            setIsLoggedIn(false);
            setIsFetching(false);
        };
        await getSavedSearches((response)=>{
            if (response.data.length > 0) {
                const latest = getMostRecentSearch(response.data);
                setLastSavedSearch(latest);
                setSavedSearches((oldState)=>[
                        ...oldState,
                        ...response.data
                    ]);
            }
        }, onError, options);
        setIsFetching(false);
    };
    return {
        savedSearches,
        lastSavedSearch,
        isFetching,
        fetchSavedSearches,
        isLoggedIn,
        setIsLoggedIn,
        setSavedSearches,
        error
    };
};

const getLocalStorageItem = (key)=>{
    if (!isLocalStorageUndefined()) return localStorage.getItem(key);
    else return null;
};
const setLocalStorageItem = (key, value)=>{
    if (!isLocalStorageUndefined()) localStorage.setItem(key, value);
};
const removeLocalStorageItem = (key)=>{
    if (!isLocalStorageUndefined()) localStorage.removeItem(key);
};

const JWT_COOKIE_KEY = 'oauth.access.token';
const CLIENT_TOKEN = 'auth.client.token';
const getToken = ()=>{
    if (!isDocumentUndefined()) {
        const cookieMatchArray = document.cookie.match(`(^|;)\\s*${JWT_COOKIE_KEY}\\s*=\\s*([^;]+)`);
        return cookieMatchArray ? cookieMatchArray.pop() : undefined;
    } else return undefined;
};
const getParams = ()=>{
    const params = new URLSearchParams(window?.location?.search ?? '');
    const token = params.get('token');
    const ssid = params.get('ssid');
    const ac = params.get('ac');
    if (!token && !ssid) return null;
    return {
        token,
        ssid,
        ac
    };
};
const getLegacyParams = ()=>{
    const params = new URLSearchParams(window?.location?.search ?? '');
    const idalerteimmo = params.get('idalerteimmo');
    const identifieur = params.get('identifieur');
    if (!idalerteimmo || !identifieur) {
        return null;
    }
    return {
        idalert: idalerteimmo,
        identifier: identifieur
    };
};
const getBasicKey = (basicKeys, brand)=>{
    switch(brand){
        case 'imn':
            return basicKeys.imn;
        case 'iwt':
            return basicKeys.iwt;
        default:
            return basicKeys.imn;
    }
};
const getIWTAnonymousAuthToken = async ({ basicsKey, brand, stage })=>{
    const savedToken = getLocalStorageItem(CLIENT_TOKEN);
    if (savedToken) {
        return savedToken;
    }
    const authKey = getBasicKey(basicsKey, brand);
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Basic ${btoa(authKey)}`
    };
    const body = {
        grant_type: 'client_credentials'
    };
    const fetchInit = {
        method: 'POST',
        body: JSON.stringify(body),
        headers
    };
    const legacyEndpoint = createLegacyEndpoint(stage, brand);
    const url = legacyEndpoint + '/auth/oauth/token?grant_type=client_credentials';
    const response = await fetch(url, fetchInit);
    const responseJson = await response.json();
    setLocalStorageItem(CLIENT_TOKEN, responseJson.access_token);
    return responseJson.access_token;
};

const TrackingWrapper = ({ children, isDevMode })=>{
    const [consent, setConsent] = useState(false);
    useEffect(()=>{
        const isAuth = getToken();
        if (isAuth) {
            setConsent(true);
        }
    }, []);
    const memoizedChildren = useMemo(()=>/*#__PURE__*/ jsx(Fragment, {
            children: children
        }), [
        children
    ]);
    return /*#__PURE__*/ jsx(WithThor, {
        userConsent: consent,
        compatibilities: {
            GA3: false,
            GA4: true
        },
        devMode: isDevMode,
        children: memoizedChildren
    });
};

const URL_createIntermediaryMatchingMandate = '/contact-request-service/search-mandate';
const createIntermediaryMatchingMandate = async (success, error, options)=>{
    const { body } = options;
    const authenticationToken = getToken();
    return baseApiWithResponse(success, error, {
        url: URL_createIntermediaryMatchingMandate,
        httpMethod: 'POST',
        authenticationToken,
        body
    });
};

var isCheckBoxInput = (element) => element.type === 'checkbox';

var isDateObject = (value) => value instanceof Date;

var isNullOrUndefined = (value) => value == null;

const isObjectType = (value) => typeof value === 'object';
var isObject$1 = (value) => !isNullOrUndefined(value) &&
    !Array.isArray(value) &&
    isObjectType(value) &&
    !isDateObject(value);

var getEventValue = (event) => isObject$1(event) && event.target
    ? isCheckBoxInput(event.target)
        ? event.target.checked
        : event.target.value
    : event;

var getNodeParentName = (name) => name.substring(0, name.search(/\.\d+(\.|$)/)) || name;

var isNameInFieldArray = (names, name) => names.has(getNodeParentName(name));

var isPlainObject = (tempObject) => {
    const prototypeCopy = tempObject.constructor && tempObject.constructor.prototype;
    return (isObject$1(prototypeCopy) && prototypeCopy.hasOwnProperty('isPrototypeOf'));
};

var isWeb = typeof window !== 'undefined' &&
    typeof window.HTMLElement !== 'undefined' &&
    typeof document !== 'undefined';

function cloneObject(data) {
    let copy;
    const isArray = Array.isArray(data);
    const isFileListInstance = typeof FileList !== 'undefined' ? data instanceof FileList : false;
    if (data instanceof Date) {
        copy = new Date(data);
    }
    else if (data instanceof Set) {
        copy = new Set(data);
    }
    else if (!(isWeb && (data instanceof Blob || isFileListInstance)) &&
        (isArray || isObject$1(data))) {
        copy = isArray ? [] : {};
        if (!isArray && !isPlainObject(data)) {
            copy = data;
        }
        else {
            for (const key in data) {
                if (data.hasOwnProperty(key)) {
                    copy[key] = cloneObject(data[key]);
                }
            }
        }
    }
    else {
        return data;
    }
    return copy;
}

var compact = (value) => Array.isArray(value) ? value.filter(Boolean) : [];

var isUndefined = (val) => val === undefined;

var get = (object, path, defaultValue) => {
    if (!path || !isObject$1(object)) {
        return defaultValue;
    }
    const result = compact(path.split(/[,[\].]+?/)).reduce((result, key) => isNullOrUndefined(result) ? result : result[key], object);
    return isUndefined(result) || result === object
        ? isUndefined(object[path])
            ? defaultValue
            : object[path]
        : result;
};

var isBoolean = (value) => typeof value === 'boolean';

var isKey = (value) => /^\w*$/.test(value);

var stringToPath = (input) => compact(input.replace(/["|']|\]/g, '').split(/\.|\[/));

var set = (object, path, value) => {
    let index = -1;
    const tempPath = isKey(path) ? [path] : stringToPath(path);
    const length = tempPath.length;
    const lastIndex = length - 1;
    while (++index < length) {
        const key = tempPath[index];
        let newValue = value;
        if (index !== lastIndex) {
            const objValue = object[key];
            newValue =
                isObject$1(objValue) || Array.isArray(objValue)
                    ? objValue
                    : !isNaN(+tempPath[index + 1])
                        ? []
                        : {};
        }
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
            return;
        }
        object[key] = newValue;
        object = object[key];
    }
    return object;
};

const EVENTS = {
    BLUR: 'blur',
    FOCUS_OUT: 'focusout',
    CHANGE: 'change',
};
const VALIDATION_MODE = {
    onBlur: 'onBlur',
    onChange: 'onChange',
    onSubmit: 'onSubmit',
    onTouched: 'onTouched',
    all: 'all',
};
const INPUT_VALIDATION_RULES = {
    max: 'max',
    min: 'min',
    maxLength: 'maxLength',
    minLength: 'minLength',
    pattern: 'pattern',
    required: 'required',
    validate: 'validate',
};

const HookFormContext = React.createContext(null);
/**
 * This custom hook allows you to access the form context. useFormContext is intended to be used in deeply nested structures, where it would become inconvenient to pass the context as a prop. To be used with {@link FormProvider}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @returns return all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */
const useFormContext = () => React.useContext(HookFormContext);

var getProxyFormState = (formState, control, localProxyFormState, isRoot = true) => {
    const result = {
        defaultValues: control._defaultValues,
    };
    for (const key in formState) {
        Object.defineProperty(result, key, {
            get: () => {
                const _key = key;
                if (control._proxyFormState[_key] !== VALIDATION_MODE.all) {
                    control._proxyFormState[_key] = !isRoot || VALIDATION_MODE.all;
                }
                localProxyFormState && (localProxyFormState[_key] = true);
                return formState[_key];
            },
        });
    }
    return result;
};

var isEmptyObject = (value) => isObject$1(value) && !Object.keys(value).length;

var shouldRenderFormState = (formStateData, _proxyFormState, updateFormState, isRoot) => {
    updateFormState(formStateData);
    const { name, ...formState } = formStateData;
    return (isEmptyObject(formState) ||
        Object.keys(formState).length >= Object.keys(_proxyFormState).length ||
        Object.keys(formState).find((key) => _proxyFormState[key] ===
            (!isRoot || VALIDATION_MODE.all)));
};

var convertToArrayPayload = (value) => (Array.isArray(value) ? value : [value]);

var shouldSubscribeByName = (name, signalName, exact) => !name ||
    !signalName ||
    name === signalName ||
    convertToArrayPayload(name).some((currentName) => currentName &&
        (exact
            ? currentName === signalName
            : currentName.startsWith(signalName) ||
                signalName.startsWith(currentName)));

function useSubscribe(props) {
    const _props = React.useRef(props);
    _props.current = props;
    React.useEffect(() => {
        const subscription = !props.disabled &&
            _props.current.subject &&
            _props.current.subject.subscribe({
                next: _props.current.next,
            });
        return () => {
            subscription && subscription.unsubscribe();
        };
    }, [props.disabled]);
}

/**
 * This custom hook allows you to subscribe to each form state, and isolate the re-render at the custom hook level. It has its scope in terms of form state subscription, so it would not affect other useFormState and useForm. Using this hook can reduce the re-render impact on large and complex form application.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformstate) • [Demo](https://codesandbox.io/s/useformstate-75xly)
 *
 * @param props - include options on specify fields to subscribe. {@link UseFormStateReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, control } = useForm({
 *     defaultValues: {
 *     firstName: "firstName"
 *   }});
 *   const { dirtyFields } = useFormState({
 *     control
 *   });
 *   const onSubmit = (data) => console.log(data);
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input {...register("firstName")} placeholder="First Name" />
 *       {dirtyFields.firstName && <p>Field is dirty.</p>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */
function useFormState(props) {
    const methods = useFormContext();
    const { control = methods.control, disabled, name, exact } = props || {};
    const [formState, updateFormState] = React.useState(control._formState);
    const _mounted = React.useRef(true);
    const _localProxyFormState = React.useRef({
        isDirty: false,
        isLoading: false,
        dirtyFields: false,
        touchedFields: false,
        validatingFields: false,
        isValidating: false,
        isValid: false,
        errors: false,
    });
    const _name = React.useRef(name);
    _name.current = name;
    useSubscribe({
        disabled,
        next: (value) => _mounted.current &&
            shouldSubscribeByName(_name.current, value.name, exact) &&
            shouldRenderFormState(value, _localProxyFormState.current, control._updateFormState) &&
            updateFormState({
                ...control._formState,
                ...value,
            }),
        subject: control._subjects.state,
    });
    React.useEffect(() => {
        _mounted.current = true;
        _localProxyFormState.current.isValid && control._updateValid(true);
        return () => {
            _mounted.current = false;
        };
    }, [control]);
    return React.useMemo(() => getProxyFormState(formState, control, _localProxyFormState.current, false), [formState, control]);
}

var isString = (value) => typeof value === 'string';

var generateWatchOutput = (names, _names, formValues, isGlobal, defaultValue) => {
    if (isString(names)) {
        isGlobal && _names.watch.add(names);
        return get(formValues, names, defaultValue);
    }
    if (Array.isArray(names)) {
        return names.map((fieldName) => (isGlobal && _names.watch.add(fieldName), get(formValues, fieldName)));
    }
    isGlobal && (_names.watchAll = true);
    return formValues;
};

/**
 * Custom hook to subscribe to field change and isolate re-rendering at the component level.
 *
 * @remarks
 *
 * [API](https://react-hook-form.com/docs/usewatch) • [Demo](https://codesandbox.io/s/react-hook-form-v7-ts-usewatch-h9i5e)
 *
 * @example
 * ```tsx
 * const { control } = useForm();
 * const values = useWatch({
 *   name: "fieldName"
 *   control,
 * })
 * ```
 */
function useWatch(props) {
    const methods = useFormContext();
    const { control = methods.control, name, defaultValue, disabled, exact, } = props || {};
    const _name = React.useRef(name);
    _name.current = name;
    useSubscribe({
        disabled,
        subject: control._subjects.values,
        next: (formState) => {
            if (shouldSubscribeByName(_name.current, formState.name, exact)) {
                updateValue(cloneObject(generateWatchOutput(_name.current, control._names, formState.values || control._formValues, false, defaultValue)));
            }
        },
    });
    const [value, updateValue] = React.useState(control._getWatch(name, defaultValue));
    React.useEffect(() => control._removeUnmounted());
    return value;
}

/**
 * Custom hook to work with controlled component, this function provide you with both form and field level state. Re-render is isolated at the hook level.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller) • [Demo](https://codesandbox.io/s/usecontroller-0o8px)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns field properties, field and form state. {@link UseControllerReturn}
 *
 * @example
 * ```tsx
 * function Input(props) {
 *   const { field, fieldState, formState } = useController(props);
 *   return (
 *     <div>
 *       <input {...field} placeholder={props.name} />
 *       <p>{fieldState.isTouched && "Touched"}</p>
 *       <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *     </div>
 *   );
 * }
 * ```
 */
function useController(props) {
    const methods = useFormContext();
    const { name, disabled, control = methods.control, shouldUnregister } = props;
    const isArrayField = isNameInFieldArray(control._names.array, name);
    const value = useWatch({
        control,
        name,
        defaultValue: get(control._formValues, name, get(control._defaultValues, name, props.defaultValue)),
        exact: true,
    });
    const formState = useFormState({
        control,
        name,
        exact: true,
    });
    const _registerProps = React.useRef(control.register(name, {
        ...props.rules,
        value,
        ...(isBoolean(props.disabled) ? { disabled: props.disabled } : {}),
    }));
    const fieldState = React.useMemo(() => Object.defineProperties({}, {
        invalid: {
            enumerable: true,
            get: () => !!get(formState.errors, name),
        },
        isDirty: {
            enumerable: true,
            get: () => !!get(formState.dirtyFields, name),
        },
        isTouched: {
            enumerable: true,
            get: () => !!get(formState.touchedFields, name),
        },
        isValidating: {
            enumerable: true,
            get: () => !!get(formState.validatingFields, name),
        },
        error: {
            enumerable: true,
            get: () => get(formState.errors, name),
        },
    }), [formState, name]);
    const field = React.useMemo(() => ({
        name,
        value,
        ...(isBoolean(disabled) || formState.disabled
            ? { disabled: formState.disabled || disabled }
            : {}),
        onChange: (event) => _registerProps.current.onChange({
            target: {
                value: getEventValue(event),
                name: name,
            },
            type: EVENTS.CHANGE,
        }),
        onBlur: () => _registerProps.current.onBlur({
            target: {
                value: get(control._formValues, name),
                name: name,
            },
            type: EVENTS.BLUR,
        }),
        ref: (elm) => {
            const field = get(control._fields, name);
            if (field && elm) {
                field._f.ref = {
                    focus: () => elm.focus(),
                    select: () => elm.select(),
                    setCustomValidity: (message) => elm.setCustomValidity(message),
                    reportValidity: () => elm.reportValidity(),
                };
            }
        },
    }), [
        name,
        control._formValues,
        disabled,
        formState.disabled,
        value,
        control._fields,
    ]);
    React.useEffect(() => {
        const _shouldUnregisterField = control._options.shouldUnregister || shouldUnregister;
        const updateMounted = (name, value) => {
            const field = get(control._fields, name);
            if (field && field._f) {
                field._f.mount = value;
            }
        };
        updateMounted(name, true);
        if (_shouldUnregisterField) {
            const value = cloneObject(get(control._options.defaultValues, name));
            set(control._defaultValues, name, value);
            if (isUndefined(get(control._formValues, name))) {
                set(control._formValues, name, value);
            }
        }
        !isArrayField && control.register(name);
        return () => {
            (isArrayField
                ? _shouldUnregisterField && !control._state.action
                : _shouldUnregisterField)
                ? control.unregister(name)
                : updateMounted(name, false);
        };
    }, [name, control, isArrayField, shouldUnregister]);
    React.useEffect(() => {
        control._updateDisabledField({
            disabled,
            fields: control._fields,
            name,
        });
    }, [disabled, name, control]);
    return React.useMemo(() => ({
        field,
        formState,
        fieldState,
    }), [field, formState, fieldState]);
}

/**
 * Component based on `useController` hook to work with controlled component.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller/controller) • [Demo](https://codesandbox.io/s/react-hook-form-v6-controller-ts-jwyzw) • [Video](https://www.youtube.com/watch?v=N2UNk_UCVyA)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns provide field handler functions, field and form state.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control } = useForm<FormValues>({
 *     defaultValues: {
 *       test: ""
 *     }
 *   });
 *
 *   return (
 *     <form>
 *       <Controller
 *         control={control}
 *         name="test"
 *         render={({ field: { onChange, onBlur, value, ref }, formState, fieldState }) => (
 *           <>
 *             <input
 *               onChange={onChange} // send value to hook form
 *               onBlur={onBlur} // notify when input is touched
 *               value={value} // return updated value
 *               ref={ref} // set ref for focus management
 *             />
 *             <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *             <p>{fieldState.isTouched ? "touched" : ""}</p>
 *           </>
 *         )}
 *       />
 *     </form>
 *   );
 * }
 * ```
 */
const Controller = (props) => props.render(useController(props));

var appendErrors = (name, validateAllFieldCriteria, errors, type, message) => validateAllFieldCriteria
    ? {
        ...errors[name],
        types: {
            ...(errors[name] && errors[name].types ? errors[name].types : {}),
            [type]: message || true,
        },
    }
    : {};

var getValidationModes = (mode) => ({
    isOnSubmit: !mode || mode === VALIDATION_MODE.onSubmit,
    isOnBlur: mode === VALIDATION_MODE.onBlur,
    isOnChange: mode === VALIDATION_MODE.onChange,
    isOnAll: mode === VALIDATION_MODE.all,
    isOnTouch: mode === VALIDATION_MODE.onTouched,
});

var isWatched = (name, _names, isBlurEvent) => !isBlurEvent &&
    (_names.watchAll ||
        _names.watch.has(name) ||
        [..._names.watch].some((watchName) => name.startsWith(watchName) &&
            /^\.\w+/.test(name.slice(watchName.length))));

const iterateFieldsByAction = (fields, action, fieldsNames, abortEarly) => {
    for (const key of fieldsNames || Object.keys(fields)) {
        const field = get(fields, key);
        if (field) {
            const { _f, ...currentField } = field;
            if (_f) {
                if (_f.refs && _f.refs[0] && action(_f.refs[0], key) && !abortEarly) {
                    return true;
                }
                else if (_f.ref && action(_f.ref, _f.name) && !abortEarly) {
                    return true;
                }
                else {
                    if (iterateFieldsByAction(currentField, action)) {
                        break;
                    }
                }
            }
            else if (isObject$1(currentField)) {
                if (iterateFieldsByAction(currentField, action)) {
                    break;
                }
            }
        }
    }
    return;
};

var updateFieldArrayRootError = (errors, error, name) => {
    const fieldArrayErrors = convertToArrayPayload(get(errors, name));
    set(fieldArrayErrors, 'root', error[name]);
    set(errors, name, fieldArrayErrors);
    return errors;
};

var isFileInput = (element) => element.type === 'file';

var isFunction = (value) => typeof value === 'function';

var isHTMLElement = (value) => {
    if (!isWeb) {
        return false;
    }
    const owner = value ? value.ownerDocument : 0;
    return (value instanceof
        (owner && owner.defaultView ? owner.defaultView.HTMLElement : HTMLElement));
};

var isMessage = (value) => isString(value);

var isRadioInput = (element) => element.type === 'radio';

var isRegex = (value) => value instanceof RegExp;

const defaultResult = {
    value: false,
    isValid: false,
};
const validResult = { value: true, isValid: true };
var getCheckboxValue = (options) => {
    if (Array.isArray(options)) {
        if (options.length > 1) {
            const values = options
                .filter((option) => option && option.checked && !option.disabled)
                .map((option) => option.value);
            return { value: values, isValid: !!values.length };
        }
        return options[0].checked && !options[0].disabled
            ? // @ts-expect-error expected to work in the browser
                options[0].attributes && !isUndefined(options[0].attributes.value)
                    ? isUndefined(options[0].value) || options[0].value === ''
                        ? validResult
                        : { value: options[0].value, isValid: true }
                    : validResult
            : defaultResult;
    }
    return defaultResult;
};

const defaultReturn = {
    isValid: false,
    value: null,
};
var getRadioValue = (options) => Array.isArray(options)
    ? options.reduce((previous, option) => option && option.checked && !option.disabled
        ? {
            isValid: true,
            value: option.value,
        }
        : previous, defaultReturn)
    : defaultReturn;

function getValidateError(result, ref, type = 'validate') {
    if (isMessage(result) ||
        (Array.isArray(result) && result.every(isMessage)) ||
        (isBoolean(result) && !result)) {
        return {
            type,
            message: isMessage(result) ? result : '',
            ref,
        };
    }
}

var getValueAndMessage = (validationData) => isObject$1(validationData) && !isRegex(validationData)
    ? validationData
    : {
        value: validationData,
        message: '',
    };

var validateField = async (field, disabledFieldNames, formValues, validateAllFieldCriteria, shouldUseNativeValidation, isFieldArray) => {
    const { ref, refs, required, maxLength, minLength, min, max, pattern, validate, name, valueAsNumber, mount, } = field._f;
    const inputValue = get(formValues, name);
    if (!mount || disabledFieldNames.has(name)) {
        return {};
    }
    const inputRef = refs ? refs[0] : ref;
    const setCustomValidity = (message) => {
        if (shouldUseNativeValidation && inputRef.reportValidity) {
            inputRef.setCustomValidity(isBoolean(message) ? '' : message || '');
            inputRef.reportValidity();
        }
    };
    const error = {};
    const isRadio = isRadioInput(ref);
    const isCheckBox = isCheckBoxInput(ref);
    const isRadioOrCheckbox = isRadio || isCheckBox;
    const isEmpty = ((valueAsNumber || isFileInput(ref)) &&
        isUndefined(ref.value) &&
        isUndefined(inputValue)) ||
        (isHTMLElement(ref) && ref.value === '') ||
        inputValue === '' ||
        (Array.isArray(inputValue) && !inputValue.length);
    const appendErrorsCurry = appendErrors.bind(null, name, validateAllFieldCriteria, error);
    const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = INPUT_VALIDATION_RULES.maxLength, minType = INPUT_VALIDATION_RULES.minLength) => {
        const message = exceedMax ? maxLengthMessage : minLengthMessage;
        error[name] = {
            type: exceedMax ? maxType : minType,
            message,
            ref,
            ...appendErrorsCurry(exceedMax ? maxType : minType, message),
        };
    };
    if (isFieldArray
        ? !Array.isArray(inputValue) || !inputValue.length
        : required &&
            ((!isRadioOrCheckbox && (isEmpty || isNullOrUndefined(inputValue))) ||
                (isBoolean(inputValue) && !inputValue) ||
                (isCheckBox && !getCheckboxValue(refs).isValid) ||
                (isRadio && !getRadioValue(refs).isValid))) {
        const { value, message } = isMessage(required)
            ? { value: !!required, message: required }
            : getValueAndMessage(required);
        if (value) {
            error[name] = {
                type: INPUT_VALIDATION_RULES.required,
                message,
                ref: inputRef,
                ...appendErrorsCurry(INPUT_VALIDATION_RULES.required, message),
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (!isEmpty && (!isNullOrUndefined(min) || !isNullOrUndefined(max))) {
        let exceedMax;
        let exceedMin;
        const maxOutput = getValueAndMessage(max);
        const minOutput = getValueAndMessage(min);
        if (!isNullOrUndefined(inputValue) && !isNaN(inputValue)) {
            const valueNumber = ref.valueAsNumber ||
                (inputValue ? +inputValue : inputValue);
            if (!isNullOrUndefined(maxOutput.value)) {
                exceedMax = valueNumber > maxOutput.value;
            }
            if (!isNullOrUndefined(minOutput.value)) {
                exceedMin = valueNumber < minOutput.value;
            }
        }
        else {
            const valueDate = ref.valueAsDate || new Date(inputValue);
            const convertTimeToDate = (time) => new Date(new Date().toDateString() + ' ' + time);
            const isTime = ref.type == 'time';
            const isWeek = ref.type == 'week';
            if (isString(maxOutput.value) && inputValue) {
                exceedMax = isTime
                    ? convertTimeToDate(inputValue) > convertTimeToDate(maxOutput.value)
                    : isWeek
                        ? inputValue > maxOutput.value
                        : valueDate > new Date(maxOutput.value);
            }
            if (isString(minOutput.value) && inputValue) {
                exceedMin = isTime
                    ? convertTimeToDate(inputValue) < convertTimeToDate(minOutput.value)
                    : isWeek
                        ? inputValue < minOutput.value
                        : valueDate < new Date(minOutput.value);
            }
        }
        if (exceedMax || exceedMin) {
            getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, INPUT_VALIDATION_RULES.max, INPUT_VALIDATION_RULES.min);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if ((maxLength || minLength) &&
        !isEmpty &&
        (isString(inputValue) || (isFieldArray && Array.isArray(inputValue)))) {
        const maxLengthOutput = getValueAndMessage(maxLength);
        const minLengthOutput = getValueAndMessage(minLength);
        const exceedMax = !isNullOrUndefined(maxLengthOutput.value) &&
            inputValue.length > +maxLengthOutput.value;
        const exceedMin = !isNullOrUndefined(minLengthOutput.value) &&
            inputValue.length < +minLengthOutput.value;
        if (exceedMax || exceedMin) {
            getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if (pattern && !isEmpty && isString(inputValue)) {
        const { value: patternValue, message } = getValueAndMessage(pattern);
        if (isRegex(patternValue) && !inputValue.match(patternValue)) {
            error[name] = {
                type: INPUT_VALIDATION_RULES.pattern,
                message,
                ref,
                ...appendErrorsCurry(INPUT_VALIDATION_RULES.pattern, message),
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (validate) {
        if (isFunction(validate)) {
            const result = await validate(inputValue, formValues);
            const validateError = getValidateError(result, inputRef);
            if (validateError) {
                error[name] = {
                    ...validateError,
                    ...appendErrorsCurry(INPUT_VALIDATION_RULES.validate, validateError.message),
                };
                if (!validateAllFieldCriteria) {
                    setCustomValidity(validateError.message);
                    return error;
                }
            }
        }
        else if (isObject$1(validate)) {
            let validationResult = {};
            for (const key in validate) {
                if (!isEmptyObject(validationResult) && !validateAllFieldCriteria) {
                    break;
                }
                const validateError = getValidateError(await validate[key](inputValue, formValues), inputRef, key);
                if (validateError) {
                    validationResult = {
                        ...validateError,
                        ...appendErrorsCurry(key, validateError.message),
                    };
                    setCustomValidity(validateError.message);
                    if (validateAllFieldCriteria) {
                        error[name] = validationResult;
                    }
                }
            }
            if (!isEmptyObject(validationResult)) {
                error[name] = {
                    ref: inputRef,
                    ...validationResult,
                };
                if (!validateAllFieldCriteria) {
                    return error;
                }
            }
        }
    }
    setCustomValidity(true);
    return error;
};

function baseGet(object, updatePath) {
    const length = updatePath.slice(0, -1).length;
    let index = 0;
    while (index < length) {
        object = isUndefined(object) ? index++ : object[updatePath[index++]];
    }
    return object;
}
function isEmptyArray(obj) {
    for (const key in obj) {
        if (obj.hasOwnProperty(key) && !isUndefined(obj[key])) {
            return false;
        }
    }
    return true;
}
function unset(object, path) {
    const paths = Array.isArray(path)
        ? path
        : isKey(path)
            ? [path]
            : stringToPath(path);
    const childObject = paths.length === 1 ? object : baseGet(object, paths);
    const index = paths.length - 1;
    const key = paths[index];
    if (childObject) {
        delete childObject[key];
    }
    if (index !== 0 &&
        ((isObject$1(childObject) && isEmptyObject(childObject)) ||
            (Array.isArray(childObject) && isEmptyArray(childObject)))) {
        unset(object, paths.slice(0, -1));
    }
    return object;
}

var createSubject = () => {
    let _observers = [];
    const next = (value) => {
        for (const observer of _observers) {
            observer.next && observer.next(value);
        }
    };
    const subscribe = (observer) => {
        _observers.push(observer);
        return {
            unsubscribe: () => {
                _observers = _observers.filter((o) => o !== observer);
            },
        };
    };
    const unsubscribe = () => {
        _observers = [];
    };
    return {
        get observers() {
            return _observers;
        },
        next,
        subscribe,
        unsubscribe,
    };
};

var isPrimitive = (value) => isNullOrUndefined(value) || !isObjectType(value);

function deepEqual(object1, object2) {
    if (isPrimitive(object1) || isPrimitive(object2)) {
        return object1 === object2;
    }
    if (isDateObject(object1) && isDateObject(object2)) {
        return object1.getTime() === object2.getTime();
    }
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) {
        return false;
    }
    for (const key of keys1) {
        const val1 = object1[key];
        if (!keys2.includes(key)) {
            return false;
        }
        if (key !== 'ref') {
            const val2 = object2[key];
            if ((isDateObject(val1) && isDateObject(val2)) ||
                (isObject$1(val1) && isObject$1(val2)) ||
                (Array.isArray(val1) && Array.isArray(val2))
                ? !deepEqual(val1, val2)
                : val1 !== val2) {
                return false;
            }
        }
    }
    return true;
}

var isMultipleSelect = (element) => element.type === `select-multiple`;

var isRadioOrCheckbox = (ref) => isRadioInput(ref) || isCheckBoxInput(ref);

var live = (ref) => isHTMLElement(ref) && ref.isConnected;

var objectHasFunction = (data) => {
    for (const key in data) {
        if (isFunction(data[key])) {
            return true;
        }
    }
    return false;
};

function markFieldsDirty(data, fields = {}) {
    const isParentNodeArray = Array.isArray(data);
    if (isObject$1(data) || isParentNodeArray) {
        for (const key in data) {
            if (Array.isArray(data[key]) ||
                (isObject$1(data[key]) && !objectHasFunction(data[key]))) {
                fields[key] = Array.isArray(data[key]) ? [] : {};
                markFieldsDirty(data[key], fields[key]);
            }
            else if (!isNullOrUndefined(data[key])) {
                fields[key] = true;
            }
        }
    }
    return fields;
}
function getDirtyFieldsFromDefaultValues(data, formValues, dirtyFieldsFromValues) {
    const isParentNodeArray = Array.isArray(data);
    if (isObject$1(data) || isParentNodeArray) {
        for (const key in data) {
            if (Array.isArray(data[key]) ||
                (isObject$1(data[key]) && !objectHasFunction(data[key]))) {
                if (isUndefined(formValues) ||
                    isPrimitive(dirtyFieldsFromValues[key])) {
                    dirtyFieldsFromValues[key] = Array.isArray(data[key])
                        ? markFieldsDirty(data[key], [])
                        : { ...markFieldsDirty(data[key]) };
                }
                else {
                    getDirtyFieldsFromDefaultValues(data[key], isNullOrUndefined(formValues) ? {} : formValues[key], dirtyFieldsFromValues[key]);
                }
            }
            else {
                dirtyFieldsFromValues[key] = !deepEqual(data[key], formValues[key]);
            }
        }
    }
    return dirtyFieldsFromValues;
}
var getDirtyFields = (defaultValues, formValues) => getDirtyFieldsFromDefaultValues(defaultValues, formValues, markFieldsDirty(formValues));

var getFieldValueAs = (value, { valueAsNumber, valueAsDate, setValueAs }) => isUndefined(value)
    ? value
    : valueAsNumber
        ? value === ''
            ? NaN
            : value
                ? +value
                : value
        : valueAsDate && isString(value)
            ? new Date(value)
            : setValueAs
                ? setValueAs(value)
                : value;

function getFieldValue(_f) {
    const ref = _f.ref;
    if (isFileInput(ref)) {
        return ref.files;
    }
    if (isRadioInput(ref)) {
        return getRadioValue(_f.refs).value;
    }
    if (isMultipleSelect(ref)) {
        return [...ref.selectedOptions].map(({ value }) => value);
    }
    if (isCheckBoxInput(ref)) {
        return getCheckboxValue(_f.refs).value;
    }
    return getFieldValueAs(isUndefined(ref.value) ? _f.ref.value : ref.value, _f);
}

var getResolverOptions = (fieldsNames, _fields, criteriaMode, shouldUseNativeValidation) => {
    const fields = {};
    for (const name of fieldsNames) {
        const field = get(_fields, name);
        field && set(fields, name, field._f);
    }
    return {
        criteriaMode,
        names: [...fieldsNames],
        fields,
        shouldUseNativeValidation,
    };
};

var getRuleValue = (rule) => isUndefined(rule)
    ? rule
    : isRegex(rule)
        ? rule.source
        : isObject$1(rule)
            ? isRegex(rule.value)
                ? rule.value.source
                : rule.value
            : rule;

const ASYNC_FUNCTION = 'AsyncFunction';
var hasPromiseValidation = (fieldReference) => !!fieldReference &&
    !!fieldReference.validate &&
    !!((isFunction(fieldReference.validate) &&
        fieldReference.validate.constructor.name === ASYNC_FUNCTION) ||
        (isObject$1(fieldReference.validate) &&
            Object.values(fieldReference.validate).find((validateFunction) => validateFunction.constructor.name === ASYNC_FUNCTION)));

var hasValidation = (options) => options.mount &&
    (options.required ||
        options.min ||
        options.max ||
        options.maxLength ||
        options.minLength ||
        options.pattern ||
        options.validate);

function schemaErrorLookup(errors, _fields, name) {
    const error = get(errors, name);
    if (error || isKey(name)) {
        return {
            error,
            name,
        };
    }
    const names = name.split('.');
    while (names.length) {
        const fieldName = names.join('.');
        const field = get(_fields, fieldName);
        const foundError = get(errors, fieldName);
        if (field && !Array.isArray(field) && name !== fieldName) {
            return { name };
        }
        if (foundError && foundError.type) {
            return {
                name: fieldName,
                error: foundError,
            };
        }
        names.pop();
    }
    return {
        name,
    };
}

var skipValidation = (isBlurEvent, isTouched, isSubmitted, reValidateMode, mode) => {
    if (mode.isOnAll) {
        return false;
    }
    else if (!isSubmitted && mode.isOnTouch) {
        return !(isTouched || isBlurEvent);
    }
    else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) {
        return !isBlurEvent;
    }
    else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) {
        return isBlurEvent;
    }
    return true;
};

var unsetEmptyArray = (ref, name) => !compact(get(ref, name)).length && unset(ref, name);

const defaultOptions = {
    mode: VALIDATION_MODE.onSubmit,
    reValidateMode: VALIDATION_MODE.onChange,
    shouldFocusError: true,
};
function createFormControl(props = {}) {
    let _options = {
        ...defaultOptions,
        ...props,
    };
    let _formState = {
        submitCount: 0,
        isDirty: false,
        isLoading: isFunction(_options.defaultValues),
        isValidating: false,
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        touchedFields: {},
        dirtyFields: {},
        validatingFields: {},
        errors: _options.errors || {},
        disabled: _options.disabled || false,
    };
    let _fields = {};
    let _defaultValues = isObject$1(_options.defaultValues) || isObject$1(_options.values)
        ? cloneObject(_options.defaultValues || _options.values) || {}
        : {};
    let _formValues = _options.shouldUnregister
        ? {}
        : cloneObject(_defaultValues);
    let _state = {
        action: false,
        mount: false,
        watch: false,
    };
    let _names = {
        mount: new Set(),
        disabled: new Set(),
        unMount: new Set(),
        array: new Set(),
        watch: new Set(),
    };
    let delayErrorCallback;
    let timer = 0;
    const _proxyFormState = {
        isDirty: false,
        dirtyFields: false,
        validatingFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false,
    };
    const _subjects = {
        values: createSubject(),
        array: createSubject(),
        state: createSubject(),
    };
    const validationModeBeforeSubmit = getValidationModes(_options.mode);
    const validationModeAfterSubmit = getValidationModes(_options.reValidateMode);
    const shouldDisplayAllAssociatedErrors = _options.criteriaMode === VALIDATION_MODE.all;
    const debounce = (callback) => (wait) => {
        clearTimeout(timer);
        timer = setTimeout(callback, wait);
    };
    const _updateValid = async (shouldUpdateValid) => {
        if (!_options.disabled && (_proxyFormState.isValid || shouldUpdateValid)) {
            const isValid = _options.resolver
                ? isEmptyObject((await _executeSchema()).errors)
                : await executeBuiltInValidation(_fields, true);
            if (isValid !== _formState.isValid) {
                _subjects.state.next({
                    isValid,
                });
            }
        }
    };
    const _updateIsValidating = (names, isValidating) => {
        if (!_options.disabled &&
            (_proxyFormState.isValidating || _proxyFormState.validatingFields)) {
            (names || Array.from(_names.mount)).forEach((name) => {
                if (name) {
                    isValidating
                        ? set(_formState.validatingFields, name, isValidating)
                        : unset(_formState.validatingFields, name);
                }
            });
            _subjects.state.next({
                validatingFields: _formState.validatingFields,
                isValidating: !isEmptyObject(_formState.validatingFields),
            });
        }
    };
    const _updateFieldArray = (name, values = [], method, args, shouldSetValues = true, shouldUpdateFieldsAndState = true) => {
        if (args && method && !_options.disabled) {
            _state.action = true;
            if (shouldUpdateFieldsAndState && Array.isArray(get(_fields, name))) {
                const fieldValues = method(get(_fields, name), args.argA, args.argB);
                shouldSetValues && set(_fields, name, fieldValues);
            }
            if (shouldUpdateFieldsAndState &&
                Array.isArray(get(_formState.errors, name))) {
                const errors = method(get(_formState.errors, name), args.argA, args.argB);
                shouldSetValues && set(_formState.errors, name, errors);
                unsetEmptyArray(_formState.errors, name);
            }
            if (_proxyFormState.touchedFields &&
                shouldUpdateFieldsAndState &&
                Array.isArray(get(_formState.touchedFields, name))) {
                const touchedFields = method(get(_formState.touchedFields, name), args.argA, args.argB);
                shouldSetValues && set(_formState.touchedFields, name, touchedFields);
            }
            if (_proxyFormState.dirtyFields) {
                _formState.dirtyFields = getDirtyFields(_defaultValues, _formValues);
            }
            _subjects.state.next({
                name,
                isDirty: _getDirty(name, values),
                dirtyFields: _formState.dirtyFields,
                errors: _formState.errors,
                isValid: _formState.isValid,
            });
        }
        else {
            set(_formValues, name, values);
        }
    };
    const updateErrors = (name, error) => {
        set(_formState.errors, name, error);
        _subjects.state.next({
            errors: _formState.errors,
        });
    };
    const _setErrors = (errors) => {
        _formState.errors = errors;
        _subjects.state.next({
            errors: _formState.errors,
            isValid: false,
        });
    };
    const updateValidAndValue = (name, shouldSkipSetValueAs, value, ref) => {
        const field = get(_fields, name);
        if (field) {
            const defaultValue = get(_formValues, name, isUndefined(value) ? get(_defaultValues, name) : value);
            isUndefined(defaultValue) ||
                (ref && ref.defaultChecked) ||
                shouldSkipSetValueAs
                ? set(_formValues, name, shouldSkipSetValueAs ? defaultValue : getFieldValue(field._f))
                : setFieldValue(name, defaultValue);
            _state.mount && _updateValid();
        }
    };
    const updateTouchAndDirty = (name, fieldValue, isBlurEvent, shouldDirty, shouldRender) => {
        let shouldUpdateField = false;
        let isPreviousDirty = false;
        const output = {
            name,
        };
        if (!_options.disabled) {
            const disabledField = !!(get(_fields, name) &&
                get(_fields, name)._f &&
                get(_fields, name)._f.disabled);
            if (!isBlurEvent || shouldDirty) {
                if (_proxyFormState.isDirty) {
                    isPreviousDirty = _formState.isDirty;
                    _formState.isDirty = output.isDirty = _getDirty();
                    shouldUpdateField = isPreviousDirty !== output.isDirty;
                }
                const isCurrentFieldPristine = disabledField || deepEqual(get(_defaultValues, name), fieldValue);
                isPreviousDirty = !!(!disabledField && get(_formState.dirtyFields, name));
                isCurrentFieldPristine || disabledField
                    ? unset(_formState.dirtyFields, name)
                    : set(_formState.dirtyFields, name, true);
                output.dirtyFields = _formState.dirtyFields;
                shouldUpdateField =
                    shouldUpdateField ||
                        (_proxyFormState.dirtyFields &&
                            isPreviousDirty !== !isCurrentFieldPristine);
            }
            if (isBlurEvent) {
                const isPreviousFieldTouched = get(_formState.touchedFields, name);
                if (!isPreviousFieldTouched) {
                    set(_formState.touchedFields, name, isBlurEvent);
                    output.touchedFields = _formState.touchedFields;
                    shouldUpdateField =
                        shouldUpdateField ||
                            (_proxyFormState.touchedFields &&
                                isPreviousFieldTouched !== isBlurEvent);
                }
            }
            shouldUpdateField && shouldRender && _subjects.state.next(output);
        }
        return shouldUpdateField ? output : {};
    };
    const shouldRenderByError = (name, isValid, error, fieldState) => {
        const previousFieldError = get(_formState.errors, name);
        const shouldUpdateValid = _proxyFormState.isValid &&
            isBoolean(isValid) &&
            _formState.isValid !== isValid;
        if (_options.delayError && error) {
            delayErrorCallback = debounce(() => updateErrors(name, error));
            delayErrorCallback(_options.delayError);
        }
        else {
            clearTimeout(timer);
            delayErrorCallback = null;
            error
                ? set(_formState.errors, name, error)
                : unset(_formState.errors, name);
        }
        if ((error ? !deepEqual(previousFieldError, error) : previousFieldError) ||
            !isEmptyObject(fieldState) ||
            shouldUpdateValid) {
            const updatedFormState = {
                ...fieldState,
                ...(shouldUpdateValid && isBoolean(isValid) ? { isValid } : {}),
                errors: _formState.errors,
                name,
            };
            _formState = {
                ..._formState,
                ...updatedFormState,
            };
            _subjects.state.next(updatedFormState);
        }
    };
    const _executeSchema = async (name) => {
        _updateIsValidating(name, true);
        const result = await _options.resolver(_formValues, _options.context, getResolverOptions(name || _names.mount, _fields, _options.criteriaMode, _options.shouldUseNativeValidation));
        _updateIsValidating(name);
        return result;
    };
    const executeSchemaAndUpdateState = async (names) => {
        const { errors } = await _executeSchema(names);
        if (names) {
            for (const name of names) {
                const error = get(errors, name);
                error
                    ? set(_formState.errors, name, error)
                    : unset(_formState.errors, name);
            }
        }
        else {
            _formState.errors = errors;
        }
        return errors;
    };
    const executeBuiltInValidation = async (fields, shouldOnlyCheckValid, context = {
        valid: true,
    }) => {
        for (const name in fields) {
            const field = fields[name];
            if (field) {
                const { _f, ...fieldValue } = field;
                if (_f) {
                    const isFieldArrayRoot = _names.array.has(_f.name);
                    const isPromiseFunction = field._f && hasPromiseValidation(field._f);
                    if (isPromiseFunction && _proxyFormState.validatingFields) {
                        _updateIsValidating([name], true);
                    }
                    const fieldError = await validateField(field, _names.disabled, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation && !shouldOnlyCheckValid, isFieldArrayRoot);
                    if (isPromiseFunction && _proxyFormState.validatingFields) {
                        _updateIsValidating([name]);
                    }
                    if (fieldError[_f.name]) {
                        context.valid = false;
                        if (shouldOnlyCheckValid) {
                            break;
                        }
                    }
                    !shouldOnlyCheckValid &&
                        (get(fieldError, _f.name)
                            ? isFieldArrayRoot
                                ? updateFieldArrayRootError(_formState.errors, fieldError, _f.name)
                                : set(_formState.errors, _f.name, fieldError[_f.name])
                            : unset(_formState.errors, _f.name));
                }
                !isEmptyObject(fieldValue) &&
                    (await executeBuiltInValidation(fieldValue, shouldOnlyCheckValid, context));
            }
        }
        return context.valid;
    };
    const _removeUnmounted = () => {
        for (const name of _names.unMount) {
            const field = get(_fields, name);
            field &&
                (field._f.refs
                    ? field._f.refs.every((ref) => !live(ref))
                    : !live(field._f.ref)) &&
                unregister(name);
        }
        _names.unMount = new Set();
    };
    const _getDirty = (name, data) => !_options.disabled &&
        (name && data && set(_formValues, name, data),
            !deepEqual(getValues(), _defaultValues));
    const _getWatch = (names, defaultValue, isGlobal) => generateWatchOutput(names, _names, {
        ...(_state.mount
            ? _formValues
            : isUndefined(defaultValue)
                ? _defaultValues
                : isString(names)
                    ? { [names]: defaultValue }
                    : defaultValue),
    }, isGlobal, defaultValue);
    const _getFieldArray = (name) => compact(get(_state.mount ? _formValues : _defaultValues, name, _options.shouldUnregister ? get(_defaultValues, name, []) : []));
    const setFieldValue = (name, value, options = {}) => {
        const field = get(_fields, name);
        let fieldValue = value;
        if (field) {
            const fieldReference = field._f;
            if (fieldReference) {
                !fieldReference.disabled &&
                    set(_formValues, name, getFieldValueAs(value, fieldReference));
                fieldValue =
                    isHTMLElement(fieldReference.ref) && isNullOrUndefined(value)
                        ? ''
                        : value;
                if (isMultipleSelect(fieldReference.ref)) {
                    [...fieldReference.ref.options].forEach((optionRef) => (optionRef.selected = fieldValue.includes(optionRef.value)));
                }
                else if (fieldReference.refs) {
                    if (isCheckBoxInput(fieldReference.ref)) {
                        fieldReference.refs.length > 1
                            ? fieldReference.refs.forEach((checkboxRef) => (!checkboxRef.defaultChecked || !checkboxRef.disabled) &&
                                (checkboxRef.checked = Array.isArray(fieldValue)
                                    ? !!fieldValue.find((data) => data === checkboxRef.value)
                                    : fieldValue === checkboxRef.value))
                            : fieldReference.refs[0] &&
                                (fieldReference.refs[0].checked = !!fieldValue);
                    }
                    else {
                        fieldReference.refs.forEach((radioRef) => (radioRef.checked = radioRef.value === fieldValue));
                    }
                }
                else if (isFileInput(fieldReference.ref)) {
                    fieldReference.ref.value = '';
                }
                else {
                    fieldReference.ref.value = fieldValue;
                    if (!fieldReference.ref.type) {
                        _subjects.values.next({
                            name,
                            values: { ..._formValues },
                        });
                    }
                }
            }
        }
        (options.shouldDirty || options.shouldTouch) &&
            updateTouchAndDirty(name, fieldValue, options.shouldTouch, options.shouldDirty, true);
        options.shouldValidate && trigger(name);
    };
    const setValues = (name, value, options) => {
        for (const fieldKey in value) {
            const fieldValue = value[fieldKey];
            const fieldName = `${name}.${fieldKey}`;
            const field = get(_fields, fieldName);
            (_names.array.has(name) ||
                isObject$1(fieldValue) ||
                (field && !field._f)) &&
                !isDateObject(fieldValue)
                ? setValues(fieldName, fieldValue, options)
                : setFieldValue(fieldName, fieldValue, options);
        }
    };
    const setValue = (name, value, options = {}) => {
        const field = get(_fields, name);
        const isFieldArray = _names.array.has(name);
        const cloneValue = cloneObject(value);
        set(_formValues, name, cloneValue);
        if (isFieldArray) {
            _subjects.array.next({
                name,
                values: { ..._formValues },
            });
            if ((_proxyFormState.isDirty || _proxyFormState.dirtyFields) &&
                options.shouldDirty) {
                _subjects.state.next({
                    name,
                    dirtyFields: getDirtyFields(_defaultValues, _formValues),
                    isDirty: _getDirty(name, cloneValue),
                });
            }
        }
        else {
            field && !field._f && !isNullOrUndefined(cloneValue)
                ? setValues(name, cloneValue, options)
                : setFieldValue(name, cloneValue, options);
        }
        isWatched(name, _names) && _subjects.state.next({ ..._formState });
        _subjects.values.next({
            name: _state.mount ? name : undefined,
            values: { ..._formValues },
        });
    };
    const onChange = async (event) => {
        _state.mount = true;
        const target = event.target;
        let name = target.name;
        let isFieldValueUpdated = true;
        const field = get(_fields, name);
        const getCurrentFieldValue = () => target.type ? getFieldValue(field._f) : getEventValue(event);
        const _updateIsFieldValueUpdated = (fieldValue) => {
            isFieldValueUpdated =
                Number.isNaN(fieldValue) ||
                    (isDateObject(fieldValue) && isNaN(fieldValue.getTime())) ||
                    deepEqual(fieldValue, get(_formValues, name, fieldValue));
        };
        if (field) {
            let error;
            let isValid;
            const fieldValue = getCurrentFieldValue();
            const isBlurEvent = event.type === EVENTS.BLUR || event.type === EVENTS.FOCUS_OUT;
            const shouldSkipValidation = (!hasValidation(field._f) &&
                !_options.resolver &&
                !get(_formState.errors, name) &&
                !field._f.deps) ||
                skipValidation(isBlurEvent, get(_formState.touchedFields, name), _formState.isSubmitted, validationModeAfterSubmit, validationModeBeforeSubmit);
            const watched = isWatched(name, _names, isBlurEvent);
            set(_formValues, name, fieldValue);
            if (isBlurEvent) {
                field._f.onBlur && field._f.onBlur(event);
                delayErrorCallback && delayErrorCallback(0);
            }
            else if (field._f.onChange) {
                field._f.onChange(event);
            }
            const fieldState = updateTouchAndDirty(name, fieldValue, isBlurEvent, false);
            const shouldRender = !isEmptyObject(fieldState) || watched;
            !isBlurEvent &&
                _subjects.values.next({
                    name,
                    type: event.type,
                    values: { ..._formValues },
                });
            if (shouldSkipValidation) {
                if (_proxyFormState.isValid) {
                    if (_options.mode === 'onBlur' && isBlurEvent) {
                        _updateValid();
                    }
                    else if (!isBlurEvent) {
                        _updateValid();
                    }
                }
                return (shouldRender &&
                    _subjects.state.next({ name, ...(watched ? {} : fieldState) }));
            }
            !isBlurEvent && watched && _subjects.state.next({ ..._formState });
            if (_options.resolver) {
                const { errors } = await _executeSchema([name]);
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    const previousErrorLookupResult = schemaErrorLookup(_formState.errors, _fields, name);
                    const errorLookupResult = schemaErrorLookup(errors, _fields, previousErrorLookupResult.name || name);
                    error = errorLookupResult.error;
                    name = errorLookupResult.name;
                    isValid = isEmptyObject(errors);
                }
            }
            else {
                _updateIsValidating([name], true);
                error = (await validateField(field, _names.disabled, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation))[name];
                _updateIsValidating([name]);
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    if (error) {
                        isValid = false;
                    }
                    else if (_proxyFormState.isValid) {
                        isValid = await executeBuiltInValidation(_fields, true);
                    }
                }
            }
            if (isFieldValueUpdated) {
                field._f.deps &&
                    trigger(field._f.deps);
                shouldRenderByError(name, isValid, error, fieldState);
            }
        }
    };
    const _focusInput = (ref, key) => {
        if (get(_formState.errors, key) && ref.focus) {
            ref.focus();
            return 1;
        }
        return;
    };
    const trigger = async (name, options = {}) => {
        let isValid;
        let validationResult;
        const fieldNames = convertToArrayPayload(name);
        if (_options.resolver) {
            const errors = await executeSchemaAndUpdateState(isUndefined(name) ? name : fieldNames);
            isValid = isEmptyObject(errors);
            validationResult = name
                ? !fieldNames.some((name) => get(errors, name))
                : isValid;
        }
        else if (name) {
            validationResult = (await Promise.all(fieldNames.map(async (fieldName) => {
                const field = get(_fields, fieldName);
                return await executeBuiltInValidation(field && field._f ? { [fieldName]: field } : field);
            }))).every(Boolean);
            !(!validationResult && !_formState.isValid) && _updateValid();
        }
        else {
            validationResult = isValid = await executeBuiltInValidation(_fields);
        }
        _subjects.state.next({
            ...(!isString(name) ||
                (_proxyFormState.isValid && isValid !== _formState.isValid)
                ? {}
                : { name }),
            ...(_options.resolver || !name ? { isValid } : {}),
            errors: _formState.errors,
        });
        options.shouldFocus &&
            !validationResult &&
            iterateFieldsByAction(_fields, _focusInput, name ? fieldNames : _names.mount);
        return validationResult;
    };
    const getValues = (fieldNames) => {
        const values = {
            ...(_state.mount ? _formValues : _defaultValues),
        };
        return isUndefined(fieldNames)
            ? values
            : isString(fieldNames)
                ? get(values, fieldNames)
                : fieldNames.map((name) => get(values, name));
    };
    const getFieldState = (name, formState) => ({
        invalid: !!get((formState || _formState).errors, name),
        isDirty: !!get((formState || _formState).dirtyFields, name),
        error: get((formState || _formState).errors, name),
        isValidating: !!get(_formState.validatingFields, name),
        isTouched: !!get((formState || _formState).touchedFields, name),
    });
    const clearErrors = (name) => {
        name &&
            convertToArrayPayload(name).forEach((inputName) => unset(_formState.errors, inputName));
        _subjects.state.next({
            errors: name ? _formState.errors : {},
        });
    };
    const setError = (name, error, options) => {
        const ref = (get(_fields, name, { _f: {} })._f || {}).ref;
        const currentError = get(_formState.errors, name) || {};
        // Don't override existing error messages elsewhere in the object tree.
        const { ref: currentRef, message, type, ...restOfErrorTree } = currentError;
        set(_formState.errors, name, {
            ...restOfErrorTree,
            ...error,
            ref,
        });
        _subjects.state.next({
            name,
            errors: _formState.errors,
            isValid: false,
        });
        options && options.shouldFocus && ref && ref.focus && ref.focus();
    };
    const watch = (name, defaultValue) => isFunction(name)
        ? _subjects.values.subscribe({
            next: (payload) => name(_getWatch(undefined, defaultValue), payload),
        })
        : _getWatch(name, defaultValue, true);
    const unregister = (name, options = {}) => {
        for (const fieldName of name ? convertToArrayPayload(name) : _names.mount) {
            _names.mount.delete(fieldName);
            _names.array.delete(fieldName);
            if (!options.keepValue) {
                unset(_fields, fieldName);
                unset(_formValues, fieldName);
            }
            !options.keepError && unset(_formState.errors, fieldName);
            !options.keepDirty && unset(_formState.dirtyFields, fieldName);
            !options.keepTouched && unset(_formState.touchedFields, fieldName);
            !options.keepIsValidating &&
                unset(_formState.validatingFields, fieldName);
            !_options.shouldUnregister &&
                !options.keepDefaultValue &&
                unset(_defaultValues, fieldName);
        }
        _subjects.values.next({
            values: { ..._formValues },
        });
        _subjects.state.next({
            ..._formState,
            ...(!options.keepDirty ? {} : { isDirty: _getDirty() }),
        });
        !options.keepIsValid && _updateValid();
    };
    const _updateDisabledField = ({ disabled, name, field, fields, }) => {
        if ((isBoolean(disabled) && _state.mount) ||
            !!disabled ||
            _names.disabled.has(name)) {
            disabled ? _names.disabled.add(name) : _names.disabled.delete(name);
            updateTouchAndDirty(name, getFieldValue(field ? field._f : get(fields, name)._f), false, false, true);
        }
    };
    const register = (name, options = {}) => {
        let field = get(_fields, name);
        const disabledIsDefined = isBoolean(options.disabled) || isBoolean(_options.disabled);
        set(_fields, name, {
            ...(field || {}),
            _f: {
                ...(field && field._f ? field._f : { ref: { name } }),
                name,
                mount: true,
                ...options,
            },
        });
        _names.mount.add(name);
        if (field) {
            _updateDisabledField({
                field,
                disabled: isBoolean(options.disabled)
                    ? options.disabled
                    : _options.disabled,
                name,
            });
        }
        else {
            updateValidAndValue(name, true, options.value);
        }
        return {
            ...(disabledIsDefined
                ? { disabled: options.disabled || _options.disabled }
                : {}),
            ...(_options.progressive
                ? {
                    required: !!options.required,
                    min: getRuleValue(options.min),
                    max: getRuleValue(options.max),
                    minLength: getRuleValue(options.minLength),
                    maxLength: getRuleValue(options.maxLength),
                    pattern: getRuleValue(options.pattern),
                }
                : {}),
            name,
            onChange,
            onBlur: onChange,
            ref: (ref) => {
                if (ref) {
                    register(name, options);
                    field = get(_fields, name);
                    const fieldRef = isUndefined(ref.value)
                        ? ref.querySelectorAll
                            ? ref.querySelectorAll('input,select,textarea')[0] || ref
                            : ref
                        : ref;
                    const radioOrCheckbox = isRadioOrCheckbox(fieldRef);
                    const refs = field._f.refs || [];
                    if (radioOrCheckbox
                        ? refs.find((option) => option === fieldRef)
                        : fieldRef === field._f.ref) {
                        return;
                    }
                    set(_fields, name, {
                        _f: {
                            ...field._f,
                            ...(radioOrCheckbox
                                ? {
                                    refs: [
                                        ...refs.filter(live),
                                        fieldRef,
                                        ...(Array.isArray(get(_defaultValues, name)) ? [{}] : []),
                                    ],
                                    ref: { type: fieldRef.type, name },
                                }
                                : { ref: fieldRef }),
                        },
                    });
                    updateValidAndValue(name, false, undefined, fieldRef);
                }
                else {
                    field = get(_fields, name, {});
                    if (field._f) {
                        field._f.mount = false;
                    }
                    (_options.shouldUnregister || options.shouldUnregister) &&
                        !(isNameInFieldArray(_names.array, name) && _state.action) &&
                        _names.unMount.add(name);
                }
            },
        };
    };
    const _focusError = () => _options.shouldFocusError &&
        iterateFieldsByAction(_fields, _focusInput, _names.mount);
    const _disableForm = (disabled) => {
        if (isBoolean(disabled)) {
            _subjects.state.next({ disabled });
            iterateFieldsByAction(_fields, (ref, name) => {
                const currentField = get(_fields, name);
                if (currentField) {
                    ref.disabled = currentField._f.disabled || disabled;
                    if (Array.isArray(currentField._f.refs)) {
                        currentField._f.refs.forEach((inputRef) => {
                            inputRef.disabled = currentField._f.disabled || disabled;
                        });
                    }
                }
            }, 0, false);
        }
    };
    const handleSubmit = (onValid, onInvalid) => async (e) => {
        let onValidError = undefined;
        if (e) {
            e.preventDefault && e.preventDefault();
            e.persist && e.persist();
        }
        let fieldValues = cloneObject(_formValues);
        if (_names.disabled.size) {
            for (const name of _names.disabled) {
                set(fieldValues, name, undefined);
            }
        }
        _subjects.state.next({
            isSubmitting: true,
        });
        if (_options.resolver) {
            const { errors, values } = await _executeSchema();
            _formState.errors = errors;
            fieldValues = values;
        }
        else {
            await executeBuiltInValidation(_fields);
        }
        unset(_formState.errors, 'root');
        if (isEmptyObject(_formState.errors)) {
            _subjects.state.next({
                errors: {},
            });
            try {
                await onValid(fieldValues, e);
            }
            catch (error) {
                onValidError = error;
            }
        }
        else {
            if (onInvalid) {
                await onInvalid({ ..._formState.errors }, e);
            }
            _focusError();
            setTimeout(_focusError);
        }
        _subjects.state.next({
            isSubmitted: true,
            isSubmitting: false,
            isSubmitSuccessful: isEmptyObject(_formState.errors) && !onValidError,
            submitCount: _formState.submitCount + 1,
            errors: _formState.errors,
        });
        if (onValidError) {
            throw onValidError;
        }
    };
    const resetField = (name, options = {}) => {
        if (get(_fields, name)) {
            if (isUndefined(options.defaultValue)) {
                setValue(name, cloneObject(get(_defaultValues, name)));
            }
            else {
                setValue(name, options.defaultValue);
                set(_defaultValues, name, cloneObject(options.defaultValue));
            }
            if (!options.keepTouched) {
                unset(_formState.touchedFields, name);
            }
            if (!options.keepDirty) {
                unset(_formState.dirtyFields, name);
                _formState.isDirty = options.defaultValue
                    ? _getDirty(name, cloneObject(get(_defaultValues, name)))
                    : _getDirty();
            }
            if (!options.keepError) {
                unset(_formState.errors, name);
                _proxyFormState.isValid && _updateValid();
            }
            _subjects.state.next({ ..._formState });
        }
    };
    const _reset = (formValues, keepStateOptions = {}) => {
        const updatedValues = formValues ? cloneObject(formValues) : _defaultValues;
        const cloneUpdatedValues = cloneObject(updatedValues);
        const isEmptyResetValues = isEmptyObject(formValues);
        const values = isEmptyResetValues ? _defaultValues : cloneUpdatedValues;
        if (!keepStateOptions.keepDefaultValues) {
            _defaultValues = updatedValues;
        }
        if (!keepStateOptions.keepValues) {
            if (keepStateOptions.keepDirtyValues) {
                const fieldsToCheck = new Set([
                    ..._names.mount,
                    ...Object.keys(getDirtyFields(_defaultValues, _formValues)),
                ]);
                for (const fieldName of Array.from(fieldsToCheck)) {
                    get(_formState.dirtyFields, fieldName)
                        ? set(values, fieldName, get(_formValues, fieldName))
                        : setValue(fieldName, get(values, fieldName));
                }
            }
            else {
                if (isWeb && isUndefined(formValues)) {
                    for (const name of _names.mount) {
                        const field = get(_fields, name);
                        if (field && field._f) {
                            const fieldReference = Array.isArray(field._f.refs)
                                ? field._f.refs[0]
                                : field._f.ref;
                            if (isHTMLElement(fieldReference)) {
                                const form = fieldReference.closest('form');
                                if (form) {
                                    form.reset();
                                    break;
                                }
                            }
                        }
                    }
                }
                _fields = {};
            }
            _formValues = _options.shouldUnregister
                ? keepStateOptions.keepDefaultValues
                    ? cloneObject(_defaultValues)
                    : {}
                : cloneObject(values);
            _subjects.array.next({
                values: { ...values },
            });
            _subjects.values.next({
                values: { ...values },
            });
        }
        _names = {
            mount: keepStateOptions.keepDirtyValues ? _names.mount : new Set(),
            unMount: new Set(),
            array: new Set(),
            disabled: new Set(),
            watch: new Set(),
            watchAll: false,
            focus: '',
        };
        _state.mount =
            !_proxyFormState.isValid ||
                !!keepStateOptions.keepIsValid ||
                !!keepStateOptions.keepDirtyValues;
        _state.watch = !!_options.shouldUnregister;
        _subjects.state.next({
            submitCount: keepStateOptions.keepSubmitCount
                ? _formState.submitCount
                : 0,
            isDirty: isEmptyResetValues
                ? false
                : keepStateOptions.keepDirty
                    ? _formState.isDirty
                    : !!(keepStateOptions.keepDefaultValues &&
                        !deepEqual(formValues, _defaultValues)),
            isSubmitted: keepStateOptions.keepIsSubmitted
                ? _formState.isSubmitted
                : false,
            dirtyFields: isEmptyResetValues
                ? {}
                : keepStateOptions.keepDirtyValues
                    ? keepStateOptions.keepDefaultValues && _formValues
                        ? getDirtyFields(_defaultValues, _formValues)
                        : _formState.dirtyFields
                    : keepStateOptions.keepDefaultValues && formValues
                        ? getDirtyFields(_defaultValues, formValues)
                        : keepStateOptions.keepDirty
                            ? _formState.dirtyFields
                            : {},
            touchedFields: keepStateOptions.keepTouched
                ? _formState.touchedFields
                : {},
            errors: keepStateOptions.keepErrors ? _formState.errors : {},
            isSubmitSuccessful: keepStateOptions.keepIsSubmitSuccessful
                ? _formState.isSubmitSuccessful
                : false,
            isSubmitting: false,
        });
    };
    const reset = (formValues, keepStateOptions) => _reset(isFunction(formValues)
        ? formValues(_formValues)
        : formValues, keepStateOptions);
    const setFocus = (name, options = {}) => {
        const field = get(_fields, name);
        const fieldReference = field && field._f;
        if (fieldReference) {
            const fieldRef = fieldReference.refs
                ? fieldReference.refs[0]
                : fieldReference.ref;
            if (fieldRef.focus) {
                fieldRef.focus();
                options.shouldSelect &&
                    isFunction(fieldRef.select) &&
                    fieldRef.select();
            }
        }
    };
    const _updateFormState = (updatedFormState) => {
        _formState = {
            ..._formState,
            ...updatedFormState,
        };
    };
    const _resetDefaultValues = () => isFunction(_options.defaultValues) &&
        _options.defaultValues().then((values) => {
            reset(values, _options.resetOptions);
            _subjects.state.next({
                isLoading: false,
            });
        });
    return {
        control: {
            register,
            unregister,
            getFieldState,
            handleSubmit,
            setError,
            _executeSchema,
            _getWatch,
            _getDirty,
            _updateValid,
            _removeUnmounted,
            _updateFieldArray,
            _updateDisabledField,
            _getFieldArray,
            _reset,
            _resetDefaultValues,
            _updateFormState,
            _disableForm,
            _subjects,
            _proxyFormState,
            _setErrors,
            get _fields() {
                return _fields;
            },
            get _formValues() {
                return _formValues;
            },
            get _state() {
                return _state;
            },
            set _state(value) {
                _state = value;
            },
            get _defaultValues() {
                return _defaultValues;
            },
            get _names() {
                return _names;
            },
            set _names(value) {
                _names = value;
            },
            get _formState() {
                return _formState;
            },
            set _formState(value) {
                _formState = value;
            },
            get _options() {
                return _options;
            },
            set _options(value) {
                _options = {
                    ..._options,
                    ...value,
                };
            },
        },
        trigger,
        register,
        handleSubmit,
        watch,
        setValue,
        getValues,
        reset,
        resetField,
        clearErrors,
        unregister,
        setError,
        setFocus,
        getFieldState,
    };
}

/**
 * Custom hook to manage the entire form.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useform) • [Demo](https://codesandbox.io/s/react-hook-form-get-started-ts-5ksmm) • [Video](https://www.youtube.com/watch?v=RkXv4AXXC_4)
 *
 * @param props - form configuration and validation parameters.
 *
 * @returns methods - individual functions to manage the form state. {@link UseFormReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, watch, formState: { errors } } = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   console.log(watch("example"));
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input defaultValue="test" {...register("example")} />
 *       <input {...register("exampleRequired", { required: true })} />
 *       {errors.exampleRequired && <span>This field is required</span>}
 *       <button>Submit</button>
 *     </form>
 *   );
 * }
 * ```
 */
function useForm(props = {}) {
    const _formControl = React.useRef(undefined);
    const _values = React.useRef(undefined);
    const [formState, updateFormState] = React.useState({
        isDirty: false,
        isValidating: false,
        isLoading: isFunction(props.defaultValues),
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        submitCount: 0,
        dirtyFields: {},
        touchedFields: {},
        validatingFields: {},
        errors: props.errors || {},
        disabled: props.disabled || false,
        defaultValues: isFunction(props.defaultValues)
            ? undefined
            : props.defaultValues,
    });
    if (!_formControl.current) {
        _formControl.current = {
            ...createFormControl(props),
            formState,
        };
    }
    const control = _formControl.current.control;
    control._options = props;
    useSubscribe({
        subject: control._subjects.state,
        next: (value) => {
            if (shouldRenderFormState(value, control._proxyFormState, control._updateFormState, true)) {
                updateFormState({ ...control._formState });
            }
        },
    });
    React.useEffect(() => control._disableForm(props.disabled), [control, props.disabled]);
    React.useEffect(() => {
        if (control._proxyFormState.isDirty) {
            const isDirty = control._getDirty();
            if (isDirty !== formState.isDirty) {
                control._subjects.state.next({
                    isDirty,
                });
            }
        }
    }, [control, formState.isDirty]);
    React.useEffect(() => {
        if (props.values && !deepEqual(props.values, _values.current)) {
            control._reset(props.values, control._options.resetOptions);
            _values.current = props.values;
            updateFormState((state) => ({ ...state }));
        }
        else {
            control._resetDefaultValues();
        }
    }, [props.values, control]);
    React.useEffect(() => {
        if (props.errors) {
            control._setErrors(props.errors);
        }
    }, [props.errors, control]);
    React.useEffect(() => {
        if (!control._state.mount) {
            control._updateValid();
            control._state.mount = true;
        }
        if (control._state.watch) {
            control._state.watch = false;
            control._subjects.state.next({ ...control._formState });
        }
        control._removeUnmounted();
    });
    React.useEffect(() => {
        props.shouldUnregister &&
            control._subjects.values.next({
                values: control._getWatch(),
            });
    }, [props.shouldUnregister, control]);
    _formControl.current.formState = getProxyFormState(formState, control);
    return _formControl.current;
}

// This file is a workaround for a bug in web browsers' "native"
// ES6 importing system which is uncapable of importing "*.json" files.
// https://github.com/catamphetamine/libphonenumber-js/issues/239
var metadata = {"version":4,"country_calling_codes":{"1":["US","AG","AI","AS","BB","BM","BS","CA","DM","DO","GD","GU","JM","KN","KY","LC","MP","MS","PR","SX","TC","TT","VC","VG","VI"],"7":["RU","KZ"],"20":["EG"],"27":["ZA"],"30":["GR"],"31":["NL"],"32":["BE"],"33":["FR"],"34":["ES"],"36":["HU"],"39":["IT","VA"],"40":["RO"],"41":["CH"],"43":["AT"],"44":["GB","GG","IM","JE"],"45":["DK"],"46":["SE"],"47":["NO","SJ"],"48":["PL"],"49":["DE"],"51":["PE"],"52":["MX"],"53":["CU"],"54":["AR"],"55":["BR"],"56":["CL"],"57":["CO"],"58":["VE"],"60":["MY"],"61":["AU","CC","CX"],"62":["ID"],"63":["PH"],"64":["NZ"],"65":["SG"],"66":["TH"],"81":["JP"],"82":["KR"],"84":["VN"],"86":["CN"],"90":["TR"],"91":["IN"],"92":["PK"],"93":["AF"],"94":["LK"],"95":["MM"],"98":["IR"],"211":["SS"],"212":["MA","EH"],"213":["DZ"],"216":["TN"],"218":["LY"],"220":["GM"],"221":["SN"],"222":["MR"],"223":["ML"],"224":["GN"],"225":["CI"],"226":["BF"],"227":["NE"],"228":["TG"],"229":["BJ"],"230":["MU"],"231":["LR"],"232":["SL"],"233":["GH"],"234":["NG"],"235":["TD"],"236":["CF"],"237":["CM"],"238":["CV"],"239":["ST"],"240":["GQ"],"241":["GA"],"242":["CG"],"243":["CD"],"244":["AO"],"245":["GW"],"246":["IO"],"247":["AC"],"248":["SC"],"249":["SD"],"250":["RW"],"251":["ET"],"252":["SO"],"253":["DJ"],"254":["KE"],"255":["TZ"],"256":["UG"],"257":["BI"],"258":["MZ"],"260":["ZM"],"261":["MG"],"262":["RE","YT"],"263":["ZW"],"264":["NA"],"265":["MW"],"266":["LS"],"267":["BW"],"268":["SZ"],"269":["KM"],"290":["SH","TA"],"291":["ER"],"297":["AW"],"298":["FO"],"299":["GL"],"350":["GI"],"351":["PT"],"352":["LU"],"353":["IE"],"354":["IS"],"355":["AL"],"356":["MT"],"357":["CY"],"358":["FI","AX"],"359":["BG"],"370":["LT"],"371":["LV"],"372":["EE"],"373":["MD"],"374":["AM"],"375":["BY"],"376":["AD"],"377":["MC"],"378":["SM"],"380":["UA"],"381":["RS"],"382":["ME"],"383":["XK"],"385":["HR"],"386":["SI"],"387":["BA"],"389":["MK"],"420":["CZ"],"421":["SK"],"423":["LI"],"500":["FK"],"501":["BZ"],"502":["GT"],"503":["SV"],"504":["HN"],"505":["NI"],"506":["CR"],"507":["PA"],"508":["PM"],"509":["HT"],"590":["GP","BL","MF"],"591":["BO"],"592":["GY"],"593":["EC"],"594":["GF"],"595":["PY"],"596":["MQ"],"597":["SR"],"598":["UY"],"599":["CW","BQ"],"670":["TL"],"672":["NF"],"673":["BN"],"674":["NR"],"675":["PG"],"676":["TO"],"677":["SB"],"678":["VU"],"679":["FJ"],"680":["PW"],"681":["WF"],"682":["CK"],"683":["NU"],"685":["WS"],"686":["KI"],"687":["NC"],"688":["TV"],"689":["PF"],"690":["TK"],"691":["FM"],"692":["MH"],"850":["KP"],"852":["HK"],"853":["MO"],"855":["KH"],"856":["LA"],"880":["BD"],"886":["TW"],"960":["MV"],"961":["LB"],"962":["JO"],"963":["SY"],"964":["IQ"],"965":["KW"],"966":["SA"],"967":["YE"],"968":["OM"],"970":["PS"],"971":["AE"],"972":["IL"],"973":["BH"],"974":["QA"],"975":["BT"],"976":["MN"],"977":["NP"],"992":["TJ"],"993":["TM"],"994":["AZ"],"995":["GE"],"996":["KG"],"998":["UZ"]},"countries":{"AC":["247","00","(?:[01589]\\d|[46])\\d{4}",[5,6]],"AD":["376","00","(?:1|6\\d)\\d{7}|[135-9]\\d{5}",[6,8,9],[["(\\d{3})(\\d{3})","$1 $2",["[135-9]"]],["(\\d{4})(\\d{4})","$1 $2",["1"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"]]]],"AE":["971","00","(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}",[5,6,7,8,9,10,11,12],[["(\\d{3})(\\d{2,9})","$1 $2",["60|8"]],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[236]|[479][2-8]"],"0$1"],["(\\d{3})(\\d)(\\d{5})","$1 $2 $3",["[479]"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["5"],"0$1"]],"0"],"AF":["93","00","[2-7]\\d{8}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[2-7]"],"0$1"]],"0"],"AG":["1","011","(?:268|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([457]\\d{6})$|1","268$1",0,"268"],"AI":["1","011","(?:264|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2457]\\d{6})$|1","264$1",0,"264"],"AL":["355","00","(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}",[6,7,8,9],[["(\\d{3})(\\d{3,4})","$1 $2",["80|9"],"0$1"],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["4[2-6]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2358][2-5]|4"],"0$1"],["(\\d{3})(\\d{5})","$1 $2",["[23578]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["6"],"0$1"]],"0"],"AM":["374","00","(?:[1-489]\\d|55|60|77)\\d{6}",[8],[["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[89]0"],"0 $1"],["(\\d{3})(\\d{5})","$1 $2",["2|3[12]"],"(0$1)"],["(\\d{2})(\\d{6})","$1 $2",["1|47"],"(0$1)"],["(\\d{2})(\\d{6})","$1 $2",["[3-9]"],"0$1"]],"0"],"AO":["244","00","[29]\\d{8}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[29]"]]]],"AR":["54","00","(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}",[10,11],[["(\\d{4})(\\d{2})(\\d{4})","$1 $2-$3",["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])","2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)","2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]","2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"],"0$1",1],["(\\d{2})(\\d{4})(\\d{4})","$1 $2-$3",["1"],"0$1",1],["(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["[68]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2-$3",["[23]"],"0$1",1],["(\\d)(\\d{4})(\\d{2})(\\d{4})","$2 15-$3-$4",["9(?:2[2-469]|3[3-578])","9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))","9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)","9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]","9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"],"0$1",0,"$1 $2 $3-$4"],["(\\d)(\\d{2})(\\d{4})(\\d{4})","$2 15-$3-$4",["91"],"0$1",0,"$1 $2 $3-$4"],["(\\d{3})(\\d{3})(\\d{5})","$1-$2-$3",["8"],"0$1"],["(\\d)(\\d{3})(\\d{3})(\\d{4})","$2 15-$3-$4",["9"],"0$1",0,"$1 $2 $3-$4"]],"0",0,"0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?","9$1"],"AS":["1","011","(?:[58]\\d\\d|684|900)\\d{7}",[10],0,"1",0,"([267]\\d{6})$|1","684$1",0,"684"],"AT":["43","00","1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",[4,5,6,7,8,9,10,11,12,13],[["(\\d)(\\d{3,12})","$1 $2",["1(?:11|[2-9])"],"0$1"],["(\\d{3})(\\d{2})","$1 $2",["517"],"0$1"],["(\\d{2})(\\d{3,5})","$1 $2",["5[079]"],"0$1"],["(\\d{3})(\\d{3,10})","$1 $2",["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"],"0$1"],["(\\d{4})(\\d{3,9})","$1 $2",["[2-467]|5[2-6]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["5"],"0$1"],["(\\d{2})(\\d{4})(\\d{4,7})","$1 $2 $3",["5"],"0$1"]],"0"],"AU":["61","001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011","1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}",[5,6,7,8,9,10,12],[["(\\d{2})(\\d{3,4})","$1 $2",["16"],"0$1"],["(\\d{2})(\\d{3})(\\d{2,4})","$1 $2 $3",["16"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["14|4"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["[2378]"],"(0$1)"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:30|[89])"]]],"0",0,"(183[12])|0",0,0,0,[["(?:(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|7(?:[013-57-9]\\d|2[0-8]))\\d|3(?:(?:[0-3589]\\d|6[1-9]|7[0-35-9])\\d|4(?:[0-578]\\d|90)))\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|3\\d\\d)|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}",[9]],["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",[9]],["180(?:0\\d{3}|2)\\d{3}",[7,10]],["190[0-26]\\d{6}",[10]],0,0,0,["163\\d{2,6}",[5,6,7,8,9]],["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",[9]],["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",[6,8,10,12]]],"0011"],"AW":["297","00","(?:[25-79]\\d\\d|800)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[25-9]"]]]],"AX":["358","00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))","2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}",[5,6,7,8,9,10,11,12],0,"0",0,0,0,0,"18",0,"00"],"AZ":["994","00","365\\d{6}|(?:[124579]\\d|60|88)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["90"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[28]|2|365|46","1[28]|2|365[45]|46","1[28]|2|365(?:4|5[02])|46"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[13-9]"],"0$1"]],"0"],"BA":["387","00","6\\d{8}|(?:[35689]\\d|49|70)\\d{6}",[8,9],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["6[1-3]|[7-9]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2-$3",["[3-5]|6[56]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["6"],"0$1"]],"0"],"BB":["1","011","(?:246|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2-9]\\d{6})$|1","246$1",0,"246"],"BD":["880","00","[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}",[6,7,8,9,10],[["(\\d{2})(\\d{4,6})","$1-$2",["31[5-8]|[459]1"],"0$1"],["(\\d{3})(\\d{3,7})","$1-$2",["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"],"0$1"],["(\\d{4})(\\d{3,6})","$1-$2",["[13-9]|2[23]"],"0$1"],["(\\d)(\\d{7,8})","$1-$2",["2"],"0$1"]],"0"],"BE":["32","00","4\\d{8}|[1-9]\\d{7}",[8,9],[["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["(?:80|9)0"],"0$1"],["(\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[239]|4[23]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[15-8]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["4"],"0$1"]],"0"],"BF":["226","00","[025-7]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[025-7]"]]]],"BG":["359","00","00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}",[6,7,8,9,12],[["(\\d)(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["2"],"0$1"],["(\\d{3})(\\d{4})","$1 $2",["43[1-6]|70[1-9]"],"0$1"],["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"],"0$1"],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["(?:70|8)0"],"0$1"],["(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3",["43[1-7]|7"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[48]|9[08]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"0$1"]],"0"],"BH":["973","00","[136-9]\\d{7}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[13679]|8[02-4679]"]]]],"BI":["257","00","(?:[267]\\d|31)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2367]"]]]],"BJ":["229","00","(?:01\\d|[24-689])\\d{7}",[8,10],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[24-689]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["0"]]]],"BL":["590","00","(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}",[9],0,"0",0,0,0,0,0,[["590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"],["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"],["80[0-5]\\d{6}"],0,0,0,0,0,["9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}"]]],"BM":["1","011","(?:441|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2-9]\\d{6})$|1","441$1",0,"441"],"BN":["673","00","[2-578]\\d{6}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-578]"]]]],"BO":["591","00(?:1\\d)?","8001\\d{5}|(?:[2-467]\\d|50)\\d{6}",[8,9],[["(\\d)(\\d{7})","$1 $2",["[235]|4[46]"]],["(\\d{8})","$1",["[67]"]],["(\\d{3})(\\d{2})(\\d{4})","$1 $2 $3",["8"]]],"0",0,"0(1\\d)?"],"BQ":["599","00","(?:[34]1|7\\d)\\d{5}",[7],0,0,0,0,0,0,"[347]"],"BR":["55","00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)","(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}",[8,9,10,11],[["(\\d{4})(\\d{4})","$1-$2",["300|4(?:0[02]|37)","4(?:02|37)0|[34]00"]],["(\\d{3})(\\d{2,3})(\\d{4})","$1 $2 $3",["(?:[358]|90)0"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1 $2-$3",["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"],"($1)"],["(\\d{2})(\\d{5})(\\d{4})","$1 $2-$3",["[16][1-9]|[2-57-9]"],"($1)"]],"0",0,"(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?","$2"],"BS":["1","011","(?:242|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([3-8]\\d{6})$|1","242$1",0,"242"],"BT":["975","00","[17]\\d{7}|[2-8]\\d{6}",[7,8],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[2-68]|7[246]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[67]|7"]]]],"BW":["267","00","(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}",[7,8,10],[["(\\d{2})(\\d{5})","$1 $2",["90"]],["(\\d{3})(\\d{4})","$1 $2",["[24-6]|3[15-9]"]],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[37]"]],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["0"]],["(\\d{3})(\\d{4})(\\d{3})","$1 $2 $3",["8"]]]],"BY":["375","810","(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}",[6,7,8,9,10,11],[["(\\d{3})(\\d{3})","$1 $2",["800"],"8 $1"],["(\\d{3})(\\d{2})(\\d{2,4})","$1 $2 $3",["800"],"8 $1"],["(\\d{4})(\\d{2})(\\d{3})","$1 $2-$3",["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])","1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"],"8 0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2-$3-$4",["1(?:[56]|7[467])|2[1-3]"],"8 0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2-$3-$4",["[1-4]"],"8 0$1"],["(\\d{3})(\\d{3,4})(\\d{4})","$1 $2 $3",["[89]"],"8 $1"]],"8",0,"0|80?",0,0,0,0,"8~10"],"BZ":["501","00","(?:0800\\d|[2-8])\\d{6}",[7,11],[["(\\d{3})(\\d{4})","$1-$2",["[2-8]"]],["(\\d)(\\d{3})(\\d{4})(\\d{3})","$1-$2-$3-$4",["0"]]]],"CA":["1","011","[2-9]\\d{9}|3\\d{6}",[7,10],0,"1",0,0,0,0,0,[["(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|9(?:0[25]|42))[2-9]\\d{6}",[10]],["",[10]],["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",[10]],["900[2-9]\\d{6}",[10]],["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:2[125-9]|33|44|66|77|88)|6(?:22|33))[2-9]\\d{6}",[10]],0,["310\\d{4}",[7]],0,["600[2-9]\\d{6}",[10]]]],"CC":["61","001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011","1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",[6,7,8,9,10,12],0,"0",0,"([59]\\d{7})$|0","8$1",0,0,[["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}",[9]],["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",[9]],["180(?:0\\d{3}|2)\\d{3}",[7,10]],["190[0-26]\\d{6}",[10]],0,0,0,0,["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",[9]],["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",[6,8,10,12]]],"0011"],"CD":["243","00","(?:(?:[189]|5\\d)\\d|2)\\d{7}|[1-68]\\d{6}",[7,8,9,10],[["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["88"],"0$1"],["(\\d{2})(\\d{5})","$1 $2",["[1-6]"],"0$1"],["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[89]"],"0$1"],["(\\d{2})(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3 $4",["5"],"0$1"]],"0"],"CF":["236","00","(?:[27]\\d{3}|8776)\\d{4}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[278]"]]]],"CG":["242","00","222\\d{6}|(?:0\\d|80)\\d{7}",[9],[["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["8"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[02]"]]]],"CH":["41","00","8\\d{11}|[2-9]\\d{8}",[9,12],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8[047]|90"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-79]|81"],"0$1"],["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["8"],"0$1"]],"0"],"CI":["225","00","[02]\\d{9}",[10],[["(\\d{2})(\\d{2})(\\d)(\\d{5})","$1 $2 $3 $4",["2"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3 $4",["0"]]]],"CK":["682","00","[2-578]\\d{4}",[5],[["(\\d{2})(\\d{3})","$1 $2",["[2-578]"]]]],"CL":["56","(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0","12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}",[9,10,11],[["(\\d{5})(\\d{4})","$1 $2",["219","2196"],"($1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["44"]],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2[1-36]"],"($1)"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["9[2-9]"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"],"($1)"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["60|8"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]],["(\\d{3})(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3 $4",["60"]]]],"CM":["237","00","[26]\\d{8}|88\\d{6,7}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["88"]],["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["[26]|88"]]]],"CN":["86","00|1(?:[12]\\d|79)\\d\\d00","(?:(?:1[03-689]|2\\d)\\d\\d|6)\\d{8}|1\\d{10}|[126]\\d{6}(?:\\d(?:\\d{2})?)?|86\\d{5,6}|(?:[3-579]\\d|8[0-57-9])\\d{5,9}",[7,8,9,10,11,12],[["(\\d{2})(\\d{5,6})","$1 $2",["(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]","(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1","10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12","10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123","10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123"],"0$1"],["(\\d{3})(\\d{5,6})","$1 $2",["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]","(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]","85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])","85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["(?:4|80)0"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["10|2(?:[02-57-9]|1[1-9])","10|2(?:[02-57-9]|1[1-9])","10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"],"0$1",1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"],"0$1",1],["(\\d{3})(\\d{7,8})","$1 $2",["9"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["80"],"0$1",1],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["[3-578]"],"0$1",1],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["1[3-9]"]],["(\\d{2})(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3 $4",["[12]"],"0$1",1]],"0",0,"(1(?:[12]\\d|79)\\d\\d)|0",0,0,0,0,"00"],"CO":["57","00(?:4(?:[14]4|56)|[579])","(?:46|60\\d\\d)\\d{6}|(?:1\\d|[39])\\d{9}",[8,10,11],[["(\\d{4})(\\d{4})","$1 $2",["46"]],["(\\d{3})(\\d{7})","$1 $2",["6|90"],"($1)"],["(\\d{3})(\\d{7})","$1 $2",["3[0-357]|91"]],["(\\d)(\\d{3})(\\d{7})","$1-$2-$3",["1"],"0$1",0,"$1 $2 $3"]],"0",0,"0([3579]|4(?:[14]4|56))?"],"CR":["506","00","(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}",[8,10],[["(\\d{4})(\\d{4})","$1 $2",["[2-7]|8[3-9]"]],["(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["[89]"]]],0,0,"(19(?:0[0-2468]|1[09]|20|66|77|99))"],"CU":["53","119","(?:[2-7]|8\\d\\d)\\d{7}|[2-47]\\d{6}|[34]\\d{5}",[6,7,8,10],[["(\\d{2})(\\d{4,6})","$1 $2",["2[1-4]|[34]"],"(0$1)"],["(\\d)(\\d{6,7})","$1 $2",["7"],"(0$1)"],["(\\d)(\\d{7})","$1 $2",["[56]"],"0$1"],["(\\d{3})(\\d{7})","$1 $2",["8"],"0$1"]],"0"],"CV":["238","0","(?:[2-59]\\d\\d|800)\\d{4}",[7],[["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[2-589]"]]]],"CW":["599","00","(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}",[7,8],[["(\\d{3})(\\d{4})","$1 $2",["[3467]"]],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["9[4-8]"]]],0,0,0,0,0,"[69]"],"CX":["61","001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011","1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",[6,7,8,9,10,12],0,"0",0,"([59]\\d{7})$|0","8$1",0,0,[["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}",[9]],["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",[9]],["180(?:0\\d{3}|2)\\d{3}",[7,10]],["190[0-26]\\d{6}",[10]],0,0,0,0,["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",[9]],["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",[6,8,10,12]]],"0011"],"CY":["357","00","(?:[279]\\d|[58]0)\\d{6}",[8],[["(\\d{2})(\\d{6})","$1 $2",["[257-9]"]]]],"CZ":["420","00","(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}",[9,10,11,12],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[2-8]|9[015-7]"]],["(\\d{2})(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3 $4",["96"]],["(\\d{2})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9"]],["(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9"]]]],"DE":["49","00","[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}",[4,5,6,7,8,9,10,11,12,13,14,15],[["(\\d{2})(\\d{3,13})","$1 $2",["3[02]|40|[68]9"],"0$1"],["(\\d{3})(\\d{3,12})","$1 $2",["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1","2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"],"0$1"],["(\\d{4})(\\d{2,11})","$1 $2",["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]","[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"],"0$1"],["(\\d{3})(\\d{4})","$1 $2",["138"],"0$1"],["(\\d{5})(\\d{2,10})","$1 $2",["3"],"0$1"],["(\\d{3})(\\d{5,11})","$1 $2",["181"],"0$1"],["(\\d{3})(\\d)(\\d{4,10})","$1 $2 $3",["1(?:3|80)|9"],"0$1"],["(\\d{3})(\\d{7,8})","$1 $2",["1[67]"],"0$1"],["(\\d{3})(\\d{7,12})","$1 $2",["8"],"0$1"],["(\\d{5})(\\d{6})","$1 $2",["185","1850","18500"],"0$1"],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["7"],"0$1"],["(\\d{4})(\\d{7})","$1 $2",["18[68]"],"0$1"],["(\\d{4})(\\d{7})","$1 $2",["15[1279]"],"0$1"],["(\\d{5})(\\d{6})","$1 $2",["15[03568]","15(?:[0568]|31)"],"0$1"],["(\\d{3})(\\d{8})","$1 $2",["18"],"0$1"],["(\\d{3})(\\d{2})(\\d{7,8})","$1 $2 $3",["1(?:6[023]|7)"],"0$1"],["(\\d{4})(\\d{2})(\\d{7})","$1 $2 $3",["15[279]"],"0$1"],["(\\d{3})(\\d{2})(\\d{8})","$1 $2 $3",["15"],"0$1"]],"0"],"DJ":["253","00","(?:2\\d|77)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[27]"]]]],"DK":["45","00","[2-9]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-9]"]]]],"DM":["1","011","(?:[58]\\d\\d|767|900)\\d{7}",[10],0,"1",0,"([2-7]\\d{6})$|1","767$1",0,"767"],"DO":["1","011","(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,0,0,0,"8001|8[024]9"],"DZ":["213","00","(?:[1-4]|[5-79]\\d|80)\\d{7}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[1-4]"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["9"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-8]"],"0$1"]],"0"],"EC":["593","00","1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}",[8,9,10,11],[["(\\d)(\\d{3})(\\d{4})","$1 $2-$3",["[2-7]"],"(0$1)",0,"$1-$2-$3"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["9"],"0$1"],["(\\d{4})(\\d{3})(\\d{3,4})","$1 $2 $3",["1"]]],"0"],"EE":["372","00","8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}",[7,8,10],[["(\\d{3})(\\d{4})","$1 $2",["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88","[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]],["(\\d{4})(\\d{3,4})","$1 $2",["[45]|8(?:00|[1-49])","[45]|8(?:00[1-9]|[1-49])"]],["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["7"]],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["8"]]]],"EG":["20","00","[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}",[8,9,10],[["(\\d)(\\d{7,8})","$1 $2",["[23]"],"0$1"],["(\\d{2})(\\d{6,7})","$1 $2",["1[35]|[4-6]|8[2468]|9[235-7]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[89]"],"0$1"],["(\\d{2})(\\d{8})","$1 $2",["1"],"0$1"]],"0"],"EH":["212","00","[5-8]\\d{8}",[9],0,"0",0,0,0,0,"528[89]"],"ER":["291","00","[178]\\d{6}",[7],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[178]"],"0$1"]],"0"],"ES":["34","00","[5-9]\\d{8}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[89]00"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-9]"]]]],"ET":["251","00","(?:11|[2-579]\\d)\\d{7}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-579]"],"0$1"]],"0"],"FI":["358","00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))","[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}",[5,6,7,8,9,10,11,12],[["(\\d{5})","$1",["20[2-59]"],"0$1"],["(\\d{3})(\\d{3,7})","$1 $2",["(?:[1-3]0|[68])0|70[07-9]"],"0$1"],["(\\d{2})(\\d{4,8})","$1 $2",["[14]|2[09]|50|7[135]"],"0$1"],["(\\d{2})(\\d{6,10})","$1 $2",["7"],"0$1"],["(\\d)(\\d{4,9})","$1 $2",["(?:19|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"],"0$1"]],"0",0,0,0,0,"1[03-79]|[2-9]",0,"00"],"FJ":["679","0(?:0|52)","45\\d{5}|(?:0800\\d|[235-9])\\d{6}",[7,11],[["(\\d{3})(\\d{4})","$1 $2",["[235-9]|45"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["0"]]],0,0,0,0,0,0,0,"00"],"FK":["500","00","[2-7]\\d{4}",[5]],"FM":["691","00","(?:[39]\\d\\d|820)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[389]"]]]],"FO":["298","00","[2-9]\\d{5}",[6],[["(\\d{6})","$1",["[2-9]"]]],0,0,"(10(?:01|[12]0|88))"],"FR":["33","00","[1-9]\\d{8}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0 $1"],["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["[1-79]"],"0$1"]],"0"],"GA":["241","00","(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}",[7,8],[["(\\d)(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-7]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["0"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["11|[67]"],"0$1"]],0,0,"0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})","$1"],"GB":["44","00","[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}",[7,9,10],[["(\\d{3})(\\d{4})","$1 $2",["800","8001","80011","800111","8001111"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["845","8454","84546","845464"],"0$1"],["(\\d{3})(\\d{6})","$1 $2",["800"],"0$1"],["(\\d{5})(\\d{4,5})","$1 $2",["1(?:38|5[23]|69|76|94)","1(?:(?:38|69)7|5(?:24|39)|768|946)","1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"],"0$1"],["(\\d{4})(\\d{5,6})","$1 $2",["1(?:[2-69][02-9]|[78])"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["[25]|7(?:0|6[02-9])","[25]|7(?:0|6(?:[03-9]|2[356]))"],"0$1"],["(\\d{4})(\\d{6})","$1 $2",["7"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[1389]"],"0$1"]],"0",0,0,0,0,0,[["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0-35])|4(?:(?:[0-5]\\d|70)\\d|69[7-9])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-3]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}",[9,10]],["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}",[10]],["80[08]\\d{7}|800\\d{6}|8001111"],["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d",[7,10]],["70\\d{8}",[10]],0,["(?:3[0347]|55)\\d{8}",[10]],["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",[10]],["56\\d{8}",[10]]],0," x"],"GD":["1","011","(?:473|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2-9]\\d{6})$|1","473$1",0,"473"],"GE":["995","00","(?:[3-57]\\d\\d|800)\\d{6}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["70"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["32"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[57]"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[348]"],"0$1"]],"0"],"GF":["594","00","(?:[56]94\\d|7093)\\d{5}|(?:80|9\\d)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-7]|9[47]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[89]"],"0$1"]],"0"],"GG":["44","00","(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?",[7,9,10],0,"0",0,"([25-9]\\d{5})$|0","1481$1",0,0,[["1481[25-9]\\d{5}",[10]],["7(?:(?:781|839)\\d|911[17])\\d{5}",[10]],["80[08]\\d{7}|800\\d{6}|8001111"],["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d",[7,10]],["70\\d{8}",[10]],0,["(?:3[0347]|55)\\d{8}",[10]],["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",[10]],["56\\d{8}",[10]]]],"GH":["233","00","(?:[235]\\d{3}|800)\\d{5}",[8,9],[["(\\d{3})(\\d{5})","$1 $2",["8"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[235]"],"0$1"]],"0"],"GI":["350","00","(?:[25]\\d|60)\\d{6}",[8],[["(\\d{3})(\\d{5})","$1 $2",["2"]]]],"GL":["299","00","(?:19|[2-689]\\d|70)\\d{4}",[6],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["19|[2-9]"]]]],"GM":["220","00","[2-9]\\d{6}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-9]"]]]],"GN":["224","00","722\\d{6}|(?:3|6\\d)\\d{7}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["3"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[67]"]]]],"GP":["590","00","(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-79]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0$1"]],"0",0,0,0,0,0,[["590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"],["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"],["80[0-5]\\d{6}"],0,0,0,0,0,["9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}"]]],"GQ":["240","00","222\\d{6}|(?:3\\d|55|[89]0)\\d{7}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[235]"]],["(\\d{3})(\\d{6})","$1 $2",["[89]"]]]],"GR":["30","00","5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}",[10,11,12],[["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["21|7"]],["(\\d{4})(\\d{6})","$1 $2",["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[2689]"]],["(\\d{3})(\\d{3,4})(\\d{5})","$1 $2 $3",["8"]]]],"GT":["502","00","80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}",[8,11],[["(\\d{4})(\\d{4})","$1 $2",["[2-8]"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]]]],"GU":["1","011","(?:[58]\\d\\d|671|900)\\d{7}",[10],0,"1",0,"([2-9]\\d{6})$|1","671$1",0,"671"],"GW":["245","00","[49]\\d{8}|4\\d{6}",[7,9],[["(\\d{3})(\\d{4})","$1 $2",["40"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[49]"]]]],"GY":["592","001","(?:[2-8]\\d{3}|9008)\\d{3}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-9]"]]]],"HK":["852","00(?:30|5[09]|[126-9]?)","8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}",[5,6,7,8,9,11],[["(\\d{3})(\\d{2,5})","$1 $2",["900","9003"]],["(\\d{4})(\\d{4})","$1 $2",["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"]],["(\\d{3})(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9"]]],0,0,0,0,0,0,0,"00"],"HN":["504","00","8\\d{10}|[237-9]\\d{7}",[8,11],[["(\\d{4})(\\d{4})","$1-$2",["[237-9]"]]]],"HR":["385","00","(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}",[6,7,8,9],[["(\\d{2})(\\d{2})(\\d{2,3})","$1 $2 $3",["6[01]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["8"],"0$1"],["(\\d)(\\d{4})(\\d{3})","$1 $2 $3",["1"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["6|7[245]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["9"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-57]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"],"0$1"]],"0"],"HT":["509","00","(?:[2-489]\\d|55)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["[2-589]"]]]],"HU":["36","00","[235-7]\\d{8}|[1-9]\\d{7}",[8,9],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["1"],"(06 $1)"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"],"(06 $1)"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-9]"],"06 $1"]],"06"],"ID":["62","00[89]","00[1-9]\\d{9,14}|(?:[1-36]|8\\d{5})\\d{6}|00\\d{9}|[1-9]\\d{8,10}|[2-9]\\d{7}",[7,8,9,10,11,12,13,14,15,16,17],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["15"]],["(\\d{2})(\\d{5,9})","$1 $2",["2[124]|[36]1"],"(0$1)"],["(\\d{3})(\\d{5,7})","$1 $2",["800"],"0$1"],["(\\d{3})(\\d{5,8})","$1 $2",["[2-79]"],"(0$1)"],["(\\d{3})(\\d{3,4})(\\d{3})","$1-$2-$3",["8[1-35-9]"],"0$1"],["(\\d{3})(\\d{6,8})","$1 $2",["1"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["804"],"0$1"],["(\\d{3})(\\d)(\\d{3})(\\d{3})","$1 $2 $3 $4",["80"],"0$1"],["(\\d{3})(\\d{4})(\\d{4,5})","$1-$2-$3",["8"],"0$1"]],"0"],"IE":["353","00","(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}",[7,8,9,10],[["(\\d{2})(\\d{5})","$1 $2",["2[24-9]|47|58|6[237-9]|9[35-9]"],"(0$1)"],["(\\d{3})(\\d{5})","$1 $2",["[45]0"],"(0$1)"],["(\\d)(\\d{3,4})(\\d{4})","$1 $2 $3",["1"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2569]|4[1-69]|7[14]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["70"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["81"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[78]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["4"],"(0$1)"],["(\\d{2})(\\d)(\\d{3})(\\d{4})","$1 $2 $3 $4",["8"],"0$1"]],"0"],"IL":["972","0(?:0|1[2-9])","1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}",[7,8,9,10,11,12],[["(\\d{4})(\\d{3})","$1-$2",["125"]],["(\\d{4})(\\d{2})(\\d{2})","$1-$2-$3",["121"]],["(\\d)(\\d{3})(\\d{4})","$1-$2-$3",["[2-489]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["[57]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1-$2-$3",["12"]],["(\\d{4})(\\d{6})","$1-$2",["159"]],["(\\d)(\\d{3})(\\d{3})(\\d{3})","$1-$2-$3-$4",["1[7-9]"]],["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})","$1-$2 $3-$4",["15"]]],"0"],"IM":["44","00","1624\\d{6}|(?:[3578]\\d|90)\\d{8}",[10],0,"0",0,"([25-8]\\d{5})$|0","1624$1",0,"74576|(?:16|7[56])24"],"IN":["91","00","(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}",[8,9,10,11,12,13],[["(\\d{8})","$1",["5(?:0|2[23]|3[03]|[67]1|88)","5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)","5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"],0,1],["(\\d{4})(\\d{4,5})","$1 $2",["180","1800"],0,1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["140"],0,1],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["11|2[02]|33|4[04]|79[1-7]|80[2-46]","11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])","11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"],"0$1",1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]","1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]","1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"],"0$1",1],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807","1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]","1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"],"0$1",1],["(\\d{5})(\\d{5})","$1 $2",["[6-9]"],"0$1",1],["(\\d{4})(\\d{2,4})(\\d{4})","$1 $2 $3",["1(?:6|8[06])","1(?:6|8[06]0)"],0,1],["(\\d{4})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["18"],0,1]],"0"],"IO":["246","00","3\\d{6}",[7],[["(\\d{3})(\\d{4})","$1 $2",["3"]]]],"IQ":["964","00","(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}",[8,9,10],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-6]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"0$1"]],"0"],"IR":["98","00","[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}",[4,5,6,7,10],[["(\\d{4,5})","$1",["96"],"0$1"],["(\\d{2})(\\d{4,5})","$1 $2",["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["9"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["[1-8]"],"0$1"]],"0"],"IS":["354","00|1(?:0(?:01|[12]0)|100)","(?:38\\d|[4-9])\\d{6}",[7,9],[["(\\d{3})(\\d{4})","$1 $2",["[4-9]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["3"]]],0,0,0,0,0,0,0,"00"],"IT":["39","00","0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?",[6,7,8,9,10,11,12],[["(\\d{2})(\\d{4,6})","$1 $2",["0[26]"]],["(\\d{3})(\\d{3,6})","$1 $2",["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])","0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]],["(\\d{4})(\\d{2,6})","$1 $2",["0(?:[13-579][2-46-8]|8[236-8])"]],["(\\d{4})(\\d{4})","$1 $2",["894"]],["(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[26]|5"]],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["1(?:44|[679])|[378]|43"]],["(\\d{3})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[13-57-9][0159]|14"]],["(\\d{2})(\\d{4})(\\d{5})","$1 $2 $3",["0[26]"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["0"]],["(\\d{3})(\\d{4})(\\d{4,5})","$1 $2 $3",["3"]]],0,0,0,0,0,0,[["0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}",[6,7,8,9,10,11]],["3[2-9]\\d{7,8}|(?:31|43)\\d{8}",[9,10]],["80(?:0\\d{3}|3)\\d{3}",[6,9]],["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}",[6,8,9,10]],["1(?:78\\d|99)\\d{6}",[9,10]],["3[2-8]\\d{9,10}",[11,12]],0,0,["55\\d{8}",[10]],["84(?:[08]\\d{3}|[17])\\d{3}",[6,9]]]],"JE":["44","00","1534\\d{6}|(?:[3578]\\d|90)\\d{8}",[10],0,"0",0,"([0-24-8]\\d{5})$|0","1534$1",0,0,[["1534[0-24-8]\\d{5}"],["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}"],["80(?:07(?:35|81)|8901)\\d{4}"],["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"],["701511\\d{4}"],0,["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"],["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"],["56\\d{8}"]]],"JM":["1","011","(?:[58]\\d\\d|658|900)\\d{7}",[10],0,"1",0,0,0,0,"658|876"],"JO":["962","00","(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}",[8,9],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2356]|87"],"(0$1)"],["(\\d{3})(\\d{5,6})","$1 $2",["[89]"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["70"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["7"],"0$1"]],"0"],"JP":["81","010","00[1-9]\\d{6,14}|[25-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}",[8,9,10,11,12,13,14,15,16,17],[["(\\d{3})(\\d{3})(\\d{3})","$1-$2-$3",["(?:12|57|99)0"],"0$1"],["(\\d{4})(\\d)(\\d{4})","$1-$2-$3",["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])","1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]","1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["60"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1-$2-$3",["3|4(?:2[09]|7[01])|6[1-9]","3|4(?:2(?:0|9[02-69])|7(?:0[019]|1))|6[1-9]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])","1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]","1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"],"0$1"],["(\\d{3})(\\d{2})(\\d{4})","$1-$2-$3",["[14]|[289][2-9]|5[3-9]|7[2-4679]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["800"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1-$2-$3",["[25-9]"],"0$1"]],"0",0,"(000[259]\\d{6})$|(?:(?:003768)0?)|0","$1"],"KE":["254","000","(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}",[7,8,9,10],[["(\\d{2})(\\d{5,7})","$1 $2",["[24-6]"],"0$1"],["(\\d{3})(\\d{6})","$1 $2",["[17]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[89]"],"0$1"]],"0"],"KG":["996","00","8\\d{9}|[235-9]\\d{8}",[9,10],[["(\\d{4})(\\d{5})","$1 $2",["3(?:1[346]|[24-79])"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[235-79]|88"],"0$1"],["(\\d{3})(\\d{3})(\\d)(\\d{2,3})","$1 $2 $3 $4",["8"],"0$1"]],"0"],"KH":["855","00[14-9]","1\\d{9}|[1-9]\\d{7,8}",[8,9,10],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-9]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]]],"0"],"KI":["686","00","(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}",[5,8],0,"0"],"KM":["269","00","[3478]\\d{6}",[7],[["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[3478]"]]]],"KN":["1","011","(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2-7]\\d{6})$|1","869$1",0,"869"],"KP":["850","00|99","85\\d{6}|(?:19\\d|[2-7])\\d{7}",[8,10],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["8"],"0$1"],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2-7]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"]],"0"],"KR":["82","00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))","00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}",[5,6,8,9,10,11,12,13,14],[["(\\d{2})(\\d{3,4})","$1-$2",["(?:3[1-3]|[46][1-4]|5[1-5])1"],"0$1"],["(\\d{4})(\\d{4})","$1-$2",["1"]],["(\\d)(\\d{3,4})(\\d{4})","$1-$2-$3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["[36]0|8"],"0$1"],["(\\d{2})(\\d{3,4})(\\d{4})","$1-$2-$3",["[1346]|5[1-5]"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1-$2-$3",["[57]"],"0$1"],["(\\d{2})(\\d{5})(\\d{4})","$1-$2-$3",["5"],"0$1"]],"0",0,"0(8(?:[1-46-8]|5\\d\\d))?"],"KW":["965","00","18\\d{5}|(?:[2569]\\d|41)\\d{6}",[7,8],[["(\\d{4})(\\d{3,4})","$1 $2",["[169]|2(?:[235]|4[1-35-9])|52"]],["(\\d{3})(\\d{5})","$1 $2",["[245]"]]]],"KY":["1","011","(?:345|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2-9]\\d{6})$|1","345$1",0,"345"],"KZ":["7","810","(?:33622|8\\d{8})\\d{5}|[78]\\d{9}",[10,14],0,"8",0,0,0,0,"33|7",0,"8~10"],"LA":["856","00","[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}",[8,9,10],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["2[13]|3[14]|[4-8]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["30[0135-9]"],"0$1"],["(\\d{2})(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3 $4",["[23]"],"0$1"]],"0"],"LB":["961","00","[27-9]\\d{7}|[13-9]\\d{6}",[7,8],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[27-9]"]]],"0"],"LC":["1","011","(?:[58]\\d\\d|758|900)\\d{7}",[10],0,"1",0,"([2-8]\\d{6})$|1","758$1",0,"758"],"LI":["423","00","[68]\\d{8}|(?:[2378]\\d|90)\\d{5}",[7,9],[["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[2379]|8(?:0[09]|7)","[2379]|8(?:0(?:02|9)|7)"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["69"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"]]],"0",0,"(1001)|0"],"LK":["94","00","[1-9]\\d{8}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[1-689]"],"0$1"]],"0"],"LR":["231","00","(?:[245]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}",[7,8,9],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["4[67]|[56]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[2-578]"],"0$1"]],"0"],"LS":["266","00","(?:[256]\\d\\d|800)\\d{5}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[2568]"]]]],"LT":["370","00","(?:[3469]\\d|52|[78]0)\\d{6}",[8],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["52[0-7]"],"(0-$1)",1],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[7-9]"],"0 $1",1],["(\\d{2})(\\d{6})","$1 $2",["37|4(?:[15]|6[1-8])"],"(0-$1)",1],["(\\d{3})(\\d{5})","$1 $2",["[3-6]"],"(0-$1)",1]],"0",0,"[08]"],"LU":["352","00","35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}",[4,5,6,7,8,9,10,11],[["(\\d{2})(\\d{3})","$1 $2",["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]],["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]],["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["20[2-689]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})","$1 $2 $3 $4",["2(?:[0367]|4[3-8])"]],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["80[01]|90[015]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["20"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})","$1 $2 $3 $4 $5",["2(?:[0367]|4[3-8])"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})","$1 $2 $3 $4",["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]],0,0,"(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"],"LV":["371","00","(?:[268]\\d|90)\\d{6}",[8],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[269]|8[01]"]]]],"LY":["218","00","[2-9]\\d{8}",[9],[["(\\d{2})(\\d{7})","$1-$2",["[2-9]"],"0$1"]],"0"],"MA":["212","00","[5-8]\\d{8}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["5[45]"],"0$1"],["(\\d{4})(\\d{5})","$1-$2",["5(?:2[2-46-9]|3[3-9]|9)|8(?:0[89]|92)"],"0$1"],["(\\d{2})(\\d{7})","$1-$2",["8"],"0$1"],["(\\d{3})(\\d{6})","$1-$2",["[5-7]"],"0$1"]],"0",0,0,0,0,0,[["5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"],["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-467]|5[0-3]|8[0-5]))\\d{6}"],["80[0-7]\\d{6}"],["89\\d{7}"],0,0,0,0,["(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"]]],"MC":["377","00","(?:[3489]|6\\d)\\d{7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["4"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[389]"]],["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["6"],"0$1"]],"0"],"MD":["373","00","(?:[235-7]\\d|[89]0)\\d{6}",[8],[["(\\d{3})(\\d{5})","$1 $2",["[89]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["22|3"],"0$1"],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[25-7]"],"0$1"]],"0"],"ME":["382","00","(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-9]"],"0$1"]],"0"],"MF":["590","00","(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}",[9],0,"0",0,0,0,0,0,[["590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"],["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"],["80[0-5]\\d{6}"],0,0,0,0,0,["9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}"]]],"MG":["261","00","[23]\\d{8}",[9],[["(\\d{2})(\\d{2})(\\d{3})(\\d{2})","$1 $2 $3 $4",["[23]"],"0$1"]],"0",0,"([24-9]\\d{6})$|0","20$1"],"MH":["692","011","329\\d{4}|(?:[256]\\d|45)\\d{5}",[7],[["(\\d{3})(\\d{4})","$1-$2",["[2-6]"]]],"1"],"MK":["389","00","[2-578]\\d{7}",[8],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["2|34[47]|4(?:[37]7|5[47]|64)"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[347]"],"0$1"],["(\\d{3})(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["[58]"],"0$1"]],"0"],"ML":["223","00","[24-9]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[24-9]"]]]],"MM":["95","00","1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}",[6,7,8,9,10],[["(\\d)(\\d{2})(\\d{3})","$1 $2 $3",["16|2"],"0$1"],["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["4(?:[2-46]|5[3-5])|5|6(?:[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-5]|(?:60|86)[23]"],"0$1"],["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[12]|452|678|86","[12]|452|6788|86"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[4-7]|8[1-35]"],"0$1"],["(\\d)(\\d{3})(\\d{4,6})","$1 $2 $3",["9(?:2[0-4]|[35-9]|4[137-9])"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"],"0$1"],["(\\d)(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["92"],"0$1"],["(\\d)(\\d{5})(\\d{4})","$1 $2 $3",["9"],"0$1"]],"0"],"MN":["976","001","[12]\\d{7,9}|[5-9]\\d{7}",[8,9,10],[["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["[12]1"],"0$1"],["(\\d{4})(\\d{4})","$1 $2",["[5-9]"]],["(\\d{3})(\\d{5,6})","$1 $2",["[12]2[1-3]"],"0$1"],["(\\d{4})(\\d{5,6})","$1 $2",["[12](?:27|3[2-8]|4[2-68]|5[1-4689])","[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"],"0$1"],["(\\d{5})(\\d{4,5})","$1 $2",["[12]"],"0$1"]],"0"],"MO":["853","00","0800\\d{3}|(?:28|[68]\\d)\\d{6}",[7,8],[["(\\d{4})(\\d{3})","$1 $2",["0"]],["(\\d{4})(\\d{4})","$1 $2",["[268]"]]]],"MP":["1","011","[58]\\d{9}|(?:67|90)0\\d{7}",[10],0,"1",0,"([2-9]\\d{6})$|1","670$1",0,"670"],"MQ":["596","00","(?:596\\d|7091)\\d{5}|(?:69|[89]\\d)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-79]|8(?:0[6-9]|[36])"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0$1"]],"0"],"MR":["222","00","(?:[2-4]\\d\\d|800)\\d{5}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-48]"]]]],"MS":["1","011","(?:[58]\\d\\d|664|900)\\d{7}",[10],0,"1",0,"([34]\\d{6})$|1","664$1",0,"664"],"MT":["356","00","3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[2357-9]"]]]],"MU":["230","0(?:0|[24-7]0|3[03])","(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}",[7,8,10],[["(\\d{3})(\\d{4})","$1 $2",["[2-46]|8[013]"]],["(\\d{4})(\\d{4})","$1 $2",["[57]"]],["(\\d{5})(\\d{5})","$1 $2",["8"]]],0,0,0,0,0,0,0,"020"],"MV":["960","0(?:0|19)","(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}",[7,10],[["(\\d{3})(\\d{4})","$1-$2",["[34679]"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[89]"]]],0,0,0,0,0,0,0,"00"],"MW":["265","00","(?:[1289]\\d|31|77)\\d{7}|1\\d{6}",[7,9],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["1[2-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["2"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[137-9]"],"0$1"]],"0"],"MX":["52","0[09]","[2-9]\\d{9}",[10],[["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["33|5[56]|81"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[2-9]"]]],0,0,0,0,0,0,0,"00"],"MY":["60","00","1\\d{8,9}|(?:3\\d|[4-9])\\d{7}",[8,9,10],[["(\\d)(\\d{3})(\\d{4})","$1-$2 $3",["[4-79]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1-$2 $3",["1(?:[02469]|[378][1-9]|53)|8","1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1-$2 $3",["3"],"0$1"],["(\\d)(\\d{3})(\\d{2})(\\d{4})","$1-$2-$3-$4",["1(?:[367]|80)"]],["(\\d{3})(\\d{3})(\\d{4})","$1-$2 $3",["15"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1-$2 $3",["1"],"0$1"]],"0"],"MZ":["258","00","(?:2|8\\d)\\d{7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["2|8[2-79]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"]]]],"NA":["264","00","[68]\\d{7,8}",[8,9],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["88"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["6"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["87"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["8"],"0$1"]],"0"],"NC":["687","00","(?:050|[2-57-9]\\d\\d)\\d{3}",[6],[["(\\d{2})(\\d{2})(\\d{2})","$1.$2.$3",["[02-57-9]"]]]],"NE":["227","00","[027-9]\\d{7}",[8],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["08"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[089]|2[013]|7[0467]"]]]],"NF":["672","00","[13]\\d{5}",[6],[["(\\d{2})(\\d{4})","$1 $2",["1[0-3]"]],["(\\d)(\\d{5})","$1 $2",["[13]"]]],0,0,"([0-258]\\d{4})$","3$1"],"NG":["234","009","38\\d{6}|[78]\\d{9,13}|(?:20|9\\d)\\d{8}",[8,10,11,12,13,14],[["(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["3"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[7-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["20[129]"],"0$1"],["(\\d{4})(\\d{2})(\\d{4})","$1 $2 $3",["2"],"0$1"],["(\\d{3})(\\d{4})(\\d{4,5})","$1 $2 $3",["[78]"],"0$1"],["(\\d{3})(\\d{5})(\\d{5,6})","$1 $2 $3",["[78]"],"0$1"]],"0"],"NI":["505","00","(?:1800|[25-8]\\d{3})\\d{4}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[125-8]"]]]],"NL":["31","00","(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}",[5,6,7,8,9,10,11],[["(\\d{3})(\\d{4,7})","$1 $2",["[89]0"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["66"],"0$1"],["(\\d)(\\d{8})","$1 $2",["6"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-578]|91"],"0$1"],["(\\d{3})(\\d{3})(\\d{5})","$1 $2 $3",["9"],"0$1"]],"0"],"NO":["47","00","(?:0|[2-9]\\d{3})\\d{4}",[5,8],[["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["8"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-79]"]]],0,0,0,0,0,"[02-689]|7[0-8]"],"NP":["977","00","(?:1\\d|9)\\d{9}|[1-9]\\d{7}",[8,10,11],[["(\\d)(\\d{7})","$1-$2",["1[2-6]"],"0$1"],["(\\d{2})(\\d{6})","$1-$2",["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"],"0$1"],["(\\d{3})(\\d{7})","$1-$2",["9"]]],"0"],"NR":["674","00","(?:444|(?:55|8\\d)\\d|666)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[4-68]"]]]],"NU":["683","00","(?:[4-7]|888\\d)\\d{3}",[4,7],[["(\\d{3})(\\d{4})","$1 $2",["8"]]]],"NZ":["64","0(?:0|161)","[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}",[5,6,7,8,9,10],[["(\\d{2})(\\d{3,8})","$1 $2",["8[1-79]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["50[036-8]|8|90","50(?:[0367]|88)|8|90"],"0$1"],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["24|[346]|7[2-57-9]|9[2-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["2(?:10|74)|[589]"],"0$1"],["(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["1|2[028]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,5})","$1 $2 $3",["2(?:[169]|7[0-35-9])|7"],"0$1"]],"0",0,0,0,0,0,0,"00"],"OM":["968","00","(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}",[7,8,9],[["(\\d{3})(\\d{4,6})","$1 $2",["[58]"]],["(\\d{2})(\\d{6})","$1 $2",["2"]],["(\\d{4})(\\d{4})","$1 $2",["[179]"]]]],"PA":["507","00","(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}",[7,8,10,11],[["(\\d{3})(\\d{4})","$1-$2",["[1-57-9]"]],["(\\d{4})(\\d{4})","$1-$2",["[68]"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"]]]],"PE":["51","00|19(?:1[124]|77|90)00","(?:[14-8]|9\\d)\\d{7}",[8,9],[["(\\d{3})(\\d{5})","$1 $2",["80"],"(0$1)"],["(\\d)(\\d{7})","$1 $2",["1"],"(0$1)"],["(\\d{2})(\\d{6})","$1 $2",["[4-8]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["9"]]],"0",0,0,0,0,0,0,"00"," Anexo "],"PF":["689","00","4\\d{5}(?:\\d{2})?|8\\d{7,8}",[6,8,9],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["44"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["4|8[7-9]"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"]]]],"PG":["675","00|140[1-3]","(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}",[7,8],[["(\\d{3})(\\d{4})","$1 $2",["18|[2-69]|85"]],["(\\d{4})(\\d{4})","$1 $2",["[78]"]]],0,0,0,0,0,0,0,"00"],"PH":["63","00","(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}",[6,8,9,10,11,12,13],[["(\\d)(\\d{5})","$1 $2",["2"],"(0$1)"],["(\\d{4})(\\d{4,6})","$1 $2",["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2","3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"],"(0$1)"],["(\\d{5})(\\d{4})","$1 $2",["346|4(?:27|9[35])|883","3469|4(?:279|9(?:30|56))|8834"],"(0$1)"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[3-7]|8[2-8]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[89]"],"0$1"],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]],["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})","$1 $2 $3 $4",["1"]]],"0"],"PK":["92","00","122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",[8,9,10,11,12],[["(\\d{3})(\\d{3})(\\d{2,7})","$1 $2 $3",["[89]0"],"0$1"],["(\\d{4})(\\d{5})","$1 $2",["1"]],["(\\d{3})(\\d{6,7})","$1 $2",["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])","9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"],"(0$1)"],["(\\d{2})(\\d{7,8})","$1 $2",["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"],"(0$1)"],["(\\d{5})(\\d{5})","$1 $2",["58"],"(0$1)"],["(\\d{3})(\\d{7})","$1 $2",["3"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["[24-9]"],"(0$1)"]],"0"],"PL":["48","00","(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}",[6,7,8,9,10],[["(\\d{5})","$1",["19"]],["(\\d{3})(\\d{3})","$1 $2",["11|20|64"]],["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1","(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]],["(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["64"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[2-8]|[2-7]|8[1-79]|9[145]"]],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["8"]]]],"PM":["508","00","[45]\\d{5}|(?:708|8\\d\\d)\\d{6}",[6,9],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["[45]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["7"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0$1"]],"0"],"PR":["1","011","(?:[589]\\d\\d|787)\\d{7}",[10],0,"1",0,0,0,0,"787|939"],"PS":["970","00","[2489]2\\d{6}|(?:1\\d|5)\\d{8}",[8,9,10],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2489]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["5"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]]],"0"],"PT":["351","00","1693\\d{5}|(?:[26-9]\\d|30)\\d{7}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["2[12]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["16|[236-9]"]]]],"PW":["680","01[12]","(?:[24-8]\\d\\d|345|900)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-9]"]]]],"PY":["595","00","59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}",[6,7,8,9,10,11],[["(\\d{3})(\\d{3,6})","$1 $2",["[2-9]0"],"0$1"],["(\\d{2})(\\d{5})","$1 $2",["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"],"(0$1)"],["(\\d{3})(\\d{4,5})","$1 $2",["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["87"]],["(\\d{3})(\\d{6})","$1 $2",["9(?:[5-79]|8[1-7])"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[2-8]"],"0$1"],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["9"]]],"0"],"QA":["974","00","800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}",[7,8,9,11],[["(\\d{3})(\\d{4})","$1 $2",["2[16]|8"]],["(\\d{4})(\\d{4})","$1 $2",["[3-7]"]]]],"RE":["262","00","709\\d{6}|(?:26|[689]\\d)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[26-9]"],"0$1"]],"0",0,0,0,0,0,[["26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"],["(?:69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))|7092[0-3])\\d{4}"],["80\\d{7}"],["89[1-37-9]\\d{6}"],0,0,0,0,["9(?:399[0-3]|479[0-5]|76(?:2[278]|3[0-37]))\\d{4}"],["8(?:1[019]|2[0156]|84|90)\\d{6}"]]],"RO":["40","00","(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}",[6,9],[["(\\d{3})(\\d{3})","$1 $2",["2[3-6]","2[3-6]\\d9"],"0$1"],["(\\d{2})(\\d{4})","$1 $2",["219|31"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[23]1"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[236-9]"],"0$1"]],"0",0,0,0,0,0,0,0," int "],"RS":["381","00","38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}",[6,7,8,9,10,11,12],[["(\\d{3})(\\d{3,9})","$1 $2",["(?:2[389]|39)0|[7-9]"],"0$1"],["(\\d{2})(\\d{5,10})","$1 $2",["[1-36]"],"0$1"]],"0"],"RU":["7","810","8\\d{13}|[347-9]\\d{9}",[10,14],[["(\\d{4})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["7(?:1[0-8]|2[1-9])","7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))","7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"],"8 ($1)",1],["(\\d{5})(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["7(?:1[0-68]|2[1-9])","7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))","7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"],"8 ($1)",1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"8 ($1)",1],["(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2-$3-$4",["[349]|8(?:[02-7]|1[1-8])"],"8 ($1)",1],["(\\d{4})(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3 $4",["8"],"8 ($1)"]],"8",0,0,0,0,"3[04-689]|[489]",0,"8~10"],"RW":["250","00","(?:06|[27]\\d\\d|[89]00)\\d{6}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["0"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["2"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[7-9]"],"0$1"]],"0"],"SA":["966","00","92\\d{7}|(?:[15]|8\\d)\\d{8}",[9,10],[["(\\d{4})(\\d{5})","$1 $2",["9"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["5"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["81"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"]]],"0"],"SB":["677","0[01]","[6-9]\\d{6}|[1-6]\\d{4}",[5,7],[["(\\d{2})(\\d{5})","$1 $2",["6[89]|7|8[4-9]|9(?:[1-8]|9[0-8])"]]]],"SC":["248","010|0[0-2]","(?:[2489]\\d|64)\\d{5}",[7],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[246]|9[57]"]]],0,0,0,0,0,0,0,"00"],"SD":["249","00","[19]\\d{8}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[19]"],"0$1"]],"0"],"SE":["46","00","(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}",[6,7,8,9,10,12],[["(\\d{2})(\\d{2,3})(\\d{2})","$1-$2 $3",["20"],"0$1",0,"$1 $2 $3"],["(\\d{3})(\\d{4})","$1-$2",["9(?:00|39|44|9)"],"0$1",0,"$1 $2"],["(\\d{2})(\\d{3})(\\d{2})","$1-$2 $3",["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"],"0$1",0,"$1 $2 $3"],["(\\d)(\\d{2,3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["8"],"0$1",0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2,3})(\\d{2})","$1-$2 $3",["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"],"0$1",0,"$1 $2 $3"],["(\\d{3})(\\d{2,3})(\\d{3})","$1-$2 $3",["9(?:00|39|44)"],"0$1",0,"$1 $2 $3"],["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"],"0$1",0,"$1 $2 $3 $4"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["10|7"],"0$1",0,"$1 $2 $3 $4"],["(\\d)(\\d{3})(\\d{3})(\\d{2})","$1-$2 $3 $4",["8"],"0$1",0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1-$2 $3 $4",["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"],"0$1",0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2})(\\d{2})(\\d{3})","$1-$2 $3 $4",["9"],"0$1",0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1-$2 $3 $4 $5",["[26]"],"0$1",0,"$1 $2 $3 $4 $5"]],"0"],"SG":["65","0[0-3]\\d","(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}",[8,10,11],[["(\\d{4})(\\d{4})","$1 $2",["[369]|8(?:0[1-9]|[1-9])"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"]],["(\\d{4})(\\d{4})(\\d{3})","$1 $2 $3",["7"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]]]],"SH":["290","00","(?:[256]\\d|8)\\d{3}",[4,5],0,0,0,0,0,0,"[256]"],"SI":["386","00|10(?:22|66|88|99)","[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}",[5,6,7,8],[["(\\d{2})(\\d{3,6})","$1 $2",["8[09]|9"],"0$1"],["(\\d{3})(\\d{5})","$1 $2",["59|8"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[37][01]|4[0139]|51|6"],"0$1"],["(\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[1-57]"],"(0$1)"]],"0",0,0,0,0,0,0,"00"],"SJ":["47","00","0\\d{4}|(?:[489]\\d|79)\\d{6}",[5,8],0,0,0,0,0,0,"79"],"SK":["421","00","[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}",[6,7,9],[["(\\d)(\\d{2})(\\d{3,4})","$1 $2 $3",["21"],"0$1"],["(\\d{2})(\\d{2})(\\d{2,3})","$1 $2 $3",["[3-5][1-8]1","[3-5][1-8]1[67]"],"0$1"],["(\\d)(\\d{3})(\\d{3})(\\d{2})","$1/$2 $3 $4",["2"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[689]"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1/$2 $3 $4",["[3-5]"],"0$1"]],"0"],"SL":["232","00","(?:[237-9]\\d|66)\\d{6}",[8],[["(\\d{2})(\\d{6})","$1 $2",["[236-9]"],"(0$1)"]],"0"],"SM":["378","00","(?:0549|[5-7]\\d)\\d{6}",[8,10],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-7]"]],["(\\d{4})(\\d{6})","$1 $2",["0"]]],0,0,"([89]\\d{5})$","0549$1"],"SN":["221","00","(?:[378]\\d|93)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"]],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[379]"]]]],"SO":["252","00","[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}",[6,7,8,9],[["(\\d{2})(\\d{4})","$1 $2",["8[125]"]],["(\\d{6})","$1",["[134]"]],["(\\d)(\\d{6})","$1 $2",["[15]|2[0-79]|3[0-46-8]|4[0-7]"]],["(\\d)(\\d{7})","$1 $2",["(?:2|90)4|[67]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[348]|64|79|90"]],["(\\d{2})(\\d{5,7})","$1 $2",["1|28|6[0-35-9]|7[67]|9[2-9]"]]],"0"],"SR":["597","00","(?:[2-5]|68|[78]\\d)\\d{5}",[6,7],[["(\\d{2})(\\d{2})(\\d{2})","$1-$2-$3",["56"]],["(\\d{3})(\\d{3})","$1-$2",["[2-5]"]],["(\\d{3})(\\d{4})","$1-$2",["[6-8]"]]]],"SS":["211","00","[19]\\d{8}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[19]"],"0$1"]],"0"],"ST":["239","00","(?:22|9\\d)\\d{5}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[29]"]]]],"SV":["503","00","[267]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?",[7,8,11],[["(\\d{3})(\\d{4})","$1 $2",["[89]"]],["(\\d{4})(\\d{4})","$1 $2",["[267]"]],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["[89]"]]]],"SX":["1","011","7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"(5\\d{6})$|1","721$1",0,"721"],"SY":["963","00","[1-359]\\d{8}|[1-5]\\d{7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-4]|5[1-3]"],"0$1",1],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[59]"],"0$1",1]],"0"],"SZ":["268","00","0800\\d{4}|(?:[237]\\d|900)\\d{6}",[8,9],[["(\\d{4})(\\d{4})","$1 $2",["[0237]"]],["(\\d{5})(\\d{4})","$1 $2",["9"]]]],"TA":["290","00","8\\d{3}",[4],0,0,0,0,0,0,"8"],"TC":["1","011","(?:[58]\\d\\d|649|900)\\d{7}",[10],0,"1",0,"([2-479]\\d{6})$|1","649$1",0,"649"],"TD":["235","00|16","(?:22|[689]\\d|77)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[26-9]"]]],0,0,0,0,0,0,0,"00"],"TG":["228","00","[279]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[279]"]]]],"TH":["66","00[1-9]","(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}",[8,9,10,13],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[13-9]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]]],"0"],"TJ":["992","810","[0-57-9]\\d{8}",[9],[["(\\d{6})(\\d)(\\d{2})","$1 $2 $3",["331","3317"]],["(\\d{3})(\\d{2})(\\d{4})","$1 $2 $3",["44[02-479]|[34]7"]],["(\\d{4})(\\d)(\\d{4})","$1 $2 $3",["3(?:[1245]|3[12])"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[0-57-9]"]]],0,0,0,0,0,0,0,"8~10"],"TK":["690","00","[2-47]\\d{3,6}",[4,5,6,7]],"TL":["670","00","7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}",[7,8],[["(\\d{3})(\\d{4})","$1 $2",["[2-489]|70"]],["(\\d{4})(\\d{4})","$1 $2",["7"]]]],"TM":["993","810","(?:[1-6]\\d|71)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2-$3-$4",["12"],"(8 $1)"],["(\\d{3})(\\d)(\\d{2})(\\d{2})","$1 $2-$3-$4",["[1-5]"],"(8 $1)"],["(\\d{2})(\\d{6})","$1 $2",["[67]"],"8 $1"]],"8",0,0,0,0,0,0,"8~10"],"TN":["216","00","[2-57-9]\\d{7}",[8],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2-57-9]"]]]],"TO":["676","00","(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}",[5,7],[["(\\d{2})(\\d{3})","$1-$2",["[2-4]|50|6[09]|7[0-24-69]|8[05]"]],["(\\d{4})(\\d{3})","$1 $2",["0"]],["(\\d{3})(\\d{4})","$1 $2",["[5-9]"]]]],"TR":["90","00","4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}",[7,10,12,13],[["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["512|8[01589]|90"],"0$1",1],["(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["5(?:[0-59]|61)","5(?:[0-59]|61[06])","5(?:[0-59]|61[06]1)"],"0$1",1],["(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[24][1-8]|3[1-9]"],"(0$1)",1],["(\\d{3})(\\d{3})(\\d{6,7})","$1 $2 $3",["80"],"0$1",1]],"0"],"TT":["1","011","(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2-46-8]\\d{6})$|1","868$1",0,"868"],"TV":["688","00","(?:2|7\\d\\d|90)\\d{4}",[5,6,7],[["(\\d{2})(\\d{3})","$1 $2",["2"]],["(\\d{2})(\\d{4})","$1 $2",["90"]],["(\\d{2})(\\d{5})","$1 $2",["7"]]]],"TW":["886","0(?:0[25-79]|19)","[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}",[7,8,9,10,11],[["(\\d{2})(\\d)(\\d{4})","$1 $2 $3",["202"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[258]0"],"0$1"],["(\\d)(\\d{3,4})(\\d{4})","$1 $2 $3",["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]","[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[49]"],"0$1"],["(\\d{2})(\\d{4})(\\d{4,5})","$1 $2 $3",["7"],"0$1"]],"0",0,0,0,0,0,0,0,"#"],"TZ":["255","00[056]","(?:[25-8]\\d|41|90)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{4})","$1 $2 $3",["[89]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[24]"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["5"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[67]"],"0$1"]],"0"],"UA":["380","00","[89]\\d{9}|[3-9]\\d{8}",[9,10],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]","6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"],"0$1"],["(\\d{4})(\\d{5})","$1 $2",["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])","3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[3-7]|89|9[1-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[89]"],"0$1"]],"0",0,0,0,0,0,0,"0~0"],"UG":["256","00[057]","800\\d{6}|(?:[29]0|[347]\\d)\\d{7}",[9],[["(\\d{4})(\\d{5})","$1 $2",["202","2024"],"0$1"],["(\\d{3})(\\d{6})","$1 $2",["[27-9]|4(?:6[45]|[7-9])"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["[34]"],"0$1"]],"0"],"US":["1","011","[2-9]\\d{9}|3\\d{6}",[10],[["(\\d{3})(\\d{4})","$1-$2",["310"],0,1],["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",["[2-9]"],0,1,"$1-$2-$3"]],"1",0,0,0,0,0,[["(?:3052(?:0[0-8]|[1-9]\\d)|5056(?:[0-35-9]\\d|4[468]))\\d{4}|(?:2742|305[3-9]|472[247-9]|505[2-57-9]|983[2-47-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-47-9]|1[02-9]|2[0135-79]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[0-247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"],[""],["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"],["900[2-9]\\d{6}"],["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"],0,0,0,["305209\\d{4}"]]],"UY":["598","0(?:0|1[3-9]\\d)","0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}",[6,7,8,9,10,11,12,13],[["(\\d{3})(\\d{3,4})","$1 $2",["0"]],["(\\d{3})(\\d{4})","$1 $2",["[49]0|8"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"0$1"],["(\\d{4})(\\d{4})","$1 $2",["[124]"]],["(\\d{3})(\\d{3})(\\d{2,4})","$1 $2 $3",["0"]],["(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})","$1 $2 $3 $4",["0"]]],"0",0,0,0,0,0,0,"00"," int. "],"UZ":["998","00","(?:20|33|[5-9]\\d)\\d{7}",[9],[["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[235-9]"]]]],"VA":["39","00","0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",[6,7,8,9,10,11,12],0,0,0,0,0,0,"06698"],"VC":["1","011","(?:[58]\\d\\d|784|900)\\d{7}",[10],0,"1",0,"([2-7]\\d{6})$|1","784$1",0,"784"],"VE":["58","00","[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}",[10],[["(\\d{3})(\\d{7})","$1-$2",["[24-689]"],"0$1"]],"0"],"VG":["1","011","(?:284|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2-578]\\d{6})$|1","284$1",0,"284"],"VI":["1","011","[58]\\d{9}|(?:34|90)0\\d{7}",[10],0,"1",0,"([2-9]\\d{6})$|1","340$1",0,"340"],"VN":["84","00","[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}",[7,8,9,10],[["(\\d{2})(\\d{5})","$1 $2",["80"],"0$1",1],["(\\d{4})(\\d{4,6})","$1 $2",["1"],0,1],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["6"],"0$1",1],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[357-9]"],"0$1",1],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["2[48]"],"0$1",1],["(\\d{3})(\\d{4})(\\d{3})","$1 $2 $3",["2"],"0$1",1]],"0"],"VU":["678","00","[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}",[5,7],[["(\\d{3})(\\d{4})","$1 $2",["[57-9]"]]]],"WF":["681","00","(?:40|72|8\\d{4})\\d{4}|[89]\\d{5}",[6,9],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["[47-9]"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"]]]],"WS":["685","0","(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}",[5,6,7,10],[["(\\d{5})","$1",["[2-5]|6[1-9]"]],["(\\d{3})(\\d{3,7})","$1 $2",["[68]"]],["(\\d{2})(\\d{5})","$1 $2",["7"]]]],"XK":["383","00","2\\d{7,8}|3\\d{7,11}|(?:4\\d\\d|[89]00)\\d{5}",[8,9,10,11,12],[["(\\d{3})(\\d{5})","$1 $2",["[89]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2-4]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["2|39"],"0$1"],["(\\d{2})(\\d{7,10})","$1 $2",["3"],"0$1"]],"0"],"YE":["967","00","(?:1|7\\d)\\d{7}|[1-7]\\d{6}",[7,8,9],[["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-6]|7(?:[24-6]|8[0-7])"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["7"],"0$1"]],"0"],"YT":["262","00","7093\\d{5}|(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}",[9],0,"0",0,0,0,0,0,[["269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}"],["(?:639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])|7093[5-7])\\d{4}"],["80\\d{7}"],0,0,0,0,0,["9(?:(?:39|47)8[01]|769\\d)\\d{4}"]]],"ZA":["27","00","[1-79]\\d{8}|8\\d{4,9}",[5,6,7,8,9,10],[["(\\d{2})(\\d{3,4})","$1 $2",["8[1-4]"],"0$1"],["(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["8[1-4]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["860"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"],"0$1"]],"0"],"ZM":["260","00","800\\d{6}|(?:21|63|[79]\\d)\\d{7}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[28]"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["[79]"],"0$1"]],"0"],"ZW":["263","00","2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}",[5,6,7,8,9,10],[["(\\d{3})(\\d{3,5})","$1 $2",["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"],"0$1"],["(\\d)(\\d{3})(\\d{2,4})","$1 $2 $3",["[49]"],"0$1"],["(\\d{3})(\\d{4})","$1 $2",["80"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2","2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)","2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"],"0$1"],["(\\d{4})(\\d{6})","$1 $2",["8"],"0$1"],["(\\d{2})(\\d{3,5})","$1 $2",["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["29[013-9]|39|54"],"0$1"],["(\\d{4})(\\d{3,5})","$1 $2",["(?:25|54)8","258|5483"],"0$1"]],"0"]},"nonGeographic":{"800":["800",0,"(?:00|[1-9]\\d)\\d{6}",[8],[["(\\d{4})(\\d{4})","$1 $2",["\\d"]]],0,0,0,0,0,0,[0,0,["(?:00|[1-9]\\d)\\d{6}"]]],"808":["808",0,"[1-9]\\d{7}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[1-9]"]]],0,0,0,0,0,0,[0,0,0,0,0,0,0,0,0,["[1-9]\\d{7}"]]],"870":["870",0,"7\\d{11}|[235-7]\\d{8}",[9,12],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[235-7]"]]],0,0,0,0,0,0,[0,["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"],0,0,0,0,0,0,["2\\d{8}",[9]]]],"878":["878",0,"10\\d{10}",[12],[["(\\d{2})(\\d{5})(\\d{5})","$1 $2 $3",["1"]]],0,0,0,0,0,0,[0,0,0,0,0,0,0,0,["10\\d{10}"]]],"881":["881",0,"6\\d{9}|[0-36-9]\\d{8}",[9,10],[["(\\d)(\\d{3})(\\d{5})","$1 $2 $3",["[0-37-9]"]],["(\\d)(\\d{3})(\\d{5,6})","$1 $2 $3",["6"]]],0,0,0,0,0,0,[0,["6\\d{9}|[0-36-9]\\d{8}"]]],"882":["882",0,"[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?",[7,8,9,10,11,12],[["(\\d{2})(\\d{5})","$1 $2",["16|342"]],["(\\d{2})(\\d{6})","$1 $2",["49"]],["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["1[36]|9"]],["(\\d{2})(\\d{4})(\\d{3})","$1 $2 $3",["3[23]"]],["(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["16"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["10|23|3(?:[15]|4[57])|4|51"]],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["34"]],["(\\d{2})(\\d{4,5})(\\d{5})","$1 $2 $3",["[1-35]"]]],0,0,0,0,0,0,[0,["342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}",[7,8,9,10,12]],0,0,0,["348[57]\\d{7}",[11]],0,0,["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"]]],"883":["883",0,"(?:[1-4]\\d|51)\\d{6,10}",[8,9,10,11,12],[["(\\d{3})(\\d{3})(\\d{2,8})","$1 $2 $3",["[14]|2[24-689]|3[02-689]|51[24-9]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["510"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["21"]],["(\\d{4})(\\d{4})(\\d{4})","$1 $2 $3",["51[13]"]],["(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["[235]"]]],0,0,0,0,0,0,[0,0,0,0,0,0,0,0,["(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"]]],"888":["888",0,"\\d{11}",[11],[["(\\d{3})(\\d{3})(\\d{5})","$1 $2 $3"]],0,0,0,0,0,0,[0,0,0,0,0,0,["\\d{11}"]]],"979":["979",0,"[1359]\\d{8}",[9],[["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["[1359]"]]],0,0,0,0,0,0,[0,0,0,["[1359]\\d{8}"]]]}};

// Importing from a ".js" file is a workaround for Node.js "ES Modules"
// importing system which is even uncapable of importing "*.json" files.

function withMetadataArgument(func, _arguments) {
	var args = Array.prototype.slice.call(_arguments);
	args.push(metadata);
	return func.apply(this, args)
}

// Copy-pasted from:
// https://github.com/substack/semver-compare/blob/master/index.js
//
// Inlining this function because some users reported issues with
// importing from `semver-compare` in a browser with ES6 "native" modules.
//
// Fixes `semver-compare` not being able to compare versions with alpha/beta/etc "tags".
// https://github.com/catamphetamine/libphonenumber-js/issues/381
function compare (a, b) {
  a = a.split('-');
  b = b.split('-');
  var pa = a[0].split('.');
  var pb = b[0].split('.');

  for (var i = 0; i < 3; i++) {
    var na = Number(pa[i]);
    var nb = Number(pb[i]);
    if (na > nb) return 1;
    if (nb > na) return -1;
    if (!isNaN(na) && isNaN(nb)) return 1;
    if (isNaN(na) && !isNaN(nb)) return -1;
  }

  if (a[1] && b[1]) {
    return a[1] > b[1] ? 1 : a[1] < b[1] ? -1 : 0;
  }

  return !a[1] && b[1] ? 1 : a[1] && !b[1] ? -1 : 0;
}

var objectConstructor = {}.constructor;
function isObject(object) {
  return object !== undefined && object !== null && object.constructor === objectConstructor;
}

function _typeof$1(obj) { "@babel/helpers - typeof"; return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof$1(obj); }

function _classCallCheck$2(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$1(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$2(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$1(Constructor.prototype, protoProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var V3 = '1.2.0'; // Moved `001` country code to "nonGeographic" section of metadata.

var V4 = '1.7.35';
var DEFAULT_EXT_PREFIX = ' ext. ';
var CALLING_CODE_REG_EXP = /^\d+$/;
/**
 * See: https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md
 */

var Metadata = /*#__PURE__*/function () {
  function Metadata(metadata) {
    _classCallCheck$2(this, Metadata);

    validateMetadata(metadata);
    this.metadata = metadata;
    setVersion.call(this, metadata);
  }

  _createClass$2(Metadata, [{
    key: "getCountries",
    value: function getCountries() {
      return Object.keys(this.metadata.countries).filter(function (_) {
        return _ !== '001';
      });
    }
  }, {
    key: "getCountryMetadata",
    value: function getCountryMetadata(countryCode) {
      return this.metadata.countries[countryCode];
    }
  }, {
    key: "nonGeographic",
    value: function nonGeographic() {
      if (this.v1 || this.v2 || this.v3) return; // `nonGeographical` was a typo.
      // It's present in metadata generated from `1.7.35` to `1.7.37`.
      // The test case could be found by searching for "nonGeographical".

      return this.metadata.nonGeographic || this.metadata.nonGeographical;
    }
  }, {
    key: "hasCountry",
    value: function hasCountry(country) {
      return this.getCountryMetadata(country) !== undefined;
    }
  }, {
    key: "hasCallingCode",
    value: function hasCallingCode(callingCode) {
      if (this.getCountryCodesForCallingCode(callingCode)) {
        return true;
      }

      if (this.nonGeographic()) {
        if (this.nonGeographic()[callingCode]) {
          return true;
        }
      } else {
        // A hacky workaround for old custom metadata (generated before V4).
        var countryCodes = this.countryCallingCodes()[callingCode];

        if (countryCodes && countryCodes.length === 1 && countryCodes[0] === '001') {
          return true;
        }
      }
    }
  }, {
    key: "isNonGeographicCallingCode",
    value: function isNonGeographicCallingCode(callingCode) {
      if (this.nonGeographic()) {
        return this.nonGeographic()[callingCode] ? true : false;
      } else {
        return this.getCountryCodesForCallingCode(callingCode) ? false : true;
      }
    } // Deprecated.

  }, {
    key: "country",
    value: function country(countryCode) {
      return this.selectNumberingPlan(countryCode);
    }
  }, {
    key: "selectNumberingPlan",
    value: function selectNumberingPlan(countryCode, callingCode) {
      // Supports just passing `callingCode` as the first argument.
      if (countryCode && CALLING_CODE_REG_EXP.test(countryCode)) {
        callingCode = countryCode;
        countryCode = null;
      }

      if (countryCode && countryCode !== '001') {
        if (!this.hasCountry(countryCode)) {
          throw new Error("Unknown country: ".concat(countryCode));
        }

        this.numberingPlan = new NumberingPlan(this.getCountryMetadata(countryCode), this);
      } else if (callingCode) {
        if (!this.hasCallingCode(callingCode)) {
          throw new Error("Unknown calling code: ".concat(callingCode));
        }

        this.numberingPlan = new NumberingPlan(this.getNumberingPlanMetadata(callingCode), this);
      } else {
        this.numberingPlan = undefined;
      }

      return this;
    }
  }, {
    key: "getCountryCodesForCallingCode",
    value: function getCountryCodesForCallingCode(callingCode) {
      var countryCodes = this.countryCallingCodes()[callingCode];

      if (countryCodes) {
        // Metadata before V4 included "non-geographic entity" calling codes
        // inside `country_calling_codes` (for example, `"881":["001"]`).
        // Now the semantics of `country_calling_codes` has changed:
        // it's specifically for "countries" now.
        // Older versions of custom metadata will simply skip parsing
        // "non-geographic entity" phone numbers with new versions
        // of this library: it's not considered a bug,
        // because such numbers are extremely rare,
        // and developers extremely rarely use custom metadata.
        if (countryCodes.length === 1 && countryCodes[0].length === 3) {
          return;
        }

        return countryCodes;
      }
    }
  }, {
    key: "getCountryCodeForCallingCode",
    value: function getCountryCodeForCallingCode(callingCode) {
      var countryCodes = this.getCountryCodesForCallingCode(callingCode);

      if (countryCodes) {
        return countryCodes[0];
      }
    }
  }, {
    key: "getNumberingPlanMetadata",
    value: function getNumberingPlanMetadata(callingCode) {
      var countryCode = this.getCountryCodeForCallingCode(callingCode);

      if (countryCode) {
        return this.getCountryMetadata(countryCode);
      }

      if (this.nonGeographic()) {
        var metadata = this.nonGeographic()[callingCode];

        if (metadata) {
          return metadata;
        }
      } else {
        // A hacky workaround for old custom metadata (generated before V4).
        // In that metadata, there was no concept of "non-geographic" metadata
        // so metadata for `001` country code was stored along with other countries.
        // The test case can be found by searching for:
        // "should work around `nonGeographic` metadata not existing".
        var countryCodes = this.countryCallingCodes()[callingCode];

        if (countryCodes && countryCodes.length === 1 && countryCodes[0] === '001') {
          return this.metadata.countries['001'];
        }
      }
    } // Deprecated.

  }, {
    key: "countryCallingCode",
    value: function countryCallingCode() {
      return this.numberingPlan.callingCode();
    } // Deprecated.

  }, {
    key: "IDDPrefix",
    value: function IDDPrefix() {
      return this.numberingPlan.IDDPrefix();
    } // Deprecated.

  }, {
    key: "defaultIDDPrefix",
    value: function defaultIDDPrefix() {
      return this.numberingPlan.defaultIDDPrefix();
    } // Deprecated.

  }, {
    key: "nationalNumberPattern",
    value: function nationalNumberPattern() {
      return this.numberingPlan.nationalNumberPattern();
    } // Deprecated.

  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      return this.numberingPlan.possibleLengths();
    } // Deprecated.

  }, {
    key: "formats",
    value: function formats() {
      return this.numberingPlan.formats();
    } // Deprecated.

  }, {
    key: "nationalPrefixForParsing",
    value: function nationalPrefixForParsing() {
      return this.numberingPlan.nationalPrefixForParsing();
    } // Deprecated.

  }, {
    key: "nationalPrefixTransformRule",
    value: function nationalPrefixTransformRule() {
      return this.numberingPlan.nationalPrefixTransformRule();
    } // Deprecated.

  }, {
    key: "leadingDigits",
    value: function leadingDigits() {
      return this.numberingPlan.leadingDigits();
    } // Deprecated.

  }, {
    key: "hasTypes",
    value: function hasTypes() {
      return this.numberingPlan.hasTypes();
    } // Deprecated.

  }, {
    key: "type",
    value: function type(_type) {
      return this.numberingPlan.type(_type);
    } // Deprecated.

  }, {
    key: "ext",
    value: function ext() {
      return this.numberingPlan.ext();
    }
  }, {
    key: "countryCallingCodes",
    value: function countryCallingCodes() {
      if (this.v1) return this.metadata.country_phone_code_to_countries;
      return this.metadata.country_calling_codes;
    } // Deprecated.

  }, {
    key: "chooseCountryByCountryCallingCode",
    value: function chooseCountryByCountryCallingCode(callingCode) {
      return this.selectNumberingPlan(callingCode);
    }
  }, {
    key: "hasSelectedNumberingPlan",
    value: function hasSelectedNumberingPlan() {
      return this.numberingPlan !== undefined;
    }
  }]);

  return Metadata;
}();

var NumberingPlan = /*#__PURE__*/function () {
  function NumberingPlan(metadata, globalMetadataObject) {
    _classCallCheck$2(this, NumberingPlan);

    this.globalMetadataObject = globalMetadataObject;
    this.metadata = metadata;
    setVersion.call(this, globalMetadataObject.metadata);
  }

  _createClass$2(NumberingPlan, [{
    key: "callingCode",
    value: function callingCode() {
      return this.metadata[0];
    } // Formatting information for regions which share
    // a country calling code is contained by only one region
    // for performance reasons. For example, for NANPA region
    // ("North American Numbering Plan Administration",
    //  which includes USA, Canada, Cayman Islands, Bahamas, etc)
    // it will be contained in the metadata for `US`.

  }, {
    key: "getDefaultCountryMetadataForRegion",
    value: function getDefaultCountryMetadataForRegion() {
      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
    } // Is always present.

  }, {
    key: "IDDPrefix",
    value: function IDDPrefix() {
      if (this.v1 || this.v2) return;
      return this.metadata[1];
    } // Is only present when a country supports multiple IDD prefixes.

  }, {
    key: "defaultIDDPrefix",
    value: function defaultIDDPrefix() {
      if (this.v1 || this.v2) return;
      return this.metadata[12];
    }
  }, {
    key: "nationalNumberPattern",
    value: function nationalNumberPattern() {
      if (this.v1 || this.v2) return this.metadata[1];
      return this.metadata[2];
    } // "possible length" data is always present in Google's metadata.

  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      if (this.v1) return;
      return this.metadata[this.v2 ? 2 : 3];
    }
  }, {
    key: "_getFormats",
    value: function _getFormats(metadata) {
      return metadata[this.v1 ? 2 : this.v2 ? 3 : 4];
    } // For countries of the same region (e.g. NANPA)
    // formats are all stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".

  }, {
    key: "formats",
    value: function formats() {
      var _this = this;

      var formats = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
      return formats.map(function (_) {
        return new Format(_, _this);
      });
    }
  }, {
    key: "nationalPrefix",
    value: function nationalPrefix() {
      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
    }
  }, {
    key: "_getNationalPrefixFormattingRule",
    value: function _getNationalPrefixFormattingRule(metadata) {
      return metadata[this.v1 ? 4 : this.v2 ? 5 : 6];
    } // For countries of the same region (e.g. NANPA)
    // national prefix formatting rule is stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".

  }, {
    key: "nationalPrefixFormattingRule",
    value: function nationalPrefixFormattingRule() {
      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "_nationalPrefixForParsing",
    value: function _nationalPrefixForParsing() {
      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function nationalPrefixForParsing() {
      // If `national_prefix_for_parsing` is not set explicitly,
      // then infer it from `national_prefix` (if any)
      return this._nationalPrefixForParsing() || this.nationalPrefix();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function nationalPrefixTransformRule() {
      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
    }
  }, {
    key: "_getNationalPrefixIsOptionalWhenFormatting",
    value: function _getNationalPrefixIsOptionalWhenFormatting() {
      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
    } // For countries of the same region (e.g. NANPA)
    // "national prefix is optional when formatting" flag is
    // stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".

  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "leadingDigits",
    value: function leadingDigits() {
      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
    }
  }, {
    key: "types",
    value: function types() {
      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
    }
  }, {
    key: "hasTypes",
    value: function hasTypes() {
      // Versions 1.2.0 - 1.2.4: can be `[]`.

      /* istanbul ignore next */
      if (this.types() && this.types().length === 0) {
        return false;
      } // Versions <= 1.2.4: can be `undefined`.
      // Version >= 1.2.5: can be `0`.


      return !!this.types();
    }
  }, {
    key: "type",
    value: function type(_type2) {
      if (this.hasTypes() && getType(this.types(), _type2)) {
        return new Type(getType(this.types(), _type2), this);
      }
    }
  }, {
    key: "ext",
    value: function ext() {
      if (this.v1 || this.v2) return DEFAULT_EXT_PREFIX;
      return this.metadata[13] || DEFAULT_EXT_PREFIX;
    }
  }]);

  return NumberingPlan;
}();

var Format = /*#__PURE__*/function () {
  function Format(format, metadata) {
    _classCallCheck$2(this, Format);

    this._format = format;
    this.metadata = metadata;
  }

  _createClass$2(Format, [{
    key: "pattern",
    value: function pattern() {
      return this._format[0];
    }
  }, {
    key: "format",
    value: function format() {
      return this._format[1];
    }
  }, {
    key: "leadingDigitsPatterns",
    value: function leadingDigitsPatterns() {
      return this._format[2] || [];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function nationalPrefixFormattingRule() {
      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
    value: function nationalPrefixIsMandatoryWhenFormattingInNationalFormat() {
      // National prefix is omitted if there's no national prefix formatting rule
      // set for this country, or when the national prefix formatting rule
      // contains no national prefix itself, or when this rule is set but
      // national prefix is optional for this phone number format
      // (and it is not enforced explicitly)
      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    } // Checks whether national prefix formatting rule contains national prefix.

  }, {
    key: "usesNationalPrefix",
    value: function usesNationalPrefix() {
      return this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
      !FIRST_GROUP_ONLY_PREFIX_PATTERN.test(this.nationalPrefixFormattingRule()) // In compressed metadata, `this.nationalPrefixFormattingRule()` is `0`
      // when `national_prefix_formatting_rule` is not present.
      // So, `true` or `false` are returned explicitly here, so that
      // `0` number isn't returned.
      ? true : false;
    }
  }, {
    key: "internationalFormat",
    value: function internationalFormat() {
      return this._format[5] || this.format();
    }
  }]);

  return Format;
}();
/**
 * A pattern that is used to determine if the national prefix formatting rule
 * has the first group only, i.e., does not start with the national prefix.
 * Note that the pattern explicitly allows for unbalanced parentheses.
 */


var FIRST_GROUP_ONLY_PREFIX_PATTERN = /^\(?\$1\)?$/;

var Type = /*#__PURE__*/function () {
  function Type(type, metadata) {
    _classCallCheck$2(this, Type);

    this.type = type;
    this.metadata = metadata;
  }

  _createClass$2(Type, [{
    key: "pattern",
    value: function pattern() {
      if (this.metadata.v1) return this.type;
      return this.type[0];
    }
  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      if (this.metadata.v1) return;
      return this.type[1] || this.metadata.possibleLengths();
    }
  }]);

  return Type;
}();

function getType(types, type) {
  switch (type) {
    case 'FIXED_LINE':
      return types[0];

    case 'MOBILE':
      return types[1];

    case 'TOLL_FREE':
      return types[2];

    case 'PREMIUM_RATE':
      return types[3];

    case 'PERSONAL_NUMBER':
      return types[4];

    case 'VOICEMAIL':
      return types[5];

    case 'UAN':
      return types[6];

    case 'PAGER':
      return types[7];

    case 'VOIP':
      return types[8];

    case 'SHARED_COST':
      return types[9];
  }
}

function validateMetadata(metadata) {
  if (!metadata) {
    throw new Error('[libphonenumber-js] `metadata` argument not passed. Check your arguments.');
  } // `country_phone_code_to_countries` was renamed to `country_calling_codes` in `1.0.18`.
  // For that reason, it's not used in this detection algorithm.
  // Instead, it detects by `countries: {}` property existence.


  if (!isObject(metadata) || !isObject(metadata.countries)) {
    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(isObject(metadata) ? 'an object of shape: { ' + Object.keys(metadata).join(', ') + ' }' : 'a ' + typeOf(metadata) + ': ' + metadata, "."));
  }
} // Babel transforms `typeof` into some "branches"
// so istanbul will show this as "branch not covered".

/* istanbul ignore next */

var typeOf = function typeOf(_) {
  return _typeof$1(_);
};
/**
 * Returns "country calling code" for a country.
 * Throws an error if the country doesn't exist or isn't supported by this library.
 * @param  {string} country
 * @param  {object} metadata
 * @return {string}
 * @example
 * // Returns "44"
 * getCountryCallingCode("GB")
 */

function getCountryCallingCode(country, metadata) {
  metadata = new Metadata(metadata);

  if (metadata.hasCountry(country)) {
    return metadata.country(country).countryCallingCode();
  }

  throw new Error("Unknown country: ".concat(country));
}
function isSupportedCountry(country, metadata) {
  // metadata = new Metadata(metadata)
  // return metadata.hasCountry(country)
  return metadata.countries.hasOwnProperty(country);
}

function setVersion(metadata) {
  var version = metadata.version;

  if (typeof version === 'number') {
    this.v1 = version === 1;
    this.v2 = version === 2;
    this.v3 = version === 3;
    this.v4 = version === 4;
  } else {
    if (!version) {
      this.v1 = true;
    } else if (compare(version, V3) === -1) {
      this.v2 = true;
    } else if (compare(version, V4) === -1) {
      this.v3 = true;
    } else {
      this.v4 = true;
    }
  }
} // const ISO_COUNTRY_CODE = /^[A-Z]{2}$/
// function isCountryCode(countryCode) {
// 	return ISO_COUNTRY_CODE.test(countryCodeOrCountryCallingCode)
// }

function checkNumberLength(nationalNumber, metadata) {
  return checkNumberLengthForType(nationalNumber, undefined, metadata);
} // Checks whether a number is possible for the country based on its length.
// Should only be called for the "new" metadata which has "possible lengths".

function checkNumberLengthForType(nationalNumber, type, metadata) {
  var type_info = metadata.type(type); // There should always be "<possiblePengths/>" set for every type element.
  // This is declared in the XML schema.
  // For size efficiency, where a sub-description (e.g. fixed-line)
  // has the same "<possiblePengths/>" as the "general description", this is missing,
  // so we fall back to the "general description". Where no numbers of the type
  // exist at all, there is one possible length (-1) which is guaranteed
  // not to match the length of any real phone number.

  var possible_lengths = type_info && type_info.possibleLengths() || metadata.possibleLengths(); // let local_lengths    = type_info && type.possibleLengthsLocal() || metadata.possibleLengthsLocal()
  // Metadata before version `1.0.18` didn't contain `possible_lengths`.

  if (!possible_lengths) {
    return 'IS_POSSIBLE';
  }

  var actual_length = nationalNumber.length; // In `libphonenumber-js` all "local-only" formats are dropped for simplicity.
  // // This is safe because there is never an overlap beween the possible lengths
  // // and the local-only lengths; this is checked at build time.
  // if (local_lengths && local_lengths.indexOf(nationalNumber.length) >= 0)
  // {
  // 	return 'IS_POSSIBLE_LOCAL_ONLY'
  // }

  var minimum_length = possible_lengths[0];

  if (minimum_length === actual_length) {
    return 'IS_POSSIBLE';
  }

  if (minimum_length > actual_length) {
    return 'TOO_SHORT';
  }

  if (possible_lengths[possible_lengths.length - 1] < actual_length) {
    return 'TOO_LONG';
  } // We skip the first element since we've already checked it.


  return possible_lengths.indexOf(actual_length, 1) >= 0 ? 'IS_POSSIBLE' : 'INVALID_LENGTH';
}

/**
 * Checks if a phone number is "possible" (basically just checks its length).
 *
 * isPossible(phoneNumberInstance, { ..., v2: true }, metadata)
 *
 * isPossible({ phone: '8005553535', country: 'RU' }, { ... }, metadata)
 * isPossible({ phone: '8005553535', country: 'RU' }, undefined, metadata)
 *
 * @param  {object|PhoneNumber} input — If `options.v2: true` flag is passed, the `input` should be a `PhoneNumber` instance. Otherwise, it should be an object of shape `{ phone: '...', country: '...' }`.
 * @param  {object} [options]
 * @param  {object} metadata
 * @return {string}
 */

function isPossiblePhoneNumber(input, options, metadata) {
  /* istanbul ignore if */
  if (options === undefined) {
    options = {};
  }

  metadata = new Metadata(metadata);

  if (options.v2) {
    if (!input.countryCallingCode) {
      throw new Error('Invalid phone number object passed');
    }

    metadata.selectNumberingPlan(input.countryCallingCode);
  } else {
    if (!input.phone) {
      return false;
    }

    if (input.country) {
      if (!metadata.hasCountry(input.country)) {
        throw new Error("Unknown country: ".concat(input.country));
      }

      metadata.country(input.country);
    } else {
      if (!input.countryCallingCode) {
        throw new Error('Invalid phone number object passed');
      }

      metadata.selectNumberingPlan(input.countryCallingCode);
    }
  } // Old metadata (< 1.0.18) had no "possible length" data.


  if (metadata.possibleLengths()) {
    return isPossibleNumber(input.phone || input.nationalNumber, metadata);
  } else {
    // There was a bug between `1.7.35` and `1.7.37` where "possible_lengths"
    // were missing for "non-geographical" numbering plans.
    // Just assume the number is possible in such cases:
    // it's unlikely that anyone generated their custom metadata
    // in that short period of time (one day).
    // This code can be removed in some future major version update.
    if (input.countryCallingCode && metadata.isNonGeographicCallingCode(input.countryCallingCode)) {
      // "Non-geographic entities" did't have `possibleLengths`
      // due to a bug in metadata generation process.
      return true;
    } else {
      throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
    }
  }
}
function isPossibleNumber(nationalNumber, metadata) {
  //, isInternational) {
  switch (checkNumberLength(nationalNumber, metadata)) {
    case 'IS_POSSIBLE':
      return true;
    // This library ignores "local-only" phone numbers (for simplicity).
    // See the readme for more info on what are "local-only" phone numbers.
    // case 'IS_POSSIBLE_LOCAL_ONLY':
    // 	return !isInternational

    default:
      return false;
  }
}

/**
 * Checks whether the entire input sequence can be matched
 * against the regular expression.
 * @return {boolean}
 */
function matchesEntirely(text, regular_expression) {
  // If assigning the `''` default value is moved to the arguments above,
  // code coverage would decrease for some weird reason.
  text = text || '';
  return new RegExp('^(?:' + regular_expression + ')$').test(text);
}

function _createForOfIteratorHelperLoose$3(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray$4(o)) || allowArrayLike) { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$4(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$4(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$4(o, minLen); }

function _arrayLikeToArray$4(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var NON_FIXED_LINE_PHONE_TYPES = ['MOBILE', 'PREMIUM_RATE', 'TOLL_FREE', 'SHARED_COST', 'VOIP', 'PERSONAL_NUMBER', 'PAGER', 'UAN', 'VOICEMAIL']; // Finds out national phone number type (fixed line, mobile, etc)

function getNumberType(input, options, metadata) {
  // If assigning the `{}` default value is moved to the arguments above,
  // code coverage would decrease for some weird reason.
  options = options || {}; // When `parse()` returns an empty object — `{}` —
  // that means that the phone number is malformed,
  // so it can't possibly be valid.

  if (!input.country && !input.countryCallingCode) {
    return;
  }

  metadata = new Metadata(metadata);
  metadata.selectNumberingPlan(input.country, input.countryCallingCode);
  var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // The following is copy-pasted from the original function:
  // https://github.com/googlei18n/libphonenumber/blob/3ea547d4fbaa2d0b67588904dfa5d3f2557c27ff/javascript/i18n/phonenumbers/phonenumberutil.js#L2835
  // Is this national number even valid for this country

  if (!matchesEntirely(nationalNumber, metadata.nationalNumberPattern())) {
    return;
  } // Is it fixed line number


  if (isNumberTypeEqualTo(nationalNumber, 'FIXED_LINE', metadata)) {
    // Because duplicate regular expressions are removed
    // to reduce metadata size, if "mobile" pattern is ""
    // then it means it was removed due to being a duplicate of the fixed-line pattern.
    //
    if (metadata.type('MOBILE') && metadata.type('MOBILE').pattern() === '') {
      return 'FIXED_LINE_OR_MOBILE';
    } // `MOBILE` type pattern isn't included if it matched `FIXED_LINE` one.
    // For example, for "US" country.
    // Old metadata (< `1.0.18`) had a specific "types" data structure
    // that happened to be `undefined` for `MOBILE` in that case.
    // Newer metadata (>= `1.0.18`) has another data structure that is
    // not `undefined` for `MOBILE` in that case (it's just an empty array).
    // So this `if` is just for backwards compatibility with old metadata.


    if (!metadata.type('MOBILE')) {
      return 'FIXED_LINE_OR_MOBILE';
    } // Check if the number happens to qualify as both fixed line and mobile.
    // (no such country in the minimal metadata set)

    /* istanbul ignore if */


    if (isNumberTypeEqualTo(nationalNumber, 'MOBILE', metadata)) {
      return 'FIXED_LINE_OR_MOBILE';
    }

    return 'FIXED_LINE';
  }

  for (var _iterator = _createForOfIteratorHelperLoose$3(NON_FIXED_LINE_PHONE_TYPES), _step; !(_step = _iterator()).done;) {
    var type = _step.value;

    if (isNumberTypeEqualTo(nationalNumber, type, metadata)) {
      return type;
    }
  }
}
function isNumberTypeEqualTo(nationalNumber, type, metadata) {
  type = metadata.type(type);

  if (!type || !type.pattern()) {
    return false;
  } // Check if any possible number lengths are present;
  // if so, we use them to avoid checking
  // the validation pattern if they don't match.
  // If they are absent, this means they match
  // the general description, which we have
  // already checked before a specific number type.


  if (type.possibleLengths() && type.possibleLengths().indexOf(nationalNumber.length) < 0) {
    return false;
  }

  return matchesEntirely(nationalNumber, type.pattern());
}

/**
 * Checks if a given phone number is valid.
 *
 * isValid(phoneNumberInstance, { ..., v2: true }, metadata)
 *
 * isPossible({ phone: '8005553535', country: 'RU' }, { ... }, metadata)
 * isPossible({ phone: '8005553535', country: 'RU' }, undefined, metadata)
 *
 * If the `number` is a string, it will be parsed to an object,
 * but only if it contains only valid phone number characters (including punctuation).
 * If the `number` is an object, it is used as is.
 *
 * The optional `defaultCountry` argument is the default country.
 * I.e. it does not restrict to just that country,
 * e.g. in those cases where several countries share
 * the same phone numbering rules (NANPA, Britain, etc).
 * For example, even though the number `07624 369230`
 * belongs to the Isle of Man ("IM" country code)
 * calling `isValidNumber('07624369230', 'GB', metadata)`
 * still returns `true` because the country is not restricted to `GB`,
 * it's just that `GB` is the default one for the phone numbering rules.
 * For restricting the country see `isValidNumberForRegion()`
 * though restricting a country might not be a good idea.
 * https://github.com/googlei18n/libphonenumber/blob/master/FAQ.md#when-should-i-use-isvalidnumberforregion
 *
 * Examples:
 *
 * ```js
 * isValidNumber('+78005553535', metadata)
 * isValidNumber('8005553535', 'RU', metadata)
 * isValidNumber('88005553535', 'RU', metadata)
 * isValidNumber({ phone: '8005553535', country: 'RU' }, metadata)
 * ```
 */

function isValidNumber(input, options, metadata) {
  // If assigning the `{}` default value is moved to the arguments above,
  // code coverage would decrease for some weird reason.
  options = options || {};
  metadata = new Metadata(metadata);
  metadata.selectNumberingPlan(input.country, input.countryCallingCode); // By default, countries only have type regexps when it's required for
  // distinguishing different countries having the same `countryCallingCode`.

  if (metadata.hasTypes()) {
    return getNumberType(input, options, metadata.metadata) !== undefined;
  } // If there are no type regexps for this country in metadata then use
  // `nationalNumberPattern` as a "better than nothing" replacement.


  var nationalNumber = options.v2 ? input.nationalNumber : input.phone;
  return matchesEntirely(nationalNumber, metadata.nationalNumberPattern());
}

/**
 * Returns a list of countries that the phone number could potentially belong to.
 * @param  {string} callingCode — Calling code.
 * @param  {string} nationalNumber — National (significant) number.
 * @param  {object} metadata — Metadata.
 * @return {string[]} A list of possible countries.
 */

function getPossibleCountriesForNumber(callingCode, nationalNumber, metadata) {
  var _metadata = new Metadata(metadata);

  var possibleCountries = _metadata.getCountryCodesForCallingCode(callingCode);

  if (!possibleCountries) {
    return [];
  }

  return possibleCountries.filter(function (country) {
    return couldNationalNumberBelongToCountry(nationalNumber, country, metadata);
  });
}

function couldNationalNumberBelongToCountry(nationalNumber, country, metadata) {
  var _metadata = new Metadata(metadata);

  _metadata.selectNumberingPlan(country);

  if (_metadata.numberingPlan.possibleLengths().indexOf(nationalNumber.length) >= 0) {
    return true;
  }

  return false;
}

// The minimum length of the national significant number.
var MIN_LENGTH_FOR_NSN = 2; // The ITU says the maximum length should be 15,
// but one can find longer numbers in Germany.

var MAX_LENGTH_FOR_NSN = 17; // The maximum length of the country calling code.

var MAX_LENGTH_COUNTRY_CODE = 3; // Digits accepted in phone numbers
// (ascii, fullwidth, arabic-indic, and eastern arabic digits).

var VALID_DIGITS = "0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9"; // `DASHES` will be right after the opening square bracket of the "character class"

var DASHES = "-\u2010-\u2015\u2212\u30FC\uFF0D";
var SLASHES = "\uFF0F/";
var DOTS = "\uFF0E.";
var WHITESPACE = " \xA0\xAD\u200B\u2060\u3000";
var BRACKETS = "()\uFF08\uFF09\uFF3B\uFF3D\\[\\]"; // export const OPENING_BRACKETS = '(\uFF08\uFF3B\\\['

var TILDES = "~\u2053\u223C\uFF5E"; // Regular expression of acceptable punctuation found in phone numbers. This
// excludes punctuation found as a leading character only. This consists of dash
// characters, white space characters, full stops, slashes, square brackets,
// parentheses and tildes. Full-width variants are also present.

var VALID_PUNCTUATION = "".concat(DASHES).concat(SLASHES).concat(DOTS).concat(WHITESPACE).concat(BRACKETS).concat(TILDES);
var PLUS_CHARS = "+\uFF0B"; // const LEADING_PLUS_CHARS_PATTERN = new RegExp('^[' + PLUS_CHARS + ']+')

var CAPTURING_DIGIT_PATTERN = new RegExp('([' + VALID_DIGITS + '])');
function stripIddPrefix(number, country, callingCode, metadata) {
  if (!country) {
    return;
  } // Check if the number is IDD-prefixed.


  var countryMetadata = new Metadata(metadata);
  countryMetadata.selectNumberingPlan(country, callingCode);
  var IDDPrefixPattern = new RegExp(countryMetadata.IDDPrefix());

  if (number.search(IDDPrefixPattern) !== 0) {
    return;
  } // Strip IDD prefix.


  number = number.slice(number.match(IDDPrefixPattern)[0].length); // If there're any digits after an IDD prefix,
  // then those digits are a country calling code.
  // Since no country code starts with a `0`,
  // the code below validates that the next digit (if present) is not `0`.

  var matchedGroups = number.match(CAPTURING_DIGIT_PATTERN);

  if (matchedGroups && matchedGroups[1] != null && matchedGroups[1].length > 0) {
    if (matchedGroups[1] === '0') {
      return;
    }
  }

  return number;
}

/**
 * Strips any national prefix (such as 0, 1) present in a
 * (possibly incomplete) number provided.
 * "Carrier codes" are only used  in Colombia and Brazil,
 * and only when dialing within those countries from a mobile phone to a fixed line number.
 * Sometimes it won't actually strip national prefix
 * and will instead prepend some digits to the `number`:
 * for example, when number `2345678` is passed with `VI` country selected,
 * it will return `{ number: "3402345678" }`, because `340` area code is prepended.
 * @param {string} number — National number digits.
 * @param {object} metadata — Metadata with country selected.
 * @return {object} `{ nationalNumber: string, nationalPrefix: string? carrierCode: string? }`. Even if a national prefix was extracted, it's not necessarily present in the returned object, so don't rely on its presence in the returned object in order to find out whether a national prefix has been extracted or not.
 */
function extractNationalNumberFromPossiblyIncompleteNumber(number, metadata) {
  if (number && metadata.numberingPlan.nationalPrefixForParsing()) {
    // See METADATA.md for the description of
    // `national_prefix_for_parsing` and `national_prefix_transform_rule`.
    // Attempt to parse the first digits as a national prefix.
    var prefixPattern = new RegExp('^(?:' + metadata.numberingPlan.nationalPrefixForParsing() + ')');
    var prefixMatch = prefixPattern.exec(number);

    if (prefixMatch) {
      var nationalNumber;
      var carrierCode; // https://gitlab.com/catamphetamine/libphonenumber-js/-/blob/master/METADATA.md#national_prefix_for_parsing--national_prefix_transform_rule
      // If a `national_prefix_for_parsing` has any "capturing groups"
      // then it means that the national (significant) number is equal to
      // those "capturing groups" transformed via `national_prefix_transform_rule`,
      // and nothing could be said about the actual national prefix:
      // what is it and was it even there.
      // If a `national_prefix_for_parsing` doesn't have any "capturing groups",
      // then everything it matches is a national prefix.
      // To determine whether `national_prefix_for_parsing` matched any
      // "capturing groups", the value of the result of calling `.exec()`
      // is looked at, and if it has non-undefined values where there're
      // "capturing groups" in the regular expression, then it means
      // that "capturing groups" have been matched.
      // It's not possible to tell whether there'll be any "capturing gropus"
      // before the matching process, because a `national_prefix_for_parsing`
      // could exhibit both behaviors.

      var capturedGroupsCount = prefixMatch.length - 1;
      var hasCapturedGroups = capturedGroupsCount > 0 && prefixMatch[capturedGroupsCount];

      if (metadata.nationalPrefixTransformRule() && hasCapturedGroups) {
        nationalNumber = number.replace(prefixPattern, metadata.nationalPrefixTransformRule()); // If there's more than one captured group,
        // then carrier code is the second one.

        if (capturedGroupsCount > 1) {
          carrierCode = prefixMatch[1];
        }
      } // If there're no "capturing groups",
      // or if there're "capturing groups" but no
      // `national_prefix_transform_rule`,
      // then just strip the national prefix from the number,
      // and possibly a carrier code.
      // Seems like there could be more.
      else {
        // `prefixBeforeNationalNumber` is the whole substring matched by
        // the `national_prefix_for_parsing` regular expression.
        // There seem to be no guarantees that it's just a national prefix.
        // For example, if there's a carrier code, it's gonna be a
        // part of `prefixBeforeNationalNumber` too.
        var prefixBeforeNationalNumber = prefixMatch[0];
        nationalNumber = number.slice(prefixBeforeNationalNumber.length); // If there's at least one captured group,
        // then carrier code is the first one.

        if (hasCapturedGroups) {
          carrierCode = prefixMatch[1];
        }
      } // Tries to guess whether a national prefix was present in the input.
      // This is not something copy-pasted from Google's library:
      // they don't seem to have an equivalent for that.
      // So this isn't an "officially approved" way of doing something like that.
      // But since there seems no other existing method, this library uses it.


      var nationalPrefix;

      if (hasCapturedGroups) {
        var possiblePositionOfTheFirstCapturedGroup = number.indexOf(prefixMatch[1]);
        var possibleNationalPrefix = number.slice(0, possiblePositionOfTheFirstCapturedGroup); // Example: an Argentinian (AR) phone number `0111523456789`.
        // `prefixMatch[0]` is `01115`, and `$1` is `11`,
        // and the rest of the phone number is `23456789`.
        // The national number is transformed via `9$1` to `91123456789`.
        // National prefix `0` is detected being present at the start.
        // if (possibleNationalPrefix.indexOf(metadata.numberingPlan.nationalPrefix()) === 0) {

        if (possibleNationalPrefix === metadata.numberingPlan.nationalPrefix()) {
          nationalPrefix = metadata.numberingPlan.nationalPrefix();
        }
      } else {
        nationalPrefix = prefixMatch[0];
      }

      return {
        nationalNumber: nationalNumber,
        nationalPrefix: nationalPrefix,
        carrierCode: carrierCode
      };
    }
  }

  return {
    nationalNumber: number
  };
}

/**
 * Strips national prefix and carrier code from a complete phone number.
 * The difference from the non-"FromCompleteNumber" function is that
 * it won't extract national prefix if the resultant number is too short
 * to be a complete number for the selected phone numbering plan.
 * @param  {string} number — Complete phone number digits.
 * @param  {Metadata} metadata — Metadata with a phone numbering plan selected.
 * @return {object} `{ nationalNumber: string, carrierCode: string? }`.
 */

function extractNationalNumber(number, metadata) {
  // Parsing national prefixes and carrier codes
  // is only required for local phone numbers
  // but some people don't understand that
  // and sometimes write international phone numbers
  // with national prefixes (or maybe even carrier codes).
  // http://ucken.blogspot.ru/2016/03/trunk-prefixes-in-skype4b.html
  // Google's original library forgives such mistakes
  // and so does this library, because it has been requested:
  // https://github.com/catamphetamine/libphonenumber-js/issues/127
  var _extractNationalNumbe = extractNationalNumberFromPossiblyIncompleteNumber(number, metadata),
      carrierCode = _extractNationalNumbe.carrierCode,
      nationalNumber = _extractNationalNumbe.nationalNumber;

  if (nationalNumber !== number) {
    if (!shouldHaveExtractedNationalPrefix(number, nationalNumber, metadata)) {
      // Don't strip the national prefix.
      return {
        nationalNumber: number
      };
    } // Check the national (significant) number length after extracting national prefix and carrier code.
    // Legacy generated metadata (before `1.0.18`) didn't support the "possible lengths" feature.


    if (metadata.possibleLengths()) {
      // The number remaining after stripping the national prefix and carrier code
      // should be long enough to have a possible length for the country.
      // Otherwise, don't strip the national prefix and carrier code,
      // since the original number could be a valid number.
      // This check has been copy-pasted "as is" from Google's original library:
      // https://github.com/google/libphonenumber/blob/876268eb1ad6cdc1b7b5bef17fc5e43052702d57/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L3236-L3250
      // It doesn't check for the "possibility" of the original `number`.
      // I guess it's fine not checking that one. It works as is anyway.
      if (!isPossibleIncompleteNationalNumber(nationalNumber, metadata)) {
        // Don't strip the national prefix.
        return {
          nationalNumber: number
        };
      }
    }
  }

  return {
    nationalNumber: nationalNumber,
    carrierCode: carrierCode
  };
} // In some countries, the same digit could be a national prefix
// or a leading digit of a valid phone number.
// For example, in Russia, national prefix is `8`,
// and also `800 555 35 35` is a valid number
// in which `8` is not a national prefix, but the first digit
// of a national (significant) number.
// Same's with Belarus:
// `82004910060` is a valid national (significant) number,
// but `2004910060` is not.
// To support such cases (to prevent the code from always stripping
// national prefix), a condition is imposed: a national prefix
// is not extracted when the original number is "viable" and the
// resultant number is not, a "viable" national number being the one
// that matches `national_number_pattern`.

function shouldHaveExtractedNationalPrefix(nationalNumberBefore, nationalNumberAfter, metadata) {
  // The equivalent in Google's code is:
  // https://github.com/google/libphonenumber/blob/e326fa1fc4283bb05eb35cb3c15c18f98a31af33/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L2969-L3004
  if (matchesEntirely(nationalNumberBefore, metadata.nationalNumberPattern()) && !matchesEntirely(nationalNumberAfter, metadata.nationalNumberPattern())) {
    return false;
  } // This "is possible" national number (length) check has been commented out
  // because it's superceded by the (effectively) same check done in the
  // `extractNationalNumber()` function after it calls `shouldHaveExtractedNationalPrefix()`.
  // In other words, why run the same check twice if it could only be run once.
  // // Check the national (significant) number length after extracting national prefix and carrier code.
  // // Fixes a minor "weird behavior" bug: https://gitlab.com/catamphetamine/libphonenumber-js/-/issues/57
  // // (Legacy generated metadata (before `1.0.18`) didn't support the "possible lengths" feature).
  // if (metadata.possibleLengths()) {
  // 	if (isPossibleIncompleteNationalNumber(nationalNumberBefore, metadata) &&
  // 		!isPossibleIncompleteNationalNumber(nationalNumberAfter, metadata)) {
  // 		return false
  // 	}
  // }


  return true;
}

function isPossibleIncompleteNationalNumber(nationalNumber, metadata) {
  switch (checkNumberLength(nationalNumber, metadata)) {
    case 'TOO_SHORT':
    case 'INVALID_LENGTH':
      // This library ignores "local-only" phone numbers (for simplicity).
      // See the readme for more info on what are "local-only" phone numbers.
      // case 'IS_POSSIBLE_LOCAL_ONLY':
      return false;

    default:
      return true;
  }
}

/**
 * Sometimes some people incorrectly input international phone numbers
 * without the leading `+`. This function corrects such input.
 * @param  {string} number — Phone number digits.
 * @param  {string?} country
 * @param  {string?} callingCode
 * @param  {object} metadata
 * @return {object} `{ countryCallingCode: string?, number: string }`.
 */

function extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(number, country, callingCode, metadata) {
  var countryCallingCode = country ? getCountryCallingCode(country, metadata) : callingCode;

  if (number.indexOf(countryCallingCode) === 0) {
    metadata = new Metadata(metadata);
    metadata.selectNumberingPlan(country, callingCode);
    var possibleShorterNumber = number.slice(countryCallingCode.length);

    var _extractNationalNumbe = extractNationalNumber(possibleShorterNumber, metadata),
        possibleShorterNationalNumber = _extractNationalNumbe.nationalNumber;

    var _extractNationalNumbe2 = extractNationalNumber(number, metadata),
        nationalNumber = _extractNationalNumbe2.nationalNumber; // If the number was not valid before but is valid now,
    // or if it was too long before, we consider the number
    // with the country calling code stripped to be a better result
    // and keep that instead.
    // For example, in Germany (+49), `49` is a valid area code,
    // so if a number starts with `49`, it could be both a valid
    // national German number or an international number without
    // a leading `+`.


    if (!matchesEntirely(nationalNumber, metadata.nationalNumberPattern()) && matchesEntirely(possibleShorterNationalNumber, metadata.nationalNumberPattern()) || checkNumberLength(nationalNumber, metadata) === 'TOO_LONG') {
      return {
        countryCallingCode: countryCallingCode,
        number: possibleShorterNumber
      };
    }
  }

  return {
    number: number
  };
}

/**
 * Converts a phone number digits (possibly with a `+`)
 * into a calling code and the rest phone number digits.
 * The "rest phone number digits" could include
 * a national prefix, carrier code, and national
 * (significant) number.
 * @param  {string} number — Phone number digits (possibly with a `+`).
 * @param  {string} [country] — Default country.
 * @param  {string} [callingCode] — Default calling code (some phone numbering plans are non-geographic).
 * @param  {object} metadata
 * @return {object} `{ countryCallingCodeSource: string?, countryCallingCode: string?, number: string }`
 * @example
 * // Returns `{ countryCallingCode: "1", number: "2133734253" }`.
 * extractCountryCallingCode('2133734253', 'US', null, metadata)
 * extractCountryCallingCode('2133734253', null, '1', metadata)
 * extractCountryCallingCode('+12133734253', null, null, metadata)
 * extractCountryCallingCode('+12133734253', 'RU', null, metadata)
 */

function extractCountryCallingCode(number, country, callingCode, metadata) {
  if (!number) {
    return {};
  }

  var isNumberWithIddPrefix; // If this is not an international phone number,
  // then either extract an "IDD" prefix, or extract a
  // country calling code from a number by autocorrecting it
  // by prepending a leading `+` in cases when it starts
  // with the country calling code.
  // https://wikitravel.org/en/International_dialling_prefix
  // https://github.com/catamphetamine/libphonenumber-js/issues/376

  if (number[0] !== '+') {
    // Convert an "out-of-country" dialing phone number
    // to a proper international phone number.
    var numberWithoutIDD = stripIddPrefix(number, country, callingCode, metadata); // If an IDD prefix was stripped then
    // convert the number to international one
    // for subsequent parsing.

    if (numberWithoutIDD && numberWithoutIDD !== number) {
      isNumberWithIddPrefix = true;
      number = '+' + numberWithoutIDD;
    } else {
      // Check to see if the number starts with the country calling code
      // for the default country. If so, we remove the country calling code,
      // and do some checks on the validity of the number before and after.
      // https://github.com/catamphetamine/libphonenumber-js/issues/376
      if (country || callingCode) {
        var _extractCountryCallin = extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(number, country, callingCode, metadata),
            countryCallingCode = _extractCountryCallin.countryCallingCode,
            shorterNumber = _extractCountryCallin.number;

        if (countryCallingCode) {
          return {
            countryCallingCodeSource: 'FROM_NUMBER_WITHOUT_PLUS_SIGN',
            countryCallingCode: countryCallingCode,
            number: shorterNumber
          };
        }
      }

      return {
        // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
        // countryCallingCodeSource: 'UNSPECIFIED',
        number: number
      };
    }
  } // Fast abortion: country codes do not begin with a '0'


  if (number[1] === '0') {
    return {};
  }

  metadata = new Metadata(metadata); // The thing with country phone codes
  // is that they are orthogonal to each other
  // i.e. there's no such country phone code A
  // for which country phone code B exists
  // where B starts with A.
  // Therefore, while scanning digits,
  // if a valid country code is found,
  // that means that it is the country code.
  //

  var i = 2;

  while (i - 1 <= MAX_LENGTH_COUNTRY_CODE && i <= number.length) {
    var _countryCallingCode = number.slice(1, i);

    if (metadata.hasCallingCode(_countryCallingCode)) {
      metadata.selectNumberingPlan(_countryCallingCode);
      return {
        countryCallingCodeSource: isNumberWithIddPrefix ? 'FROM_NUMBER_WITH_IDD' : 'FROM_NUMBER_WITH_PLUS_SIGN',
        countryCallingCode: _countryCallingCode,
        number: number.slice(i)
      };
    }

    i++;
  }

  return {};
} // The possible values for the returned `countryCallingCodeSource` are:
//
// Copy-pasted from:
// https://github.com/google/libphonenumber/blob/master/resources/phonenumber.proto
//
// // The source from which the country_code is derived. This is not set in the
// // general parsing method, but in the method that parses and keeps raw_input.
// // New fields could be added upon request.
// enum CountryCodeSource {
//  // Default value returned if this is not set, because the phone number was
//  // created using parse, not parseAndKeepRawInput. hasCountryCodeSource will
//  // return false if this is the case.
//  UNSPECIFIED = 0;
//
//  // The country_code is derived based on a phone number with a leading "+",
//  // e.g. the French number "+33 1 42 68 53 00".
//  FROM_NUMBER_WITH_PLUS_SIGN = 1;
//
//  // The country_code is derived based on a phone number with a leading IDD,
//  // e.g. the French number "011 33 1 42 68 53 00", as it is dialled from US.
//  FROM_NUMBER_WITH_IDD = 5;
//
//  // The country_code is derived based on a phone number without a leading
//  // "+", e.g. the French number "33 1 42 68 53 00" when defaultCountry is
//  // supplied as France.
//  FROM_NUMBER_WITHOUT_PLUS_SIGN = 10;
//
//  // The country_code is derived NOT based on the phone number itself, but
//  // from the defaultCountry parameter provided in the parsing function by the
//  // clients. This happens mostly for numbers written in the national format
//  // (without country code). For example, this would be set when parsing the
//  // French number "01 42 68 53 00", when defaultCountry is supplied as
//  // France.
//  FROM_DEFAULT_COUNTRY = 20;
// }

//
// E.g. "(999) 111-22-33" -> "999 111 22 33"
//
// For some reason Google's metadata contains `<intlFormat/>`s with brackets and dashes.
// Meanwhile, there's no single opinion about using punctuation in international phone numbers.
//
// For example, Google's `<intlFormat/>` for USA is `+1 213-373-4253`.
// And here's a quote from WikiPedia's "North American Numbering Plan" page:
// https://en.wikipedia.org/wiki/North_American_Numbering_Plan
//
// "The country calling code for all countries participating in the NANP is 1.
// In international format, an NANP number should be listed as +1 301 555 01 00,
// where 301 is an area code (Maryland)."
//
// I personally prefer the international format without any punctuation.
// For example, brackets are remnants of the old age, meaning that the
// phone number part in brackets (so called "area code") can be omitted
// if dialing within the same "area".
// And hyphens were clearly introduced for splitting local numbers into memorizable groups.
// For example, remembering "5553535" is difficult but "555-35-35" is much simpler.
// Imagine a man taking a bus from home to work and seeing an ad with a phone number.
// He has a couple of seconds to memorize that number until it passes by.
// If it were spaces instead of hyphens the man wouldn't necessarily get it,
// but with hyphens instead of spaces the grouping is more explicit.
// I personally think that hyphens introduce visual clutter,
// so I prefer replacing them with spaces in international numbers.
// In the modern age all output is done on displays where spaces are clearly distinguishable
// so hyphens can be safely replaced with spaces without losing any legibility.
//

function applyInternationalSeparatorStyle(formattedNumber) {
  return formattedNumber.replace(new RegExp("[".concat(VALID_PUNCTUATION, "]+"), 'g'), ' ').trim();
}

// first group is not used in the national pattern (e.g. Argentina) so the $1
// group does not match correctly. Therefore, we use `\d`, so that the first
// group actually used in the pattern will be matched.

var FIRST_GROUP_PATTERN = /(\$\d)/;
function formatNationalNumberUsingFormat(number, format, _ref) {
  var useInternationalFormat = _ref.useInternationalFormat,
      withNationalPrefix = _ref.withNationalPrefix;
  var formattedNumber = number.replace(new RegExp(format.pattern()), useInternationalFormat ? format.internationalFormat() : // This library doesn't use `domestic_carrier_code_formatting_rule`,
  // because that one is only used when formatting phone numbers
  // for dialing from a mobile phone, and this is not a dialing library.
  // carrierCode && format.domesticCarrierCodeFormattingRule()
  // 	// First, replace the $CC in the formatting rule with the desired carrier code.
  // 	// Then, replace the $FG in the formatting rule with the first group
  // 	// and the carrier code combined in the appropriate way.
  // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
  // 	: (
  // 		withNationalPrefix && format.nationalPrefixFormattingRule()
  // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
  // 			: format.format()
  // 	)
  withNationalPrefix && format.nationalPrefixFormattingRule() ? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule()) : format.format());

  if (useInternationalFormat) {
    return applyInternationalSeparatorStyle(formattedNumber);
  }

  return formattedNumber;
}

/**
 * Pattern that makes it easy to distinguish whether a region has a single
 * international dialing prefix or not. If a region has a single international
 * prefix (e.g. 011 in USA), it will be represented as a string that contains
 * a sequence of ASCII digits, and possibly a tilde, which signals waiting for
 * the tone. If there are multiple available international prefixes in a
 * region, they will be represented as a regex string that always contains one
 * or more characters that are not ASCII digits or a tilde.
 */

var SINGLE_IDD_PREFIX_REG_EXP = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/; // For regions that have multiple IDD prefixes
// a preferred IDD prefix is returned.

function getIddPrefix(country, callingCode, metadata) {
  var countryMetadata = new Metadata(metadata);
  countryMetadata.selectNumberingPlan(country, callingCode);

  if (countryMetadata.defaultIDDPrefix()) {
    return countryMetadata.defaultIDDPrefix();
  }

  if (SINGLE_IDD_PREFIX_REG_EXP.test(countryMetadata.IDDPrefix())) {
    return countryMetadata.IDDPrefix();
  }
}

var RFC3966_EXTN_PREFIX = ';ext=';
/**
 * Helper method for constructing regular expressions for parsing. Creates
 * an expression that captures up to max_length digits.
 * @return {string} RegEx pattern to capture extension digits.
 */

var getExtensionDigitsPattern = function getExtensionDigitsPattern(maxLength) {
  return "([".concat(VALID_DIGITS, "]{1,").concat(maxLength, "})");
};
/**
 * Helper initialiser method to create the regular-expression pattern to match
 * extensions.
 * Copy-pasted from Google's `libphonenumber`:
 * https://github.com/google/libphonenumber/blob/55b2646ec9393f4d3d6661b9c82ef9e258e8b829/javascript/i18n/phonenumbers/phonenumberutil.js#L759-L766
 * @return {string} RegEx pattern to capture extensions.
 */


function createExtensionPattern(purpose) {
  // We cap the maximum length of an extension based on the ambiguity of the way
  // the extension is prefixed. As per ITU, the officially allowed length for
  // extensions is actually 40, but we don't support this since we haven't seen real
  // examples and this introduces many false interpretations as the extension labels
  // are not standardized.

  /** @type {string} */
  var extLimitAfterExplicitLabel = '20';
  /** @type {string} */

  var extLimitAfterLikelyLabel = '15';
  /** @type {string} */

  var extLimitAfterAmbiguousChar = '9';
  /** @type {string} */

  var extLimitWhenNotSure = '6';
  /** @type {string} */

  var possibleSeparatorsBetweenNumberAndExtLabel = "[ \xA0\\t,]*"; // Optional full stop (.) or colon, followed by zero or more spaces/tabs/commas.

  /** @type {string} */

  var possibleCharsAfterExtLabel = "[:\\.\uFF0E]?[ \xA0\\t,-]*";
  /** @type {string} */

  var optionalExtnSuffix = "#?"; // Here the extension is called out in more explicit way, i.e mentioning it obvious
  // patterns like "ext.".

  /** @type {string} */

  var explicitExtLabels = "(?:e?xt(?:ensi(?:o\u0301?|\xF3))?n?|\uFF45?\uFF58\uFF54\uFF4E?|\u0434\u043E\u0431|anexo)"; // One-character symbols that can be used to indicate an extension, and less
  // commonly used or more ambiguous extension labels.

  /** @type {string} */

  var ambiguousExtLabels = "(?:[x\uFF58#\uFF03~\uFF5E]|int|\uFF49\uFF4E\uFF54)"; // When extension is not separated clearly.

  /** @type {string} */

  var ambiguousSeparator = "[- ]+"; // This is the same as possibleSeparatorsBetweenNumberAndExtLabel, but not matching
  // comma as extension label may have it.

  /** @type {string} */

  var possibleSeparatorsNumberExtLabelNoComma = "[ \xA0\\t]*"; // ",," is commonly used for auto dialling the extension when connected. First
  // comma is matched through possibleSeparatorsBetweenNumberAndExtLabel, so we do
  // not repeat it here. Semi-colon works in Iphone and Android also to pop up a
  // button with the extension number following.

  /** @type {string} */

  var autoDiallingAndExtLabelsFound = "(?:,{2}|;)";
  /** @type {string} */

  var rfcExtn = RFC3966_EXTN_PREFIX + getExtensionDigitsPattern(extLimitAfterExplicitLabel);
  /** @type {string} */

  var explicitExtn = possibleSeparatorsBetweenNumberAndExtLabel + explicitExtLabels + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterExplicitLabel) + optionalExtnSuffix;
  /** @type {string} */

  var ambiguousExtn = possibleSeparatorsBetweenNumberAndExtLabel + ambiguousExtLabels + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix;
  /** @type {string} */

  var americanStyleExtnWithSuffix = ambiguousSeparator + getExtensionDigitsPattern(extLimitWhenNotSure) + "#";
  /** @type {string} */

  var autoDiallingExtn = possibleSeparatorsNumberExtLabelNoComma + autoDiallingAndExtLabelsFound + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterLikelyLabel) + optionalExtnSuffix;
  /** @type {string} */

  var onlyCommasExtn = possibleSeparatorsNumberExtLabelNoComma + "(?:,)+" + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix; // The first regular expression covers RFC 3966 format, where the extension is added
  // using ";ext=". The second more generic where extension is mentioned with explicit
  // labels like "ext:". In both the above cases we allow more numbers in extension than
  // any other extension labels. The third one captures when single character extension
  // labels or less commonly used labels are used. In such cases we capture fewer
  // extension digits in order to reduce the chance of falsely interpreting two
  // numbers beside each other as a number + extension. The fourth one covers the
  // special case of American numbers where the extension is written with a hash
  // at the end, such as "- 503#". The fifth one is exclusively for extension
  // autodialling formats which are used when dialling and in this case we accept longer
  // extensions. The last one is more liberal on the number of commas that acts as
  // extension labels, so we have a strict cap on the number of digits in such extensions.

  return rfcExtn + "|" + explicitExtn + "|" + ambiguousExtn + "|" + americanStyleExtnWithSuffix + "|" + autoDiallingExtn + "|" + onlyCommasExtn;
}

//  Checks we have at least three leading digits, and only valid punctuation,
//  alpha characters and digits in the phone number. Does not include extension
//  data. The symbol 'x' is allowed here as valid punctuation since it is often
//  used as a placeholder for carrier codes, for example in Brazilian phone
//  numbers. We also allow multiple '+' characters at the start.
//
//  Corresponds to the following:
//  [digits]{minLengthNsn}|
//  plus_sign*
//  (([punctuation]|[star])*[digits]){3,}([punctuation]|[star]|[digits]|[alpha])*
//
//  The first reg-ex is to allow short numbers (two digits long) to be parsed if
//  they are entered as "15" etc, but only if there is no punctuation in them.
//  The second expression restricts the number of digits to three or more, but
//  then allows them to be in international form, and to have alpha-characters
//  and punctuation. We split up the two reg-exes here and combine them when
//  creating the reg-ex VALID_PHONE_NUMBER_PATTERN itself so we can prefix it
//  with ^ and append $ to each branch.
//
//  "Note VALID_PUNCTUATION starts with a -,
//   so must be the first in the range" (c) Google devs.
//  (wtf did they mean by saying that; probably nothing)
//

var MIN_LENGTH_PHONE_NUMBER_PATTERN = '[' + VALID_DIGITS + ']{' + MIN_LENGTH_FOR_NSN + '}'; //
// And this is the second reg-exp:
// (see MIN_LENGTH_PHONE_NUMBER_PATTERN for a full description of this reg-exp)
//

var VALID_PHONE_NUMBER = '[' + PLUS_CHARS + ']{0,1}' + '(?:' + '[' + VALID_PUNCTUATION + ']*' + '[' + VALID_DIGITS + ']' + '){3,}' + '[' + VALID_PUNCTUATION + VALID_DIGITS + ']*'; // This regular expression isn't present in Google's `libphonenumber`
// and is only used to determine whether the phone number being input
// is too short for it to even consider it a "valid" number.
// This is just a way to differentiate between a really invalid phone
// number like "abcde" and a valid phone number that a user has just
// started inputting, like "+1" or "1": both these cases would be
// considered `NOT_A_NUMBER` by Google's `libphonenumber`, but this
// library can provide a more detailed error message — whether it's
// really "not a number", or is it just a start of a valid phone number.

var VALID_PHONE_NUMBER_START_REG_EXP = new RegExp('^' + '[' + PLUS_CHARS + ']{0,1}' + '(?:' + '[' + VALID_PUNCTUATION + ']*' + '[' + VALID_DIGITS + ']' + '){1,2}' + '$', 'i');
var VALID_PHONE_NUMBER_WITH_EXTENSION = VALID_PHONE_NUMBER + // Phone number extensions
'(?:' + createExtensionPattern() + ')?'; // The combined regular expression for valid phone numbers:
//

var VALID_PHONE_NUMBER_PATTERN = new RegExp( // Either a short two-digit-only phone number
'^' + MIN_LENGTH_PHONE_NUMBER_PATTERN + '$' + '|' + // Or a longer fully parsed phone number (min 3 characters)
'^' + VALID_PHONE_NUMBER_WITH_EXTENSION + '$', 'i'); // Checks to see if the string of characters could possibly be a phone number at
// all. At the moment, checks to see that the string begins with at least 2
// digits, ignoring any punctuation commonly found in phone numbers. This method
// does not require the number to be normalized in advance - but does assume
// that leading non-number symbols have been removed, such as by the method
// `extract_possible_number`.
//

function isViablePhoneNumber(number) {
  return number.length >= MIN_LENGTH_FOR_NSN && VALID_PHONE_NUMBER_PATTERN.test(number);
} // This is just a way to differentiate between a really invalid phone
// number like "abcde" and a valid phone number that a user has just
// started inputting, like "+1" or "1": both these cases would be
// considered `NOT_A_NUMBER` by Google's `libphonenumber`, but this
// library can provide a more detailed error message — whether it's
// really "not a number", or is it just a start of a valid phone number.

function isViablePhoneNumberStart(number) {
  return VALID_PHONE_NUMBER_START_REG_EXP.test(number);
}

/**
 * @param  {object} - `{ ?number, ?extension }`.
 * @return {string} Phone URI (RFC 3966).
 */

function formatRFC3966(_ref) {
  var number = _ref.number,
      ext = _ref.ext;

  if (!number) {
    return '';
  }

  if (number[0] !== '+') {
    throw new Error("\"formatRFC3966()\" expects \"number\" to be in E.164 format.");
  }

  return "tel:".concat(number).concat(ext ? ';ext=' + ext : '');
}

function _createForOfIteratorHelperLoose$2(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray$3(o)) || allowArrayLike) { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$3(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$3(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$3(o, minLen); }

function _arrayLikeToArray$3(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$4(Object(source), true).forEach(function (key) { _defineProperty$4(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$4(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var DEFAULT_OPTIONS = {
  formatExtension: function formatExtension(formattedNumber, extension, metadata) {
    return "".concat(formattedNumber).concat(metadata.ext()).concat(extension);
  }
};
/**
 * Formats a phone number.
 *
 * format(phoneNumberInstance, 'INTERNATIONAL', { ..., v2: true }, metadata)
 * format(phoneNumberInstance, 'NATIONAL', { ..., v2: true }, metadata)
 *
 * format({ phone: '8005553535', country: 'RU' }, 'INTERNATIONAL', { ... }, metadata)
 * format({ phone: '8005553535', country: 'RU' }, 'NATIONAL', undefined, metadata)
 *
 * @param  {object|PhoneNumber} input — If `options.v2: true` flag is passed, the `input` should be a `PhoneNumber` instance. Otherwise, it should be an object of shape `{ phone: '...', country: '...' }`.
 * @param  {string} format
 * @param  {object} [options]
 * @param  {object} metadata
 * @return {string}
 */

function formatNumber(input, format, options, metadata) {
  // Apply default options.
  if (options) {
    options = _objectSpread$4(_objectSpread$4({}, DEFAULT_OPTIONS), options);
  } else {
    options = DEFAULT_OPTIONS;
  }

  metadata = new Metadata(metadata);

  if (input.country && input.country !== '001') {
    // Validate `input.country`.
    if (!metadata.hasCountry(input.country)) {
      throw new Error("Unknown country: ".concat(input.country));
    }

    metadata.country(input.country);
  } else if (input.countryCallingCode) {
    metadata.selectNumberingPlan(input.countryCallingCode);
  } else return input.phone || '';

  var countryCallingCode = metadata.countryCallingCode();
  var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // This variable should have been declared inside `case`s
  // but Babel has a bug and it says "duplicate variable declaration".

  var number;

  switch (format) {
    case 'NATIONAL':
      // Legacy argument support.
      // (`{ country: ..., phone: '' }`)
      if (!nationalNumber) {
        return '';
      }

      number = formatNationalNumber(nationalNumber, input.carrierCode, 'NATIONAL', metadata, options);
      return addExtension(number, input.ext, metadata, options.formatExtension);

    case 'INTERNATIONAL':
      // Legacy argument support.
      // (`{ country: ..., phone: '' }`)
      if (!nationalNumber) {
        return "+".concat(countryCallingCode);
      }

      number = formatNationalNumber(nationalNumber, null, 'INTERNATIONAL', metadata, options);
      number = "+".concat(countryCallingCode, " ").concat(number);
      return addExtension(number, input.ext, metadata, options.formatExtension);

    case 'E.164':
      // `E.164` doesn't define "phone number extensions".
      return "+".concat(countryCallingCode).concat(nationalNumber);

    case 'RFC3966':
      return formatRFC3966({
        number: "+".concat(countryCallingCode).concat(nationalNumber),
        ext: input.ext
      });
    // For reference, here's Google's IDD formatter:
    // https://github.com/google/libphonenumber/blob/32719cf74e68796788d1ca45abc85dcdc63ba5b9/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L1546
    // Not saying that this IDD formatter replicates it 1:1, but it seems to work.
    // Who would even need to format phone numbers in IDD format anyway?

    case 'IDD':
      if (!options.fromCountry) {
        return; // throw new Error('`fromCountry` option not passed for IDD-prefixed formatting.')
      }

      var formattedNumber = formatIDD(nationalNumber, input.carrierCode, countryCallingCode, options.fromCountry, metadata);
      return addExtension(formattedNumber, input.ext, metadata, options.formatExtension);

    default:
      throw new Error("Unknown \"format\" argument passed to \"formatNumber()\": \"".concat(format, "\""));
  }
}

function formatNationalNumber(number, carrierCode, formatAs, metadata, options) {
  var format = chooseFormatForNumber(metadata.formats(), number);

  if (!format) {
    return number;
  }

  return formatNationalNumberUsingFormat(number, format, {
    useInternationalFormat: formatAs === 'INTERNATIONAL',
    withNationalPrefix: format.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && options && options.nationalPrefix === false ? false : true});
}

function chooseFormatForNumber(availableFormats, nationalNnumber) {
  for (var _iterator = _createForOfIteratorHelperLoose$2(availableFormats), _step; !(_step = _iterator()).done;) {
    var format = _step.value;

    // Validate leading digits.
    // The test case for "else path" could be found by searching for
    // "format.leadingDigitsPatterns().length === 0".
    if (format.leadingDigitsPatterns().length > 0) {
      // The last leading_digits_pattern is used here, as it is the most detailed
      var lastLeadingDigitsPattern = format.leadingDigitsPatterns()[format.leadingDigitsPatterns().length - 1]; // If leading digits don't match then move on to the next phone number format

      if (nationalNnumber.search(lastLeadingDigitsPattern) !== 0) {
        continue;
      }
    } // Check that the national number matches the phone number format regular expression


    if (matchesEntirely(nationalNnumber, format.pattern())) {
      return format;
    }
  }
}

function addExtension(formattedNumber, ext, metadata, formatExtension) {
  return ext ? formatExtension(formattedNumber, ext, metadata) : formattedNumber;
}

function formatIDD(nationalNumber, carrierCode, countryCallingCode, fromCountry, metadata) {
  var fromCountryCallingCode = getCountryCallingCode(fromCountry, metadata.metadata); // When calling within the same country calling code.

  if (fromCountryCallingCode === countryCallingCode) {
    var formattedNumber = formatNationalNumber(nationalNumber, carrierCode, 'NATIONAL', metadata); // For NANPA regions, return the national format for these regions
    // but prefix it with the country calling code.

    if (countryCallingCode === '1') {
      return countryCallingCode + ' ' + formattedNumber;
    } // If regions share a country calling code, the country calling code need
    // not be dialled. This also applies when dialling within a region, so this
    // if clause covers both these cases. Technically this is the case for
    // dialling from La Reunion to other overseas departments of France (French
    // Guiana, Martinique, Guadeloupe), but not vice versa - so we don't cover
    // this edge case for now and for those cases return the version including
    // country calling code. Details here:
    // http://www.petitfute.com/voyage/225-info-pratiques-reunion
    //


    return formattedNumber;
  }

  var iddPrefix = getIddPrefix(fromCountry, undefined, metadata.metadata);

  if (iddPrefix) {
    return "".concat(iddPrefix, " ").concat(countryCallingCode, " ").concat(formatNationalNumber(nationalNumber, null, 'INTERNATIONAL', metadata));
  }
}

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$3(Object(source), true).forEach(function (key) { _defineProperty$3(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$3(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck$1(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$1(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var PhoneNumber = /*#__PURE__*/function () {
  /**
   * @param  {string} countryOrCountryCallingCode
   * @param  {string} nationalNumber
   * @param  {object} metadata — Metadata JSON
   * @return {PhoneNumber}
   */
  function PhoneNumber(countryOrCountryCallingCode, nationalNumber, metadata) {
    _classCallCheck$1(this, PhoneNumber);

    // Validate `countryOrCountryCallingCode` argument.
    if (!countryOrCountryCallingCode) {
      throw new TypeError('First argument is required');
    }

    if (typeof countryOrCountryCallingCode !== 'string') {
      throw new TypeError('First argument must be a string');
    } // In case of public API use: `constructor(number, metadata)`.
    // Transform the arguments from `constructor(number, metadata)` to
    // `constructor(countryOrCountryCallingCode, nationalNumber, metadata)`.


    if (typeof countryOrCountryCallingCode === 'string') {
      if (countryOrCountryCallingCode[0] === '+' && !nationalNumber) {
        throw new TypeError('`metadata` argument not passed');
      }

      if (isObject(nationalNumber) && isObject(nationalNumber.countries)) {
        metadata = nationalNumber;
        var e164Number = countryOrCountryCallingCode;

        if (!E164_NUMBER_REGEXP.test(e164Number)) {
          throw new Error('Invalid `number` argument passed: must consist of a "+" followed by digits');
        }

        var _extractCountryCallin = extractCountryCallingCode(e164Number, undefined, undefined, metadata),
            _countryCallingCode = _extractCountryCallin.countryCallingCode,
            number = _extractCountryCallin.number;

        nationalNumber = number;
        countryOrCountryCallingCode = _countryCallingCode;

        if (!nationalNumber) {
          throw new Error('Invalid `number` argument passed: too short');
        }
      }
    } // Validate `nationalNumber` argument.


    if (!nationalNumber) {
      throw new TypeError('`nationalNumber` argument is required');
    }

    if (typeof nationalNumber !== 'string') {
      throw new TypeError('`nationalNumber` argument must be a string');
    } // Validate `metadata` argument.


    validateMetadata(metadata); // Initialize properties.

    var _getCountryAndCountry = getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadata),
        country = _getCountryAndCountry.country,
        countryCallingCode = _getCountryAndCountry.countryCallingCode;

    this.country = country;
    this.countryCallingCode = countryCallingCode;
    this.nationalNumber = nationalNumber;
    this.number = '+' + this.countryCallingCode + this.nationalNumber; // Exclude `metadata` property output from `PhoneNumber.toString()`
    // so that it doesn't clutter the console output of Node.js.
    // Previously, when Node.js did `console.log(new PhoneNumber(...))`,
    // it would output the whole internal structure of the `metadata` object.

    this.getMetadata = function () {
      return metadata;
    };
  }

  _createClass$1(PhoneNumber, [{
    key: "setExt",
    value: function setExt(ext) {
      this.ext = ext;
    }
  }, {
    key: "getPossibleCountries",
    value: function getPossibleCountries() {
      if (this.country) {
        return [this.country];
      }

      return getPossibleCountriesForNumber(this.countryCallingCode, this.nationalNumber, this.getMetadata());
    }
  }, {
    key: "isPossible",
    value: function isPossible() {
      return isPossiblePhoneNumber(this, {
        v2: true
      }, this.getMetadata());
    }
  }, {
    key: "isValid",
    value: function isValid() {
      return isValidNumber(this, {
        v2: true
      }, this.getMetadata());
    }
  }, {
    key: "isNonGeographic",
    value: function isNonGeographic() {
      var metadata = new Metadata(this.getMetadata());
      return metadata.isNonGeographicCallingCode(this.countryCallingCode);
    }
  }, {
    key: "isEqual",
    value: function isEqual(phoneNumber) {
      return this.number === phoneNumber.number && this.ext === phoneNumber.ext;
    } // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
    // but later it was found out that it doesn't include the possible `TOO_SHORT` result
    // returned from `parsePhoneNumberWithError()` in the original `validatePhoneNumberLength()`,
    // so eventually I simply commented out this method from the `PhoneNumber` class
    // and just left the `validatePhoneNumberLength()` function, even though that one would require
    // and additional step to also validate the actual country / calling code of the phone number.
    // validateLength() {
    // 	const metadata = new Metadata(this.getMetadata())
    // 	metadata.selectNumberingPlan(this.countryCallingCode)
    // 	const result = checkNumberLength(this.nationalNumber, metadata)
    // 	if (result !== 'IS_POSSIBLE') {
    // 		return result
    // 	}
    // }

  }, {
    key: "getType",
    value: function getType() {
      return getNumberType(this, {
        v2: true
      }, this.getMetadata());
    }
  }, {
    key: "format",
    value: function format(_format, options) {
      return formatNumber(this, _format, options ? _objectSpread$3(_objectSpread$3({}, options), {}, {
        v2: true
      }) : {
        v2: true
      }, this.getMetadata());
    }
  }, {
    key: "formatNational",
    value: function formatNational(options) {
      return this.format('NATIONAL', options);
    }
  }, {
    key: "formatInternational",
    value: function formatInternational(options) {
      return this.format('INTERNATIONAL', options);
    }
  }, {
    key: "getURI",
    value: function getURI(options) {
      return this.format('RFC3966', options);
    }
  }]);

  return PhoneNumber;
}();

var isCountryCode = function isCountryCode(value) {
  return /^[A-Z]{2}$/.test(value);
};

function getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadataJson) {
  var country;
  var countryCallingCode;
  var metadata = new Metadata(metadataJson); // If country code is passed then derive `countryCallingCode` from it.
  // Also store the country code as `.country`.

  if (isCountryCode(countryOrCountryCallingCode)) {
    country = countryOrCountryCallingCode;
    metadata.selectNumberingPlan(country);
    countryCallingCode = metadata.countryCallingCode();
  } else {
    countryCallingCode = countryOrCountryCallingCode;
  }

  return {
    country: country,
    countryCallingCode: countryCallingCode
  };
}

var E164_NUMBER_REGEXP = /^\+\d+$/;

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _createClass(Constructor, protoProps, staticProps) { Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

// https://stackoverflow.com/a/46971044/970769
// "Breaking changes in Typescript 2.1"
// "Extending built-ins like Error, Array, and Map may no longer work."
// "As a recommendation, you can manually adjust the prototype immediately after any super(...) calls."
// https://github.com/Microsoft/TypeScript-wiki/blob/main/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
var ParseError = /*#__PURE__*/function (_Error) {
  _inherits(ParseError, _Error);

  var _super = _createSuper(ParseError);

  function ParseError(code) {
    var _this;

    _classCallCheck(this, ParseError);

    _this = _super.call(this, code); // Set the prototype explicitly.
    // Any subclass of FooError will have to manually set the prototype as well.

    Object.setPrototypeOf(_assertThisInitialized(_this), ParseError.prototype);
    _this.name = _this.constructor.name;
    return _this;
  }

  return _createClass(ParseError);
}( /*#__PURE__*/_wrapNativeSuper(Error));

// 1 or more valid digits, for use when parsing.

var EXTN_PATTERN = new RegExp('(?:' + createExtensionPattern() + ')$', 'i'); // Strips any extension (as in, the part of the number dialled after the call is
// connected, usually indicated with extn, ext, x or similar) from the end of
// the number, and returns it.

function extractExtension(number) {
  var start = number.search(EXTN_PATTERN);

  if (start < 0) {
    return {};
  } // If we find a potential extension, and the number preceding this is a viable
  // number, we assume it is an extension.


  var numberWithoutExtension = number.slice(0, start);
  var matches = number.match(EXTN_PATTERN);
  var i = 1;

  while (i < matches.length) {
    if (matches[i]) {
      return {
        number: numberWithoutExtension,
        ext: matches[i]
      };
    }

    i++;
  }
}

// These mappings map a character (key) to a specific digit that should
// replace it for normalization purposes. Non-European digits that
// may be used in phone numbers are mapped to a European equivalent.
//
// E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
//
var DIGITS = {
  '0': '0',
  '1': '1',
  '2': '2',
  '3': '3',
  '4': '4',
  '5': '5',
  '6': '6',
  '7': '7',
  '8': '8',
  '9': '9',
  "\uFF10": '0',
  // Fullwidth digit 0
  "\uFF11": '1',
  // Fullwidth digit 1
  "\uFF12": '2',
  // Fullwidth digit 2
  "\uFF13": '3',
  // Fullwidth digit 3
  "\uFF14": '4',
  // Fullwidth digit 4
  "\uFF15": '5',
  // Fullwidth digit 5
  "\uFF16": '6',
  // Fullwidth digit 6
  "\uFF17": '7',
  // Fullwidth digit 7
  "\uFF18": '8',
  // Fullwidth digit 8
  "\uFF19": '9',
  // Fullwidth digit 9
  "\u0660": '0',
  // Arabic-indic digit 0
  "\u0661": '1',
  // Arabic-indic digit 1
  "\u0662": '2',
  // Arabic-indic digit 2
  "\u0663": '3',
  // Arabic-indic digit 3
  "\u0664": '4',
  // Arabic-indic digit 4
  "\u0665": '5',
  // Arabic-indic digit 5
  "\u0666": '6',
  // Arabic-indic digit 6
  "\u0667": '7',
  // Arabic-indic digit 7
  "\u0668": '8',
  // Arabic-indic digit 8
  "\u0669": '9',
  // Arabic-indic digit 9
  "\u06F0": '0',
  // Eastern-Arabic digit 0
  "\u06F1": '1',
  // Eastern-Arabic digit 1
  "\u06F2": '2',
  // Eastern-Arabic digit 2
  "\u06F3": '3',
  // Eastern-Arabic digit 3
  "\u06F4": '4',
  // Eastern-Arabic digit 4
  "\u06F5": '5',
  // Eastern-Arabic digit 5
  "\u06F6": '6',
  // Eastern-Arabic digit 6
  "\u06F7": '7',
  // Eastern-Arabic digit 7
  "\u06F8": '8',
  // Eastern-Arabic digit 8
  "\u06F9": '9' // Eastern-Arabic digit 9

};
function parseDigit(character) {
  return DIGITS[character];
}

function _createForOfIteratorHelperLoose$1(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray$2(o)) || allowArrayLike) { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$2(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$2(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$2(o, minLen); }

function _arrayLikeToArray$2(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
/**
 * Parses phone number characters from a string.
 * Drops all punctuation leaving only digits and the leading `+` sign (if any).
 * Also converts wide-ascii and arabic-indic numerals to conventional numerals.
 * E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
 * @param  {string} string
 * @return {string}
 * @example
 * ```js
 * // Outputs '8800555'.
 * parseIncompletePhoneNumber('8 (800) 555')
 * // Outputs '+7800555'.
 * parseIncompletePhoneNumber('+7 800 555')
 * ```
 */

function parseIncompletePhoneNumber(string) {
  var result = ''; // Using `.split('')` here instead of normal `for ... of`
  // because the importing application doesn't neccessarily include an ES6 polyfill.
  // The `.split('')` approach discards "exotic" UTF-8 characters
  // (the ones consisting of four bytes) but digits
  // (including non-European ones) don't fall into that range
  // so such "exotic" characters would be discarded anyway.

  for (var _iterator = _createForOfIteratorHelperLoose$1(string.split('')), _step; !(_step = _iterator()).done;) {
    var character = _step.value;
    result += parsePhoneNumberCharacter(character, result) || '';
  }

  return result;
}
/**
 * Parses next character while parsing phone number digits (including a `+`)
 * from text: discards everything except `+` and digits, and `+` is only allowed
 * at the start of a phone number.
 * For example, is used in `react-phone-number-input` where it uses
 * [`input-format`](https://gitlab.com/catamphetamine/input-format).
 * @param  {string} character - Yet another character from raw input string.
 * @param  {string?} prevParsedCharacters - Previous parsed characters.
 * @param  {function?} emitEvent - An optional "emit event" function.
 * @return {string?} The parsed character.
 */

function parsePhoneNumberCharacter(character, prevParsedCharacters, emitEvent) {
  // Only allow a leading `+`.
  if (character === '+') {
    // If this `+` is not the first parsed character
    // then discard it.
    if (prevParsedCharacters) {

      return;
    }

    return '+';
  } // Allow digits.


  return parseDigit(character);
}

function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray$1(o)) || allowArrayLike) { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$1(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$1(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen); }

function _arrayLikeToArray$1(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function getCountryByNationalNumber(nationalPhoneNumber, _ref) {
  var countries = _ref.countries,
      metadata = _ref.metadata;
  // Re-create `metadata` because it will be selecting a `country`.
  metadata = new Metadata(metadata); // const matchingCountries = []

  for (var _iterator = _createForOfIteratorHelperLoose(countries), _step; !(_step = _iterator()).done;) {
    var country = _step.value;
    metadata.country(country); // "Leading digits" patterns are only defined for about 20% of all countries.
    // By definition, matching "leading digits" is a sufficient but not a necessary
    // condition for a phone number to belong to a country.
    // The point of "leading digits" check is that it's the fastest one to get a match.
    // https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md#leading_digits
    // I'd suppose that "leading digits" patterns are mutually exclusive for different countries
    // because of the intended use of that feature.

    if (metadata.leadingDigits()) {
      if (nationalPhoneNumber && nationalPhoneNumber.search(metadata.leadingDigits()) === 0) {
        return country;
      }
    } // Else perform full validation with all of those
    // fixed-line/mobile/etc regular expressions.
    else if (getNumberType({
      phone: nationalPhoneNumber,
      country: country
    }, undefined, metadata.metadata)) {
      // If both the `defaultCountry` and the "main" one match the phone number,
      // don't prefer the `defaultCountry` over the "main" one.
      // https://gitlab.com/catamphetamine/libphonenumber-js/-/issues/154
      return country; // // If the `defaultCountry` is among the `matchingCountries` then return it.
      // if (defaultCountry) {
      // 	if (country === defaultCountry) {
      // 		return country
      // 	}
      // 	matchingCountries.push(country)
      // } else {
      // 	return country
      // }
    }
  } // // Return the first ("main") one of the `matchingCountries`.
  // if (matchingCountries.length > 0) {
  // 	return matchingCountries[0]
  // }

}

function getCountryByCallingCode(callingCode, _ref) {
  var nationalPhoneNumber = _ref.nationalNumber,
      metadata = _ref.metadata;

  var possibleCountries = metadata.getCountryCodesForCallingCode(callingCode);

  if (!possibleCountries) {
    return;
  } // If there's just one country corresponding to the country code,
  // then just return it, without further phone number digits validation.


  if (possibleCountries.length === 1) {
    return possibleCountries[0];
  }

  return getCountryByNationalNumber(nationalPhoneNumber, {
    countries: possibleCountries,
    metadata: metadata.metadata
  });
}

// When phone numbers are written in `RFC3966` format — `"tel:+12133734253"` —
// they can have their "calling code" part written separately in a `phone-context` parameter.
// Example: `"tel:12133734253;phone-context=+1"`.
// This function parses the full phone number from the local number and the `phone-context`
// when the `phone-context` contains a `+` sign.
var PLUS_SIGN = '+';
var RFC3966_VISUAL_SEPARATOR_ = '[\\-\\.\\(\\)]?';
var RFC3966_PHONE_DIGIT_ = '(' + '[' + VALID_DIGITS + ']' + '|' + RFC3966_VISUAL_SEPARATOR_ + ')';
var RFC3966_GLOBAL_NUMBER_DIGITS_ = '^' + '\\' + PLUS_SIGN + RFC3966_PHONE_DIGIT_ + '*' + '[' + VALID_DIGITS + ']' + RFC3966_PHONE_DIGIT_ + '*' + '$';
/**
 * Regular expression of valid global-number-digits for the phone-context
 * parameter, following the syntax defined in RFC3966.
 */

var RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_ = new RegExp(RFC3966_GLOBAL_NUMBER_DIGITS_, 'g'); // In this port of Google's library, we don't accept alpha characters in phone numbers.
// const ALPHANUM_ = VALID_ALPHA_ + VALID_DIGITS

var ALPHANUM_ = VALID_DIGITS;
var RFC3966_DOMAINLABEL_ = '[' + ALPHANUM_ + ']+((\\-)*[' + ALPHANUM_ + '])*';
var VALID_ALPHA_ = 'a-zA-Z';
var RFC3966_TOPLABEL_ = '[' + VALID_ALPHA_ + ']+((\\-)*[' + ALPHANUM_ + '])*';
var RFC3966_DOMAINNAME_ = '^(' + RFC3966_DOMAINLABEL_ + '\\.)*' + RFC3966_TOPLABEL_ + '\\.?$';
/**
 * Regular expression of valid domainname for the phone-context parameter,
 * following the syntax defined in RFC3966.
 */

var RFC3966_DOMAINNAME_PATTERN_ = new RegExp(RFC3966_DOMAINNAME_, 'g');
var RFC3966_PREFIX_ = 'tel:';
var RFC3966_PHONE_CONTEXT_ = ';phone-context=';
var RFC3966_ISDN_SUBADDRESS_ = ';isub=';
/**
 * Extracts the value of the phone-context parameter of `numberToExtractFrom`,
 * following the syntax defined in RFC3966.
 *
 * @param {string} numberToExtractFrom
 * @return {string|null} the extracted string (possibly empty), or `null` if no phone-context parameter is found.
 */

function extractPhoneContext(numberToExtractFrom) {
  var indexOfPhoneContext = numberToExtractFrom.indexOf(RFC3966_PHONE_CONTEXT_); // If no phone-context parameter is present

  if (indexOfPhoneContext < 0) {
    return null;
  }

  var phoneContextStart = indexOfPhoneContext + RFC3966_PHONE_CONTEXT_.length; // If phone-context parameter is empty

  if (phoneContextStart >= numberToExtractFrom.length) {
    return '';
  }

  var phoneContextEnd = numberToExtractFrom.indexOf(';', phoneContextStart); // If phone-context is not the last parameter

  if (phoneContextEnd >= 0) {
    return numberToExtractFrom.substring(phoneContextStart, phoneContextEnd);
  } else {
    return numberToExtractFrom.substring(phoneContextStart);
  }
}
/**
 * Returns whether the value of phoneContext follows the syntax defined in RFC3966.
 *
 * @param {string|null} phoneContext
 * @return {boolean}
 */

function isPhoneContextValid(phoneContext) {
  if (phoneContext === null) {
    return true;
  }

  if (phoneContext.length === 0) {
    return false;
  } // Does phone-context value match pattern of global-number-digits or domainname.


  return RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_.test(phoneContext) || RFC3966_DOMAINNAME_PATTERN_.test(phoneContext);
}

/**
 * @param  {string} numberToParse
 * @param  {string} nationalNumber
 * @return {}
 */

function extractFormattedPhoneNumberFromPossibleRfc3966NumberUri(numberToParse, _ref) {
  var extractFormattedPhoneNumber = _ref.extractFormattedPhoneNumber;
  var phoneContext = extractPhoneContext(numberToParse);

  if (!isPhoneContextValid(phoneContext)) {
    throw new ParseError('NOT_A_NUMBER');
  }

  var phoneNumberString;

  if (phoneContext === null) {
    // Extract a possible number from the string passed in.
    // (this strips leading characters that could not be the start of a phone number)
    phoneNumberString = extractFormattedPhoneNumber(numberToParse) || '';
  } else {
    phoneNumberString = ''; // If the phone context contains a phone number prefix, we need to capture
    // it, whereas domains will be ignored.

    if (phoneContext.charAt(0) === PLUS_SIGN) {
      phoneNumberString += phoneContext;
    } // Now append everything between the "tel:" prefix and the phone-context.
    // This should include the national number, an optional extension or
    // isdn-subaddress component. Note we also handle the case when "tel:" is
    // missing, as we have seen in some of the phone number inputs.
    // In that case, we append everything from the beginning.


    var indexOfRfc3966Prefix = numberToParse.indexOf(RFC3966_PREFIX_);
    var indexOfNationalNumber; // RFC 3966 "tel:" prefix is preset at this stage because
    // `isPhoneContextValid()` requires it to be present.

    /* istanbul ignore else */

    if (indexOfRfc3966Prefix >= 0) {
      indexOfNationalNumber = indexOfRfc3966Prefix + RFC3966_PREFIX_.length;
    } else {
      indexOfNationalNumber = 0;
    }

    var indexOfPhoneContext = numberToParse.indexOf(RFC3966_PHONE_CONTEXT_);
    phoneNumberString += numberToParse.substring(indexOfNationalNumber, indexOfPhoneContext);
  } // Delete the isdn-subaddress and everything after it if it is present.
  // Note extension won't appear at the same time with isdn-subaddress
  // according to paragraph 5.3 of the RFC3966 spec.


  var indexOfIsdn = phoneNumberString.indexOf(RFC3966_ISDN_SUBADDRESS_);

  if (indexOfIsdn > 0) {
    phoneNumberString = phoneNumberString.substring(0, indexOfIsdn);
  } // If both phone context and isdn-subaddress are absent but other
  // parameters are present, the parameters are left in nationalNumber.
  // This is because we are concerned about deleting content from a potential
  // number string when there is no strong evidence that the number is
  // actually written in RFC3966.


  if (phoneNumberString !== '') {
    return phoneNumberString;
  }
}

// This is a port of Google Android `libphonenumber`'s
// `phonenumberutil.js` of December 31th, 2018.
//
// https://github.com/googlei18n/libphonenumber/commits/master/javascript/i18n/phonenumbers/phonenumberutil.js
// This prevents malicious input from consuming CPU.

var MAX_INPUT_STRING_LENGTH = 250; // This consists of the plus symbol, digits, and arabic-indic digits.

var PHONE_NUMBER_START_PATTERN = new RegExp('[' + PLUS_CHARS + VALID_DIGITS + ']'); // Regular expression of trailing characters that we want to remove.
// A trailing `#` is sometimes used when writing phone numbers with extensions in US.
// Example: "+1 (645) 123 1234-910#" number has extension "910".

var AFTER_PHONE_NUMBER_END_PATTERN = new RegExp('[^' + VALID_DIGITS + '#' + ']+$');
//
// ```js
// parse('8 (800) 555-35-35', 'RU')
// parse('8 (800) 555-35-35', 'RU', metadata)
// parse('8 (800) 555-35-35', { country: { default: 'RU' } })
// parse('8 (800) 555-35-35', { country: { default: 'RU' } }, metadata)
// parse('+7 800 555 35 35')
// parse('+7 800 555 35 35', metadata)
// ```
//

/**
 * Parses a phone number.
 *
 * parse('123456789', { defaultCountry: 'RU', v2: true }, metadata)
 * parse('123456789', { defaultCountry: 'RU' }, metadata)
 * parse('123456789', undefined, metadata)
 *
 * @param  {string} input
 * @param  {object} [options]
 * @param  {object} metadata
 * @return {object|PhoneNumber?} If `options.v2: true` flag is passed, it returns a `PhoneNumber?` instance. Otherwise, returns an object of shape `{ phone: '...', country: '...' }` (or just `{}` if no phone number was parsed).
 */

function parse(text, options, metadata) {
  // If assigning the `{}` default value is moved to the arguments above,
  // code coverage would decrease for some weird reason.
  options = options || {};
  metadata = new Metadata(metadata); // Validate `defaultCountry`.

  if (options.defaultCountry && !metadata.hasCountry(options.defaultCountry)) {
    if (options.v2) {
      throw new ParseError('INVALID_COUNTRY');
    }

    throw new Error("Unknown country: ".concat(options.defaultCountry));
  } // Parse the phone number.


  var _parseInput = parseInput(text, options.v2, options.extract),
      formattedPhoneNumber = _parseInput.number,
      ext = _parseInput.ext,
      error = _parseInput.error; // If the phone number is not viable then return nothing.


  if (!formattedPhoneNumber) {
    if (options.v2) {
      if (error === 'TOO_SHORT') {
        throw new ParseError('TOO_SHORT');
      }

      throw new ParseError('NOT_A_NUMBER');
    }

    return {};
  }

  var _parsePhoneNumber = parsePhoneNumber$3(formattedPhoneNumber, options.defaultCountry, options.defaultCallingCode, metadata),
      country = _parsePhoneNumber.country,
      nationalNumber = _parsePhoneNumber.nationalNumber,
      countryCallingCode = _parsePhoneNumber.countryCallingCode,
      countryCallingCodeSource = _parsePhoneNumber.countryCallingCodeSource,
      carrierCode = _parsePhoneNumber.carrierCode;

  if (!metadata.hasSelectedNumberingPlan()) {
    if (options.v2) {
      throw new ParseError('INVALID_COUNTRY');
    }

    return {};
  } // Validate national (significant) number length.


  if (!nationalNumber || nationalNumber.length < MIN_LENGTH_FOR_NSN) {
    // Won't throw here because the regexp already demands length > 1.

    /* istanbul ignore if */
    if (options.v2) {
      throw new ParseError('TOO_SHORT');
    } // Google's demo just throws an error in this case.


    return {};
  } // Validate national (significant) number length.
  //
  // A sidenote:
  //
  // They say that sometimes national (significant) numbers
  // can be longer than `MAX_LENGTH_FOR_NSN` (e.g. in Germany).
  // https://github.com/googlei18n/libphonenumber/blob/7e1748645552da39c4e1ba731e47969d97bdb539/resources/phonenumber.proto#L36
  // Such numbers will just be discarded.
  //


  if (nationalNumber.length > MAX_LENGTH_FOR_NSN) {
    if (options.v2) {
      throw new ParseError('TOO_LONG');
    } // Google's demo just throws an error in this case.


    return {};
  }

  if (options.v2) {
    var phoneNumber = new PhoneNumber(countryCallingCode, nationalNumber, metadata.metadata);

    if (country) {
      phoneNumber.country = country;
    }

    if (carrierCode) {
      phoneNumber.carrierCode = carrierCode;
    }

    if (ext) {
      phoneNumber.ext = ext;
    }

    phoneNumber.__countryCallingCodeSource = countryCallingCodeSource;
    return phoneNumber;
  } // Check if national phone number pattern matches the number.
  // National number pattern is different for each country,
  // even for those ones which are part of the "NANPA" group.


  var valid = (options.extended ? metadata.hasSelectedNumberingPlan() : country) ? matchesEntirely(nationalNumber, metadata.nationalNumberPattern()) : false;

  if (!options.extended) {
    return valid ? result(country, nationalNumber, ext) : {};
  } // isInternational: countryCallingCode !== undefined


  return {
    country: country,
    countryCallingCode: countryCallingCode,
    carrierCode: carrierCode,
    valid: valid,
    possible: valid ? true : options.extended === true && metadata.possibleLengths() && isPossibleNumber(nationalNumber, metadata) ? true : false,
    phone: nationalNumber,
    ext: ext
  };
}
/**
 * Extracts a formatted phone number from text.
 * Doesn't guarantee that the extracted phone number
 * is a valid phone number (for example, doesn't validate its length).
 * @param  {string} text
 * @param  {boolean} [extract] — If `false`, then will parse the entire `text` as a phone number.
 * @param  {boolean} [throwOnError] — By default, it won't throw if the text is too long.
 * @return {string}
 * @example
 * // Returns "(213) 373-4253".
 * extractFormattedPhoneNumber("Call (213) 373-4253 for assistance.")
 */

function _extractFormattedPhoneNumber(text, extract, throwOnError) {
  if (!text) {
    return;
  }

  if (text.length > MAX_INPUT_STRING_LENGTH) {
    if (throwOnError) {
      throw new ParseError('TOO_LONG');
    }

    return;
  }

  if (extract === false) {
    return text;
  } // Attempt to extract a possible number from the string passed in


  var startsAt = text.search(PHONE_NUMBER_START_PATTERN);

  if (startsAt < 0) {
    return;
  }

  return text // Trim everything to the left of the phone number
  .slice(startsAt) // Remove trailing non-numerical characters
  .replace(AFTER_PHONE_NUMBER_END_PATTERN, '');
}
/**
 * @param  {string} text - Input.
 * @param  {boolean} v2 - Legacy API functions don't pass `v2: true` flag.
 * @param  {boolean} [extract] - Whether to extract a phone number from `text`, or attempt to parse the entire text as a phone number.
 * @return {object} `{ ?number, ?ext }`.
 */


function parseInput(text, v2, extract) {
  // // Parse RFC 3966 phone number URI.
  // if (text && text.indexOf('tel:') === 0) {
  // 	return parseRFC3966(text)
  // }
  // let number = extractFormattedPhoneNumber(text, extract, v2)
  var number = extractFormattedPhoneNumberFromPossibleRfc3966NumberUri(text, {
    extractFormattedPhoneNumber: function extractFormattedPhoneNumber(text) {
      return _extractFormattedPhoneNumber(text, extract, v2);
    }
  }); // If the phone number is not viable, then abort.

  if (!number) {
    return {};
  }

  if (!isViablePhoneNumber(number)) {
    if (isViablePhoneNumberStart(number)) {
      return {
        error: 'TOO_SHORT'
      };
    }

    return {};
  } // Attempt to parse extension first, since it doesn't require region-specific
  // data and we want to have the non-normalised number here.


  var withExtensionStripped = extractExtension(number);

  if (withExtensionStripped.ext) {
    return withExtensionStripped;
  }

  return {
    number: number
  };
}
/**
 * Creates `parse()` result object.
 */


function result(country, nationalNumber, ext) {
  var result = {
    country: country,
    phone: nationalNumber
  };

  if (ext) {
    result.ext = ext;
  }

  return result;
}
/**
 * Parses a viable phone number.
 * @param {string} formattedPhoneNumber — Example: "(213) 373-4253".
 * @param {string} [defaultCountry]
 * @param {string} [defaultCallingCode]
 * @param {Metadata} metadata
 * @return {object} Returns `{ country: string?, countryCallingCode: string?, nationalNumber: string? }`.
 */


function parsePhoneNumber$3(formattedPhoneNumber, defaultCountry, defaultCallingCode, metadata) {
  // Extract calling code from phone number.
  var _extractCountryCallin = extractCountryCallingCode(parseIncompletePhoneNumber(formattedPhoneNumber), defaultCountry, defaultCallingCode, metadata.metadata),
      countryCallingCodeSource = _extractCountryCallin.countryCallingCodeSource,
      countryCallingCode = _extractCountryCallin.countryCallingCode,
      number = _extractCountryCallin.number; // Choose a country by `countryCallingCode`.


  var country;

  if (countryCallingCode) {
    metadata.selectNumberingPlan(countryCallingCode);
  } // If `formattedPhoneNumber` is passed in "national" format
  // then `number` is defined and `countryCallingCode` is `undefined`.
  else if (number && (defaultCountry || defaultCallingCode)) {
    metadata.selectNumberingPlan(defaultCountry, defaultCallingCode);

    if (defaultCountry) {
      country = defaultCountry;
    }

    countryCallingCode = defaultCallingCode || getCountryCallingCode(defaultCountry, metadata.metadata);
  } else return {};

  if (!number) {
    return {
      countryCallingCodeSource: countryCallingCodeSource,
      countryCallingCode: countryCallingCode
    };
  }

  var _extractNationalNumbe = extractNationalNumber(parseIncompletePhoneNumber(number), metadata),
      nationalNumber = _extractNationalNumbe.nationalNumber,
      carrierCode = _extractNationalNumbe.carrierCode; // Sometimes there are several countries
  // corresponding to the same country phone code
  // (e.g. NANPA countries all having `1` country phone code).
  // Therefore, to reliably determine the exact country,
  // national (significant) number should have been parsed first.
  //
  // When `metadata.json` is generated, all "ambiguous" country phone codes
  // get their countries populated with the full set of
  // "phone number type" regular expressions.
  //


  var exactCountry = getCountryByCallingCode(countryCallingCode, {
    nationalNumber: nationalNumber,
    metadata: metadata
  });

  if (exactCountry) {
    country = exactCountry;
    /* istanbul ignore if */

    if (exactCountry === '001') ; else {
      metadata.country(country);
    }
  }

  return {
    country: country,
    countryCallingCode: countryCallingCode,
    countryCallingCodeSource: countryCallingCodeSource,
    nationalNumber: nationalNumber,
    carrierCode: carrierCode
  };
}

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2(Object(source), true).forEach(function (key) { _defineProperty$2(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$2(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function parsePhoneNumberWithError(text, options, metadata) {
  return parse(text, _objectSpread$2(_objectSpread$2({}, options), {}, {
    v2: true
  }), metadata);
}

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1(Object(source), true).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$1(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
// * input `text`
// * `options` object
// * `metadata` JSON

function normalizeArguments(args) {
  var _Array$prototype$slic = Array.prototype.slice.call(args),
      _Array$prototype$slic2 = _slicedToArray(_Array$prototype$slic, 4),
      arg_1 = _Array$prototype$slic2[0],
      arg_2 = _Array$prototype$slic2[1],
      arg_3 = _Array$prototype$slic2[2],
      arg_4 = _Array$prototype$slic2[3];

  var text;
  var options;
  var metadata; // If the phone number is passed as a string.
  // `parsePhoneNumber('88005553535', ...)`.

  if (typeof arg_1 === 'string') {
    text = arg_1;
  } else throw new TypeError('A text for parsing must be a string.'); // If "default country" argument is being passed then move it to `options`.
  // `parsePhoneNumber('88005553535', 'RU', [options], metadata)`.


  if (!arg_2 || typeof arg_2 === 'string') {
    if (arg_4) {
      options = arg_3;
      metadata = arg_4;
    } else {
      options = undefined;
      metadata = arg_3;
    }

    if (arg_2) {
      options = _objectSpread$1({
        defaultCountry: arg_2
      }, options);
    }
  } // `defaultCountry` is not passed.
  // Example: `parsePhoneNumber('+78005553535', [options], metadata)`.
  else if (isObject(arg_2)) {
    if (arg_3) {
      options = arg_2;
      metadata = arg_3;
    } else {
      metadata = arg_2;
    }
  } else throw new Error("Invalid second argument: ".concat(arg_2));

  return {
    text: text,
    options: options,
    metadata: metadata
  };
}

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function parsePhoneNumber$2(text, options, metadata) {
  // Validate `defaultCountry`.
  if (options && options.defaultCountry && !isSupportedCountry(options.defaultCountry, metadata)) {
    options = _objectSpread(_objectSpread({}, options), {}, {
      defaultCountry: undefined
    });
  } // Parse phone number.


  try {
    return parsePhoneNumberWithError(text, options, metadata);
  } catch (error) {
    /* istanbul ignore else */
    if (error instanceof ParseError) ; else {
      throw error;
    }
  }
}

function parsePhoneNumber$1() {
  var _normalizeArguments = normalizeArguments(arguments),
      text = _normalizeArguments.text,
      options = _normalizeArguments.options,
      metadata = _normalizeArguments.metadata;

  return parsePhoneNumber$2(text, options, metadata);
}

function parsePhoneNumber() {
	return withMetadataArgument(parsePhoneNumber$1, arguments)
}

var util;
(function (util) {
    util.assertEqual = (val) => val;
    function assertIs(_arg) { }
    util.assertIs = assertIs;
    function assertNever(_x) {
        throw new Error();
    }
    util.assertNever = assertNever;
    util.arrayToEnum = (items) => {
        const obj = {};
        for (const item of items) {
            obj[item] = item;
        }
        return obj;
    };
    util.getValidEnumValues = (obj) => {
        const validKeys = util.objectKeys(obj).filter((k) => typeof obj[obj[k]] !== "number");
        const filtered = {};
        for (const k of validKeys) {
            filtered[k] = obj[k];
        }
        return util.objectValues(filtered);
    };
    util.objectValues = (obj) => {
        return util.objectKeys(obj).map(function (e) {
            return obj[e];
        });
    };
    util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
        ? (obj) => Object.keys(obj) // eslint-disable-line ban/ban
        : (object) => {
            const keys = [];
            for (const key in object) {
                if (Object.prototype.hasOwnProperty.call(object, key)) {
                    keys.push(key);
                }
            }
            return keys;
        };
    util.find = (arr, checker) => {
        for (const item of arr) {
            if (checker(item))
                return item;
        }
        return undefined;
    };
    util.isInteger = typeof Number.isInteger === "function"
        ? (val) => Number.isInteger(val) // eslint-disable-line ban/ban
        : (val) => typeof val === "number" && isFinite(val) && Math.floor(val) === val;
    function joinValues(array, separator = " | ") {
        return array
            .map((val) => (typeof val === "string" ? `'${val}'` : val))
            .join(separator);
    }
    util.joinValues = joinValues;
    util.jsonStringifyReplacer = (_, value) => {
        if (typeof value === "bigint") {
            return value.toString();
        }
        return value;
    };
})(util || (util = {}));
var objectUtil;
(function (objectUtil) {
    objectUtil.mergeShapes = (first, second) => {
        return {
            ...first,
            ...second, // second overwrites first
        };
    };
})(objectUtil || (objectUtil = {}));
const ZodParsedType = util.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set",
]);
const getParsedType = (data) => {
    const t = typeof data;
    switch (t) {
        case "undefined":
            return ZodParsedType.undefined;
        case "string":
            return ZodParsedType.string;
        case "number":
            return isNaN(data) ? ZodParsedType.nan : ZodParsedType.number;
        case "boolean":
            return ZodParsedType.boolean;
        case "function":
            return ZodParsedType.function;
        case "bigint":
            return ZodParsedType.bigint;
        case "symbol":
            return ZodParsedType.symbol;
        case "object":
            if (Array.isArray(data)) {
                return ZodParsedType.array;
            }
            if (data === null) {
                return ZodParsedType.null;
            }
            if (data.then &&
                typeof data.then === "function" &&
                data.catch &&
                typeof data.catch === "function") {
                return ZodParsedType.promise;
            }
            if (typeof Map !== "undefined" && data instanceof Map) {
                return ZodParsedType.map;
            }
            if (typeof Set !== "undefined" && data instanceof Set) {
                return ZodParsedType.set;
            }
            if (typeof Date !== "undefined" && data instanceof Date) {
                return ZodParsedType.date;
            }
            return ZodParsedType.object;
        default:
            return ZodParsedType.unknown;
    }
};

const ZodIssueCode = util.arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite",
]);
const quotelessJson = (obj) => {
    const json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
};
class ZodError extends Error {
    get errors() {
        return this.issues;
    }
    constructor(issues) {
        super();
        this.issues = [];
        this.addIssue = (sub) => {
            this.issues = [...this.issues, sub];
        };
        this.addIssues = (subs = []) => {
            this.issues = [...this.issues, ...subs];
        };
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) {
            // eslint-disable-next-line ban/ban
            Object.setPrototypeOf(this, actualProto);
        }
        else {
            this.__proto__ = actualProto;
        }
        this.name = "ZodError";
        this.issues = issues;
    }
    format(_mapper) {
        const mapper = _mapper ||
            function (issue) {
                return issue.message;
            };
        const fieldErrors = { _errors: [] };
        const processError = (error) => {
            for (const issue of error.issues) {
                if (issue.code === "invalid_union") {
                    issue.unionErrors.map(processError);
                }
                else if (issue.code === "invalid_return_type") {
                    processError(issue.returnTypeError);
                }
                else if (issue.code === "invalid_arguments") {
                    processError(issue.argumentsError);
                }
                else if (issue.path.length === 0) {
                    fieldErrors._errors.push(mapper(issue));
                }
                else {
                    let curr = fieldErrors;
                    let i = 0;
                    while (i < issue.path.length) {
                        const el = issue.path[i];
                        const terminal = i === issue.path.length - 1;
                        if (!terminal) {
                            curr[el] = curr[el] || { _errors: [] };
                            // if (typeof el === "string") {
                            //   curr[el] = curr[el] || { _errors: [] };
                            // } else if (typeof el === "number") {
                            //   const errorArray: any = [];
                            //   errorArray._errors = [];
                            //   curr[el] = curr[el] || errorArray;
                            // }
                        }
                        else {
                            curr[el] = curr[el] || { _errors: [] };
                            curr[el]._errors.push(mapper(issue));
                        }
                        curr = curr[el];
                        i++;
                    }
                }
            }
        };
        processError(this);
        return fieldErrors;
    }
    static assert(value) {
        if (!(value instanceof ZodError)) {
            throw new Error(`Not a ZodError: ${value}`);
        }
    }
    toString() {
        return this.message;
    }
    get message() {
        return JSON.stringify(this.issues, util.jsonStringifyReplacer, 2);
    }
    get isEmpty() {
        return this.issues.length === 0;
    }
    flatten(mapper = (issue) => issue.message) {
        const fieldErrors = {};
        const formErrors = [];
        for (const sub of this.issues) {
            if (sub.path.length > 0) {
                fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
                fieldErrors[sub.path[0]].push(mapper(sub));
            }
            else {
                formErrors.push(mapper(sub));
            }
        }
        return { formErrors, fieldErrors };
    }
    get formErrors() {
        return this.flatten();
    }
}
ZodError.create = (issues) => {
    const error = new ZodError(issues);
    return error;
};

const errorMap = (issue, _ctx) => {
    let message;
    switch (issue.code) {
        case ZodIssueCode.invalid_type:
            if (issue.received === ZodParsedType.undefined) {
                message = "Required";
            }
            else {
                message = `Expected ${issue.expected}, received ${issue.received}`;
            }
            break;
        case ZodIssueCode.invalid_literal:
            message = `Invalid literal value, expected ${JSON.stringify(issue.expected, util.jsonStringifyReplacer)}`;
            break;
        case ZodIssueCode.unrecognized_keys:
            message = `Unrecognized key(s) in object: ${util.joinValues(issue.keys, ", ")}`;
            break;
        case ZodIssueCode.invalid_union:
            message = `Invalid input`;
            break;
        case ZodIssueCode.invalid_union_discriminator:
            message = `Invalid discriminator value. Expected ${util.joinValues(issue.options)}`;
            break;
        case ZodIssueCode.invalid_enum_value:
            message = `Invalid enum value. Expected ${util.joinValues(issue.options)}, received '${issue.received}'`;
            break;
        case ZodIssueCode.invalid_arguments:
            message = `Invalid function arguments`;
            break;
        case ZodIssueCode.invalid_return_type:
            message = `Invalid function return type`;
            break;
        case ZodIssueCode.invalid_date:
            message = `Invalid date`;
            break;
        case ZodIssueCode.invalid_string:
            if (typeof issue.validation === "object") {
                if ("includes" in issue.validation) {
                    message = `Invalid input: must include "${issue.validation.includes}"`;
                    if (typeof issue.validation.position === "number") {
                        message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
                    }
                }
                else if ("startsWith" in issue.validation) {
                    message = `Invalid input: must start with "${issue.validation.startsWith}"`;
                }
                else if ("endsWith" in issue.validation) {
                    message = `Invalid input: must end with "${issue.validation.endsWith}"`;
                }
                else {
                    util.assertNever(issue.validation);
                }
            }
            else if (issue.validation !== "regex") {
                message = `Invalid ${issue.validation}`;
            }
            else {
                message = "Invalid";
            }
            break;
        case ZodIssueCode.too_small:
            if (issue.type === "array")
                message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
            else if (issue.type === "string")
                message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
            else if (issue.type === "number")
                message = `Number must be ${issue.exact
                    ? `exactly equal to `
                    : issue.inclusive
                        ? `greater than or equal to `
                        : `greater than `}${issue.minimum}`;
            else if (issue.type === "date")
                message = `Date must be ${issue.exact
                    ? `exactly equal to `
                    : issue.inclusive
                        ? `greater than or equal to `
                        : `greater than `}${new Date(Number(issue.minimum))}`;
            else
                message = "Invalid input";
            break;
        case ZodIssueCode.too_big:
            if (issue.type === "array")
                message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
            else if (issue.type === "string")
                message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
            else if (issue.type === "number")
                message = `Number must be ${issue.exact
                    ? `exactly`
                    : issue.inclusive
                        ? `less than or equal to`
                        : `less than`} ${issue.maximum}`;
            else if (issue.type === "bigint")
                message = `BigInt must be ${issue.exact
                    ? `exactly`
                    : issue.inclusive
                        ? `less than or equal to`
                        : `less than`} ${issue.maximum}`;
            else if (issue.type === "date")
                message = `Date must be ${issue.exact
                    ? `exactly`
                    : issue.inclusive
                        ? `smaller than or equal to`
                        : `smaller than`} ${new Date(Number(issue.maximum))}`;
            else
                message = "Invalid input";
            break;
        case ZodIssueCode.custom:
            message = `Invalid input`;
            break;
        case ZodIssueCode.invalid_intersection_types:
            message = `Intersection results could not be merged`;
            break;
        case ZodIssueCode.not_multiple_of:
            message = `Number must be a multiple of ${issue.multipleOf}`;
            break;
        case ZodIssueCode.not_finite:
            message = "Number must be finite";
            break;
        default:
            message = _ctx.defaultError;
            util.assertNever(issue);
    }
    return { message };
};

let overrideErrorMap = errorMap;
function setErrorMap(map) {
    overrideErrorMap = map;
}
function getErrorMap() {
    return overrideErrorMap;
}

const makeIssue = (params) => {
    const { data, path, errorMaps, issueData } = params;
    const fullPath = [...path, ...(issueData.path || [])];
    const fullIssue = {
        ...issueData,
        path: fullPath,
    };
    if (issueData.message !== undefined) {
        return {
            ...issueData,
            path: fullPath,
            message: issueData.message,
        };
    }
    let errorMessage = "";
    const maps = errorMaps
        .filter((m) => !!m)
        .slice()
        .reverse();
    for (const map of maps) {
        errorMessage = map(fullIssue, { data, defaultError: errorMessage }).message;
    }
    return {
        ...issueData,
        path: fullPath,
        message: errorMessage,
    };
};
const EMPTY_PATH = [];
function addIssueToContext(ctx, issueData) {
    const overrideMap = getErrorMap();
    const issue = makeIssue({
        issueData: issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
            ctx.common.contextualErrorMap, // contextual error map is first priority
            ctx.schemaErrorMap, // then schema-bound map if available
            overrideMap, // then global override map
            overrideMap === errorMap ? undefined : errorMap, // then global default map
        ].filter((x) => !!x),
    });
    ctx.common.issues.push(issue);
}
class ParseStatus {
    constructor() {
        this.value = "valid";
    }
    dirty() {
        if (this.value === "valid")
            this.value = "dirty";
    }
    abort() {
        if (this.value !== "aborted")
            this.value = "aborted";
    }
    static mergeArray(status, results) {
        const arrayValue = [];
        for (const s of results) {
            if (s.status === "aborted")
                return INVALID;
            if (s.status === "dirty")
                status.dirty();
            arrayValue.push(s.value);
        }
        return { status: status.value, value: arrayValue };
    }
    static async mergeObjectAsync(status, pairs) {
        const syncPairs = [];
        for (const pair of pairs) {
            const key = await pair.key;
            const value = await pair.value;
            syncPairs.push({
                key,
                value,
            });
        }
        return ParseStatus.mergeObjectSync(status, syncPairs);
    }
    static mergeObjectSync(status, pairs) {
        const finalObject = {};
        for (const pair of pairs) {
            const { key, value } = pair;
            if (key.status === "aborted")
                return INVALID;
            if (value.status === "aborted")
                return INVALID;
            if (key.status === "dirty")
                status.dirty();
            if (value.status === "dirty")
                status.dirty();
            if (key.value !== "__proto__" &&
                (typeof value.value !== "undefined" || pair.alwaysSet)) {
                finalObject[key.value] = value.value;
            }
        }
        return { status: status.value, value: finalObject };
    }
}
const INVALID = Object.freeze({
    status: "aborted",
});
const DIRTY = (value) => ({ status: "dirty", value });
const OK = (value) => ({ status: "valid", value });
const isAborted = (x) => x.status === "aborted";
const isDirty = (x) => x.status === "dirty";
const isValid = (x) => x.status === "valid";
const isAsync = (x) => typeof Promise !== "undefined" && x instanceof Promise;

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (typeof state === "function" ? receiver !== state || true : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (typeof state === "function" ? receiver !== state || true : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (state.set(receiver, value)), value;
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var errorUtil;
(function (errorUtil) {
    errorUtil.errToObj = (message) => typeof message === "string" ? { message } : message || {};
    errorUtil.toString = (message) => typeof message === "string" ? message : message === null || message === void 0 ? void 0 : message.message;
})(errorUtil || (errorUtil = {}));

var _ZodEnum_cache, _ZodNativeEnum_cache;
class ParseInputLazyPath {
    constructor(parent, value, path, key) {
        this._cachedPath = [];
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
    }
    get path() {
        if (!this._cachedPath.length) {
            if (this._key instanceof Array) {
                this._cachedPath.push(...this._path, ...this._key);
            }
            else {
                this._cachedPath.push(...this._path, this._key);
            }
        }
        return this._cachedPath;
    }
}
const handleResult = (ctx, result) => {
    if (isValid(result)) {
        return { success: true, data: result.value };
    }
    else {
        if (!ctx.common.issues.length) {
            throw new Error("Validation failed but no issues detected.");
        }
        return {
            success: false,
            get error() {
                if (this._error)
                    return this._error;
                const error = new ZodError(ctx.common.issues);
                this._error = error;
                return this._error;
            },
        };
    }
};
function processCreateParams(params) {
    if (!params)
        return {};
    const { errorMap, invalid_type_error, required_error, description } = params;
    if (errorMap && (invalid_type_error || required_error)) {
        throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    }
    if (errorMap)
        return { errorMap: errorMap, description };
    const customMap = (iss, ctx) => {
        var _a, _b;
        const { message } = params;
        if (iss.code === "invalid_enum_value") {
            return { message: message !== null && message !== void 0 ? message : ctx.defaultError };
        }
        if (typeof ctx.data === "undefined") {
            return { message: (_a = message !== null && message !== void 0 ? message : required_error) !== null && _a !== void 0 ? _a : ctx.defaultError };
        }
        if (iss.code !== "invalid_type")
            return { message: ctx.defaultError };
        return { message: (_b = message !== null && message !== void 0 ? message : invalid_type_error) !== null && _b !== void 0 ? _b : ctx.defaultError };
    };
    return { errorMap: customMap, description };
}
class ZodType {
    get description() {
        return this._def.description;
    }
    _getType(input) {
        return getParsedType(input.data);
    }
    _getOrReturnCtx(input, ctx) {
        return (ctx || {
            common: input.parent.common,
            data: input.data,
            parsedType: getParsedType(input.data),
            schemaErrorMap: this._def.errorMap,
            path: input.path,
            parent: input.parent,
        });
    }
    _processInputParams(input) {
        return {
            status: new ParseStatus(),
            ctx: {
                common: input.parent.common,
                data: input.data,
                parsedType: getParsedType(input.data),
                schemaErrorMap: this._def.errorMap,
                path: input.path,
                parent: input.parent,
            },
        };
    }
    _parseSync(input) {
        const result = this._parse(input);
        if (isAsync(result)) {
            throw new Error("Synchronous parse encountered promise.");
        }
        return result;
    }
    _parseAsync(input) {
        const result = this._parse(input);
        return Promise.resolve(result);
    }
    parse(data, params) {
        const result = this.safeParse(data, params);
        if (result.success)
            return result.data;
        throw result.error;
    }
    safeParse(data, params) {
        var _a;
        const ctx = {
            common: {
                issues: [],
                async: (_a = params === null || params === void 0 ? void 0 : params.async) !== null && _a !== void 0 ? _a : false,
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data,
            parsedType: getParsedType(data),
        };
        const result = this._parseSync({ data, path: ctx.path, parent: ctx });
        return handleResult(ctx, result);
    }
    "~validate"(data) {
        var _a, _b;
        const ctx = {
            common: {
                issues: [],
                async: !!this["~standard"].async,
            },
            path: [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data,
            parsedType: getParsedType(data),
        };
        if (!this["~standard"].async) {
            try {
                const result = this._parseSync({ data, path: [], parent: ctx });
                return isValid(result)
                    ? {
                        value: result.value,
                    }
                    : {
                        issues: ctx.common.issues,
                    };
            }
            catch (err) {
                if ((_b = (_a = err === null || err === void 0 ? void 0 : err.message) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === null || _b === void 0 ? void 0 : _b.includes("encountered")) {
                    this["~standard"].async = true;
                }
                ctx.common = {
                    issues: [],
                    async: true,
                };
            }
        }
        return this._parseAsync({ data, path: [], parent: ctx }).then((result) => isValid(result)
            ? {
                value: result.value,
            }
            : {
                issues: ctx.common.issues,
            });
    }
    async parseAsync(data, params) {
        const result = await this.safeParseAsync(data, params);
        if (result.success)
            return result.data;
        throw result.error;
    }
    async safeParseAsync(data, params) {
        const ctx = {
            common: {
                issues: [],
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
                async: true,
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data,
            parsedType: getParsedType(data),
        };
        const maybeAsyncResult = this._parse({ data, path: ctx.path, parent: ctx });
        const result = await (isAsync(maybeAsyncResult)
            ? maybeAsyncResult
            : Promise.resolve(maybeAsyncResult));
        return handleResult(ctx, result);
    }
    refine(check, message) {
        const getIssueProperties = (val) => {
            if (typeof message === "string" || typeof message === "undefined") {
                return { message };
            }
            else if (typeof message === "function") {
                return message(val);
            }
            else {
                return message;
            }
        };
        return this._refinement((val, ctx) => {
            const result = check(val);
            const setError = () => ctx.addIssue({
                code: ZodIssueCode.custom,
                ...getIssueProperties(val),
            });
            if (typeof Promise !== "undefined" && result instanceof Promise) {
                return result.then((data) => {
                    if (!data) {
                        setError();
                        return false;
                    }
                    else {
                        return true;
                    }
                });
            }
            if (!result) {
                setError();
                return false;
            }
            else {
                return true;
            }
        });
    }
    refinement(check, refinementData) {
        return this._refinement((val, ctx) => {
            if (!check(val)) {
                ctx.addIssue(typeof refinementData === "function"
                    ? refinementData(val, ctx)
                    : refinementData);
                return false;
            }
            else {
                return true;
            }
        });
    }
    _refinement(refinement) {
        return new ZodEffects({
            schema: this,
            typeName: ZodFirstPartyTypeKind.ZodEffects,
            effect: { type: "refinement", refinement },
        });
    }
    superRefine(refinement) {
        return this._refinement(refinement);
    }
    constructor(def) {
        /** Alias of safeParseAsync */
        this.spa = this.safeParseAsync;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.brand = this.brand.bind(this);
        this.default = this.default.bind(this);
        this.catch = this.catch.bind(this);
        this.describe = this.describe.bind(this);
        this.pipe = this.pipe.bind(this);
        this.readonly = this.readonly.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
        this["~standard"] = {
            version: 1,
            vendor: "zod",
            validate: (data) => this["~validate"](data),
        };
    }
    optional() {
        return ZodOptional.create(this, this._def);
    }
    nullable() {
        return ZodNullable.create(this, this._def);
    }
    nullish() {
        return this.nullable().optional();
    }
    array() {
        return ZodArray.create(this);
    }
    promise() {
        return ZodPromise.create(this, this._def);
    }
    or(option) {
        return ZodUnion.create([this, option], this._def);
    }
    and(incoming) {
        return ZodIntersection.create(this, incoming, this._def);
    }
    transform(transform) {
        return new ZodEffects({
            ...processCreateParams(this._def),
            schema: this,
            typeName: ZodFirstPartyTypeKind.ZodEffects,
            effect: { type: "transform", transform },
        });
    }
    default(def) {
        const defaultValueFunc = typeof def === "function" ? def : () => def;
        return new ZodDefault({
            ...processCreateParams(this._def),
            innerType: this,
            defaultValue: defaultValueFunc,
            typeName: ZodFirstPartyTypeKind.ZodDefault,
        });
    }
    brand() {
        return new ZodBranded({
            typeName: ZodFirstPartyTypeKind.ZodBranded,
            type: this,
            ...processCreateParams(this._def),
        });
    }
    catch(def) {
        const catchValueFunc = typeof def === "function" ? def : () => def;
        return new ZodCatch({
            ...processCreateParams(this._def),
            innerType: this,
            catchValue: catchValueFunc,
            typeName: ZodFirstPartyTypeKind.ZodCatch,
        });
    }
    describe(description) {
        const This = this.constructor;
        return new This({
            ...this._def,
            description,
        });
    }
    pipe(target) {
        return ZodPipeline.create(this, target);
    }
    readonly() {
        return ZodReadonly.create(this);
    }
    isOptional() {
        return this.safeParse(undefined).success;
    }
    isNullable() {
        return this.safeParse(null).success;
    }
}
const cuidRegex = /^c[^\s-]{8,}$/i;
const cuid2Regex = /^[0-9a-z]+$/;
const ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/i;
// const uuidRegex =
//   /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
const uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
const nanoidRegex = /^[a-z0-9_-]{21}$/i;
const jwtRegex = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/;
const durationRegex = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/;
// from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
//old email regex
// const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i;
// eslint-disable-next-line
// const emailRegex =
//   /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/;
// const emailRegex =
//   /^[a-zA-Z0-9\.\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// const emailRegex =
//   /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
const emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
// const emailRegex =
//   /^[a-z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9\-]+)*$/i;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
const _emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
let emojiRegex;
// faster, simpler, safer
const ipv4Regex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/;
const ipv4CidrRegex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/;
// const ipv6Regex =
// /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
const ipv6Regex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/;
const ipv6CidrRegex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/;
// https://stackoverflow.com/questions/7860392/determine-if-string-is-in-base64-using-javascript
const base64Regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
// https://base64.guru/standards/base64url
const base64urlRegex = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/;
// simple
// const dateRegexSource = `\\d{4}-\\d{2}-\\d{2}`;
// no leap year validation
// const dateRegexSource = `\\d{4}-((0[13578]|10|12)-31|(0[13-9]|1[0-2])-30|(0[1-9]|1[0-2])-(0[1-9]|1\\d|2\\d))`;
// with leap year validation
const dateRegexSource = `((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))`;
const dateRegex = new RegExp(`^${dateRegexSource}$`);
function timeRegexSource(args) {
    // let regex = `\\d{2}:\\d{2}:\\d{2}`;
    let regex = `([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d`;
    if (args.precision) {
        regex = `${regex}\\.\\d{${args.precision}}`;
    }
    else if (args.precision == null) {
        regex = `${regex}(\\.\\d+)?`;
    }
    return regex;
}
function timeRegex(args) {
    return new RegExp(`^${timeRegexSource(args)}$`);
}
// Adapted from https://stackoverflow.com/a/3143231
function datetimeRegex(args) {
    let regex = `${dateRegexSource}T${timeRegexSource(args)}`;
    const opts = [];
    opts.push(args.local ? `Z?` : `Z`);
    if (args.offset)
        opts.push(`([+-]\\d{2}:?\\d{2})`);
    regex = `${regex}(${opts.join("|")})`;
    return new RegExp(`^${regex}$`);
}
function isValidIP(ip, version) {
    if ((version === "v4" || !version) && ipv4Regex.test(ip)) {
        return true;
    }
    if ((version === "v6" || !version) && ipv6Regex.test(ip)) {
        return true;
    }
    return false;
}
function isValidJWT(jwt, alg) {
    if (!jwtRegex.test(jwt))
        return false;
    try {
        const [header] = jwt.split(".");
        // Convert base64url to base64
        const base64 = header
            .replace(/-/g, "+")
            .replace(/_/g, "/")
            .padEnd(header.length + ((4 - (header.length % 4)) % 4), "=");
        const decoded = JSON.parse(atob(base64));
        if (typeof decoded !== "object" || decoded === null)
            return false;
        if (!decoded.typ || !decoded.alg)
            return false;
        if (alg && decoded.alg !== alg)
            return false;
        return true;
    }
    catch (_a) {
        return false;
    }
}
function isValidCidr(ip, version) {
    if ((version === "v4" || !version) && ipv4CidrRegex.test(ip)) {
        return true;
    }
    if ((version === "v6" || !version) && ipv6CidrRegex.test(ip)) {
        return true;
    }
    return false;
}
class ZodString extends ZodType {
    _parse(input) {
        if (this._def.coerce) {
            input.data = String(input.data);
        }
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.string) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.string,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        const status = new ParseStatus();
        let ctx = undefined;
        for (const check of this._def.checks) {
            if (check.kind === "min") {
                if (input.data.length < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "max") {
                if (input.data.length > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "length") {
                const tooBig = input.data.length > check.value;
                const tooSmall = input.data.length < check.value;
                if (tooBig || tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    if (tooBig) {
                        addIssueToContext(ctx, {
                            code: ZodIssueCode.too_big,
                            maximum: check.value,
                            type: "string",
                            inclusive: true,
                            exact: true,
                            message: check.message,
                        });
                    }
                    else if (tooSmall) {
                        addIssueToContext(ctx, {
                            code: ZodIssueCode.too_small,
                            minimum: check.value,
                            type: "string",
                            inclusive: true,
                            exact: true,
                            message: check.message,
                        });
                    }
                    status.dirty();
                }
            }
            else if (check.kind === "email") {
                if (!emailRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "email",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "emoji") {
                if (!emojiRegex) {
                    emojiRegex = new RegExp(_emojiRegex, "u");
                }
                if (!emojiRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "emoji",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "uuid") {
                if (!uuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "uuid",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "nanoid") {
                if (!nanoidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "nanoid",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "cuid") {
                if (!cuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "cuid",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "cuid2") {
                if (!cuid2Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "cuid2",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "ulid") {
                if (!ulidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "ulid",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "url") {
                try {
                    new URL(input.data);
                }
                catch (_a) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "url",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "regex") {
                check.regex.lastIndex = 0;
                const testResult = check.regex.test(input.data);
                if (!testResult) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "regex",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "trim") {
                input.data = input.data.trim();
            }
            else if (check.kind === "includes") {
                if (!input.data.includes(check.value, check.position)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_string,
                        validation: { includes: check.value, position: check.position },
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "toLowerCase") {
                input.data = input.data.toLowerCase();
            }
            else if (check.kind === "toUpperCase") {
                input.data = input.data.toUpperCase();
            }
            else if (check.kind === "startsWith") {
                if (!input.data.startsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_string,
                        validation: { startsWith: check.value },
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "endsWith") {
                if (!input.data.endsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_string,
                        validation: { endsWith: check.value },
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "datetime") {
                const regex = datetimeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_string,
                        validation: "datetime",
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "date") {
                const regex = dateRegex;
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_string,
                        validation: "date",
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "time") {
                const regex = timeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_string,
                        validation: "time",
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "duration") {
                if (!durationRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "duration",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "ip") {
                if (!isValidIP(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "ip",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "jwt") {
                if (!isValidJWT(input.data, check.alg)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "jwt",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "cidr") {
                if (!isValidCidr(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "cidr",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "base64") {
                if (!base64Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "base64",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "base64url") {
                if (!base64urlRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "base64url",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else {
                util.assertNever(check);
            }
        }
        return { status: status.value, value: input.data };
    }
    _regex(regex, validation, message) {
        return this.refinement((data) => regex.test(data), {
            validation,
            code: ZodIssueCode.invalid_string,
            ...errorUtil.errToObj(message),
        });
    }
    _addCheck(check) {
        return new ZodString({
            ...this._def,
            checks: [...this._def.checks, check],
        });
    }
    email(message) {
        return this._addCheck({ kind: "email", ...errorUtil.errToObj(message) });
    }
    url(message) {
        return this._addCheck({ kind: "url", ...errorUtil.errToObj(message) });
    }
    emoji(message) {
        return this._addCheck({ kind: "emoji", ...errorUtil.errToObj(message) });
    }
    uuid(message) {
        return this._addCheck({ kind: "uuid", ...errorUtil.errToObj(message) });
    }
    nanoid(message) {
        return this._addCheck({ kind: "nanoid", ...errorUtil.errToObj(message) });
    }
    cuid(message) {
        return this._addCheck({ kind: "cuid", ...errorUtil.errToObj(message) });
    }
    cuid2(message) {
        return this._addCheck({ kind: "cuid2", ...errorUtil.errToObj(message) });
    }
    ulid(message) {
        return this._addCheck({ kind: "ulid", ...errorUtil.errToObj(message) });
    }
    base64(message) {
        return this._addCheck({ kind: "base64", ...errorUtil.errToObj(message) });
    }
    base64url(message) {
        // base64url encoding is a modification of base64 that can safely be used in URLs and filenames
        return this._addCheck({
            kind: "base64url",
            ...errorUtil.errToObj(message),
        });
    }
    jwt(options) {
        return this._addCheck({ kind: "jwt", ...errorUtil.errToObj(options) });
    }
    ip(options) {
        return this._addCheck({ kind: "ip", ...errorUtil.errToObj(options) });
    }
    cidr(options) {
        return this._addCheck({ kind: "cidr", ...errorUtil.errToObj(options) });
    }
    datetime(options) {
        var _a, _b;
        if (typeof options === "string") {
            return this._addCheck({
                kind: "datetime",
                precision: null,
                offset: false,
                local: false,
                message: options,
            });
        }
        return this._addCheck({
            kind: "datetime",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
            offset: (_a = options === null || options === void 0 ? void 0 : options.offset) !== null && _a !== void 0 ? _a : false,
            local: (_b = options === null || options === void 0 ? void 0 : options.local) !== null && _b !== void 0 ? _b : false,
            ...errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message),
        });
    }
    date(message) {
        return this._addCheck({ kind: "date", message });
    }
    time(options) {
        if (typeof options === "string") {
            return this._addCheck({
                kind: "time",
                precision: null,
                message: options,
            });
        }
        return this._addCheck({
            kind: "time",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
            ...errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message),
        });
    }
    duration(message) {
        return this._addCheck({ kind: "duration", ...errorUtil.errToObj(message) });
    }
    regex(regex, message) {
        return this._addCheck({
            kind: "regex",
            regex: regex,
            ...errorUtil.errToObj(message),
        });
    }
    includes(value, options) {
        return this._addCheck({
            kind: "includes",
            value: value,
            position: options === null || options === void 0 ? void 0 : options.position,
            ...errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message),
        });
    }
    startsWith(value, message) {
        return this._addCheck({
            kind: "startsWith",
            value: value,
            ...errorUtil.errToObj(message),
        });
    }
    endsWith(value, message) {
        return this._addCheck({
            kind: "endsWith",
            value: value,
            ...errorUtil.errToObj(message),
        });
    }
    min(minLength, message) {
        return this._addCheck({
            kind: "min",
            value: minLength,
            ...errorUtil.errToObj(message),
        });
    }
    max(maxLength, message) {
        return this._addCheck({
            kind: "max",
            value: maxLength,
            ...errorUtil.errToObj(message),
        });
    }
    length(len, message) {
        return this._addCheck({
            kind: "length",
            value: len,
            ...errorUtil.errToObj(message),
        });
    }
    /**
     * Equivalent to `.min(1)`
     */
    nonempty(message) {
        return this.min(1, errorUtil.errToObj(message));
    }
    trim() {
        return new ZodString({
            ...this._def,
            checks: [...this._def.checks, { kind: "trim" }],
        });
    }
    toLowerCase() {
        return new ZodString({
            ...this._def,
            checks: [...this._def.checks, { kind: "toLowerCase" }],
        });
    }
    toUpperCase() {
        return new ZodString({
            ...this._def,
            checks: [...this._def.checks, { kind: "toUpperCase" }],
        });
    }
    get isDatetime() {
        return !!this._def.checks.find((ch) => ch.kind === "datetime");
    }
    get isDate() {
        return !!this._def.checks.find((ch) => ch.kind === "date");
    }
    get isTime() {
        return !!this._def.checks.find((ch) => ch.kind === "time");
    }
    get isDuration() {
        return !!this._def.checks.find((ch) => ch.kind === "duration");
    }
    get isEmail() {
        return !!this._def.checks.find((ch) => ch.kind === "email");
    }
    get isURL() {
        return !!this._def.checks.find((ch) => ch.kind === "url");
    }
    get isEmoji() {
        return !!this._def.checks.find((ch) => ch.kind === "emoji");
    }
    get isUUID() {
        return !!this._def.checks.find((ch) => ch.kind === "uuid");
    }
    get isNANOID() {
        return !!this._def.checks.find((ch) => ch.kind === "nanoid");
    }
    get isCUID() {
        return !!this._def.checks.find((ch) => ch.kind === "cuid");
    }
    get isCUID2() {
        return !!this._def.checks.find((ch) => ch.kind === "cuid2");
    }
    get isULID() {
        return !!this._def.checks.find((ch) => ch.kind === "ulid");
    }
    get isIP() {
        return !!this._def.checks.find((ch) => ch.kind === "ip");
    }
    get isCIDR() {
        return !!this._def.checks.find((ch) => ch.kind === "cidr");
    }
    get isBase64() {
        return !!this._def.checks.find((ch) => ch.kind === "base64");
    }
    get isBase64url() {
        // base64url encoding is a modification of base64 that can safely be used in URLs and filenames
        return !!this._def.checks.find((ch) => ch.kind === "base64url");
    }
    get minLength() {
        let min = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "min") {
                if (min === null || ch.value > min)
                    min = ch.value;
            }
        }
        return min;
    }
    get maxLength() {
        let max = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "max") {
                if (max === null || ch.value < max)
                    max = ch.value;
            }
        }
        return max;
    }
}
ZodString.create = (params) => {
    var _a;
    return new ZodString({
        checks: [],
        typeName: ZodFirstPartyTypeKind.ZodString,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...processCreateParams(params),
    });
};
// https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
function floatSafeRemainder(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepDecCount = (step.toString().split(".")[1] || "").length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = parseInt(step.toFixed(decCount).replace(".", ""));
    return (valInt % stepInt) / Math.pow(10, decCount);
}
class ZodNumber extends ZodType {
    constructor() {
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
        this.step = this.multipleOf;
    }
    _parse(input) {
        if (this._def.coerce) {
            input.data = Number(input.data);
        }
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.number) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.number,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        let ctx = undefined;
        const status = new ParseStatus();
        for (const check of this._def.checks) {
            if (check.kind === "int") {
                if (!util.isInteger(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_type,
                        expected: "integer",
                        received: "float",
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "min") {
                const tooSmall = check.inclusive
                    ? input.data < check.value
                    : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_small,
                        minimum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "max") {
                const tooBig = check.inclusive
                    ? input.data > check.value
                    : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_big,
                        maximum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "multipleOf") {
                if (floatSafeRemainder(input.data, check.value) !== 0) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "finite") {
                if (!Number.isFinite(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.not_finite,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else {
                util.assertNever(check);
            }
        }
        return { status: status.value, value: input.data };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new ZodNumber({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind,
                    value,
                    inclusive,
                    message: errorUtil.toString(message),
                },
            ],
        });
    }
    _addCheck(check) {
        return new ZodNumber({
            ...this._def,
            checks: [...this._def.checks, check],
        });
    }
    int(message) {
        return this._addCheck({
            kind: "int",
            message: errorUtil.toString(message),
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: false,
            message: errorUtil.toString(message),
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: false,
            message: errorUtil.toString(message),
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: true,
            message: errorUtil.toString(message),
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: true,
            message: errorUtil.toString(message),
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: errorUtil.toString(message),
        });
    }
    finite(message) {
        return this._addCheck({
            kind: "finite",
            message: errorUtil.toString(message),
        });
    }
    safe(message) {
        return this._addCheck({
            kind: "min",
            inclusive: true,
            value: Number.MIN_SAFE_INTEGER,
            message: errorUtil.toString(message),
        })._addCheck({
            kind: "max",
            inclusive: true,
            value: Number.MAX_SAFE_INTEGER,
            message: errorUtil.toString(message),
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "min") {
                if (min === null || ch.value > min)
                    min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "max") {
                if (max === null || ch.value < max)
                    max = ch.value;
            }
        }
        return max;
    }
    get isInt() {
        return !!this._def.checks.find((ch) => ch.kind === "int" ||
            (ch.kind === "multipleOf" && util.isInteger(ch.value)));
    }
    get isFinite() {
        let max = null, min = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "finite" ||
                ch.kind === "int" ||
                ch.kind === "multipleOf") {
                return true;
            }
            else if (ch.kind === "min") {
                if (min === null || ch.value > min)
                    min = ch.value;
            }
            else if (ch.kind === "max") {
                if (max === null || ch.value < max)
                    max = ch.value;
            }
        }
        return Number.isFinite(min) && Number.isFinite(max);
    }
}
ZodNumber.create = (params) => {
    return new ZodNumber({
        checks: [],
        typeName: ZodFirstPartyTypeKind.ZodNumber,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...processCreateParams(params),
    });
};
class ZodBigInt extends ZodType {
    constructor() {
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
    }
    _parse(input) {
        if (this._def.coerce) {
            try {
                input.data = BigInt(input.data);
            }
            catch (_a) {
                return this._getInvalidInput(input);
            }
        }
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.bigint) {
            return this._getInvalidInput(input);
        }
        let ctx = undefined;
        const status = new ParseStatus();
        for (const check of this._def.checks) {
            if (check.kind === "min") {
                const tooSmall = check.inclusive
                    ? input.data < check.value
                    : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_small,
                        type: "bigint",
                        minimum: check.value,
                        inclusive: check.inclusive,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "max") {
                const tooBig = check.inclusive
                    ? input.data > check.value
                    : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_big,
                        type: "bigint",
                        maximum: check.value,
                        inclusive: check.inclusive,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "multipleOf") {
                if (input.data % check.value !== BigInt(0)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else {
                util.assertNever(check);
            }
        }
        return { status: status.value, value: input.data };
    }
    _getInvalidInput(input) {
        const ctx = this._getOrReturnCtx(input);
        addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_type,
            expected: ZodParsedType.bigint,
            received: ctx.parsedType,
        });
        return INVALID;
    }
    gte(value, message) {
        return this.setLimit("min", value, true, errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new ZodBigInt({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind,
                    value,
                    inclusive,
                    message: errorUtil.toString(message),
                },
            ],
        });
    }
    _addCheck(check) {
        return new ZodBigInt({
            ...this._def,
            checks: [...this._def.checks, check],
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: false,
            message: errorUtil.toString(message),
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: false,
            message: errorUtil.toString(message),
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: true,
            message: errorUtil.toString(message),
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: true,
            message: errorUtil.toString(message),
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value,
            message: errorUtil.toString(message),
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "min") {
                if (min === null || ch.value > min)
                    min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "max") {
                if (max === null || ch.value < max)
                    max = ch.value;
            }
        }
        return max;
    }
}
ZodBigInt.create = (params) => {
    var _a;
    return new ZodBigInt({
        checks: [],
        typeName: ZodFirstPartyTypeKind.ZodBigInt,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...processCreateParams(params),
    });
};
class ZodBoolean extends ZodType {
    _parse(input) {
        if (this._def.coerce) {
            input.data = Boolean(input.data);
        }
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.boolean) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.boolean,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        return OK(input.data);
    }
}
ZodBoolean.create = (params) => {
    return new ZodBoolean({
        typeName: ZodFirstPartyTypeKind.ZodBoolean,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...processCreateParams(params),
    });
};
class ZodDate extends ZodType {
    _parse(input) {
        if (this._def.coerce) {
            input.data = new Date(input.data);
        }
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.date) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.date,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        if (isNaN(input.data.getTime())) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_date,
            });
            return INVALID;
        }
        const status = new ParseStatus();
        let ctx = undefined;
        for (const check of this._def.checks) {
            if (check.kind === "min") {
                if (input.data.getTime() < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_small,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        minimum: check.value,
                        type: "date",
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "max") {
                if (input.data.getTime() > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_big,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        maximum: check.value,
                        type: "date",
                    });
                    status.dirty();
                }
            }
            else {
                util.assertNever(check);
            }
        }
        return {
            status: status.value,
            value: new Date(input.data.getTime()),
        };
    }
    _addCheck(check) {
        return new ZodDate({
            ...this._def,
            checks: [...this._def.checks, check],
        });
    }
    min(minDate, message) {
        return this._addCheck({
            kind: "min",
            value: minDate.getTime(),
            message: errorUtil.toString(message),
        });
    }
    max(maxDate, message) {
        return this._addCheck({
            kind: "max",
            value: maxDate.getTime(),
            message: errorUtil.toString(message),
        });
    }
    get minDate() {
        let min = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "min") {
                if (min === null || ch.value > min)
                    min = ch.value;
            }
        }
        return min != null ? new Date(min) : null;
    }
    get maxDate() {
        let max = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "max") {
                if (max === null || ch.value < max)
                    max = ch.value;
            }
        }
        return max != null ? new Date(max) : null;
    }
}
ZodDate.create = (params) => {
    return new ZodDate({
        checks: [],
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        typeName: ZodFirstPartyTypeKind.ZodDate,
        ...processCreateParams(params),
    });
};
class ZodSymbol extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.symbol) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.symbol,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        return OK(input.data);
    }
}
ZodSymbol.create = (params) => {
    return new ZodSymbol({
        typeName: ZodFirstPartyTypeKind.ZodSymbol,
        ...processCreateParams(params),
    });
};
class ZodUndefined extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.undefined) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.undefined,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        return OK(input.data);
    }
}
ZodUndefined.create = (params) => {
    return new ZodUndefined({
        typeName: ZodFirstPartyTypeKind.ZodUndefined,
        ...processCreateParams(params),
    });
};
class ZodNull extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.null) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.null,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        return OK(input.data);
    }
}
ZodNull.create = (params) => {
    return new ZodNull({
        typeName: ZodFirstPartyTypeKind.ZodNull,
        ...processCreateParams(params),
    });
};
class ZodAny extends ZodType {
    constructor() {
        super(...arguments);
        // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.
        this._any = true;
    }
    _parse(input) {
        return OK(input.data);
    }
}
ZodAny.create = (params) => {
    return new ZodAny({
        typeName: ZodFirstPartyTypeKind.ZodAny,
        ...processCreateParams(params),
    });
};
class ZodUnknown extends ZodType {
    constructor() {
        super(...arguments);
        // required
        this._unknown = true;
    }
    _parse(input) {
        return OK(input.data);
    }
}
ZodUnknown.create = (params) => {
    return new ZodUnknown({
        typeName: ZodFirstPartyTypeKind.ZodUnknown,
        ...processCreateParams(params),
    });
};
class ZodNever extends ZodType {
    _parse(input) {
        const ctx = this._getOrReturnCtx(input);
        addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_type,
            expected: ZodParsedType.never,
            received: ctx.parsedType,
        });
        return INVALID;
    }
}
ZodNever.create = (params) => {
    return new ZodNever({
        typeName: ZodFirstPartyTypeKind.ZodNever,
        ...processCreateParams(params),
    });
};
class ZodVoid extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.undefined) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.void,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        return OK(input.data);
    }
}
ZodVoid.create = (params) => {
    return new ZodVoid({
        typeName: ZodFirstPartyTypeKind.ZodVoid,
        ...processCreateParams(params),
    });
};
class ZodArray extends ZodType {
    _parse(input) {
        const { ctx, status } = this._processInputParams(input);
        const def = this._def;
        if (ctx.parsedType !== ZodParsedType.array) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.array,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        if (def.exactLength !== null) {
            const tooBig = ctx.data.length > def.exactLength.value;
            const tooSmall = ctx.data.length < def.exactLength.value;
            if (tooBig || tooSmall) {
                addIssueToContext(ctx, {
                    code: tooBig ? ZodIssueCode.too_big : ZodIssueCode.too_small,
                    minimum: (tooSmall ? def.exactLength.value : undefined),
                    maximum: (tooBig ? def.exactLength.value : undefined),
                    type: "array",
                    inclusive: true,
                    exact: true,
                    message: def.exactLength.message,
                });
                status.dirty();
            }
        }
        if (def.minLength !== null) {
            if (ctx.data.length < def.minLength.value) {
                addIssueToContext(ctx, {
                    code: ZodIssueCode.too_small,
                    minimum: def.minLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.minLength.message,
                });
                status.dirty();
            }
        }
        if (def.maxLength !== null) {
            if (ctx.data.length > def.maxLength.value) {
                addIssueToContext(ctx, {
                    code: ZodIssueCode.too_big,
                    maximum: def.maxLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.maxLength.message,
                });
                status.dirty();
            }
        }
        if (ctx.common.async) {
            return Promise.all([...ctx.data].map((item, i) => {
                return def.type._parseAsync(new ParseInputLazyPath(ctx, item, ctx.path, i));
            })).then((result) => {
                return ParseStatus.mergeArray(status, result);
            });
        }
        const result = [...ctx.data].map((item, i) => {
            return def.type._parseSync(new ParseInputLazyPath(ctx, item, ctx.path, i));
        });
        return ParseStatus.mergeArray(status, result);
    }
    get element() {
        return this._def.type;
    }
    min(minLength, message) {
        return new ZodArray({
            ...this._def,
            minLength: { value: minLength, message: errorUtil.toString(message) },
        });
    }
    max(maxLength, message) {
        return new ZodArray({
            ...this._def,
            maxLength: { value: maxLength, message: errorUtil.toString(message) },
        });
    }
    length(len, message) {
        return new ZodArray({
            ...this._def,
            exactLength: { value: len, message: errorUtil.toString(message) },
        });
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
ZodArray.create = (schema, params) => {
    return new ZodArray({
        type: schema,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: ZodFirstPartyTypeKind.ZodArray,
        ...processCreateParams(params),
    });
};
function deepPartialify(schema) {
    if (schema instanceof ZodObject) {
        const newShape = {};
        for (const key in schema.shape) {
            const fieldSchema = schema.shape[key];
            newShape[key] = ZodOptional.create(deepPartialify(fieldSchema));
        }
        return new ZodObject({
            ...schema._def,
            shape: () => newShape,
        });
    }
    else if (schema instanceof ZodArray) {
        return new ZodArray({
            ...schema._def,
            type: deepPartialify(schema.element),
        });
    }
    else if (schema instanceof ZodOptional) {
        return ZodOptional.create(deepPartialify(schema.unwrap()));
    }
    else if (schema instanceof ZodNullable) {
        return ZodNullable.create(deepPartialify(schema.unwrap()));
    }
    else if (schema instanceof ZodTuple) {
        return ZodTuple.create(schema.items.map((item) => deepPartialify(item)));
    }
    else {
        return schema;
    }
}
class ZodObject extends ZodType {
    constructor() {
        super(...arguments);
        this._cached = null;
        /**
         * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
         * If you want to pass through unknown properties, use `.passthrough()` instead.
         */
        this.nonstrict = this.passthrough;
        // extend<
        //   Augmentation extends ZodRawShape,
        //   NewOutput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
        //       ? Augmentation[k]["_output"]
        //       : k extends keyof Output
        //       ? Output[k]
        //       : never;
        //   }>,
        //   NewInput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
        //       ? Augmentation[k]["_input"]
        //       : k extends keyof Input
        //       ? Input[k]
        //       : never;
        //   }>
        // >(
        //   augmentation: Augmentation
        // ): ZodObject<
        //   extendShape<T, Augmentation>,
        //   UnknownKeys,
        //   Catchall,
        //   NewOutput,
        //   NewInput
        // > {
        //   return new ZodObject({
        //     ...this._def,
        //     shape: () => ({
        //       ...this._def.shape(),
        //       ...augmentation,
        //     }),
        //   }) as any;
        // }
        /**
         * @deprecated Use `.extend` instead
         *  */
        this.augment = this.extend;
    }
    _getCached() {
        if (this._cached !== null)
            return this._cached;
        const shape = this._def.shape();
        const keys = util.objectKeys(shape);
        return (this._cached = { shape, keys });
    }
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.object) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.object,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        const { status, ctx } = this._processInputParams(input);
        const { shape, keys: shapeKeys } = this._getCached();
        const extraKeys = [];
        if (!(this._def.catchall instanceof ZodNever &&
            this._def.unknownKeys === "strip")) {
            for (const key in ctx.data) {
                if (!shapeKeys.includes(key)) {
                    extraKeys.push(key);
                }
            }
        }
        const pairs = [];
        for (const key of shapeKeys) {
            const keyValidator = shape[key];
            const value = ctx.data[key];
            pairs.push({
                key: { status: "valid", value: key },
                value: keyValidator._parse(new ParseInputLazyPath(ctx, value, ctx.path, key)),
                alwaysSet: key in ctx.data,
            });
        }
        if (this._def.catchall instanceof ZodNever) {
            const unknownKeys = this._def.unknownKeys;
            if (unknownKeys === "passthrough") {
                for (const key of extraKeys) {
                    pairs.push({
                        key: { status: "valid", value: key },
                        value: { status: "valid", value: ctx.data[key] },
                    });
                }
            }
            else if (unknownKeys === "strict") {
                if (extraKeys.length > 0) {
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.unrecognized_keys,
                        keys: extraKeys,
                    });
                    status.dirty();
                }
            }
            else if (unknownKeys === "strip") ;
            else {
                throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
            }
        }
        else {
            // run catchall validation
            const catchall = this._def.catchall;
            for (const key of extraKeys) {
                const value = ctx.data[key];
                pairs.push({
                    key: { status: "valid", value: key },
                    value: catchall._parse(new ParseInputLazyPath(ctx, value, ctx.path, key) //, ctx.child(key), value, getParsedType(value)
                    ),
                    alwaysSet: key in ctx.data,
                });
            }
        }
        if (ctx.common.async) {
            return Promise.resolve()
                .then(async () => {
                const syncPairs = [];
                for (const pair of pairs) {
                    const key = await pair.key;
                    const value = await pair.value;
                    syncPairs.push({
                        key,
                        value,
                        alwaysSet: pair.alwaysSet,
                    });
                }
                return syncPairs;
            })
                .then((syncPairs) => {
                return ParseStatus.mergeObjectSync(status, syncPairs);
            });
        }
        else {
            return ParseStatus.mergeObjectSync(status, pairs);
        }
    }
    get shape() {
        return this._def.shape();
    }
    strict(message) {
        errorUtil.errToObj;
        return new ZodObject({
            ...this._def,
            unknownKeys: "strict",
            ...(message !== undefined
                ? {
                    errorMap: (issue, ctx) => {
                        var _a, _b, _c, _d;
                        const defaultError = (_c = (_b = (_a = this._def).errorMap) === null || _b === void 0 ? void 0 : _b.call(_a, issue, ctx).message) !== null && _c !== void 0 ? _c : ctx.defaultError;
                        if (issue.code === "unrecognized_keys")
                            return {
                                message: (_d = errorUtil.errToObj(message).message) !== null && _d !== void 0 ? _d : defaultError,
                            };
                        return {
                            message: defaultError,
                        };
                    },
                }
                : {}),
        });
    }
    strip() {
        return new ZodObject({
            ...this._def,
            unknownKeys: "strip",
        });
    }
    passthrough() {
        return new ZodObject({
            ...this._def,
            unknownKeys: "passthrough",
        });
    }
    // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };
    extend(augmentation) {
        return new ZodObject({
            ...this._def,
            shape: () => ({
                ...this._def.shape(),
                ...augmentation,
            }),
        });
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */
    merge(merging) {
        const merged = new ZodObject({
            unknownKeys: merging._def.unknownKeys,
            catchall: merging._def.catchall,
            shape: () => ({
                ...this._def.shape(),
                ...merging._def.shape(),
            }),
            typeName: ZodFirstPartyTypeKind.ZodObject,
        });
        return merged;
    }
    // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    setKey(key, schema) {
        return this.augment({ [key]: schema });
    }
    // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    catchall(index) {
        return new ZodObject({
            ...this._def,
            catchall: index,
        });
    }
    pick(mask) {
        const shape = {};
        util.objectKeys(mask).forEach((key) => {
            if (mask[key] && this.shape[key]) {
                shape[key] = this.shape[key];
            }
        });
        return new ZodObject({
            ...this._def,
            shape: () => shape,
        });
    }
    omit(mask) {
        const shape = {};
        util.objectKeys(this.shape).forEach((key) => {
            if (!mask[key]) {
                shape[key] = this.shape[key];
            }
        });
        return new ZodObject({
            ...this._def,
            shape: () => shape,
        });
    }
    /**
     * @deprecated
     */
    deepPartial() {
        return deepPartialify(this);
    }
    partial(mask) {
        const newShape = {};
        util.objectKeys(this.shape).forEach((key) => {
            const fieldSchema = this.shape[key];
            if (mask && !mask[key]) {
                newShape[key] = fieldSchema;
            }
            else {
                newShape[key] = fieldSchema.optional();
            }
        });
        return new ZodObject({
            ...this._def,
            shape: () => newShape,
        });
    }
    required(mask) {
        const newShape = {};
        util.objectKeys(this.shape).forEach((key) => {
            if (mask && !mask[key]) {
                newShape[key] = this.shape[key];
            }
            else {
                const fieldSchema = this.shape[key];
                let newField = fieldSchema;
                while (newField instanceof ZodOptional) {
                    newField = newField._def.innerType;
                }
                newShape[key] = newField;
            }
        });
        return new ZodObject({
            ...this._def,
            shape: () => newShape,
        });
    }
    keyof() {
        return createZodEnum(util.objectKeys(this.shape));
    }
}
ZodObject.create = (shape, params) => {
    return new ZodObject({
        shape: () => shape,
        unknownKeys: "strip",
        catchall: ZodNever.create(),
        typeName: ZodFirstPartyTypeKind.ZodObject,
        ...processCreateParams(params),
    });
};
ZodObject.strictCreate = (shape, params) => {
    return new ZodObject({
        shape: () => shape,
        unknownKeys: "strict",
        catchall: ZodNever.create(),
        typeName: ZodFirstPartyTypeKind.ZodObject,
        ...processCreateParams(params),
    });
};
ZodObject.lazycreate = (shape, params) => {
    return new ZodObject({
        shape,
        unknownKeys: "strip",
        catchall: ZodNever.create(),
        typeName: ZodFirstPartyTypeKind.ZodObject,
        ...processCreateParams(params),
    });
};
class ZodUnion extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        const options = this._def.options;
        function handleResults(results) {
            // return first issue-free validation if it exists
            for (const result of results) {
                if (result.result.status === "valid") {
                    return result.result;
                }
            }
            for (const result of results) {
                if (result.result.status === "dirty") {
                    // add issues from dirty option
                    ctx.common.issues.push(...result.ctx.common.issues);
                    return result.result;
                }
            }
            // return invalid
            const unionErrors = results.map((result) => new ZodError(result.ctx.common.issues));
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_union,
                unionErrors,
            });
            return INVALID;
        }
        if (ctx.common.async) {
            return Promise.all(options.map(async (option) => {
                const childCtx = {
                    ...ctx,
                    common: {
                        ...ctx.common,
                        issues: [],
                    },
                    parent: null,
                };
                return {
                    result: await option._parseAsync({
                        data: ctx.data,
                        path: ctx.path,
                        parent: childCtx,
                    }),
                    ctx: childCtx,
                };
            })).then(handleResults);
        }
        else {
            let dirty = undefined;
            const issues = [];
            for (const option of options) {
                const childCtx = {
                    ...ctx,
                    common: {
                        ...ctx.common,
                        issues: [],
                    },
                    parent: null,
                };
                const result = option._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx,
                });
                if (result.status === "valid") {
                    return result;
                }
                else if (result.status === "dirty" && !dirty) {
                    dirty = { result, ctx: childCtx };
                }
                if (childCtx.common.issues.length) {
                    issues.push(childCtx.common.issues);
                }
            }
            if (dirty) {
                ctx.common.issues.push(...dirty.ctx.common.issues);
                return dirty.result;
            }
            const unionErrors = issues.map((issues) => new ZodError(issues));
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_union,
                unionErrors,
            });
            return INVALID;
        }
    }
    get options() {
        return this._def.options;
    }
}
ZodUnion.create = (types, params) => {
    return new ZodUnion({
        options: types,
        typeName: ZodFirstPartyTypeKind.ZodUnion,
        ...processCreateParams(params),
    });
};
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////                                 //////////
//////////      ZodDiscriminatedUnion      //////////
//////////                                 //////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
const getDiscriminator = (type) => {
    if (type instanceof ZodLazy) {
        return getDiscriminator(type.schema);
    }
    else if (type instanceof ZodEffects) {
        return getDiscriminator(type.innerType());
    }
    else if (type instanceof ZodLiteral) {
        return [type.value];
    }
    else if (type instanceof ZodEnum) {
        return type.options;
    }
    else if (type instanceof ZodNativeEnum) {
        // eslint-disable-next-line ban/ban
        return util.objectValues(type.enum);
    }
    else if (type instanceof ZodDefault) {
        return getDiscriminator(type._def.innerType);
    }
    else if (type instanceof ZodUndefined) {
        return [undefined];
    }
    else if (type instanceof ZodNull) {
        return [null];
    }
    else if (type instanceof ZodOptional) {
        return [undefined, ...getDiscriminator(type.unwrap())];
    }
    else if (type instanceof ZodNullable) {
        return [null, ...getDiscriminator(type.unwrap())];
    }
    else if (type instanceof ZodBranded) {
        return getDiscriminator(type.unwrap());
    }
    else if (type instanceof ZodReadonly) {
        return getDiscriminator(type.unwrap());
    }
    else if (type instanceof ZodCatch) {
        return getDiscriminator(type._def.innerType);
    }
    else {
        return [];
    }
};
class ZodDiscriminatedUnion extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.object) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.object,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        const discriminator = this.discriminator;
        const discriminatorValue = ctx.data[discriminator];
        const option = this.optionsMap.get(discriminatorValue);
        if (!option) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_union_discriminator,
                options: Array.from(this.optionsMap.keys()),
                path: [discriminator],
            });
            return INVALID;
        }
        if (ctx.common.async) {
            return option._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx,
            });
        }
        else {
            return option._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx,
            });
        }
    }
    get discriminator() {
        return this._def.discriminator;
    }
    get options() {
        return this._def.options;
    }
    get optionsMap() {
        return this._def.optionsMap;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */
    static create(discriminator, options, params) {
        // Get all the valid discriminator values
        const optionsMap = new Map();
        // try {
        for (const type of options) {
            const discriminatorValues = getDiscriminator(type.shape[discriminator]);
            if (!discriminatorValues.length) {
                throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
            }
            for (const value of discriminatorValues) {
                if (optionsMap.has(value)) {
                    throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
                }
                optionsMap.set(value, type);
            }
        }
        return new ZodDiscriminatedUnion({
            typeName: ZodFirstPartyTypeKind.ZodDiscriminatedUnion,
            discriminator,
            options,
            optionsMap,
            ...processCreateParams(params),
        });
    }
}
function mergeValues(a, b) {
    const aType = getParsedType(a);
    const bType = getParsedType(b);
    if (a === b) {
        return { valid: true, data: a };
    }
    else if (aType === ZodParsedType.object && bType === ZodParsedType.object) {
        const bKeys = util.objectKeys(b);
        const sharedKeys = util
            .objectKeys(a)
            .filter((key) => bKeys.indexOf(key) !== -1);
        const newObj = { ...a, ...b };
        for (const key of sharedKeys) {
            const sharedValue = mergeValues(a[key], b[key]);
            if (!sharedValue.valid) {
                return { valid: false };
            }
            newObj[key] = sharedValue.data;
        }
        return { valid: true, data: newObj };
    }
    else if (aType === ZodParsedType.array && bType === ZodParsedType.array) {
        if (a.length !== b.length) {
            return { valid: false };
        }
        const newArray = [];
        for (let index = 0; index < a.length; index++) {
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = mergeValues(itemA, itemB);
            if (!sharedValue.valid) {
                return { valid: false };
            }
            newArray.push(sharedValue.data);
        }
        return { valid: true, data: newArray };
    }
    else if (aType === ZodParsedType.date &&
        bType === ZodParsedType.date &&
        +a === +b) {
        return { valid: true, data: a };
    }
    else {
        return { valid: false };
    }
}
class ZodIntersection extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        const handleParsed = (parsedLeft, parsedRight) => {
            if (isAborted(parsedLeft) || isAborted(parsedRight)) {
                return INVALID;
            }
            const merged = mergeValues(parsedLeft.value, parsedRight.value);
            if (!merged.valid) {
                addIssueToContext(ctx, {
                    code: ZodIssueCode.invalid_intersection_types,
                });
                return INVALID;
            }
            if (isDirty(parsedLeft) || isDirty(parsedRight)) {
                status.dirty();
            }
            return { status: status.value, value: merged.data };
        };
        if (ctx.common.async) {
            return Promise.all([
                this._def.left._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx,
                }),
                this._def.right._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx,
                }),
            ]).then(([left, right]) => handleParsed(left, right));
        }
        else {
            return handleParsed(this._def.left._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx,
            }), this._def.right._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx,
            }));
        }
    }
}
ZodIntersection.create = (left, right, params) => {
    return new ZodIntersection({
        left: left,
        right: right,
        typeName: ZodFirstPartyTypeKind.ZodIntersection,
        ...processCreateParams(params),
    });
};
class ZodTuple extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.array) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.array,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        if (ctx.data.length < this._def.items.length) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.too_small,
                minimum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array",
            });
            return INVALID;
        }
        const rest = this._def.rest;
        if (!rest && ctx.data.length > this._def.items.length) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.too_big,
                maximum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array",
            });
            status.dirty();
        }
        const items = [...ctx.data]
            .map((item, itemIndex) => {
            const schema = this._def.items[itemIndex] || this._def.rest;
            if (!schema)
                return null;
            return schema._parse(new ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
        })
            .filter((x) => !!x); // filter nulls
        if (ctx.common.async) {
            return Promise.all(items).then((results) => {
                return ParseStatus.mergeArray(status, results);
            });
        }
        else {
            return ParseStatus.mergeArray(status, items);
        }
    }
    get items() {
        return this._def.items;
    }
    rest(rest) {
        return new ZodTuple({
            ...this._def,
            rest,
        });
    }
}
ZodTuple.create = (schemas, params) => {
    if (!Array.isArray(schemas)) {
        throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    }
    return new ZodTuple({
        items: schemas,
        typeName: ZodFirstPartyTypeKind.ZodTuple,
        rest: null,
        ...processCreateParams(params),
    });
};
class ZodRecord extends ZodType {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.object) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.object,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        const pairs = [];
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        for (const key in ctx.data) {
            pairs.push({
                key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, key)),
                value: valueType._parse(new ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key)),
                alwaysSet: key in ctx.data,
            });
        }
        if (ctx.common.async) {
            return ParseStatus.mergeObjectAsync(status, pairs);
        }
        else {
            return ParseStatus.mergeObjectSync(status, pairs);
        }
    }
    get element() {
        return this._def.valueType;
    }
    static create(first, second, third) {
        if (second instanceof ZodType) {
            return new ZodRecord({
                keyType: first,
                valueType: second,
                typeName: ZodFirstPartyTypeKind.ZodRecord,
                ...processCreateParams(third),
            });
        }
        return new ZodRecord({
            keyType: ZodString.create(),
            valueType: first,
            typeName: ZodFirstPartyTypeKind.ZodRecord,
            ...processCreateParams(second),
        });
    }
}
class ZodMap extends ZodType {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.map) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.map,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        const pairs = [...ctx.data.entries()].map(([key, value], index) => {
            return {
                key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, [index, "key"])),
                value: valueType._parse(new ParseInputLazyPath(ctx, value, ctx.path, [index, "value"])),
            };
        });
        if (ctx.common.async) {
            const finalMap = new Map();
            return Promise.resolve().then(async () => {
                for (const pair of pairs) {
                    const key = await pair.key;
                    const value = await pair.value;
                    if (key.status === "aborted" || value.status === "aborted") {
                        return INVALID;
                    }
                    if (key.status === "dirty" || value.status === "dirty") {
                        status.dirty();
                    }
                    finalMap.set(key.value, value.value);
                }
                return { status: status.value, value: finalMap };
            });
        }
        else {
            const finalMap = new Map();
            for (const pair of pairs) {
                const key = pair.key;
                const value = pair.value;
                if (key.status === "aborted" || value.status === "aborted") {
                    return INVALID;
                }
                if (key.status === "dirty" || value.status === "dirty") {
                    status.dirty();
                }
                finalMap.set(key.value, value.value);
            }
            return { status: status.value, value: finalMap };
        }
    }
}
ZodMap.create = (keyType, valueType, params) => {
    return new ZodMap({
        valueType,
        keyType,
        typeName: ZodFirstPartyTypeKind.ZodMap,
        ...processCreateParams(params),
    });
};
class ZodSet extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.set) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.set,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        const def = this._def;
        if (def.minSize !== null) {
            if (ctx.data.size < def.minSize.value) {
                addIssueToContext(ctx, {
                    code: ZodIssueCode.too_small,
                    minimum: def.minSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.minSize.message,
                });
                status.dirty();
            }
        }
        if (def.maxSize !== null) {
            if (ctx.data.size > def.maxSize.value) {
                addIssueToContext(ctx, {
                    code: ZodIssueCode.too_big,
                    maximum: def.maxSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.maxSize.message,
                });
                status.dirty();
            }
        }
        const valueType = this._def.valueType;
        function finalizeSet(elements) {
            const parsedSet = new Set();
            for (const element of elements) {
                if (element.status === "aborted")
                    return INVALID;
                if (element.status === "dirty")
                    status.dirty();
                parsedSet.add(element.value);
            }
            return { status: status.value, value: parsedSet };
        }
        const elements = [...ctx.data.values()].map((item, i) => valueType._parse(new ParseInputLazyPath(ctx, item, ctx.path, i)));
        if (ctx.common.async) {
            return Promise.all(elements).then((elements) => finalizeSet(elements));
        }
        else {
            return finalizeSet(elements);
        }
    }
    min(minSize, message) {
        return new ZodSet({
            ...this._def,
            minSize: { value: minSize, message: errorUtil.toString(message) },
        });
    }
    max(maxSize, message) {
        return new ZodSet({
            ...this._def,
            maxSize: { value: maxSize, message: errorUtil.toString(message) },
        });
    }
    size(size, message) {
        return this.min(size, message).max(size, message);
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
ZodSet.create = (valueType, params) => {
    return new ZodSet({
        valueType,
        minSize: null,
        maxSize: null,
        typeName: ZodFirstPartyTypeKind.ZodSet,
        ...processCreateParams(params),
    });
};
class ZodFunction extends ZodType {
    constructor() {
        super(...arguments);
        this.validate = this.implement;
    }
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.function) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.function,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        function makeArgsIssue(args, error) {
            return makeIssue({
                data: args,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    getErrorMap(),
                    errorMap,
                ].filter((x) => !!x),
                issueData: {
                    code: ZodIssueCode.invalid_arguments,
                    argumentsError: error,
                },
            });
        }
        function makeReturnsIssue(returns, error) {
            return makeIssue({
                data: returns,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    getErrorMap(),
                    errorMap,
                ].filter((x) => !!x),
                issueData: {
                    code: ZodIssueCode.invalid_return_type,
                    returnTypeError: error,
                },
            });
        }
        const params = { errorMap: ctx.common.contextualErrorMap };
        const fn = ctx.data;
        if (this._def.returns instanceof ZodPromise) {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return OK(async function (...args) {
                const error = new ZodError([]);
                const parsedArgs = await me._def.args
                    .parseAsync(args, params)
                    .catch((e) => {
                    error.addIssue(makeArgsIssue(args, e));
                    throw error;
                });
                const result = await Reflect.apply(fn, this, parsedArgs);
                const parsedReturns = await me._def.returns._def.type
                    .parseAsync(result, params)
                    .catch((e) => {
                    error.addIssue(makeReturnsIssue(result, e));
                    throw error;
                });
                return parsedReturns;
            });
        }
        else {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return OK(function (...args) {
                const parsedArgs = me._def.args.safeParse(args, params);
                if (!parsedArgs.success) {
                    throw new ZodError([makeArgsIssue(args, parsedArgs.error)]);
                }
                const result = Reflect.apply(fn, this, parsedArgs.data);
                const parsedReturns = me._def.returns.safeParse(result, params);
                if (!parsedReturns.success) {
                    throw new ZodError([makeReturnsIssue(result, parsedReturns.error)]);
                }
                return parsedReturns.data;
            });
        }
    }
    parameters() {
        return this._def.args;
    }
    returnType() {
        return this._def.returns;
    }
    args(...items) {
        return new ZodFunction({
            ...this._def,
            args: ZodTuple.create(items).rest(ZodUnknown.create()),
        });
    }
    returns(returnType) {
        return new ZodFunction({
            ...this._def,
            returns: returnType,
        });
    }
    implement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    strictImplement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    static create(args, returns, params) {
        return new ZodFunction({
            args: (args
                ? args
                : ZodTuple.create([]).rest(ZodUnknown.create())),
            returns: returns || ZodUnknown.create(),
            typeName: ZodFirstPartyTypeKind.ZodFunction,
            ...processCreateParams(params),
        });
    }
}
class ZodLazy extends ZodType {
    get schema() {
        return this._def.getter();
    }
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        const lazySchema = this._def.getter();
        return lazySchema._parse({ data: ctx.data, path: ctx.path, parent: ctx });
    }
}
ZodLazy.create = (getter, params) => {
    return new ZodLazy({
        getter: getter,
        typeName: ZodFirstPartyTypeKind.ZodLazy,
        ...processCreateParams(params),
    });
};
class ZodLiteral extends ZodType {
    _parse(input) {
        if (input.data !== this._def.value) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                received: ctx.data,
                code: ZodIssueCode.invalid_literal,
                expected: this._def.value,
            });
            return INVALID;
        }
        return { status: "valid", value: input.data };
    }
    get value() {
        return this._def.value;
    }
}
ZodLiteral.create = (value, params) => {
    return new ZodLiteral({
        value: value,
        typeName: ZodFirstPartyTypeKind.ZodLiteral,
        ...processCreateParams(params),
    });
};
function createZodEnum(values, params) {
    return new ZodEnum({
        values,
        typeName: ZodFirstPartyTypeKind.ZodEnum,
        ...processCreateParams(params),
    });
}
class ZodEnum extends ZodType {
    constructor() {
        super(...arguments);
        _ZodEnum_cache.set(this, void 0);
    }
    _parse(input) {
        if (typeof input.data !== "string") {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            addIssueToContext(ctx, {
                expected: util.joinValues(expectedValues),
                received: ctx.parsedType,
                code: ZodIssueCode.invalid_type,
            });
            return INVALID;
        }
        if (!__classPrivateFieldGet(this, _ZodEnum_cache)) {
            __classPrivateFieldSet(this, _ZodEnum_cache, new Set(this._def.values));
        }
        if (!__classPrivateFieldGet(this, _ZodEnum_cache).has(input.data)) {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            addIssueToContext(ctx, {
                received: ctx.data,
                code: ZodIssueCode.invalid_enum_value,
                options: expectedValues,
            });
            return INVALID;
        }
        return OK(input.data);
    }
    get options() {
        return this._def.values;
    }
    get enum() {
        const enumValues = {};
        for (const val of this._def.values) {
            enumValues[val] = val;
        }
        return enumValues;
    }
    get Values() {
        const enumValues = {};
        for (const val of this._def.values) {
            enumValues[val] = val;
        }
        return enumValues;
    }
    get Enum() {
        const enumValues = {};
        for (const val of this._def.values) {
            enumValues[val] = val;
        }
        return enumValues;
    }
    extract(values, newDef = this._def) {
        return ZodEnum.create(values, {
            ...this._def,
            ...newDef,
        });
    }
    exclude(values, newDef = this._def) {
        return ZodEnum.create(this.options.filter((opt) => !values.includes(opt)), {
            ...this._def,
            ...newDef,
        });
    }
}
_ZodEnum_cache = new WeakMap();
ZodEnum.create = createZodEnum;
class ZodNativeEnum extends ZodType {
    constructor() {
        super(...arguments);
        _ZodNativeEnum_cache.set(this, void 0);
    }
    _parse(input) {
        const nativeEnumValues = util.getValidEnumValues(this._def.values);
        const ctx = this._getOrReturnCtx(input);
        if (ctx.parsedType !== ZodParsedType.string &&
            ctx.parsedType !== ZodParsedType.number) {
            const expectedValues = util.objectValues(nativeEnumValues);
            addIssueToContext(ctx, {
                expected: util.joinValues(expectedValues),
                received: ctx.parsedType,
                code: ZodIssueCode.invalid_type,
            });
            return INVALID;
        }
        if (!__classPrivateFieldGet(this, _ZodNativeEnum_cache)) {
            __classPrivateFieldSet(this, _ZodNativeEnum_cache, new Set(util.getValidEnumValues(this._def.values)));
        }
        if (!__classPrivateFieldGet(this, _ZodNativeEnum_cache).has(input.data)) {
            const expectedValues = util.objectValues(nativeEnumValues);
            addIssueToContext(ctx, {
                received: ctx.data,
                code: ZodIssueCode.invalid_enum_value,
                options: expectedValues,
            });
            return INVALID;
        }
        return OK(input.data);
    }
    get enum() {
        return this._def.values;
    }
}
_ZodNativeEnum_cache = new WeakMap();
ZodNativeEnum.create = (values, params) => {
    return new ZodNativeEnum({
        values: values,
        typeName: ZodFirstPartyTypeKind.ZodNativeEnum,
        ...processCreateParams(params),
    });
};
class ZodPromise extends ZodType {
    unwrap() {
        return this._def.type;
    }
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.promise &&
            ctx.common.async === false) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.promise,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        const promisified = ctx.parsedType === ZodParsedType.promise
            ? ctx.data
            : Promise.resolve(ctx.data);
        return OK(promisified.then((data) => {
            return this._def.type.parseAsync(data, {
                path: ctx.path,
                errorMap: ctx.common.contextualErrorMap,
            });
        }));
    }
}
ZodPromise.create = (schema, params) => {
    return new ZodPromise({
        type: schema,
        typeName: ZodFirstPartyTypeKind.ZodPromise,
        ...processCreateParams(params),
    });
};
class ZodEffects extends ZodType {
    innerType() {
        return this._def.schema;
    }
    sourceType() {
        return this._def.schema._def.typeName === ZodFirstPartyTypeKind.ZodEffects
            ? this._def.schema.sourceType()
            : this._def.schema;
    }
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        const effect = this._def.effect || null;
        const checkCtx = {
            addIssue: (arg) => {
                addIssueToContext(ctx, arg);
                if (arg.fatal) {
                    status.abort();
                }
                else {
                    status.dirty();
                }
            },
            get path() {
                return ctx.path;
            },
        };
        checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
        if (effect.type === "preprocess") {
            const processed = effect.transform(ctx.data, checkCtx);
            if (ctx.common.async) {
                return Promise.resolve(processed).then(async (processed) => {
                    if (status.value === "aborted")
                        return INVALID;
                    const result = await this._def.schema._parseAsync({
                        data: processed,
                        path: ctx.path,
                        parent: ctx,
                    });
                    if (result.status === "aborted")
                        return INVALID;
                    if (result.status === "dirty")
                        return DIRTY(result.value);
                    if (status.value === "dirty")
                        return DIRTY(result.value);
                    return result;
                });
            }
            else {
                if (status.value === "aborted")
                    return INVALID;
                const result = this._def.schema._parseSync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx,
                });
                if (result.status === "aborted")
                    return INVALID;
                if (result.status === "dirty")
                    return DIRTY(result.value);
                if (status.value === "dirty")
                    return DIRTY(result.value);
                return result;
            }
        }
        if (effect.type === "refinement") {
            const executeRefinement = (acc) => {
                const result = effect.refinement(acc, checkCtx);
                if (ctx.common.async) {
                    return Promise.resolve(result);
                }
                if (result instanceof Promise) {
                    throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                }
                return acc;
            };
            if (ctx.common.async === false) {
                const inner = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx,
                });
                if (inner.status === "aborted")
                    return INVALID;
                if (inner.status === "dirty")
                    status.dirty();
                // return value is ignored
                executeRefinement(inner.value);
                return { status: status.value, value: inner.value };
            }
            else {
                return this._def.schema
                    ._parseAsync({ data: ctx.data, path: ctx.path, parent: ctx })
                    .then((inner) => {
                    if (inner.status === "aborted")
                        return INVALID;
                    if (inner.status === "dirty")
                        status.dirty();
                    return executeRefinement(inner.value).then(() => {
                        return { status: status.value, value: inner.value };
                    });
                });
            }
        }
        if (effect.type === "transform") {
            if (ctx.common.async === false) {
                const base = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx,
                });
                if (!isValid(base))
                    return base;
                const result = effect.transform(base.value, checkCtx);
                if (result instanceof Promise) {
                    throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
                }
                return { status: status.value, value: result };
            }
            else {
                return this._def.schema
                    ._parseAsync({ data: ctx.data, path: ctx.path, parent: ctx })
                    .then((base) => {
                    if (!isValid(base))
                        return base;
                    return Promise.resolve(effect.transform(base.value, checkCtx)).then((result) => ({ status: status.value, value: result }));
                });
            }
        }
        util.assertNever(effect);
    }
}
ZodEffects.create = (schema, effect, params) => {
    return new ZodEffects({
        schema,
        typeName: ZodFirstPartyTypeKind.ZodEffects,
        effect,
        ...processCreateParams(params),
    });
};
ZodEffects.createWithPreprocess = (preprocess, schema, params) => {
    return new ZodEffects({
        schema,
        effect: { type: "preprocess", transform: preprocess },
        typeName: ZodFirstPartyTypeKind.ZodEffects,
        ...processCreateParams(params),
    });
};
class ZodOptional extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === ZodParsedType.undefined) {
            return OK(undefined);
        }
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
ZodOptional.create = (type, params) => {
    return new ZodOptional({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodOptional,
        ...processCreateParams(params),
    });
};
class ZodNullable extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === ZodParsedType.null) {
            return OK(null);
        }
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
ZodNullable.create = (type, params) => {
    return new ZodNullable({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodNullable,
        ...processCreateParams(params),
    });
};
class ZodDefault extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        let data = ctx.data;
        if (ctx.parsedType === ZodParsedType.undefined) {
            data = this._def.defaultValue();
        }
        return this._def.innerType._parse({
            data,
            path: ctx.path,
            parent: ctx,
        });
    }
    removeDefault() {
        return this._def.innerType;
    }
}
ZodDefault.create = (type, params) => {
    return new ZodDefault({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodDefault,
        defaultValue: typeof params.default === "function"
            ? params.default
            : () => params.default,
        ...processCreateParams(params),
    });
};
class ZodCatch extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        // newCtx is used to not collect issues from inner types in ctx
        const newCtx = {
            ...ctx,
            common: {
                ...ctx.common,
                issues: [],
            },
        };
        const result = this._def.innerType._parse({
            data: newCtx.data,
            path: newCtx.path,
            parent: {
                ...newCtx,
            },
        });
        if (isAsync(result)) {
            return result.then((result) => {
                return {
                    status: "valid",
                    value: result.status === "valid"
                        ? result.value
                        : this._def.catchValue({
                            get error() {
                                return new ZodError(newCtx.common.issues);
                            },
                            input: newCtx.data,
                        }),
                };
            });
        }
        else {
            return {
                status: "valid",
                value: result.status === "valid"
                    ? result.value
                    : this._def.catchValue({
                        get error() {
                            return new ZodError(newCtx.common.issues);
                        },
                        input: newCtx.data,
                    }),
            };
        }
    }
    removeCatch() {
        return this._def.innerType;
    }
}
ZodCatch.create = (type, params) => {
    return new ZodCatch({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodCatch,
        catchValue: typeof params.catch === "function" ? params.catch : () => params.catch,
        ...processCreateParams(params),
    });
};
class ZodNaN extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.nan) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.nan,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        return { status: "valid", value: input.data };
    }
}
ZodNaN.create = (params) => {
    return new ZodNaN({
        typeName: ZodFirstPartyTypeKind.ZodNaN,
        ...processCreateParams(params),
    });
};
const BRAND = Symbol("zod_brand");
class ZodBranded extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        const data = ctx.data;
        return this._def.type._parse({
            data,
            path: ctx.path,
            parent: ctx,
        });
    }
    unwrap() {
        return this._def.type;
    }
}
class ZodPipeline extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.common.async) {
            const handleAsync = async () => {
                const inResult = await this._def.in._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx,
                });
                if (inResult.status === "aborted")
                    return INVALID;
                if (inResult.status === "dirty") {
                    status.dirty();
                    return DIRTY(inResult.value);
                }
                else {
                    return this._def.out._parseAsync({
                        data: inResult.value,
                        path: ctx.path,
                        parent: ctx,
                    });
                }
            };
            return handleAsync();
        }
        else {
            const inResult = this._def.in._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx,
            });
            if (inResult.status === "aborted")
                return INVALID;
            if (inResult.status === "dirty") {
                status.dirty();
                return {
                    status: "dirty",
                    value: inResult.value,
                };
            }
            else {
                return this._def.out._parseSync({
                    data: inResult.value,
                    path: ctx.path,
                    parent: ctx,
                });
            }
        }
    }
    static create(a, b) {
        return new ZodPipeline({
            in: a,
            out: b,
            typeName: ZodFirstPartyTypeKind.ZodPipeline,
        });
    }
}
class ZodReadonly extends ZodType {
    _parse(input) {
        const result = this._def.innerType._parse(input);
        const freeze = (data) => {
            if (isValid(data)) {
                data.value = Object.freeze(data.value);
            }
            return data;
        };
        return isAsync(result)
            ? result.then((data) => freeze(data))
            : freeze(result);
    }
    unwrap() {
        return this._def.innerType;
    }
}
ZodReadonly.create = (type, params) => {
    return new ZodReadonly({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodReadonly,
        ...processCreateParams(params),
    });
};
////////////////////////////////////////
////////////////////////////////////////
//////////                    //////////
//////////      z.custom      //////////
//////////                    //////////
////////////////////////////////////////
////////////////////////////////////////
function cleanParams(params, data) {
    const p = typeof params === "function"
        ? params(data)
        : typeof params === "string"
            ? { message: params }
            : params;
    const p2 = typeof p === "string" ? { message: p } : p;
    return p2;
}
function custom(check, _params = {}, 
/**
 * @deprecated
 *
 * Pass `fatal` into the params object instead:
 *
 * ```ts
 * z.string().custom((val) => val.length > 5, { fatal: false })
 * ```
 *
 */
fatal) {
    if (check)
        return ZodAny.create().superRefine((data, ctx) => {
            var _a, _b;
            const r = check(data);
            if (r instanceof Promise) {
                return r.then((r) => {
                    var _a, _b;
                    if (!r) {
                        const params = cleanParams(_params, data);
                        const _fatal = (_b = (_a = params.fatal) !== null && _a !== void 0 ? _a : fatal) !== null && _b !== void 0 ? _b : true;
                        ctx.addIssue({ code: "custom", ...params, fatal: _fatal });
                    }
                });
            }
            if (!r) {
                const params = cleanParams(_params, data);
                const _fatal = (_b = (_a = params.fatal) !== null && _a !== void 0 ? _a : fatal) !== null && _b !== void 0 ? _b : true;
                ctx.addIssue({ code: "custom", ...params, fatal: _fatal });
            }
            return;
        });
    return ZodAny.create();
}
const late = {
    object: ZodObject.lazycreate,
};
var ZodFirstPartyTypeKind;
(function (ZodFirstPartyTypeKind) {
    ZodFirstPartyTypeKind["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind["ZodPipeline"] = "ZodPipeline";
    ZodFirstPartyTypeKind["ZodReadonly"] = "ZodReadonly";
})(ZodFirstPartyTypeKind || (ZodFirstPartyTypeKind = {}));
const instanceOfType = (
// const instanceOfType = <T extends new (...args: any[]) => any>(
cls, params = {
    message: `Input not instance of ${cls.name}`,
}) => custom((data) => data instanceof cls, params);
const stringType = ZodString.create;
const numberType = ZodNumber.create;
const nanType = ZodNaN.create;
const bigIntType = ZodBigInt.create;
const booleanType = ZodBoolean.create;
const dateType = ZodDate.create;
const symbolType = ZodSymbol.create;
const undefinedType = ZodUndefined.create;
const nullType = ZodNull.create;
const anyType = ZodAny.create;
const unknownType = ZodUnknown.create;
const neverType = ZodNever.create;
const voidType = ZodVoid.create;
const arrayType = ZodArray.create;
const objectType = ZodObject.create;
const strictObjectType = ZodObject.strictCreate;
const unionType = ZodUnion.create;
const discriminatedUnionType = ZodDiscriminatedUnion.create;
const intersectionType = ZodIntersection.create;
const tupleType = ZodTuple.create;
const recordType = ZodRecord.create;
const mapType = ZodMap.create;
const setType = ZodSet.create;
const functionType = ZodFunction.create;
const lazyType = ZodLazy.create;
const literalType = ZodLiteral.create;
const enumType = ZodEnum.create;
const nativeEnumType = ZodNativeEnum.create;
const promiseType = ZodPromise.create;
const effectsType = ZodEffects.create;
const optionalType = ZodOptional.create;
const nullableType = ZodNullable.create;
const preprocessType = ZodEffects.createWithPreprocess;
const pipelineType = ZodPipeline.create;
const ostring = () => stringType().optional();
const onumber = () => numberType().optional();
const oboolean = () => booleanType().optional();
const coerce = {
    string: ((arg) => ZodString.create({ ...arg, coerce: true })),
    number: ((arg) => ZodNumber.create({ ...arg, coerce: true })),
    boolean: ((arg) => ZodBoolean.create({
        ...arg,
        coerce: true,
    })),
    bigint: ((arg) => ZodBigInt.create({ ...arg, coerce: true })),
    date: ((arg) => ZodDate.create({ ...arg, coerce: true })),
};
const NEVER = INVALID;

var z = /*#__PURE__*/Object.freeze({
    __proto__: null,
    defaultErrorMap: errorMap,
    setErrorMap: setErrorMap,
    getErrorMap: getErrorMap,
    makeIssue: makeIssue,
    EMPTY_PATH: EMPTY_PATH,
    addIssueToContext: addIssueToContext,
    ParseStatus: ParseStatus,
    INVALID: INVALID,
    DIRTY: DIRTY,
    OK: OK,
    isAborted: isAborted,
    isDirty: isDirty,
    isValid: isValid,
    isAsync: isAsync,
    get util () { return util; },
    get objectUtil () { return objectUtil; },
    ZodParsedType: ZodParsedType,
    getParsedType: getParsedType,
    ZodType: ZodType,
    datetimeRegex: datetimeRegex,
    ZodString: ZodString,
    ZodNumber: ZodNumber,
    ZodBigInt: ZodBigInt,
    ZodBoolean: ZodBoolean,
    ZodDate: ZodDate,
    ZodSymbol: ZodSymbol,
    ZodUndefined: ZodUndefined,
    ZodNull: ZodNull,
    ZodAny: ZodAny,
    ZodUnknown: ZodUnknown,
    ZodNever: ZodNever,
    ZodVoid: ZodVoid,
    ZodArray: ZodArray,
    ZodObject: ZodObject,
    ZodUnion: ZodUnion,
    ZodDiscriminatedUnion: ZodDiscriminatedUnion,
    ZodIntersection: ZodIntersection,
    ZodTuple: ZodTuple,
    ZodRecord: ZodRecord,
    ZodMap: ZodMap,
    ZodSet: ZodSet,
    ZodFunction: ZodFunction,
    ZodLazy: ZodLazy,
    ZodLiteral: ZodLiteral,
    ZodEnum: ZodEnum,
    ZodNativeEnum: ZodNativeEnum,
    ZodPromise: ZodPromise,
    ZodEffects: ZodEffects,
    ZodTransformer: ZodEffects,
    ZodOptional: ZodOptional,
    ZodNullable: ZodNullable,
    ZodDefault: ZodDefault,
    ZodCatch: ZodCatch,
    ZodNaN: ZodNaN,
    BRAND: BRAND,
    ZodBranded: ZodBranded,
    ZodPipeline: ZodPipeline,
    ZodReadonly: ZodReadonly,
    custom: custom,
    Schema: ZodType,
    ZodSchema: ZodType,
    late: late,
    get ZodFirstPartyTypeKind () { return ZodFirstPartyTypeKind; },
    coerce: coerce,
    any: anyType,
    array: arrayType,
    bigint: bigIntType,
    boolean: booleanType,
    date: dateType,
    discriminatedUnion: discriminatedUnionType,
    effect: effectsType,
    'enum': enumType,
    'function': functionType,
    'instanceof': instanceOfType,
    intersection: intersectionType,
    lazy: lazyType,
    literal: literalType,
    map: mapType,
    nan: nanType,
    nativeEnum: nativeEnumType,
    never: neverType,
    'null': nullType,
    nullable: nullableType,
    number: numberType,
    object: objectType,
    oboolean: oboolean,
    onumber: onumber,
    optional: optionalType,
    ostring: ostring,
    pipeline: pipelineType,
    preprocess: preprocessType,
    promise: promiseType,
    record: recordType,
    set: setType,
    strictObject: strictObjectType,
    string: stringType,
    symbol: symbolType,
    transformer: effectsType,
    tuple: tupleType,
    'undefined': undefinedType,
    union: unionType,
    unknown: unknownType,
    'void': voidType,
    NEVER: NEVER,
    ZodIssueCode: ZodIssueCode,
    quotelessJson: quotelessJson,
    ZodError: ZodError
});

const validatorsErrorTranslationKeys = {
    required: 'required',
    string: 'string',
    phone: 'phoneNumber',
    email: 'email',
    consent: 'consent'
};
const stringValidator = {
    message: validatorsErrorTranslationKeys.string
};
const nonemptyValidator = {
    message: validatorsErrorTranslationKeys.required
};
const emailValidator = {
    message: validatorsErrorTranslationKeys.email
};
const consentValidator = {
    message: validatorsErrorTranslationKeys.consent
};
const phoneValidatorRules = z.string(stringValidator).nonempty(nonemptyValidator).transform((value, ctx)=>{
    const phoneNumber = parsePhoneNumber(value, {
        defaultCountry: 'FR'
    });
    if (!phoneNumber?.isValid()) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: validatorsErrorTranslationKeys.phone
        });
        return z.NEVER;
    }
    return phoneNumber.formatInternational().replace(/\s+/g, '');
});
const consentValidatorRules = z.boolean(consentValidator).transform((value, ctx)=>{
    if (!value) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: validatorsErrorTranslationKeys.consent
        });
        return z.NEVER;
    }
    return value;
});
const IntermediaryMatchingMandateFormSchema = z.object({
    name: z.string(stringValidator).nonempty(nonemptyValidator),
    email: z.string(stringValidator).email(emailValidator).nonempty(nonemptyValidator),
    phoneNumber: phoneValidatorRules,
    message: z.string(stringValidator).optional(),
    consent: consentValidatorRules
});

const s$1=(t,s,o)=>{if(t&&"reportValidity"in t){const r=get(o,s);t.setCustomValidity(r&&r.message||""),t.reportValidity();}},o=(e,t)=>{for(const o in t.fields){const r=t.fields[o];r&&r.ref&&"reportValidity"in r.ref?s$1(r.ref,o,e):r&&r.refs&&r.refs.forEach(t=>s$1(t,o,e));}},r=(s,r)=>{r.shouldUseNativeValidation&&o(s,r);const f={};for(const o in s){const n=get(r.fields,o),a=Object.assign(s[o]||{},{ref:n&&n.ref});if(i(r.names||Object.keys(s),o)){const s=Object.assign({},get(f,o));set(s,"root",a),set(f,o,s);}else set(f,o,a);}return f},i=(e,t)=>e.some(e=>e.match(`^${t}\\.\\d+`));

function n(r,e){for(var n={};r.length;){var s=r[0],t=s.code,i=s.message,a=s.path.join(".");if(!n[a])if("unionErrors"in s){var u=s.unionErrors[0].errors[0];n[a]={message:u.message,type:u.code};}else n[a]={message:i,type:t};if("unionErrors"in s&&s.unionErrors.forEach(function(e){return e.errors.forEach(function(e){return r.push(e)})}),e){var c=n[a].types,f=c&&c[s.code];n[a]=appendErrors(a,e,n,t,f?[].concat(f,s.message):s.message);}r.shift();}return n}function s(o$1,s,t){return void 0===t&&(t={}),function(i,a,u){try{return Promise.resolve(function(e,n){try{var a=Promise.resolve(o$1["sync"===t.mode?"parse":"parseAsync"](i,s)).then(function(e){return u.shouldUseNativeValidation&&o({},u),{errors:{},values:t.raw?Object.assign({},i):e}});}catch(r){return n(r)}return a&&a.then?a.then(void 0,n):a}(0,function(r$1){if(function(r){return Array.isArray(null==r?void 0:r.errors)}(r$1))return {values:{},errors:r(n(r$1.errors,!u.shouldUseNativeValidation&&"all"===u.criteriaMode),u)};throw r$1}))}catch(r){return Promise.reject(r)}}}

const IntermediaryMatchingMandateForm = ({ onSubmit, translation, testId, email, error, isFetching })=>{
    const { control, handleSubmit } = useForm({
        resolver: s(IntermediaryMatchingMandateFormSchema),
        defaultValues: {
            name: '',
            email: email ?? '',
            phoneNumber: '',
            message: '',
            consent: undefined
        }
    });
    const getError = (label, error)=>{
        return {
            error: translation(`${intermediaryMatchingMandateLokalizePrefix}.errors.${error}`, {
                field: label.toLowerCase()
            })
        };
    };
    const labels = {
        name: translation(`${intermediaryMatchingMandateLokalizePrefix}.labels.name`),
        email: translation(`${intermediaryMatchingMandateLokalizePrefix}.labels.email`),
        phoneNumber: translation(`${intermediaryMatchingMandateLokalizePrefix}.labels.phoneNumber`),
        message: translation(`${intermediaryMatchingMandateLokalizePrefix}.labels.message`),
        consent: translation(`${intermediaryMatchingMandateLokalizePrefix}.labels.consent`)
    };
    const placeHolders = {
        phoneNumber: translation(`${intermediaryMatchingMandateLokalizePrefix}.placeholders.phoneNumber`),
        message: translation(`${intermediaryMatchingMandateLokalizePrefix}.placeholders.message`)
    };
    return /*#__PURE__*/ jsxs(Box, {
        as: "form",
        onSubmit: handleSubmit(onSubmit),
        display: "flex",
        flexDirection: "column",
        gap: "spacing.20",
        alignItems: "center",
        justifyContent: "center",
        testId: `${testId}_form`,
        children: [
            /*#__PURE__*/ jsx(Controller, {
                name: "name",
                control: control,
                render: ({ field, fieldState: { error } })=>/*#__PURE__*/ jsx(TextField, {
                        ...field,
                        ...error && getError(labels.name, error.message),
                        label: labels.name,
                        hasNecessityIndicator: false,
                        testId: `${testId}_form-name`
                    })
            }),
            /*#__PURE__*/ jsx(Controller, {
                name: "email",
                control: control,
                render: ({ field, fieldState: { error } })=>/*#__PURE__*/ jsx(TextField, {
                        ...field,
                        ...error && getError(labels.email, error.message),
                        isDisabled: !!email,
                        label: labels.email,
                        hasNecessityIndicator: false,
                        placeholder: `johndoe@gmail.com`,
                        testId: `${testId}_form-email`
                    })
            }),
            /*#__PURE__*/ jsx(Controller, {
                name: "phoneNumber",
                control: control,
                render: ({ field, fieldState: { error } })=>/*#__PURE__*/ jsx(TextField, {
                        ...field,
                        ...error && getError(labels.phoneNumber, error.message),
                        label: labels.phoneNumber,
                        hasNecessityIndicator: false,
                        placeholder: placeHolders.phoneNumber,
                        testId: `${testId}_form-phoneNumber`
                    })
            }),
            /*#__PURE__*/ jsx(Controller, {
                name: "message",
                control: control,
                render: ({ field })=>/*#__PURE__*/ jsx(TextArea, {
                        ...field,
                        label: labels.message,
                        maxCharacters: 500,
                        placeholder: placeHolders.message,
                        testId: `${testId}_form-message`,
                        isOptional: true
                    })
            }),
            /*#__PURE__*/ jsx(Controller, {
                name: "consent",
                control: control,
                render: ({ field: { value, ...field }, fieldState: { error } })=>/*#__PURE__*/ jsx(Checkbox, {
                        isSelected: value,
                        ...field,
                        ...error && getError('consent', error.message),
                        hasNecessityIndicator: false,
                        testId: `${testId}_form-consent`,
                        children: labels.consent
                    })
            }),
            error && /*#__PURE__*/ jsx(StateMessage, {
                variant: "error",
                margin: "auto",
                children: translation('savedSearch_errorTechnical_text')
            }),
            /*#__PURE__*/ jsx(Button, {
                type: "submit",
                icon: EnvelopeIcon,
                iconPosition: "start",
                isLoading: isFetching,
                isFullWidth: true,
                testId: `${testId}_form-submit`,
                children: translation(`${intermediaryMatchingMandateLokalizePrefix}.submit`)
            })
        ]
    });
};

const IntermediaryMatchingMandateLegal = ({ brandConfig, translate })=>{
    const { upperLocal, country, terms, policy } = brandConfig.legals;
    return /*#__PURE__*/ jsxs(Box, {
        as: "p",
        margin: "0",
        typography: "typography.body.11.regular",
        children: [
            translate(`${intermediaryMatchingMandateLokalizePrefix}.legal.text.first`, {
                upperLocal,
                country
            }),
            " ",
            ' ',
            /*#__PURE__*/ jsxs(Box, {
                as: "a",
                href: "https://www.aviv-group.com/companies",
                target: "_blank",
                display: "inline",
                typography: "typography.body.11.boldUnderlined",
                color: "color.content.subdued.default",
                cursor: "pointer",
                userSelect: "none",
                children: [
                    translate(`${intermediaryMatchingMandateLokalizePrefix}.legal.text.link.first`),
                    " ",
                    ' '
                ]
            }),
            translate(`${intermediaryMatchingMandateLokalizePrefix}.legal.text.second`),
            " ",
            ' ',
            /*#__PURE__*/ jsx(Box, {
                as: "a",
                href: policy,
                target: "_blank",
                display: "inline",
                typography: "typography.body.11.boldUnderlined",
                color: "color.content.subdued.default",
                cursor: "pointer",
                userSelect: "none",
                children: translate(`${intermediaryMatchingMandateLokalizePrefix}.legal.text.link.second`)
            }),
            /*#__PURE__*/ jsx("br", {}),
            translate(`${intermediaryMatchingMandateLokalizePrefix}.legal.text.third`),
            " ",
            ' ',
            /*#__PURE__*/ jsxs(Box, {
                as: "a",
                href: terms,
                target: "_blank",
                display: "inline",
                typography: "typography.body.11.boldUnderlined",
                color: "color.content.subdued.default",
                cursor: "pointer",
                userSelect: "none",
                children: [
                    translate(`${intermediaryMatchingMandateLokalizePrefix}.legal.text.link.third`),
                    " ",
                    ' '
                ]
            }),
            translate(`${intermediaryMatchingMandateLokalizePrefix}.legal.text.fourth`)
        ]
    });
};

const IntermediaryMatchingMandateSuggestionsLi = ()=>{
    return /*#__PURE__*/ jsxs("svg", {
        width: "80",
        height: "80",
        viewBox: "0 0 80 80",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ jsxs("g", {
                clipPath: "url(#clip0_9668_65329)",
                children: [
                    /*#__PURE__*/ jsx("mask", {
                        id: "mask0_9668_65329",
                        style: {
                            maskType: 'luminance'
                        },
                        maskUnits: "userSpaceOnUse",
                        x: "0",
                        y: "0",
                        width: "80",
                        height: "80",
                        children: /*#__PURE__*/ jsx("path", {
                            d: "M80 0H0V79.9998H80V0Z",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ jsxs("g", {
                        mask: "url(#mask0_9668_65329)",
                        children: [
                            /*#__PURE__*/ jsx("path", {
                                d: "M39.5265 60.5849C39.0669 62.8322 37.3395 65.0133 34.3552 66.7349C27.2903 70.8088 15.8347 70.8088 8.76971 66.7349C5.60266 64.9083 3.85303 62.5666 3.52637 60.1755V55.8794C3.85303 58.2711 5.60266 60.6072 8.76971 62.4394C15.8347 66.5133 27.2903 66.5133 34.3552 62.4394C37.3395 60.7177 39.0669 58.5366 39.5265 56.2894V60.5794V60.5849Z",
                                fill: "#007DBD"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M21.5604 69.9233C16.904 69.9233 12.242 68.8994 8.69847 66.8567C5.62002 65.08 3.73195 62.7161 3.38867 60.1972V55.885C3.38867 55.8133 3.44406 55.7522 3.51604 55.7467C3.59356 55.7356 3.65447 55.7967 3.66001 55.8633C3.99221 58.2933 5.83041 60.585 8.83685 62.3178C15.852 66.3694 27.2688 66.3694 34.2839 62.3178C37.152 60.6622 38.9182 58.57 39.3888 56.2617C39.4054 56.19 39.4663 56.1456 39.5383 56.1511C39.6103 56.1567 39.6601 56.2172 39.6601 56.2895V60.5794C39.6601 60.5794 39.6601 60.5961 39.6601 60.6072C39.1673 62.9983 37.3568 65.1517 34.4223 66.8511C30.8788 68.8994 26.2168 69.9178 21.5604 69.9178V69.9233ZM3.66551 57.0756V60.1756C3.99772 62.5889 5.83597 64.8805 8.83685 66.6133C15.852 70.6594 27.2688 70.6594 34.2839 66.6133C37.1464 64.9633 38.9071 62.8711 39.3888 60.5683V57.28C38.658 59.2839 36.9582 61.0944 34.4223 62.5611C27.3297 66.6517 15.7911 66.6517 8.69847 62.5611C6.10169 61.0611 4.35207 59.1456 3.66551 57.0756Z",
                                fill: "black"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M7.59607 55.8468C7.20846 53.5216 8.55946 51.1193 11.6435 49.3479C17.1248 46.1871 26.0058 46.1871 31.4872 49.3479C34.6044 51.1469 35.9443 53.5825 35.518 55.924L35.363 56.1951C34.8647 54.6343 33.5746 53.1397 31.4817 51.933C26.0003 48.7667 17.1193 48.7667 11.6379 51.933C9.57268 53.1286 8.28262 54.6011 7.77879 56.1401L7.59607 55.8468Z",
                                fill: "#007DBD"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M35.3635 56.3334C35.3635 56.3334 35.3524 56.3334 35.3468 56.3334C35.2915 56.3284 35.2472 56.2895 35.2306 56.2395C34.7267 54.6509 33.4035 53.2061 31.4157 52.0547C25.9842 48.9161 17.142 48.9161 11.7103 52.0547C9.73929 53.195 8.42152 54.6232 7.91213 56.1895C7.89552 56.2395 7.85124 56.2784 7.79585 56.284C7.74602 56.2895 7.69068 56.2673 7.66296 56.2173L7.48024 55.924C7.48024 55.924 7.45813 55.8684 7.45813 55.8412C7.06502 53.3722 8.56546 50.9642 11.5775 49.2261C17.0866 46.0487 26.0506 46.0487 31.5597 49.2261C34.6215 50.9919 36.1165 53.4442 35.6569 55.9518C35.6569 55.9684 35.6458 55.9795 35.6403 55.9962L35.4853 56.2673C35.4631 56.3118 35.4133 56.339 35.3635 56.339V56.3334ZM21.5603 49.4309C25.1758 49.4309 28.7968 50.228 31.5486 51.8167C33.4755 52.9293 34.7987 54.3188 35.3856 55.8523C35.7953 53.4829 34.3502 51.158 31.4157 49.4697C25.9842 46.331 17.142 46.331 11.7103 49.4697C8.79802 51.1469 7.34741 53.4552 7.72941 55.8079L7.74052 55.8301C8.33296 54.3077 9.64513 52.9238 11.5664 51.8167C14.3182 50.228 17.9392 49.4309 21.5547 49.4309H21.5603Z",
                                fill: "black"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M8.77039 62.4505C15.8353 66.5243 27.2909 66.5243 34.3558 62.4505C41.4207 58.376 41.4207 51.7613 34.3558 47.6816C27.2909 43.6074 15.8353 43.6074 8.77039 47.6816C1.70544 51.7613 1.70544 58.3705 8.77039 62.4505ZM11.6439 49.3146C17.1254 46.1538 26.0063 46.1538 31.4877 49.3146C36.9692 52.4809 36.9692 57.6066 31.4877 60.7677C26.0063 63.9282 17.1254 63.9282 11.6439 60.7677C6.16256 57.601 6.16256 52.4754 11.6439 49.3146Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M21.5601 65.6444C16.9036 65.6444 12.2417 64.6205 8.69812 62.5777C5.23766 60.5794 3.33301 57.9166 3.33301 55.0715C3.33301 52.2263 5.23766 49.5637 8.69812 47.5654C15.7907 43.4746 27.3294 43.4746 34.422 47.5654C37.8825 49.5637 39.7872 52.2263 39.7872 55.0715C39.7872 57.9166 37.8825 60.5794 34.422 62.5777C30.8785 64.626 26.2165 65.6444 21.5601 65.6444ZM8.83656 62.3344C15.8517 66.3805 27.2685 66.3805 34.2836 62.3344C37.6555 60.3855 39.5103 57.8061 39.5103 55.0715C39.5103 52.337 37.6555 49.7519 34.2836 47.8089C27.2685 43.7625 15.8517 43.7625 8.83656 47.8089C5.46467 49.7575 3.60985 52.337 3.60985 55.0715C3.60985 57.8061 5.46467 60.3911 8.83656 62.3344ZM21.5601 63.2749C17.9446 63.2749 14.3235 62.4783 11.5717 60.8894C8.87534 59.3338 7.39145 57.2583 7.39145 55.0438C7.39145 52.8297 8.87534 50.7538 11.5717 49.1983C17.0808 46.021 26.0448 46.021 31.5539 49.1983C34.2503 50.7538 35.7342 52.8297 35.7342 55.0438C35.7342 57.2583 34.2503 59.3338 31.5539 60.8894C28.8022 62.4783 25.1811 63.2749 21.5656 63.2749H21.5601ZM21.5601 47.0838C17.9944 47.0838 14.4232 47.8699 11.7102 49.4364C9.10234 50.942 7.66834 52.9293 7.66834 55.0438C7.66834 57.1527 9.10234 59.1455 11.7102 60.6516C17.1417 63.7899 25.984 63.7899 31.4155 60.6516C34.0233 59.1455 35.4574 57.1527 35.4574 55.0438C35.4574 52.9348 34.0233 50.942 31.4155 49.4364C28.697 47.8699 25.1313 47.0838 21.5656 47.0838H21.5601Z",
                                fill: "black"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M42.0352 67.4987L35.1143 63.5076L36.2659 62.8376L43.1869 66.8343L42.0352 67.4987Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M42.0353 67.6372C42.0353 67.6372 41.9855 67.6316 41.9689 67.6205L35.0479 63.6294C35.0037 63.6072 34.9814 63.5572 34.9814 63.5077C34.9814 63.4577 35.0092 63.4133 35.0479 63.3861L36.1996 62.7161C36.2438 62.6939 36.2937 62.6883 36.338 62.7161L43.2589 66.7127C43.3032 66.735 43.3254 66.7844 43.3254 66.8344C43.3254 66.8844 43.2977 66.9288 43.2589 66.9561L42.1073 67.6205C42.1073 67.6205 42.063 67.6372 42.0408 67.6372H42.0353ZM35.3912 63.5077L42.0353 67.3383L42.9101 66.8344L36.266 62.9983L35.3912 63.5077Z",
                                fill: "black"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M43.1868 66.8289L42.0352 67.4933V68.805L43.1868 68.1355V66.8289Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M42.0352 68.9432C42.0352 68.9432 41.9854 68.9377 41.9688 68.9271C41.9245 68.9049 41.9023 68.8549 41.9023 68.8049V67.4932C41.9023 67.4432 41.93 67.3988 41.9688 67.3715L43.1204 66.7071C43.1647 66.6849 43.2146 66.6849 43.2588 66.7071C43.3031 66.7293 43.3253 66.7788 43.3253 66.8288V68.1354C43.3253 68.1849 43.2976 68.2293 43.2588 68.2571L42.1072 68.9271C42.1072 68.9271 42.0629 68.9432 42.0352 68.9432ZM42.1737 67.576V68.5671L43.0485 68.0577V67.0727L42.1737 67.576Z",
                                fill: "black"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M35.1143 63.5078V64.8139L42.0352 68.8106V67.4989L35.1143 63.5078Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M42.0353 68.9434C42.0353 68.9434 41.9855 68.9378 41.9689 68.9273L35.0479 64.9306C35.0037 64.9084 34.9814 64.8584 34.9814 64.8084V63.5023C34.9814 63.4523 35.0092 63.4078 35.0479 63.3806C35.0867 63.3528 35.1421 63.3584 35.1863 63.3806L42.1073 67.3717C42.1516 67.394 42.1738 67.4434 42.1738 67.4934V68.8051C42.1738 68.8551 42.1461 68.8995 42.1073 68.9273C42.0852 68.9378 42.063 68.9434 42.0408 68.9434H42.0353ZM35.2528 64.7312L41.8969 68.5673V67.5762L35.2528 63.7456V64.7312Z",
                                fill: "black"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M56.6356 75.9572L38.9121 65.7272L41.8687 64.0222L59.5922 74.2522L56.6356 75.9572Z",
                                fill: "#C2E0EF"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M56.6356 76.0954C56.6356 76.0954 56.5856 76.0899 56.569 76.0788L38.8457 65.8493C38.8015 65.8271 38.7793 65.7771 38.7793 65.7271C38.7793 65.6777 38.807 65.6332 38.8457 65.6054L41.8024 63.9005C41.8467 63.8782 41.8965 63.8782 41.9408 63.9005L59.664 74.1304C59.7084 74.1521 59.7306 74.2021 59.7306 74.2521C59.7306 74.3016 59.7029 74.346 59.664 74.3738L56.7073 76.0788C56.7073 76.0788 56.6629 76.0954 56.6412 76.0954H56.6356ZM39.189 65.7271L56.6356 75.7965L59.3151 74.2521L41.8688 64.1827L39.189 65.7271Z",
                                fill: "black"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M59.5919 74.2466L56.6357 75.9516V79.3005L59.5919 77.5955V74.2466Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M56.6363 79.4389C56.6363 79.4389 56.5863 79.4334 56.5696 79.4223C56.5251 79.4001 56.5029 79.3506 56.5029 79.3006V75.9517C56.5029 75.9017 56.5307 75.8573 56.5696 75.8295L59.5207 74.1251C59.5652 74.1028 59.6146 74.1028 59.659 74.1251C59.7035 74.1467 59.7257 74.1967 59.7257 74.2467V77.5956C59.7257 77.6456 59.6979 77.6895 59.659 77.7173L56.7079 79.4223C56.7079 79.4223 56.6635 79.4389 56.6418 79.4389H56.6363ZM56.7746 76.0345V79.0623L59.4485 77.5178V74.4901L56.7746 76.0345Z",
                                fill: "black"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M38.918 65.7272V69.0761L56.6414 79.3005V75.9517L38.918 65.7217V65.7272Z",
                                fill: "#C2E0EF"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M56.6356 79.4388C56.6356 79.4388 56.5856 79.4332 56.569 79.4221L38.8457 69.1983C38.8015 69.176 38.7793 69.126 38.7793 69.076V65.7271C38.7793 65.6777 38.807 65.6333 38.8457 65.6055C38.8845 65.5777 38.9399 65.5833 38.9842 65.6055L56.7073 75.8349C56.7517 75.8571 56.774 75.9071 56.774 75.9571V79.306C56.774 79.356 56.7462 79.3999 56.7073 79.4277C56.6851 79.4388 56.6629 79.4443 56.6412 79.4443L56.6356 79.4388ZM39.0506 68.9933L56.4967 79.0621V76.0343L39.0506 65.9655V68.9988V68.9933Z",
                                fill: "black"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M26.2383 40.3083L26.1719 17.2031L38.984 14.4519L52.9367 32.6471L53.0032 55.7523L26.2383 40.3027V40.3083Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M53.0032 55.8906C53.0032 55.8906 52.9533 55.8851 52.9367 55.874L26.172 40.4246C26.1277 40.4024 26.1055 40.3527 26.1055 40.3028L26.0391 17.1976C26.0391 17.1311 26.0834 17.0758 26.1498 17.0592L38.9619 14.308C39.0117 14.2969 39.0671 14.3191 39.1003 14.3579L53.053 32.5531C53.053 32.5531 53.0807 32.6084 53.0807 32.6361L53.1471 55.7412C53.1471 55.7912 53.1195 55.8356 53.0807 55.8634C53.0585 55.874 53.0364 55.8795 53.0087 55.8795L53.0032 55.8906ZM26.3768 40.2253L52.8648 55.5144L52.7983 32.697L38.9232 14.6069L26.3104 17.3138L26.3768 40.2253Z",
                                fill: "black"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M53.0039 55.7522L52.9375 32.6471L76.2863 18.825L76.3524 41.9302L53.0039 55.7522Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M53.0037 55.8905C53.0037 55.8905 52.9594 55.885 52.9373 55.8739C52.893 55.8522 52.8653 55.8022 52.8653 55.7522L52.7988 32.6471C52.7988 32.5973 52.8265 32.553 52.8653 32.5254L76.2138 18.7031C76.2583 18.6755 76.3077 18.6755 76.3522 18.7031C76.3966 18.7253 76.4244 18.7751 76.4244 18.825L76.4905 41.9302C76.4905 41.98 76.4633 42.0242 76.4244 42.052L53.0757 55.8739C53.0757 55.8739 53.0314 55.8961 53.0037 55.8961V55.8905ZM53.0757 32.7246L53.1421 55.5088L76.2138 41.8471L76.1472 19.063L53.0757 32.7246Z",
                                fill: "black"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M38.9841 14.452L52.9367 32.6473L76.2911 18.8971L62.3272 0.696289L38.9785 14.452H38.9841Z",
                                fill: "#007DBD"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M52.9373 32.7855C52.893 32.7855 52.8542 32.7689 52.8265 32.7302L38.8738 14.5349C38.8516 14.5017 38.8406 14.463 38.8461 14.4242C38.8517 14.3855 38.8794 14.3522 38.9126 14.3301L62.261 0.574347C62.3221 0.541134 62.3994 0.552203 62.4438 0.607558L76.4021 18.8083C76.4244 18.8416 76.4355 18.8803 76.4299 18.9191C76.4244 18.9578 76.3966 18.991 76.3633 19.0131L53.0092 32.7634C53.0092 32.7634 52.9649 32.78 52.9373 32.78V32.7855ZM39.1894 14.4906L52.976 32.4645L76.0921 18.8582L62.2999 0.878824L39.1894 14.4906Z",
                                fill: "black"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M26.1999 17.1644L38.9179 14.4796L62.2163 0.707275L49.4931 3.39202L26.1943 17.1644H26.1999Z",
                                fill: "#007DBD"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M26.2051 17.3028C26.1497 17.3028 26.0999 17.2695 26.0777 17.2142C26.0556 17.1533 26.0777 17.0813 26.1386 17.0426L49.4374 3.27021C49.4374 3.27021 49.4651 3.25916 49.4817 3.25362L62.2054 0.574412C62.2715 0.557807 62.3382 0.596568 62.3604 0.657462C62.3826 0.718351 62.3604 0.790312 62.2993 0.829062L39.0006 14.6014C39.0006 14.6014 38.9729 14.6125 38.9563 14.618L26.2383 17.3028C26.2383 17.3028 26.2217 17.3028 26.2106 17.3028H26.2051ZM49.5536 3.51931L27.0023 16.8544L38.8732 14.3468L61.4298 1.01728L49.5536 3.51931Z",
                                fill: "black"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M34.3448 44.9526L34.2783 33.5549L41.2049 37.5516L41.2713 48.9492L34.3448 44.947V44.9526Z",
                                fill: "#C2E0EF"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M41.2763 49.0932C41.2763 49.0932 41.2264 49.0877 41.2098 49.0766L34.2833 45.0745C34.239 45.0523 34.2169 45.0025 34.2169 44.9527L34.1504 33.5551C34.1504 33.5052 34.1781 33.4609 34.2169 33.4333C34.2612 33.4112 34.311 33.4056 34.3553 33.4333L41.2818 37.4299C41.3261 37.452 41.3482 37.5019 41.3482 37.5517L41.4147 48.9493C41.4147 48.9991 41.3869 49.0435 41.3482 49.0711C41.3261 49.0822 41.3039 49.0877 41.2763 49.0877V49.0932ZM34.4882 44.8752L41.1378 48.7169L41.0769 37.6347L34.4272 33.7986L34.4882 44.8752Z",
                                fill: "black"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M34.2832 33.5549L34.3496 44.9526L35.7061 44.1831L35.6397 34.3354L34.2832 33.5549Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M34.3448 45.0911C34.3448 45.0911 34.295 45.0855 34.2784 45.0745C34.2341 45.0523 34.212 45.0025 34.212 44.9527L34.1455 33.5551C34.1455 33.5052 34.1732 33.4609 34.212 33.4333C34.2562 33.4112 34.3061 33.4056 34.3503 33.4333L35.7068 34.2138C35.7511 34.2359 35.7733 34.2858 35.7733 34.3301L35.8397 44.1777C35.8397 44.2275 35.8121 44.2718 35.7678 44.2995L34.4112 45.0689C34.4112 45.0689 34.367 45.0855 34.3448 45.0855V45.0911ZM34.4168 33.7931L34.4777 44.7146L35.5573 44.1002L35.491 34.4131L34.4168 33.7931Z",
                                fill: "black"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M35.7006 44.1832L41.2651 47.4049L41.2762 48.9493L34.3496 44.9472L35.7061 44.1777L35.7006 44.1832Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M41.2769 49.0931C41.2769 49.0931 41.227 49.0875 41.2104 49.0764L34.2839 45.0743C34.2396 45.0521 34.2119 45.0023 34.2175 44.9525C34.223 44.9027 34.2451 44.8584 34.2894 44.8307L35.6459 44.0613C35.6902 44.0391 35.7401 44.0391 35.7844 44.0613L41.3488 47.2829C41.3931 47.3051 41.4153 47.3549 41.4153 47.4048L41.4263 48.9491C41.4263 48.999 41.3987 49.0432 41.3599 49.0709C41.3378 49.082 41.3156 49.0875 41.2879 49.0875L41.2769 49.0931ZM34.6272 44.958L41.1384 48.7166V47.4933L35.7013 44.3491L34.6272 44.958Z",
                                fill: "black"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M37.4949 40.4467C37.4173 40.4467 37.3564 40.3858 37.3564 40.3083V39.5112C37.3564 39.4337 37.4173 39.3728 37.4949 39.3728C37.5724 39.3728 37.6333 39.4337 37.6333 39.5112V40.3083C37.6333 40.3858 37.5724 40.4467 37.4949 40.4467Z",
                                fill: "black"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M41.166 30.3055C42.3731 29.6081 42.3731 27.3496 41.166 25.2572C39.959 23.1647 37.999 22.0411 36.792 22.7385C35.585 23.436 35.585 25.6945 36.792 27.7869C37.999 29.8738 39.959 31.003 41.166 30.3055Z",
                                fill: "#007DBD"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M40.3745 30.6488C39.1619 30.6488 37.667 29.5693 36.6758 27.8589C35.4301 25.7056 35.4522 23.3585 36.7257 22.6223C37.3569 22.2569 38.1818 22.3344 39.0511 22.8382C39.8983 23.3253 40.69 24.1612 41.288 25.1963C41.886 26.2259 42.2126 27.333 42.2126 28.3128C42.2126 29.3203 41.8693 30.0731 41.2382 30.4329C40.978 30.5823 40.6845 30.6543 40.3745 30.6543V30.6488ZM37.6005 22.6721C37.3292 22.6721 37.0801 22.733 36.8641 22.8603C35.7235 23.519 35.7457 25.7 36.914 27.7205C38.0822 29.7409 39.9592 30.848 41.0997 30.1893C41.6368 29.8793 41.9358 29.2096 41.9358 28.3072C41.9358 27.3773 41.6202 26.32 41.0499 25.3291C40.4796 24.3383 39.7211 23.5412 38.9127 23.0762C38.4476 22.8105 37.9992 22.6721 37.6005 22.6721Z",
                                fill: "black"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M59.166 14.4907L63.8449 20.5908L70.616 16.7104L65.9321 10.6047L59.166 14.4851V14.4907Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M63.8447 20.7291C63.8003 20.7291 63.7614 20.7125 63.7336 20.6737L59.0497 14.5736C59.0275 14.5404 59.0164 14.5016 59.0219 14.4629C59.0275 14.4241 59.0553 14.391 59.0886 14.3688L65.8597 10.4884C65.9208 10.4552 65.998 10.4663 66.0369 10.5216L70.7214 16.6273C70.743 16.6605 70.7541 16.6992 70.7486 16.738C70.743 16.7767 70.7158 16.81 70.6825 16.8321L63.9108 20.7125C63.9108 20.7125 63.8664 20.7291 63.8447 20.7291ZM59.3708 14.5294L63.883 20.4081L70.4114 16.666L65.8986 10.7818L59.3708 14.5238V14.5294Z",
                                fill: "black"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M63.2461 19.7771L69.1872 16.2842L70.6155 16.7104L63.8444 20.5908L63.2461 19.7771Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M63.8448 20.7292C63.8004 20.7292 63.7615 20.707 63.7337 20.6738L63.136 19.8601C63.1137 19.8268 63.1026 19.7881 63.1137 19.7493C63.1193 19.7106 63.1471 19.6774 63.1804 19.6552L69.121 16.1623C69.1543 16.1457 69.1932 16.1402 69.2321 16.1513L70.6604 16.5775C70.716 16.5941 70.7543 16.6384 70.7598 16.6937C70.7654 16.7491 70.7382 16.8045 70.6937 16.8321L63.9221 20.7125C63.9221 20.7125 63.8776 20.7292 63.856 20.7292H63.8448ZM63.446 19.8158L63.8832 20.4081L70.2671 16.7491L69.2098 16.428L63.4515 19.8102L63.446 19.8158Z",
                                fill: "black"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M70.6156 16.7105L69.1929 16.2842L65.1729 11.0366L65.9373 10.6104L70.6212 16.7161L70.6156 16.7105Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M70.6157 16.8488C70.6157 16.8488 70.5879 16.8487 70.5774 16.8432L69.1541 16.417C69.1263 16.4115 69.1041 16.3893 69.0824 16.3672L65.0624 11.1195C65.0402 11.0863 65.0291 11.0475 65.0346 11.0088C65.0402 10.97 65.0679 10.9368 65.1013 10.9147L65.8652 10.4885C65.9263 10.4553 65.9979 10.4719 66.0424 10.5272L70.7268 16.6329C70.7652 16.6827 70.7652 16.7491 70.7268 16.7934C70.6991 16.8322 70.6602 16.8543 70.6102 16.8543L70.6157 16.8488ZM69.2757 16.1624L70.2502 16.4557L65.9041 10.7874L65.3835 11.0808L69.2813 16.1679L69.2757 16.1624Z",
                                fill: "black"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ jsx("defs", {
                children: /*#__PURE__*/ jsx("clipPath", {
                    id: "clip0_9668_65329",
                    children: /*#__PURE__*/ jsx("rect", {
                        width: "80",
                        height: "80",
                        fill: "white"
                    })
                })
            })
        ]
    });
};

const IntermediaryMatchingMandateSuggestionsSl = ()=>{
    return /*#__PURE__*/ jsxs("svg", {
        width: "80",
        height: "80",
        viewBox: "0 0 80 80",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ jsxs("g", {
                clipPath: "url(#clip0_9668_56399)",
                children: [
                    /*#__PURE__*/ jsx("mask", {
                        id: "mask0_9668_56399",
                        style: {
                            maskType: 'luminance'
                        },
                        maskUnits: "userSpaceOnUse",
                        x: "0",
                        y: "0",
                        width: "80",
                        height: "80",
                        children: /*#__PURE__*/ jsx("path", {
                            d: "M80 0H0V79.9998H80V0Z",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ jsxs("g", {
                        mask: "url(#mask0_9668_56399)",
                        children: [
                            /*#__PURE__*/ jsx("path", {
                                d: "M39.5265 60.5849C39.0669 62.8322 37.3395 65.0133 34.3552 66.7349C27.2903 70.8088 15.8347 70.8088 8.76971 66.7349C5.60266 64.9083 3.85303 62.5666 3.52637 60.1755V55.8794C3.85303 58.2711 5.60266 60.6072 8.76971 62.4394C15.8347 66.5133 27.2903 66.5133 34.3552 62.4394C37.3395 60.7177 39.0669 58.5366 39.5265 56.2894V60.5794V60.5849Z",
                                fill: "#CA2E5F"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M21.5604 69.9231C16.904 69.9231 12.242 68.8992 8.69847 66.8564C5.62002 65.0797 3.73195 62.7159 3.38867 60.197V55.8848C3.38867 55.8131 3.44406 55.752 3.51604 55.7464C3.59356 55.7353 3.65447 55.7964 3.66001 55.8631C3.99221 58.2931 5.83041 60.5848 8.83685 62.3175C15.852 66.3692 27.2688 66.3692 34.2839 62.3175C37.152 60.662 38.9182 58.5698 39.3888 56.2614C39.4054 56.1898 39.4663 56.1453 39.5383 56.1509C39.6103 56.1564 39.6601 56.217 39.6601 56.2892V60.5792C39.6601 60.5792 39.6601 60.5959 39.6601 60.607C39.1673 62.9981 37.3568 65.1514 34.4223 66.8509C30.8788 68.8992 26.2168 69.9175 21.5604 69.9175V69.9231ZM3.66551 57.0753V60.1753C3.99772 62.5886 5.83597 64.8803 8.83685 66.6131C15.852 70.6592 27.2688 70.6592 34.2839 66.6131C37.1464 64.9631 38.9071 62.8709 39.3888 60.5681V57.2798C38.658 59.2836 36.9582 61.0942 34.4223 62.5609C27.3297 66.6514 15.7911 66.6514 8.69847 62.5609C6.10169 61.0609 4.35207 59.1453 3.66551 57.0753Z",
                                fill: "black"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M7.59607 55.8465C7.20846 53.5214 8.55946 51.119 11.6435 49.3476C17.1248 46.1869 26.0058 46.1869 31.4872 49.3476C34.6044 51.1467 35.9443 53.5823 35.518 55.9237L35.363 56.1948C34.8647 54.6341 33.5746 53.1395 31.4817 51.9327C26.0003 48.7664 17.1193 48.7664 11.6379 51.9327C9.57268 53.1284 8.28262 54.6008 7.77879 56.1398L7.59607 55.8465Z",
                                fill: "#CA2E5F"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M35.3635 56.3332C35.3635 56.3332 35.3524 56.3332 35.3468 56.3332C35.2915 56.3282 35.2472 56.2893 35.2306 56.2393C34.7267 54.6506 33.4035 53.2059 31.4157 52.0545C25.9842 48.9158 17.142 48.9158 11.7103 52.0545C9.73929 53.1948 8.42152 54.623 7.91213 56.1893C7.89552 56.2393 7.85124 56.2782 7.79585 56.2837C7.74602 56.2893 7.69068 56.2671 7.66296 56.2171L7.48024 55.9237C7.48024 55.9237 7.45813 55.8682 7.45813 55.841C7.06502 53.372 8.56546 50.964 11.5775 49.2258C17.0866 46.0484 26.0506 46.0484 31.5597 49.2258C34.6215 50.9916 36.1165 53.4439 35.6569 55.9515C35.6569 55.9682 35.6458 55.9793 35.6403 55.996L35.4853 56.2671C35.4631 56.3115 35.4133 56.3387 35.3635 56.3387V56.3332ZM21.5603 49.4306C25.1758 49.4306 28.7968 50.2278 31.5486 51.8165C33.4755 52.9291 34.7987 54.3185 35.3856 55.8521C35.7953 53.4826 34.3502 51.1577 31.4157 49.4694C25.9842 46.3308 17.142 46.3308 11.7103 49.4694C8.79802 51.1466 7.34741 53.455 7.72941 55.8076L7.74052 55.8299C8.33296 54.3074 9.64513 52.9236 11.5664 51.8165C14.3182 50.2278 17.9392 49.4306 21.5547 49.4306H21.5603Z",
                                fill: "black"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M8.77039 62.4505C15.8353 66.5243 27.2909 66.5243 34.3558 62.4505C41.4207 58.376 41.4207 51.7613 34.3558 47.6816C27.2909 43.6074 15.8353 43.6074 8.77039 47.6816C1.70544 51.7613 1.70544 58.3705 8.77039 62.4505ZM11.6439 49.3146C17.1254 46.1538 26.0063 46.1538 31.4877 49.3146C36.9692 52.4809 36.9692 57.6066 31.4877 60.7677C26.0063 63.9282 17.1254 63.9282 11.6439 60.7677C6.16256 57.601 6.16256 52.4754 11.6439 49.3146Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M21.5601 65.6446C16.9036 65.6446 12.2417 64.6207 8.69812 62.578C5.23766 60.5796 3.33301 57.9169 3.33301 55.0717C3.33301 52.2265 5.23766 49.5639 8.69812 47.5656C15.7907 43.4749 27.3294 43.4749 34.422 47.5656C37.8825 49.5639 39.7872 52.2265 39.7872 55.0717C39.7872 57.9169 37.8825 60.5796 34.422 62.578C30.8785 64.6263 26.2165 65.6446 21.5601 65.6446ZM8.83656 62.3346C15.8517 66.3807 27.2685 66.3807 34.2836 62.3346C37.6555 60.3857 39.5103 57.8063 39.5103 55.0717C39.5103 52.3373 37.6555 49.7521 34.2836 47.8091C27.2685 43.7627 15.8517 43.7627 8.83656 47.8091C5.46467 49.7577 3.60985 52.3373 3.60985 55.0717C3.60985 57.8063 5.46467 60.3913 8.83656 62.3346ZM21.5601 63.2752C17.9446 63.2752 14.3235 62.4785 11.5717 60.8896C8.87534 59.3341 7.39145 57.2585 7.39145 55.0441C7.39145 52.8299 8.87534 50.7541 11.5717 49.1986C17.0808 46.0212 26.0448 46.0212 31.5539 49.1986C34.2503 50.7541 35.7342 52.8299 35.7342 55.0441C35.7342 57.2585 34.2503 59.3341 31.5539 60.8896C28.8022 62.4785 25.1811 63.2752 21.5656 63.2752H21.5601ZM21.5601 47.084C17.9944 47.084 14.4232 47.8701 11.7102 49.4366C9.10234 50.9423 7.66834 52.9295 7.66834 55.0441C7.66834 57.153 9.10234 59.1457 11.7102 60.6518C17.1417 63.7902 25.984 63.7902 31.4155 60.6518C34.0233 59.1457 35.4574 57.153 35.4574 55.0441C35.4574 52.9351 34.0233 50.9423 31.4155 49.4366C28.697 47.8701 25.1313 47.084 21.5656 47.084H21.5601Z",
                                fill: "black"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M42.0352 67.499L35.1143 63.5079L36.2659 62.8379L43.1869 66.8345L42.0352 67.499Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M42.0353 67.6372C42.0353 67.6372 41.9855 67.6316 41.9689 67.6205L35.0479 63.6294C35.0037 63.6072 34.9814 63.5572 34.9814 63.5077C34.9814 63.4577 35.0092 63.4133 35.0479 63.3861L36.1996 62.7161C36.2438 62.6939 36.2937 62.6883 36.338 62.7161L43.2589 66.7127C43.3032 66.735 43.3254 66.7844 43.3254 66.8344C43.3254 66.8844 43.2977 66.9288 43.2589 66.9561L42.1073 67.6205C42.1073 67.6205 42.063 67.6372 42.0408 67.6372H42.0353ZM35.3912 63.5077L42.0353 67.3383L42.9101 66.8344L36.266 62.9983L35.3912 63.5077Z",
                                fill: "black"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M43.1868 66.8291L42.0352 67.4935V68.8052L43.1868 68.1358V66.8291Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M42.0352 68.9432C42.0352 68.9432 41.9854 68.9377 41.9688 68.9271C41.9245 68.9049 41.9023 68.8549 41.9023 68.8049V67.4932C41.9023 67.4432 41.93 67.3988 41.9688 67.3715L43.1204 66.7071C43.1647 66.6849 43.2146 66.6849 43.2588 66.7071C43.3031 66.7293 43.3253 66.7788 43.3253 66.8288V68.1354C43.3253 68.1849 43.2976 68.2293 43.2588 68.2571L42.1072 68.9271C42.1072 68.9271 42.0629 68.9432 42.0352 68.9432ZM42.1737 67.576V68.5671L43.0485 68.0577V67.0727L42.1737 67.576Z",
                                fill: "black"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M35.1143 63.5078V64.8139L42.0352 68.8106V67.4989L35.1143 63.5078Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M42.0353 68.9434C42.0353 68.9434 41.9855 68.9378 41.9689 68.9273L35.0479 64.9306C35.0037 64.9084 34.9814 64.8584 34.9814 64.8084V63.5023C34.9814 63.4523 35.0092 63.4078 35.0479 63.3806C35.0867 63.3528 35.1421 63.3584 35.1863 63.3806L42.1073 67.3717C42.1516 67.394 42.1738 67.4434 42.1738 67.4934V68.8051C42.1738 68.8551 42.1461 68.8995 42.1073 68.9273C42.0852 68.9378 42.063 68.9434 42.0408 68.9434H42.0353ZM35.2528 64.7312L41.8969 68.5673V67.5762L35.2528 63.7456V64.7312Z",
                                fill: "black"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M56.6356 75.9569L38.9121 65.727L41.8687 64.022L59.5922 74.252L56.6356 75.9569Z",
                                fill: "#FFC2CD"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M56.6356 76.0954C56.6356 76.0954 56.5856 76.0899 56.569 76.0788L38.8457 65.8493C38.8015 65.8271 38.7793 65.7771 38.7793 65.7271C38.7793 65.6777 38.807 65.6332 38.8457 65.6054L41.8024 63.9005C41.8467 63.8782 41.8965 63.8782 41.9408 63.9005L59.664 74.1304C59.7084 74.1521 59.7306 74.2021 59.7306 74.2521C59.7306 74.3016 59.7029 74.346 59.664 74.3738L56.7073 76.0788C56.7073 76.0788 56.6629 76.0954 56.6412 76.0954H56.6356ZM39.189 65.7271L56.6356 75.7965L59.3151 74.2521L41.8688 64.1827L39.189 65.7271Z",
                                fill: "black"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M59.5919 74.2466L56.6357 75.9516V79.3005L59.5919 77.5955V74.2466Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M56.6363 79.4389C56.6363 79.4389 56.5863 79.4334 56.5696 79.4223C56.5251 79.4001 56.5029 79.3506 56.5029 79.3006V75.9517C56.5029 75.9017 56.5307 75.8573 56.5696 75.8295L59.5207 74.1251C59.5652 74.1028 59.6146 74.1028 59.659 74.1251C59.7035 74.1467 59.7257 74.1967 59.7257 74.2467V77.5956C59.7257 77.6456 59.6979 77.6895 59.659 77.7173L56.7079 79.4223C56.7079 79.4223 56.6635 79.4389 56.6418 79.4389H56.6363ZM56.7746 76.0345V79.0623L59.4485 77.5178V74.4901L56.7746 76.0345Z",
                                fill: "black"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M38.918 65.7272V69.0761L56.6414 79.3005V75.9517L38.918 65.7217V65.7272Z",
                                fill: "#FFC2CD"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M56.6356 79.439C56.6356 79.439 56.5856 79.4335 56.569 79.4224L38.8457 69.1985C38.8015 69.1763 38.7793 69.1263 38.7793 69.0763V65.7274C38.7793 65.6779 38.807 65.6335 38.8457 65.6057C38.8845 65.5779 38.9399 65.5835 38.9842 65.6057L56.7073 75.8352C56.7517 75.8574 56.774 75.9074 56.774 75.9574V79.3063C56.774 79.3563 56.7462 79.4001 56.7073 79.4279C56.6851 79.439 56.6629 79.4446 56.6412 79.4446L56.6356 79.439ZM39.0506 68.9935L56.4967 79.0624V76.0346L39.0506 65.9657V68.999V68.9935Z",
                                fill: "black"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M26.2383 40.3081L26.1719 17.2028L38.984 14.4517L52.9367 32.6469L53.0032 55.752L26.2383 40.3025V40.3081Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M53.0032 55.8906C53.0032 55.8906 52.9533 55.8851 52.9367 55.874L26.172 40.4246C26.1277 40.4024 26.1055 40.3527 26.1055 40.3028L26.0391 17.1976C26.0391 17.1311 26.0834 17.0758 26.1498 17.0592L38.9619 14.308C39.0117 14.2969 39.0671 14.3191 39.1003 14.3579L53.053 32.5531C53.053 32.5531 53.0807 32.6084 53.0807 32.6361L53.1471 55.7412C53.1471 55.7912 53.1195 55.8356 53.0807 55.8634C53.0585 55.874 53.0364 55.8795 53.0087 55.8795L53.0032 55.8906ZM26.3768 40.2253L52.8648 55.5144L52.7983 32.697L38.9232 14.6069L26.3104 17.3138L26.3768 40.2253Z",
                                fill: "black"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M53.0039 55.7525L52.9375 32.6473L76.2863 18.8252L76.3524 41.9304L53.0039 55.7525Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M53.0037 55.8908C53.0037 55.8908 52.9594 55.8852 52.9373 55.8741C52.893 55.8525 52.8653 55.8025 52.8653 55.7525L52.7988 32.6473C52.7988 32.5976 52.8265 32.5533 52.8653 32.5256L76.2138 18.7034C76.2583 18.6757 76.3077 18.6757 76.3522 18.7034C76.3966 18.7255 76.4244 18.7754 76.4244 18.8252L76.4905 41.9304C76.4905 41.9803 76.4633 42.0245 76.4244 42.0522L53.0757 55.8741C53.0757 55.8741 53.0314 55.8963 53.0037 55.8963V55.8908ZM53.0757 32.7248L53.1421 55.509L76.2138 41.8474L76.1472 19.0632L53.0757 32.7248Z",
                                fill: "black"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M38.9841 14.452L52.9367 32.6473L76.2911 18.8971L62.3272 0.696289L38.9785 14.452H38.9841Z",
                                fill: "#CA2E5F"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M52.9373 32.7855C52.893 32.7855 52.8542 32.7689 52.8265 32.7302L38.8738 14.5349C38.8516 14.5017 38.8406 14.463 38.8461 14.4242C38.8517 14.3855 38.8794 14.3522 38.9126 14.3301L62.261 0.574347C62.3221 0.541134 62.3994 0.552203 62.4438 0.607558L76.4021 18.8083C76.4244 18.8416 76.4355 18.8803 76.4299 18.9191C76.4244 18.9578 76.3966 18.991 76.3633 19.0131L53.0092 32.7634C53.0092 32.7634 52.9649 32.78 52.9373 32.78V32.7855ZM39.1894 14.4906L52.976 32.4645L76.0921 18.8582L62.2999 0.878824L39.1894 14.4906Z",
                                fill: "black"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M26.1999 17.1641L38.9179 14.4794L62.2163 0.707031L49.4931 3.39178L26.1943 17.1641H26.1999Z",
                                fill: "#CA2E5F"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M26.2051 17.3025C26.1497 17.3025 26.0999 17.2693 26.0777 17.2139C26.0556 17.153 26.0777 17.0811 26.1386 17.0423L49.4374 3.26996C49.4374 3.26996 49.4651 3.25891 49.4817 3.25337L62.2054 0.574168C62.2715 0.557563 62.3382 0.596324 62.3604 0.657218C62.3826 0.718107 62.3604 0.790068 62.2993 0.828818L39.0006 14.6012C39.0006 14.6012 38.9729 14.6122 38.9563 14.6178L26.2383 17.3025C26.2383 17.3025 26.2217 17.3025 26.2106 17.3025H26.2051ZM49.5536 3.51907L27.0023 16.8542L38.8732 14.3465L61.4298 1.01704L49.5536 3.51907Z",
                                fill: "black"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M34.3448 44.9528L34.2783 33.5552L41.2049 37.5518L41.2713 48.9495L34.3448 44.9473V44.9528Z",
                                fill: "#FFC2CD"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M41.2763 49.0932C41.2763 49.0932 41.2264 49.0877 41.2098 49.0766L34.2833 45.0745C34.239 45.0523 34.2169 45.0025 34.2169 44.9527L34.1504 33.5551C34.1504 33.5052 34.1781 33.4609 34.2169 33.4333C34.2612 33.4112 34.311 33.4056 34.3553 33.4333L41.2818 37.4299C41.3261 37.452 41.3482 37.5019 41.3482 37.5517L41.4147 48.9493C41.4147 48.9991 41.3869 49.0435 41.3482 49.0711C41.3261 49.0822 41.3039 49.0877 41.2763 49.0877V49.0932ZM34.4882 44.8752L41.1378 48.7169L41.0769 37.6347L34.4272 33.7986L34.4882 44.8752Z",
                                fill: "black"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M34.2832 33.5552L34.3496 44.9528L35.7061 44.1834L35.6397 34.3357L34.2832 33.5552Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M34.3448 45.0911C34.3448 45.0911 34.295 45.0855 34.2784 45.0745C34.2341 45.0523 34.212 45.0025 34.212 44.9527L34.1455 33.5551C34.1455 33.5052 34.1732 33.4609 34.212 33.4333C34.2562 33.4112 34.3061 33.4056 34.3503 33.4333L35.7068 34.2138C35.7511 34.2359 35.7733 34.2858 35.7733 34.3301L35.8397 44.1777C35.8397 44.2275 35.8121 44.2718 35.7678 44.2995L34.4112 45.0689C34.4112 45.0689 34.367 45.0855 34.3448 45.0855V45.0911ZM34.4168 33.7931L34.4777 44.7146L35.5573 44.1002L35.491 34.4131L34.4168 33.7931Z",
                                fill: "black"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M35.7006 44.1832L41.2651 47.4049L41.2762 48.9493L34.3496 44.9472L35.7061 44.1777L35.7006 44.1832Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M41.2769 49.0933C41.2769 49.0933 41.227 49.0878 41.2104 49.0767L34.2839 45.0745C34.2396 45.0524 34.2119 45.0026 34.2175 44.9528C34.223 44.9029 34.2451 44.8586 34.2894 44.8309L35.6459 44.0615C35.6902 44.0394 35.7401 44.0394 35.7844 44.0615L41.3488 47.2832C41.3931 47.3053 41.4153 47.3552 41.4153 47.405L41.4263 48.9494C41.4263 48.9992 41.3987 49.0435 41.3599 49.0712C41.3378 49.0823 41.3156 49.0878 41.2879 49.0878L41.2769 49.0933ZM34.6272 44.9583L41.1384 48.7169V47.4936L35.7013 44.3494L34.6272 44.9583Z",
                                fill: "black"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M37.4949 40.4469C37.4173 40.4469 37.3564 40.386 37.3564 40.3085V39.5114C37.3564 39.4339 37.4173 39.373 37.4949 39.373C37.5724 39.373 37.6333 39.4339 37.6333 39.5114V40.3085C37.6333 40.386 37.5724 40.4469 37.4949 40.4469Z",
                                fill: "black"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M41.166 30.3055C42.3731 29.6081 42.3731 27.3496 41.166 25.2572C39.959 23.1647 37.999 22.0411 36.792 22.7385C35.585 23.436 35.585 25.6945 36.792 27.7869C37.999 29.8738 39.959 31.003 41.166 30.3055Z",
                                fill: "#CA2E5F"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M40.3745 30.6488C39.1619 30.6488 37.667 29.5693 36.6758 27.8589C35.4301 25.7056 35.4522 23.3585 36.7257 22.6223C37.3569 22.2569 38.1818 22.3344 39.0511 22.8382C39.8983 23.3253 40.69 24.1612 41.288 25.1963C41.886 26.2259 42.2126 27.333 42.2126 28.3128C42.2126 29.3203 41.8693 30.0731 41.2382 30.4329C40.978 30.5823 40.6845 30.6543 40.3745 30.6543V30.6488ZM37.6005 22.6721C37.3292 22.6721 37.0801 22.733 36.8641 22.8603C35.7235 23.519 35.7457 25.7 36.914 27.7205C38.0822 29.7409 39.9592 30.848 41.0997 30.1893C41.6368 29.8793 41.9358 29.2096 41.9358 28.3072C41.9358 27.3773 41.6202 26.32 41.0499 25.3291C40.4796 24.3383 39.7211 23.5412 38.9127 23.0762C38.4476 22.8105 37.9992 22.6721 37.6005 22.6721Z",
                                fill: "black"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M59.166 14.4904L63.8449 20.5906L70.616 16.7101L65.9321 10.6045L59.166 14.4849V14.4904Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M63.8447 20.7291C63.8003 20.7291 63.7614 20.7125 63.7336 20.6737L59.0497 14.5736C59.0275 14.5404 59.0164 14.5016 59.0219 14.4629C59.0275 14.4241 59.0553 14.391 59.0886 14.3688L65.8597 10.4884C65.9208 10.4552 65.998 10.4663 66.0369 10.5216L70.7214 16.6273C70.743 16.6605 70.7541 16.6992 70.7486 16.738C70.743 16.7767 70.7158 16.81 70.6825 16.8321L63.9108 20.7125C63.9108 20.7125 63.8664 20.7291 63.8447 20.7291ZM59.3708 14.5294L63.883 20.4081L70.4114 16.666L65.8986 10.7818L59.3708 14.5238V14.5294Z",
                                fill: "black"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M63.2461 19.7771L69.1872 16.2842L70.6155 16.7104L63.8444 20.5908L63.2461 19.7771Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M63.8448 20.7292C63.8004 20.7292 63.7615 20.707 63.7337 20.6738L63.136 19.8601C63.1137 19.8268 63.1026 19.7881 63.1137 19.7493C63.1193 19.7106 63.1471 19.6774 63.1804 19.6552L69.121 16.1623C69.1543 16.1457 69.1932 16.1402 69.2321 16.1513L70.6604 16.5775C70.716 16.5941 70.7543 16.6384 70.7598 16.6937C70.7654 16.7491 70.7382 16.8045 70.6937 16.8321L63.9221 20.7125C63.9221 20.7125 63.8776 20.7292 63.856 20.7292H63.8448ZM63.446 19.8158L63.8832 20.4081L70.2671 16.7491L69.2098 16.428L63.4515 19.8102L63.446 19.8158Z",
                                fill: "black"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M70.6156 16.7105L69.1929 16.2842L65.1729 11.0366L65.9373 10.6104L70.6212 16.7161L70.6156 16.7105Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M70.6157 16.849C70.6157 16.849 70.5879 16.849 70.5774 16.8435L69.1541 16.4172C69.1263 16.4117 69.1041 16.3895 69.0824 16.3674L65.0624 11.1198C65.0402 11.0866 65.0291 11.0478 65.0346 11.0091C65.0402 10.9703 65.0679 10.9371 65.1013 10.9149L65.8652 10.4887C65.9263 10.4555 65.9979 10.4721 66.0424 10.5274L70.7268 16.6331C70.7652 16.6829 70.7652 16.7494 70.7268 16.7937C70.6991 16.8324 70.6602 16.8545 70.6102 16.8545L70.6157 16.849ZM69.2757 16.1626L70.2502 16.456L65.9041 10.7876L65.3835 11.081L69.2813 16.1682L69.2757 16.1626Z",
                                fill: "black"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ jsx("defs", {
                children: /*#__PURE__*/ jsx("clipPath", {
                    id: "clip0_9668_56399",
                    children: /*#__PURE__*/ jsx("rect", {
                        width: "80",
                        height: "80",
                        fill: "white"
                    })
                })
            })
        ]
    });
};

const IntermediaryMatchingMandateSuggestions = ({ translation, brandConfig, testId })=>{
    const deviceType = useBreakpointValue({
        base: 'mobile',
        md: 'desktop'
    });
    const suggestionsGridTemplates = {
        mobile: `
    "title title icon"
    "text text text"
    `,
        desktop: `
    "title title icon"
    "text text icon"
    `
    };
    const suggestionsGridColumns = {
        mobile: '1fr 1fr auto',
        desktop: '1fr 1fr auto'
    };
    return /*#__PURE__*/ jsxs(Box, {
        as: "div",
        display: "grid",
        gridTemplateAreas: suggestionsGridTemplates[deviceType],
        gridTemplateColumns: suggestionsGridColumns[deviceType],
        padding: "spacing.16",
        gap: "spacing.16",
        borderRadius: "radius.8",
        backgroundColor: "color.surface.accent.light.default",
        testId: `${testId}_suggestions`,
        children: [
            /*#__PURE__*/ jsx(Box, {
                as: "h3",
                gridArea: "title",
                margin: "0",
                typography: "typography.headline.20.bold",
                testId: `${testId}_suggestions-title`,
                children: translation(`${intermediaryMatchingMandateLokalizePrefix}.suggestions.title`)
            }),
            /*#__PURE__*/ jsx(Box, {
                as: "p",
                gridArea: "text",
                margin: "0",
                typography: "typography.body.14.regular",
                testId: `${testId}_suggestions-text`,
                children: translation(`${intermediaryMatchingMandateLokalizePrefix}.suggestions.text`)
            }),
            brandConfig.brandId === 'sl' && /*#__PURE__*/ jsx(Box, {
                as: "div",
                width: "fit-content",
                gridArea: "icon",
                testId: `${testId}_suggestions-img`,
                children: /*#__PURE__*/ jsx(IntermediaryMatchingMandateSuggestionsSl, {})
            }),
            brandConfig.brandId === 'li' && /*#__PURE__*/ jsx(Box, {
                as: "div",
                width: "fit-content",
                gridArea: "icon",
                testId: `${testId}_suggestions-img`,
                children: /*#__PURE__*/ jsx(IntermediaryMatchingMandateSuggestionsLi, {})
            })
        ]
    });
};

const IntermediaryMatchingMandate = ({ search, brandConfig, translation, onSuccess, email, callsConfig })=>{
    const [error, setError] = useState(false);
    const [isFetching, setIsFetching] = useState(false);
    const { success } = useSnackbar();
    const trackOpenIntermediaryMatchingMandate = useThorEvent({
        eventData: intermediaryMatchingMandateThorEvent(search, 'lead_classified_mandate_research_opened')
    });
    const trackSubmitIntermediaryMatchingMandate = useThorEvent({
        eventData: intermediaryMatchingMandateThorEvent(search, 'lead_classified_mandate_research_submit')
    });
    const trackConfirmIntermediaryMatchingMandate = useThorEvent({
        eventData: intermediaryMatchingMandateThorEvent(search, 'lead_classified_mandate_research_confirm')
    });
    const displayIntermediaryMatchingMandateSucces = ()=>success({
            description: translation(`${intermediaryMatchingMandateLokalizePrefix}.success`),
            action: {
                children: ''
            },
            variant: 'success',
            testId: "av-ssab-Button['contact']-Snackbar['success']"
        });
    const intermediaryMatchingMandateSuccess = ()=>{
        setIsFetching(false);
        setError(false);
        onSuccess();
        displayIntermediaryMatchingMandateSucces();
        trackConfirmIntermediaryMatchingMandate();
    };
    const intermediaryMatchingMandateError = ()=>{
        setIsFetching(false);
        setError(true);
    };
    const onSubmit = async (data)=>{
        setIsFetching(true);
        trackSubmitIntermediaryMatchingMandate();
        const payload = createIntermediaryMatchingMandatePayload(data, search);
        const options = {
            body: payload
        };
        await createIntermediaryMatchingMandate(intermediaryMatchingMandateSuccess, intermediaryMatchingMandateError, options);
    };
    useEffect(()=>{
        trackOpenIntermediaryMatchingMandate();
    }, []);
    return /*#__PURE__*/ jsxs(Box, {
        as: "div",
        display: "flex",
        flexDirection: "column",
        gap: "spacing.16",
        testId: `${intermediaryMatchingMandateTestId}_container`,
        children: [
            /*#__PURE__*/ jsx(IntermediaryMatchingMandateSuggestions, {
                translation: translation,
                brandConfig: brandConfig,
                testId: intermediaryMatchingMandateTestId
            }),
            /*#__PURE__*/ jsx(IntermediaryMatchingMandateForm, {
                onSubmit: onSubmit,
                translation: translation,
                testId: intermediaryMatchingMandateTestId,
                email: email,
                isFetching: isFetching,
                error: error
            }),
            /*#__PURE__*/ jsx(IntermediaryMatchingMandateLegal, {
                brandConfig: brandConfig,
                translate: translation
            })
        ]
    });
};

const getRangeNew = (min, max, symbol = "")=>{
    if (min && max) {
        return `${min} - ${max}${' '}${symbol}`;
    } else if (min) {
        return `${min}${' '}${symbol}`;
    } else if (max) {
        return `${max}${' '}${symbol}`;
    }
    return ``;
};

const IconCriteria = ({ type, text })=>{
    const iconProps = {
        size: 'sizing.20'
    };
    return text ? /*#__PURE__*/ jsxs(Box, {
        display: "flex",
        alignItems: "center",
        gap: "spacing.4",
        width: "fit-content",
        typography: "typography.body.14.regular",
        children: [
            type === 'price' ? /*#__PURE__*/ jsx(EuroSignIcon, {
                ...iconProps
            }) : type === 'room' ? /*#__PURE__*/ jsx(DoorClosedIcon, {
                ...iconProps
            }) : type === 'm' ? /*#__PURE__*/ jsx(ExpandIcon, {
                ...iconProps
            }) : /*#__PURE__*/ jsx(BedFrontIcon, {
                ...iconProps
            }),
            text
        ]
    }) : null;
};

const LegacyCriteriaTags = ({ criterias })=>{
    const maxCriterias = 5;
    if (!criterias?.length) {
        return null;
    }
    return /*#__PURE__*/ jsxs(Box, {
        width: "100%",
        as: "div",
        display: "flex",
        alignItems: "center",
        gap: "spacing.12",
        flexWrap: 'wrap',
        children: [
            criterias.slice(0, maxCriterias).map((criteria, i)=>/*#__PURE__*/ jsx(Tag, {
                    variant: "subdued",
                    children: criteria
                }, i)),
            criterias.length > maxCriterias && /*#__PURE__*/ jsx(Tag, {
                variant: "subdued",
                children: "..."
            })
        ]
    });
};

const CardCriterias = ({ item, legacyItem, testId, locale, translate })=>{
    if (isLegacySLGSavedSearch(legacyItem)) {
        return /*#__PURE__*/ jsx(LegacyCriteriaTags, {
            criterias: legacyItem.searchCriterias
        });
    }
    const price = getRangeNew(formatNumber$1(item.criteria.prices.priceMin, locale), formatNumber$1(item.criteria.prices.priceMax, locale));
    const rooms = getRangeNew(item.criteria.structure?.rooms?.numberOfRoomsMin, item.criteria.structure?.rooms?.numberOfRoomsMax, translate('savedSearch.iconCriteria.rooms.text'));
    const area = getRangeNew(formatNumber$1(item.criteria.spaces.spaceMin, locale), formatNumber$1(item.criteria.spaces.spaceMax, locale), 'm²');
    const beds = getRangeNew(item.criteria.structure?.rooms?.numberOfBedRoomsMin, item.criteria.structure?.rooms?.numberOfBedRoomsMax, 'ch');
    const noCriteria = !price && !rooms && !area && !beds;
    const criterias = mapCriteriaToWording(item, translate);
    return /*#__PURE__*/ jsxs(Fragment, {
        children: [
            /*#__PURE__*/ jsxs(Box, {
                as: "div",
                color: "color.content.default.default",
                typography: "typography.body.16.regular",
                display: noCriteria ? 'none' : 'flex',
                alignItems: 'center',
                gap: 'spacing.16',
                flexWrap: 'wrap',
                marginTop: "spacing.16",
                testId: `${testId}-Criterias`,
                children: [
                    /*#__PURE__*/ jsx(IconCriteria, {
                        type: "price",
                        text: price
                    }),
                    /*#__PURE__*/ jsx(IconCriteria, {
                        type: "m",
                        text: area
                    }),
                    /*#__PURE__*/ jsx(IconCriteria, {
                        type: "room",
                        text: rooms
                    }),
                    /*#__PURE__*/ jsx(IconCriteria, {
                        type: "bed",
                        text: beds
                    })
                ]
            }),
            /*#__PURE__*/ jsx(Divider, {
                marginTop: "spacing.12",
                marginBottom: "spacing.12"
            }),
            /*#__PURE__*/ jsx(Box, {
                as: "p",
                margin: "0",
                typography: "typography.body.14.regular",
                children: criterias.join(' ・ ')
            })
        ]
    });
};

const CardLocations = ({ locations, testId, className })=>{
    return /*#__PURE__*/ jsx(Box, {
        as: "p",
        margin: "0",
        testId: `${testId}-Description-Locations`,
        unsafe_className: className,
        typography: "typography.body.14.regular",
        children: locations
    });
};

const EmailGroup = ({ state, setState, currentState, setCurrentState, translate, testId })=>{
    const items = [
        {
            label: translate('savedSearch.notificationsEdit.frequency.daily'),
            value: SavedSearchFrequency.daily
        },
        {
            label: translate('savedSearch.notificationsEdit.frequency.realtime'),
            value: SavedSearchFrequency.realtime
        },
        {
            label: translate('savedSearch.notificationsEdit.frequency.never'),
            value: 'never'
        }
    ];
    const handleChange = (value)=>{
        setState(value);
        if (value === 'never' && currentState.recommendation) {
            setCurrentState({
                email: value,
                recommendation: false
            });
        } else setCurrentState({
            ...currentState,
            email: value
        });
    };
    useEffect(()=>{
        setState(currentState.email);
    }, [
        currentState.email
    ]);
    return /*#__PURE__*/ jsx(Box, {
        as: "div",
        unsafe_className: "radio_group-container",
        children: /*#__PURE__*/ jsx(RadioGroup, {
            items: items,
            name: "email-radio-group",
            label: translate('savedSearch.notificationsEdit.email'),
            hasNecessityIndicator: false,
            value: state,
            onChange: handleChange,
            testId: testId
        })
    });
};
const RecommendationGroup = ({ state, setState, currentState, setCurrentState, defaultEmailState, translate, testId })=>{
    const items = [
        {
            label: translate('savedSearch.notificationsEdit.recommendation.text'),
            value: 'recommendation'
        }
    ];
    const handleChange = (value)=>{
        setState(value);
        if (value.includes('recommendation') && currentState.email === 'never') {
            setCurrentState({
                email: defaultEmailState,
                recommendation: true
            });
        } else setCurrentState({
            ...currentState,
            recommendation: value.includes('recommendation')
        });
    };
    useEffect(()=>{
        setState(currentState.recommendation ? [
            'recommendation'
        ] : []);
    }, [
        currentState.recommendation
    ]);
    return /*#__PURE__*/ jsx(ToggleGroup, {
        items: items,
        name: "recommendations-toggle-group",
        label: translate('savedSearch.notificationsEdit.recommendation.title'),
        hasNecessityIndicator: false,
        onChange: handleChange,
        value: state,
        testId: testId
    });
};

const getToggleDefaultState$1 = (item)=>{
    const emailChannel = item?.channels?.find((channel)=>channel.channel === SavedSearchNotificationChannel.email);
    const emailFrequencyValue = !emailChannel?.enabled ? 'never' : emailChannel?.frequency ?? SavedSearchFrequency.realtime;
    const recommendationChannel = item?.relaxedCriteria?.isEnabled;
    return {
        email: emailFrequencyValue,
        recommendation: recommendationChannel
    };
};
const CardNotifications = ({ item, brandConfig, onSuccess, onError, isAnonyme, callsConfig, translate, authToken, testId })=>{
    const defaultState = useMemo(()=>getToggleDefaultState$1(item), [
        item
    ]);
    const [currentState, setCurrentState] = useState(defaultState);
    const [emailState, setEmailState] = useState(defaultState.email);
    const [recommendationState, setRecommendationState] = useState(defaultState.recommendation ? [
        'recommendation'
    ] : []);
    const [isUpdating, setIsUpdating] = useState(false);
    const { identity } = item;
    const [isOpen, setIsOpen] = useState(false);
    const isDisabled = currentState.email === defaultState.email && currentState.recommendation === defaultState.recommendation;
    const useRecommendations = brandConfig.recommendations;
    const trackSavedSearchEnableAlert = useThorEvent({
        eventData: mapSavedSearchToogleAlertToThorEvent(item, 'email', 'enable_alert_notification')
    });
    const trackSavedSearchDisableAlert = useThorEvent({
        eventData: mapSavedSearchToogleAlertToThorEvent(item, 'email', 'disable_alert_notification')
    });
    const ChannelTrigger = ()=>{
        return /*#__PURE__*/ jsxs(Box, {
            backgroundColor: 'color.surface.light.default',
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: 'spacing.12',
            gap: "spacing.12",
            borderRadius: 'radius.8',
            margin: "0",
            marginTop: "spacing.16",
            as: "div",
            cursor: "pointer",
            onClick: ()=>setIsOpen(!isOpen),
            testId: `${testId}-Notifications-Trigger`,
            children: [
                /*#__PURE__*/ jsx(Box, {
                    margin: "0",
                    as: "p",
                    typography: "typography.body.14.regular",
                    children: translate('savedSearch.notificationsEdit.trigger')
                }),
                /*#__PURE__*/ jsx(Box, {
                    display: "flex",
                    cursor: "pointer",
                    alignItems: "center",
                    gap: "spacing.6",
                    children: /*#__PURE__*/ jsx(ChevronRightIcon, {})
                })
            ]
        });
    };
    const updateItemSuccess = ()=>{
        onSuccess({
            ...item,
            channels: [
                ...item.channels.filter((channel)=>channel.channel !== SavedSearchNotificationChannel.email),
                {
                    channel: SavedSearchNotificationChannel.email,
                    enabled: currentState.email !== 'never',
                    frequency: currentState.email !== 'never' ? currentState.email : undefined
                }
            ],
            relaxedCriteria: {
                ...item.relaxedCriteria,
                isEnabled: currentState.recommendation
            }
        });
        if (defaultState.email !== currentState.email) {
            if (currentState.email) {
                trackSavedSearchEnableAlert();
            } else {
                trackSavedSearchDisableAlert();
            }
        }
        setIsOpen(false);
        setIsUpdating(false);
    };
    const updateItemError = ()=>{
        onError();
        setIsUpdating(false);
    };
    const handleWLUpdate = (targets)=>{
        setIsUpdating(true);
        const enabled = currentState.email !== 'never';
        const frequency = currentState.email !== 'never' ? currentState.email : defaultState.email;
        if (targets.includes(NotificationsTargetEnum.EMAIL) && targets.includes(NotificationsTargetEnum.RECOMMENDATIONS) && useRecommendations) {
            updateChannelState(updateItemSuccess, updateItemError, {
                authenticationToken: authToken ?? '',
                body: {
                    channelName: NotificationsTargetEnum.EMAIL,
                    enabled,
                    frequency
                },
                id: identity.id
            });
            updateAlternativeState(updateItemSuccess, updateItemError, {
                authenticationToken: authToken ?? '',
                value: currentState.recommendation,
                id: identity.id
            });
        } else if (targets.includes(NotificationsTargetEnum.EMAIL)) {
            updateChannelState(updateItemSuccess, updateItemError, {
                authenticationToken: authToken ?? '',
                body: {
                    channelName: NotificationsTargetEnum.EMAIL,
                    enabled,
                    frequency
                },
                id: identity.id
            });
        } else if (targets.includes(NotificationsTargetEnum.RECOMMENDATIONS) && useRecommendations) {
            updateAlternativeState(updateItemSuccess, updateItemError, {
                authenticationToken: authToken ?? '',
                value: currentState.recommendation,
                id: identity.id
            });
        }
    };
    const handleUpdate = ()=>{
        setIsUpdating(true);
        if (!isAnonyme) {
            if (currentState.email !== defaultState.email && currentState.recommendation !== defaultState.recommendation && useRecommendations) {
                handleWLUpdate([
                    NotificationsTargetEnum.EMAIL,
                    NotificationsTargetEnum.RECOMMENDATIONS
                ]);
            } else if (currentState.email !== defaultState.email) {
                handleWLUpdate([
                    NotificationsTargetEnum.EMAIL
                ]);
            } else if (currentState.recommendation !== defaultState.recommendation && useRecommendations) {
                handleWLUpdate([
                    NotificationsTargetEnum.RECOMMENDATIONS
                ]);
            }
        } else {
            const params = getParams();
            if (params) {
                if (currentState.email !== defaultState.email) {
                    updateWLChannelAnonymous(updateItemSuccess, updateItemError, {
                        params,
                        value: currentState.email});
                }
                if (currentState.recommendation !== defaultState.recommendation && useRecommendations) {
                    updateAlternativeState(updateItemSuccess, updateItemError, {
                        authenticationToken: authToken ?? '',
                        value: currentState.recommendation,
                        id: identity.id
                    });
                }
            }
        }
    };
    return /*#__PURE__*/ jsx(Modal, {
        title: translate('savedSearch.notificationsEdit.title'),
        testId: `${testId}-Modal-Notifications`,
        onOpenChange: ()=>setIsOpen(!isOpen),
        isOpen: isOpen,
        isDismissable: true,
        trigger: ChannelTrigger,
        footerEndButtonProps: {
            onPress: handleUpdate,
            children: translate('savedSearch.actions.update'),
            isDisabled,
            isLoading: isUpdating,
            testId: `${testId}-Modal-Update-Button`
        },
        children: /*#__PURE__*/ jsxs(Box, {
            as: "div",
            display: "flex",
            flexDirection: "column",
            gap: "spacing.16",
            children: [
                /*#__PURE__*/ jsx(EmailGroup, {
                    state: emailState,
                    setState: setEmailState,
                    currentState: currentState,
                    setCurrentState: setCurrentState,
                    translate: translate,
                    testId: `${testId}-Email-Toggle`
                }),
                useRecommendations && /*#__PURE__*/ jsx(RecommendationGroup, {
                    state: recommendationState,
                    setState: setRecommendationState,
                    currentState: currentState,
                    setCurrentState: setCurrentState,
                    defaultEmailState: defaultState.email,
                    translate: translate,
                    testId: `${testId}-Recommendation-Toggle`
                })
            ]
        })
    });
};

const getToggleDefaultState = (item)=>{
    const emailChannel = item?.channels?.find((channel)=>channel.channel === SavedSearchNotificationChannel.email);
    const recommendationChannel = item?.relaxedCriteria?.isEnabled;
    return {
        email: emailChannel?.enabled ?? false,
        recommendation: recommendationChannel
    };
};
const ChannelTrigger = ({ isReadOnly, label, translate, state, testId })=>{
    return /*#__PURE__*/ jsxs(Box, {
        backgroundColor: 'color.surface.light.default',
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: 'spacing.12',
        gap: "spacing.12",
        borderRadius: 'radius.8',
        testId: testId,
        children: [
            /*#__PURE__*/ jsx(Box, {
                margin: "0",
                as: "p",
                typography: "typography.body.14.regular",
                children: label
            }),
            /*#__PURE__*/ jsxs(Box, {
                display: "flex",
                alignItems: "center",
                gap: "spacing.6",
                children: [
                    /*#__PURE__*/ jsx(Box, {
                        typography: "typography.body.14.bold",
                        margin: "0",
                        as: "p",
                        children: state ? translate('savedSearch.actions.enabled') : translate('savedSearch.actions.disabled')
                    }),
                    !isReadOnly && /*#__PURE__*/ jsx(ChevronRightIcon, {})
                ]
            })
        ]
    });
};
const LegacyCardNotifications = ({ item, brandConfig, onSuccess, onError, isAnonyme, legacyItem, callsConfig, translate, authToken, testId })=>{
    const defaultState = useMemo(()=>getToggleDefaultState(item), [
        item
    ]);
    const [isUpdating, setIsUpdating] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [toggleState, setToggleState] = useState(defaultState);
    const { identity } = item;
    const isDisabled = toggleState.email === defaultState.email && toggleState.recommendation === defaultState.recommendation;
    const useRecommendations = brandConfig.legacy.useRecommendations;
    const isReadOnly = brandConfig.legacy.channelInteractionEnabled === false;
    const trackSavedSearchEnableAlert = useThorEvent({
        eventData: mapSavedSearchToogleAlertToThorEvent(item, 'email', 'enable_alert_notification')
    });
    const trackSavedSearchDisableAlert = useThorEvent({
        eventData: mapSavedSearchToogleAlertToThorEvent(item, 'email', 'disable_alert_notification')
    });
    const ChannelsTriggerBox = ()=>{
        return /*#__PURE__*/ jsxs(Box, {
            backgroundColor: 'color.surface.light.default',
            display: "flex",
            flexDirection: "column",
            margin: "0",
            marginTop: "spacing.16",
            borderRadius: 'radius.8',
            as: "div",
            cursor: isReadOnly ? 'auto' : "pointer",
            onClick: ()=>{
                if (!isReadOnly) {
                    setIsOpen(!isOpen);
                }
            },
            children: [
                /*#__PURE__*/ jsx(ChannelTrigger, {
                    isReadOnly: isReadOnly,
                    label: translate('savedSearch.notificationsEdit.email'),
                    translate: translate,
                    state: defaultState.email,
                    testId: `${testId}-Email-Trigger`
                }, "trigger-mail"),
                useRecommendations && /*#__PURE__*/ jsxs(Fragment, {
                    children: [
                        /*#__PURE__*/ jsx(Divider, {}),
                        /*#__PURE__*/ jsx(ChannelTrigger, {
                            isReadOnly: isReadOnly,
                            label: translate('savedSearch.notificationsEdit.recommendation.title'),
                            state: defaultState.recommendation,
                            translate: translate,
                            testId: `${testId}-Recommendation-Trigger`
                        }, "trigger-recommendation")
                    ]
                })
            ]
        });
    };
    const updateItemSuccess = ()=>{
        onSuccess({
            ...item,
            channels: [
                {
                    channel: SavedSearchNotificationChannel.email,
                    enabled: toggleState.email
                }
            ],
            relaxedCriteria: {
                ...item.relaxedCriteria,
                isEnabled: toggleState.recommendation
            }
        });
        if (defaultState.email !== toggleState.email) {
            if (toggleState.email) {
                trackSavedSearchEnableAlert();
            } else {
                trackSavedSearchDisableAlert();
            }
        }
        setIsOpen(false);
        setIsUpdating(false);
    };
    const updateItemError = ()=>{
        onError();
        setIsUpdating(false);
    };
    const handleUpdate = ()=>{
        setIsUpdating(true);
        if (!isAnonyme) {
            if (isLegacySLGSavedSearch(legacyItem)) {
                updateLegacySLGNotificationsState(updateItemSuccess, updateItemError, {
                    id: identity.id,
                    value: toggleState.email,
                    config: callsConfig,
                    authenticationToken: authToken ?? ''
                });
            } else if (isLegacyIWTSavedSearch(legacyItem)) {
                updateLegacyIWTNotificationsStates(updateItemSuccess, updateItemError, {
                    id: identity.id,
                    item: legacyItem,
                    value: toggleState,
                    target: brandConfig.legacy.useRecommendations ? [
                        NotificationsTargetEnum.EMAIL,
                        NotificationsTargetEnum.RECOMMENDATIONS
                    ] : [
                        NotificationsTargetEnum.EMAIL
                    ],
                    config: callsConfig,
                    authenticationToken: authToken ?? ''
                });
            }
        } else {
            if (isLegacySLGSavedSearch(legacyItem)) {
                const legacyParams = getLegacyParams();
                if (!legacyParams) {
                    updateItemError();
                    return;
                }
                updateLegacySLGNotificationsStateAnonymous(updateItemSuccess, updateItemError, identity.id, toggleState.email, {
                    stage: callsConfig.stage,
                    params: legacyParams
                });
            } else if (isLegacyIWTSavedSearch(legacyItem)) {
                updateLegacyNotificationsStatesAnonymous(updateItemSuccess, updateItemError, {
                    ssid: legacyItem.baseAttributes.id,
                    item: legacyItem,
                    value: toggleState,
                    target: brandConfig.legacy.useRecommendations ? [
                        NotificationsTargetEnum.EMAIL,
                        NotificationsTargetEnum.RECOMMENDATIONS
                    ] : [
                        NotificationsTargetEnum.EMAIL
                    ],
                    config: callsConfig
                });
            }
        }
    };
    const handleToggle = (label)=>{
        setToggleState((prevState)=>{
            const newState = {
                ...prevState,
                [label]: !prevState[label]
            };
            if (label === 'email') {
                const newEmailState = !prevState.email;
                if (!newEmailState) {
                    newState.recommendation = false;
                }
            } else if (label === 'recommendation') {
                const newRecommendationState = !prevState.recommendation;
                if (newRecommendationState) {
                    newState.email = true;
                }
            }
            return newState;
        });
    };
    return /*#__PURE__*/ jsx(Modal, {
        title: translate('savedSearch.notificationsEdit.title'),
        testId: `${testId}-Modal-Notifications`,
        onOpenChange: ()=>setIsOpen(!isOpen),
        isOpen: isOpen,
        isDismissable: true,
        trigger: ChannelsTriggerBox,
        footerEndButtonProps: {
            onPress: handleUpdate,
            children: translate('savedSearch.actions.update'),
            isDisabled,
            isLoading: isUpdating,
            testId: `${testId}-Modal-Update-Button`
        },
        children: /*#__PURE__*/ jsxs(Box, {
            as: "div",
            display: "flex",
            flexDirection: "column",
            gap: "spacing.16",
            children: [
                /*#__PURE__*/ jsx(Toggle, {
                    hasNecessityIndicator: false,
                    onChange: ()=>handleToggle('email'),
                    testId: `${testId}-Email-Toggle`,
                    isSelected: toggleState.email,
                    children: translate('savedSearch.notificationsEdit.email')
                }),
                useRecommendations && /*#__PURE__*/ jsx(Toggle, {
                    hasNecessityIndicator: false,
                    onChange: ()=>handleToggle('recommendation'),
                    isSelected: toggleState.recommendation,
                    testId: `${testId}-Recommendation-Toggle`,
                    children: translate('savedSearch.notificationsEdit.recommendation.title')
                })
            ]
        })
    });
};

const DeletionModal = ({ item, isLegacy, callsConfig, testId, isAnonyme, open, setOpen, translate, authToken, dispatchDelete, toDisplay })=>{
    const { identity } = item;
    const { id } = identity;
    const { add } = useSnackbar();
    const t = translate;
    if (!t) return null;
    const trackSavedSearchDeleted = useThorEvent({
        eventData: mapSavedSearchDeletedToThorEvent(item)
    });
    const handleSuccessDelete = ()=>{
        dispatchDelete();
        add({
            description: t('savedSearch_alertDelete_text'),
            action: {
                children: ''
            },
            variant: 'success',
            testId: `${testId}-Snackbar-Success`
        });
        trackSavedSearchDeleted();
    };
    const handleErrorDelete = (error)=>{
        if (error.httpStatusCode === 401) {
            redirectToLogin(callsConfig.stage, callsConfig.brand);
        }
    };
    const deleteHandler = ()=>{
        const deleteOptions = {
            config: callsConfig,
            authenticationToken: authToken,
            id
        };
        setOpen(!open);
        if (!isLegacy) {
            if (isAnonyme) ; else {
                deleteSavedSearches(handleSuccessDelete, handleErrorDelete, deleteOptions);
            }
        } else {
            if (isAnonyme) {
                switch(callsConfig.brand){
                    case 'sl':
                        const legacyParams = getLegacyParams();
                        if (!legacyParams) return;
                        deleteLegacySLGAnonymousSavedSearch(handleSuccessDelete, handleErrorDelete, id, {
                            stage: callsConfig.stage,
                            params: legacyParams
                        });
                        break;
                    default:
                        deleteLegacyIWTSavedSearchesAnonymous(handleSuccessDelete, handleErrorDelete, {
                            config: callsConfig,
                            ssid: id
                        });
                        break;
                }
            } else if (callsConfig.brand === 'sl') {
                deleteLegacySLGSavedSearches(handleSuccessDelete, handleErrorDelete, deleteOptions);
            } else {
                deleteLegacyIWTSavedSearches(handleSuccessDelete, handleErrorDelete, deleteOptions);
            }
        }
    };
    const Trigger = /*#__PURE__*/ jsx(Box, {
        as: "div",
        onClick: ()=>setOpen(true),
        display: toDisplay ? 'block' : 'none',
        cursor: "pointer",
        testId: `${testId}`,
        children: /*#__PURE__*/ jsx(TrashCanIcon, {
            color: "color.content.default.default",
            testId: `${testId}-Icon`
        })
    });
    return /*#__PURE__*/ jsx(Box, {
        as: "div",
        children: /*#__PURE__*/ jsx(Modal, {
            testId: `${testId}-Modal`,
            isOpen: open,
            onOpenChange: ()=>setOpen(!open),
            isDismissable: true,
            hasContentPadding: false,
            trigger: ()=>Trigger,
            children: /*#__PURE__*/ jsxs(Box, {
                as: "div",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                gap: "spacing.24",
                padding: "spacing.24",
                width: "100%",
                children: [
                    /*#__PURE__*/ jsx(Box, {
                        as: "h3",
                        typography: "typography.headline.22.bold",
                        textAlign: "center",
                        margin: "0",
                        children: t('savedSearch.deleteAlertConfirmation.title')
                    }),
                    /*#__PURE__*/ jsx(Box, {
                        as: "p",
                        typography: "typography.body.16.regular",
                        textAlign: "center",
                        margin: "0",
                        children: t('savedSearch.deleteAlertConfirmation.text')
                    }),
                    /*#__PURE__*/ jsxs(Box, {
                        as: "div",
                        margin: "0",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "spacing.8",
                        width: "100%",
                        children: [
                            /*#__PURE__*/ jsx(Button, {
                                onPress: deleteHandler,
                                size: "40",
                                isFullWidth: true,
                                variant: "primary",
                                testId: `${testId}-Button-Delete`,
                                children: t('savedSearch.alertDelete.action')
                            }),
                            /*#__PURE__*/ jsx(Button, {
                                onPress: ()=>setOpen(false),
                                isFullWidth: true,
                                size: "40",
                                variant: "tertiary",
                                testId: `${testId}-Button-Cancel`,
                                children: t('savedSearch.cancel.action')
                            })
                        ]
                    })
                ]
            })
        })
    });
};

const getDesignCard = (isModal)=>{
    return {
        as: 'div',
        display: 'flex',
        flexDirection: 'column',
        padding: 'spacing.16',
        borderWidth: 'borderWidth.1',
        borderRadius: 'radius.16',
        borderStyle: 'solid',
        borderColor: 'color.border.light.default',
        gap: isModal ? 'spacing.8' : 'initial',
        width: isModal ? "100%" : {
            'breakpoint.xs': '100%',
            'breakpoint.md': '640px'
        },
        maxWidth: isModal ? "initial" : '640px'
    };
};
const getDesignCardTitleContainer = (testId)=>{
    return {
        as: 'div',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        marginBottom: 'spacing.12',
        testId: `${testId}-Header`
    };
};
const getDesignCardTitle = (isMobile, testId)=>{
    return {
        as: 'h2',
        typography: 'typography.body.16.bold',
        margin: 0,
        width: isMobile ? '90%' : '95%',
        testId: `${testId}-Header-Title`
    };
};

const CardTitle = ({ title, brandConfig, stage, locale, item, translate, callsConfig, isAnonyme, dispatchDelete, isModal, dispatchUpdate, isMobile, testId, authToken })=>{
    const [customTitle, setCustomTitle] = useState(title);
    const { error } = useSnackbar();
    const [deleteOpen, setDeleteOpen] = useState(false);
    const isLegacy = isLegacySavedSearch(item);
    const initialModel = reverseWLItemToSearchModel(item);
    const editAuthorized = !isModal && !isLegacy;
    const toDisplayEdit = editAuthorized && !isMobile;
    const toDisplayDelete = isModal || !isMobile;
    const trackEditOpen = useThorEvent({
        // @ts-ignore
        eventData: mapSavedSearchEditAlert(item, 'edit_alert')
    });
    const trackEditConfirmation = useThorEvent({
        // @ts-ignore
        eventData: mapSavedSearchEditAlert(item, 'edit_alert_confirmation')
    });
    const submitUpdate = async (res)=>{
        if (res?.locations?.length > 10) {
            error({
                description: translate('savedSearch_locationTooLarge_text'),
                action: {
                    children: ''
                },
                variant: 'error',
                testId: "av-ssab-Button['createAlert']-Snackbar['error']"
            });
            return;
        }
        const updatePayload = {
            criteria: getSavedSearchCriteria(res),
            channels: item.channels,
            externalProperties: {
                ...item?.externalProperties
            },
            title: item.title ? customTitle : customTitle !== title ? customTitle : undefined
        };
        dispatchUpdate({
            ...item,
            ...updatePayload
        });
        const updateSuccess = (res)=>{
            if (res) {
                const getSuccess = (res)=>{
                    const newItem = res?.data;
                    dispatchUpdate(newItem);
                };
                getSavedSearch(getSuccess, updateError, {
                    id: item.identity.id,
                    authenticationToken: authToken ?? ''
                });
                trackEditConfirmation();
            }
        };
        const updateError = (err)=>{
            console.log(err);
        };
        updateSavedSearch(updateSuccess, updateError, {
            authenticationToken: authToken ?? '',
            id: item.identity.id,
            body: clearObject(updatePayload)
        });
    };
    return /*#__PURE__*/ jsxs(Box, {
        ...getDesignCardTitleContainer(testId),
        justifyContent: isModal || isLegacy ? 'space-between' : 'initial',
        children: [
            /*#__PURE__*/ jsx(Box, {
                ...getDesignCardTitle(isMobile, testId),
                children: title
            }),
            /*#__PURE__*/ jsxs(Box, {
                display: "flex",
                alignItems: "start",
                flexDirection: isMobile ? 'row-reverse' : 'row',
                justifyContent: isMobile ? 'end' : 'initial',
                unsafe_className: "saved_search-actionmenu",
                gap: isMobile ? 'initial' : 'spacing.32',
                children: [
                    editAuthorized && /*#__PURE__*/ jsx(SearchEdit, {
                        stage: stage,
                        locale: locale,
                        brand: brandConfig.searchBrand,
                        cancelText: translate('savedSearch.cancel.action'),
                        onSubmit: submitUpdate,
                        initialModel: initialModel,
                        submitText: translate('savedSearch.actions.update'),
                        title: translate('savedSearch.actions.editAlert'),
                        formId: item.identity.id,
                        customElement: /*#__PURE__*/ jsx(Box, {
                            as: "div",
                            marginBottom: "spacing.12",
                            children: /*#__PURE__*/ jsx(TextField, {
                                testId: testId + '-Title-Input',
                                label: translate('savedSearch.actions.alertTitle'),
                                hasNecessityIndicator: false,
                                value: customTitle,
                                onChange: (e)=>setCustomTitle(e)
                            })
                        }),
                        trigger: (props)=>toDisplayEdit ? /*#__PURE__*/ jsx(Box, {
                                as: "div",
                                cursor: "pointer",
                                onClick: ()=>{
                                    trackEditOpen();
                                    props.onPress();
                                },
                                children: /*#__PURE__*/ jsx(PenIcon, {
                                    testId: testId + '-Header-Update-Icon'
                                })
                            }) : /*#__PURE__*/ jsx(ActionMenu, {
                                "aria-label": title,
                                menuItems: [
                                    {
                                        id: 'edit',
                                        children: translate('savedSearch.actions.edit'),
                                        elementType: 'button',
                                        onAction: ()=>{
                                            trackEditOpen();
                                            props.onPress();
                                        }
                                    },
                                    {
                                        id: 'delete',
                                        children: translate('savedSearch.alertDelete.action'),
                                        elementType: 'button',
                                        onAction: ()=>setDeleteOpen(true)
                                    }
                                ],
                                children: (renderProps)=>/*#__PURE__*/ jsx(Button, {
                                        ...renderProps,
                                        variant: "tertiary",
                                        size: "40",
                                        icon: EllipsisVerticalIcon,
                                        testId: "SavedSearchCard-Header-ActionMenu",
                                        iconOnly: true,
                                        children: "Toggle menu"
                                    })
                            })
                    }),
                    /*#__PURE__*/ jsx(DeletionModal, {
                        item: item,
                        isLegacy: isLegacy,
                        testId: `${testId}-Header-Delete`,
                        translate: translate,
                        isAnonyme: isAnonyme,
                        callsConfig: callsConfig,
                        dispatchDelete: dispatchDelete,
                        toDisplay: toDisplayDelete,
                        open: deleteOpen,
                        setOpen: setDeleteOpen,
                        authToken: authToken ?? ''
                    })
                ]
            })
        ]
    });
};

const SerpLink = ({ stage, brand, item, display, translate, testId })=>{
    if (isLegacySavedSearch(item)) {
        return null;
    }
    const searchUrl = mapSearchModelToQueryString(reverseWLItemToSearchModel(item));
    const listingsLink = searchUrl ? getListingsLink(stage, brand, searchUrl) : getListingsLink(stage, brand, '');
    const trackSeeProperties = useThorEvent({
        eventData: mapSavedSearchSeePropertiesToThorEvent(item)
    });
    return /*#__PURE__*/ jsx(Box, {
        as: "div",
        width: "100%",
        margin: "auto",
        gap: "spacing.12",
        testId: testId,
        marginTop: "spacing.16",
        display: "flex",
        justifyContent: "end",
        alignItems: "center",
        children: /*#__PURE__*/ jsx(Button, {
            variant: "secondary",
            href: listingsLink,
            // @ts-ignore
            onPressStart: trackSeeProperties,
            isFullWidth: display === "mobile",
            children: translate('savedSearch.actions.listings')
        })
    });
};

const mobileCardClasses = 'saved_search-criterias_display saved_search-criterias_display-mobile';
const desktopCardClasses = 'saved_search-criterias_display saved_search-criterias_display-desktop';
const SavedSearchCard = ({ item, brandConfig, index, translate, onAlertUpdate, onAlertDelete, locale, callsConfig, isAnonyme, deviceType, authToken, legacyItem, isModal })=>{
    const { stage } = callsConfig;
    const isLegacy = isLegacySavedSearch(item);
    const testIdPrefix = `av-ssap-AlertPage-${isLegacy ? 'Legacy' : 'WL'}Alert`;
    const testId = `${testIdPrefix}[${index}]-SavedSearchCard`;
    const cardWording = getWLItemWording(item, translate);
    const notificationsProps = {
        item,
        brandConfig: brandConfig,
        onSuccess: onAlertUpdate ?? (()=>{}),
        onError: ()=>{},
        isAnonyme,
        callsConfig,
        translate,
        authToken,
        testId
    };
    return /*#__PURE__*/ jsxs(Box, {
        ...getDesignCard(isModal ?? false),
        children: [
            /*#__PURE__*/ jsx(CardTitle, {
                title: cardWording.title,
                isMobile: deviceType === 'mobile',
                testId: `${testIdPrefix}[${index}]-SavedSearchCard`,
                stage: stage,
                brandConfig: brandConfig,
                dispatchDelete: onAlertDelete ?? (()=>{}),
                dispatchUpdate: onAlertUpdate ?? (()=>{}),
                locale: locale,
                item: item,
                translate: translate,
                authToken: authToken,
                callsConfig: callsConfig,
                isAnonyme: isAnonyme,
                isModal: isModal
            }),
            /*#__PURE__*/ jsx(CardLocations, {
                locations: cardWording?.adLocations,
                className: deviceType === 'mobile' ? mobileCardClasses : desktopCardClasses,
                testId: `${testId}`
            }),
            /*#__PURE__*/ jsx(CardCriterias, {
                item: item,
                legacyItem: legacyItem,
                translate: translate,
                locale: locale,
                testId: `${testId}-Description`
            }),
            !isModal && legacyItem && /*#__PURE__*/ jsx(LegacyCardNotifications, {
                ...notificationsProps,
                legacyItem: legacyItem
            }),
            !isModal && !isLegacy && /*#__PURE__*/ jsx(CardNotifications, {
                ...notificationsProps
            }),
            !isModal && /*#__PURE__*/ jsx(SerpLink, {
                item: item,
                brand: brandConfig.brandId,
                stage: stage,
                translate: translate,
                display: deviceType,
                testId: `${testId}-Listing_Button`
            })
        ]
    });
};

const getError = (errorCode)=>{
    const error = savedSearchApiErrorCode.find((error)=>error.errorCode === errorCode);
    return error;
};
const unauthorizedErrorOnClickActions = (search, stage, brand)=>{
    let expires = new Date();
    expires.setTime(expires.getTime() + 300 * 1000);
    const localStorageSearch = {
        search: search,
        expires: expires
    };
    setLocalStorageItem(localKeys.autoLocalStorageSearchKey, JSON.stringify(localStorageSearch));
    redirectToLogin(stage, brand, localKeys.autoSaveSearchQueryParam + '=true');
};
const handleError = (apiError, search, stage, brand, translate, error, setIsOpen, setIsLoggedIn)=>{
    if (apiError.httpStatusCode === 401) {
        setIsLoggedIn(false);
        unauthorizedErrorOnClickActions(search, stage, brand);
    } else {
        const errorValue = getError(apiError.errorCode);
        if (!errorValue) {
            error({
                description: translate('savedSearch_errorTechnical_text'),
                action: {
                    children: ''
                },
                variant: 'error',
                testId: "av-ssab-Button['createAlert']-Snackbar['error']"
            });
            return;
        }
        if (!errorValue.translationKey) {
            setIsOpen(true);
            return;
        } else {
            error({
                description: translate(errorValue.translationKey),
                action: {
                    children: ''
                },
                variant: 'error',
                testId: "av-ssab-Button['createAlert']-Snackbar['error']"
            });
            return;
        }
    }
};

const AlertCreate = ()=>{
    return /*#__PURE__*/ jsxs("svg", {
        width: "144",
        height: "144",
        viewBox: "0 0 144 144",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ jsx("g", {
                clipPath: "url(#clip0_3167_15527)",
                children: /*#__PURE__*/ jsxs("g", {
                    clipPath: "url(#clip1_3167_15527)",
                    children: [
                        /*#__PURE__*/ jsx("path", {
                            d: "M14.2524 100.471C14.2524 118.578 20.9883 130.976 31.713 136.109C31.814 136.159 34.6516 137.644 35.5403 138.18C35.8635 138.382 33.2985 136.149 32.733 135.563C26.5425 129.056 22.917 118.83 22.917 105.513C22.917 71.3095 46.9316 29.7201 76.5508 12.6033C88.0027 5.9951 98.6063 4.01466 107.311 6.04563C108.22 6.25782 111.916 7.66231 112.775 7.95534C110.987 6.37906 106.19 3.92372 104.07 2.91328C94.5264 -1.66398 81.8325 -0.471665 67.8863 7.59159C38.2771 24.678 14.2524 66.2675 14.2524 100.471Z",
                            fill: "#C2E0EF"
                        }),
                        /*#__PURE__*/ jsx("path", {
                            d: "M35.5606 138.433C35.5101 138.433 35.4494 138.422 35.409 138.392C34.5507 137.867 31.7634 136.412 31.612 136.341C20.4227 130.986 14 117.911 14 100.471C14 66.237 38.1155 24.4758 67.755 7.36918C81.267 -0.441473 94.1933 -2.1087 104.171 2.68075C106.433 3.76192 111.169 6.20716 112.936 7.76323C113.027 7.84407 113.047 7.97542 112.987 8.07646C112.926 8.17751 112.795 8.22804 112.684 8.18763C112.452 8.10679 112.007 7.94512 111.462 7.74303C110.038 7.21761 107.887 6.42946 107.241 6.27789C98.273 4.17619 87.6999 6.42945 76.6621 12.8053C47.1539 29.8614 23.1594 71.4408 23.1594 105.502C23.1594 118.345 26.5324 128.672 32.9046 135.381C33.1672 135.654 33.9044 136.321 34.5608 136.917C35.4629 137.732 35.8636 138.207 35.7626 138.342C35.7121 138.402 35.6312 138.433 35.5504 138.433H35.5606ZM91.8503 0.508326C84.5187 0.508326 76.3792 2.96368 68.0075 7.80366C38.4993 24.8295 14.5049 66.3987 14.5049 100.471C14.5049 117.709 20.8166 130.612 31.8241 135.886C31.8746 135.906 32.8643 136.432 33.8641 136.967C33.3187 136.472 32.7734 135.977 32.5512 135.745C26.0881 128.945 22.6646 118.497 22.6646 105.523C22.6646 71.2993 46.7802 29.5179 76.4197 12.391C87.5686 5.95457 98.2629 3.68109 107.362 5.8131C107.978 5.95456 109.765 6.61135 111.23 7.14688C109.079 5.71207 105.736 4.00442 103.948 3.15566C100.283 1.3975 96.2028 0.528524 91.8402 0.528524L91.8503 0.508326Z",
                            fill: "black"
                        }),
                        /*#__PURE__*/ jsx("path", {
                            d: "M109.937 6.85423C109.079 6.56121 108.2 6.3086 107.291 6.09641C98.5964 4.05533 88.0029 6.03579 76.5612 12.644C46.9621 29.7507 22.9678 71.2997 22.9678 105.483C22.9678 119.992 27.2798 130.845 34.5307 137.19C44.3667 145.819 59.5248 146.264 76.5612 136.402C106.18 119.326 130.185 77.7664 130.185 43.5936C130.185 23.9912 122.278 11.0374 109.937 6.85423Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ jsx("path", {
                            d: "M52.6071 144C45.629 144 39.3982 141.797 34.3589 137.382C26.7345 130.703 22.7051 119.679 22.7051 105.482C22.7051 71.2894 46.8004 29.5484 76.4297 12.4317C87.5685 6.0053 98.253 3.73185 107.342 5.85376C108.251 6.06595 109.139 6.31854 110.008 6.62167C122.984 11.0272 130.427 24.5063 130.427 43.6035C130.427 77.8067 106.312 119.538 76.6822 136.624C68.1893 141.535 59.9791 144 52.6071 144ZM100.444 5.58092C93.1228 5.58092 85.0338 8.0464 76.6923 12.8662C47.2144 29.9021 23.2201 71.4511 23.2201 105.482C23.2201 119.527 27.1889 130.43 34.6921 136.998C44.8817 145.93 60.0902 145.637 76.4297 136.179C105.928 119.174 129.922 77.645 129.922 43.5934C129.922 24.7286 122.601 11.4212 109.846 7.08649C108.998 6.79346 108.119 6.54083 107.231 6.33875C105.059 5.83353 102.787 5.58092 100.434 5.58092H100.444Z",
                            fill: "black"
                        }),
                        /*#__PURE__*/ jsx("path", {
                            d: "M106.483 13.8561C105.716 13.5934 104.928 13.361 104.12 13.1791C96.3239 11.3503 86.8109 13.1286 76.5608 19.0498C50.0216 34.3881 28.5015 71.6428 28.5015 102.289C28.5015 115.294 32.3693 125.024 38.8728 130.713C47.6889 138.453 61.2917 138.837 76.5608 130.016C103.12 114.707 124.65 77.4427 124.65 46.7962C124.65 29.2147 117.561 17.6048 106.483 13.8561Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ jsx("path", {
                            d: "M55.0812 136.846C48.82 136.846 43.2253 134.865 38.7011 130.894C31.8643 124.913 28.249 115.01 28.249 102.279C28.249 71.6123 49.8601 34.1656 76.4397 18.8171C86.4272 13.0476 96.021 11.0065 104.181 12.9162C104.989 13.1082 105.796 13.3406 106.564 13.6033C118.218 17.5541 124.903 29.649 124.903 46.7859C124.903 77.4627 103.272 114.899 76.6921 130.217C69.0677 134.623 61.7057 136.836 55.0911 136.836L55.0812 136.846ZM97.97 12.7343C91.4059 12.7343 84.1651 14.9371 76.682 19.2617C50.2539 34.5395 28.7438 71.7841 28.7438 102.289C28.7438 114.879 32.2986 124.64 39.0243 130.521C48.1434 138.523 61.7766 138.26 76.4196 129.793C102.868 114.546 124.378 77.3111 124.378 46.796C124.378 29.8915 117.814 17.9684 106.382 14.0883C105.625 13.8256 104.837 13.6033 104.049 13.4113C102.1 12.9566 100.06 12.7242 97.9599 12.7242L97.97 12.7343Z",
                            fill: "black"
                        }),
                        /*#__PURE__*/ jsx("path", {
                            d: "M45.9927 96.014L50.6683 87.7588L69.1589 98.3987L107.645 31.1543L115.39 35.6305L71.9562 111.069L45.9927 96.014Z",
                            fill: "#007DBD"
                        }),
                        /*#__PURE__*/ jsx("path", {
                            d: "M71.9562 111.322C71.9562 111.322 71.8653 111.312 71.8249 111.292L45.8613 96.2366C45.7401 96.1658 45.6997 96.0143 45.7704 95.893L50.446 87.6378C50.4763 87.5772 50.5369 87.5367 50.5975 87.5165C50.6581 87.4963 50.7289 87.5165 50.7895 87.5367L69.0579 98.0452L107.423 31.0232C107.453 30.9625 107.513 30.9221 107.574 30.9019C107.635 30.8817 107.705 30.9019 107.766 30.9221L115.512 35.3984C115.633 35.4691 115.673 35.6207 115.602 35.7419L72.1682 111.181C72.1379 111.242 72.0773 111.282 72.0167 111.302C71.9965 111.302 71.9764 111.302 71.9562 111.302V111.322ZM46.3359 95.9132L71.8653 110.716L115.047 35.7116L107.736 31.488L69.3709 98.51C69.3406 98.5707 69.2801 98.6111 69.2195 98.6313C69.1589 98.6515 69.0881 98.6313 69.0275 98.6111L50.7591 88.1026L46.3359 95.9132Z",
                            fill: "black"
                        }),
                        /*#__PURE__*/ jsx("path", {
                            d: "M46.5376 85.1625L50.6681 87.7593L45.9924 96.0145L41.8721 93.4076L46.5376 85.1523V85.1625Z",
                            fill: "#C2E0EF"
                        }),
                        /*#__PURE__*/ jsx("path", {
                            d: "M45.9925 96.2668C45.9925 96.2668 45.9016 96.2567 45.8612 96.2264L41.7409 93.6194C41.6298 93.5487 41.5895 93.3972 41.6602 93.286L46.3257 85.0307C46.356 84.9701 46.4167 84.9297 46.4874 84.9095C46.558 84.8893 46.6287 84.9095 46.6792 84.9398L50.8095 87.5366C50.9206 87.6074 50.961 87.7589 50.8903 87.8701L46.2147 96.1253C46.1844 96.1859 46.1238 96.2264 46.0531 96.2466C46.0329 96.2466 46.0127 96.2466 45.9925 96.2466V96.2668ZM42.2155 93.3264L45.9117 95.6605L50.3349 87.8499L46.6288 85.5158L42.2155 93.3264Z",
                            fill: "black"
                        }),
                        /*#__PURE__*/ jsx("path", {
                            d: "M65.0283 95.7922L69.1586 98.3991L107.644 31.1548L103.524 28.5479L65.0283 95.7922Z",
                            fill: "#C2E0EF"
                        }),
                        /*#__PURE__*/ jsx("path", {
                            d: "M69.1586 98.6517C69.1586 98.6517 69.0677 98.6416 69.0273 98.6113L64.897 96.0044C64.7859 95.9337 64.7455 95.7821 64.8162 95.6608L103.312 28.4165C103.342 28.3559 103.403 28.3155 103.474 28.2952C103.544 28.275 103.615 28.2952 103.666 28.3256L107.786 30.9325C107.897 31.0032 107.937 31.1548 107.867 31.276L69.3808 98.5204C69.3505 98.581 69.29 98.6214 69.2193 98.6416C69.1991 98.6416 69.1788 98.6416 69.1586 98.6416V98.6517ZM65.3716 95.7114L69.0779 98.0455L107.311 31.2356L103.615 28.9015L65.3716 95.7114Z",
                            fill: "black"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ jsxs("defs", {
                children: [
                    /*#__PURE__*/ jsx("clipPath", {
                        id: "clip0_3167_15527",
                        children: /*#__PURE__*/ jsx("rect", {
                            width: "144",
                            height: "144",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ jsx("clipPath", {
                        id: "clip1_3167_15527",
                        children: /*#__PURE__*/ jsx("rect", {
                            width: "144",
                            height: "144",
                            fill: "white"
                        })
                    })
                ]
            })
        ]
    });
};

const LiModalContent = ({ searchModel, search, brandConfig, callsConfig, screenSize, closeModal, translate, testId, onSuccess, trackRent, trackBuy })=>{
    const [isSaved, setIsSaved] = React.useState(false);
    const [email, setEmail] = React.useState('');
    const [seeTerms, setSeeTerms] = React.useState(false);
    const handleCreateClick = (emailValue, setError, setIsCreating)=>{
        const isValid = isValidEmail(emailValue);
        if (!isValid) setError(translate('savedSearch.alertEmail.invalid'));
        else if (isValid) {
            setError(undefined);
            setIsCreating(true);
            const onSuccessFinal = ()=>{
                if (includeUpperOrLower(search.criteria.distributionType, DistributionType.RENT)) {
                    trackRent();
                }
                if (includeUpperOrLower(search.criteria.distributionType, DistributionType.BUY)) {
                    trackBuy();
                }
                onSuccess();
                setIsCreating(false);
                setEmail(emailValue);
                setIsSaved(true);
            };
            const onError = (error)=>{
                if (error.error === errorCodes.duplicated) {
                    setError(translate('savedSearch_duplicateError_text'));
                } else {
                    setError(translate('savedSearch_errorTechnical_text'));
                }
                setIsCreating(false);
            };
            const currentUrl = !isWindowUndefined() ? window?.location?.href : '';
            createOnLi({
                payload: {
                    title: generateSavedSearchTitle(search.criteria, translate),
                    email: emailValue,
                    search,
                    currentUrl},
                configCalls: callsConfig
            }).then((result)=>'error' in result ? onError(result) : onSuccessFinal()).catch((error)=>onError(error));
        }
    };
    const CreateContent = ()=>{
        const [emailValue, setEmailValue] = React.useState('');
        const [error, setError] = React.useState(undefined);
        const [isCreating, setIsCreating] = React.useState(false);
        const containerRef = useRef(null);
        useEffect(()=>{
            const handleKeyDown = (e)=>{
                if (e.key === 'Enter') {
                    handleCreateClick(emailValue, setError, setIsCreating);
                }
            };
            if (containerRef.current) {
                containerRef.current?.querySelector('input')?.focus();
                containerRef.current?.addEventListener('keydown', handleKeyDown);
            }
            return ()=>{
                if (containerRef.current) {
                    containerRef.current?.removeEventListener('keydown', handleKeyDown);
                }
            };
        }, [
            containerRef.current,
            emailValue
        ]);
        return /*#__PURE__*/ jsxs(Fragment, {
            children: [
                /*#__PURE__*/ jsxs(Box, {
                    as: "div",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "spacing.8",
                    width: screenSize === 'desktop' ? '436px' : 'initial',
                    children: [
                        /*#__PURE__*/ jsx(Box, {
                            as: "h3",
                            typography: "typography.headline.22.bold",
                            margin: "0",
                            testId: `${testId}-create_title`,
                            children: translate('savedSearch.alertCreate.action')
                        }),
                        /*#__PURE__*/ jsx(Box, {
                            as: "p",
                            typography: "typography.body.16.regular",
                            margin: "0",
                            textAlign: "center",
                            testId: `${testId}-create_text`,
                            children: translate('savedSearch.alertEmail.text')
                        })
                    ]
                }),
                /*#__PURE__*/ jsxs(Box, {
                    as: "div",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "spacing.8",
                    width: screenSize === 'desktop' ? 384 : 'initial',
                    unsafe_className: "saved_search_btn-email",
                    children: [
                        /*#__PURE__*/ jsx(TextField, {
                            label: translate('savedSearch.alertEmail.option'),
                            type: "email",
                            hasNecessityIndicator: false,
                            value: emailValue,
                            onChange: (v)=>setEmailValue(v),
                            iconStart: EnvelopeIcon,
                            error: error,
                            containerRef: containerRef,
                            testId: `${testId}-create_email-container`
                        }),
                        /*#__PURE__*/ jsx(Button, {
                            variant: "primary",
                            onPress: ()=>handleCreateClick(emailValue, setError, setIsCreating),
                            isFullWidth: true,
                            isLoading: isCreating,
                            size: "48",
                            testId: `${testId}-create_submit`,
                            children: translate('savedSearch.alertEmail.actionCreate')
                        })
                    ]
                }),
                /*#__PURE__*/ jsxs(Box, {
                    as: "div",
                    margin: "0",
                    typography: "typography.body.12.regular",
                    color: "color.content.subdued.default",
                    textAlign: "center",
                    display: "inline-block",
                    width: screenSize === 'desktop' ? '436px' : 'initial',
                    unsafe_className: "saved_search_btn-email_disclaimer",
                    userSelect: "none",
                    testId: `${testId}-create_terms`,
                    children: [
                        translate('savedSearch.alertEmail.disclaimer.text'),
                        ' ',
                        /*#__PURE__*/ jsx(Box, {
                            as: "p",
                            onClick: ()=>setSeeTerms(!seeTerms),
                            display: "inline",
                            typography: "typography.body.12.boldUnderlined",
                            color: "color.content.subdued.default",
                            cursor: "pointer",
                            userSelect: "none",
                            children: translate('savedSearch.alertEmail.disclaimer.link')
                        }),
                        "."
                    ]
                }),
                seeTerms && /*#__PURE__*/ jsxs(Box, {
                    as: "p",
                    margin: "0",
                    typography: "typography.body.12.regular",
                    color: "color.content.subdued.default",
                    textAlign: "center",
                    userSelect: 'none',
                    children: [
                        "Ces données pourront être transmises aux sociétés du",
                        ' ',
                        /*#__PURE__*/ jsx(Box, {
                            as: "a",
                            href: "https://www.aviv-group.com/companies",
                            target: "_blank",
                            display: "inline",
                            typography: "typography.body.12.boldUnderlined",
                            color: "color.content.subdued.default",
                            cursor: "pointer",
                            userSelect: "none",
                            children: "Groupe AVIV"
                        }),
                        ' ',
                        "auquel nous appartenons. Pour exercer vos droits sur vos données (accès, rectification, effacement, opposition, portabilité et limitation), contactez-nous à cette adresse : Digital Classifieds France - 65 Rue Ordener, 75880 Paris Cedex 18 ou en",
                        ' ',
                        /*#__PURE__*/ jsx(Box, {
                            as: "a",
                            href: "https://www.logic-immo.com/contactez-nous#formSection",
                            target: "_blank",
                            display: "inline",
                            typography: "typography.body.12.boldUnderlined",
                            color: "color.content.subdued.default",
                            cursor: "pointer",
                            userSelect: "none",
                            children: "cliquant ici"
                        }),
                        ". Pour plus d’informations, consultez notre",
                        ' ',
                        /*#__PURE__*/ jsx(Box, {
                            as: "a",
                            href: "https://www.logic-immo.com/cgu-et-politique-de-confidentialite.html",
                            target: "_blank",
                            display: "inline",
                            typography: "typography.body.12.boldUnderlined",
                            color: "color.content.subdued.default",
                            cursor: "pointer",
                            userSelect: "none",
                            children: "Politique de Confidentialité"
                        }),
                        "."
                    ]
                })
            ]
        });
    };
    const CreatedContent = ()=>{
        return /*#__PURE__*/ jsxs(Fragment, {
            children: [
                /*#__PURE__*/ jsx(AlertCreate, {}),
                /*#__PURE__*/ jsxs(Box, {
                    as: "div",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "spacing.16",
                    testId: `${testId}-created_container`,
                    children: [
                        /*#__PURE__*/ jsx(Box, {
                            as: "h3",
                            typography: "typography.headline.22.bold",
                            margin: "0",
                            textAlign: "center",
                            testId: `${testId}-created_title`,
                            children: translate('savedSearch.alertEmail.created.title')
                        }),
                        /*#__PURE__*/ jsx(Box, {
                            as: "p",
                            typography: "typography.body.16.regular",
                            margin: "0",
                            textAlign: "center",
                            testId: `${testId}-created_text`,
                            children: translate('savedSearch.alertEmail.created.text')
                        }),
                        /*#__PURE__*/ jsx(Box, {
                            as: "p",
                            typography: "typography.body.16.regular",
                            margin: "0",
                            textAlign: "center",
                            testId: `${testId}-created_email`,
                            children: email
                        })
                    ]
                }),
                /*#__PURE__*/ jsx(Box, {
                    as: "div",
                    display: "flex",
                    justifyContent: "center",
                    unsafe_className: "saved_search_btn-email_created-btn",
                    width: screenSize === 'desktop' ? '50%' : '80%',
                    children: /*#__PURE__*/ jsx(Button, {
                        variant: "primary",
                        isFullWidth: true,
                        onPress: closeModal,
                        size: "48",
                        testId: `${testId}-created_button`,
                        children: translate('savedSearch.alertEmail.created.action')
                    })
                })
            ]
        });
    };
    return isSaved && isIntermediaryMatchingMandateShowable(brandConfig) ? /*#__PURE__*/ jsx(IntermediaryMatchingMandate, {
        search: searchModel,
        translation: translate,
        brandConfig: brandConfig,
        onSuccess: closeModal,
        email: email,
        callsConfig: callsConfig
    }) : /*#__PURE__*/ jsx(Box, {
        as: "div",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "spacing.24",
        paddingTop: "spacing.4",
        paddingHorizontal: !isSaved ? 'spacing.32' : 'spacing.6',
        paddingBottom: "spacing.4",
        children: !isSaved ? /*#__PURE__*/ jsx(CreateContent, {}) : isSaved && !isIntermediaryMatchingMandateShowable(brandConfig) && /*#__PURE__*/ jsx(CreatedContent, {})
    });
};

const hintsLocalStorageKey = 'ssal_hint-items_storage';
const daysPastToDisplayHint = 90;
const findHintType = (type, hints)=>{
    return hints.find((hintItem)=>hintItem.type === type);
};
const persistHintState = (type)=>{
    const existingLocalStorage = getLocalStorageItem(hintsLocalStorageKey);
    const currentDate = new Date();
    const newExpirationDate = new Date();
    newExpirationDate.setDate(newExpirationDate.getDate() + daysPastToDisplayHint);
    const currentHint = {
        type,
        expirationDate: newExpirationDate.toISOString()
    };
    if (existingLocalStorage) {
        const hints = JSON.parse(existingLocalStorage);
        const hintFound = findHintType(type, hints);
        if (hintFound && new Date(hintFound.expirationDate) < currentDate) {
            const newHints = hints.filter((hintItem)=>hintItem.type !== type);
            newHints.push(currentHint);
            setLocalStorageItem(hintsLocalStorageKey, JSON.stringify(newHints));
        } else if (!hintFound) {
            hints.push(currentHint);
            setLocalStorageItem(hintsLocalStorageKey, JSON.stringify(hints));
        }
    } else {
        const hints = [
            currentHint
        ];
        setLocalStorageItem(hintsLocalStorageKey, JSON.stringify(hints));
    }
};
const shouldShowHint = (config, type)=>{
    if (!config.button.hintFeatures[type]) {
        return false;
    }
    const hintsStorage = getLocalStorageItem(hintsLocalStorageKey);
    if (!hintsStorage) {
        return true;
    }
    const hints = JSON.parse(hintsStorage);
    const hintFound = findHintType(type, hints);
    if ((!hintFound || new Date(hintFound.expirationDate) < new Date()) && config.button.hintFeatures[type]) {
        return true;
    }
    return false;
};

const HintArrow = ({ props, placement })=>{
    const rootFontSizeValue = getRootFontSizeValue();
    const arrowDiagonal = 18 * rootFontSizeValue / 16;
    const arrowSize = arrowDiagonal / Math.sqrt(2);
    return /*#__PURE__*/ jsx(Box, {
        ...props,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: placement === 'left' || placement === 'right' ? arrowDiagonal / 2 : arrowDiagonal,
        height: placement === 'top' || placement === 'bottom' ? arrowDiagonal / 2 : arrowDiagonal,
        overflow: [
            'hidden',
            'clip'
        ],
        transform: placement === 'top' || placement === 'bottom' ? 'translateX(-50%)' : 'translateY(-50%)',
        position: "absolute",
        top: placement === 'top' ? '100%' : undefined,
        bottom: placement === 'bottom' ? '100%' : undefined,
        left: placement === 'left' ? '100%' : undefined,
        right: placement === 'right' ? '100%' : undefined,
        children: /*#__PURE__*/ jsx(Box, {
            width: arrowSize,
            height: arrowSize,
            transform: "rotate(45deg)",
            position: "absolute",
            top: placement === 'top' ? -arrowSize / 2 : undefined,
            bottom: placement === 'bottom' ? -arrowSize / 2 : undefined,
            left: placement === 'left' ? -arrowSize / 2 : undefined,
            right: placement === 'right' ? -arrowSize / 2 : undefined,
            borderWidth: "unsafe_component.tooltip.borderWidth",
            borderStyle: "solid",
            borderColor: "unsafe_component.tooltip.color.border",
            backgroundColor: "unsafe_component.tooltip.color.bg"
        })
    });
};

const hintGridTemplates = {
    mobile: `
    "iconTitle iconTitle close"
    "text text text"
    `,
    desktop: `
    "alertIcon title close"
    "alertIcon text close"
    `
};
const Hint = ({ placement, alignment, triggerRef, deviceType, isOpen, onClose, content })=>{
    const hintRef = useRef(null);
    const { boxProps: cancelProps, isHovered } = useHoverable();
    const { boxProps } = usePopover({
        popover: hintRef,
        trigger: triggerRef
    }, {
        isOpen,
        close: onClose,
        placement: placement,
        alignment: alignment,
        offset: 10
    });
    return content && /*#__PURE__*/ jsxs(Box, {
        ref: hintRef,
        ...boxProps.popover,
        as: "div",
        backgroundColor: "color.surface.default.inverted.default",
        display: "grid",
        gridTemplateAreas: hintGridTemplates[deviceType],
        columnGap: "spacing.24",
        gap: "spacing.8",
        padding: "spacing.16",
        borderRadius: "radius.8",
        boxShadow: "shadow.4",
        children: [
            deviceType === 'desktop' ? /*#__PURE__*/ jsxs(Fragment, {
                children: [
                    /*#__PURE__*/ jsx(Box, {
                        as: "div",
                        width: "2rem",
                        display: "flex",
                        alignItems: "flex-start",
                        gridArea: "alertIcon",
                        children: /*#__PURE__*/ jsx(AlertOnFilledIcon, {
                            color: "color.content.default.inverted.default"
                        })
                    }),
                    /*#__PURE__*/ jsx(Box, {
                        as: "p",
                        margin: "0",
                        width: "fit-content",
                        alignItems: "center",
                        display: "flex",
                        gridArea: "title",
                        typography: "typography.body.14.bold",
                        color: "color.content.default.inverted.default",
                        children: content.title
                    })
                ]
            }) : /*#__PURE__*/ jsxs(Box, {
                as: "div",
                gridArea: "iconTitle",
                alignItems: "flex-start",
                gap: "spacing.8",
                display: "flex",
                children: [
                    /*#__PURE__*/ jsx(AlertOnFilledIcon, {
                        color: "color.content.default.inverted.default"
                    }),
                    /*#__PURE__*/ jsx(Box, {
                        as: "p",
                        margin: "0",
                        width: "fit-content",
                        typography: "typography.body.14.bold",
                        color: "color.content.default.inverted.default",
                        children: content.title
                    })
                ]
            }),
            /*#__PURE__*/ jsx(Box, {
                ...cancelProps,
                as: "div",
                justifySelf: "end",
                gridArea: "close",
                transitionDuration: "motionDuration.200",
                transitionProperty: "opacity",
                transitionTimingFunction: "motionEasing.ease",
                opacity: isHovered ? 'opacity.70' : 'opacity.full',
                cursor: "pointer",
                onClick: onClose,
                transform: "translateY(-5px)",
                children: /*#__PURE__*/ jsx(CloseIcon, {
                    color: "color.content.default.inverted.default"
                })
            }),
            /*#__PURE__*/ jsx(Box, {
                as: "p",
                margin: "0",
                maxWidth: "420px",
                width: "fit-content",
                gridArea: "text",
                typography: "typography.body.14.regular",
                color: "color.content.default.inverted.default",
                children: content.text
            }),
            /*#__PURE__*/ jsx(HintArrow, {
                props: boxProps.arrow,
                placement: placement
            })
        ]
    });
};

const ButtonTrigger = ({ isSaved, onPress, translate, deviceType, brandConfig, hintType })=>{
    const [isHintOpen, setIsHintOpen] = useState(shouldShowHint(brandConfig, hintType?.type ?? 'default'));
    const buttonRef = useRef(null);
    const hintPlacement = 'top';
    const hintAlignment = deviceType === 'mobile' ? 'end' : 'middle';
    const closeHint = ()=>setIsHintOpen(false);
    useEffect(()=>{
        if (isHintOpen) {
            persistHintState(hintType.type);
        }
    }, [
        isHintOpen
    ]);
    return /*#__PURE__*/ jsxs(Box, {
        as: "div",
        children: [
            /*#__PURE__*/ jsx(Overlay, {
                isOpen: isHintOpen,
                children: /*#__PURE__*/ jsx(Hint, {
                    isOpen: isHintOpen,
                    content: hintType.content,
                    triggerRef: buttonRef,
                    placement: hintPlacement,
                    alignment: hintAlignment,
                    deviceType: deviceType,
                    onClose: closeHint
                })
            }),
            /*#__PURE__*/ jsx(Button, {
                size: "48",
                variant: "primary-floating",
                iconPosition: "start",
                ref: buttonRef,
                icon: isSaved ? BellFilledIcon : BellIcon,
                onPress: onPress,
                testId: "av-ssab-Button['createAlert']",
                children: isSaved ? translate('savedSearch.alertActivated.action') : translate('savedSearch.getAlerts.action')
            })
        ]
    });
};

const CardBell = ()=>{
    return /*#__PURE__*/ jsxs("svg", {
        viewBox: "3.1894 3.4814 45.9831 34.2706",
        width: "45.9831",
        height: "34.2706",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": "bell-icon",
        children: [
            /*#__PURE__*/ jsx("defs", {
                children: /*#__PURE__*/ jsx("clipPath", {
                    id: "clip0_1362_119584",
                    children: /*#__PURE__*/ jsx("rect", {
                        width: "137.2",
                        height: "137.2",
                        fill: "white"
                    })
                })
            }),
            /*#__PURE__*/ jsxs("g", {
                children: [
                    /*#__PURE__*/ jsx("path", {
                        d: "M32.515 3.71657C28.9615 3.45589 25.3806 3.41473 21.8271 3.57937C18.8224 3.71657 15.7492 3.89493 12.8405 4.74557C10.316 5.48645 8.01109 6.76241 6.3784 8.87529C4.77316 10.9744 3.74416 13.5675 3.36 16.1743C2.674 20.7431 4.05972 26.0116 7.47601 29.2495C9.49285 31.1566 12.2643 32.213 14.9122 32.8853C18.0816 33.6811 21.4155 33.9966 24.6809 34.2436C26.6154 34.3808 28.5636 34.4494 30.5119 34.3396C31.4448 34.2985 32.3778 34.2024 33.3108 34.0789C34.1888 33.9555 35.3413 33.5439 36.1645 33.9966C36.8505 34.3808 37.3444 35.2177 37.9618 35.7253C38.5244 36.1781 39.1418 36.576 39.7866 36.8778C41.1312 37.5227 42.6129 37.8108 44.0947 37.7422C44.3005 37.7285 44.3965 37.4541 44.2044 37.3306C42.3385 36.2741 40.9665 34.5729 40.3354 32.5286C40.2119 32.5835 40.0747 32.6383 39.9512 32.6932C40.2805 33.2009 41.6525 32.7207 42.0778 32.6246C43.2578 32.3639 44.2868 31.7877 45.1648 30.9645C47.3875 28.8516 48.2518 25.7235 48.7595 22.7874C49.7062 17.2857 49.3083 10.2747 44.5337 6.55661C41.6114 4.27909 37.564 3.71657 33.9693 3.68913C33.6812 3.68913 33.6812 4.14189 33.9693 4.14189C37.0289 4.16933 40.3491 4.59465 43.052 6.11757C45.5764 7.54445 47.2091 10.0003 48.0186 12.7443C48.7869 15.3374 48.883 18.0814 48.6223 20.7568C48.3616 23.4185 47.8128 26.2723 46.4545 28.6184C45.6176 30.059 44.3965 31.3761 42.8187 31.9661C42.4346 32.1033 42.0367 32.1993 41.6388 32.2679C41.4604 32.3091 40.3903 32.5423 40.3217 32.4463C40.1982 32.2542 39.8552 32.3639 39.9375 32.6109C40.6098 34.7649 42.0504 36.5623 43.9986 37.6736C44.0398 37.5364 44.0672 37.3992 44.1084 37.262C42.6678 37.3306 41.2272 37.0425 39.9238 36.3976C38.6616 35.7802 37.8246 34.8747 36.8643 33.9006C35.9313 32.9539 34.6553 33.3655 33.4891 33.5301C31.8427 33.7634 30.1826 33.8594 28.5362 33.8457C25.2297 33.832 21.9094 33.5027 18.6441 33.0362C15.6257 32.6109 12.6073 31.8563 9.91817 30.3608C5.65125 27.9735 3.62068 22.7874 3.703 18.0677C3.74416 15.5432 4.47132 13.005 5.6924 10.7961C7.0644 8.31277 9.09496 6.58405 11.7429 5.56877C14.7476 4.41629 17.9992 4.15561 21.1823 3.97725C24.9416 3.84005 28.7283 3.84005 32.515 3.97725C32.6796 3.97725 32.6796 3.73029 32.515 3.71657Z",
                        fill: "black",
                        clipPath: "url(#clip0_1362_119584)"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M27.1167 9.04119V9.33636L27.4076 9.38617C30.768 9.96149 33.3181 12.8911 33.3181 16.4088V21.0462C33.3181 22.3476 33.7081 23.6636 34.5482 24.6959C34.5597 24.7105 34.5684 24.7253 34.5804 24.7519V26.7559C34.5728 26.7667 34.5545 26.7886 34.5141 26.8207C34.43 26.8873 34.2895 26.9655 34.0806 27.0483C33.6654 27.2127 33.0519 27.3673 32.2736 27.4994C30.7221 27.7628 28.5782 27.9266 26.2044 27.9266C23.8237 27.9266 21.6765 27.7628 20.125 27.4994C19.3467 27.3673 18.7343 27.2127 18.321 27.0484C18.113 26.9658 17.9741 26.8878 17.8917 26.8218C17.8533 26.791 17.8358 26.77 17.8285 26.7596V24.7023C17.83 24.7002 17.8318 24.6977 17.8341 24.6948L17.8356 24.6929C18.6571 23.6514 19.0633 22.3522 19.0633 21.0462V16.4088C19.0633 12.8911 21.6134 9.96149 24.9738 9.38617L25.2648 9.33636V9.04119V9.01375C25.2648 8.50733 25.6843 8.08779 26.1907 8.08779C26.6971 8.08779 27.1167 8.50733 27.1167 9.01375V9.04119Z",
                        fill: "#3DA4CE",
                        stroke: "black",
                        strokeWidth: "0.7",
                        clipPath: "url(#clip0_1362_119584)"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M31.7615 25.0778C28.3315 24.6113 24.7917 24.5976 21.3617 24.9818C20.8404 25.0367 20.8404 25.8599 21.3617 25.805C24.7231 25.4345 28.1943 25.4208 31.542 25.8736C32.0633 25.9422 32.2828 25.1464 31.7615 25.0778Z",
                        fill: "black",
                        clipPath: "url(#clip0_1362_119584)"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M25.2314 25.1504C25.4098 25.7129 25.451 26.3303 25.3275 26.9066C25.204 27.4965 24.9433 28.059 24.9708 28.649C25.0256 29.4448 25.7116 30.1445 26.5074 30.1719C27.3032 30.1994 28.0578 29.5134 28.0578 28.7176C28.0578 28.0865 27.6462 27.5377 27.4129 26.9477C27.2071 26.4401 27.1248 25.8638 27.1797 25.315",
                        fill: "black",
                        clipPath: "url(#clip0_1362_119584)"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M25.1071 25.1503C25.2031 25.9323 25.1757 26.632 24.9287 27.3866C24.7641 27.8806 24.6132 28.3882 24.7229 28.9096C24.9013 29.7739 25.7108 30.4874 26.6026 30.4599C27.4395 30.4462 28.2078 29.7602 28.3313 28.937C28.3999 28.4568 28.2353 28.004 28.0295 27.5787C27.6727 26.8241 27.3572 26.1793 27.3983 25.3286C27.4121 25.0405 26.973 25.0405 26.9593 25.3286C26.8907 26.1793 27.0965 26.9064 27.4532 27.6748C27.6727 28.1412 27.906 28.6214 27.6865 29.1291C27.4669 29.6367 26.9319 29.9523 26.3831 29.8562C25.1071 29.6367 25.258 28.3333 25.4775 27.4004C25.6696 26.6046 25.6971 25.8226 25.3541 25.068C25.2855 24.9719 25.0797 25.0268 25.1071 25.1503Z",
                        fill: "black",
                        clipPath: "url(#clip0_1362_119584)"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M23.9269 10.6187C22.3353 11.5654 20.7438 12.663 20.4008 14.6113C20.0029 16.9985 20.5106 19.4544 20.2225 21.8554C20.195 22.0338 20.4969 22.0749 20.538 21.8966C20.9908 19.7837 20.6615 17.6434 20.7987 15.4893C20.8673 14.4192 21.1143 13.4313 21.814 12.6081C22.4314 11.881 23.2409 11.3322 24.0366 10.8108C24.1738 10.7422 24.0641 10.5364 23.9269 10.6187Z",
                        fill: "white",
                        clipPath: "url(#clip0_1362_119584)"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M19.6473 23.7487C19.6885 23.7212 19.7434 23.7075 19.7845 23.6801C19.8531 23.6526 19.8669 23.5566 19.8394 23.5017C19.7983 23.4331 19.7159 23.4194 19.6611 23.4468C19.6199 23.4743 19.565 23.488 19.5239 23.5154C19.469 23.5429 19.4415 23.6389 19.4827 23.6938C19.5101 23.7761 19.5787 23.7898 19.6473 23.7487Z",
                        fill: "white",
                        clipPath: "url(#clip0_1362_119584)"
                    })
                ]
            })
        ]
    });
};

const getBoxProps = (screenSize)=>{
    switch(screenSize){
        case 'mobile':
            return {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            };
        case 'tablet':
            return {
                display: 'grid',
                gridTemplateAreas: `
        "title icon"
        "button icon"
        `
            };
        case 'desktop':
            return {
                display: 'grid',
                gridTemplateAreas: `
        "title icon"
        "button icon"
        `
            };
        default:
            return {};
    }
};
const cardTriggerTestId = 'av-ssab-CardTrigger';
const CardTrigger = ({ isSaved, onPress, translate, deviceType, width = 'auto' })=>{
    const boxProps = useMemo(()=>getBoxProps(deviceType), [
        deviceType
    ]);
    return /*#__PURE__*/ jsxs(Box, {
        padding: "spacing.16",
        borderRadius: "radius.16",
        gap: "spacing.16",
        width: width,
        minWidth: "fit-content",
        backgroundColor: "color.surface.accent.light.default",
        testId: cardTriggerTestId,
        ...boxProps,
        children: [
            deviceType !== 'mobile' && /*#__PURE__*/ jsxs(Fragment, {
                children: [
                    /*#__PURE__*/ jsx(Box, {
                        as: "h4",
                        gridArea: "title",
                        margin: "0",
                        testId: `${cardTriggerTestId}_title`,
                        children: translate('savedSearch_buttonCard_title')
                    }),
                    /*#__PURE__*/ jsx(Box, {
                        gridArea: "icon",
                        display: "flex",
                        justifyContent: "end",
                        testId: `${cardTriggerTestId}_icon`,
                        children: /*#__PURE__*/ jsx(CardBell, {})
                    })
                ]
            }),
            /*#__PURE__*/ jsx(Box, {
                gridArea: "button",
                children: /*#__PURE__*/ jsx(Button, {
                    size: "40",
                    variant: "secondary",
                    onPress: onPress,
                    icon: isSaved ? BellFilledIcon : BellIcon,
                    iconPosition: "start",
                    testId: `${cardTriggerTestId}_button`,
                    children: isSaved ? translate('savedSearch.alertActivated.action') : translate('savedSearch.getAlerts.action')
                })
            })
        ]
    });
};

const SavedSearchButtonComponent = (buttonSearchModel)=>{
    const deviceType = useBreakpointValue({
        base: 'mobile',
        md: 'desktop'
    });
    const config = getCustomBrandConfig(buttonSearchModel.brand);
    if (!config) {
        console.error(`Brand ${buttonSearchModel.brand} is not supported`);
        return null;
    }
    if (buttonSearchModel?.type === 'btn-card' && !config.button.supportCard) {
        console.error(`Button type "btn-card" is not supported for  ${buttonSearchModel.brand} brand. Please use "btn" type.`);
        return null;
    }
    const search = mapSearchDataModelToWLSearch(buttonSearchModel.searchModel);
    const { savedSearches, fetchSavedSearches, isLoggedIn, setIsLoggedIn, setSavedSearches } = useSavedSearch(buttonSearchModel.stage, buttonSearchModel.brand, getToken());
    const { t, i18n } = useTranslation();
    const { success, error } = useSnackbar();
    const { setSafeArea } = useSafeArea();
    const [isOpen, setIsOpen] = useState(false);
    const [isIntermediaryMatchingMandateOpen, setIsIntermediaryMatchingMandateOpen] = useState(false);
    const [hasDelete, setHasDelete] = useState(false);
    const [isSearchSaved, setIsSearchSaved] = useState(false);
    const [isButtonClickable, setIsButtonClickable] = useState(true);
    const [maxAlertsCount, setMaxAlertsCount] = useState(10);
    const [hasAutoSaveSearch, setHasAutoSaveSearch] = useState(false);
    const { maxAlertsCustomKey, logSearchDataModel, autoLocalStorageSearchKey, autoSaveSearchQueryParam } = localKeys;
    const alertsCount = useMemo(()=>savedSearches.length, [
        savedSearches
    ]);
    const maxAlertsCustom = getLocalStorageItem(maxAlertsCustomKey);
    const logSearchDataModelValue = getLocalStorageItem(logSearchDataModel);
    const trackSearchInterestMaxAlert = useThorEvent({
        eventData: mapSavedSearchInterestToThorEvent(search, 'lead_classified_alert_opened')
    });
    const trackSearchInterestSubmitRent = useThorEvent({
        eventData: mapSavedSearchSubscripionToThorEvent(search, 'lead_classified_alert_submit_rent', buttonSearchModel?.origin)
    });
    const trackSearchInterestSubmitBuy = useThorEvent({
        eventData: mapSavedSearchSubscripionToThorEvent(search, 'lead_classified_alert_submit_buy', buttonSearchModel?.origin)
    });
    const CallConfigs = {
        stage: buttonSearchModel.stage,
        brand: buttonSearchModel.brand,
        basicsKey: {
            imn: 'imn',
            iwt: 'iwt'
        }
    };
    const intermediaryMatchingMandateOnSuccess = ()=>{
        success({
            description: t('savedSearch_alertCreated_text'),
            action: {
                children: ''
            },
            variant: 'success',
            testId: "av-ssab-Button['createAlert']-Snackbar['success']"
        });
        setIsIntermediaryMatchingMandateOpen(false);
        setIsOpen(false);
    };
    const handleIntermediaryMatchingMandateStateChange = ()=>{
        setIsIntermediaryMatchingMandateOpen(false);
        setIsOpen(false);
        if (config.brandId !== 'li') {
            success({
                description: t('savedSearch_alertCreated_text'),
                action: {
                    children: ''
                },
                variant: 'success',
                testId: "av-ssab-Button['createAlert']-Snackbar['success']"
            });
        }
    };
    const handleSavedSearchesPostApiSuccess = ()=>{
        clearSearchToBeSavedFromLocalStorage();
        fetchSavedSearches();
        setSafeArea({
            bottom: 58
        });
        if (isIntermediaryMatchingMandateShowable(config)) {
            setIsIntermediaryMatchingMandateOpen(true);
        } else {
            success({
                description: t('savedSearch_alertCreated_text'),
                action: {
                    children: ''
                },
                variant: 'success',
                testId: "av-ssab-Button['createAlert']-Snackbar['success']"
            });
        }
        if (includeUpperOrLower(search.criteria.distributionType, DistributionType$1.RENT)) {
            trackSearchInterestSubmitRent();
        }
        if (includeUpperOrLower(search.criteria.distributionType, DistributionType$1.BUY)) {
            trackSearchInterestSubmitBuy();
        }
        setIsSearchSaved(true);
    };
    const handleSavedSearchesPostApiError = (apiError)=>{
        const { stage, brand } = buttonSearchModel;
        setIsButtonClickable(true);
        clearSearchToBeSavedFromLocalStorage();
        handleError(apiError, search, stage, brand, t, error, setIsOpen, setIsLoggedIn);
    };
    const clearSearchToBeSavedFromLocalStorage = ()=>{
        removeLocalStorageItem(autoLocalStorageSearchKey);
        const queryParameters = new URLSearchParams(window?.location?.search);
        queryParameters.delete(autoSaveSearchQueryParam);
    };
    const modalContinueButton = {
        children: t('savedSearch.alertContinue.action'),
        onPress: ()=>{
            setIsOpen(false);
            setTimeout(()=>{
                setHasDelete(false);
            }, 500);
        }
    };
    const handleGetAlertClick = ()=>{
        if (!isLoggedIn) {
            unauthorizedErrorOnClickActions(search, buttonSearchModel.stage, buttonSearchModel.brand);
        } else if (isButtonClickable) {
            if (getNumberOfLocations(search.criteria.location) > 40) {
                error({
                    description: t('savedSearch_locationTooLarge_text'),
                    action: {
                        children: ''
                    },
                    variant: 'error',
                    testId: "av-ssab-Button['createAlert']-Snackbar['error']"
                });
                return;
            }
            if (alertsCount >= maxAlertsCount) {
                setIsOpen(true);
                trackSearchInterestMaxAlert();
                return;
            }
            setIsButtonClickable(false);
            if (logSearchDataModelValue === 'true') {
                console.log('Button search model is: ', buttonSearchModel);
            }
            // const searchWithTracking = {
            //   ...search,
            //   userInteractionData: getUserInteractionData('serp', buttonSearchModel.origin),
            // };
            addSavedSearch(handleSavedSearchesPostApiSuccess, handleSavedSearchesPostApiError, {
                authenticationToken: getToken(),
                body: clearObject(search)
            });
        }
    };
    const handleGetAlertClickLi = ()=>{
        if (getNumberOfLocations(search.criteria.location) > 10) {
            error({
                description: t('savedSearch_locationTooLarge_text'),
                action: {
                    children: ''
                },
                variant: 'error',
                testId: "av-ssab-Button['createAlert']-Snackbar['error']"
            });
            return;
        }
        setIsOpen(true);
    };
    useEffect(()=>{
        if (buttonSearchModel?.locale) {
            i18n.changeLanguage(buttonSearchModel.locale);
        }
        if (maxAlertsCustom && !isNaN(parseInt(maxAlertsCustom))) {
            setMaxAlertsCount(parseInt(maxAlertsCustom));
        }
        const searchToBeSavedLS = getLocalStorageItem(autoLocalStorageSearchKey);
        if (searchToBeSavedLS) {
            const searchToBeSaved = JSON.parse(searchToBeSavedLS);
            const queryParameters = new URLSearchParams(window?.location?.search);
            const autoSaveSearchQueryValue = queryParameters.get(autoSaveSearchQueryParam) ?? '';
            if (new Date() < new Date(searchToBeSaved.expires) && autoSaveSearchQueryValue === 'true' && !hasAutoSaveSearch) {
                setHasAutoSaveSearch(true);
                clearSearchToBeSavedFromLocalStorage();
                addSavedSearch(handleSavedSearchesPostApiSuccess, handleSavedSearchesPostApiError, {
                    authenticationToken: getToken(),
                    body: clearObject(search)
                });
            } else {
                clearSearchToBeSavedFromLocalStorage();
            }
        }
    }, []);
    useEffect(()=>{
        if (!isSearchSaved) {
            return;
        }
        const timer = setTimeout(()=>{
            setIsButtonClickable(true);
            setIsSearchSaved(false);
        }, 5000);
        return ()=>{
            clearTimeout(timer);
        };
    }, [
        isSearchSaved
    ]);
    const alertsList = savedSearches?.filter((item)=>!isLegacySavedSearch(item))?.map((item, index)=>{
        const removeItemFromData = ()=>{
            const id = item.identity.id;
            setSavedSearches((prevState)=>{
                return prevState.filter((search)=>search.identity.id !== id) ?? [];
            });
            setHasDelete(true);
        };
        return /*#__PURE__*/ jsx(SavedSearchCard, {
            item: item,
            brandConfig: config,
            translate: t,
            isAnonyme: !isLoggedIn,
            callsConfig: CallConfigs,
            onAlertDelete: removeItemFromData,
            locale: buttonSearchModel.locale ?? 'de',
            isModal: true,
            deviceType: deviceType,
            index: index,
            authToken: getToken() ?? ''
        }, index);
    });
    const Trigger = ()=>{
        const triggerProps = {
            isSaved: isSearchSaved,
            deviceType: deviceType,
            onPress: buttonSearchModel.brand === 'li' ? handleGetAlertClickLi : handleGetAlertClick,
            translate: t,
            width: buttonSearchModel.type === 'btn-card' ? buttonSearchModel.width : undefined,
            brandConfig: config
        };
        if (buttonSearchModel.type === 'btn-card') {
            return /*#__PURE__*/ jsx(CardTrigger, {
                ...triggerProps
            });
        } else {
            return /*#__PURE__*/ jsx(ButtonTrigger, {
                ...triggerProps,
                hintType: getHintType(buttonSearchModel.searchModel, t)
            });
        }
    };
    const DeleteFeedBack = ()=>{
        const message = hasDelete ? t('savedSearch_niceJob_text') : t('savedSearch_there’sNoRoomLeft_text', {
            maxAlertsCount
        });
        return /*#__PURE__*/ jsx(FeedbackMessage, {
            testId: "av-ssab-Modal-FeedbackMessage",
            variant: hasDelete ? 'success' : 'warning',
            title: hasDelete ? t('savedSearch_niceJob_title') : t('savedSearch_there’sNoRoomLeft_title'),
            children: message
        });
    };
    return /*#__PURE__*/ jsxs(Box, {
        as: "div",
        children: [
            /*#__PURE__*/ jsx(Fragment, {
                children: buttonSearchModel.brand === 'li' ? /*#__PURE__*/ jsx(Modal, {
                    testId: savedSearchButtonModalTestId,
                    isOpen: isOpen,
                    onOpenChange: handleIntermediaryMatchingMandateStateChange,
                    isDismissable: true,
                    trigger: ()=>Trigger(),
                    children: /*#__PURE__*/ jsx(LiModalContent, {
                        search: search,
                        searchModel: buttonSearchModel.searchModel,
                        brandConfig: config,
                        callsConfig: CallConfigs,
                        screenSize: deviceType,
                        closeModal: intermediaryMatchingMandateOnSuccess,
                        onSuccess: ()=>setIsSearchSaved(true),
                        translate: t,
                        testId: savedSearchButtonModalTestId,
                        trackBuy: trackSearchInterestSubmitBuy,
                        trackRent: trackSearchInterestSubmitRent
                    })
                }) : /*#__PURE__*/ jsxs(Modal, {
                    testId: "av-ssab-Modal",
                    isOpen: isOpen,
                    onOpenChange: ()=>setIsOpen(!isOpen),
                    isDismissable: true,
                    title: t('savedSearch.alertDeletePopUp.title'),
                    footerEndButtonProps: modalContinueButton,
                    displayMode: deviceType === 'mobile' ? 'fullscreen' : 'default',
                    trigger: ()=>Trigger(),
                    children: [
                        /*#__PURE__*/ jsx(DeleteFeedBack, {}, 'deleteFeedbackKey' + '-' + buttonSearchModel.brand),
                        /*#__PURE__*/ jsx(Box, {
                            width: "100%",
                            marginTop: "spacing.16",
                            testId: "av-ssab-Modal-AlertList",
                            display: "flex",
                            flexDirection: "column",
                            gap: "spacing.16",
                            children: alertsList
                        }, 'alertListBoxKey' + '-' + buttonSearchModel.brand)
                    ]
                })
            }),
            /*#__PURE__*/ jsx(DataDome, {
                element: "button",
                brand: buttonSearchModel.brand,
                stage: buttonSearchModel.stage
            }),
            /*#__PURE__*/ jsx(Overlay, {
                isOpen: isIntermediaryMatchingMandateOpen,
                children: /*#__PURE__*/ jsx(Modal, {
                    isOpen: isIntermediaryMatchingMandateOpen,
                    onOpenChange: handleIntermediaryMatchingMandateStateChange,
                    displayMode: deviceType === 'mobile' ? 'fullscreen' : 'fullHeight',
                    trigger: ()=>/*#__PURE__*/ jsx(Fragment, {}),
                    children: /*#__PURE__*/ jsx(IntermediaryMatchingMandate, {
                        search: buttonSearchModel.searchModel,
                        brandConfig: config,
                        translation: t,
                        onSuccess: intermediaryMatchingMandateOnSuccess,
                        callsConfig: CallConfigs
                    })
                })
            })
        ]
    });
};

const SsrButton = (buttonSearchModel)=>{
    const [isClient, setIsClient] = useState(false);
    const skeletonProps = {
        button: {
            width: '191px',
            height: 'sizing.48'
        },
        btnCard: {
            as: 'div',
            width: '100%',
            height: {
                'breakpoint.base': 'sizing.72',
                'breakpoint.md': '112px',
                'breakpoint.xl': '136px'
            },
            overflow: 'hidden'
        }
    };
    useEffect(()=>{
        setIsClient(true);
    }, []);
    return isClient ? /*#__PURE__*/ jsx(SavedSearchButtonComponent, {
        ...buttonSearchModel
    }) : buttonSearchModel.type === 'btn' ? /*#__PURE__*/ jsx(Box, {
        as: "div",
        overflow: "hidden",
        borderRadius: "unsafe_component.button.radius",
        children: /*#__PURE__*/ jsx(Skeleton, {
            ...skeletonProps.button
        })
    }) : /*#__PURE__*/ jsx(Box, {
        ...skeletonProps.btnCard,
        borderRadius: "radius.16",
        children: /*#__PURE__*/ jsx(Skeleton, {
            width: "100%",
            height: "100%"
        })
    });
};

const SavedSearchButton = (buttonSearchModel)=>{
    const isDevMode = buttonSearchModel.stage !== 'live';
    return /*#__PURE__*/ jsx(I18nextProvider, {
        i18n: instance,
        children: /*#__PURE__*/ jsx(TrackingWrapper, {
            isDevMode: isDevMode,
            children: /*#__PURE__*/ jsx(SsrButton, {
                ...buttonSearchModel
            })
        })
    });
};

const MoreProperties = ()=>/*#__PURE__*/ jsxs("svg", {
        width: "145",
        height: "145",
        viewBox: "0 0 145 145",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ jsx("path", {
                d: "M121.638 108.921L63.4453 75.2812L7.74365 107.516",
                fill: "white"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M121.638 109.171C121.638 109.171 121.548 109.161 121.519 109.142L63.4453 75.5811L7.87312 107.727C7.75354 107.796 7.60407 107.756 7.53432 107.637C7.46457 107.517 7.50443 107.368 7.624 107.298L63.3257 75.0729C63.4054 75.033 63.4951 75.033 63.5748 75.0729L121.768 108.703C121.887 108.773 121.927 108.922 121.857 109.042C121.807 109.122 121.728 109.161 121.638 109.161V109.171Z",
                fill: "black"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M7.74365 107.52L65.9365 141.14L121.638 108.925",
                fill: "white"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M65.9364 141.379C65.9364 141.379 65.8467 141.369 65.8168 141.349L7.624 107.728C7.50443 107.659 7.46457 107.509 7.53432 107.39C7.60407 107.27 7.75354 107.23 7.87312 107.3L65.9364 140.851L121.519 108.705C121.638 108.635 121.788 108.675 121.857 108.795C121.927 108.914 121.887 109.064 121.768 109.133L66.0659 141.349C66.0659 141.349 65.9862 141.379 65.9464 141.379H65.9364Z",
                fill: "black"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M104.529 112.77L104.619 60.6555L86.0849 56.6797L65.8968 83.0159L65.8071 135.13L104.529 112.77Z",
                fill: "white"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M65.807 135.379C65.807 135.379 65.7173 135.369 65.6874 135.349C65.6077 135.309 65.5679 135.219 65.5679 135.129L65.6575 83.015C65.6575 82.9552 65.6775 82.9054 65.7074 82.8655L85.8955 56.5293C85.9553 56.4495 86.0549 56.4196 86.1446 56.4396L104.679 60.4154C104.798 60.4353 104.878 60.545 104.878 60.6645L104.788 112.779C104.788 112.869 104.738 112.948 104.669 112.998L65.9465 135.359C65.9465 135.359 65.8668 135.388 65.827 135.388L65.807 135.379ZM66.1458 83.0947L66.0561 134.691L104.28 112.62L104.37 60.8539L86.1845 56.9478L66.1458 83.0947Z",
                fill: "black"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M65.8071 135.049L65.8968 83.0145L27.1248 60.6641L27.0352 112.699L65.8071 135.049Z",
                fill: "white"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M65.807 135.3C65.807 135.3 65.7173 135.29 65.6874 135.27L26.9155 112.919C26.8358 112.879 26.7959 112.79 26.7959 112.7L26.8856 60.6554C26.8856 60.5657 26.9354 60.486 27.0052 60.4361C27.0849 60.3963 27.1745 60.3963 27.2543 60.4361L66.0262 82.7866C66.1059 82.8264 66.1458 82.9161 66.1458 83.0058L66.0561 135.041C66.0561 135.13 66.0063 135.21 65.9366 135.26C65.8967 135.28 65.8568 135.29 65.817 135.29L65.807 135.3ZM27.2842 112.561L65.5579 134.622L65.6476 83.1553L27.3738 61.0838L27.2842 112.551V112.561Z",
                fill: "black"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M86.0851 56.6785L65.897 83.0148L27.125 60.6644L47.3231 34.3281L86.0851 56.6785Z",
                fill: "#E30513"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M65.8969 83.2651C65.8969 83.2651 65.8072 83.2551 65.7773 83.2352L27.0054 60.8847C26.9456 60.8449 26.8958 60.7851 26.8858 60.7154C26.8758 60.6456 26.8858 60.5758 26.9356 60.5161L47.1337 34.1798C47.2134 34.0802 47.343 34.0503 47.4526 34.12L86.2146 56.4804C86.2744 56.5203 86.3242 56.5801 86.3341 56.6498C86.3441 56.7196 86.3341 56.7893 86.2843 56.8491L66.0962 83.1854C66.0464 83.2451 65.9766 83.285 65.8969 83.285V83.2651ZM27.5036 60.5858L65.8371 82.6871L85.7163 56.7495L47.3828 34.6482L27.4936 60.5858H27.5036Z",
                fill: "black"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M104.579 60.6077L86.1748 56.7315L47.4028 34.3711L65.8073 38.2573L104.579 60.6077Z",
                fill: "white"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M104.579 60.8554C104.579 60.8554 104.549 60.8554 104.529 60.8554L86.1349 56.9692C86.1349 56.9692 86.0851 56.9493 86.0651 56.9393L47.2932 34.5889C47.1836 34.5291 47.1437 34.3996 47.1836 34.28C47.2234 34.1704 47.343 34.1007 47.4725 34.1206L65.877 37.9968C65.877 37.9968 65.9268 38.0167 65.9468 38.0267L104.709 60.3871C104.818 60.4468 104.858 60.5764 104.818 60.696C104.778 60.7956 104.689 60.8554 104.589 60.8554H104.579ZM86.2644 56.4909L103.085 60.0383L65.7176 38.485L48.8875 34.9377L86.2644 56.4909Z",
                fill: "black"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M100.732 114.913L100.812 99.1289L92.8605 103.723L92.7808 119.506L100.732 114.913Z",
                fill: "white"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M92.7807 119.755C92.7807 119.755 92.691 119.745 92.6611 119.725C92.5814 119.685 92.5415 119.595 92.5415 119.505L92.6113 103.722C92.6113 103.632 92.6611 103.552 92.7308 103.502L100.683 98.9088C100.762 98.8689 100.852 98.8689 100.932 98.9088C101.011 98.9487 101.051 99.0383 101.051 99.128L100.971 114.912C100.971 115.001 100.922 115.081 100.852 115.131L92.9002 119.725C92.9002 119.725 92.8205 119.755 92.7807 119.755ZM93.0995 103.861L93.0298 119.067L100.483 114.762L100.553 99.5565L93.0995 103.861Z",
                fill: "black"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M100.812 99.1484L100.733 114.912L99.1782 114.025L99.2579 100.045L100.812 99.1484Z",
                fill: "white"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M100.733 115.161C100.733 115.161 100.653 115.151 100.613 115.131L99.0587 114.244C98.979 114.204 98.9292 114.114 98.9292 114.025L98.999 100.044C98.999 99.9547 99.0488 99.875 99.1185 99.8251L100.673 98.9283C100.753 98.8885 100.842 98.8885 100.922 98.9283C101.002 98.9682 101.042 99.0579 101.042 99.1476L100.962 114.911C100.962 115.001 100.912 115.081 100.842 115.131C100.803 115.151 100.763 115.161 100.723 115.161H100.733ZM99.4274 113.885L100.484 114.483L100.553 99.576L99.4972 100.184L99.4274 113.875V113.885Z",
                fill: "black"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M99.178 114.023L92.7907 117.72L92.7808 119.504L100.732 114.91L99.178 114.023Z",
                fill: "white"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M92.7809 119.754C92.7809 119.754 92.6912 119.744 92.6513 119.724C92.5716 119.684 92.5317 119.594 92.5317 119.505V117.731C92.5317 117.641 92.5915 117.562 92.6613 117.512L99.0485 113.815C99.1283 113.775 99.2179 113.775 99.2977 113.815L100.852 114.702C100.932 114.742 100.982 114.831 100.982 114.921C100.982 115.011 100.932 115.091 100.862 115.14L92.9104 119.734C92.9104 119.734 92.8307 119.764 92.7908 119.764L92.7809 119.754ZM93.0399 117.871V119.076L100.234 114.921L99.1781 114.323L93.0399 117.881V117.871Z",
                fill: "black"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M88.4416 68.7169C89.5956 66.7206 89.5964 64.5619 88.4434 63.8954C87.2904 63.2289 85.4202 64.307 84.2662 66.3033C83.1122 68.2996 83.1115 70.4583 84.2645 71.1248C85.4175 71.7913 87.2877 70.7132 88.4416 68.7169Z",
                fill: "white"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M85.0382 71.5667C84.7094 71.5667 84.4104 71.487 84.1414 71.3375C82.846 70.5902 82.8061 68.3282 84.0517 66.1759C84.6296 65.1695 85.4069 64.3623 86.2339 63.884C87.1008 63.3858 87.9379 63.3061 88.5756 63.6748C89.871 64.4221 89.9108 66.6841 88.6653 68.8364C88.0873 69.8428 87.3101 70.65 86.483 71.1282C85.9749 71.4172 85.4866 71.5667 85.0382 71.5667ZM87.6688 63.9438C87.3101 63.9438 86.9016 64.0634 86.4731 64.3125C85.7257 64.751 85.0083 65.4983 84.4802 66.425C83.414 68.2684 83.3741 70.3211 84.3905 70.909C84.8688 71.188 85.5165 71.1083 86.2339 70.6998C86.9813 70.2613 87.6987 69.514 88.2268 68.5873C89.293 66.7439 89.3329 64.6912 88.3165 64.1033C88.1272 63.9937 87.908 63.9339 87.6688 63.9339V63.9438Z",
                fill: "black"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M87.3501 63.7708C88.0576 63.99 88.506 64.7074 88.506 65.8135C88.506 67.6968 87.1807 69.9886 85.5565 70.9253C85.2476 71.1047 84.9387 71.2242 84.6597 71.284C85.138 71.4036 85.7259 71.284 86.3636 70.9253C87.9978 69.9886 89.3131 67.6968 89.3131 65.8135C89.3131 64.3288 88.486 63.5416 87.3401 63.7309V63.7708H87.3501Z",
                fill: "white"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M85.0386 71.5749C84.8792 71.5749 84.7397 71.5549 84.5902 71.525C84.4806 71.4951 84.4009 71.3955 84.4009 71.2759C84.4009 71.1564 84.4806 71.0567 84.6002 71.0368C84.8692 70.977 85.1383 70.8674 85.4272 70.708C86.9917 69.8111 88.2571 67.609 88.2571 65.8154C88.2571 64.8588 87.8984 64.2011 87.2707 64.0118C87.181 63.9819 87.1112 63.9022 87.1013 63.8125V63.7726C87.0714 63.6431 87.161 63.5136 87.3005 63.4936C87.8885 63.394 88.4166 63.5235 88.8152 63.8623C89.2935 64.2709 89.5625 64.9684 89.5625 65.8154C89.5625 67.7784 88.1774 70.1699 86.4835 71.1464C85.9852 71.4354 85.487 71.5848 85.0386 71.5848V71.5749ZM88.2073 64.0616C88.5561 64.4801 88.7554 65.078 88.7554 65.8154C88.7554 67.4496 87.7888 69.3926 86.4835 70.5585C87.9283 69.582 89.0643 67.5193 89.0643 65.8154C89.0643 65.1079 88.865 64.5499 88.4963 64.241C88.4066 64.1712 88.3169 64.1114 88.2173 64.0616H88.2073Z",
                fill: "black"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M56.092 51.5575L49.3161 60.3861L39.521 54.776L46.2969 45.9375L56.092 51.5575Z",
                fill: "white"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M49.3161 60.6363C49.3161 60.6363 49.2264 60.6264 49.1965 60.6065L39.4014 54.9865C39.3416 54.9466 39.2918 54.8868 39.2818 54.8171C39.2718 54.7473 39.2818 54.6776 39.3316 54.6178L46.1075 45.7892C46.1872 45.6896 46.3167 45.6597 46.4264 45.7294L56.2215 51.3494C56.2813 51.3893 56.3311 51.4491 56.3411 51.5188C56.351 51.5886 56.3411 51.6583 56.2912 51.7181L49.5253 60.5467C49.4755 60.6065 49.4058 60.6463 49.326 60.6463L49.3161 60.6363ZM39.8896 54.6975L49.2463 60.0584L55.7133 51.6284L46.3566 46.2675L39.8896 54.6975Z",
                fill: "black"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M50.183 59.2104L41.5837 54.1484L39.521 54.7762L49.3161 60.3862L50.183 59.2104Z",
                fill: "white"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M49.316 60.6349C49.316 60.6349 49.2263 60.6249 49.1964 60.605L39.4013 54.985C39.3116 54.9352 39.2618 54.8355 39.2817 54.7359C39.2917 54.6362 39.3614 54.5565 39.4611 54.5266L41.5237 53.9088C41.5935 53.8889 41.6632 53.8988 41.723 53.9287L50.3224 58.9808C50.3822 59.0206 50.422 59.0804 50.442 59.1502C50.4519 59.2199 50.442 59.2897 50.4021 59.3494L49.5352 60.5253C49.4854 60.595 49.4156 60.6249 49.3359 60.6249L49.316 60.6349ZM40.1486 54.8455L49.2462 60.0569L49.8142 59.2797L41.5536 54.417L40.1486 54.8355V54.8455Z",
                fill: "black"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M39.5205 54.7799L41.5832 54.1522L47.4024 46.5592L46.2964 45.9414L39.5205 54.7799Z",
                fill: "white"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M39.5207 55.0268C39.441 55.0268 39.3613 54.9869 39.3114 54.9172C39.2517 54.8275 39.2517 54.7079 39.3114 54.6282L46.0873 45.7996C46.167 45.7 46.2966 45.6701 46.4062 45.7299L47.5222 46.3477C47.582 46.3876 47.6318 46.4473 47.6418 46.5171C47.6617 46.5868 47.6418 46.6666 47.592 46.7164L41.7727 54.3093C41.7727 54.3093 41.693 54.3791 41.6431 54.399L39.5805 55.0168C39.5805 55.0168 39.5307 55.0268 39.5107 55.0268H39.5207ZM46.3663 46.268L40.1983 54.3193L41.4438 53.9407L47.0439 46.6367L46.3763 46.258L46.3663 46.268Z",
                fill: "black"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M73.8779 61.663L67.112 70.4915L57.3169 64.8815L64.0828 56.043L73.8779 61.663Z",
                fill: "white"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M67.112 70.7397C67.112 70.7397 67.0223 70.7297 66.9924 70.7098L57.1973 65.0997C57.1375 65.0599 57.0877 65.0001 57.0777 64.9304C57.0677 64.8606 57.0777 64.7908 57.1275 64.7311L63.9034 55.9025C63.9831 55.8028 64.1126 55.773 64.2223 55.8427L74.0174 61.4627C74.0772 61.5026 74.127 61.5623 74.137 61.6321C74.1469 61.7018 74.137 61.7716 74.0871 61.8314L67.3212 70.66C67.2714 70.7197 67.2016 70.7596 67.1219 70.7596L67.112 70.7397ZM57.6855 64.8008L67.0422 70.1617L73.5092 61.7317L64.1525 56.3708L57.6855 64.8008Z",
                fill: "black"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M67.9794 69.312L59.38 64.25L57.3174 64.8778L67.1125 70.4878L67.9794 69.312Z",
                fill: "white"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M67.1124 70.7382C67.1124 70.7382 67.0227 70.7282 66.9928 70.7083L57.1977 65.0983C57.108 65.0484 57.0582 64.9488 57.0781 64.8491C57.0881 64.7495 57.1578 64.6698 57.2575 64.6399L59.3201 64.0221C59.3899 64.0022 59.4596 64.0121 59.5194 64.042L68.1188 69.094C68.1786 69.1339 68.2184 69.1937 68.2384 69.2634C68.2483 69.3332 68.2384 69.4029 68.1985 69.4627L67.3316 70.6385C67.2818 70.7083 67.212 70.7382 67.1323 70.7382H67.1124ZM57.945 64.9488L67.0426 70.1602L67.6106 69.383L59.35 64.5203L57.945 64.9388V64.9488Z",
                fill: "black"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M57.3169 64.8776L59.3795 64.2498L65.1988 56.6668L64.0828 56.0391L57.3169 64.8776Z",
                fill: "white"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M57.3171 65.1284C57.2374 65.1284 57.1577 65.0885 57.1078 65.0187C57.048 64.9291 57.048 64.8095 57.1078 64.7298L63.8837 55.9012C63.9634 55.8016 64.093 55.7717 64.2026 55.8315L65.3186 56.4493C65.3784 56.4891 65.4282 56.5489 65.4382 56.6187C65.4581 56.6884 65.4382 56.7681 65.3883 56.8179L59.5691 64.4109C59.5691 64.4109 59.4893 64.4807 59.4395 64.5006L57.3769 65.1184C57.3769 65.1184 57.327 65.1284 57.3071 65.1284H57.3171ZM64.1527 56.3695L57.9847 64.4209L59.2303 64.0422L64.8303 56.7382L64.1627 56.3596L64.1527 56.3695Z",
                fill: "black"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M30.7817 113.219V99.5977L50.3421 110.818V124.539L30.7817 113.219Z",
                fill: "#F8C3C6"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M50.342 124.797C50.342 124.797 50.2523 124.787 50.2125 124.767L30.6621 113.447C30.5823 113.408 30.5425 113.318 30.5425 113.228V99.5968C30.5425 99.5071 30.5923 99.4274 30.6621 99.3775C30.7418 99.3377 30.8315 99.3377 30.9112 99.3775L50.4616 110.598C50.5413 110.637 50.5911 110.727 50.5911 110.817V124.548C50.5911 124.638 50.5413 124.717 50.4715 124.767C50.4317 124.787 50.3918 124.797 50.352 124.797H50.342ZM31.0307 113.079L50.0829 124.109V110.956L31.0307 100.025V113.079Z",
                fill: "black"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M40.547 119.039C40.4075 119.039 40.2979 118.929 40.2979 118.79V105.108C40.2979 104.969 40.4075 104.859 40.547 104.859C40.6865 104.859 40.7961 104.969 40.7961 105.108V118.79C40.7961 118.929 40.6865 119.039 40.547 119.039Z",
                fill: "black"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M30.7816 113.2L29.3965 114.057V98.7617L30.7816 99.5688V113.2Z",
                fill: "white"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M29.3966 114.305C29.3966 114.305 29.3169 114.296 29.277 114.276C29.1973 114.236 29.1475 114.146 29.1475 114.056V98.7608C29.1475 98.6712 29.1973 98.5914 29.277 98.5416C29.3567 98.5018 29.4464 98.5018 29.5261 98.5416L30.9112 99.3487C30.9909 99.3886 31.0308 99.4783 31.0308 99.568V113.209C31.0308 113.299 30.9909 113.379 30.9112 113.419L29.5261 114.266C29.5261 114.266 29.4364 114.305 29.3966 114.305ZM29.6457 99.1893V113.608L30.5325 113.06V99.7075L29.6457 99.1893Z",
                fill: "black"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M41.962 119.957C41.8225 119.957 41.7129 119.847 41.7129 119.708V106.026C41.7129 105.887 41.8225 105.777 41.962 105.777C42.1015 105.777 42.2111 105.887 42.2111 106.026V119.708C42.2111 119.847 42.1015 119.957 41.962 119.957Z",
                fill: "black"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M50.3419 124.539V126.123L29.3965 114.056L30.7816 113.199L50.3419 124.539Z",
                fill: "white"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M50.3418 126.373C50.3418 126.373 50.2521 126.363 50.2222 126.343L29.2768 114.266C29.1971 114.226 29.1572 114.146 29.1572 114.057C29.1572 113.967 29.1971 113.887 29.2768 113.837L30.6619 112.99C30.7416 112.941 30.8412 112.941 30.9209 112.99L50.4813 124.33C50.561 124.37 50.6009 124.46 50.6009 124.549V126.134C50.6009 126.223 50.5511 126.303 50.4813 126.353C50.4414 126.373 50.4016 126.383 50.3617 126.383L50.3418 126.373ZM29.8846 114.047L50.0927 125.695V124.689L30.7914 113.499L29.8846 114.057V114.047Z",
                fill: "black"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M25.082 86.5352V88.6277L65.807 112.104L106.482 88.6975V86.6049L65.807 110.012L25.082 86.5352Z",
                fill: "#F8C3C6"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M65.8069 112.352C65.8069 112.352 65.7173 112.342 65.6874 112.322L24.9623 88.846C24.8826 88.8061 24.8428 88.7164 24.8428 88.6268V86.5342C24.8428 86.4445 24.8926 86.3648 24.9623 86.315C25.0321 86.2652 25.1317 86.2751 25.2115 86.315L65.8069 109.722L106.353 86.3847C106.432 86.3449 106.522 86.3449 106.602 86.3847C106.681 86.4246 106.721 86.5143 106.721 86.604V88.6965C106.721 88.7862 106.671 88.8659 106.602 88.9157L65.9265 112.322C65.9265 112.322 65.8468 112.352 65.8069 112.352ZM25.331 88.4773L65.8069 111.814L106.233 88.547V87.0324L65.9365 110.22C65.8568 110.26 65.7671 110.26 65.6874 110.22L25.341 86.9527V88.4673L25.331 88.4773Z",
                fill: "black"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M27.0151 85.2812L25.082 86.5368L65.807 110.013L106.482 86.6065L104.659 85.5503L104.549 86.5966L65.807 108.897L27.0151 86.5368V85.2812Z",
                fill: "#F8C3C6"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M65.8069 110.261C65.8069 110.261 65.7173 110.251 65.6874 110.231L24.9623 86.7544C24.8826 86.7145 24.8428 86.6348 24.8428 86.5451C24.8428 86.4554 24.8826 86.3757 24.9524 86.3259L26.8855 85.0803C26.9652 85.0305 27.0549 85.0305 27.1446 85.0803C27.2243 85.1202 27.2741 85.2099 27.2741 85.2996V86.4056L65.8169 108.627L104.33 86.4654L104.419 85.5487C104.419 85.469 104.479 85.3892 104.559 85.3494C104.629 85.3095 104.718 85.3095 104.798 85.3494L106.622 86.3957C106.701 86.4355 106.741 86.5252 106.741 86.6149C106.741 86.7046 106.691 86.7843 106.622 86.8341L65.9464 110.241C65.9464 110.241 65.8667 110.271 65.8269 110.271L65.8069 110.261ZM25.5602 86.5252L65.8069 109.733L105.984 86.6149L104.868 85.9672L104.798 86.6348C104.798 86.7145 104.748 86.7843 104.679 86.8241L65.9365 109.125C65.8568 109.165 65.7671 109.165 65.6874 109.125L26.8955 86.7544C26.8158 86.7145 26.7759 86.6248 26.7759 86.5352V85.748L25.5702 86.5252H25.5602Z",
                fill: "black"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M43.2671 89.0372V77.5381L32.8442 71.5195V83.0086L43.2671 89.0372Z",
                fill: "white"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M43.267 89.2754C43.267 89.2754 43.1773 89.2655 43.1474 89.2455L32.7246 83.227C32.6448 83.1871 32.605 83.0974 32.605 83.0077V71.5186C32.605 71.429 32.6548 71.3492 32.7246 71.2994C32.8043 71.2596 32.894 71.2596 32.9737 71.2994L43.3966 77.318C43.4763 77.3578 43.5161 77.4475 43.5161 77.5372V89.0263C43.5161 89.116 43.4663 89.1957 43.3966 89.2455C43.3567 89.2655 43.3168 89.2754 43.277 89.2754H43.267ZM33.0932 82.8682L43.0179 88.5978V77.6767L33.0932 71.9471V82.8682Z",
                fill: "black"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M32.8442 83.0078L33.8008 82.5195L43.2671 87.9801V89.0363L32.8442 83.0078Z",
                fill: "white"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M43.2673 89.2746C43.2673 89.2746 43.1776 89.2646 43.1477 89.2447L32.7248 83.2261C32.6451 83.1763 32.5953 83.0966 32.6053 83.0069C32.6152 82.9172 32.6651 82.8375 32.7448 82.7877L33.7113 82.2994C33.791 82.2596 33.8807 82.2596 33.9505 82.2994L43.4068 87.76C43.4865 87.7998 43.5264 87.8895 43.5264 87.9792V89.0255C43.5264 89.1152 43.4766 89.1949 43.4068 89.2447C43.367 89.2646 43.3271 89.2746 43.2872 89.2746H43.2673ZM33.3626 83.0268L43.0182 88.597V88.1287L33.801 82.8076L33.3626 83.0268Z",
                fill: "black"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M33.8008 72.0775V82.5204L32.8442 83.0086V71.5195L33.8008 72.0775Z",
                fill: "white"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M32.8443 83.2569C32.8443 83.2569 32.7546 83.2469 32.7148 83.217C32.645 83.1771 32.5952 83.0875 32.5952 83.0077V71.5186C32.5952 71.429 32.645 71.3492 32.7148 71.2994C32.7945 71.2596 32.8842 71.2596 32.9639 71.2994L33.9305 71.8574C34.0102 71.8973 34.05 71.987 34.05 72.0767V82.5195C34.05 82.6092 34.0002 82.6988 33.9105 82.7387L32.944 83.227C32.944 83.227 32.8742 83.2569 32.8344 83.2569H32.8443ZM33.0934 71.9471V82.5992L33.5618 82.36V72.2162L33.0934 71.9471Z",
                fill: "black"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M38.7232 85.609C38.5837 85.609 38.4741 85.4994 38.4741 85.3599V74.9171C38.4741 74.7776 38.5837 74.668 38.7232 74.668C38.8627 74.668 38.9723 74.7776 38.9723 74.9171V85.3599C38.9723 85.4994 38.8627 85.609 38.7232 85.609Z",
                fill: "black"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M60.147 98.492V87.0029L49.7241 80.9844V92.4735L60.147 98.492Z",
                fill: "white"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M60.1469 98.7402C60.1469 98.7402 60.0572 98.7302 60.0273 98.7103L49.6044 92.6917C49.5247 92.6519 49.4849 92.5622 49.4849 92.4725V80.9834C49.4849 80.8937 49.5347 80.814 49.6044 80.7642C49.6742 80.7144 49.7738 80.7243 49.8535 80.7642L60.2764 86.7828C60.3562 86.8226 60.396 86.9123 60.396 87.002V98.4911C60.396 98.5808 60.3462 98.6605 60.2764 98.7103C60.2366 98.7302 60.1967 98.7402 60.1569 98.7402H60.1469ZM49.9731 92.333L59.8978 98.0626V87.1515L49.9731 81.4219V92.343V92.333Z",
                fill: "black"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M49.7241 92.4726L50.6807 91.9844L60.147 97.4449V98.4912L49.7241 92.4726Z",
                fill: "white"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M60.1472 98.7394C60.1472 98.7394 60.0575 98.7295 60.0276 98.7095L49.6047 92.691C49.525 92.6411 49.4752 92.5614 49.4852 92.4718C49.4951 92.3821 49.5449 92.3024 49.6247 92.2525L50.5912 91.7643C50.6709 91.7244 50.7606 91.7244 50.8304 91.7643L60.2867 97.2248C60.3664 97.2647 60.4063 97.3544 60.4063 97.4441V98.4903C60.4063 98.58 60.3564 98.6597 60.2867 98.7095C60.2468 98.7295 60.207 98.7394 60.1671 98.7394H60.1472ZM50.2425 92.4817L59.8881 98.0519V97.5836L50.6709 92.2625L50.2325 92.4817H50.2425Z",
                fill: "black"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M50.6807 81.5324V91.9852L49.7241 92.4735V80.9844L50.6807 81.5324Z",
                fill: "white"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M49.7242 92.7217C49.7242 92.7217 49.6345 92.7117 49.5947 92.6818C49.5249 92.642 49.4751 92.5523 49.4751 92.4726V80.9835C49.4751 80.8938 49.5249 80.8141 49.5947 80.7643C49.6744 80.7244 49.7641 80.7244 49.8438 80.7643L50.8103 81.3223C50.8901 81.3621 50.9299 81.4518 50.9299 81.5415V91.9843C50.9299 92.074 50.8801 92.1637 50.7904 92.2035L49.8239 92.6918C49.8239 92.6918 49.7541 92.7217 49.7142 92.7217H49.7242ZM49.9733 81.412V92.064L50.4417 91.8249V81.671L49.9733 81.402V81.412Z",
                fill: "black"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M55.6031 95.0739C55.4636 95.0739 55.354 94.9643 55.354 94.8248V84.3819C55.354 84.2424 55.4636 84.1328 55.6031 84.1328C55.7426 84.1328 55.8522 84.2424 55.8522 84.3819V94.8248C55.8522 94.9643 55.7426 95.0739 55.6031 95.0739Z",
                fill: "black"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M71.6562 98.492V87.0029L82.0791 80.9844V92.4735L71.6562 98.492Z",
                fill: "white"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M71.6561 98.7403C71.6561 98.7403 71.5665 98.7303 71.5366 98.7104C71.4568 98.6705 71.417 98.5808 71.417 98.4911V87.0021C71.417 86.9124 71.4668 86.8327 71.5366 86.7828L81.9594 80.7643C82.0392 80.7244 82.1288 80.7244 82.2086 80.7643C82.2883 80.8041 82.3281 80.8938 82.3281 80.9835V92.4726C82.3281 92.5623 82.2783 92.642 82.2086 92.6918L71.7857 98.7104C71.7857 98.7104 71.706 98.7403 71.6661 98.7403H71.6561ZM71.9053 87.1416V98.0627L81.8299 92.3331V81.412L71.9053 87.1416Z",
                fill: "black"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M82.0791 92.4726L81.1126 91.9844L71.6562 97.4449V98.4912L82.0791 92.4726Z",
                fill: "white"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M71.6561 98.7394C71.6561 98.7394 71.5665 98.7295 71.5366 98.7095C71.4568 98.6697 71.417 98.58 71.417 98.4903V97.4441C71.417 97.3544 71.4668 97.2747 71.5366 97.2248L80.9929 91.7643C81.0627 91.7244 81.1523 91.7244 81.232 91.7643L82.1986 92.2525C82.2783 92.2924 82.3281 92.3721 82.3381 92.4718C82.3381 92.5614 82.2883 92.6511 82.2185 92.691L71.7956 98.7095C71.7956 98.7095 71.7159 98.7394 71.6761 98.7394H71.6561ZM71.9053 97.5836V98.0519L81.5509 92.4817L81.1125 92.2625L71.8953 97.5836H71.9053Z",
                fill: "black"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M81.1123 81.5324V91.9852L82.0789 92.4735V80.9844L81.1123 81.5324Z",
                fill: "white"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M82.079 92.7217C82.079 92.7217 81.9992 92.7217 81.9693 92.6918L81.0028 92.2035C80.9231 92.1637 80.8633 92.074 80.8633 91.9843V81.5415C80.8633 81.4518 80.9131 81.3721 80.9829 81.3223L81.9494 80.7643C82.0291 80.7244 82.1188 80.7244 82.1985 80.7643C82.2782 80.8041 82.3181 80.8938 82.3181 80.9835V92.4726C82.3181 92.5623 82.2782 92.642 82.1985 92.6818C82.1587 92.7018 82.1088 92.7217 82.069 92.7217H82.079ZM81.3615 91.8249L81.8298 92.064V81.412L81.3615 81.681V91.8349V91.8249Z",
                fill: "black"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M76.1998 95.0739C76.0603 95.0739 75.9507 94.9643 75.9507 94.8248V84.3819C75.9507 84.2424 76.0603 84.1328 76.1998 84.1328C76.3393 84.1328 76.4489 84.2424 76.4489 84.3819V94.8248C76.4489 94.9643 76.3393 95.0739 76.1998 95.0739Z",
                fill: "black"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M71.6562 127.436V115.937L82.0791 109.918V121.417L71.6562 127.436Z",
                fill: "#F8C3C6"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M71.6561 127.686C71.6561 127.686 71.5665 127.676 71.5366 127.656C71.4568 127.616 71.417 127.526 71.417 127.436V115.947C71.417 115.858 71.4668 115.778 71.5366 115.728L81.9594 109.71C82.0392 109.67 82.1288 109.67 82.2086 109.71C82.2883 109.749 82.3281 109.839 82.3281 109.929V121.418C82.3281 121.508 82.2783 121.587 82.2086 121.637L71.7857 127.656C71.7857 127.656 71.706 127.686 71.6661 127.686H71.6561ZM71.9053 116.087V127.008L81.8299 121.278V110.357L71.9053 116.087Z",
                fill: "black"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M82.0791 121.416L81.1126 120.918L71.6562 126.388V127.435L82.0791 121.416Z",
                fill: "white"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M71.6561 127.685C71.6561 127.685 71.5665 127.675 71.5366 127.655C71.4568 127.615 71.417 127.525 71.417 127.436V126.389C71.417 126.3 71.4668 126.22 71.5366 126.17L80.9929 120.71C81.0627 120.67 81.1523 120.67 81.232 120.71L82.1986 121.198C82.2783 121.238 82.3281 121.317 82.3381 121.417C82.3381 121.507 82.2883 121.596 82.2185 121.636L71.7956 127.655C71.7956 127.655 71.7159 127.685 71.6761 127.685H71.6561ZM71.9053 126.529V126.997L81.5609 121.427L81.1224 121.208L71.9053 126.529Z",
                fill: "black"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M81.1123 110.476V120.919L82.0789 121.417V109.918L81.1123 110.476Z",
                fill: "white"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M82.079 121.667C82.079 121.667 81.9992 121.667 81.9693 121.637L81.0028 121.149C80.9231 121.109 80.8633 121.019 80.8633 120.93V110.487C80.8633 110.397 80.9131 110.317 80.9829 110.268L81.9494 109.71C82.0291 109.67 82.1188 109.67 82.1985 109.71C82.2782 109.749 82.3181 109.839 82.3181 109.929V121.418C82.3181 121.508 82.2782 121.587 82.1985 121.627C82.1587 121.647 82.1088 121.667 82.069 121.667H82.079ZM81.3615 120.77L81.8298 121.009V110.357L81.3615 110.626V120.77Z",
                fill: "black"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M76.1998 124.007C76.0603 124.007 75.9507 123.898 75.9507 123.758V113.316C75.9507 113.176 76.0603 113.066 76.1998 113.066C76.3393 113.066 76.4489 113.176 76.4489 113.316V123.758C76.4489 123.898 76.3393 124.007 76.1998 124.007Z",
                fill: "black"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M88.5264 88.4747V76.9756L98.9493 70.957V82.4561L88.5264 88.4747Z",
                fill: "#F8C3C6"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M88.5263 88.7246C88.5263 88.7246 88.4366 88.7147 88.4067 88.6947C88.327 88.6549 88.2871 88.5652 88.2871 88.4755V76.9864C88.2871 76.8968 88.3369 76.817 88.4067 76.7672L98.8296 70.7486C98.9093 70.7088 98.999 70.7088 99.0787 70.7486C99.1584 70.7885 99.1983 70.8782 99.1983 70.9679V82.457C99.1983 82.5466 99.1484 82.6264 99.0787 82.6762L88.6558 88.6947C88.6558 88.6947 88.5761 88.7246 88.5362 88.7246H88.5263ZM88.7754 77.1259V88.0471L98.7 82.3175V71.3963L88.7754 77.1259Z",
                fill: "black"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M98.9493 82.4553L97.9827 81.957L88.5264 87.4275V88.4738L98.9493 82.4553Z",
                fill: "white"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M88.5263 88.7237C88.5263 88.7237 88.4366 88.7138 88.4067 88.6939C88.327 88.654 88.2871 88.5643 88.2871 88.4746V87.4284C88.2871 87.3387 88.3369 87.259 88.4067 87.2091L97.863 81.7486C97.9328 81.7087 98.0225 81.6988 98.1022 81.7486L99.0687 82.2368C99.1484 82.2767 99.1983 82.3564 99.2082 82.4561C99.2082 82.5457 99.1584 82.6354 99.0887 82.6753L88.6658 88.6939C88.6658 88.6939 88.586 88.7237 88.5462 88.7237H88.5263ZM88.7754 87.5679V88.0362L98.421 82.466L97.9826 82.2468L88.7654 87.5679H88.7754Z",
                fill: "black"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M97.9824 71.515V81.9579L98.949 82.4561V70.957L97.9824 71.515Z",
                fill: "white"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M98.9491 82.7061C98.9491 82.7061 98.8694 82.7061 98.8395 82.6762L97.8729 82.1879C97.7932 82.1481 97.7334 82.0584 97.7334 81.9687V71.5259C97.7334 71.4362 97.7832 71.3565 97.853 71.3067L98.8195 70.7486C98.8993 70.7088 98.9889 70.7088 99.0686 70.7486C99.1484 70.7885 99.1882 70.8782 99.1882 70.9679V82.457C99.1882 82.5466 99.1484 82.6264 99.0686 82.6662C99.0288 82.6861 98.979 82.7061 98.9391 82.7061H98.9491ZM98.2316 81.8093L98.7 82.0484V71.3963L98.2316 71.6654V81.8192V81.8093Z",
                fill: "black"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M93.0699 85.0465C92.9304 85.0465 92.8208 84.9369 92.8208 84.7974V74.3546C92.8208 74.2151 92.9304 74.1055 93.0699 74.1055C93.2094 74.1055 93.319 74.2151 93.319 74.3546V84.7974C93.319 84.9369 93.2094 85.0465 93.0699 85.0465Z",
                fill: "black"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M121.638 111.024L65.9365 143.24V141.137L121.638 108.922",
                fill: "#F8C3C6"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M65.9364 143.491C65.9364 143.491 65.8467 143.481 65.8168 143.461C65.7371 143.421 65.6973 143.331 65.6973 143.241V141.129C65.6973 141.039 65.7471 140.96 65.8168 140.91L121.519 108.694C121.638 108.625 121.788 108.665 121.857 108.784C121.927 108.904 121.887 109.053 121.768 109.123L66.1855 141.269V142.803L121.519 110.807C121.638 110.737 121.788 110.777 121.857 110.897C121.927 111.016 121.887 111.166 121.768 111.235L66.066 143.451C66.066 143.451 65.9862 143.481 65.9464 143.481L65.9364 143.491Z",
                fill: "black"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M7.74365 107.52L65.9365 141.14V143.242L7.74365 109.622",
                fill: "#F8C3C6"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M65.9364 143.491C65.9364 143.491 65.8467 143.481 65.8168 143.461L7.624 109.841C7.50443 109.771 7.46457 109.622 7.53432 109.502C7.60407 109.383 7.75354 109.343 7.87312 109.412L65.6873 142.814V141.279L7.624 107.728C7.50443 107.659 7.46457 107.509 7.53432 107.39C7.60407 107.27 7.75354 107.23 7.87312 107.3L66.056 140.92C66.1357 140.96 66.1755 141.05 66.1755 141.139V143.252C66.1755 143.342 66.1257 143.421 66.056 143.471C66.0161 143.491 65.9762 143.501 65.9364 143.501V143.491Z",
                fill: "black"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M122.265 48.1806C119.535 50.8113 115.151 52.1664 109.461 51.728C96.0189 50.6817 80.4045 39.9699 74.5852 27.8032C71.9745 22.3526 71.7852 17.5298 73.5688 13.9625L77.5845 8.11328C75.7909 11.6806 75.9902 16.5034 78.6009 21.954C84.4202 34.1207 100.035 44.8326 113.477 45.8788C119.166 46.3173 123.551 44.9621 126.281 42.3315L122.265 48.1806Z",
                fill: "#E30513"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M111.564 52.0575C110.876 52.0575 110.169 52.0276 109.441 51.9778C95.9394 50.9315 80.2054 40.13 74.3562 27.9135C71.8153 22.6024 71.4566 17.6102 73.3399 13.8535L77.3755 7.97446C77.4452 7.86485 77.5947 7.83496 77.7043 7.90471C77.8139 7.97446 77.8638 8.11397 77.804 8.23354C75.9904 11.8507 76.3492 16.6934 78.8204 21.855C84.5898 33.932 100.144 44.604 113.497 45.6404C118.947 46.0688 123.312 44.8631 126.102 42.1627C126.192 42.0731 126.341 42.0731 126.431 42.1528C126.53 42.2325 126.55 42.382 126.471 42.4816L122.455 48.3308C122.455 48.3308 122.435 48.3607 122.425 48.3706C119.894 50.8119 116.167 52.0774 111.554 52.0774L111.564 52.0575ZM76.6082 9.97733L73.7783 14.1026C71.9747 17.6899 72.3434 22.5326 74.8146 27.6943C80.5841 39.7713 96.1387 50.4433 109.491 51.4796C114.932 51.8981 119.286 50.7023 122.086 48.0219L125.096 43.6375C122.226 45.6404 118.26 46.5073 113.467 46.1286C99.9651 45.0823 84.2211 34.2808 78.3819 22.0643C76.2694 17.64 75.6616 13.435 76.6082 9.9873V9.97733Z",
                fill: "black"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M83.1749 11.8613C84.8191 8.33386 88.9045 6.32102 94.7736 6.77939C105.197 7.58652 117.313 15.8969 121.827 25.3333C124.388 30.6942 123.95 35.2779 121.17 38.078L120.711 38.2972C121.498 35.7064 121.13 32.458 119.406 28.8608C114.892 19.4244 102.785 11.114 92.3522 10.3068C88.4162 9.99793 85.2774 10.8051 83.145 12.4392L83.1749 11.8613Z",
                fill: "#E30513"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M120.701 38.5452C120.642 38.5452 120.582 38.5252 120.542 38.4854C120.462 38.4256 120.432 38.316 120.462 38.2263C121.259 35.5957 120.811 32.397 119.167 28.9692C114.693 19.6225 102.656 11.3619 92.3224 10.5548C88.5857 10.2658 85.4569 10.9833 83.2846 12.6374C83.2049 12.6972 83.1052 12.7071 83.0156 12.6573C82.9259 12.6075 82.8761 12.5178 82.886 12.4281L82.9159 11.8502C82.9159 11.8502 82.9259 11.7904 82.9358 11.7605C84.6996 7.99393 89.0242 6.08074 94.7737 6.52914C105.266 7.34623 117.493 15.7264 122.027 25.2226C124.548 30.5038 124.299 35.2469 121.319 38.2462C121.299 38.2661 121.279 38.2861 121.249 38.296L120.791 38.5153C120.791 38.5153 120.721 38.5352 120.681 38.5352L120.701 38.5452ZM90.7381 9.98683C91.2662 9.98683 91.8142 10.0068 92.3623 10.0466C102.855 10.8637 115.081 19.2538 119.615 28.7401C121.19 32.0383 121.698 35.1473 121.09 37.7679C123.8 34.928 123.99 30.434 121.588 25.4219C117.114 16.0752 105.077 7.81456 94.7438 7.00744C89.2235 6.57896 85.0882 8.36261 83.4141 11.91C85.3074 10.6445 87.8085 9.97687 90.7381 9.97687V9.98683Z",
                fill: "black"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M78.5911 21.9631C84.4104 34.1298 100.025 44.8416 113.467 45.8879C126.909 46.9342 133.097 37.9163 127.278 25.7496C121.458 13.5829 105.844 2.87104 92.4019 1.82476C78.9598 0.778489 72.7718 9.79638 78.5911 21.9631ZM94.7934 6.73727C105.216 7.5444 117.333 15.8548 121.847 25.2912C126.361 34.7276 121.558 41.7227 111.135 40.9056C100.712 40.0985 88.5955 31.7881 84.0815 22.3517C79.5676 12.9153 84.3705 5.92018 94.7934 6.73727Z",
                fill: "white"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M115.56 46.2264C114.872 46.2264 114.175 46.1965 113.457 46.1467C99.9552 45.1004 84.2112 34.2989 78.372 22.0824C75.5222 16.1136 75.4126 10.6929 78.0731 6.80676C80.7336 2.9206 85.8354 1.0672 92.422 1.58535C105.924 2.64159 121.668 13.4332 127.507 25.6497C130.357 31.6184 130.467 37.0391 127.806 40.9253C125.434 44.383 121.13 46.2364 115.56 46.2364V46.2264ZM90.3195 1.9939C84.9187 1.9939 80.7535 3.76759 78.4816 7.08577C75.9207 10.8125 76.0403 16.0638 78.8204 21.8632C84.5899 33.9402 100.144 44.6122 113.497 45.6485C119.904 46.1467 124.847 44.363 127.397 40.6363C129.958 36.9096 129.839 31.6583 127.059 25.8589C121.289 13.7819 105.735 3.11989 92.3821 2.07362C91.6747 2.02379 90.9871 1.9939 90.3195 1.9939ZM112.75 41.2242C112.221 41.2242 111.673 41.2043 111.115 41.1545C100.623 40.3374 88.3963 31.9572 83.8625 22.461C81.6404 17.8176 81.5607 13.5926 83.6333 10.5634C85.7059 7.53418 89.6817 6.08932 94.8135 6.4879C105.306 7.30499 117.533 15.6951 122.066 25.1813C124.289 29.8248 124.368 34.0498 122.296 37.079C120.442 39.7794 117.094 41.2143 112.75 41.2143V41.2242ZM93.1693 6.92634C88.9942 6.92634 85.7856 8.29148 84.0319 10.8524C82.0589 13.7221 82.1585 17.7777 84.3009 22.2518C88.775 31.5985 100.812 39.8591 111.145 40.6662C116.088 41.0548 119.904 39.6797 121.877 36.8099C123.85 33.9402 123.75 29.8846 121.608 25.4105C117.134 16.0638 105.097 7.80322 94.7637 6.99609C94.2156 6.95623 93.6875 6.9363 93.1693 6.9363V6.92634Z",
                fill: "black"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M119.217 59.9488L113.527 48.0312L115.719 48.2006L121.419 60.1182L119.217 59.9488Z",
                fill: "white"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M121.419 60.3664C121.419 60.3664 121.409 60.3664 121.399 60.3664L119.207 60.197C119.117 60.197 119.037 60.1373 118.997 60.0575L113.298 48.14C113.258 48.0603 113.268 47.9606 113.317 47.8909C113.367 47.8211 113.457 47.7812 113.547 47.7812L115.739 47.9506C115.829 47.9506 115.908 48.0104 115.948 48.0901L121.648 60.0077C121.688 60.0874 121.678 60.1871 121.628 60.2568C121.578 60.3266 121.508 60.3664 121.419 60.3664ZM119.386 59.7088L121.01 59.8383L115.559 48.4389L113.935 48.3094L119.386 59.7088Z",
                fill: "black"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M121.419 60.1186L119.217 59.9492L118.001 61.7329L120.193 61.9023L121.419 60.1186Z",
                fill: "white"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M120.193 62.1505C120.193 62.1505 120.183 62.1505 120.173 62.1505L117.981 61.9811C117.891 61.9811 117.812 61.9213 117.772 61.8416C117.732 61.7619 117.742 61.6622 117.792 61.5925L119.017 59.8088C119.067 59.7391 119.157 59.6992 119.246 59.6992L121.439 59.8686C121.528 59.8686 121.608 59.9284 121.648 60.0081C121.688 60.0878 121.678 60.1875 121.628 60.2572L120.402 62.0409C120.352 62.1106 120.283 62.1505 120.193 62.1505ZM118.449 61.5128L120.073 61.6423L120.97 60.3369L119.346 60.2074L118.449 61.5128Z",
                fill: "black"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M113.527 48.0312L112.301 49.8149L118.001 61.7325L119.217 59.9488L113.527 48.0312Z",
                fill: "white"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M118.001 61.982C118.001 61.982 117.991 61.982 117.981 61.982C117.891 61.982 117.812 61.9222 117.772 61.8425L112.072 49.9249C112.032 49.8452 112.042 49.7455 112.092 49.6758L113.318 47.8921C113.367 47.8224 113.457 47.7726 113.547 47.7825C113.636 47.7825 113.716 47.8423 113.756 47.922L119.456 59.8396C119.496 59.9193 119.486 60.019 119.436 60.0887L118.21 61.8724C118.16 61.9421 118.091 61.982 118.001 61.982ZM112.59 49.8352L118.041 61.2346L118.938 59.9293L113.487 48.5299L112.59 49.8352Z",
                fill: "black"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M131.214 85.1286L116.625 54.6172L122.245 55.0457L136.844 85.567L131.214 85.1286Z",
                fill: "#F8C3C6"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M136.844 85.8174C136.844 85.8174 136.834 85.8174 136.824 85.8174L131.204 85.3789C131.114 85.3789 131.034 85.3191 130.994 85.2394L116.406 54.7181C116.367 54.6384 116.377 54.5387 116.426 54.469C116.476 54.3992 116.556 54.3594 116.656 54.3594L122.276 54.7978C122.365 54.7978 122.445 54.8576 122.485 54.9373L137.073 85.4587C137.113 85.5384 137.103 85.628 137.053 85.7078C137.003 85.7775 136.933 85.8174 136.844 85.8174ZM131.383 84.9006L136.435 85.2893L122.096 55.2861L117.044 54.8975L131.393 84.9006H131.383Z",
                fill: "black"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M136.844 85.5713L131.214 85.1328L128.085 89.7065L133.705 90.135L136.844 85.5713Z",
                fill: "white"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M133.705 90.3923C133.705 90.3923 133.695 90.3923 133.685 90.3923L128.065 89.9539C127.975 89.9539 127.896 89.8941 127.856 89.8144C127.816 89.7347 127.826 89.645 127.876 89.5653L131.004 85.0015C131.054 84.9318 131.144 84.8819 131.234 84.8919L136.854 85.3303C136.943 85.3303 137.023 85.3901 137.063 85.4698C137.103 85.5495 137.093 85.6392 137.043 85.7189L133.914 90.2827C133.864 90.3525 133.795 90.3923 133.705 90.3923ZM128.533 89.4855L133.585 89.8742L136.395 85.7887L131.343 85.4001L128.533 89.4955V89.4855Z",
                fill: "black"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M116.626 54.6211L113.497 59.1848L128.085 89.7062L131.214 85.1325L116.626 54.6211Z",
                fill: "#F8C3C6"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M128.085 89.9544C128.085 89.9544 128.075 89.9544 128.065 89.9544C127.975 89.9544 127.896 89.8946 127.856 89.8149L113.268 59.2936C113.228 59.2139 113.238 59.1142 113.288 59.0445L116.417 54.4807C116.466 54.4109 116.546 54.3711 116.646 54.3711C116.735 54.3711 116.815 54.4309 116.855 54.5106L131.443 85.0319C131.483 85.1116 131.473 85.2013 131.423 85.281L128.294 89.8448C128.244 89.9145 128.175 89.9544 128.085 89.9544ZM113.786 59.2039L128.125 89.2071L130.935 85.1116L116.586 55.1085L113.786 59.2039Z",
                fill: "black"
            })
        ]
    });

const ProfileSl = ()=>/*#__PURE__*/ jsxs("svg", {
        width: "73",
        height: "73",
        viewBox: "0 0 73 73",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ jsxs("g", {
                clipPath: "url(#clip0_5591_31692)",
                children: [
                    /*#__PURE__*/ jsx("mask", {
                        id: "mask0_5591_31692",
                        style: {
                            maskType: 'luminance'
                        },
                        maskUnits: "userSpaceOnUse",
                        x: "0",
                        y: "0",
                        width: "73",
                        height: "73",
                        children: /*#__PURE__*/ jsx("path", {
                            d: "M72.5 0.9375H0.5V72.9375H72.5V0.9375Z",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ jsxs("g", {
                        mask: "url(#mask0_5591_31692)",
                        children: [
                            /*#__PURE__*/ jsx("path", {
                                d: "M0.729583 60.2749C4.09454 48.1882 10.6072 36.8442 20.7576 30.9878C27.0985 27.3294 32.444 26.814 38.7445 29.4163C41.68 30.629 42.1448 31.4224 44.9338 33.3223C41.008 32.7968 34.1821 33.0242 29.2357 35.8791C20.702 40.8007 14.7502 49.6081 11.0669 59.4664L7.31293 66.6419C5.96898 66.0154 2.50806 63.6504 1.74008 63.1044C0.90642 62.5134 0.411281 61.4474 0.73464 60.2749H0.729583Z",
                                fill: "#E30513"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M7.30775 66.7701C7.30775 66.7701 7.27235 66.7701 7.25215 66.7601C5.9284 66.1436 2.50787 63.8141 1.65906 63.2131C0.704137 62.5361 0.28985 61.3736 0.603104 60.2471C0.603104 60.2416 0.603094 60.2316 0.608146 60.2266C4.40762 46.5835 11.5417 36.1592 20.6918 30.8788C27.0983 27.18 32.5146 26.7101 38.7898 29.2972C40.831 30.1411 41.6697 30.7727 42.943 31.7328C43.5037 32.1522 44.1404 32.6322 44.9993 33.2184C45.0498 33.2537 45.0649 33.3144 45.0448 33.37C45.0246 33.4255 44.969 33.4559 44.9084 33.4508C40.7098 32.8899 34.0961 33.2184 29.2911 35.9925C21.5103 40.4795 15.2452 48.6148 11.1779 59.5141L7.41385 66.7046C7.39365 66.7451 7.3482 66.7701 7.3027 66.7701H7.30775ZM0.845614 60.3326C0.57278 61.3486 0.946676 62.3946 1.8056 63.0056C2.62916 63.5921 5.87285 65.8001 7.25215 66.4771L10.9506 59.4131C15.033 48.4683 21.3385 40.2926 29.1698 35.7752C33.8383 33.0819 40.1843 32.6676 44.4385 33.1426C43.7817 32.6827 43.2613 32.2937 42.7965 31.9399C41.5384 30.995 40.7097 30.3685 38.6988 29.5398C32.5045 26.983 27.159 27.4478 20.8232 31.1062C11.7287 36.3563 4.63498 46.7301 0.850671 60.3176C0.850671 60.3226 0.850666 60.3326 0.845614 60.3376V60.3326Z",
                                fill: "black"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M48.3594 44.2475C49.9357 43.338 50.6381 41.4027 49.961 39.7099C46.2929 30.5589 36.87 27.9768 25.8202 34.3487C15.6698 40.2102 9.15206 51.5489 5.79216 63.6359C5.17068 65.8794 7.57566 67.7539 9.59161 66.5919L48.3594 44.2424V44.2475Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M8.29276 67.0763C7.70671 67.0763 7.13071 66.8793 6.63556 66.4953C5.74131 65.8028 5.37244 64.6913 5.67561 63.5998C9.47001 49.9517 16.6041 39.5223 25.7643 34.2368C31.7161 30.8059 37.3143 29.8407 41.9575 31.4476C45.6307 32.7159 48.4399 35.5557 50.0819 39.6587C50.7743 41.3868 50.0617 43.408 48.4247 44.3529L9.65696 66.7023C9.22246 66.9498 8.75761 67.0763 8.29276 67.0763ZM37.3092 30.9473C33.7978 30.9473 29.9276 32.1297 25.8906 34.4592C16.7911 39.7092 9.69736 50.083 5.91811 63.6708C5.64526 64.6608 5.97876 65.6663 6.78716 66.2983C7.59556 66.9248 8.64646 66.9953 9.53066 66.4853L48.2984 44.1357C49.8293 43.2514 50.4912 41.3717 49.8445 39.7547C48.2277 35.7224 45.4741 32.9332 41.8716 31.6901C40.4367 31.1949 38.9109 30.9473 37.3042 30.9473H37.3092Z",
                                fill: "black"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M21.9902 8.41899C24.577 6.92334 26.9314 6.71109 28.6947 7.57009C29.7609 8.09059 33.8281 10.3593 33.8281 10.3593C33.8281 10.3593 29.2354 10.8495 28.1997 11.4457C22.7278 14.6039 18.2866 22.2844 18.2866 28.6007C18.2866 30.1216 19.5144 34.4369 19.5144 34.4369C19.5144 34.4369 15.9271 32.6026 14.7751 31.8599C13.1028 30.7785 12.0771 28.6108 12.0771 25.5739C12.0771 19.2577 16.5132 11.5721 21.9902 8.41899Z",
                                fill: "#E30513"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M19.5146 34.5664C19.5146 34.5664 19.4742 34.5664 19.459 34.5513C19.4237 34.5311 15.8516 32.7069 14.7097 31.9642C12.9312 30.8171 11.9561 28.5433 11.9561 25.5721C11.9561 19.2205 16.4326 11.4793 21.9297 8.30604C24.461 6.84574 26.8811 6.54254 28.7556 7.45209C29.8166 7.96749 33.8536 10.2262 33.894 10.2464C33.9395 10.2716 33.9647 10.3272 33.9546 10.3828C33.9445 10.4384 33.899 10.4788 33.8435 10.4839C33.798 10.4839 29.2659 10.974 28.2655 11.5551C22.8341 14.6879 18.4182 22.3382 18.4182 28.6039C18.4182 30.0945 19.6308 34.3643 19.6409 34.4047C19.6561 34.4553 19.6409 34.5058 19.6005 34.5361C19.5752 34.5563 19.55 34.5664 19.5197 34.5664H19.5146ZM26.4113 7.19439C25.0724 7.19439 23.5819 7.64409 22.051 8.52839C16.6195 11.6612 12.2036 19.3064 12.2036 25.5772C12.2036 28.4624 13.1434 30.6554 14.8411 31.757C15.796 32.3734 18.4687 33.763 19.3125 34.1976C19.0397 33.2072 18.1555 29.9227 18.1555 28.6039C18.1555 22.2573 22.632 14.5111 28.1291 11.3378C29.0082 10.8325 32.2722 10.4131 33.4191 10.2817C32.4136 9.72089 29.5084 8.10894 28.6343 7.68449C27.9624 7.35604 27.2096 7.19439 26.4062 7.19439H26.4113Z",
                                fill: "black"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M33.515 26.3813C37.3853 19.681 37.3903 12.4401 33.515 10.2016C29.6448 7.96311 23.3696 11.5811 19.4994 18.2813C15.6292 24.9816 15.6242 32.2226 19.4944 34.461C23.3646 36.6995 29.6398 33.0816 33.51 26.3813H33.515Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M22.0609 35.2425C21.111 35.2425 20.2218 35.0252 19.4336 34.5705C15.5078 32.3017 15.4927 24.9647 19.3932 18.219C21.2778 14.9598 23.7838 12.3171 26.4465 10.7809C29.1344 9.22966 31.6657 8.98711 33.5806 10.0937C37.5013 12.3625 37.5215 19.6995 33.621 26.4452C30.5036 31.8368 25.82 35.2476 22.0609 35.2476V35.2425ZM30.9331 9.65916C29.5992 9.65916 28.1138 10.1089 26.5778 10.9982C23.9505 12.5141 21.4748 15.1215 19.6155 18.3402C15.7857 24.9698 15.7604 32.1501 19.565 34.3481C23.3644 36.5462 29.579 32.9434 33.4088 26.3139C37.2386 19.6843 37.2638 12.504 33.4593 10.306C32.7115 9.87141 31.8577 9.65916 30.9381 9.65916H30.9331Z",
                                fill: "black"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M43.3423 49.583C43.3423 54.2114 44.9692 57.4604 47.5914 58.9714C50.2187 60.4874 53.8462 60.2649 57.8582 57.9559C65.8712 53.3274 72.3737 42.0793 72.3737 32.8272C72.3737 28.1987 70.7472 24.9496 68.1247 23.4388C65.4977 21.9279 61.8697 22.1452 57.8582 24.4544C49.8449 29.083 43.3423 40.331 43.3423 49.583Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M51.3756 60.0758C49.971 60.0758 48.6776 59.7473 47.5307 59.0853C44.7468 57.4838 43.2158 54.1083 43.2158 49.5858C43.2158 40.3085 49.7538 28.9898 57.7921 24.3512C61.7081 22.0925 65.4016 21.7286 68.1851 23.3355C70.9691 24.9373 72.5001 28.3127 72.5001 32.8351C72.5001 42.1124 65.9621 53.4313 57.9236 58.0698C55.6146 59.3988 53.3866 60.0758 51.3756 60.0758ZM64.3401 22.5978C62.3751 22.5978 60.1871 23.2597 57.9186 24.5684C49.9508 29.1667 43.4685 40.3894 43.4685 49.5858C43.4685 54.0123 44.9539 57.3118 47.657 58.8683C50.355 60.4293 53.9576 60.0658 57.7921 57.8523C65.7601 53.2543 72.2426 42.0316 72.2426 32.8351C72.2426 28.4087 70.7571 25.1091 68.0541 23.5528C66.9476 22.9161 65.6946 22.6028 64.3351 22.6028L64.3401 22.5978Z",
                                fill: "black"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M44.1857 56.9918C41.5584 55.4763 39.9365 52.2268 39.9365 47.5984C39.9365 38.3464 46.4341 27.0984 54.4523 22.4699C58.4588 20.1556 62.0918 19.9383 64.7188 21.4542L68.0838 23.3743C65.4568 21.8584 61.8288 22.0808 57.8173 24.39C49.804 29.0185 43.3015 40.2665 43.3015 49.5185C43.3015 54.1473 44.9284 57.3963 47.5506 58.9123L44.1857 56.9918Z",
                                fill: "#F8C3C6"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M47.5558 59.0363C47.5558 59.0363 47.5154 59.0313 47.4952 59.0213L44.1302 57.1013C41.3463 55.4943 39.8154 52.1188 39.8154 47.6014C39.8154 38.3241 46.3533 27.0054 54.392 22.3668C58.3125 20.1081 62.001 19.7443 64.785 21.3511L68.089 23.2359C68.089 23.2359 68.1295 23.2611 68.15 23.2713C68.2105 23.3066 68.2305 23.3824 68.195 23.4431C68.16 23.5037 68.084 23.5239 68.0235 23.4885L67.963 23.4532C65.27 21.9322 61.6925 22.3061 57.883 24.5042C49.9153 29.1024 43.433 40.3251 43.433 49.5216C43.433 53.9478 44.9184 57.2478 47.6215 58.8038C47.6821 58.8393 47.7023 58.9153 47.667 58.9758C47.6417 59.0163 47.6013 59.0413 47.5558 59.0413V59.0363ZM44.2515 56.8788L46.0047 57.8793C44.1706 56.0503 43.1753 53.1548 43.1753 49.5165C43.1753 40.2392 49.7132 28.9205 57.752 24.2819C60.879 22.4779 63.855 21.8817 66.346 22.5335L64.6485 21.5633C61.9505 20.007 58.348 20.3658 54.508 22.579C46.5403 27.1772 40.0579 38.3999 40.0579 47.5964C40.0579 52.0228 41.5434 55.3173 44.2464 56.8788H44.2515Z",
                                fill: "black"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M48.0864 46.8948L49.6274 44.1763L55.7256 47.6831L66.8011 27.5469L69.3576 29.0224L56.6506 51.862L48.0864 46.8948Z",
                                fill: "#E30513"
                            }),
                            /*#__PURE__*/ jsx("path", {
                                d: "M56.6507 51.9885C56.6507 51.9885 56.6052 51.9835 56.5847 51.9735L48.0209 47.0064C47.9602 46.9711 47.94 46.8953 47.9754 46.8346L49.5164 44.1161C49.5316 44.0858 49.5619 44.0656 49.5922 44.0555C49.6225 44.0454 49.6579 44.0555 49.6882 44.0656L55.6752 47.5117L66.6847 27.4867C66.6997 27.4564 66.7302 27.4362 66.7607 27.4261C66.7957 27.416 66.8262 27.4261 66.8567 27.4362L69.4132 28.9117C69.4737 28.947 69.4942 29.0228 69.4587 29.0835L56.7517 51.923C56.7362 51.9535 56.7062 51.9735 56.6757 51.9835C56.6657 51.9835 56.6557 51.9835 56.6402 51.9835L56.6507 51.9885ZM48.2583 46.8447L56.6002 51.6855L69.1807 29.0683L66.8467 27.7192L55.8372 47.7442C55.8217 47.7745 55.7917 47.7947 55.7612 47.8048C55.7312 47.8149 55.6957 47.8048 55.6652 47.7947L49.6781 44.3486L48.2634 46.8498L48.2583 46.8447Z",
                                fill: "black"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ jsx("defs", {
                children: /*#__PURE__*/ jsx("clipPath", {
                    id: "clip0_5591_31692",
                    children: /*#__PURE__*/ jsx("rect", {
                        width: "72",
                        height: "72.0003",
                        fill: "white",
                        transform: "translate(0.5 0.9375)"
                    })
                })
            })
        ]
    });

const ClassifiedsAdditionnalBlock = (props)=>{
    const { translate, deviceType } = props;
    return /*#__PURE__*/ jsxs(Box, {
        as: "div",
        display: "flex",
        flexDirection: "column",
        gap: "spacing.16",
        alignItems: "center",
        justifyContent: props.type === 'mvp' ? 'center' : "end",
        paddingHorizontal: "spacing.16",
        paddingVertical: "spacing.24",
        minWidth: deviceType === 'mobile' ? '100%' : '295px',
        maxWidth: deviceType === 'mobile' ? '100%' : '295px',
        borderRadius: "radius.16",
        minHeight: deviceType === 'mobile' ? '259px' : '386px',
        backgroundColor: props.type === 'mvp' ? 'color.background.light' : undefined,
        children: [
            props.type === 'loadMore' && /*#__PURE__*/ jsxs(Fragment, {
                children: [
                    /*#__PURE__*/ jsx(MoreProperties, {}),
                    /*#__PURE__*/ jsx(Box, {
                        as: "p",
                        typography: "typography.headline.20.bold",
                        textAlign: "center",
                        children: translate('savedSearch.hpMfe.seeMore.text', {
                            number: props.classifiedsLeft
                        })
                    }),
                    /*#__PURE__*/ jsx(Button, {
                        variant: "primary",
                        size: "48",
                        isFullWidth: true,
                        onPress: props.onClick,
                        children: translate('savedSearch.hpMfe.seeMore.action')
                    })
                ]
            }),
            props.type !== 'loadMore' && /*#__PURE__*/ jsxs(Fragment, {
                children: [
                    props.type === 'noMore' && /*#__PURE__*/ jsxs(Fragment, {
                        children: [
                            /*#__PURE__*/ jsx(ProfileSl, {}),
                            /*#__PURE__*/ jsx(Box, {
                                as: "p",
                                margin: "0",
                                marginTop: "spacing.12",
                                typography: "typography.headline.22.bold",
                                textAlign: "center",
                                children: translate('savedSearch.hpMfe.noMore.firstText')
                            }),
                            /*#__PURE__*/ jsx(Box, {
                                as: "p",
                                margin: "0",
                                typography: "typography.headline.20.bold",
                                textAlign: "center",
                                children: translate('savedSearch.hpMfe.noMore.secondText')
                            })
                        ]
                    }),
                    props.type === 'mvp' && /*#__PURE__*/ jsx(Box, {
                        as: "p",
                        margin: "0",
                        marginTop: "spacing.12",
                        typography: "typography.headline.20.bold",
                        textAlign: "center",
                        children: translate('savedSearch.hpMfe.mvp.blockText')
                    }),
                    /*#__PURE__*/ jsx(Button, {
                        variant: "primary",
                        size: "48",
                        isFullWidth: true,
                        href: props.lastSearchLink,
                        icon: MagnifyingGlassIcon,
                        iconPosition: "end",
                        children: translate('savedSearch.hpMfe.noMore.firstAction')
                    }),
                    /*#__PURE__*/ jsx(Button, {
                        variant: "secondary",
                        size: "48",
                        isFullWidth: true,
                        onPress: props.startNewSearch,
                        children: translate('savedSearch.hpMfe.noMore.secondAction')
                    })
                ]
            })
        ]
    });
};

const FavoriteProviderWrapper = ({ brandConfig, stage, locale, children })=>{
    const { favoriteBrand, hpList } = brandConfig;
    if (!favoriteBrand || !hpList.favorites) {
        return /*#__PURE__*/ jsx(Fragment, {
            children: children
        });
    }
    return /*#__PURE__*/ jsx(FavoritesProvider, {
        brand: favoriteBrand,
        env: stage,
        locale: locale,
        children: children
    });
};

const componentStyle = {
    paddingTop: {
        'breakpoint.base': 'spacing.32',
        'breakpoint.md': 'spacing.32',
        'breakpoint.lg': 'spacing.32'
    },
    paddingBottom: {
        'breakpoint.base': 'spacing.40',
        'breakpoint.md': 'spacing.40',
        'breakpoint.lg': 'spacing.48'
    }
};
const useTracking = ({ classifieds, savedSearch })=>{
    const event = matchingListTracking(classifieds, savedSearch);
    const trackEvent = useThorEvent({
        eventData: event ?? {}
    });
    useEffect(()=>{
        if (!event) {
            return;
        }
        trackEvent();
    }, [
        event
    ]);
};
const SavedSearchMatchList = ({ authenticationToken, stage, brand, locale, startNewSearch, itemsPerLine = 4, firstShowLimitNumber = 3, maxShowLimitNumber = 7 })=>{
    const [savedSearch, setSavedSearch] = useState(null);
    const [classifieds, setClassifieds] = useState(null);
    const [classifiedsArray, setClassifiedsArray] = useState([]);
    const [savedSearchTitle, setSavedSearchTitle] = useState('');
    const [listingsLink, setListingsLink] = useState('');
    const [matchingFound, setMatchingFound] = useState(false);
    const [showMore, setShowMore] = useState(false);
    const [error, setError] = useState(null);
    const { t, i18n } = useTranslation();
    const formatBreakpoint = {
        vertical: 'base'
    };
    const config = getCustomBrandConfig(brand);
    const deviceType = useBreakpointValue({
        base: 'mobile',
        md: 'desktop'
    });
    if (!config) {
        console.warn('Brand not found in config');
    }
    if (!config?.hpList.supported) {
        console.warn('Brand not supported for SavedSearchMatch');
    }
    if (error) console.warn(error);
    const showMoreSupported = config?.hpList.showMore;
    const commonAdditionnalBlocksProps = {
        translate: t,
        brand,
        deviceType
    };
    const callsError = (error)=>{
        setError(error?.errorMessage ?? 'Error fetching data');
    };
    const fetchClassified = async (savedSearchId)=>{
        const getClassifiedMatchingSuccess = async (response)=>{
            if (response.length === 0) {
                setError('No matching found');
                return;
            } else if (response.length > 0) {
                setMatchingFound(true);
            }
            const responseIds = config?.hpList.withRelaxed ? response.map((item)=>item.classifiedId) : response.filter((item)=>!item.matchingContext.isRelaxedMatch).map((item)=>item.classifiedId);
            const classifiedDatas = await getCardsData(responseIds, config.searchBrand, stage, locale, false);
            if (classifiedDatas.errored) {
                setError(classifiedDatas?.message ?? 'Error fetching classifieds');
                return;
            }
            const classifiedsObjectsToArray = Object.values(classifiedDatas.data);
            setClassifieds(classifiedDatas.data);
            setClassifiedsArray(classifiedsObjectsToArray);
        };
        await getSavedSearchMatches(getClassifiedMatchingSuccess, callsError, {
            authenticationToken,
            savedSearchId: savedSearchId
        });
    };
    const fetchSavedSearch = async ()=>{
        const getSavedSearchesSuccess = (response)=>{
            if (response.data.length > 0) {
                const latest = getMostRecentSearch(response.data);
                if (!latest) {
                    setError('No saved search found');
                    return;
                }
                const { title } = getWLItemWording(latest, t);
                setSavedSearch(latest);
                setSavedSearchTitle(title);
            } else setError('No saved search found');
        };
        await getSavedSearches(getSavedSearchesSuccess, callsError, {
            authenticationToken});
    };
    useTracking({
        classifieds,
        savedSearch
    });
    useEffect(()=>{
        i18n.changeLanguage(getOldFormatLocale(locale));
        if (config) {
            fetchSavedSearch();
        }
    }, []);
    useEffect(()=>{
        if (savedSearch !== null) {
            fetchClassified(savedSearch.identity.id);
            const searchUrl = mapSearchModelToQueryString(reverseWLItemToSearchModel(savedSearch));
            const link = searchUrl ? getListingsLink(stage, brand, searchUrl) : getListingsLink(stage, brand, '');
            const url = new URL(link);
            url.searchParams.append('order', 'DateDesc');
            url.searchParams.append('m', 'homepage_last_saved_search_see_more_properties_classified_search_results');
            setListingsLink(url.toString());
        }
    }, [
        savedSearch
    ]);
    if (error || !matchingFound || !classifieds || classifiedsArray.length === 0) {
        return undefined;
    }
    return /*#__PURE__*/ jsxs(Box, {
        as: "div",
        display: "flex",
        flexDirection: "column",
        gap: "spacing.16",
        paddingBottom: componentStyle.paddingBottom,
        paddingTop: componentStyle.paddingTop,
        width: "100%",
        children: [
            /*#__PURE__*/ jsxs(Box, {
                as: "div",
                children: [
                    /*#__PURE__*/ jsx(Box, {
                        as: "h3",
                        margin: "0",
                        typography: "typography.headline.28.bold",
                        children: t('savedSearch.hpMfe.title')
                    }),
                    /*#__PURE__*/ jsx(Box, {
                        as: "p",
                        margin: "0",
                        typography: "typography.body.14.regular",
                        children: savedSearchTitle
                    })
                ]
            }),
            /*#__PURE__*/ jsx(Box, {
                as: "div",
                display: "flex",
                gap: "spacing.12",
                flexWrap: "wrap",
                children: /*#__PURE__*/ jsx(FavoriteProviderWrapper, {
                    brandConfig: config,
                    stage: stage,
                    locale: locale,
                    children: /*#__PURE__*/ jsxs(CardMFEProvider, {
                        cards: classifieds,
                        brand: config.searchBrand,
                        stage: stage,
                        locale: locale,
                        formatBreakpoints: formatBreakpoint,
                        fixedCardHeight: {
                            active: true,
                            keyFactsWidth: '265'
                        },
                        children: [
                            classifiedsArray.slice(0, firstShowLimitNumber).map((classified)=>{
                                return /*#__PURE__*/ jsx(Box, {
                                    maxWidth: deviceType === 'mobile' ? '100%' : '295px',
                                    children: /*#__PURE__*/ jsx(CardFull, {
                                        id: classified.id,
                                        cdpUrlParams: {
                                            m: 'homepage_last_saved_search_classified_detail_classified_detail'
                                        },
                                        actionSlot: config.hpList.favorites ? /*#__PURE__*/ jsx(FavoriteHeart, {
                                            classifiedId: classified.id
                                        }) : undefined
                                    }, classified.id)
                                }, classified.id);
                            }),
                            (!showMoreSupported || classifiedsArray.length <= firstShowLimitNumber) && /*#__PURE__*/ jsx(ClassifiedsAdditionnalBlock, {
                                type: "mvp",
                                lastSearchLink: listingsLink,
                                startNewSearch: startNewSearch,
                                ...commonAdditionnalBlocksProps
                            }),
                            showMoreSupported && !showMore && classifiedsArray.length > firstShowLimitNumber && /*#__PURE__*/ jsx(ClassifiedsAdditionnalBlock, {
                                type: "loadMore",
                                classifiedsLeft: classifiedsArray.length - firstShowLimitNumber > itemsPerLine ? itemsPerLine : classifiedsArray.length - firstShowLimitNumber,
                                onClick: ()=>setShowMore(true),
                                ...commonAdditionnalBlocksProps
                            }),
                            showMoreSupported && showMore && classifiedsArray.length > firstShowLimitNumber && classifiedsArray.slice(firstShowLimitNumber, maxShowLimitNumber).map((classified)=>{
                                return /*#__PURE__*/ jsx(Box, {
                                    maxWidth: deviceType === 'mobile' ? '100%' : '295px',
                                    children: /*#__PURE__*/ jsx(CardFull, {
                                        id: classified.id,
                                        cdpUrlParams: {
                                            m: 'homepage_last_saved_search_classified_detail_classified_detail'
                                        },
                                        actionSlot: config.hpList.favorites ? /*#__PURE__*/ jsx(FavoriteHeart, {
                                            classifiedId: classified.id
                                        }) : undefined
                                    }, classified.id)
                                }, classified.id);
                            }),
                            showMoreSupported && showMore && classifiedsArray.length > maxShowLimitNumber && /*#__PURE__*/ jsx(ClassifiedsAdditionnalBlock, {
                                type: "noMore",
                                lastSearchLink: listingsLink,
                                startNewSearch: startNewSearch,
                                ...commonAdditionnalBlocksProps
                            }),
                            showMoreSupported && showMore && classifiedsArray.length <= maxShowLimitNumber && /*#__PURE__*/ jsx(ClassifiedsAdditionnalBlock, {
                                type: "noMore",
                                lastSearchLink: listingsLink,
                                startNewSearch: startNewSearch,
                                ...commonAdditionnalBlocksProps
                            })
                        ]
                    })
                })
            })
        ]
    });
};

export { BackButton, DataDome, DeletionModal, ErrorPage, SavedSearchButton, SavedSearchCard, SavedSearchMatchList, TrackingWrapper };
//# sourceMappingURL=index.mjs.map
